module.exports={
"label_emailtocloudcc_department":`Dział`,
"label.wei.weiresearch":`Mikro głosowanie`,
"message.error.appsecret.null":`Hasło tajnego klucza nie może być puste!`,
"label.file.orderbylastmodifydate":`Posortowane według czasu ostatniej modyfikacji`,
"label.minus":`-Minus`,
"label.horizontalbar":`Linie poziome`,
"label.emailobject.emailsentfailed":`Nie udało się wysłać poczty".`,
"assignedresource.check":`Ten zasób serwisowy został przypisany do terminu serwisowego. Proszę nie dodawać go ponownie.`,
"label.finish":`Pełny`,
"label.document.history":`Pobierz Historia`,
"label.customfields.number.numberLengthHelpText":`1.Proszę wprowadzić długość liczby i liczbę miejsc po przecinku. Na przykład, liczba o długości 8 i 2 miejscach po przecinku może przyjąć wartości do "12345678.90".`,
"label.standard.buttonandlink.info":`Nadpisanie standardowych przycisków i linków zmienia znaczenie adresu URL CloudCC.com oraz wszelkich wywołań tego adresu, takich jak strona niestandardowa CloudCC.com, skrót przeglądarki lub system zewnętrzny. Możesz zastąpić adres URL CloudCC.com dla standardowego przycisku lub linku własną stroną.`,
"front-epwechat-module-v1-contacts-desc":`Po włączeniu tej opcji w systemie CloudCC zostanie dodany obiekt Kontakty WeCom, do którego będą synchronizowane informacje o klientach z WeCom.`,
"label.mr.caption.contact.result":`Znajdź duplikaty i połącz: Wyniki wyszukiwania duplikatów kontaktów`,
"label.ems.selectaccount":`Wybierz konto`,
"label.group.no.activity":`Nie ma pasujących aktywnych grup.`,
"label.call.for":`Zaproszeni przez`,
"label.newreportguide":`Przewodnik po nowych raportach`,
"component.telerecord.label.name":`Nazwy`,
"vue.add.dashboard.component":`Dodaj komponent {titleName}`,
"label.chatter.sendEmailToGroupMember.check.V":`Wyświetl głosy`,
"UG.ST.002":`Określić`,
"label.setting.intergrationmanage":`Zarządzanie integracją`,
"label.field.apiname.validate":`Proszę wpisać liczbę z przedziału od 0 do 6.`,
"label.emailmerge.list.deletefolder":`Usuń folder`,
"vue_label_pool_received":`Otrzymane`,
"label_emailtocloudcc_step1_case1":`E-mail do sprawy`,
"message.sumlength":`Suma długości i liczby miejsc po przecinku nie może przekroczyć 18 miejsc po przecinku.`,
"vue_label_approve_reassignapproval":`{name} przydzielił to zatwierdzenie do {people}.`,
"label.specify.time":`Godzina: 13:00 21 czerwca 2016 r.`,
"vue_label_report_sortdown":`Sortuj w porządku malejącym`,
"chatter.login.now":`Przesyłanie...`,
"label.import.page2.notsuited":`Nieopracowany`,
"label.please.fill.out":`Proszę wypełnić`,
"label.recordtype.edit.description":`Wybierz wartość z "Dostępne wartości", następnie dodaj ją do "Wybrane wartości" i uczyń ją wartością listy wyboru dla tego typu rekordu. Zwróć uwagę, że usunięcie wartości z listy nie spowoduje usunięcia tej wartości z istniejącego rekordu. Na koniec wybierz domyślną wartość listy wyboru dla danego typu rekordu.`,
"label.customer.tab.new":`Zakładka Nowy Klient`,
"label.sameas":`Tak jak`,
"front-filter-module-v1-filter-a-week-ago":`Tydzień temu`,
"label.processsetting.disable.process.failed":`Nie udało się wyłączyć procesu!`,
"label.summaryreport.2018.step4":`Krok 4 Wybierz kryteria raportowania`,
"label.secrecyinfo":`Informacje poufne, nie rozpowszechniać`,
"label.custom.page.component.general.settings":`Ustawienia ogólne komponentu`,
"label.ccpeak.folder":`Niewypełnione foldery klasowe`,
"vue_label_homepage_select_button_operation":`Wybierz Przycisk`,
"message.pleaseinputrightdistance":`Proszę wprowadzić prawidłowy interwał dni`,
"label.mobile.phone.required.short":`jest wymagany`,
"vue_label_account_equityseructure":`Struktura akcjonariatu`,
"label.file.library.error1":`Ten plik jest już w tej bibliotece.`,
"fliter.nextmonth":`Następny miesiąc`,
"label.mr.descreption.oneGroupNote2":`zbiór informacji o przedsiębiorstwie, są`,
"label.allfolderdashboard":`Wszystkie foldery pulpitu nawigacyjnego`,
"lable.opppdt.selPdt.bykeywords":`Według słów kluczowych`,
"setup_layout_label_selectedfield":`Wybierz pola`,
"label.file.preview.convert.firstpage.failure":`Wystąpił błąd podczas prewejścia, proszę kliknąć szczegóły podglądu lub pobierz, aby zobaczyć`,
"vue_label_systemSettings_companie":`Zakładanie firmy`,
"label.loginhis.recently":`Historia ostatnich logowań`,
"label.permission.visualpagepermission.edit":`Własne przypisanie strony`,
"label.ccservice.validate.email":`Format odpowiedniej wartości {2} pola {1} w obiekcie API {0} jest nieprawidłowy. Proszę podać poprawny adres e-mail!`,
"label.sms.companyname.gm":`Ustawienie SMS-2`,
"lable.opppdt.addpdt.table.discount":`Rabat (% zniżki)`,
"Lead.Scoring.Setting.LevelSetting":`Ustawienia popularności ołowiu`,
"message.duplication.label.duplicationremark":`to operacja odpytywania duplikatów danych, gdy nowe lub edytowane rekordy`,
"label.file.preview.error":`Wystąpił błąd podczas prewejścia, proszę pobrać aby zobaczyć`,
"label.imgfield.type.input":`Wstaw obraz`,
"label.file.share.email.content1":`Nazwa pliku: #filename`,
"vue_label_notice_batchedit_fail":`Aktualizacja danych o identyfikatorze {0} nie powiodła się z powodem {1}.`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.four":`Cztery`,
"label.view.sortview.printview":`Drukuj`,
"label.projectManagement.Addposttask":`Dodaj po wykonaniu zadania`,
"vue_label_commonobjects_view_fail":`Nie udało się ustawić domyślnego widoku`,
"label.dayinweek":`Tydzień`,
"label.layout.notexist":`Układ nie istnieje.`,
"label.brief.total":`Zapis {ogółem}`,
"label.dashboardSetup.tz.bb":`Przejdź do raportów`,
"label_emailtocloudcc_select3":`Proszę wybrać właściciela rekordu`,
"label.input.least.string":`Proszę wprowadzić co najmniej {0} znaków`,
"label.app.step2":`Krok 2 Wprowadź szczegóły`,
"lable.account.LastWeek":`W ostatnim tygodniu`,
"label.notifications":`Powiadomienia`,
"label.tabpage.viewname":`Wyświetl nazwę`,
"label.knowledge.language.italian":`Włoski`,
"label.sendmail.step2.introduce":`Proszę wybrać szablon wiadomości e-mail`,
"label_enable_or_no":`Czy chcesz włączyć ?`,
"pagecreator_button_save":`Zapisz`,
"template.chart.cplb":`Kategoria produktu`,
"label.knowledge.publish":`Nie może być publikowany, ponieważ nie jest kwalifikowany.`,
"label.name.required":`Pole nazwy jest wymagane`,
"component.chatter.label.myfans":`Moi zwolennicy`,
"label.rejectoperate":`Czynności związane z odrzuceniem`,
"label.report.action.addtodashboard3":`Wybierz Pulpit nawigacyjny`,
"label.icon.101":`Podręcznik`,
"label.data.exp.su.ok":`Eksportowanie`,
"label.appupload.component.type.layout":`Układy stron`,
"template.chart.yscb":`Budżetowany koszt`,
"label.tabularreport.selectorder":`Określanie rodzaju wyświetlania każdej kolumny raportu`,
"email.title.one":`Odzyskaj hasło`,
"label.case.copy.link":`Kopiuj łącze internetowe`,
"label.mr.descreption.oneGroupReData4":`grupa, pozostaje`,
"label.newprocess5.error.des":`Można wprowadzać tylko liczby.`,
"label.partnerCloud.loginButton":`Przycisk logowania`,
"label.interfaceconstraint.adminonly":`Tylko administratorzy mogą korzystać z tego interfejsu.`,
"label.campaign.channel.input.date":`2.Proszę ustawić okres ważności dla Twojego kanału marketingowego:`,
"label.clientwebsiteentranceprofile":`Profil Portalu Klienta`,
"UG.opportunity.011":`Transakcja importowa`,
"label.page.copy.value.paste.template":`Skopiuj i wklej wartość pola scalania do swojego szablonu poniżej.`,
"label.notselect":`No Select`,
"label.weixin.input.password":`Proszę wpisać swoje hasło.`,
"label.email.select.template":`Wybierz szablon`,
"label_chatter_ok":`Potwierdź`,
"permissionService.error":`Przypisanie zestawu uprawnień nie powiodło się, proszę sprawdzić, czy licencja aplikacji wygasła lub przypisanie osiągnęło górny limit.`,
"label.webtocloudcc.sorry":`Przepraszamy, błąd strony, proszę spróbować ponownie lub skontaktować się z administratorem.`,
"UG.opportunity.007":`Funkcja kontaktu`,
"label.manageAll.forapproval":`Punkty do zatwierdzenia`,
"label.imgfield.type.ref":`Wzór Obraz`,
"label.profile.setcustomtab":`Własne ustawienia zakładek`,
"label.tabpage.datatyoez":`Typ danych`,
"label.partnerCloud.basicSetting.editPersonal":`Zezwolenie użytkownikom chmury partnerskiej na edycję danych osobowych`,
"label.mr.caption.account":`Znajdź duplikaty i połącz: Kody do wyszukiwania duplikatów kont`,
"message.serviceterritoryMe.time.violation":`Naruszenie czasu wysyłania: okres wysyłania nie mieści się w zakresie czasowym członków regionu.`,
"pagecreator_page_message_publish_success":`Strona została pomyślnie opublikowana`,
"label.field.formula.timezonetip":`Należy zwrócić uwagę na obsługę wielu stref czasowych dla obsługi funkcji typu data/czas. W przypadku użycia funkcji systemowej, takiej jak sysdate, w formule w celu uzyskania bieżącego czasu, należy ją zastąpić odpowiednią funkcją obsługującą wiele stref czasowych, taką jak current_date.`,
"label.marketseamemset.specialuser":`Członek specjalny`,
"label.staticresource.message":`Szczegółowe informacje o zasobach statycznych`,
"label.workflow.rulecondition":`Kryteria zasad`,
"component_salesperformance_label_nodata":`Dodaj swoją okazję biznesową i wróć tutaj, aby zobaczyć wykres wydajności.`,
"label.customfields.textarea.tip":`Umożliwia użytkownikom wprowadzanie wielu wierszy tekstu, do 4000 znaków.`,
"font-evaluate-module-v1-template":`Własny szablon`,
"label.step3.total5":`Krok 3 z 5`,
"label.customfields.formula.percent.tip":`Obliczanie procentu i automatyczne dodawanie znaku procentu do liczby.`,
"label.sortdesc":`Zejdź`,
"lable.PowerProcess.edit":`Edytuj proces uprawnienia`,
"label.dongshifang.description":`Skonfiguruj informacje Dongshifang, aby spełnić potrzeby Twojej organizacji w zakresie wysyłania i odbierania SMS-ów.`,
"label.chatter.addressee":`Odbiorca`,
"vue_label_systemSettings_obj2":`Konsola zarządzania obiektami`,
"label.selectreporttype.tip":`Wybierz typ danych, które mają być zawarte w raporcie`,
"label.version.enterprise":`Enterprise Edition`,
"label.area.add":`Dodaj terytorium`,
"label.h5.bookmarked":`Zakładki do książek`,
"label.step5.total7":`Krok 5 z 7`,
"front-lightning-module-v1-title-quotation":`Podgląd Cytat`,
"label.search.onlymyrecords":`Ograniczenie do przedmiotów, które posiadam`,
"vue_label_commonobjects_noduplication":`Duplikat {字段} w {记录}.`,
"label.customerpage.edit":`Edycja zakładek na stronach niestandardowych`,
"message.please.choose.user":`Proszę wybrać użytkownika`,
"label.approval.his.currentactor":`Aktualny zatwierdzający`,
"label.field.duplicate.error.msg3":`Możesz utworzyć najwyżej 3 unikalne pola właściwości.`,
"label.page_url":`URL strony`,
"label.permission.goback":`Powrót do Zestawów uprawnień`,
"vue_label_commonobjects_view_kanban_notice2":`Aby wyświetlić wszystkie rekordy, użyj widoku listy lub widoku podzielonego ekranu`,
"label.group.no.recent.searchs":`Nie ma pasujących ostatnio oglądanych grup.`,
"label.event.fiducial.point":`punktualny`,
"label.integrations.mailchimp.addtolist":`Dodaj wybrane leady i kontakty z konta CloudCC do swojej listy Mailchimp`,
"label.workflow.configrule.introduce":`Należy wprowadzić nazwę, opis i kryteria wyzwalające regułę przepływu. W następnym kroku należy skojarzyć akcje przepływu z tą regułą.`,
"label.icon.161":`Walizka`,
"label.recordtype.enable":`Aktywny`,
"label_mailboxes_limit":`Liczba skrzynek przekracza limit.`,
"label.notification.time3":`{0} godzin temu`,
"label.setsharerule.step2":`Krok 2 Wybierz, które rekordy mają być udostępnione`,
"vue_label_homepage_somecomponents":`Uwaga! Po dodaniu komponentu wysokość przekracza limit i powoduje niekompletne wyświetlanie. Proszę usunąć niektóre elementy.`,
"label.icon.63":`Studnia podziemna`,
"label.use.standard.sharerules":`Użyj standardowych zasad podziału`,
"label.button.step2.select.required.field":`Krok 2 Wybierz wymagane pola`,
"lable.Confirm.collect.potential.customers":`Potwierdzam odbiór leadu {nazwa}`,
"label.version.sum.custompage":`strona(y) własna(e)`,
"label.file.ccchat.changefile":`Plik zmian`,
"label.mobile.phone.phone.call":`Zadzwoń na`,
"label.appupload.managed.img":`Kontrolowane`,
"vue_label_chatter_comment":`komentarz`,
"label.central.european.time":`Czas środkowoeuropejski`,
"label.three.quarter":`III kwartał`,
"label.service.newBuildDialog.filter.editor":`Edytor filtrów`,
"pagecreator_systemstyle_funcpath":`/ konstruktor / biblioteka stylów marki`,
"label_chatter_collect":`Zakładka do książki`,
"label.custom.page.component.window.settings":`Ustawienia okna komponentu`,
"component_chatter_file_label_title":`Przesyłanie plików`,
"label.marketsea.button.discard":`Odrzuć`,
"label.Batch.input":`Wejście wsadowe`,
"vue_label_campaign_market_members":`Istniejący członkowie rynku`,
"label.salescloud.salesdashboard":`Pulpity sprzedaży`,
"message.summaryconditionrepeated":`Przepraszamy, warunki podsumowania dublują się, prosimy o ponowny wybór.`,
"label.tianyancha.h5.companycode":`Kod firmy`,
"label.quickbooks.description":`Śledź swoje faktury, płatności i szacunki w QuickBooks Online.`,
"label.colombia.time":`Czas Kolumbii`,
"label.usermanage.unknown.license":`Nieprawidłowa licencja i nie można utworzyć nowych użytkowników, skontaktuj się z administratorem.`,
"label.operatedata.selectoperateandobject":`Wybierz operację (Importuj lub Eksportuj) i obiekty`,
"message.setup.field.picklist.valuerepeated":`Wartości z listy nie mogą być powtórzone, proszę wpisać je ponownie.`,
"label.editerror.list":`Lista danych nie została edytowana.`,
"pagecreator_page_message_save_success":`Strona zapisana pomyślnie`,
"label.icon.154":`Komputer`,
"label.emailsync.setting":`Osobiste ustawienia poczty elektronicznej`,
"label.startuploadfile.step2":`Krok 3 Kliknij "Rozpocznij przesyłanie", aby przesłać pliki`,
"label.dashboard.notmeet.conditions":`Nie znaleziono pasujących informacji, a tablica rozdzielcza nie została skonfigurowana.`,
"label.temp.del.conf":`Czy na pewno chcesz usunąć?`,
"label.sms.authkey":`Hasło uwierzytelniania`,
"lable.oppt.jieduan.choosejieduan":`Wybierz etap zamknięty`,
"label.tabpage.viewNamez":`Proszę wprowadzić nazwę widoku`,
"label.totalQuotation":`Łącznie z wyceną`,
"label.tabpage.hoursagoz":`Godziny`,
"label.receiveadminnews":`Odbieranie wiadomości od administratora`,
"label.field.is.lookup":`Czy pole jest skorelowane z polem lookup?`,
"label.any_changes":`Wszelkie zmiany dokonane tutaj będą również aktualizować stopkę w`,
"lable.products.to.assets":`Potwierdzić przeniesienie produktu na aktywa?`,
"label.dashboard.compare":`Porównanie`,
"vue_label_chatter_notice1":`Po usunięciu grupy, wszystkie informacje w grupie zostaną usunięte, ale pliki grupy nie zostaną usunięte.`,
"label_tabpage_exitz":`Wyloguj się`,
"label.potentialcustomerflow":`Procesy wiodące`,
"label.longtext":`Obszar tekstowy (długi)`,
"october":`Październik`,
"label.customer.email":`E-mail`,
"label.partnerCloud.productSet.addChildren":`Dodaj podpoziom`,
"label.defaultline.cannot.greater":`Domyślna liczba wierszy nie powinna przekraczać 30.`,
"front-detail-module-v1-view-report":`Wyświetl raport`,
"label.knowledge.setting.hint.sixteen":`Zachowaj wiedzę i kontynuuj jej przekazywanie`,
"label.page.use.merged.field":`Z polem łączącym`,
"label.salescloud.salescloud.continuerecover":`jeśli kontynuować, usunięcie zostanie wykonane i będzie można je odkryć`,
"front-project-module-v1-from-template-create":`Utwórz z szablonu`,
"label.exportall":`Eksport wszystkich rekordów wszystkich obiektów`,
"label.weixin.recalculate.shared.results":`Przeliczanie wyników reguły udostępniania`,
"label.components.isTemplate":`Dane szablonu`,
"label_emailsync_status":`Status e-mail użytkownika`,
"label.file.library.delete":`Czy na pewno chcesz usunąć {librayrname}？`,
"label.integrations.username":`Nazwa użytkownika`,
"front-lightningset-module-v1-detail-page-report-chart":`Wykresy raportu na stronie szczegółów`,
"label_tabular":`Układ listy`,
"label.approverecords":`Zatwierdzić`,
"vue_label_helpcenter_topic":`Korzystanie z wersji Lightning i pomoc`,
"label.h5.date.none":`Non`,
"lable.outlook.mcto.allrecord":`Wszystkie zapisy`,
"label.readandwrite":`Odczyt/zapis`,
"label.allfold":`Upadek Wszystkie`,
"AD":`Adres`,
"message.custom.field.donotdelete.reporttype":`Do pola odwołuje się źródło danych raportu`,
"label.escalation.setup.newaction.title":`Działanie eskalacyjne Edycja`,
"label.dashboard.snapshot.settings":`Ustawienia migawek pulpitu nawigacyjnego`,
"label.attendance.inner":`Pracownik biurowy`,
"chatter.ns":`Nowa wiadomość`,
"label.validate.nowork":`Błąd: nieprawidłowe pole, proszę ponownie wybrać lokalizację komunikatu o błędzie.`,
"label.custom.EmptyCanvas":`Przezroczyste płótno`,
"label.service.miniProgram.fillImageOrder":`Proszę podać kolejność karuzeli.`,
"label.icon.16":`Serwis`,
"label.selected":`Wybrane`,
"component_chatter_link_label_name":`Nazwa związku`,
"label.reportsSubscriptionPage.schedulereport.starttime":`Preferowana godzina rozpoczęcia`,
"label.file.uploadNewVersion":`Prześlij nową wersję`,
"chatter.group.theMembership":`Członkostwo`,
"label.knowledge.recommended.articles":`Sugerowane artykuły`,
"label.appupload.install.parentobj":`Obiekt macierzysty`,
"label.file.recent":`Ostatnio`,
"vue_label_helpcenter_quote":`Wycena reprezentuje sugerowaną cenę produktów i usług Twojej firmy. Możesz tworzyć oferty z okazji i ich produktów.<br>?W prawym górnym rogu informacji szczegółowych możesz użyć przycisku, aby zsynchronizować ofertę z okazją biznesową lub zsynchronizować ofertę z okazją biznesową. Jeśli wycena jest zsynchronizowana z szansą, wszelkie zmiany w wierszu wyceny zostaną zsynchronizowane z produktem szansy i na odwrót. Każda okazja biznesowa może mieć wiele powiązanych cytatów, z których każdy może być zsynchronizowany z okazją biznesową.<br>?W prawym górnym rogu szczegółowych informacji, można wygenerować pdf i podgląd oferty, i można bezpośrednio wydrukować, pobrać lub zapisać.`,
"message.error.field.default":`Wartość domyślna musi być dodatnią liczbą całkowitą.`,
"label.campaignmember.main.importmember.contacts.desc":`Importuj kontakty kampanii z plików.`,
"vue_label_calendar_show_only_this_calendar":`Pokaż tylko ten kalendarz`,
"vue_label_quot_syncfrom":`Synchronizacja z możliwości biznesowych`,
"label.data.expnode.e_desc2":`2. Eksport według szablonu: użytkownicy mogą wybrać szablon do eksportu danych.`,
"label.login.verification.mfa.desc1":`Musisz zainstalować aplikację MFA na swoim urządzeniu inteligentnym, aby kontynuować.Popularne aplikacje, które obsługują MFA na urządzeniach inteligentnych to: Cebula, Google Authenticator.`,
"label.jiandangfenpei.desc":`Przypisanie dostępu do bieżącej strony niestandardowej do profilu. Administratorzy mają dostęp do wszystkich stron niestandardowych.`,
"label_tabpage_thisrecord":`Ten zapis`,
"lable.SalesCommitmentKanBan.totalPaymentAmount":`Rollup Wpływy Kwota`,
"message.error.object.notvalidcurrency":`Nieprawidłowa waluta`,
"label.edit.discount":`Edytuj Rabat`,
"label.setup.mobile.offlinecache.setenable":`Włączenie funkcji offline po stronie mobilnej`,
"UG.ST.005":`Mam to, nie pokazuj mi tej strony ponownie i zaloguj się prosto następnym razem.`,
"label.assignedapprover":`Przydzielony zatwierdzający`,
"template.chart.htlx":`Rodzaj umowy Statystyka`,
"scope":`W zakresie`,
"label.workmate.search":`Wyszukaj współpracowników`,
"message.validation.isnotdigits":`Proszę wpisać nieprawidłowy numer`,
"label.ccpeak.use.class.time.page":`Jeśli klasa jest wywoływana przez stronę niestandardową, wywołaj metodę invoker() w klasie PageClsInvoker.`,
"setup_mainpage_label_welcome27":`Platforma chmurowa CloudCC udostępnia takie funkcje jak import, eksport, wsadowe usuwanie i wsadowe przenoszenie wszystkich danych o obiektach w systemie.`,
"front-epwechat-module-v1-epwechat-integrate":`Integracja WeCom`,
"label.file.publiclink":`Link publiczny`,
"front-epwechat-module-v1-input-name":`Proszę wpisać nazwę przedsiębiorstwa`,
"lable.Number.of.columns":`Kolumny`,
"message.error.dev.service.duplicateparameter":`Duplikat parametrów serwisowych.`,
"label.projectManagement.percent.complete":`Procent ukończenia`,
"label.chatter.nextSevenday":`Następne 7 dni`,
"chatter.feed.myfollowers":`Moi zwolennicy`,
"label.bacchtransfer.pleaseselecttouser":`Przelew do`,
"label_partner_workspace_member_memo":`Wszyscy użytkownicy z wybranym profilem i zestawem uprawnień mogą uzyskać dostęp do tej chmury partnerskiej.`,
"label.marketsea.chosen.member":`Wybrani posłowie`,
"label.marketsea.assignment.setup":`Ustawienia przydziału`,
"label.myaccount":`Moje konta`,
"label.schedulejob.setup.schedule.executedate":`Czas wykonania`,
"label.uploadaccessory":`Przesyłanie załączników`,
"Homepage.News.004":`Ostatnio nie ma żadnych nowości.`,
"label.marketsea.name":`Nazwa basenu wiodącego`,
"label.pending.task":`Otwórz zadania`,
"label.report.details":`Szczegóły`,
"UG.homepage.008":`Zrozumienie bieżącego statusu biznesowego (briefingi sprzedażowe, tablice liderów, lejki sprzedażowe itp.), przeglądanie możliwości biznesowych, które mogą być problematyczne, przewidywanie przyszłych wyników, terminowe akceptowanie i przypisywanie ważnych kwestii oraz podejmowanie świadomych decyzji.`,
"label.h5.similar.opportunity.clear.all":`Wyczyść wszystko`,
"label.tabpage.noz":`Nie`,
"label.report.recent.all.reports":`Wszystkie raporty`,
"vue_label_lead_to_score":`Kliknij przycisk Oceń, aby ocenić leady w bieżącym widoku.`,
"vue_label_normal_receivable_sf":`Należności`,
"label.layout.edittabdistribute":`Edycja układu karty`,
"label.validate.function.funcFormat.PRIORVALUE":`PRIORVALUE(pole)`,
"label.salescloud.field.editoptionlist":`Edycja listy wyboru`,
"APPIntegration.Dropbox.01":`Wybierz pliki z Dropbox`,
"label.campaign.channel.step2":`Krok 2: Ustaw domyślne wartości pól leadów dla tego kanału marketingowego.`,
"label_partner_new_function":`Opis funkcji`,
"vue_label_chat_no_search_results":`Brak wyników wyszukiwania`,
"vue_label_commonobjects_detail_visitstate":`Odwiedź stan`,
"label.sendemail.send.testemail":`To jest testowy email, jeśli możesz go odebrać, możesz użyć tej skrzynki do wysyłania emaili.`,
"label.attendance.clear.position":`Wyraźne punkty orientacyjne`,
"chatter.write.n":`Skomentuj ten post`,
"label_chatter_sendmail":`Wyślij e-mail`,
"label.remindertime":`Czas przypomnienia`,
"label.app.elegantgray":`Elegant Grey`,
"label.tabpage.ownedz":`Totalnie`,
"label.select.approval":`Wybierz zatwierdzającego`,
"UG.Lead.007":`Synchronizacja Google`,
"chatter.emailSetUp":`Moje CCChat Remind Setup`,
"label.default.censor":`Egzaminator z urzędu`,
"vue_label_notice_uploadavatar_success":`Awatar załadowany pomyślnie`,
"label.sms.title":`Informacje o interfejsie SMS`,
"front-console-choose-contact":`Wybierz kontakt`,
"label.field.edit.des":`Wyższy wynik pokazuje więcej ikonek gwiazdek, a maksymalny wynik to 100.`,
"label.pw.big.letter":`Duże litery`,
"label.select.time.dimension":`Proszę wybrać wymiar czasu`,
"UG_Campaign_004":`Kampania importowa`,
"label.dashboard.summary":`Metryczna`,
"label.ems.yahoo":`Yahoo!`,
"label.leadscore.rule.name":`Nazwa reguły Lead Scoring`,
"vue_label_calendar_object_name":`Nazwa obiektu`,
"label.icon.69":`Maszyna`,
"label.reporttotal":`Ogółem`,
"lable.SalesCommitmentKanBan.theActualContract":`Faktyczna kwota umowy`,
"label.project.member.data":`Ten użytkownik jest już członkiem bieżącego projektu!`,
"label.cloudccclass.list.viewremark":`Pomoc dla tej strony`,
"label.deleteObject.isNotAdministrator":`Nie jesteś administratorem i nie możesz usuwać obiektów.`,
"lable.edit.queue.nameandemail":`Nazwa kolejki i adres e-mail`,
"label.recordtype.tabname":`Typy rekordów`,
"label.file.is.ok":`Czy to jest ok.`,
"label.knowledge.language.german":`Niemiecki`,
"label.layout.realityapprover":`Faktyczny zatwierdzający`,
"label.ems.with7day":`W ciągu 7 dni`,
"label.autoRegister.changepwd.setpwd.setpwd.button":`Rozstawienie`,
"label.weixin.edit.polls":`Zmiana głosowania`,
"label.layout.mobile.default.tab":`Wybierz domyślną zakładkę w aplikacji mobilnej`,
"vue_label_report_deletegroupcolumn":`Usuń kolumnę grupy`,
"label.group.archived.success":`Archiwum z powodzeniem`,
"label.customfields.formula.returntype":`Typ zwrotu formuły`,
"label.file.followers":`Followers`,
"label.textmessage.new.templates.message1":`Nazwa szablonu nie może być pusta！.`,
"label.selected.field.length":`Nie więcej niż 10 wybranych plików`,
"ObjectDetailed_ViewKeyInformation_Layout":`Edytuj kluczowe informacje`,
"label.paging.totalofpage":`Łącznie {0} stron`,
"label.ccchat.message.new.error41":`Aby porozmawiać z większą liczbą osób, spróbuj użyć grup`,
"message.recordtype.detail.noselectlist":`Nie można wyświetlić żadnej listy wyboru`,
"label.conditiontag.lookup.title":`Wybierz wartości z poniższej listy wyboru, aby dodać.`,
"label_partner_setup":`Ustawienia chmury partnerskiej`,
"front-epwechat-module-v1-android-packname":`Android Nazwa pakietu:`,
"lable.custom.Current.CY":`Bieżący CY`,
"label.newprocess2.desc":`Jeżeli rabat jest większy niż 0.3%, zwraca wartość true.`,
"label.operatedata.selectobjectfields":`Wybierz pola eksportowanego obiektu`,
"report_reportdatasource_label":`Raport Źródło danych`,
"label.chosesubject.others":`Inne działania`,
"label.list.desc2":`Możesz wygenerować stronę PC dla dostępu z komputera lub stronę mobilną dla dostępu z urządzenia mobilnego.`,
"vue_group_several_groups":`{totalSize} grupy`,
"label.page.button.linkurl":`Przycisk lub link URL`,
"show.week":`Pokaż Weekend`,
"label.gotocalendar.new":`Przejdź do kalendarza i utwórz wydarzenia`,
"button.reset.advancedsearch":`Wyczyść warunki wyszukiwania zaawansowanego`,
"label.h5.chatter.feedandcomnum":`Napisz i zostaw wiadomość`,
"lable.opppdt.addpdt.table.unitprice":`Cena sprzedaży`,
"label.dataimport.validate":`Wybierz weryfikację, która ma być przeprowadzona`,
"label.lead.score":`Lead Scoring`,
"vue_label_help_product":`Broszura produktowa i cenowa`,
"label.role.select":`Wybierz role`,
"lable.opppdt.selPdt.searchproduct":`Znajdź produkty`,
"component_event_label_newevent":`Nowe wydarzenia`,
"front-invoice-online-payment-setup-configure-button":`Skonfiguruj teraz`,
"label.stdashbord.xsld.business.img2":`Łączna suma oportunistycznych etapów z prawdopodobieństwem 1%-99%`,
"label.event.moveup.2week":`2 tygodnie naprzód`,
"label.partnerCloud.priceOfManual.allCustomer":`Wszystkie rachunki`,
"lable.account.dep":`Kliknij przycisk Nowy, aby zdefiniować nowy rok fiskalny.`,
"label.dataimport.insertdata.error.null.update":`Wartość $schemefield_name$ w tym rekordzie jest pusta i nie może być aktualizowana. Rekord zignorował import.`,
"label_component_helper_businesschange_0activity":`30 dni bez żadnej aktywności`,
"lable.account.NextbbDays":`Następne 60 dni`,
"label_scope_length":`Zakres-długość`,
"label.customfields.operation":`uruchomić eksport danych`,
"serviceappointment.save.workorder":`Proszę wybrać zlecenie pracy powiązane z pozycją zlecenia pracy.`,
"label.field.update.hide.editor":`Ukryj edytor formuły`,
"button.partner.new":`Nowa chmura partnerska`,
"label.stdashbord.xsld.business.oppdetails":`Szczegóły dotyczące możliwości`,
"message.pleasewaitingnextversion":`Ta funkcja będzie dostępna w następnym wydaniu.`,
"label_tabpage_potentialcustomersz":`Leads`,
"label_emailtocloudcc_step2":`Krok 2`,
"label.weixin.username":`Nazwa`,
"label.quickbooks.viewlist.type":`TYP`,
"front-kefu-moudle-v1-Select-seats":`Wybierz agenta`,
"label.customsetting.manage":`Zarządzaj stroną`,
"label.tabpage.field":`Pole`,
"label.custom.page.button.icon.URL":`Przycisk Ikona URL`,
"font-evaluate-module-v1-evaluation-link":`Dodaj link do oceny:`,
"vue_label_salesfunnel_notice3":`Ilość możliwości biznesowych o prawdopodobieństwie 1% - 99%`,
"front-email-payment-describe":`Dziękujemy za Twoje wsparcie dla naszej działalności. Możesz płacić online za pośrednictwem poniższego linku, a także przeglądać, drukować i pobierać faktury w formacie PDF.`,
"label.productsales.today.noevttskaddevt":`Nie ma żadnych otwartych wydarzeń i wygasających zadań, możesz kliknąć " " w prawym górnym rogu, aby dodać nowe wydarzenie.`,
"component.setup.iframe.label.memo":`Kliknij ikonę ustawień i wprowadź adres osadzonego adresu url.`,
"front-email-payment-select-country":`Proszę podać kraj`,
"label.ems.starred":`Wiadomości e-mail oznaczone gwiazdką`,
"component_setup_label_object":`Obiekty`,
"label.query.detail.viewpartneruser":`Wyświetlanie użytkownika partnerskiego`,
"this.year":`W tym roku`,
"serviceresource.isactive.notactive":`To źródło usług nie jest włączone.`,
"label.marketing.message.recipientisnull":`Odbiorca nie może być pusty`,
"label.unfold":`Rozwiń`,
"label.service.assetBOM.view.tip":`Nie masz uprawnień, aby wyświetlić BOM aktywów. Prosimy o kontakt z administratorem.`,
"label.validate.function.funcExplain.ISCHANGED":`Sprawdza, czy wartość pola jest różna od poprzedniej wartości. Jeśli nie, zwróć TRUE, w przeciwnym wypadku zwróć FALSE.`,
"label.validate.function.funcExplain.NOW":`Zwraca datet i ime reprezentujące bieżący moment.`,
"label.phoenix.islands.time":`Phoenix Is. Czas`,
"vue_label_checkduplicate_complete_filter_rules":`Proszę wypełnić warunki filtrowania`,
"vue_label_report_rowcount":`Liczba wierszy`,
"chatter.p":`osoba`,
"label.umeng.activity.distributetask":`przydzielił ci zadanie.`,
"UG_quota_05":`Bisync with Opportunities`,
"june":`Czerwiec`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.tuesday":`Wtorek`,
"vue_label_commonobjects_view_chart_upto5":`Do 5 grup`,
"vue_label_opportunity_contactrole_searchallcontacts":`Wyszukaj wszystkie kontakty`,
"label.custom.field.task.notice":`Powiadomienie o zadaniu`,
"label.weixin.insert.address":`Wstaw Lokalizacja`,
"label.attachementNew.desc":`Zarchiwizuj załącznik do dokumentu, a załącznika nie można usunąć.`,
"setup_mainpage_label_welcome18":`Ustawienia uprawnień w CloudCC pozwalają kontrolować prawa poszczególnych użytkowników do korzystania z danych i modułów. Ustawienia uprawnień oparte na rolach obejmują również pozycje użytkowników, grupy, role, zasady udostępniania danych i kontrole bezpieczeństwa na poziomie pola, aby umożliwić współdzielenie danych między różnymi osobami i działami przedsiębiorstwa.`,
"front-kefu-instance-noarea":`Nie utworzono instancji dla tego obszaru, proszę wybrać ponownie`,
"label.please.ChooseMax":`Proszę wybrać do {a} opcji produktu.`,
"label.businesschance":`Możliwości`,
"label.verticalline-group":`Kolumny pionowe - grupowanie kolumn`,
"label.ordering.platform":``,
"label.product.pricebooks.ples":`Proszę wybrać książkę cenową`,
"vue_label_norm_addcomponent":`Nowy składnik`,
"label.ServiceCloud.Installation.address":`Adres instalacji`,
"vue_label_report_groupcolumn":`Kolumna grupy`,
"label.ccchat.person.invite.notallsucc":`{0} adresy e-mail zostały zapisane, ale nie zostały wysłane. aby wysłać zaproszenie, popraw poniższy błąd i kliknij przycisk Wyślij.`,
"label.customfields.optionlist.tip":`Umożliwia użytkownikom wybranie wartości z listy zdefiniowanej przez użytkownika.`,
"UG.activity.07":`Utwórz zadanie`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.last":`Ostatnio`,
"label.permission.accessname":`Nazwa dostępu`,
"lable.custom.year.stadate":`Rok niestandardowy Data rozpoczęcia`,
"label.ems.inputmails":`Serwer odbiorczy poczty elektronicznej (i)`,
"label.cpq.quote.transfer.order.already":`Ta oferta została przeniesiona do zamówienia. Proszę usunąć oryginalne zamówienie, a następnie zregenerować zamówienie.`,
"label.sendletter.status":`Status członka kampanii`,
"vue_label_commonobjects_view_save_as_view":`Zapisz jako widok`,
"message.mobilechooseatmostfive":`Wybierz do 5 pól`,
"label.errormessage.batchedit.nopermission":`Brak rekordu danych, do którego masz uprawnienia edycyjne.`,
"label.dataoperate.tip":`Wybierz operację i obiekty.`,
"label.enableoperate":`Dostępne działania`,
"label.ems.usernamepassword.error":`Błąd konta lub hasła skrzynki pocztowej.`,
"label.campaignmember.selectmember.deletemember":`Usunąć członków z`,
"label.Tab":`Zakładki`,
"label.emailobject.template.message1":`Proszę wybrać pole i kliknąć "Wstaw". Przy pomocy ">" oznacza kliknij, aby zobaczyć więcej dostępnych pól.`,
"label.approvalstep3.tip":`Określenie użytkownika, który powinien zatwierdzić rekordy wchodzące do tego kroku. Opcjonalnie wybierz, czy delegat zatwierdzającego ma również prawo do zatwierdzania tych wniosków.`,
"label.inusing":`Aktywny`,
"label.edit.select.tre":`Lista pól wyboru`,
"label.appointmentconfirmail.wizard.title1":`Halo {0}`,
"label.partnerCloud.financeSetting.setAlipay":`Skonfiguruj Alipay`,
"lable.edit.queue.avobj":`Dostępne obiekty`,
"vue_label_checkduplicate_verify_all_characters":`Sprawdzić wszystkie znaki`,
"label.huntingzone":`Zakres wyszukiwania`,
"label.request.approved":`Wniosek został zatwierdzony, nie powtarzaj go.`,
"label.sharerule.msgerror":`Wewnętrzny błąd serwera`,
"front-epwechat-module-v1-tick-unbound":`Proszę zaznaczyć zgodę i zaakceptować powyższe niewiążące informacje`,
"label.console.step6":`Krok 6 Wybierz sposób wyświetlania list`,
"label.multilang.micropost.vote":`{0} bilet(y)`,
"message.error.appid.null":`Klucz tajny nie może być zerowy!`,
"lable.product.delq":`Usuń problemy`,
"label.h5.approval.leixing":`Typ homologacji`,
"label.edit.field.select.style1":`Kafelki każdej opcji`,
"label.passwordPolicy.setup.alpandnum":`Musi łączyć znaki alfanumeryczne i numeryczne`,
"label.ems.close2":`Zamknij`,
"label.report.reporttypetitle":`Źródło danych`,
"label.umeng.approval.approvalsuccess":`został przedłożony do zatwierdzenia.`,
"label.page.showamount":`Całkowita liczba rekordów na stronę`,
"label.copy.asset.successfully":`Skopiuj BOM aktywów pomyślnie.`,
"vue_label_homepage_bigscreen_dark":`Ciemna`,
"vue_label_email_selected_members":`Wybrani członkowie`,
"label.file.preview":`Podgląd`,
"label.partner.new.step3.name":`Nazwa`,
"label.forecast.settings.periods.ago":`cykl(y) temu`,
"label.evaluation.praise":`Dobra`,
"label.cloudccsite.edit":`Edycja strony`,
"label.knowledgebase.advanced.filtering":`Filtr zaawansowany`,
"label.knowledgebase.framework":`Rama`,
"vue_label_pool_ownedpool":`Basen główny`,
"label.exchange.sync.setting.license":`Po włączeniu tej funkcji niektóre dane organizacyjne mogą być zapisywane na serwerze Microsoft Exchange w formie wdrożenia wewnętrznego lub w chmurze i przetwarzane przez serwer Microsoft Exchange.`,
"front-console-conversation-btn2":`Email Reply`,
"label.projectManagement.thelastone":`To jest ostatnia płyta.`,
"message.duplication.confirmscript.mergeoperation":`Rekordy te są łączone w jeden rekord za pomocą wybranych wartości. Uwaga: nie można cofnąć akcji scalania. Czy na pewno chcesz scalić rekordy?`,
"lable.outlook.detail.nosyn":`Brak synchronizacji`,
"label.iscopy":`Umożliwienie kopiowania`,
"message.matrixReportSetupStage.row":`Proszę wybrać 【Specify Row Headers】 podstawę sumy częściowej, przy czym należy wybrać jedną podstawę sumy częściowej co najmniej w dwóch podstawach sumy częściowej.`,
"label.forecast.forehistory.possibility":`Prawdopodobieństwo`,
"label.timetrigger.validate":`Wprowadzona wartość musi być dodatnią liczbą całkowitą, a system automatycznie wykona akcje przepływu, gdy wartość ta będzie dodatnią liczbą całkowitą, czyli w momencie, gdy spełniona zostanie zależność przepływu, system automatycznie wykona operację przepływu.`,
"member.name.choice.field":`Imię i nazwisko członka jest polem wymaganym !`,
"label.undone_external page":`To jest nieodwracalne, więc proszę o potwierdzenie. Ten formularz nie jest używany na żadnej stronie logowania, ale może być używany gdzie indziej. Na przykład, mogłeś użyć kodu embed, aby wstawić go na zewnętrzną stronę.`,
"UG_Lead_012":`Wskazówki dotyczące importu`,
"component_chatter_label_fans":`Followers`,
"label.systeminfo":`Informacje o systemie`,
"label.mr.descreption.oneGroupNote1":`Proszę wybrać co najmniej dwie części danych i kliknąć [Załaduj wybrane informacje], aby przejść do strony łączenia danych.<br>To jest`,
"label.wtd.changefields.selfields":`Wybierz pola, które mają być zawarte w formularzu Web-to-CloudCC:`,
"message.error.fileinfoid.null":`fileinfoid nie może być pusty! Id informacji o pliku`,
"label_tabpage_cownerz":`Zmienić właściciela`,
"setup_layout_button_save":`Zapisz`,
"Dashboard.View.Createdbyme":``,
"label.escalation.setup.detail.order":`Zamówienie`,
"button.partner.start":`Zacznij używać`,
"label.htyj.remark1":`Twoja aktualna edycja nie obsługuje przeglądania obiektu umowy`,
"component.event.label.person":`Osoba wyznaczona`,
"label.appointmentconfirmail.wizard.subtitle3":`Lokalizacja`,
"label.emailtocloudcc.filed.username":`Adres e-mail`,
"label.vlidaterule.remark":`Zdefiniuj regułę walidacji poprzez określenie warunku błędu i odpowiadającego mu komunikatu o błędzie. Użytkownik może poprawić błąd i spróbować ponownie.`,
"message.duplication.label.insertoption":`Działanie w sprawie tworzenia`,
"front-web-module-v1-detail-comment-toast":`Proszę wypełnić wszystkie oceny`,
"label.import.page2.notsuitedfiledwillbenotimport":`Uwaga: System nie będzie importował niezmapowanych pól`,
"label.h5.similar.opportunity.enable":`Umożliwić podobne możliwości`,
"label.allunfold":`Rozwiń Wszystkie`,
"component_setup_iframe_label_inputurl":`Wpisz adres url`,
"label.manage.all":`Zarządzaj wszystkim`,
"label.mobile.side.tab.cs":`Wspólne funkcje`,
"label.datamanage.contact.information":`Dane kontaktowe`,
"lable.outlook.edit.sel":`Wybierz wartość`,
"label.imgfield.type.url.tip2":`Na przykład: http://www.cloudcc.com/images/logo.png&cimgSize=50,50`,
"setup.layout.label.areasetup":`Sekcja Właściwości`,
"label.date":`Data`,
"vue_label_commonobjects_detail_openfilter":`Rozwiń filtr`,
"label.loginip.pagecue":`Wprowadź zakres ważnych adresów IP, z których mogą logować się użytkownicy o tym profilu.`,
"vue_label_email_not_valid":`Podany adres e-mail nie jest prawidłowy.`,
"label.page.step5.add.application":`Krok 5 Dodaj do aplikacji niestandardowych`,
"label.dashboard.donot.delete":`Nie możesz usunąć tego folderu, ponieważ znajdują się w nim niektóre dashboardy.`,
"label.visitAPPexchange":`Sklep z aplikacjami CloudCC (nowe okno)`,
"label.generate.location":`Wygeneruj dane dotyczące szerokości i długości geograficznej klienta.`,
"lable.quote.syncing.syncingbutton":`Synchronizacja`,
"label.pw.error.text":`Dwa wpisane przez Ciebie hasła nie pasują do siebie.`,
"label_partner_setup_Enable":`Zweryfikuj`,
"label.file.preview.unav":`Podgląd niezablokowany`,
"label.sms.tip":`Z Internetu`,
"setup.mainpage.label.welcome21":`Platforma chmurowa CloudCC udostępnia funkcję definiowania przez użytkownika szablonów wiadomości e-mail, co jest wygodne dla użytkowników i zwiększa wydajność pracy.`,
"label.trigger.for.example":`Na przykład: zaktualizuj szansę w wyzwalaczu aktualizacji konta, zaktualizuj szansę w wyzwalaczu aktualizacji konta i uruchom wyzwalacz aktualizacji konta. Jeśli w wyzwalaczu nie ma kontroli warunkowej if no, to system pozwala na maksymalnie 3 takie okrężne wywołania.`,
"setup.layout.button.layoutprop":`Nieruchomości`,
"component.chatter.label.fans":`Followers`,
"lable.PowerProcess.event.edit":`Edytuj kamień milowy`,
"label.detailintro":`Pozycje linii Opis`,
"vue_label_report_nosearchresults":`Brak wyników wyszukiwania`,
"error.name.repeat":`Nazwa nie może się powtarzać.`,
"label.emailEncoding":`Kodowanie poczty elektronicznej`,
"label.partnerCloud.financeSetting.enableAccount":`Aktywuj konto rabatowe`,
"label_emailtocloudcc_clear":`Jasne`,
"setup_mainpage_label_welcome12":`Użytkownik może dokończyć definicję raportu klikając myszką, bez programowania, i postępując zgodnie z instrukcjami systemu. System ma do wyboru raport listy, raport podsumowujący i raport macierzowy. Dostępne są również opcje wyświetlania dla wszystkich pól. Usuń niepotrzebne informacje z pola. W tym samym czasie, zapewnia on różnorodność graficznych wyświetlaczy, w tym paski, linie zagięcia, pierścienie, lejki i torty, dzięki czemu użytkownicy mogą zobaczyć na pierwszy rzut oka.`,
"lable.SalesCommitmentKanBan.contractStartDate":`Data rozpoczęcia umowy`,
"front-starter-v1-potential-customer-tips-success":`Aktywuj Lead Pool z sukcesem`,
"UG_Forcast_02":`Prognozy to szacunki dotyczące oczekiwanej sprzedaży w danym okresie, a modele prognozowania mogą pomóc w określeniu popytu na produkty i przychodów ze sprzedaży w danym okresie. Menedżerowie mogą wykorzystywać prognozy do wyznaczania celów i mierzenia postępów zespołu. Ogólna prognoza organizacji może odzwierciedlać podsumowanie całej sprzedaży w podziale na przedstawicieli handlowych (niezależnie od etapu realizacji sprzedaży od etapu pipeline do etapu zamkniętego).`,
"label.escalation.setup.detail.ruleentries":`Zapisy zasad`,
"lable.SalesCommitmentKanBan.allComplete":`Całkowita kwota`,
"label.appupload.install.apicanuse":`Nazwa api jest dostępna`,
"label.organiza.field":`Pola organizacyjne`,
"button.partner.workspace.manage":`Zarządzanie`,
"lable.PowerProcess.setevent":`Ustawienie kamienia milowego`,
"label.emailobject.groupemail.msg2":`Brakuje adresu e-mail. To uniemożliwi wysłanie wiadomości e-mail do tego odbiorcy.`,
"label.h5.orderbyname":`Posortowane według nazwy`,
"vue_label_salesadvance_opportunities":`Numer możliwości`,
"label.appointment.disable.cancel":`Wyłączenie anulowania`,
"label.trigger.folder.edit":`Strona wyzwalacza: Edycja folderu`,
"label.customfields.new.step2.opration.unique.info.v2":`Traktuj "ABC" i "abc" jako różne wartości (wielkość liter ma znaczenie)`,
"label.icon.40":`Pozycjonowanie`,
"label.eventmenuandlink":`Przyciski i linki wydarzeń`,
"label.service.gantt.candidate":`Kandydat`,
"label.top.userphoto":`Zdjęcie użytkownika`,
"label.appointmentconfirmail.wizard.btn2":`Anuluj spotkanie`,
"label.print":`Drukuj`,
"saveandreturn":`Zapisz i wróć`,
"lable.account.CurrentandNextCY":`Obecny i następny CY`,
"label.group.no.recent1":`Nie przeglądałeś żadnych aktywnych grup.`,
"lable.Asset.conversion":`Generuj aktywa zgodnie z "Przejściem aktywów" produktu zlecenia przy przenoszeniu aktywów.`,
"label.emailtocloudcc.button.sure":`Potwierdź`,
"label.Path.List":`Lista ścieżek`,
"label.please.rule.name":`Proszę wpisać nazwę przepisów.`,
"label.knowledge.category.hint.six":`Dostępna grupa kategorii`,
"setup_mainpage_label_welcome28":`Instrukcje: Kliknij w menu po lewej stronie tej strony → Zarządzaj ustawieniami → Zarządzanie danymi → Import i eksport danych, Transfer wsadowy, Usuwanie wsadowe.`,
"vue_label_commonobjects_view_chart_editchart":`Edytuj wykres`,
"label.permission.detail.app.object":`Konfiguracja obiektu`,
"label.multilang.totalpage":`z`,
"label.marketsea.button.return":`Powrót`,
"Click.to.load.more":`Kliknij, aby załadować więcej`,
"label.validate.globalvariable":`Zmienna globalna`,
"label.marketsea.iseditseabymanager":`Umożliwienie administratorom zmiany puli leadów, do której należy.`,
"label.price.yuan":`Cena (Yuan)`,
"label.service.resource.uesr.tip":`Wybierz użytkownika do tworzenia zasobów serwisowych, a typem zasobów nie może być załoga.`,
"vue_label_help_viewusageguide":`Wyświetl podręcznik użytkownika wersji Lightning`,
"label.autoRegister.changepwd.setpwd.too.long":`Za długo`,
"label.campagin.roi.fwsl":`Liczba wizyt`,
"label.campaign.mobile":`Aplikacja mobilna`,
"UG.Lead.012":`Wskazówki dotyczące importu`,
"link.recordtype.detail.backtoobject":`Powrót do Obiektów niestandardowych`,
"front-kefu-moudle-callcentrt-hasclose":`Call Center zostało zamknięte`,
"label.category.5":`IT High-tech`,
"label.import.page1.selectwayofdealdata":`Wybór trybu przetwarzania danych`,
"chatter.emailReceiveEmail":`Otrzymuj przypomnienia o CCChat`,
"vue_label_file_manage_lib_members":`Zarządzaj członkami biblioteki plików`,
"label.appupload.upload.overview":`Rekapitulacja`,
"label.service.miniProgram.inputNumber":`Proszę wpisać numer z przedziału 0-999.`,
"label.emailtemplate.finishdetailinfo":`Wypełnij szczegóły szablonu wiadomości e-mail.`,
"label.weixin.fmu.before.day":`{0} dni przed`,
"label.integrations.login":`Login`,
"label.dashboard.setUpHomePage":`Strona główna została ustawiona na wyświetlanie`,
"label_partner_common_webSit":`Domena`,
"front-epwechat-module-v1-unbound-user":`Niezwiązani użytkownicy`,
"label.partnerCloud.basicSetting.offline":`Aktywuj płatność offline`,
"label.start.loginip":`Startowy adres IP`,
"label.projectManagement.delete.subtasks":`W przypadku usunięcia tego podzadania wszystkie powiązane z nim informacje również zostaną usunięte, a danych nie będzie można odzyskać. Czy na pewno chcesz potwierdzić usunięcie?`,
"label.message.batchapp":`Zatwierdzenie masowe`,
"message.duplication.label.ruletitle":`Duplikaty zasad`,
"label.all_networks":`Wszystkie sieci`,
"label.select_columns":`Wybierz kolumny, które chcesz zobaczyć w formularzu.`,
"vue_label_notice_uploadavatar_exceed":`Rozmiar wgrywanego obrazka awatara nie może przekraczać 2MB.`,
"message.error.get.failed":`Nie udało się uzyskać informacji!`,
"label.quickbooks.viewlist.duedate":`DATA SPRAWDZENIA`,
"label.ccchat.topic.search":`Szukaj Temat`,
"label.forecast.shre.manager":`Kierownik Przydział`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.thursday":`Czwartek`,
"lable.product.pricebooks.copy":`Sklonuj z istniejącej książki cenowej`,
"label.instrumentPanel.minLabelname":`Wartość ta musi być dodatnia i mniejsza od wartości punktu przerwania 1.`,
"front-market-form-createdsecond":`Pole autouzupełniania na stronie rejestracji`,
"label.submission_detail":`Szczegóły dotyczące składania wniosków`,
"label.customfields.checkbox.tip":`Umożliwia użytkownikom wybranie wartości True (zaznaczone) lub False (niezaznaczone).`,
"label.escalation.setup.list.description":`Możesz określić automatyczne działania, gdy sprawy spełniły kryteria i przekroczyły określony czas. Kiedy eskalujesz sprawę, możesz wybrać automatyczne powiadomienie użytkownika i ponowne przypisanie sprawy do nowego użytkownika.`,
"UG.Forcast.05":`Ustawienia prognozy: krok {0}/{1}`,
"label.data.import":`Import danych`,
"label.upload.error.cause":`wysyłanie nie powiodło się z powodu`,
"label.search.change.remark":`Dotyczy ustawień obiektów wyświetlanych w pasku wyszukiwania po lewej stronie strony głównej`,
"serviceappointment.edit.status.limitwithstatus":`Statusu wizyty serwisowej nie można zmienić z {0} na {1}.`,
"label.department.operation":`Operacja`,
"label.textmessage.vonage.message3":`Aby wyszukać klucz API i sekret API, możesz zalogować się na swoje konto Vonage API i przejść do "Ustawień" pod nazwą konta. Aby sprawdzić numery telefonów, które posiadasz na koncie Vonage API, możesz przejść do zakładki Numery pod Produkty, a następnie kliknąć na "Twoje numery", aby zobaczyć wszystkie posiadane numery telefonów.`,
"label.privacystatement.dialog":`Oświadczenie o ochronie prywatności (nowe okno)`,
"label.datamanage.import.leadfield":`Na poniższej liście należy zaznaczyć pola w pliku importowym, które mają importować leady. Następnie kliknij przycisk Dalej:`,
"label.appupload.upload.install.failar":`Instalacja nie powiodła się`,
"label.viewall":`Zobacz wszystkie`,
"label.sendemail.chat.addComentsfavoritesubject":`CloudCC CCChat reply to Bookmarked`,
"lable.custom.dp":`Ta strona umożliwia zdefiniowanie lat niestandardowych.`,
"label.mobile.more.share":`Udostępnianie współpracownikom lub grupom`,
"lable.name.cannot.be.empty":`Nazwa nie może być pusta`,
"label.autoRegister.changepwd.setpwd.password":`Twoje hasło`,
"label.multipleactivity.aevents":`Zdarzenie(-a)`,
"label.many.dayline.lastday":`Ostatni dzień`,
"lable.Please.bind.the.QuickBooks.record.first":`Proszę najpierw powiązać rekordy szybkiej książki.`,
"vue_no_related_dashboards":`Brak odpowiednich pulpitów!`,
"label.newdashboardpage.name":`Nazwa`,
"vue_label_commonobjects_detail_network":`Relacja Netto`,
"label.tianyancha.reginstitute":`Organ rejestracyjny`,
"label.the.lower.bound.of.each.level.must.be.equal.to.the.upper.bound.of.the.upper.level.":`Dolna granica każdego poziomu jest równa górnej granicy górnego poziomu przy ustalaniu cen za pomocą bloków.`,
"label.chat.file.upload.info":`Prześlij pliki`,
"label.appexchange.vlidaterule":`Zasady walidacji`,
"label.salescloud.salesdashboard.current.business":`Aktualne możliwości`,
"label.app.step4.homeisfrist":`Strona główna musi być pierwszą zakładką i nie może być usunięta.`,
"label.weixin.micro.research.optionname":`Wybór mikrosondażu Nazwa`,
"label.paging.totalofnbsp":`A Total of {0}`,
"label.opportunity.perm.title":`Zamówienie dostępu`,
"front-kefu-moudle-v1-zhyzcw-reinput":`Błąd weryfikacji najemcy. Proszę wpisać ponownie`,
"label.unsaved_changes":`W przypadku kontynuowania operacji niezapisane zmiany zostaną utracone.`,
"label_partner_all_description":`Opis`,
"lable.account.Next.CQ":`Następne CQ`,
"chatter.feed.menutype.feed.me":`Do mnie`,
"label.sourcetranstemp":`Źródło - Tworzy jeden plik, który zawiera cały tekst, który jest przetłumaczalny`,
"label.apply.newuser.validate":`CloudCC rejestracja nowego użytkownika, kod walidacyjny:`,
"label.user.password.error":`Błąd nazwy użytkownika lub hasła, lub nieprawidłowy użytkownik!`,
"label.there.is.no.quotation.line.item.in.this.quotation.line.group.at.present.":`W tej grupie linii notowań nie znaleziono żadnych pozycji. Proszę kliknąć "Dodaj produkt", aby dodać.`,
"lable.PowerProcess.time.filed":`W oparciu o pole daty i godziny w {detailInterestType}.`,
"label.file.default.value.is.integer":`Można wprowadzać tylko liczby całkowite`,
"label.processsetting.please.select.field":`Proszę wybrać pola.`,
"label.app.step3.introduce":`Rozmiar pliku logo aplikacji niestandardowej musi być mniejszy niż 20 KB. Wymiary obrazu powinny wynosić maksymalnie 300 pikseli szerokości na 55 pikseli wysokości, aby uzyskać najlepsze rezultaty. Większe obrazy zostaną zmniejszone i mogą być zniekształcone.`,
"button_partner_save":`Zapisz`,
"label.marketingmanagement":`Marketing`,
"label.isEnableVisualpage_new.leftlist":`Dostępne strony niestandardowe`,
"label.salescloud.teamrole.optionlist.choose.correct":`Ta sama pozycja istnieje na liście, proszę zmodyfikować.`,
"System_ChangeUser_Info_001":`Właściciel zmieniony i kliknij, aby powrócić do poprzedniej strony.`,
"front-console-no-contact":`Brak kontaktu`,
"component.assistant.label.overduetask":`Okazje z zaległymi zadaniami`,
"label.roleofpartner":`Rola partnera`,
"label.appointmentconfirmpage.wizard.subtitle4-1":`Ty i {0}`,
"front-template-V1-Please-select-a-picture":`Proszę wybrać zdjęcie`,
"lable.SalesCommitmentKanBan.allsignedCommitmentRate":`Całkowita liczba podpisanych zobowiązań`,
"label.h5.similar.opportunity.step2.conment":`Wybierz od 3 do 10 pól lub powiązanych list, które będą porównywane podczas wyszukiwania podobnych możliwości.`,
"label.projectManagement.alert.frequency.will.not.work":`W przypadku wybrania opcji No, przypomnienie nie będzie działać.`,
"vue_label_fllscreen":`Wyświetlanie na pełnym ekranie`,
"label.customfields.selectcontainfieldlayout":`Wybierz układy stron, które powinny zawierać to pole.`,
"label.appointment.wizard.subtitle1-4":`45 min`,
"label.tianyancha.businessverify.unagree":`Nie zgadzam się`,
"label.unique":`Wyjątkowa`,
"setup_mainpage_label_welcome10":`Instrukcje: Kliknij w menu po lewej stronie → Ustawienia aplikacji → Utwórz → Obiekt → Nazwa obiektu → Układ niestandardowy.`,
"vue_label_account_subsidiary":`Spółka zależna`,
"label.dataimport.format.error":`Błąd formatu, proszę użyć formatu MM/DD/YYYY lub YYYY-MM-DD.`,
"label.email.new":`Nowa poczta elektroniczna`,
"label.log.descri":`Opis działania`,
"vue_label_dashboard_componentname":`Proszę wpisać nazwę komponentu`,
"label.weixin.quick.reply":`Quick Reply`,
"label.productsales.payment.badversion":`Twoja aktualna edycja nie obsługuje podglądu przedmiotu umowy, więc nie możesz wyświetlić listy płatności.`,
"label.position":`Lokalizacja`,
"label.Annex.Conditions":`Dodaj filtry logiczne dla dodatkowych warunków （np. ：1 And 2 Or 3 ）.`,
"label_tabpage_endz":`Koniec`,
"label.setup.mobile.bottombutton.prompt":`Uwaga: Zapisanie tych ustawień spowoduje zmianę oryginalnych ustawień użytkownika aplikacji mobilnej pierwszego poziomu.`,
"lable.Edit.template":`Edytuj szablon raportu serwisowego`,
"vue_label_report_onlydisplay2000":`Wyświetlanie tylko danych 2000`,
"label.salescloud.salesdashboard.sign.account.top5":`Top 5 Podpisane konta`,
"label.weixin.ontime":`Punktualny`,
"font-evaluate-module-v1-disappoint":`Przykro mi, że cię rozczarowałem!`,
"chatter.sel.addre":`Można wybrać do 5 adresatów!`,
"label.mobile.phone.month.summary":`Podsumowanie miesiąca`,
"label.partnerCloud.priceOfManual.selected":`Wybrane konto`,
"label.south.georgia.time":`Czas standardowy Georgii Południowej`,
"label.create.ccdocument":`Dodaj załącznik`,
"label.chatter.to":`Do`,
"label.ems.minute":`Protokół`,
"label.mobile.phone.submit.tome":`Zgłoszony do mnie`,
"label.approvalstep1":`Krok 1 Wprowadź nazwę i opis`,
"label.h5.similar.opportunity.last.months9":`Ostatnio 6-9 miesięcy`,
"Opportunity_Detailed_Phase_Label_003":`Etap zmian`,
"lable.PowerProcess.time.input":`Proszę podać godzinę.`,
"label.stdashbord.xsld.business.yqzsr":`Przewidywana kwota ogółem`,
"label.icon.64":`Reflektor`,
"label.data.choses.i_desc":`W zależności od potrzeb możesz importować dane z jednego obiektu.`,
"label.integrations.mainlandchinaleads":`Chiny kontynentalne Leads`,
"vue_label_notice_savemenu_success":`Menu zapisane pomyślnie`,
"front-kefu-moudle-v1-xzhxzxkf-online":`Wybierz usługę Easemob online`,
"label_chatter_name":`Nazwa`,
"label.Viewon_Linkedin":`Widok z LinkedIn`,
"lable.PowerProcess.chioce.event":`Proszę wybrać kamień milowy.`,
"component.chatter.file.label.maxsize":`Maksymalny rozmiar pliku to 20m`,
"label.validate.function.funcExplain.SECOND":`Zwróć drugą część dnia (z pól Data/Godzina)`,
"label.data.downpage.i.title.num4":`4、Jeśli masz pole relacji lookup i pole relacji master-detail w obiekcie, który chcesz zaimportować, wartość dla tego pola musi być ID, w przeciwnym razie jest nieważna.`,
"label.icon.139":`Waluta`,
"label.app.step4.atleastone":`Karty głównej nie można usunąć.`,
"label.weixin.input.telephone":`Proszę wpisać numer telefonu komórkowego`,
"label.setup.mobile.bottombutton.remark":`Organizacja może skonfigurować ustawienia początkowe strony pierwszego poziomu zgodnie z procesem biznesowym.`,
"label.file.searchs":`Wyszukaj pliki...`,
"vue_label_email_there_is_no_draft_yet":`Nie ma jeszcze projektu`,
"front-kefu-moudle-v1-bind-seats":`Wiążący agent`,
"label.customfields.lookupmuti.tip":`Tworzy relację, która łączy ten obiekt z innym obiektem. Pole relacji umożliwia użytkownikom kliknięcie na ikonę odnośnika w celu wybrania wielu wartości z listy podręcznej. Drugi obiekt jest źródłem wartości na liście.`,
"label.integrations.password":`Hasło`,
"label.data.newtemplate.t_conditions":`Szablon Warunki`,
"message.error.repeatsubmit":`Zgłoszenie jest powtarzane lub na tej samej stronie otwartych jest wiele okien modyfikacyjnych. Jeśli to ostatnie, proszę przesłać w nowo otwartym oknie.`,
"label.umeng.approval.approvalreassign":`Wniosek o zatwierdzenie dla #obj został ponownie przypisany. #objname`,
"lable.edit.queue.selobj":`Błąd: Kolejka musi mieć co najmniej jeden wybrany obiekt`,
"label.compact.layout.frame":`Ramka układu strony`,
"label.sms.companyname.dsf.infor":`Ta usługa obsługuje tylko Chiny kontynentalne`,
"template.report.individual.case.source":`Źródło przypadku`,
"pagecreator.button.pcpage":`Końcówka Pc`,
"vue_label_commonobject_selectdatatime":`Wybierz datę i godzinę`,
"label.icon.181":`Plik`,
"label.loginip.setup.please":`Proszę podać zakres IP.`,
"vue_label_dashboard_?secondarygroup":`Proszę wybrać grupę dodatkową`,
"lable.outlook.mcto.pleasedes":`Wprowadź domeny e-mail, z którymi nie chcesz być powiązany i oddziel je znakiem ",".`,
"DetailedInfo_Activity_EmailMessage_01":`{0} wyślij wiadomość e-mail do {1}.`,
"label.sendmail.step4":`Krok 4 Wysłane przez Ciebie e-maile są w trakcie przetwarzania.`,
"label.monitorsys.delete.source":`Opis`,
"label.monitorsys.log.datetime":`Pobieranie dziennika audytu operacji kluczowych w wyszukanym zakresie czasowym (Excel.xls)`,
"component_chatter_label_myfans":`Moi zwolennicy`,
"label.tianyancha.h5.registereddate":`Data rejestracji`,
"label.multilang.feedtrack.operatecreate":`{0} rekord został utworzony：`,
"label.console.step6.no":`Wybierz sposób wyświetlania list`,
"four":`Cztery`,
"message.confirmsetpwdforuser":`Zresetować hasło dla nowych użytkowników?`,
"label.cape.verde.time":`Czas Republiki Zielonego Przylądka`,
"label.queue.new":`Nowa kolejka`,
"label.cloudccsite.start":`Strona główna Active Site`,
"label.data.exp.way":`Metoda wywozu`,
"label.lock.record.donot.delete":`Nie można usunąć zablokowanych rekordów.`,
"label_emailtocloudcc_filed_type":`Dostawca`,
"frame_personinfo_label_minipic":`Miniaturka obrazu`,
"label.checkfield.choosetab":`Wybierz pola, aby znaleźć deplikaty`,
"component.setup.tabs.label.default":`Strona domyślna`,
"page.404.button.toknowmore":`Dowiedz się więcej`,
"vue_label_SMS_message_sent_cannot_be_empty":`Treść wysyłanego komunikatu nie może być pusta`,
"label.lookupreplaceselectvalue":`Znajdź i zamień listę wyboru`,
"pagecreator_layout_button_new":`Nowy układ`,
"label.mobile.more.upload":`Prześlij nową wersję`,
"front-kefu-moudle-v1-Connection-failure":`Połączenie nie powiodło się`,
"label.version.support.unlimited":`Nieograniczone wsparcie`,
"message.error.notmarketseamember":`Nie jest członkiem grupy wiodącej`,
"label.taskandincident":`Zadania i wydarzenia`,
"label.report.export.print.title":`Drukowanie widoków raportów`,
"label.file.publicview.error2":`Link publiczny jest nieprawidłowy, proszę użyć nowego linku publicznego`,
"label_chatter_cancel":`Anuluj`,
"front-web-module-v1-detail-comment-satisfied":`Poziom zadowolenia`,
"label.knowledge.delete.topic":`Błąd podczas usuwania tematu użytego w tym artykule wiedzy.`,
"label.forecast.forehistory.all":`Wszystkie`,
"label.displaybutton":`Wyświetlane przyciski`,
"label.icon.148":`Robot`,
"label_tabpage_ok":`Potwierdź`,
"label.checkfield.merge.mainrecord":`Zapis główny`,
"label.notification.arketsea.restored":`{5} przywrócone {2}  {0}：{1}`,
"setup.mainpage.label.welcome31":`Instrukcje: Kliknij na menu po lewej stronie tej strony → Zarządzaj ustawieniami → Utwórz → Aplikacja.`,
"front-kefu-moudle-v1-jtrrt-connect":`Powiązanie użytkowników CloudCC z rozszerzeniami TRRT`,
"vue_label_calendar_please_select":`Proszę wybrać wyświetlone pole`,
"setup.layout.label.pagename":`Nazwa układu strony`,
"template.chart.schdywjhz":`Wartość szansy w kampanii`,
"label.access_report":`Kto może uzyskać dostęp do tego raportu?`,
"label.assignment.layout.section.optional":`Dostępny`,
"label_chatter_recently":`Ostatnio`,
"lable.chat.advanced.setting":`Konfiguracja zaawansowana`,
"label.knowledge.category.hint.eight":`Grupa kategorii`,
"message.error.facebookuid.null":`Identyfikator użytkownika Facebooka nie może być pusty!`,
"label.step5.total6":`Krok 5 z 6`,
"label.is.cancel.delete":`Anulować usunięcie?`,
"setup_mainpage_label_welcome11":`Raport niestandardowy`,
"label.answers":`Odpowiedzi`,
"label.approvalstep1.tip":`Wprowadź nazwę, opis i numer kroku dla nowego kroku zatwierdzania.`,
"template.chart.htjeph":`Kwota umowy Ranking`,
"label.campaigns.onsiteregistration":`Rejestracja na miejscu`,
"front-epwechat-module-v1-input-agentid":`Proszę wprowadzić agentId`,
"label.emailobject.wizard.desc2":`Śledzenie otwieranych maili i czasu ich otwarcia`,
"label.multilang.chatterdetial.vote":`{0} bilet(y)`,
"label.customsetting.manage.value":`Dane niestandardowe`,
"front-electronic-export-listCount":`Całkowite dane {totalView} w bieżącym widoku, zaznacz importowane dane`,
"label.dashboard.create.prompt":`Nie można tworzyć pulpitów nad raportami tabelarycznymi.`,
"label_tabpage_askz":`O co chciałbyś zapytać`,
"label.ems.sentmail":`Skrzynka nadawcza`,
"label.reportlist.untop":`Nieustalony`,
"label.owner.h5.plzchose":`Proszę wybrać właściciela i zapisać`,
"label.callcenter.addup.10.pieces":`Maksymalnie jednorazowo dodaj 10 danych`,
"label.ccdocument.save":`Zapisz dokument`,
"label.productcannotnull":`Produkt nie może być pusty`,
"label_tabpage_enabletomobile":`Czy włączyć opcję "mobile-side`,
"lable.account.CYAgo":`2 CY Ago`,
"lable.Select.the.returned.high.seas.pool":`Wybierz zwróconą pulę`,
"tuesday":`Wtorek`,
"label.partnerCloud.basicSetting.partnerPayment":`Fundusz Partnerski Activate`,
"label.validate.function.funcExplain.WEEKDAY":`Zwraca określony dzień tygodnia. 1 reprezentuje niedzielę, a 7 - sobotę.`,
"label.query.detail.manageexuser":`Zarządzaj użytkownikami zewnętrznymi`,
"vue_label_systemSettings_environment":`Środowisko`,
"component_setup_tabs_label_delete":`Usuń`,
"label.weixin.delete.ccchat":`Czy na pewno chcesz usunąć ten post?`,
"label.lanxin.title":`Lanxin-H5Micro App`,
"label.layout.editcondition.morethanten":`Możesz wybrać do 10 pól jako kryteria wyszukiwania.`,
"label.project.hit.fourteen":`Zawiadomienie o aktualizacji kamienia milowego`,
"label.createby":`Utworzony przez`,
"label.moreoperation":`Więcej Operować`,
"label.lock.tip":`Zablokuj możliwość edycji rekordów`,
"label.check.input.condition.three":`Typ pola formuły i podsumowania rolki nie są obsługiwane do wstawiania.`,
"label.quote.dingjia":`Wycena`,
"label.currentuseremail":`Bieżący adres e-mail użytkownika`,
"UG_homepage_004":`Automatyka`,
"chatter.link":`Link`,
"label.new.zealand.standard.time":`Czas letni Nowej Zelandii`,
"APPIntegration.Dropbox.setting.02":`Niepełnosprawni`,
"label.version.searchandmerge":`Powielanie i łączenie czeków`,
"label.allmenus.showmsg.nomenu":`Nie znalazłem menu".`,
"front-template-V1-Enable-disable":`Aktywacja | Dezaktywacja`,
"label.marketing.setting4":`Rejestracja zakończyła się sukcesem, powracając do domyślnego adresu URL`,
"UG.Forcast.07":`Umożliwić prognozę`,
"vue_label_systemSettings_correlation":`Lista powiązana Tryb wyświetlania`,
"label.cloudccsite.remark.length":`Pozwala użytkownikom na wprowadzenie do 255 znaków`,
"label.favorite":`Zakładka do książki`,
"template.report.converted.leads":`Skonwertowane leady`,
"label.campaignmember.main.description":`Użyj tej strony do zarządzania uczestnikami kampanii. Możesz dodać nowych członków kampanii lub zaktualizować status obecnych członków kampanii.`,
"label.salescloud.teamrole.account.organization":`Członkowie zespołu mogą mieć wyższy poziom dostępu do tego konta niż domyślnie ustawiony przez Twoją organizację.`,
"label.permission.modifyAppPermission.canselectapp":`Dostępne aplikacje`,
"front-epwechat-module-v1-self":`Samodzielnie stworzona aplikacja Konfiguracja`,
"message.duplication.label.matchexactletters":`Exact`,
"label.appointmentdetail.wizard.title18":`Plan na piątek`,
"label.area":`Terytoria`,
"label.sso.saml.sp.username":`Nazwa użytkownika`,
"lable.outlook.new":`Nowa konfiguracja Exchange Sync`,
"label.custom.field.close.conversion":`Zamknięte - Przekształcone`,
"lable.outlook.detail.tmaping":`Mapuj pola zadań`,
"label.emailobject.emaildetail.nextactivity.event":`Dodaj wydarzenie`,
"vue_label_commonobjects_detail_date":`Data końcowa nie może być krótsza niż data początkowa`,
"vue_label_email_mark?as":`Zaznacz jako`,
"label.guestgroup":`Zespoły kont`,
"label_emailtocloudcc_filed_server":`Serwer`,
"label.icon.186":`Doradztwo`,
"label.department.user.edit":`Edytuj`,
"label.custom.page.component.button.settings":`Ustawienia przycisków komponentów`,
"label.partnerCloud.orderingPlatform.nextProduct":`Czy chcesz zapisać bieżącą konfigurację produktu i skonfigurować następny produkt?`,
"vue_label_appstore_cloud_platform":`oficjalna platforma w chmurze`,
"label.page.previous":`Poprzedni`,
"label.direct.dashboard.week.report":`Nowa tygodniowa notatka robocza`,
"label.ServiceCloud.prompt.warning":`Brak statystyk dystrybucji zasobów według adresów.`,
"label.emailtocloudcc.position":`Pozycja`,
"vue_label_email_please_enter_the_message_content":`Proszę wpisać treść maila`,
"labal_About_to_jump":`Wkrótce nastąpi przekierowanie.`,
"label_profile_mobile_setup_stand":`Standardowa strona główna`,
"label.visualpage.component.n3":`3.Parametry. Parametr jest zapisany w args propertites ,args="name:'zhang', age:26" Uwaga pojedyncze podwójne cudzysłowy.`,
"vue_label_report_operationmode":`Tryb pracy raportu`,
"label.reportsSubscription.select.attached.file":`Proszę wybrać rodzaj załączonego pliku.`,
"label.afghanistan.time":`Afganistan Czas`,
"label.vlidaterule.formulatrue":`Jeśli to wyrażenie formuły ma wartość?true, wyświetl tekst zdefiniowany w obszarze komunikatu o błędzie`,
"label.ccchat.person.invite.erroremail":`Format adresu e-mail jest nieprawidłowy.`,
"label.viewDashboard":`Przejdź do listy pulpitów nawigacyjnych`,
"label.at":`na stronie`,
"label.notification.arketsea.beforeretrieve":`Twoje {0}：{1} zostanie przetworzone na {2}， pozostały czas: {6} dni`,
"label.field.update.show.editor":`Pokaż edytor formuły`,
"label.weixin.polls.time":`Data głosowania`,
"vue_label_commonobjects_detail_activity_nostarttime":`Brak godziny rozpoczęcia`,
"label.direct.dashboard.me.not.approval70":`Pozycje oczekujące na zatwierdzenie Zgłoszone przeze mnie`,
"label.data.setok.t_desc3":`, Operacja.`,
"label.view.edit.search.describe":`Wyszukiwanie po wpisaniu słów kluczowych`,
"label.importsourcefiletip":`Przed importem przetłumaczonego pliku oddzielonego tabulatorami, upewnij się, że:</li><li>1.Utwórz osobny plik dla każdego języka, który chcesz importować, który zawiera tylko nazwę i tłumaczenie.</li><li>2.Atrybut języka na górze każdego pliku jest wymagany. Atrybut language wygląda następująco: language=en_US.</li><li>3.Upewnij się, że pliki importu są zapisane w kodowaniu UTF-8 przed importem.</li>4.Upewnij się, że wprowadzasz line feed na końcu pliku, który chcesz zaimportować.</li></ul></span>.`,
"UG.Case.01":`Sprawa`,
"label.weixin.report.filters":`Filtry`,
"vue_label_homepage_profilehomepageassignment":`Profil Strona główna Przydział`,
"label_tabpage_editview":`Edytuj widok`,
"label.tabpage.allpotentialcustomers":`Wszystkie tropy`,
"label.sendemail.send.standbyemail":`(zapasowa skrzynka odbiorcza)`,
"errormessage.email.atleastonereceiver.z":`Musisz wybrać lub edytować adres odbiorczy.`,
"workflow.action.tasks.assignortype.ownertype":`Typ właściciela`,
"label.list.userinterface.new.page.setup":`Nowa strona`,
"chatter.seladress":`Proszę wybrać co najmniej jednego odbiorcę.`,
"Pagelayout_Setup_004":`Można ustawić do 4 pól`,
"label.mobile.home.page.tenbig.opp":`10 największych szans w ciągu najbliższych 30 dni`,
"label.wtd.changefields.newpc":`Wygeneruj stronę PC`,
"label.opportunity.perm.remark":`To są prywatne możliwości, prosimy o kontakt z właścicielem, aby uzyskać dostęp.`,
"label.data.exp.tempdes":`Opis szablonu`,
"label.appointment.wizard.subtitle2-1":`Ze strony`,
"lable.currencyManage.button.manageexchangeRate":`Zarządzaj datowanymi kursami wymiany`,
"label.file.viewinfo":`Wyświetl szczegóły pliku`,
"label.integrations.mailchimp.export.failed":`Eksport danych nie powiódł się, proszę sprawdzić połączenie sieciowe i spróbować ponownie.`,
"pagecreator_page_button_edit":`Edytuj`,
"label.icon.86":`Teczka`,
"label.exchange.sync.reset":`Resetuj synchronizację`,
"label.customfields.lookupfilter":`Możesz utworzyć filtr, aby ograniczyć rekordy, które są dostępne dla użytkownika w polu Wyszukiwania.`,
"label.component.hotdeal.nopermission":`Aby zobaczyć swoje dane dotyczące możliwości biznesowych, skontaktuj się z administratorem CloudCC.`,
"label.address.province":`Państwo`,
"lable.PowerProcess.3digit.input":`Nie więcej niż trzy cyfry.`,
"label.asset":`Aktywa`,
"label.passwordPolicy.setup.nopwdremember":`Hasło nie jest zapamiętywane`,
"front-electronic-signature-setting-intro2":`Przed zawarciem umowy należy wstępnie ustawić szablon na platformie DocuSign. Podczas inicjowania podpisywania można wybrać wstępnie ustawiony szablon umowy.`,
"pagecreator.page.button.new":`Nowa strona`,
"label.tabpage.step2":`Krok 2 określenie warunków filtrowania`,
"label_switch_two_column_or_responsive_layout":`Przełącz się na układ dwukolumnowy lub responsywny`,
"label.batchDelete":`Masowe usuwanie`,
"chatter.edit.ct":`Edytuj swoje dane kontaktowe.`,
"UG_ST_003":`Nie masz uprawnień do tworzenia {0}, skontaktuj się z administratorem, kliknij przycisk Zatwierdź, aby przejść bezpośrednio do interfejsu {0}.`,
"label.timzone.tip.info2":`Kiedy używasz simpledateformat do formatowania daty, powinieneś ustawić strefy czasowe dla instancji simpledateformat, takich jak SimpleDateFormat myDateFormat=new SimpleDateFormat("yyyy-MM-dd");myDateFormat.setTimeZone(TimeUtil.getUserTimeZone(userInfo)); lub uzyskać instancję używając metody narzędziowej dostarczonej przez TimeUtil, SimpleDateFormat myDateFormat=TimeUtil.getSimpleDateFormat("yyyy-MM-dd",userInfo);`,
"label.ems.firstsynchistory":`Pierwszy raz synchronizujemy pocztę od jak dawna`,
"label.currency.invalid":`Waluty nieaktywne`,
"label.mask.custom":`Dostosuj`,
"lable.opppdt.addpdt.title":`Wybierz produkt`,
"label.appointment.wizard.subtitle3-3":`Środa`,
"label.weixin.report.criteria":`Grupowane według`,
"label.appupload.upload.install.uninstall":`Nie można zainstalować`,
"label.compact.layout.frame.split":`Wyświetlanie na oddzielnym ekranie`,
"label.email.attach.complete.info":`Po zakończeniu przesyłania plik zostanie wyświetlony na liście załączników poniżej`,
"label.Receivables":`Należności`,
"label.linkedin.title.setting":`Zintegrowane informacje z LinkedIn`,
"label.companynotice":`Ogłoszenie Spółki`,
"label.emailobject.discard":`Odrzuć`,
"label.selected.searchfield":`Pole wybranych wyników wyszukiwania`,
"front-electronic-signature-explainDocusign":`Opis podpisu elektronicznego DocuSign:`,
"chatter.link.name":`Nazwa łącza`,
"label.low":`Niski`,
"label.verticalline":`Kolumny pionowe`,
"label.approval.isallowed.reject.label":`Zezwolić na odrzucenie przy zatwierdzaniu pojedynczych danych?`,
"label.emailtocloudcc.button.enable":`Aktywny`,
"label.dashboardSetup.showdw.d5":`Integer Jednostka`,
"label.usermanage.not.authority":`Nie masz wystarczających uprawnień, aby to zrobić.`,
"label.customobjects.track.introduce0":`Ta strona umożliwia wybranie pól, które mają być śledzone na liście powiązanych pól {0} "Śledzenie pól". Za każdym razem, gdy użytkownik modyfikuje dowolne z pól wybranych poniżej, stara i nowa wartość pola, a także data, czas, charakterystyka zmiany oraz użytkownik dokonujący zmiany są dodawane do listy powiązanej "Śledzenie pola".`,
"canlendarmonth":`Miesiąc kalendarzowy`,
"vue_label_dashboard_minimum":`Proszę wpisać minimalną wartość`,
"label.salescloud.optionlist.inputname.linealone":`Wprowadź jedną lub więcej wartości z listy wyboru poniżej, każdą wartość oddzielając nowym wierszem.`,
"message.error.organuzation.information.null":`Informacje o organizacji nie istnieją.`,
"label.tabpage.maxfilez":`Maksymalny rozmiar pliku wynosi`,
"message.validation.apiname":`Musi zaczynać się od litery.Musi zawierać tylko litery, cyfry i podkreślniki.Musi zawierać tylko wielkie i małe litery, cyfry i podkreślniki.Maksymalna długość to 50 znaków, minimalna długość to 2 znaki.`,
"report.type.label.contractPayment":`Umowy i należności`,
"label.limiting.choose.three.files":`Możesz wybrać 3 pliki, wybrane teraz.`,
"label.reportTypeFocus":`Źródło danych raportu Koncentracja`,
"Report_Delete_Confirm_Title":`Proszę potwierdzić`,
"front-gantt-module-reorder-milestones":`Zmiana kolejności etapów`,
"front-starter-v1-customer-tips-success":`Aktywuj konto Pool pomyślnie`,
"label.tabpage.isdeleteview":`Czy na pewno chcesz usunąć ten widok?`,
"label.favorite.title":`Platforma CloudCC`,
"page.layout.sysinfo":`Informacje o systemie`,
"label.tabpage.pleaseSelectz":`Proszę wybrać`,
"label.smsnotice":`Powiadomienia SMS`,
"label.forecast.customforecast.foretype.Pipeline":`Rurociąg`,
"label.rejectbehaviour":`Odrzuć zachowanie`,
"label.searchlayout.view.example.new":`Zobacz przykład (nowe okno)`,
"vue_label_homepage_notice2":`Możesz ręcznie przypisać układ strony głównej, ułatwiając pracownikom efektywne wykonywanie codziennych zadań.`,
"label.import.index.chooseidorother":`3、Możesz wybrać, aby użyć ID lub nazwę, aby dopasować rekord i wypełnić pole wyszukiwania. Jeśli potrzebujesz zdobyć odpowiedni identyfikator rekordu i inne informacje, możesz utworzyć raport i ustawić nazwę rekordu i identyfikator rekordu jako kolumny grupy, a następnie wyeksportować raport.`,
"label.westem.european.summer.time":`Czas zachodnioeuropejski`,
"label.brackets":`Nawiasy`,
"asset.serialnumber.unique":`Numer seryjny składnika aktywów już istnieje, proszę nie dodawać go wielokrotnie.`,
"label.callcenter.access.keyID":`Dostęp Sekretny identyfikator klucza`,
"label.calendar.month.view":`Widok miesiąca`,
"label.realdelete":`Trwale usunąć`,
"label.partnerCloud.orderingPlatform.amountPaid:":`Do zapłaty:`,
"label.reportTypName":`źródło danych raportu Nazwa`,
"lable.newtabpage.opensearchresult":`Rozwiń wyniki wyszukiwania`,
"front-kefu-moudle-v1-Session-duration":`Czas trwania sesji:`,
"label.import.index.ignore":`Zignoruj`,
"label.customfields.url.tip":`Pozwala użytkownikom na wpisanie dowolnego adresu strony internetowej. Po kliknięciu na to pole, adres URL otworzy się w nowym oknie lub w bieżącym oknie, zgodnie z ustawieniami użytkownika, a domyślnie URL otworzy się w nowym oknie.`,
"label.projectManagement.editMilestone":`Edytuj kamień milowy`,
"front-gantt-module-v1-project-gantt-list":`Lista projektów`,
"label.validate.remark":`Reguły walidacji pomagają poprawić jakość danych poprzez uniemożliwienie użytkownikom zapisywania nieprawidłowych danych. Można zdefiniować jedną lub więcej reguł walidacji, które składają się z warunku błędu i odpowiadającego mu komunikatu o błędzie. Reguły sprawdzania poprawności są wykonywane w czasie zapisywania rekordu. Jeśli warunek błędu zostanie spełniony, zapis jest przerywany i wyświetlany jest komunikat o błędzie.`,
"front-kefu-moudle-v1-sjgsbzq-reinput":`Format numeru telefonu jest nieprawidłowy. Proszę wpisać ponownie`,
"label.channel.name":`Nazwa kanału`,
"label.weixin.cloudcc.user.message":`Informacje o użytkownikach CloudCC`,
"label.icon.59":`Warsztaty`,
"label.ccpeak.function":`Metoda`,
"lable.opppdt.selPdt.leastten.fields":`Proszę wybrać do 5 pól`,
"label.deadline":`Termin:`,
"label.product.sel":`Cena Wybór książki`,
"vue_label_helpcenter_detail2":`Wszystkie wydarzenia: Pokaż wszystkie wydarzenia, do których masz dostęp, nawet jeśli w nich nie uczestniczysz.<br>    Możesz również filtrować rekordy aktywności, które chcesz wyświetlić, na podstawie zakresu dat i typu aktywności.<br>    4. Dynamiczny<br>    Wszystkie osoby, które mogą przeglądać ten rekord, mogą zostawić wiadomość i post w kolumnie "Dynamiczny" rekordu, można również zobaczyć wszystkie zmiany informacji, ostatnie działania oraz komentarze i posty innych osób na temat tego rekordu. Ta kolumna ułatwia komunikację online pracy i współpracy między tobą a twoimi kolegami, pomagając poprawić pracę zespołową i wydajność.<br> Publikowanie<br>    Krok 1: Kliknij na pasek publikowania i wprowadź treść postu<br>    Krok 2: Kliknij na przycisk Plik/Link, aby dodać plik/link w razie potrzeby<br>      Krok 3: Kliknij "Udostępnij", aby zakończyć publikowanie. <br> Wyświetl post<br>     Po pomyślnym opublikowaniu postu, możesz zobaczyć mikro-post, który właśnie opublikowałeś poniżej. Mikro-post składa się z następujących części: avatar, imię osoby, treść mikro-postu i metody interakcji (lubię/komentuj/edytuj/usuń post). <br> Sortowanie i wyszukiwanie postów<br>     Kliknij listę rozwijaną po prawej stronie "Sortuj", aby zmienić sposób sortowania postów. <br>    Sortowanie "Najnowsza aktywność": sortowanie według czasu najnowszej interakcji mikro-postów;<br>       Sortowanie "Najnowszy post "Porządkowanie: Porządkowanie według czasu publikacji mikro-postów;<br>    Przeglądaj różne typy mikro-postów<br>     Zwykłe mikro-posty tekstowe: Przeglądaj całą treść bezpośrednio w obszarze publikacji mikro-postów;<br>     Mikroposty zawierające pliki: kliknij przycisk pobierania pliku, aby pobrać go lokalnie do przeglądania;<br>      Mikroposty zawierające linki: kliknij link w mikro-poście, aby go otworzyć;<br> Komentowanie i lubienie mikro-postów<br>    Komentowanie<br>   Krok 1: Kliknij na "Komentarz" poniżej każdego mikro-postu <br>    Krok 2: Wpisz komentarz w polu tekstowym, które się otworzy<br>   Krok 3: Dodaj plik/link do komentarza, jeśli potrzebujesz Krok 4: Kliknij "Komentarz" pod polem tekstowym, aby zakończyć operację<br>    Usuń komentarz<br>     Wydawca komentarza może usunąć jego treść. Kliknij przycisk po prawej stronie komentarza i wybierz "Usuń" z listy rozwijanej.`,
"pagecreator_layout_button_mergecell":`Łączenie komórek`,
"Lead_Scoring_Setting_Rule_Setup_Active":`Aktywny`,
"label.query.detail.loginbypartneruser":`Logowanie przez użytkownika partnerskiego`,
"label.view.selectrenderfields":`Wybierz pola do wyświetlenia`,
"label.code.add":`Dodaj informacje o linku do kodu QR`,
"label.appointmentconfirmpage.wizard.title1":`ZAPLANOWANE SPOTKANIE`,
"label.timzone.tip.title":`Kiedy mamy do czynienia z datami używając new date() lub calendar, należy zwrócić uwagę na obsługę odpowiednich zagadnień związanych z wieloma strefami czasowymi. ponadto klasa narzędzi timeutil dostarcza wiele narzędzi, które obsługują wiele stref czasowych.`,
"label.tag.addtags.visibility":`Widoczność`,
"label.appointmentconfirmpage.wizard.title3":`Czy na pewno chcesz anulować istniejący termin i umówić się na nowy termin?`,
"lable.outlook.detail.oldest":`Najstarszy`,
"label.account.custom.quarter.timeerror":`Niestandardowa data rozpoczęcia kwartału lub niestandardowa data zakończenia kwartału znajduje się pomiędzy niestandardowymi kwartałami historii, proszę sprawdzić i zresetować.`,
"label.sendsms.idea":`Szanowany`,
"label.manageAll.pagenum2":`To jest ostatnia strona.`,
"serviceterritory.isactive.notactive":`Ten obszar usług nie jest włączony.`,
"label.userinfo.newpwd.notnull":`Proszę wpisać nowe hasło.`,
"vue_label_dashboard_nolinkagedashboard":`Brak deski rozdzielczej`,
"message.cannotdeleteapproval":`Nie można usunąć tego procesu zatwierdzania.`,
"label.wtd.detail.m":`Mobile`,
"label.app.step4.introduce":`Wybierz karty, które mają być zawarte w tej niestandardowej aplikacji.`,
"label.ccchat.error.permission":`Brak dostępu`,
"UG_opportunity_009":`Lub`,
"label.Receivables.TheActualAmountOfMoney":`Faktyczne wpływy`,
"label.callcenter.no.search":`Brak odpowiedniego zapytania do informacji`,
"label.user.introduce":`Użytkownicy`,
"message.datalocked.addpdt":`Ten rekord szansy jest zablokowany, nie możesz dodać Pruduct.`,
"label.sendsms.step1":`Krok 1 Określenie odbiorców`,
"label.brief.contracts":`Kontrakty`,
"label.setup.mini.swap":`Ustawienie karuzeli`,
"label.emailobject.wizard.desc1":`Podłącz swój e-mail, wyślij pocztę tutaj i automatycznie zsynchronizuj z rekordem`,
"label.login.verification.mfa.desc2":`Jeśli z jakiegoś powodu nie jesteś w stanie zweryfikować, np. zgubiłeś lub omyłkowo usunąłeś aplikacje MFA z telefonu, być może usłyszałeś, że administrator odłączył MFA.`,
"label.notification.receiveSms.message":`Otrzymałeś wiadomość tekstową od {!fromaddress}, kliknij aby zobaczyć więcej szczegółów`,
"label.emailmerge.mergeFolder.publicfolder":`Niewypełnione szablony łączenia wiadomości e-mail`,
"label.password.update.false":`Nie udało się zmienić hasła, proszę skontaktować się z administratorem!`,
"label_tabpage_systemz":`System(y)`,
"label.dataimport.objectid.null":`Identyfikator obiektu jest pusty i nie może być importowany`,
"label.currency.type":`Typ waluty`,
"component_setup_button_appurl":`Adres url systemu`,
"label.appointmentconfirmail.wizard.title2":`Masz zaplanowane {0}`,
"lable.product.please.enter":`Proszę wpisać`,
"label.escalation.setup.title":`Zasady eskalacji spraw`,
"label.create_failure":`Nie udało się utworzyć formularza`,
"label.weixin.brand.model":`Model marki`,
"label.layout.nameoftestobj2":`Nazwa drugiego obiektu testowego`,
"vue_label_filters_number":`Dla każdego raportu obsługiwanych jest 10 podmiotów.`,
"label.file.following":`Śledząc stronę`,
"vue_label_account_all_contracts":`Przeniesienie wszystkich umów właścicieli klientów`,
"label.service.please.select.cycle.type":`Proszę wybrać rodzaj cyklu`,
"label.weixin.weipoll.optionname":`Mikro głosowanie Wybór Nazwa`,
"label.data.newtemplate.null":`Brak`,
"message.passwordPolicy.validate.complexReq1":`Błąd:Twoje hasło musi składać się z liter i cyfr`,
"label.forecast.shre.editmanager":`Kierownik Edycja`,
"label.emailtemplate.tip":`Poniżej znajduje się lista wszystkich Twoich szablonów wiadomości e-mail w wybranym folderze. Kliknij nowy przycisk, aby utworzyć nowy tekstowy lub HTML-owy szablon wiadomości e-mail. Możesz użyć tych szablonów podczas wysyłania pojedynczych wiadomości e-mail.`,
"label.tag.manage.button":`Zarządzaj Tagi`,
"label.changepw":`Zmiana hasła`,
"label.sso.saml.sp.idsource.nameid":`Tożsamość znajduje się w elemencie NameIdentifier deklaracji Subject`,
"label.salescloud.teamrole.addmember":`Dodaj członków grupy możliwości CloudCC`,
"label.h5.similar.opportunity.last.months6":`Ostatnie 3-6 miesięcy`,
"message.save.opportunity.role.save.failed":`Nie udało się zapisać roli kontaktu`,
"vue_label_report_formulainformation":`Informacje o wzorze`,
"label.area.assignuser.remark":`Przypisywanie użytkowników do terytoriów`,
"label.multilang.viewlist.total":`{0} Wybrane`,
"label.newprocessstep4":`Krok 4 Wybierz szablony powiadomień e-mail`,
"label.permission.objectpermission.open":`Otwórz`,
"label.service.gantt.close.list":`Lista zamknięta`,
"label.standarduserfield":`Standardowe pola użytkownika`,
"vue_label_commonobjects_detail_the_administrator":`Rekord został zablokowany, prosimy o kontakt z administratorem.`,
"label.exchange.sync.account":`Dane uwierzytelniające konta usługi Exchange`,
"label.mr.title.button.back":`z powrotem, i zresetować kryteria wyszukiwania`,
"label.notsetup.operation":`Błąd stanu linii, nie ustawiono operatora.`,
"label.notifications_center":`Centrum Zgłoszeń`,
"label.event.moveup.5hour":`5 godzin naprzód`,
"report_label_pleaseinput":`Wpisz, czego chcesz szukać`,
"label.batchadd.newbatchpage.errorlist":`Nie udało się dodać danych`,
"label.quickbooks.invoices":`Faktury`,
"chatter.feed.usingchatter":`Włącz CCChat, Twoi użytkownicy mogą śledzić kilka osób lub rekordów i pisać posty.`,
"label.all.marketing.activities":`Właściciel kampanii rynkowej`,
"label.lookup.finish":`Autouzupełnianie Lookup`,
"label.weixin.unbind":`Rozwiąż`,
"front-console-closeTime":`Czas zamknięcia`,
"label.service.rest.time":`Pozostały czas`,
"label.mr.descreption.condition1":`Wprowadzić zakres i reguły wyszukiwania zduplikowanych rekordów. Kliknąć [Znajdź duplikaty], aby uzyskać kwalifikowane duplikaty rekordów.`,
"label.group.new":`Nowa Grupa`,
"vue_label_SMS_sending_please_wait":`Wysyłanie, proszę czekać`,
"label.Standardobj.tab":`Standardowe karty obiektów`,
"label_chatter_pastEvents":`Wcześniejsze działania`,
"label.chatter.priority":`Priorytet`,
"select.nullvalue":`-Non-`,
"setup_layout_group_pagecomponent":`Składniki strony`,
"label.dataimport.dataerror.check":`Błąd danych, proszę sprawdzić dane.`,
"label.permission.detail.app.pagesetting.tip":`Ustawienia uprawnień dla stron niestandardowych Excute`,
"label.knowledge.language.polish":`Polski`,
"label.project.hit.two":`Przypomnienie o wygaśnięciu podzadania`,
"label.customerapp":`Aplikacja na zamówienie`,
"label.reportsSubscriptionPage.condition.value":`Wartość`,
"label.tabpage.no2z":`Nr2`,
"lable.system.administrator":`Przepraszamy, nie masz dostępu do obsługi. Prosimy o kontakt z administratorem.`,
"homepage.layout.buttion":`Układ strony Przydział`,
"label.notification.event.overlapEvent":`Delegowany użytkownik jest już przypisany do zdarzenia {subject} od {begintime}-{endtime}, czy chcesz utworzyć to zdarzenie?`,
"label.customfields":`Pola niestandardowe`,
"label.data.downpage.e.title":`Etapy eksportu danych`,
"label.notification.serviceappointment.remove":`Twoje wysłane zlecenie {0} zostało anulowane, prosimy o rozsądne zorganizowanie pracy.`,
"label.campagin.roi.zhuangtai":`Status kampanii`,
"label.applt.updown":`Pobierz Miniprogram QR Code`,
"label.customfields.new.step1.tip":`Określa typ informacji, które pole niestandardowe będzie zawierać.`,
"label.staticresource.upload.limit":`Można przesyłać tylko pliki w tych formatach: png, jpg, gif, js, css, zip.`,
"chatter.edit.user.p":`Zmień zdjęcie użytkownika`,
"label.icon.32":`Komputer`,
"vue_label_homepage_notice_cantset":`Strona startowa profilu nie jest skonfigurowana dla tego profilu, nie można zmienić domyślnej strony startowej profilu`,
"front-epwechat-module-v1-agree-unbound":`Wyrażam zgodę i przyjmuję powyższe niewiążące informacje`,
"label.version.chatter.cooperation":`CCChat`,
"label.customer.tab.step1.selectstyle":`Proszę wybrać styl zakładki.`,
"label.select.an.asset":`Proszę wybrać składnik majątku.`,
"label.search.sizer.field":`Pola filtra wyszukiwania`,
"label.emailmerge.mergeFolder.lastone":`Proszę wybrać co najmniej szablon.`,
"label_tabpage_step2":`Krok 2 określenie warunków filtrowania`,
"label.version.lead.automatic.allocation":`Zasady przydzielania leadów`,
"label.projectManagement.update.succeeded":`Aktualizacja zakończona sukcesem`,
"label_tabpage_bar":`Bar`,
"label.appupload.component.type.tab":`Zakładka`,
"label.pigeonhole.sel.f":`Wybierz foldery do archiwizacji`,
"homepage.components.status":`Status komponentu`,
"label.currency.edit.new":`Edycja waluty: Nowa waluta`,
"label.input.new.password":`Proszę wprowadzić prawidłowe nowe hasło`,
"chatter.group.membersName":`MMeMber Nazwa`,
"label.myinfo.modify":`Dane osobowe Edytuj`,
"label_tabpage_next":`Następny krok`,
"vue_label_homepage_card_closedopportunities":`Możliwości zamknięte`,
"label.permission.edit":`Edycja Właściwości`,
"message.error.searchfield.objid.null":`Id obiektu wymagane przez pole zapytania nie może być puste`,
"label.partnerCloud.productSet":`Konfiguracja produktu`,
"label.emailtocloudcc.filed.emailto":`E-mail do`,
"label.service.miniProgram.uploadingImage":`Prosimy o przesłanie zdjęcia karuzeli.`,
"label.sso.saml.idp.description1":`Podłączone aplikacje`,
"label.event.moveup.10minutes":`10 minut wcześniej`,
"label.quote.createby":`Przygotowujący`,
"label.workflow.baseontimeoparate":`Akcje przepływu pracy zależne od czasu`,
"label.searchall.r":`Szukaj ponownie`,
"vue_label_homepage_differentprofiles":`Przypisz różne strony główne do różnych profili`,
"label.campaign.channel.step1":`Krok 1: Informacje`,
"label.event.moveup.2hour":`2 godziny naprzód`,
"font-evaluate-module-v1-cancle-reply":`Anuluj automatyczną odpowiedź`,
"message.datalocked.delete":`Nie możesz usunąć tego rekordu, ponieważ został on zablokowany. Jeśli chcesz go usunąć, skontaktuj się z adminem.`,
"label.sso.listOfKey":`Lista kluczy`,
"label_chatter_newtask":`Nowe zadanie`,
"label_emailsync_form_seversetting":`Ustawienie`,
"label.partner.new.function":`Opis funkcji`,
"vue_label_notice_homepage_pleaceentername":`Proszę wpisać nazwę strony głównej`,
"message.please.choose.opportunity":`Proszę wybrać możliwość biznesową`,
"label_file_use_most_user":`Użytkownicy z największą ilością wykorzystanej przestrzeni dyskowej`,
"label.htyj.remark2":`więc nie można wyświetlić kwot kontraktów`,
"label.formula.message":`gdy formuła zostanie oceniona jako fałszywa， monit o niepowodzenie przesłania`,
"UG_Case_04":`Przydzielanie przypadków`,
"label.displaycolumn":`Wyświetlanie kolumn`,
"vue_label_campaign_selected_member_status":`Aktualizacja do wybranego statusu członka`,
"label.workflow.operate":`Akcje przepływu pracy`,
"label_chatter_mail":`Mail`,
"label.setup.mini.setting":`Ustawienie tła dla Mini Programów`,
"vue_label_chat_invitetojoin":`Zaprosiłeś "{invite}" do udziału w czacie grupowym`,
"setup.object.field.dependency.label.linkedfieldvalue":`Pole zależne`,
"vue_label_email_update_template":`Szablon aktualizacji`,
"label.email.template.private.mail":`Ekskluzywny Folder Szablonów Email`,
"lable.Confirm .potential.customers":`Potwierdzam recykling ołowiu {nazwa}`,
"vue_label_leadpool":`Basen ołowiany`,
"label.ems.hostorpost.error":`Błąd konfiguracji serwera lub portu, proszę sprawdzić.`,
"label.search.saveok":`Pomyślnie zapisane`,
"label.custom.field.cannot.maping":`Nie można mapować do tego pola wiele razy`,
"label.projectManagement.dispatched":`Wysłane`,
"time":`Czas`,
"label.choose_socialnetwork":`Wybierz sieć społecznościową, od której chcesz zacząć`,
"label.vlidaterule.checkedtrue":`Jeśli formuła jest polem wyboru, nie ma potrzeby stosowania podwójnego cudzysłowu.`,
"label.appointmentconfirmail.wizard.btn1":`Zmiana harmonogramu`,
"front-kefu-moudle-v1-maxchars-input":`Można wprowadzić do {0} znaków`,
"setup.mainpage.label.welcome10":`Instrukcje: Kliknij w menu po lewej stronie → Ustawienia aplikacji → Utwórz → Obiekt → Nazwa obiektu → Układ niestandardowy.`,
"label.ems.company.setup.title":`Ustawić skrzynkę mailową firmy`,
"label.channel":`Kanały`,
"label.textmessage.groupsms":`Grupa SMS`,
"label.asset.deleted.successfully":`Usuń BOM aktywów pomyślnie.`,
"label.knowledgebase.new.workspace":`Nowa przestrzeń robocza`,
"label.ServiceCloud.diliweizhi":`Lokalizacja`,
"label.private_me":`Prywatne dla właściciela (ja)`,
"label.service.miniProgram.imageLink":`Karuzela Link`,
"label.area.assigned":`Przypisani użytkownicy`,
"label.weixin..xsld.name":`Nazwa możliwości`,
"label.campaign.matchway.select.name":`Nazwa`,
"label.installedsoft":`Zainstalowane pakiety`,
"label.projectManagement.spare.time":`Dostępny czas`,
"label.user.select.custom.text.sendemail":`Wybierz niestandardowy format tekstu, aby bezpośrednio wysłać wiadomość e-mail`,
"label_chatter_chatter":`CCChat`,
"label.approveorrefuse":`Zatwierdzić/odrzucić`,
"startdate.enddate.time.illegal":`Data początkowa powinna być mniejsza lub równa dacie końcowej.`,
"label.project.hit.eight":`Codzienne przypomnienie o zadaniu`,
"message.duplication.label.uncheck":`Noo-weryfikacja`,
"label.allocation.role":`Przydzielanie użytkowników`,
"label.sendemail.lead.scoreinfo":`Szanowny #username:system ocenił wszystkie leady z wybranego przez Ciebie widoku "#viewlabel" na podstawie reguł punktacji leadów. trwa to #timestr.\NProszę się zalogować i otworzyć widok, aby sprawdzić wyniki.\Uwaga: Jeśli nie możesz zobaczyć wyniku ocenionych leadów, edytuj widok i dodaj "lead scoring" do pola wyświetlania, aby zobaczyć wynik punktacji. Dziękuję i pozdrawiam!`,
"lable.oppt.jieduan.closejieduan":`Zamknij tę możliwość`,
"label.ems.verify":`Zweryfikuj`,
"message.error.startdate":`Data początkowa musi być wcześniejsza niż data końcowa`,
"label.campaignmember.main.deletelead":`Usuń istniejące leady`,
"label.partnerCloud.financeSetting.account":`Po aktywacji funduszu partnerskiego dodane zostaną obiekty funduszu partnerskiego oraz zestawienie środków. Użytkownicy partnerscy mogą korzystać z konta w CloudCC do opłacania zamówień.`,
"message.datalocked":`jego rekord jest zablokowany. Jeśli chcesz go edytować, skontaktuj się z administratorem.`,
"lable.opppdt.selPbk.pricebook":`Książki z cenami`,
"label.knowledgebase.restore.article":`Przywrócić artykuł?`,
"label.object.batchadd":`Dodaj partię {objName}`,
"label.what_happen":`Strona po wysłaniu formularza`,
"label.roleandunderling":`Role i podwładni`,
"label.knowledge.language.russian":`Rosyjski`,
"front-electronic-signature-explain-first":`Przed przystąpieniem do podpisu elektronicznego zalecana jest rejestracja i certyfikacja na platformie Fadada.`,
"component.sendmail.label.subject":`Temat`,
"month":`Miesiąc`,
"label_chatter_save":`Zapisz`,
"label.view.sortview.sectiontitle":`Widok zostanie wyświetlony w wybranej kolejności`,
"label.mobile.home.page.major.project":`Kluczowe projekty`,
"label.weixin.input.filename":`Proszę wpisać nazwę pliku`,
"label.pagelayout.remark":`Ta strona umożliwia tworzenie różnych układów strony, aby wyświetlić`,
"label.service.miniProgram.store":`Brand Story`,
"label.recordtype.edit.selected":`Wybrana wartość`,
"message.selectgroupcondition":`Proszę wybrać warunki do grupowania`,
"label.y.axis.cannot.empty":`Oś Y nie może być pusta`,
"label.textmessage.vonage.connected.count":`Count as Contacted`,
"setup.layout.label.readonly":`Tylko do odczytu`,
"front-kefu-moudle-service-agent":`Obsługa klienta`,
"message.login.mfaverification.page.invalid":`Strona jest nieprawidłowa, proszę odświeżyć.`,
"label.central.standard.time":`Czas standardowy środkowy`,
"label.processnoticepic":`Uwaga Obraz procesu zatwierdzania`,
"vue_label_helpcenter_calendar1.2":`Zasady wyświetlania pozycji kalendarza: pozycje kalendarza będą wyświetlane w siatce kalendarza, a obszar siatki, w którym znajduje się pozycja kalendarza, reprezentuje zakres czasowy rekordu. Pozycje kalendarza, które obejmują więcej niż 24 godziny, będą wyświetlane u góry skali czasu w widokach dnia, tygodnia i dostępności. Jeśli w widoku miesiąca w siatce znajduje się wiele pozycji kalendarza, można kliknąć " Więcej", aby je wyświetlić. Po lewej lub prawej stronie pozycji kalendarza znajduje się półkole, co oznacza, że nie ma takiego wpisu w poprzednim lub następnym dniu siatki. Lewa lub prawa strona pozycji kalendarza jest zaokrąglona pod kątem prostym, co oznacza, że w poprzednim lub następnym dniu siatki nadal znajduje się ten rekord. <br> Szybko zlokalizuj datę w widoku kalendarza: Możesz zlokalizować zakres dat wyświetlany w widoku kalendarza po lewej stronie, wybierając godzinę na małym kalendarzu po prawej stronie strony kalendarza. Można również kliknąć ikony "<" i ">" w prawym górnym rogu strony kalendarza, aby szybko przełączać daty. Jeśli czas w widoku kalendarza nie jest czasem bieżącym, możesz kliknąć ikonę "Dzisiaj" w prawym górnym rogu strony kalendarza, aby szybko przełączyć się z powrotem na dzień dzisiejszy. <br> Widok listy<br> Przełącz z widoku kalendarza do widoku listy: Kliknij ikonę "kalendarz" w prawym górnym rogu widoku kalendarza i wybierz "tabela", aby przełączyć się do widoku listy wydarzeń. <br> Korzystanie z widoku listy: Aby wyświetlić określone wydarzenia lub wiele wydarzeń jednocześnie, otwórz widok tabeli. W widoku listy dostępne są wstępnie ustawione widoki listy. Kliknij ikonę "przycisku rozwijanego" w lewym górnym rogu widoku listy, aby wyświetlić wszystkie widoki listy, do których masz dostęp. Możesz również dostosować widok listy zdarzeń do swoich potrzeb. <br> 2. Mój kalendarz i inne kalendarze<br> Mój kalendarz<br> Mój kalendarz zawiera mój kalendarz wydarzeń i kalendarz obiektów. <br> Mój kalendarz wydarzeń: Wyświetl wszystkie rekordy zdarzeń, w których przypisana osoba jest Twoja na widoku kalendarza. Mojego kalendarza wydarzeń nie można usunąć, edytować ani zmienić koloru. Możesz udostępnić "Mój kalendarz wydarzeń" swoim współpracownikom.`,
"label.approval.end":`Koniec`,
"vue_label_report_notice_cannotdelete":`W tym folderze znajdują się raporty, których nie można usunąć`,
"label.sso.saml.idp.loginurl":`URL logowania idP`,
"label.emailtocloudcc.filed.port":`Port`,
"label.directdashboard.righttitle":`Pulpity analizy sprzedaży`,
"label.knowledge.case.suggest.article":`Sugerowane artykuły w sprawach`,
"label.version.maxcount":`ponad limit.`,
"label.weixin..xsld.yjqyrq":`Data zamknięcia`,
"front-project-module-v1-unmarket-is-template":`Odznacz szablon`,
"label.mobile.quickcreate.default.map":`Mapa`,
"chatter.click.p":`Kliknij, aby wyświetlić podgląd`,
"label.chat.topic.all.topic":`Wszystkie tematy`,
"label.channel.head":`Nadzorca kanału`,
"lable.edit.queue.emaildes":`Wprowadź nazwę kolejki i adres e-mail, który ma być używany do wysyłania powiadomień (na przykład, gdy sprawa zostanie umieszczona w kolejce). Adres e-mail może być dla osoby lub listy dystrybucyjnej. Kiedy obiekt jest przypisany do kolejki, tylko członkowie kolejki zostaną powiadomieni.`,
"label.tag.filter":`Tag Filtr`,
"label_chatter_filterTimeLine":`Linia czasowa filtrowania`,
"label.dashboard.show.value":`Pokaż wartości`,
"vue_label_normal_solution_sf":`Rozwiązanie`,
"label.customfields.location.tip":`Umożliwia użytkownikowi określenie lokalizacji. zawiera komponenty długości i wymiaru, które mogą być używane do obliczania odległości.`,
"label.weixin.copyright":`Copyright© 2008-2022 CloudCC.com,inc. Wszelkie prawa zastrzeżone przez CloudCC.com`,
"label.icon.33":`Komputer`,
"label.mr.title.opportunityName":`Nazwa możliwości`,
"template.report.sales.month":`Sprzedaż w tym miesiącu`,
"chatter.group.lookingForPeople":`Rozpocznij wpisywanie nazwy`,
"label_tabpage_userz":`Użytkownicy`,
"label.reportsSubscriptionPage.email.formatselection":`Proszę wybrać format raportu, który chcesz otrzymać przez e-mail`,
"lable.product.plist":`Cena katalogowa`,
"label.multilang.activity.monthline":`Tydzień {0}`,
"label.ccchat.whose.name.contains2":`Członkowie jakiejkolwiek grupy prowadzącej kampanię`,
"label.mobile.phone.day.report":`Dzienne notatki robocze`,
"label.processsetting.set.files":`Ustawianie pól`,
"label.systemlog.s":`Sukces`,
"label.tabpage.uploadsz":`Prześlij`,
"serviceterritory.member.time.conflict":`W tym przedziale czasowym zasoby serwisowe stały się członkami innego terytorium serwisowego.`,
"label_chatter_startDate":`Dane początkowe`,
"label.search.at.least.two":`Wyszukiwane hasła nie mogą być krótsze niż 2 znaki.`,
"label.approval.ressign.project":`Pozycje do przypisania`,
"lable.custom.Previous.CY":`Poprzedni CY`,
"label_chatter_link":`Link`,
"label.weixin.group.name":`Nazwa`,
"label.partnerCloud.basicSetting.domainName":`Operacja jest nieodwracalna, a nazwa domeny nie może być zmieniona po inicjalizacji. Czy na pewno chcesz potwierdzić operację?`,
"lable.SalesCommitmentKanBan.targetContract":`Docelowa kwota umowy`,
"label.currency.new":`Nowa waluta korporacyjna`,
"message.passwordPolicy.validate.complexReq3":`Błąd:Twoje hasło musi składać się z cyfr, małych i dużych liter oraz znaków specjalnych.`,
"label.icon.127":`Lekarze`,
"label.customfields.fieldname.tip":`Nazwa pola jest wewnętrznym odniesieniem i jest używana do celów integracyjnych, takich jak API.`,
"chatter.feed.menutype.feed":`Streszczenie`,
"label.home.standard.dashboard.role":`Nie masz informacji o roli, więc nie możesz wyświetlić pulpitu nawigacyjnego zobowiązań sprzedaży.`,
"label.customfields.fielddependency.button":`Kliknij przycisk, aby dołączyć lub wykluczyć wybrane wartości z zależnej listy pickupów.`,
"label.recentprojects":`Ostatnie pozycje`,
"label.appupload.logo.introduce":`Logo pakietu musi być mniejsze niż 20KB. Wymiary obrazu powinny wynosić maksymalnie 60 pikseli szerokości na 60 pikseli wysokości, aby uzyskać najlepsze rezultaty. Większe obrazy zostaną zmniejszone i mogą być zniekształcone.`,
"label.integrations.northamericanleads":`North American Leads`,
"label.sms.balance":`Saldo (w juanach)`,
"label.ccchat.message.num":`Wiadomości`,
"label.embed_website":`Aby osadzić ten formularz, po prostu skopiuj i wklej poniższy kod do kodu HTML na swojej stronie internetowej.`,
"label.trigger.check.error":`Nie powiodło się sprawdzanie składni wyzwalacza.`,
"label.bmap.baidu.maps":`Baidu Maps`,
"label.nextapproverauto":`Następny Zautomatyzowany Zatwierdzający Określony przez`,
"label.customfields.date.tip":`Umożliwia użytkownikom wprowadzenie daty lub wybranie daty z wyskakującego kalendarza.`,
"button.partner.back":`Powrót`,
"label.layout.editcondition.tip":`Wybrać pola, które mają być użyte jako kryteria wyszukiwania. Uwaga: można wybrać do 10 pól.`,
"label.stacked.area":`Obszar ułożony w stos`,
"font-evaluate-module-v1-case-closed":`Tylko w przypadku zamknięcia sprawy`,
"label_emailsync_status_log":`Dziennik połączeń`,
"label.version.area.and.sales":`Zarządzanie terytoriami i zespół sprzedaży`,
"label.service.booking.sessions":`Termin wizyty serwisowej`,
"label.untransfile":`Nieprzetłumaczone`,
"label.textmessage.sentfail":`Nie udało się wysłać`,
"label.emailtemplate.detailinfo":`Szczegóły szablonu`,
"setup_mainpage_label_welcome13":`Instrukcje: Kliknij menu górne → Raporty → Nowy.`,
"label.ccchat.error.nullid":`ID nie może być puste`,
"label.partnerCloud.partnerAccount.rebate":`Rebate Revenu`,
"label.appupload.component.type.scheme":`Pole`,
"front-kefu-moudle-phonein":`Połączenie przychodzące`,
"label.emailmerge.list.description":`Szablony mail merge to dokumenty MicroSoft Word z polami merge, które odwołują się do pól CloudCC.com.`,
"vue_label_commonobjects_detail_select_first":`Proszę najpierw wybrać powiązane elementy`,
"label_emailsync_form_action":`Działanie`,
"label.customfieldrelation":`Pola niestandardowe i relacje`,
"label.ems.other.msg":`Prosimy o podanie adresu administratora CloudCC (<a href='mailto:admin@cloudcc.com' style='text-decoration: underline;'>admin@cloudcc.com</a>), uruchomienie usługi synchronizacji poczty.`,
"label.appointment.wizard.subtitle4-3-4":`1 h`,
"label.service.miniProgram.isOpen":``,
"equal":`równa się`,
"label.partnerCloud.financeSetting.merchantInformation":`Ścieżka dostępu: Merchant Platform  Account Center  Merchant Information`,
"vue_label_calendar_displayed_field_name":`Nazwa wyświetlanego pola`,
"UG_opportunity_002":`Zdefiniuj swój cykl sprzedaży, skonfiguruj etapy`,
"label.tag.addtags.button1":`Zapisz`,
"label.explain":`Instrukcje`,
"label.icon.166":`Pawilon`,
"label.exchange.sync.setting.use":`Włącz synchronizację z programem Exchange`,
"label.chatter.assignPerson":`Osoba wyznaczona`,
"lable.PowerProcess.event.condition":`Warunki dotyczące kamieni milowych`,
"label.addattachment.step1":`Krok 1 Wybierz plik`,
"label.account.fiscal.quarter.timeerror":`Data rozpoczęcia kwartału podatkowego lub data zakończenia kwartału podatkowego znajduje się pomiędzy kwartałami podatkowymi historii, proszę sprawdzić i zresetować.`,
"label.URL":`URL do odniesienia`,
"label.icon.134":`Dane`,
"label.forecast.customforecast.foredis.sq":`Tysiące`,
"label.custom.field.number.decimal":`Nieprawidłowa liczba cyfr.`,
"label.version.history.track.error":`Twoja wersja obsługuje tylko wybrać <=5 pól, nie można wybrać więcej pól.`,
"label.log.os":`System operacyjny`,
"label.partner.workspace.tab.option":`Dostępne zakładki`,
"label.partnerCloud.partnerAccount.accountWater":`Zestawienie funduszy`,
"setup_layout_label_norelatedlist":`Brak powiązanych list`,
"label.import.page1.nextstep":`Następny`,
"label.emailobject.view.attached":`Wiadomości e-mail z załącznikami`,
"label.SalesCommitmentKanBan.allTask":`Całkowita kwota zadania`,
"label.eastem.daylight.time":`Czas letni wschodni`,
"label.create_engaging":`Stwórz atrakcyjny post, aby połączyć się z całym światem.`,
"label.area.adduser":`Dodaj lub usuń użytkownika`,
"label.timezone.importtimezone.user":`Użyj strefy czasowej użytkownika logowania`,
"label.passwordPolicy.setup.pwdremember1":`1 zapamiętane hasło`,
"label.query.detail.openpartneruser":`Włącz użytkownika partnerskiego`,
"label.senduser":`Wyślij z`,
"Pagelayout_Setup_001":`Proszę wybrać listy powiązane, które będą wyświetlane przy najechaniu na układ.`,
"label.mobile.parameter.setup":`Ustawienia aplikacji mobilnej`,
"message.device.not.bound.mfa":`Nieograniczone urządzenia MFA`,
"setup.layout.label.buttonarea":`Obszar przycisków`,
"chatter.email.reply.like":`Komentarz do przedmiotu, który mi się podoba`,
"label.chatter.day":`Dzień`,
"label.sendemail.chat.addComentspraisesubject":`CloudCC CCChat reply the post Podoba mi się`,
"label.field.remark2":`strona.`,
"label.ggReleaseRange.release":`Zakres publikacji`,
"lebel.alreadyback":`Wycofany z rynku`,
"label.appupload.install.appname":`Nazwa aplikacji`,
"label.selectnewadeckertag":`Wybierz etykietę dla nowego pola hierarchii`,
"label.cliententrancewebsiteadmin":`Administrator Portalu Klienta`,
"label.checkbox.checked":`Wybrane`,
"UG.Case.03":`Automatyczna rozbudowa obudowy`,
"vue_label_dashboard_group":`Proszę wybrać grupę`,
"label.import.index.preparedata":`Przygotuj dane, które chcesz zaimportować`,
"vue_label_member_notice1":`Możesz przesyłać pliki JPG, GIF lub PNG, maksymalny rozmiar pliku to 2M.`,
"message.modify.success":`Modyfikacja zakończona sukcesem.`,
"label.userquotas":`Kontyngenty`,
"label.appointmentpage.wizard.subtitle3-1":`Nazwa`,
"label.import.index.maxdata2":`2、Przed importem, proszę upewnić się, że wszystkie rekordy związane z nim są importowane jako pierwsze. Na przykład, jeśli istnieje relacja lookup pomiędzy obiektem, który obecnie importujesz, a kontaktami, zaimportuj najpierw te kontakty, a następnie zaimportuj swoje dane. Jeśli potrzebujesz uzyskać odpowiednie ID rekordu i inne informacje, możesz utworzyć raport i ustawić nazwę rekordu i ID rekordu jako kolumnę grupy, a następnie wyeksportować raport.`,
"label.pc.sectionpart":`Sekcja PC`,
"template.chart.wcldqzkh":`Nieprzetworzone leady`,
"label.save.the.block.pricing.information.of.the.current.price.manual":`Czy chcesz zapisać informacje o cenach blokowych z aktualnej książki cenowej?`,
"label.partnerCloud.financeSetting.payments":`Umożliwienie płatności online`,
"lable.account.ThisWeek":`W tym tygodniu`,
"label.validate.function.funcFormat.RIGHT":`RIGHT(text, num_chars)`,
"label.app.select.bgcolor":`Wybierz kolor tła`,
"label.planned.work":`Planowane miejsca pracy`,
"label.passwordPolicy.setup.nolimit":`No Limit`,
"label.vlidaterule.s":`Jeśli wyłączysz walutę używaną przez użytkownika, waluta użytkownika zostanie ustawiona na walutę korporacyjną.`,
"label.paging.totalofrecords":`Łącznie {0} rekordów`,
"label.customobjects.behaviour":`Działania`,
"vue_label_ccchat_notice_deletecommentsuccess":`Komentarz usunięty pomyślnie`,
"label.lock.record.dele":`Rekord jest zablokowany, nie można go usunąć.`,
"label.data.expnode.e.desc3":`3、Template Create: użytkownik może zrobić szablon według pól i warunków, które zostaną wyeksportowane do swoich potrzeb, co jest wygodne do wykorzystania w następnym czasie.`,
"label.button.step3.create.page":`Krok 3 Generowanie stron`,
"label.sharer":`Udział z`,
"label.service.cycle.type":`Typ cyklu`,
"lable.SalesCommitmentKanBan.allreceivingCommitmentRate":`Całkowite wpływy Wskaźnik zobowiązań`,
"label.formuladate":`Format daty: yyyy-MM-DD hh:mm:ss lub MM/DD/YYYYhh:mm:ss, np: 2007-12-25 12:25:30 lub 12/25/2007 12:25:30.Możesz również użyć today() lub now();`,
"front-template-V1-addImg":`Dodaj zdjęcie`,
"label.basecontrol":`Dostęp podstawowy`,
"label.forecast.settings.lable1":`Agregacja danych dotyczących prognoz`,
"message.error.file.null":`Przesłany plik nie może być pusty`,
"label.multiply":`*Mnożyć`,
"message.duplication.label.targetobject":`Obiekt`,
"label.addattachment":`Dodaj załącznik`,
"vue_label_dashboard_notice_editcertification":`Czy na pewno chcesz edytować komponent {nazwa}?`,
"label.notification.tip2":`Brak nowych powiadomień`,
"lable.quote.syncingfrom.firstsync":`Synchronizacja wstępna Możliwość składania ofert`,
"label.createtasktip":`Utwórz zadanie, które zostanie skojarzone z jedną lub wieloma regułami przepływu pracy, procesami zatwierdzania lub procesami uprawnień. Podczas zmiany zadania wszelkie modyfikacje zostaną zastosowane do wszystkich powiązanych z nim reguł, procesów zatwierdzania i nadawania uprawnień.`,
"label.leave":`Zostaw`,
"front-invoice-online-payment-setup-china":`Aplikuj na chińskie konta`,
"label.appointment.wizard.subtitle4-1-2":`30 min`,
"label.projectManagement.the.person.not.be.informed":`W przypadku wybrania opcji Nie, osoba odpowiedzialna nie może zostać powiadomiona!`,
"label.campagin.roi.name":`Nazwa kampanii`,
"label.import.page1.newcreate":`Utwórz stronę`,
"label.data.downpage.i.title.num2":`2、Przed rozpoczęciem importu upewnij się, że nazwa pola w pliku, który chcesz zaimportować jest zgodna z nazwą pola obiektu w CloudCC.`,
"label.callcenter.call.in":`Zadzwoń`,
"label.weixin.activity.phone":`Działalność: Zadzwoń na`,
"label.forecast.customforecast.type.role":`Przez rolę`,
"label.moscow.standard.time":`Czas standardowy moskiewski`,
"label.profile.setcustomobjectrecordtype":`Ustawienia niestandardowe typu zapisu`,
"lable.edit.queue.new":`Nowa kolejka`,
"label.newAPPexchange":`Nowa aplikacja...`,
"message.custom.field.donotdelete.fieldupdate":`Do tego pola odwołuje się aktualizacja pola w innym procesie przepływu pracy lub zatwierdzania.`,
"label.chatter.state":`Status`,
"label.subject_line":``,
"template.report.folder.active":`Analiza kampanii i działań`,
"label.icon.114":`Dom`,
"label.assignment.setup.newentries.step3":`Krok 3 Wybierz użytkownika, któremu chcesz przypisać rolę lidera`,
"label.salescloud.salesdashboard.sales.behavior.rankings":`Przegląd zachowań osobistych`,
"label.weixin.optiontwo":`Wybór 2`,
"label.sso.saml.idp.config.sp":`Usługodawcy`,
"System_TimeField_Description":`Umożliwia użytkownikom wprowadzenie czasu lokalnego. Na przykład, "14:40 PM", "14:40" i "14:40:00" są poprawnymi czasami dla tego pola.`,
"label.knowledgebase.draft":`Projekt`,
"label.chat.topic.no.more.suggestions":`Brak innych sugestii`,
"label.quote.product":`Produkt`,
"label.cryptographictext":`Tekst zaszyfrowany`,
"label.custom.unlock":`Odblokuj`,
"label.assignment.setup.newentries.step2":`Krok 2 Wybierz kryteria dla wpisu tej reguły`,
"label.tabularreport.selectline":`Wybierz kolumny, które chcesz uwzględnić w raporcie.`,
"label.exchange.sync.state.contact.m2":`Rekordy zsynchronizowane w ciągu ostatnich 60 minut:`,
"label.codeType":`Kod Typ`,
"saturday":`Sobota`,
"label.mask.type":`Rodzaje masek`,
"label.schedulejob.setup.schedule.Monthly":`Miesięcznie`,
"label.import.page2.totalfiled{{20}}，{{4}}notsuited":`文件中共{{20}}个字段，剩余{{20}}个未映射

{{20}} pola w pliku , {{20}} niezmapowane`,
"label.projectManagement.delete.item":`Wszystkie powiązane informacje tego projektu zostaną usunięte, jeśli usuniesz projekt, a danych nie będzie można odzyskać. Czy na pewno chcesz potwierdzić usunięcie?`,
"label.page.general.us.and.western.europe":`Języki ogólne USA i Europy Zachodniej`,
"label.reportsSubscription.status":`Subskrybowany`,
"label.discount.baifenbi":`Dyskonto (%)`,
"font-evaluate-module-v1-web-page-evaluation-settings":`Konfiguracja oceny internetowej`,
"message.error.searchwork":`Wpisane przez Ciebie słowa kluczowe muszą mieć 2 lub więcej znaków.`,
"label.weixin.option.setting":`Ustawienia wyborów (do 10 wyborów)`,
"label.lead.score.prompt1":`Oceniaj pojedynczy rekord leadu automatycznie podczas tworzenia lub edycji. Ale trzeba ręcznie punktować wiele rekordów leadów, podczas importu wsadowego lub tworzenia przez interfejs.`,
"label.exception.must.try.throw":`Wyjątek musi być wyrzucony w bloku staementowym.`,
"label.activity.plan":`Plan`,
"label.partnerCloud.productSet.editor":`Edycja Opcja`,
"label.mobile.quickcreate.default.signinnew":`Zaloguj się`,
"label.summaryreport.2018.step6.new":`Krok 6 Wybierz typ wykresu i element podświetlenia.`,
"vue_label_homepage_owner":`Strona główna`,
"vue_label_dashboard_editfoldersuccessfully":`Pomyślna edycja folderu`,
"label.quickbooks.view.overdueinvoices":`Zaległe faktury`,
"label.emailtocloudcc.redmessage4":`Proszę wprowadzić dane dotyczące portu`,
"label.tabpage.equalz":`Równe`,
"lable.quote.syncing.firstsync":`Synchronizacja wstępna od oferty do możliwości`,
"label.download.CloudCCAPP":`Pobierz aplikację CloudCC`,
"label.icon.6":`Waluta`,
"label.list.serial.number":`Numer seryjny`,
"label.profile.setstandardobjectrecordtype":`Ustawienia standardowego typu zapisu`,
"label.customize.memory.function.sorting.error":`Czas odpowiedzi zapytania jest zbyt długi i powoduje timeout strony. Może to być spowodowane tym, że pamięć sortowania nagłówków jest włączona. Proszę przejść do ustawień osobistych i dezaktywować tę funkcję.`,
"message.view.addtoallusers":`Widoczność powiązanych użytkowników`,
"label.globaloperation.operationtype.record.phone":`Rejestrowanie połączeń`,
"lable.opppdt.selPdt.searchresult":`Wyniki wyszukiwania`,
"label.import":`Import`,
"label.service.gantt.work.based.resources":`Zasoby oparte na godzinach pracy`,
"label_partner_template_detailimage":`Zdjęcie`,
"label.cpq.product.feature.option.count":`Minimalna liczba opcji produktu nie może być większa niż maksymalna liczba opcji produktu`,
"label.chatter.newtask":`Nowe zadanie`,
"font-trade-module-v1-invoice-total-price":`Planowane Płatności ogółem`,
"setup_mainpage_label_welcome29":`Standardowa integracja API z produktami innych firm`,
"label.data.exportall.all.btn":`Eksportuj wszystkie dane`,
"front-epwechat-module-v1-unbound-WeChat":`Rozwiąż WeCom`,
"label.salescloud.salesdashboard.performance.rankings":`Zespół - Sprzedaż Kontrakt Kwota Rankingi`,
"label.import.page1.newcreateandupdate":`Aktualizacja i rozpoczęcie nowego`,
"component.chatter.post.button.file":`Dodaj załączniki`,
"label.partnerCloud.orderingPlatform.createOrder":`Nowy porządek`,
"label.lookup.multiple.data":`Znaleziono wiele danych, proszę wybrać ręcznie`,
"button.partner.save":`Zapisz`,
"label.service.add.timeslot":`Dodaj przedział czasowy`,
"label.campaign.matchway.select.email":`E-mail`,
"front-sales-button-fromQB":`Aktualizacja z QuickBooks`,
"label.icon.108":`Strzałka`,
"lable.outlook.edit.efmapping":`Edycja mapowań pól`,
"label_tabpage_refreshz":`Odśwież`,
"chatter.follow.cancel":`Przestańcie śledzić`,
"label.totals.sum":`Ogółem`,
"label.noRequest":`Nie jest wymagany`,
"vue_label_homepage_fixedcomponent":`Proszę wybrać element stały`,
"label.knowledge.delete.case":`Błąd podczas usuwania artykułu o sprawie.`,
"label.weixin..xsld.yjwc":`Przewidywane dochody`,
"label.customcomponent.page.index.console.btn":`Konsola programisty`,
"label.sendsms.batch":`Masowe SMS-y`,
"vue_label_chat_onlychosechat":`Tylko użytkownicy zespołu mogą zostać wybrani do rozmowy.`,
"label.tabpage.page":`Strona`,
"label.cyen.note":`Włącz walutę. Zauważ, że akcja włączenia waluty jest nieodwracalna.`,
"label.weixin.againsend":`Wyślij ponownie`,
"label.processnumber":`Krok nr.`,
"label.emailobject.to":`Do:`,
"label.event.today":`Dzisiaj`,
"label.dashboard.dispalyPosition":`Pozycja spalona`,
"message.error.recalculate.dupoperate":`Przeliczanie, proszę nie działać często.`,
"vue_label_email_linkrecordsuccess":`Rekord powiązany pomyślnie`,
"label.updateoutboundnews":`Aktualizuj wiadomości wychodzące`,
"label_emailtocloudcc_exists2":`Ta skrzynka pocztowa została ustawiona na Email to Case. Nie powtarzaj ustawień.`,
"label.tag.addtags.button2":`Anuluj`,
"label.stdashbord.xsld.business.role":`Rola ta jest pobierana z ról enable w hierarchii prognoz`,
"label.commonnew":`Normalny nowy`,
"label.validate.remark2":`Przykładowe zastosowanie:`,
"label.reportsSubscriptionPage.condition.checkbox":`Dodaj warunki do tego raportu`,
"label.globalselect":`Lista opcji globalnych Zestaw wartości`,
"label.partnerCloud.partnerAccount.available":`Dostępna kwota`,
"label_tabpage_nothingz":`Nic`,
"label.version.webtolead":`We to Lead`,
"label.projectManagement.heat.map":`Mapa cieplna`,
"message.error.pleasecorrectdata":`Proszę przejrzeć wszystkie poniższe komunikaty o błędach, aby poprawić dane.`,
"label.hight.tip":`Gdy filtr zaawansowany nie jest włączony, relacją pomiędzy różnymi warunkami filtru jest "i", czyli rekord spełniający wspólne cechy 1 i 2.`,
"label.workflow.estimatecondition3":`Utworzony lub przy każdej edycji`,
"AssetRelationship.time.limit.error":`Data rozpoczęcia powinna być wcześniejsza lub równa dacie wymagalności.`,
"label.multilang.workflow.dayinmonth":`{1} co {0} miesiąc(y)`,
"label.reportsSubscriptionPage.schedulereport.daily":`Codziennie`,
"label.emailtocloudcc.step1.name":`Wybierz funkcję`,
"label.follow_up":`Email uzupełniający`,
"label.price.list.price.cannot.be.empty":`Cena katalogowa nie może być pusta.`,
"label.chatter.link":`Link`,
"label.ccpeak.condition.return.record":`Zwraca rekordy według warunku i obsługuje typowe warunki "gdzie".`,
"pagecreator.layout.message.canntdelete":`Bieżący układ nie może być usunięty`,
"label.compact.layout.main":`Układ głównych informacji kluczowych`,
"label.testandupdate":`Sprawdź aktualizację`,
"button_partner_cancel":`Anuluj`,
"label.activity":`Działania`,
"label.knowledge.setting.hint.fourteen":`Przygotuj się do pisania!`,
"vue_label_commonobjects_view_open_from_list":`Otwórz z listy, aby rozpocząć`,
"front-electronic-export-intro":`2000 rekordów może być wyeksportowanych do Mailchimp za jednym razem`,
"label.chosen.all":`Wszystkie pola`,
"label.file.extension":`Rozszerzenie pliku`,
"vue_label_systemSettings_server_miniprogram":`Miniprogram usług`,
"label.weixin.no.pending.wdgz.qin.today":`Brak planu pracy na dziś.`,
"label_tabpage_issuez":`Kwestia`,
"label.staticresource.tip":`Użyj zasobów statycznych, aby przesłać zawartość, do której chcesz się odwołać na stronie niestandardowej, w tym pliki .zip, obrazy, arkusze stylów, JavaScript i inne.`,
"label.approvalstep":`Etapy zatwierdzania`,
"label.china.standard.time":`Czas standardowy chiński`,
"label.appexchange.download.tiaoguo":`Zignoruj`,
"label.callcenter.link.Amazon.connect":`Amazon Connect`,
"vue.dashboard.notRequired.notConformToTheRules":`Nie można wysłać! Wymagane elementy nie zostały wypełnione lub są niezgodne z zasadami.`,
"label.appointment.wizard.title1":`Określenie dostępności`,
"label.chat.remove.bookmark":`Usuń zakładkę`,
"label.tabpage.advancedsearch":`Wyszukiwanie zaawansowane`,
"batch.ranf.f":`Nieudane zapisy transferu masy`,
"label.appointment.wizard.subtitle4-1-4":`1 h`,
"label.brief.account":`Konta`,
"component.chatter.link.label.url":`Link url`,
"label_emailtocloudcc_redmessage8":`Błąd parametru, prosimy o kontakt z administratorem.`,
"label.object.create.two.number.field":`Dla jednego obiektu można utworzyć do 2 własnych pól Autonumer.`,
"label.salecommit.not.roleinformation":`Użytkownik nie ma przypisanych żadnych ról i nie może przeglądać pulpitów nawigacyjnych dotyczących zaangażowania w sprzedaż.`,
"label.defautline.cannot.less":`Domyślna liczba wierszy nie powinna być mniejsza niż 1.`,
"label.selectedproducts":`Liczba wybranych produktów`,
"label.productsales.today.notskadd":`Nie ma żadnych wygasających zadań, możesz kliknąć " " w prawym górnym rogu aby dodać nowe zadanie.`,
"lable.account.year.stadate":`Rok budżetowy Data rozpoczęcia`,
"label.mobile.phone.month.plan2":`Zadania na ten miesiąc`,
"label.ccpeakfolder":`Teczki klasowe`,
"setup_mainpage_label_welcome21":`Platforma chmurowa CloudCC udostępnia funkcję definiowania przez użytkownika szablonów wiadomości e-mail, co jest wygodne dla użytkowników i zwiększa wydajność pracy.`,
"label.modify.layout":`Edytuj układ`,
"report.label.folder":`Foldery`,
"label.tianyancha.businessverify.rewritename":`Nazwa rachunku rezerwowego`,
"lable.currencyAdv.dao":`do`,
"label.mobilelayout":`Układ mobilny`,
"label.the.current.model.is.enabled.and.cannot.be.edited.":`Bieżący model jest aktywny i nie można go edytować.`,
"label_partner_all_disable":`Wyłącz`,
"label.ownerapproverfield":`Zatwierdzający Pole właściciela`,
"label.emailobject.template.message4":`Niektóre pola w wiadomości są puste, proszę edytować i wysłać ponownie!`,
"label.productsales.today.notsk":`Nie ma zadań, które wygasają.`,
"label.multilang.document.upload.success":`{0} pliki zostały przesłane pomyślnie, a {1} pliki nie zostały przesłane.`,
"label.manageAll.sta3":`Odrzucony`,
"vue_label_calendar_week_view":`Kalendarz - widok tygodniowy`,
"setup_layout_label_nocustompage":`Brak niestandardowych stron`,
"label.weixin.wdyj.jxdcl":`Wskaźnik realizacji osobistych osiągnięć`,
"label.donot.update":`Nie masz pozwolenia na modyfikację!`,
"setup.mainpage.label.welcome14":`Zarządzanie procesami dostosowywania przepływu pracy, zatwierdzania`,
"UG_Campaign_002":`Planować, realizować i monitorować skuteczność działań rynkowych.`,
"label.layout2":`Układ drugi`,
"label.app.looup":`Znajdź aplikacje`,
"label.projectManagement.selectitem":`Proszę wybrać projekt`,
"label.field.relating.rule":`Reguły asocjacji pól wyszukujących`,
"vue_label_commonobjects_detail_selectname":`Proszę najpierw wybrać imię`,
"front-email-payment-Invoice-select-pay":`Wybierz opcję Zapłać przez:`,
"label.customfields.formula.numberexample":`Fahrenheit = 1.8 * Celsius__c 32`,
"component_event_label_enddate":`*Godzina zakończenia`,
"label.partnerCloud.partnerAccount.lineOfCredit":`Limit kredytowy`,
"label.chatter.newpost":`Ostatnio opublikowany post`,
"label.report_dashboard":`Ten raport zostanie zapisany w Twoich raportach. Możesz go również dodać do pulpitu nawigacyjnego.`,
"label.assigned":`Przypisany do`,
"Homepage_News_002":`Komponent wiadomości nie jest obecnie dostępny.`,
"label.approval.select.relatedobj":`Aby wybrać odpowiednią pozycję, musi wybrać typ`,
"label.service.miniProgram.isTop":`Sticky on Top`,
"message.error.object.datatoolang":`Długość danych jest zbyt duża, maksymalna długość znaków {!length}.`,
"label.importsourcetip":`Importowanie jest przeznaczone do przyjmowania plików powstałych w wyniku naszego procesu eksportowania. Jeśli jeszcze nie dokonałeś eksportu, przejdź teraz na stronę eksportu.`,
"label.select.deadlineplease.deadline":`Proszę wybrać termin.`,
"vue_label_account_equityrelationship":`Stosunek kapitałowy`,
"label.account.Calendar.month":`Miesiąc kalendarzowy`,
"label.appointment.wizard.subtitle3-4":`Czwartek`,
"font-evaluate-module-v1-smaller-500":`Plik powinien mieć rozmiar mniejszy niż 500 KB`,
"label.reportsSubscriptionPage.email.tome":`Wysłane do mnie`,
"label.ccchat.person.invite.existpers":`Już namierzam:`,
"label.appointment.wizard.subtitle1-3":`30 min`,
"front-kefu-moudle-connected":`Podłączony`,
"label.campaignmember.main.duplicatelist.tip":`System będzie wyszukiwał zduplikowane leady i członków kampanii w oparciu o wprowadzone tutaj ustawienia.`,
"label.visualpage.such.tags.double":`Te znaczniki pojawią się w parze`,
"label.sendsms.batch.step2.introduce":`Proszę wybrać szablon SMS.`,
"Account_News_Setting_002":`Użyj poniższych ustawień konta, aby określić domyślne zachowanie konta dla Twojej organizacji.`,
"message.encryptchange.alert":`Zamierzasz przekonwertować {{!fieldapi}} z pola tekstowego zaszyfrowanego (Szyfrowanie zapisu) na pole tekstowe zaszyfrowane (Wyświetlanie zaszyfrowane), po udanej konwersji to pole będzie przechowywane w bazie danych w postaci tekstu jawnego, który może być wyświetlany w postaci tekstu jawnego lub zaszyfrowanego zgodnie z ustawieniami profilu. Pola są przeszukiwalne. Ta operacja jest nieodwracalna, czy chcesz kontynuować?`,
"label.mainpageset.description":`Skonfiguruj swoją stronę główną na poziomie organizacji w oparciu o rzeczywiste potrzeby biznesowe.<br>Komponenty w domyślnej konfiguracji, które nie są istotne dla Twojej firmy, mogą zostać wyłączone lub zablokowane.<br>Włącz: włączone komponenty są wyświetlane na stronie głównej wszystkich członków.<Wyłącz: wyłączone komponenty nie są wyświetlane na stronie głównej wszystkich członków, ani nie będą wyświetlane na liście "Configure My Homepage" w aplikacji.<br>Wyłącz: wyłączone komponenty nie są domyślnie wyświetlane na stronach głównych wszystkich członków, a użytkownicy mogą je włączyć przez "Configure My Homepage" w aplikacji.`,
"label_tabpage_linknamez":`Nazwa związku`,
"label.companyname":`CloudCC.com Sp. z o.o. Co`,
"label.currency.current":`Obecna waluta korporacyjna`,
"label.campaignmember.main.duplicatelist.html.title":`Ustawienie usuwania duplikatów poprzez skanowanie kodu`,
"label.sendsms.batch.step3.plan":`Data realizacji Plan`,
"label.profile":`Profil`,
"label.canceluploadfile.step":`Kliknij przycisk Anuluj, aby anulować wszystkie pliki wyświetlane w górnym obszarze`,
"message.newreport":`Nowe sprawozdanie`,
"label.service.newBuildDialog.date.selection":`Wybierz datę`,
"label.lookup":`Lookup`,
"label.file.editinfo":`Edytuj szczegóły pliku`,
"component_assistant_label_nodata":`Dziś nie ma imprezy, sprawdź później.`,
"label.tianyancha.businessverify.msg4":`Funkcja ta korzysta z usług stron trzecich i jest obecnie dostępna dla użytkowników za darmo, ale CloudCC nie gwarantuje, że strony trzecie zawsze będą świadczyć usługę użytkownikom za darmo. Jeśli strony trzecie pobierają opłaty, CloudCC ma prawo pobrać opłatę lub uniemożliwić użytkownikowi korzystanie z tej funkcji.`,
"label.noequal":`!=Nie równa się`,
"vue_label_metric_column":`Tabela musi mieć co najmniej 1 kolumnę oceny.`,
"label_reportType_chose_and_form":`Wybierz źródło danych raportu i format raportu`,
"vue_label_pool_reasondescription":`{0} opis przyczyny`,
"label.isusing":`Aktywny`,
"label.passwordPolicy.setup.pwdremember5":`5 zapamiętanych haseł`,
"label.cancel":`Anuluj`,
"vue_label_helpcenter_detail1.1":`Można również przeglądać i zarządzać danymi związanymi z rekordem poprzez listę powiązań. Można również przeglądać i zarządzać danymi powiązanymi z rekordem poprzez listę powiązanych.<br> 1. Przeglądaj i zarządzaj pojedynczą porcją danych<br>Możesz edytować, kopiować, usuwać lub udostępniać dane innym pracownikom za pomocą przycisków w prawym górnym rogu.<br>Przeglądaj szczegółowe informacje o użytkowniku, i możesz bezpośrednio edytować niektóre pola na stronie, aby zmienić właściciela lub typ rekordu danych.<br>Przeglądaj i zarządzaj danymi związanymi z rekordem poprzez powiązaną listę. Na liście powiązanych plików, przesłać nagrany plik lub kliknij nazwę pliku, aby pobrać i wyświetlić odpowiedni plik.<br> 2. Powiązane listy<br>Szybko połącz się poprzez powiązaną listę i użyj pływającego okna, aby wyświetlić do 10 powiązanych rekordów. Kliknij, aby wejść do widoku listy, wyświetlić wszystkie powiązane rekordy i edytować inline.<br>Użyj układu karty, aby wyświetlić i zarządzać powiązanymi rekordami poniżej.<br> 3. 3. Działania<br>Na stronie szczegółów zapisu wersja Lightning nie wyświetla dwóch powiązanych list "nieprzetworzonych działań" lub "historii działań". Zamiast tego wyświetlana jest oś czasu aktywności.<br>Osiem czasu aktywności wyświetlanie treści<br>Osiem czasu aktywności może wyświetlać wszystkie działania, które od przyszłości do przeszłości w bieżącym rekordzie. Zaległe zadania oraz nadchodzące zadania i zdarzenia są wyświetlane w module "Zaległe i nadchodzące" na osi czasu zdarzenia. Przeszłe lub aktualnie zakończone zadania, zdarzenia, nagrane rozmowy, e-maile i wiadomości tekstowe będą wyświetlane w odpowiednim miesiącu.<br>.`,
"registration.page.preview":`Podgląd strony rejestracyjnej`,
"label.quickbooks.search":`Szukaj`,
"label.setup.mobile.bottombutton.tab.show":`Wyświetlanie zakładek na dole`,
"lable.want.to.delete.tem":`Czy na pewno chcesz usunąć szablon raportu serwisowego {currentTelmplateName}?`,
"label.multilang.fielddtrack.dealkey":`Zmień {0} z {1} na {2}.`,
"vue_label_pool_return":`Powrót`,
"vue_label_calendar_failed_to_share_calendar":`Nie udało się udostępnić kalendarza`,
"label.less":`< Mniej niż`,
"label.email.form.html":`Html`,
"label.tag.nodata":`Brak zapisów`,
"label.setarticlecon":`Określ kryteria wejścia`,
"label.searchlayout.displayrow":`Kolumny do wyświetlania`,
"label.change.task":`Widok zadań`,
"lable.quote.editqtpdt.title":`Edycja pozycji kosztorysu`,
"label.appointment.wizard.subtitle4-4":`Jak daleko w przyszłość ktoś może cię zarezerwować?`,
"label.custom.page.button.css":`Przycisk CSS`,
"label.input.documentmessage":`Podaj szczegóły`,
"vue_label_commonobjects_detail_email_address":`Adres odbiorcy`,
"label.chatter.filterTimeLine":`Linia czasowa filtrowania`,
"label.must.select.twoorthree.records":`Musisz wybrać dwa lub trzy rekordy do połączenia`,
"label.mobile.setup":`Konfiguracja aplikacji mobilnej`,
"vue_label_commonobjects_detail_key_field":`Pola kluczowe`,
"label.chatter.relateitem":`Related To`,
"label.customobjects.tip":`Po utworzeniu obiektu niestandardowego można utworzyć zakładkę niestandardową, niestandardowe listy powiązane, raporty i pulpity nawigacyjne dla użytkowników, aby umożliwić im interakcję z danymi obiektu niestandardowego. Dostęp do danych obiektu własnego można również uzyskać poprzez API.`,
"label.sso.saml.idp.config":`Dostawca tożsamości`,
"label.knowledgebase.affect.article.version":`Czy modyfikacja wpłynie na istniejące tłumaczenie? Jeśli tak, można oznaczyć tłumaczenie jako "Wygasłe" i wygenerować listę tłumaczeń oczekujących na tłumaczenie dla dostawców.`,
"message.error.record":`Nie znaleziono odpowiedniego rekordu!`,
"message.duplication.label.fieldname":`Pole`,
"setup.layout.button.cancel":`Anuluj`,
"label_radar_map_function":`Użyj wykresów radarowych z wieloma metrykami, aby zmierzyć rolę kontaktów w łańcuchu decyzji sprzedażowych.`,
"label.campagin.roi.fss":`Num Wysłane`,
"label.emailobject.template.giveup":`Anuluj`,
"label.apiname.exists":`Nazwa API już istnieje.`,
"message.failtoreaddata":`Nie udało się odczytać danych`,
"label.file.versionedit":`Modyfikator zawartości`,
"template.report.lost.business.opportunity":`Stracone okazje`,
"label.ccchat.group.allowgd":`Zezwalaj grupom na archiwizację`,
"label.fieldaccesslimit":`Dostępność pola`,
"label_target_model":`Model docelowy`,
"message.validation.isnoturl":`Nieprawidłowy adres URL`,
"servicecrew.member.time.conflict":`W tym przedziale czasowym zasoby serwisowe stały się członkami innych zespołów serwisowych.`,
"label.knowledgebase.delete.details":`Spowoduje to usunięcie wszelkich informacji o przypisaniu.`,
"vue_label_normal_bottom":`Na dole`,
"label.custombutton.editerror":`Edycja nie powiodła się`,
"label.dashboardSetup.showdw.d6":`Automatyczny`,
"message.error.field.decimalPlaces":`Błąd dziesiętnego formatu danych wejściowych.`,
"label.tabpage.busoppnamez":`Nazwa możliwości biznesowych`,
"label.insertfield.intro":`Proszę wybrać pole i kliknąć "Wstaw". Przy pomocy ">" oznacza kliknij, aby zobaczyć więcej dostępnych pól.`,
"setup.layout.label.nocustompage":`Brak niestandardowych stron`,
"front-gantt-module-project-has-only":`Ten projekt ma tylko {n} kamieni milowych`,
"label.weixin.fmu.am":`{0} AM`,
"label.emailsync.status.connectaccounts":`Podłączone konto e-mail`,
"label.customcomponent.check.name.same":`Ta nazwa już istnieje.`,
"label.validate.function.funcFormat.HOUR":`GODZINA(data)`,
"label.approvepagelayout4":`Kopiuj poprzedni układ strony`,
"label.knowledge.category.hint.nine":`Aktywuj grupę kategorii`,
"label.report.sorting.column":`Sortowanie kolumnowe`,
"label.hours":`Zegar`,
"label.email.clearAllemail":`Czy chcesz opróżnić wszystkie zsynchronizowane wiadomości e-mail w skrzynce pocztowej?`,
"font-evaluate-module-v1-satisfaction":`Ocena dostateczna`,
"label.service.hide.more.info":`Ukryj więcej informacji`,
"label.area.list.intro":`Możesz edytować informacje o terytorium na tej stronie.`,
"label.sendemail.chat.addPostat":`Drogi #name:witaj! #userName wspomniał o Tobie w mikropostu.`,
"label.data.newtemplate.e_seltype.desc":`Istnieją dwa rodzaje danych pochodnych</li><li class="titledesc1">1.jeden to format CSV (domyślny)</li><li class="titledesc1">2.drugi to format kompresji. Tryb formatu kompresji jest podzielony na dwa rodzaje</li><li class="titledesc1">2.1.jeden rodzaj jest automatyczne generowanie skompresowanych plików hasło, automatycznie generowane hasło zostanie wysłany do użytkownika po pomyślnym eksportu danych skrzynki pocztowej</li><li class="titledesc1">2.2.inny jest ręcznie wprowadzić hasło skompresowanych plików, ręcznie hasło wejściowe nie zostanie wysłany do użytkownika skrzynki pocztowej, więc potrzeba dla użytkowników do zapamiętania hasła.Jeśli nie wprowadzisz, domyślnie nie ma hasła.`,
"message.passwordPolicy.validate.minlengths":`Błąd:Twoje hasło musi być co najmniej`,
"message.save":`Czy na pewno chcesz oszczędzać?`,
"label.marketsea.notfollowdays1":`Po uzyskaniu`,
"label.app.step1":`Krok 1 Wybierz typ`,
"message.error.pageid.null":`Facebook social media ID nie może być pusty!`,
"label.weixin.input.lookupfield":`Wpisz słowa kluczowe, aby znaleźć pasujące mikro głosowanie`,
"label.whChatAccount":`Konto WeChat`,
"label.tabpage.groupingitem":`Element grupujący`,
"label.callboard.introduce":`Wszystkie ogłoszenia Państwa firmy znajdują się na poniższej liście.`,
"label.financial.services.seminar":`Seminarium planowania finansowego`,
"label.data.file.i_title.num1":`1. Importowany plik musi być plikiem w formacie CSV. Plik musi zawierać tytuł i nie może być importowany bez tytułu.`,
"label.visualpage.filename.exist":`Nazwa pliku już istnieje.`,
"front-kefu-moudle-v1-new-chats":`Nowy agent`,
"label.console.step5.tab":`karta otwarta`,
"vue_label_opportunity_contactrole_edit":`Edytuj role kontaktu`,
"label.projectManagement.delete.return":`Po usunięciu ostatnich danych nastąpi powrót do poprzedniej strony.`,
"registration.page.designs":`Ustawienia wyglądu dla strony rejestracji`,
"label.console.step6.heigth":`Wysokość`,
"label.objectRelationshipAtLeast":`mają co najmniej jeden zapis związany z`,
"label.knowledge.delete.viewstat":`Erroe podczas usuwania danych przeglądania artykułu wiedzy`,
"label.direct.dashboard.month.report":`Nowa miesięczna notatka robocza`,
"label_tabpage_lookatmorez":`Zobacz więcej`,
"label.setup.rights.management":`Zarządzanie uprawnieniami`,
"label.campaign.channel.clear.img":`Wyraźny obraz`,
"label.calendar":`Kalendarz`,
"label.biaoqingfaxian.username":`Konto`,
"label.weixin.wdyj.jxht":`Osobiste-wyniki sprzedaży-umowy`,
"label.emailtocloudcc.exists1":`Ta skrzynka pocztowa została ustawiona na Email to Lead. Nie powtarzaj ustawień.`,
"label.emailtocloudcc.filed.password":`Hasło`,
"label.what_create":`Jaki rodzaj formy chcesz stworzyć?`,
"vue_label_report_onlydisplaypart":`Można wyświetlić maksymalnie 50 danych, a po uruchomieniu wyświetlić wszystkie dane.`,
"label.up":`Do góry`,
"label.addattachment.edit":`Załącznik Edytuj`,
"label.ccchat.message.search.desc5":`Wyszukiwane słowa nie mogą mieć mniej niż 2 znaki`,
"label.chose.nonotice":`Proszę wybrać zapis, który już nie przypomina Ci o sobie`,
"UG_activity_06":`Chęć kontynuowania współpracy z klientami`,
"label.set_contactsmarketing":`Ustaw jako Kontakt kampanii`,
"pagecreator.layout.button.horizontal":`Demontaż boczny`,
"label.brief.opportunity2":`Szanse, które mają się zamknąć`,
"label.ems.nomsg":`Nie ustawiony`,
"label.fieldupdate.tip":`Aktualizacje pól pozwalają na automatyczną zmianę wartości pola na określoną przez użytkownika. Aktualizacje pól są akcjami związanymi z regułami przepływu pracy i procesami zatwierdzania.`,
"label.sso.saml.sp.federationid":`ID Federacji`,
"label.import.page2.suited":`Mapowany`,
"message.error.appexchange.integrity":`Zapewnij integralność komponentów w pakiecie do przesyłania danych.`,
"label.fielddatatype":`Pole Typ danych`,
"message.approval.cannotsubmit.detail2":`Rekord musi spełniać poniższe kryteria lub formuła musi być prawdziwa, w przeciwnym razie prośba o zatwierdzenie nie może zostać wysłana, prosimy o ponowne złożenie wniosku po modyfikacji.`,
"vue_label_commonobjects_detail_cloud_as_a_user":``,
"label.summaryreport.selectlinetogroup":`Wybierz kolumnę, na której oparte jest grupowanie raportu`,
"label.tabpage.norecordtypez":`Typ rekordu niemożliwy do wykorzystania`,
"label.icon.141":`Waluta`,
"label.addattachment.step3.intruduce":`Jeśli wysyłasz dane, anuluje to trwające wysyłanie.`,
"label.trigger.recursive.call.three":`Wyzwalacze mogą być wywoływane interakcyjnie, ilość pętli jest ograniczona do 3 razy, jeśli więcej niż 3 razy system wyświetli komunikat o błędzie.`,
"maintenanceplan.workorder.type.asset.workorder":`Proszę wybrać "Jedno zlecenie dla każdego składnika aktywów" jako typ generowania zlecenia.`,
"label.emailtocloudcc.select1":`Proszę wybrać`,
"label.system.log":`Dziennik audytu konfiguracji`,
"vue_homepage_dashboard_not_support_fullscreen":`Przepraszamy, Twoja przeglądarka nie obsługuje pełnego ekranu.`,
"label.projectManagement.nodata.resource":`Nie jest jeszcze zaangażowany w żaden projekt. Dodaj "Moje" informacje o projekcie do członków, aby zobaczyć przydział czasu dla członków zespołu.`,
"label.exchange.sync.state.contact":`Kontakty`,
"label.field.type":`Typ pola`,
"label.selected.object":`Wybrany Obiekt`,
"label.customfields.new.step2":`Krok 2 Wprowadź szczegóły`,
"label.monitorsys.delete.style":`Typy operacji`,
"label.projectcondition":`Kryteria wejścia`,
"potential.customers.field.default":`Domyślne ustawienie przewodów`,
"message.password.nosame":`Hasła nie pasują do siebie.`,
"label.validate.function.funcExplain.MONTH":`Zwraca miesiąc, który jest liczbą z przedziału od 1 (styczeń) do 12 (grudzień)`,
"label.project.user.project.count":`Liczba projektów, w których uczestniczyli użytkownicy`,
"chatter.to":`do`,
"vue_label_commonobjects_detail_activity_owntask":`posiadane zadanie`,
"label.generate.mobile.page":`Strona mobilna została ukończona.`,
"label.escalation.setup.newentries.step1":`Krok 1 Ustaw kolejność, w jakiej będą przetwarzane wpisy tej reguły`,
"label.email_footer":`Stopka email`,
"label_partner_workspace_member_profile":`Dostępne profile`,
"label.loginhis.between":`Data początkowa odległość data końcowa nie może przekraczać 2 miesięcy`,
"label.user.verficationcode.error":`Nieprawidłowy kod weryfikacyjny.`,
"label.email_notifications":`Wyślij powiadomienie email o złożeniu wniosku`,
"APPIntegration_Dropbox_01":`Wybierz pliki z Dropbox`,
"label.projectManagement.Selectweek":`Wybierz tydzień`,
"wednesday":`Środa`,
"message.atleastonereceiver":`Proszę wybrać jednego odbiorcę, co najmniej`,
"label.applt.link.text":`Podłączyliśmy Twoją firmę do mini programu portalowego. Skopiuj adres portalu z mini programem dedykowanym Twojej firmie, umieść adres mini programu w linku przeskakującym do oficjalnego menu Twojej firmy, następnie klienci mogą kliknąć na menu, aby skorzystać z mini programu. (Oficjalne menu konta < Skok do mini programu< Ścieżka do mini programu)`,
"label.wait.for.a.moment":`Proszę chwilę poczekać na ustawienie języka...`,
"vue_label_chatter_only_group_members_look":`Tylko członkowie grupy mają dostęp do widoku, możesz spróbować ubiegać się o dołączenie do grupy`,
"label.knowledgebase.last.release":`Ostatnio opublikowane`,
"component.setup.label.pagesize":`Pozycje na stronie`,
"label.paging.totalofpages":`Łącznie {0} stron`,
"label.globaloperation.successmessage":`Komunikat o powodzeniu`,
"label.logout":`Wyloguj się`,
"label.partner.common.enable":`Włączenie chmury partnerskiej`,
"label.permission.objectpermission.goback":`Powrót do listy: Zestawy uprawnień`,
"label.approvalstep5.required":`Wymagany`,
"component_chatter_label_to":`Do`,
"message.please.choose.role":`Proszę wybrać rolę`,
"maintenanceasset.servicecontract.contractlineitem.illegal":`Należy wybrać pozycję umowy w ramach umowy serwisowej powiązanej z planem konserwacji.`,
"label.projectManagement.Resource.usage.view":`Widok wykorzystania zasobów`,
"label.smsmainbody":`Tekst wiadomości`,
"label.ccchat.error.nullname":`Nazwa jest wymagana`,
"label.appupload.upload.version":`Numer wersji`,
"label.data.setok.t_desc2":`Powrót do strony z szablonami danych`,
"vue_label_pool_allocationstatus":`Status przydziału`,
"label.tianyancha.orgapprovedinstitute":`Instytut zatwierdzony przez org.`,
"label.quickbooks.searchlist.startdate":`Data rozpoczęcia`,
"label.setapp":`Ustawienia aplikacji`,
"chatter.about":`O mnie`,
"label.layoutname":`Nazwa układu strony`,
"label.icon.160":`Ziemia`,
"label.tabpage.Rolesz":`Role i podwładni`,
"label.console.step5.introduce":`Wybierz sposób wyświetlania`,
"label.customfields.totalsummary.gettogetherfield":`Pole do agregacji`,
"message.appexchange.addtopackage.profile":`W pakiecie może być dodany tylko jeden element profilu!`,
"vue_label_file_user_header_pic":`Avatar`,
"font-trade-module-v1-invoice-detail-price":`Płatności szczegółowe`,
"homepage.components.three":`Krok 3 Wprowadź zawartość ekranu komponentów niestandardowych`,
"nine":`Dziewięć`,
"label.marketsea.button.restore":`Przywróć`,
"label.forecast.editshrepage.desc2":`Indywidualne udostępnianie może być wykorzystywane jedynie w celu przyznania większego dostępu do danych, a nie w celu ograniczenia dostępu.`,
"label.cloudccsite.list":`Strony`,
"label.icon.35":`Chmura`,
"vue_label_pricebook_price":`Dodaj cenę standardową`,
"label.version.sum.addressfield":`Pole(-a) adresowe`,
"label.projectManagement.Gotomilestone":`Przejdź do kamienia milowego`,
"label.dataimport.name.length":`Błąd: długość nazwy jest zbyt duża.`,
"label_alculation_method":`Metoda kakulacji`,
"label.uploadfile":`Prześlij plik`,
"label.ems.otheraccount":`Inne konto`,
"vue_label_commonobjects_detail_group_opportunitystrategy":`Czy na pewno chcesz dołączyć do tego zespołu?`,
"message.error.chatter.img.nodata":`Error: plik obrazu nie istnieje i nie może zostać przechwycony.`,
"component.chatter.file.button.files":`Wybierz dokument`,
"label.salescloud.teamrole.optionlist.choose.null":`Nazwa roli jest wymagana`,
"label.yourexportsuc":`Twoja prośba o eksport została przetworzona, proszę zobaczyć wiadomość e-mail.`,
"pagecreator_systemstyle_label_modifycolor":`Edytuj kolor`,
"label_partner_setup_title":`Ustawienia`,
"label.chat.topic.topic":`Temat`,
"file.error.nottype":`Błąd: nieprawidłowy typ. typy plików, które można załadować to txt, doc, excel, ppt, pdf, jpg, jpeg!`,
"label.all_time":`Cały czas`,
"homepage_componet_approval_label":`Punkty do zatwierdzenia`,
"label.partnerCloud.financeSetting.merchantNumber":`WeChat Pay Merchant No.`,
"label.user.resetpw":`Resetuj hasło`,
"label.exchange.sync1":`Po skonfigurowaniu konta usługi z uprawnieniami do podszywania się pod użytkowników w Microsoft©Exchange, wprowadź dane uwierzytelniające konta usługi, aby umożliwić CloudCC komunikację z serwerem Exchange.`,
"label.import.index.editfield":`Edycja mapowania pól`,
"and":`I`,
"label.partnerCloud.cloudInfrastructure":`Podstawowa konfiguracja Partner Cloud`,
"label.escalation.setup.newentries.createdate":`Gdy sprawa jest tworzona`,
"Pagelayout.Setup.002":`Wybrałeś 3 listy powiązane, a dodanie większej ilości list powiązanych będzie miało wpływ na układ strony.`,
"label.customfields.file.tip":`Zezwolenie użytkownikowi na przesłanie pliku o rozmiarze od 1 do N.`,
"label.tianyancha.businessverify.accname":`Zapytanie o nazwę klienta w czasie rzeczywistym`,
"label.Additional.Conditions":`Termin serwisu filtrów zgodnie z dodatkowymi warunkami.`,
"label.emailtocloudcc.filed.type":`Dostawca`,
"vue_label_homepage_fixedcomponents":`Składnik standardowy`,
"label.visualpage.delerror":`Usunięcie nie powiodło się, proszę spróbować ponownie później.`,
"label.tabpage.filetypez":`Typ pliku`,
"label.emailobject.search.input":`Szukaj`,
"label.createprocessstep2":`Krok 2 Określenie kryteriów wejścia`,
"label.weixin.inhead":`Przetwarzanie`,
"component.recdetail.label.title":`Szczegółowe informacje`,
"label.weixin.telephone":`Numer telefonu`,
"label.web.link":`Link internetowy`,
"label.partnerCloud.paySuccess":`Zapłacone z powodzeniem`,
"label.case.adress.link":`Internetowy Portal Obsługi Klienta`,
"label.emailobject.view.connectopp":`Emaile związane z otwartymi możliwościami`,
"front-kefu-moudle-think-again":`Pozwól mi myśleć jeszcze raz`,
"label.Button":`Przycisk`,
"chatter.pt.most":`Maksymalna wielkość pliku to 20 MB.`,
"label.service.newBuildDialog.numberdays.horizontal":`Dni przed datą poziomu`,
"label.ems.relatedobj":`Obiekt powiązany`,
"label.notification.insert.approval":`[提交人] przesyła [对象] do zatwierdzenia.`,
"label.setting.codeSet":`Zestaw kodów`,
"vue_label_report_rowlevelformula":`Formuła na poziomie wiersza`,
"label.validate.function.funcFormat.TIMENOW":`CZAS()`,
"label.copyright":`Copyright © 2008-2022 CloudCC Inc. Wszelkie prawa zastrzeżone.`,
"component.setup.button.save":`Zapisz`,
"label.emailsync.button.sure":`Potwierdź`,
"label.multilang.dupicatecheck.getdatalist":`W {0}-tej grupie zduplikowanych danych, znajduje się łącznie {1} rekordów:`,
"label.ccchat.person.invite.tochat":`Zaproś ludzi do CCChat`,
"label_partner_all_maxNum":`Maksymalna ilość danych z chmury partnera:`,
"label.checkfield":`Ustawienia pola do wyszukiwania duplikatów`,
"label.sales.dashboard.income":`Cel w zakresie dochodów`,
"label.setup":`Ustawienie`,
"label.dashboardSetup.center":`Middle`,
"lable.quote.syncing.finished":`Sync Completed`,
"vue_label_helpcenter_dashboard1":`Aby pomóc Ci wyświetlać dane statystyczne bardziej intuicyjnie, CloudCC Sales Cloud Lightning dashboard zapewnia potężne możliwości tworzenia wykresów.<br> CloudCC Sales Cloud Lightning wersja dashboard ma następujące cechy<br>Możliwość korzystania z różnych źródeł danych: można wybrać oryginalne dane w widoku pod obiektem jako źródło danych, lub można wybrać dane po raporcie jest przetwarzany jako źródło danych<br>Aż 13 rodzajów szablonów wykresów do wyboru: wsparcie lejek sprzedaży, miernik wskaźnika, wykres kołowy, wtórne zgrupowane histogram, itp. <br> Swobodnie przeciągnij i upuść, aby zmienić rozmiar i położenie wykresu: deska rozdzielcza może odróżnić ważne dane i dane pomocnicze poprzez umieszczenie pozycji i wielkości różnych wykresów, które są całkowicie do Ciebie<br>Dashboard ogólne filtrowanie: Pulpit nawigacyjny obsługuje filtrowanie wbudowanych danych wykresu za pomocą pól filtrowania ustawionych według zakresu czasu i użytkownika<br>Buforowanie danych: dane wykresu pulpitu nawigacyjnego mogą być buforowane podczas pierwszego utworzenia, zmniejszając czas ładowania wtórnego. <br>Penetracja komponentów: Można przejść do odpowiednich szczegółów raportu lub listy rekordów w odpowiednim widoku obiektu, klikając komponent<br>Powiązanie komponentów: W tym samym pulpicie nawigacyjnym komponent może skonfigurować inne komponenty tego samego źródła danych do interakcji z samym sobą. Klikając na obszar danych w komponencie, inne komponenty mogą być ustawione na ponowne zliczanie danych zgodnie z warunkami filtrowania tego obszaru danych<br> 1. Tworzenie nowego pulpitu nawigacyjnego<br> Jako przedstawiciel handlowy lub kierownik działu sprzedaży możesz wyświetlać dane dotyczące sprzedaży, tworząc pulpity nawigacyjne. Wersja Lightning oprogramowania CloudCC Sales Cloud zapewnia bogate możliwości tworzenia pulpitów nawigacyjnych<br>Uwaga: Dane pulpitu nawigacyjnego w wersji Lightning i starej wersji pulpitu nawigacyjnego nie są interoperacyjne. <br> Kliknij zakładkę "Dashboard", kliknij "New Dashboard", wypełnij nazwę dashboardu i wybierz folder, w którym chcesz zapisać ten dashboard. Możesz wprowadzić nową tablicę rozdzielczą.`,
"label.layout.availabletab.trackrecord":`Rekordy trasy`,
"label.campaignmember.main.deletecontact":`Usuń istniejące kontakty członków`,
"lable.outlook.mcto.emaltoc":`Kiedy e-maile są wysyłane do CloudCC.com`,
"label.setup.mobile.offlinecache.savesuccess":`Ustawienia pamięci podręcznej offline zostały zapisane pomyślnie.`,
"label.timezone.default":`Domyślna strefa czasowa`,
"label.noRules.have.been.enabled":`Brak włączonych zasad.`,
"label.ccchat.person.invite.existsend":`Niektóre z wprowadzonych adresów e-mail odpowiadają istniejącym użytkownikom.`,
"label.work":`Praca`,
"actualstarttime.actualendtime.time.illegal":`Rzeczywisty czas rozpoczęcia wizyty serwisowej powinien być krótszy lub równy rzeczywistemu czasowi zakończenia.`,
"lable.product.stsp":`Konfiguracja Cena standardowa`,
"vue_label_normal_account_sf":`Konto`,
"label.finishpic":`Generowane wykresy`,
"label.h5.similar.opportunity.step3":`Krok 3 Wybierz pola do wyświetlenia dla podobnych możliwości`,
"label.relateobjDefault":`Zapis domyślny`,
"label.customcomponent.check.tag.endwith":`Składnik musi kończyć się etykietą`,
"label.related.organization":`Powiązane możliwości`,
"label.recordtype.edit.selectvalue.orderby":`Opcja Lista wartości Sortowanie`,
"vue_label_homepage_enter_name":`Proszę wpisać nazwę`,
"label.permission.group":`Grupy uprawnień`,
"label.emailobject.send":`Wyślij`,
"label.ralateuser":`Użytkownicy powiązani`,
"label.validate.function.funcFormat.ADDMONTHS":`ADDMONTHS(date,num)`,
"label.tablayoutedit.remark2":`Wybierz pola wyświetlane na stronie głównej zakładki.`,
"setup_mainpage_label_welcome3":`Tworzenie formularzy w platformie chmurowej CloudCC opiera się na niestandardowych bazach danych (obiektowych), obiekty zdefiniowane przez użytkownika to tabele bazy danych, które przechowują dane specyficzne dla Twojej organizacji. Relacje między tabelami mogą być łatwo utworzone bez konieczności tworzenia programu.`,
"label.user.notallowed.login.scope":`Nie możesz zalogować się w określonym czasie lub Twój IP jest ograniczony.`,
"label.tel.ten.case":`Można wprowadzić do 10 numerów telefonów, na które mają przychodzić powiadomienia, każdy numer jest oddzielony znakiem ",".`,
"front-kefu-moudle-v1-user-info":`Informacje dla użytkownika`,
"label.aboutme":`O mnie`,
"label.setfieldediting.tip":`Podczas definiowania kroków zatwierdzania, możesz przypisać żądania zatwierdzenia do różnych użytkowników. Jedną z opcji jest użycie pola użytkownika do automatycznego kierowania tych wniosków. Jeśli chcesz użyć tej opcji dla któregoś z kroków zatwierdzania, wybierz pole z poniższej listy wyboru. Ponadto, gdy rekord jest w procesie zatwierdzania, zawsze będzie zablokowany - tylko administrator będzie mógł go edytować. Możesz jednak wybrać, aby umożliwić edycję rekordu także aktualnie przypisanemu użytkownikowi.`,
"label.existing_dashboard":`Dodaj do istniejącej tablicy rozdzielczej`,
"label.sendemail.spotsign":`Szanowny #nazwa: członek kampanii #klient, którego zaprosiłeś do #aktywności przybył i zalogował się, proszę zauważyć, że.`,
"UG_solution_01":`Podaj rozwiązanie`,
"label.tianyancha.estiblishtime":`Czas estiblish`,
"label.pc.lightningpage":`Lekka aplikacja (beta)`,
"label.saveAndSync":`Zapisz i zsynchronizuj`,
"label.state.end":`Zakończono`,
"label.sendemail.queue.assigninfo":`Kolejka:[#queueName] przydzieliła #objectName: #recordName`,
"label.approvalprocessname":`Nazwa procesu zatwierdzania`,
"label.view.conditions.message":`Filtrowane przez {!warunki}`,
"label.partnerCloud.financeSetting.alipayCorporate":`Alipay Business Account`,
"label.forecast.detailforecast.de":`s`,
"label.savepayset.failure.nopay":`Proszę skonfigurować co najmniej jedno konto płatności online`,
"label.step1.total6":`Krok 1 z 6`,
"label.appointment.wizard.subtitle4-1-3":`45 min`,
"label.emailobject.markasread":`Oznacz jako przeczytane`,
"message.error.orgid.null":`orgid nie może być pusty!`,
"label.emailtemplate.mergefield":`Wartość pola łączącego`,
"label.weixin.recent.list":`Ostatnio przeglądane listy`,
"label.emailsync.form.email":`E-mail`,
"label.funnel":`Lejek`,
"label.logintime.clear":`Czas oczekiwania`,
"label.chatter.followed":`Followed`,
"label.ccpeak.function.field.spack":`Pola w funkcji muszą posiadać sapsy po obu stronach.`,
"label.setup.mobile.offlinecache.remark":`Po włączeniu tej funkcji, członkowie organizacji mogą tworzyć, edytować i usuwać rekordy będąc offline za pomocą urządzeń mobilnych`,
"label.product.function":`Kategorie pakietów`,
"label.icon.14":`Młotek`,
"message.report.nodata":`Nie zwrócono żadnych danych.`,
"label.please.ChooseMin":`Proszę wybrać co najmniej {a} opcji produktu`,
"label.tabpage.releaseTourz":`Opublikuj przewodnik`,
"vue_label_chat_opportunity":`Zespół Opportunity`,
"vue_label_chatter_refucecertification":`Czy na pewno odmawiasz "{name}", aby dołączyć do czatu zespołu?`,
"label.version.unlimited":`Bez ograniczeń`,
"label.processsetting.enable.prompt":`Po włączeniu, ścieżka do ustawień będzie znajdować się na stronie szczegółów odpowiadającej wersji błyskawicy. Można również najpierw zapisać ustawienia i włączyć je później.`,
"label.page.display.property":`Właściwości wyświetlacza`,
"label.service.appointmentList.thisOption":`Niezaznaczony`,
"label.register.date":`Data rejestracji`,
"label.brief.contract.amount":`Kwota umowy`,
"setup.object.field.dependency.label.actionfieldnotnull":`Proszę najpierw wybrać pole kontrolne.`,
"UG_homepage_009":`Dostęp do CRM`,
"label.icon.98":`Folder`,
"label.weixin.datacount":`Ogółem`,
"label.mobile.hasbind":`Ten numer telefonu komórkowego został już użyty. Ostatnie powiązanie zostanie zwolnione, jeśli będziesz kontynuować powiązanie.`,
"label.emailtemplate.choosemorecontacts":`Wybierz więcej odbiorców`,
"setup_layout_button_deleteitem":`Usuń wybrane elementy`,
"vue_label_account_collection_plan":`Plan zbiórki nieprzetworzonej`,
"label_chatter_maturiyDate":`Data wygaśnięcia`,
"label.emailtocloudcc.license":`Licencja`,
"vue_label_checkduplicate_complete_check_rules":`Proszę wypełnić zasady kontroli duplikatów`,
"chatter.up.type":`Możesz przesłać plik jpg, gif lub png.`,
"label.attendance.nocheckout":`Nie wymeldować się`,
"label.setup.mobile.offlinecache.remark2":`Wybrana zakładka zostanie włączona na urządzeniach mobilnych wszystkich użytkowników w Twojej organizacji jako domyślna zakładka pamięci podręcznej offline. Każdy użytkownik może wyłączyć zakładkę pamięci podręcznej offline w ustawieniach organizacyjnych lub włączyć inne zakładki jako zakładki pamięci podręcznej offline w zależności od swoich potrzeb.`,
"template.report.count.marketing.activities":`Kampania ogółem`,
"label.multilingual.tip4":`Jeśli wielojęzyczność jest wyłączona, domyślny język firmy zostanie ustawiony na chiński lub angielski w oparciu o adres firmy, a język wszystkich użytkowników zostanie ustawiony na domyślny język firmy.`,
"label.settings_area":`Obszar ustawień`,
"label_assessment_content":`Treść oceny`,
"label.top":`Top`,
"UG.Account.06":`Załóż konto`,
"label.emailtocloudcc.step1.case2":`Po skonfigurowaniu, wiadomości otrzymane na tę skrzynkę będą automatycznie rejestrowane jako rekordy spraw w CloudCC. Zgodnie z kontaktem i kontem skrzynki nadawczej, należy powiązać sprawę z odpowiadającym jej kontaktem i kontem, aby ułatwić przyjmowanie i śledzenie spraw.`,
"label.forecast.forehistory.best.remark":`Uwagi dotyczące najlepszych przypadków`,
"label.project.problem.date":`Data wydania musi być zgodna z zakresem dat kamienia milowego lub projektu, do którego należy.`,
"label.forecast.customforecast.foredis.wzs":`Liczby całkowite`,
"message.setup.field.name.value.notexists":`Wprowadzona wartość listy ról zespołowych nie istnieje, wprowadź ją ponownie.`,
"label.salescloud.teamrole.opportunity.organization":`Członkowie zespołu mogą mieć większy dostęp do tej możliwości niż domyślne ustawienia dostępu do możliwości w Twojej organizacji.`,
"label.sms.message.input":`Proszę wpisać wiadomość`,
"label.document.type.not.allow":`Ten typ dokumentu nie może zostać załadowany.`,
"label.customfields.totalsummary.tip":`Pole tylko do odczytu, które wyświetla sumę, minimalną lub maksymalną wartość pola na liście powiązanej lub liczbę rekordów na liście powiązanej.`,
"label.tabpage.filesizez":`Rozmiar pliku`,
"label.import.page2.filedname":`Nazwa pliku`,
"label.same.analyze":`Moja podobna analiza możliwości`,
"label.service.gantt.refreshData":`Aktualizacja danych po odświeżeniu strony.`,
"label.sendsms.batch.step2.sendbycontext":`Wysyłanie za pomocą własnych treści SMS`,
"UG_Account_05":`Schemat struktury styków`,
"label_emailtocloudcc_step1total3":`Krok 1 z 3`,
"label.weixin.no.history":`Brak zapisów historii`,
"label.datamanage.queryfield.error":`Błąd pola zapytania.`,
"label.emailmerge.mergeFolder.emailmerge":`Szablony Mail Merge`,
"label.workflow.estimatecondition":`Kryteria oceny`,
"label.autonumberfield.wrong":`Proszę wpisać liczbę z zakresu 0-{0}.`,
"label.data.setok.t.desc1":`Jeśli chcesz użyć tego szablonu danych pochodnych, proszę kliknąć`,
"label.data.downpage.i.title":`Kroki importu danych:`,
"label.data.downpage.i_list.desc2":`Po zaimportowaniu danych otrzymasz e-mail przypominający o pomyślnym zaimportowaniu danych.`,
"label.opportunity.jieduan":`Obecny etap`,
"vue_label_commonobjects_view_sumby":`Metoda agregatowa`,
"label.knowledge.setting.hint.three":`Możemy przygotować Cię do pracy. Oto, co jest potrzebne do przygotowania:`,
"page.activity.history":`Historia działalności`,
"label.cancelQuoteLineGroup":`Anuluj grupę wierszy cytatu`,
"label.addattachment.batch.step3":`Krok 3 kliknij przycisk, aby zakończyć.`,
"label.chat.topic.follow":`Śledź`,
"label.import.page1.uploadcsvfiled":`Przeciągnij lub kliknij, aby załadować plik CSV`,
"label.batchtransfer.datetype.tip":`Dla pól daty należy wprowadzić wartość w następującym formacie:`,
"vue_label_systemSettings_application_util":`Konsola zarządzania aplikacjami`,
"label.partner.workspace.member.selectedpermission":`Wybrany zestaw uprawnień`,
"label.service.appointmentList.plansToEnd":`Plan końcowy`,
"label.industrialandcommercialverification.contactinformation":`Zadzwoń w sprawie zakupu lub pytań 400-642-2008`,
"chatter.del.p":`Usuń ten post`,
"label.forecast.customforecast.replacefirst":`Zastąpione przeze mnie`,
"Lead.Scoring.Setting.Rule.Setup.RuleName":`Nazwa zasady punktacji`,
"label.weixin.appr.applicant":`Zgłoszony przez`,
"component_event_label_calendar":`Zobacz kalendarz`,
"step":`Krok`,
"label.attendance.setting.position.alert":`Office Worker musi ustawić lokalizację punktu orientacyjnego.`,
"label.end":`Zakończono`,
"label.mobile.change.owner.success":`przeszedł na nowego właściciela`,
"label.chinese":`Chiński`,
"label.textmessage.vonage.account":`Informacje o koncie`,
"front-console-no-related-contact":`Proszę najpierw skojarzyć z kontaktem`,
"label.dashboardSetup.seltype":`Typ komponentu opcjonalnego`,
"chatter.follow.user":`Śledź tego użytkownika`,
"label.textmessage.sentsuccess":`Wysłano pomyślnie`,
"label.australian.gentral.standard.time":`australijski centralny czas letni （Południowa Australia）`,
"label.validate.function.funcFormat.AND":`AND(logiczne1,logiczne2,...)`,
"lable.SalesCommitmentKanBan.contract":`Podpisano:`,
"label.processsetting.basic.settings":`Ustawienia podstawowe`,
"label.escalation.setup.newentries.ifcondtions":`Uruchom tę regułę, jeśli`,
"label.lookup.nofound.data":`Wartość nie istnieje lub nie pasuje do filtra.`,
"vue_label_commonobjects_view_chart_chartname":`Nazwa wykresu`,
"label.dashboard.show.percent":`Pokaż %.`,
"label.sso.saml.sp.userid":`Identyfikator użytkownika`,
"label_tabpage_minutesagoz":`minuty`,
"vue_label_chatter_comment_content":`Proszę wpisać treść komentarza`,
"label.campaign.channel.step6.mobilepc":`Wygeneruj stronę mobilną i PC`,
"vue_label_homepage_editprofilepage":`Edytuj Nazwa`,
"label.tabpage.crecordtypez":`Zmiana typu rekordu`,
"label.social.posts.type.null":`Typ postu nie może być pusty`,
"label.projectManagement.groupbyuser":`Grupowanie według użytkowników`,
"vue_label_email_new_template":`Zapisz jako nowy szablon`,
"label.ems.close":`Anuluj`,
"label.ccdocument.noauthority.folder":`Nie masz uprawnień do korzystania z tego folderu.`,
"message.filterconditionerror":`<strong>Błąd: </strong>Twój filtr błędnie zacytował warunki filtrowania:`,
"label.User.Interface":`Interfejs użytkownika`,
"label_tabpage_greaterz":`Większe niż`,
"vue_label_CCChat_unfollow":`Unfollow`,
"label.selectandcontinue":`Wybierz i kontynuuj`,
"vue_label_commonobjects_detail_influence":`Influence`,
"label.total.have.priority":`jest wcześniejszy`,
"label.manageAll.sta4":`Przypomnienie`,
"label.setup.mobile.offlinecache.setup":`Ustawienia pamięci podręcznej offline po stronie urządzenia mobilnego`,
"vue_label_chatter_cancel_adding":`Anuluj`,
"vue_label_lead_select_existing":`Wybierz istniejące`,
"front-epwechat-module-v1-contacts-sync":`Synchronizacja kontaktów WeCom`,
"label.appupload.component.type.recordtype":`Typy rekordów`,
"label.layout.hint":`Ta strona nie jest dostępna do podglądu. Proszę zapisać i wyświetlić na stronie pierwszoplanowej.`,
"label.change":`Zmiana`,
"setup_layout_label_detailpage":`Szczegółowa strona`,
"label.imgfield.use.tip":`img(docid,width,height), ta funkcja służy do wyprowadzania obrazków, "docid" jest identyfikatorem dokumentu, "width" określa szerokość obrazka (typ Integer może być null), "height" określa wysokość obrazka (typ Integer może być null).`,
"pagecreator.systemstyle.button.edit":`Styl edycji`,
"label.delete_externalpage":`Dane, które chcesz usunąć nie mogą zostać wycofane, proszę potwierdzić ponownie. Formularz nie jest używany na żadnej stronie logowania, ale może być używany gdzie indziej. Na przykład, mogłeś użyć kodu embed, aby wstawić go na zewnętrzną stronę.`,
"font-evaluate-module-v1-open-case":`Wznowienie sprawy:`,
"label_not_adjust":`Brak regulacji`,
"vue_label_title_ordernow":`Zamów teraz`,
"label.notification.serviceappointment.allocation":`Wysłano Ci nowe zlecenie {0}, sprawdź je.`,
"label.objectRelationshipDescription2":`. Można określić, które rekordy powiązane z innymi obiektami będą zwracane w wynikach raportu poprzez wybór relacji z innym obiektem.`,
"vue_label_calendar_notice_createfail":`Nie udało się utworzyć kalendarza`,
"label.ems.step1":`Krok 1`,
"label.ems.password":`Hasło`,
"label.icon.143":`Skarbonka`,
"label.select.year":`Wybierz rok`,
"label.termsforusage.dialog":`Warunki użytkowania (nowe okno)`,
"label.tag.addtags.create":`Utwórz stronę`,
"label.emailobject.groupemail.msg4":`nie zostanie wysłany z powodu nieprawidłowego adresu e-mail.`,
"label.version.sum.autonumberfield":`pole(-a) numeryczne auto`,
"label.projectManagement.unallocated.time":`Czas nieprzypisany`,
"PageLayout.Search.MultiSearch.002":`Włącz niestandardowe pole wyszukiwania (Wyszukiwanie pojedynczego pola)`,
"label.icon.150":`VR`,
"label.SMS.edit":`Powiadamianie SMS Edycja`,
"Opportunity.Detailed.Phase.Label.003":`Etap zmian`,
"vue_label_helpcenter_all":`1. Wyszukiwanie ogólne<br> Wyszukiwanie ogólne to narzędzie, które pomoże Ci szybko znaleźć to, czego potrzebujesz. <br>?Wprowadź słowa kluczowe w polu wyszukiwania w pasku nawigacji na górze strony. Podczas procesu wprowadzania danych, system będzie zalecać odpowiednie treści dla Ciebie w czasie rzeczywistym zgodnie z treścią wejściową;<br>?Kliknij "Szukaj" lub bezpośrednio naciśnij klawisz Enter na klawiaturze, aby otworzyć stronę z wynikami wyszukiwania;<br>?Na stronie wyników, można filtrować obiekt po lewej stronie, aby wyświetlić listę wyników wyszukiwania pod tym obiektem. Na liście wyników polecanych jest do 10 rekordów. Możesz kliknąć "Zobacz więcej", aby wejść na stronę listy tego obiektu, aby wyświetlić więcej wyników wyszukiwania;<br>Uwaga: System domyślnie wyszukuje "oferty", "klient", "ołów", "okazja biznesowa", "działalność marketingowa", "umowa", "produkt", "zgłoszenie serwisowe", "zadanie" i "zdarzenie". <br> 2. Szybko utwórz<br> Kliknij " " na pasku nawigacji, i można wybrać obiekt, który chcesz utworzyć w oknie rozwijanym. <br> 3. Moje Centrum<br> Kliknij na awatara po prawej stronie paska nawigacji, aby otworzyć okno Moje Centrum. Dostępne są następujące funkcje: <br>?Szybko wejdź na stronę ustawień osobistych, importu wsadowego i wejścia do kosza; <br>?Jeśli jesteś w okresie próbnym, kliknij "Zamów teraz", aby szybko wejść na stronę zamówienia Cloud CC; <br>?Kliknij na wersję, aby szybko przełączyć; <br>?Wyloguj się. <br> 4. Menu<br> Niektóre obiekty menu są zalecane dla Ciebie w pasku menu. Możesz kliknąć na menu, aby szybko wejść na stronę. Można również wyświetlić wszystkie menu i ustawić często używane menu, które mają być wyświetlane na pasku menu. <br>?Wszystkie menu: Kliknij "Więcej", a następnie kliknij "Wszystkie menu" na dole rozwijanego okna; <br>?Dostosuj moje menu: Kliknij przycisk po prawej stronie menu, aby otworzyć okno menu niestandardowego i ustawić wspólne menu, które musisz wyświetlić na pasku menu we wszystkich menu. <br> 5. Centrum uruchamiania aplikacji<br> Kliknij ikonę po prawej stronie paska menu, aby szybko przejść do administratora systemu, aby skonfigurować inne usługi aplikacji dla Ciebie. <br>Uwaga: Aplikacja jest zbiorem serii modułów funkcjonalnych (takich jak zarządzanie leadami, szansami biznesowymi, zarządzanie umowami itp.), które można wykorzystać do spełnienia określonych potrzeb biznesowych.`,
"label.summaryreport.2018.step5.new":`Krok 5 Wybór kryteriów raportowania`,
"label.weixin.id":`Numer`,
"chatter.pu.mess":`stanowisko(a)`,
"label.weixin.lookup.record":`Znajdź zapisy`,
"label.ServiceCloud.statistics.by.address":`Statystyki według adresu`,
"label.jixiaoswitchoff":`Zapadnij się`,
"label.savealipay.failure":`Nie udało się zapisać informacji o handlowcu Alipay`,
"template.chart.khdqfb":`Rachunki Dystrybucja regionalna`,
"front-email-payment-immediate-payment":`Zapłać teraz`,
"label.dashboard.unit5":`Jednostka: 100 milionów`,
"label.tabpage.greaterz":`Większe niż`,
"vue_label_calendar_stop_sharing_calendar":`Przestań udostępniać kalendarz`,
"label.projectManagement.allhours":`Wszystkie (godziny)`,
"label.currency":`Waluta`,
"label_vue_create_edit_obj_create_event_dialog_title":`Przypomnienie o powtarzających się harmonogramach`,
"front-template-V1-templateSetting":`Ustawienie szablonu`,
"label.dashboard.away.condition":`Stan upadku`,
"label.replacelayout":`Zamień układ strony`,
"label.permission.detail.system.setting.tip":`Wykonaj operację zastosowaną do aplikacji. Na przykład: zmodyfikuj uprawnienia dla wszystkich danych`,
"label.customfield.delete.prompt":`Etykieta pola niestandardowego`,
"label.add":`Dodaj`,
"label.deputationalsoapprove":`Delegowany zatwierdzający również może zatwierdzić ten wniosek`,
"label.leave_nosave":`Po wyjściu aktualne dane nie zostaną zapisane.`,
"label.tianyancha.title":`TianYanCha`,
"vue_label_pool_restore":`Przywróć`,
"chatter.feed.menutype.feed.markcom":`Zakładka Post`,
"label.query.data.error":`Nie powiodło się wyszukiwanie list powiązanych`,
"label.pc.ui.2018.unpin":`Odepnij`,
"label.partner.template.memo":`Tytuł`,
"label.weixin.cannot.gain.userinformation":`Nie można uzyskać informacji o użytkowniku.`,
"label.stdashbord.xsld.department":`Dział`,
"label.service.ganttBaiduMap.scheduled.starttime":`Planowany czas rozpoczęcia`,
"label.documentforms":`Dokumenty`,
"label.operator.insert":`Operator wstawiający`,
"label.processsetting.select.five.fields":`Można wybrać do 5 pól.`,
"label.weixin.password":`Hasło`,
"vue_label_chatter_share_followers":`Podziel się z naśladowcami`,
"label.brief.baifang":`Wizyty`,
"label.emailobject.track.unopen":`Nieotwarte`,
"label.sendmail.immediately":`Wyślij teraz`,
"label.partnerCloud.payTheAmount":`Kwota płatności`,
"label.integrations.mailchimp.connect":`Podłącz CloudCC do swojego konta`,
"label.datamove.record.sucessfully":`rekord(y) został(y) pomyślnie przeniesiony(e).`,
"lable.outlook.edit.allocation":`Przydzielanie użytkowników i profili`,
"label.chosesubject.talk":`Zaplanuj rozmowę`,
"label.escalation.setup.entrydetail.escalation.time":`Eskalacja na`,
"label.projectManagement.must.be.less.than.24.hours":`Mniej niż 24 godziny`,
"setup_mainpage_label_welcome15":`Reguły przepływu pracy platformy CloudCC automatyzują proces wsparcia dla sprzedaży, marketingu i nie tylko. W zależności od predefiniowanego zestawu reguł, rekordy mogą być automatycznie przypisywane do użytkowników lub konwertowane z jednego użytkownika na drugiego. Główną korzyścią z zarządzania przepływem pracy jest poprawa wydajności pracy poprzez wyeliminowanie wielu niepotrzebnych operacji podczas aktualizacji rekordów, a także poprawa poziomu przetwarzania biznesowego i optymalizacja procesów kontroli poprzez standaryzację metod pracy i zmniejszenie kosztów operacyjnych. Obsługuje nieograniczoną nieskończoność zatwierdzeń dla dowolnego obiektu, a także może wyzwalać przypomnienia e-mail, przypomnienia SMS, zadania, aktualizacje pól i inne funkcje.`,
"label.mobile.phone.week.plan2":`W tym tygodniu`,
"label.add.newAsset":`Nowy składnik majątku`,
"vue_label_salesadvance_losts":`Liczba strat`,
"vue_label_report_editcolumn":`Edytuj Kolumnę`,
"vue_label_homepage_assignedtasks":`Przydzielone zadania`,
"label.posting_from":`Opublikowane przez`,
"year":`Rok`,
"label.autoRegister.changepwd.setpwd.tip.letter":`Co najmniej jedna litera`,
"label.version.nonsupport.feature.staticresource":`Ta funkcja jest chwilowo nieobsługiwana. Przed użyciem proszę poczekać na aktualizację.`,
"label.toleadmyclientandlinkman":`Importuj moje konta i kontakty`,
"label.appupload.install.processcrash":`Radzenie sobie z konfliktami`,
"label.profile.setstandardtab":`Ustawienia karty standardowej`,
"template.chart.khhyfx":`Analiza branży rachunków`,
"label.reportTypcrtC":`Obiekt powiązany (c) proszę kliknąć, aby wybrać obiekt powiązany`,
"vue_label_report_mayormaynothave":`Obiekt nadrzędny może, ale nie musi posiadać rekordów związanych z tym obiektem`,
"label.service.gantt.plan.recommendation":`Zalecany harmonogram`,
"label.version.sum.lookupfield":`pola relacji lookup`,
"label.builder":`Kreator stron`,
"label.sharerule.remark":`Określenie sposobu udostępniania rekordu. Rekordy i powiązane dane można udostępniać użytkownikowi, roli, roli i podwładnym, użytkownikom w terytorium, użytkownikom w terytorium i podterytorium.  Udostępnianie indywidualne może być użyte tylko do przyznania szerszego dostępu do danych, a nie do ograniczenia dostępu.`,
"vue_label_email_benn_added":`Skrzynka pocztowa została dodana`,
"label.version.allow.sum":`Jeśli jest to konieczne, proszę uaktualnić wersję CloudCC.`,
"label.icon.130":`Waluta`,
"label.custom.new":`Nowy`,
"label.see_allfields":`Wyświetl wszystkie pola`,
"front-marketing-module-v1-share-poster":`Share Poster`,
"label.service.one":`Twój filtr odwołuje się do niezdefiniowanych warunków filtrowania:`,
"lable.outlook.edit.alprec":`Zawsze preferowane CloudCC.com`,
"Account_News_Setting_001":`Ustawienia konta`,
"label.mr.caption.opportunity.result":`Znajdź duplikaty i połącz: Wyniki wyszukiwania duplikatów szans`,
"label.forbidden":`Wyłącz`,
"label.query.detail.openpartner":`Włączenie jako użytkownik partnerski`,
"label.session_date":`Data sesji`,
"label.forecast.customforecast.submit.deyuce":`Prognoza`,
"label.emailtocloudcc.filed.server":`Serwer`,
"label.emailtocloudcc.tip2":`Po usunięciu, nie będziesz mógł używać Email do CloudCC, czy na pewno chcesz usunąć?`,
"pagecreator_layout_message_delete_fail":`Usuwanie układu nie powiodło się`,
"front-lightning-module-v1-dashborad-export-PDF":`Eksport PDF`,
"lable.quote.syncing.syncingto":`Pozycje kosztorysu zostały zsynchronizowane z produktami szansy`,
"message.error.view.lastview.update":`Nie można usunąć ostatniego zestawienia publicznego</br>Nie można zmienić widoczności ostatniego zestawienia publicznego z "Widoczne dla wszystkich użytkowników" na "Widoczne tylko dla mnie"<br><br>.`,
"label.weixin.select.one":`Wybierz co najmniej jeden`,
"label.projectManagement.Pleaseenterprojectname":`Proszę wpisać nazwę projektu...`,
"label.data.downpage.e_list.desc1":`Ta strona wyświetla pomyślnie wyeksportowane pliki. Prosimy o pobranie wyeksportowanych plików w czasie zgodnym z linkiem do pobrania w emailu.`,
"label_tabpage_notexceed25":`Wybrany rekord nie może przekraczać 25`,
"label.campaign.channel.step5.remark":`Zakończyłeś konfigurację strony rejestracji.`,
"label.setup.mobile.bottombutton.profile.prompt":`Tips:niestandardowe dolne menu profilu zastąpi firmy dolne menu zunifikowane ustawienia`,
"label.stdashbord.xsld.business.knx":`Prawdopodobieństwo`,
"label.setemailtip":`Utwórz alert e-mail, który będzie powiązany z jedną lub wieloma regułami przepływu pracy lub procesami zatwierdzania. Podczas zmiany alertu e-mail wszelkie modyfikacje zostaną zastosowane do wszystkich reguł lub zatwierdzeń z nim powiązanych.`,
"report.button.go":`Idź do`,
"lable.the.united.arab.emirates":`Rekordy zostały otrzymane.`,
"label.writer. name.file":`Proszę wpisać nazwę pliku do wyceny`,
"label.validate.function.funcExplain.ADDMONTHS":`Dodaj liczbę miesięcy do daty, używając ostatniej daty miesiąca, jeżeli data jest ostatnim dniem miesiąca lub dodanie liczby miesięcy ma mniej dni.`,
"vue_label_chatter_enter_shared_content":`Proszę wprowadzić udostępnioną treść`,
"message.lookup.condition":`Kryteria wyszukiwania muszą zawierać więcej niż jeden znak`,
"vue_label_commonobjects_detail_customers":`Klienci, którzy trwale wyłączą użytkowników zewnętrznych, zablokują wszystkich użytkowników zewnętrznych powiązanych z klientem i usuną ich ze wszystkich społeczności, grup, zespołów, zestawów uprawnień i zasad udostępniania z nimi powiązanych. W tym samym czasie role i grupy powiązane z kontem zostaną trwale usunięte i nie pojawią się w koszu. Czy jesteś pewien?`,
"label.emailobject.view.all":`Wszystkie wiadomości e-mail`,
"vue_label_file_size_limit_new":`Przesyłanie nie powiodło się. Załącznik przekracza rozmiar {size}M.`,
"front-gantt-module-please-reorder-milestones":`Proszę wpisać poprawny numer, aby zmienić kolejność kamieni milowych`,
"label.escalation.setup.entrydetail.escalation.assingTemplate":`E-mail`,
"label.namespaceprefix":`Prefiks przestrzeni nazw`,
"label.ems.delete.success":`Usuń z powodzeniem`,
"label.partnerCloud.financeSetting.setWechatPay":`Skonfiguruj WeChat Pay`,
"front-epwechat-module-v1-input-token":`Proszę wprowadzić Token`,
"setup_object_field_dependency_button_setdependency":`Ustawienia zależności od pola`,
"chatter.group.request01":`Wniosek(-ki)`,
"message.error.field.number.length":`Długość wprowadzonego formatu błędu.`,
"label.tabpage.lessz":`Mniej niż`,
"vue_label_notice_uploadavatar_format":`Przesłany obrazek awatara może być tylko w formacie JPG/PNG/GIF`,
"label.project.hit.thirteen":`Codzienne przypomnienie o kamieniach milowych`,
"frame_personinfo_label_usethisimage":`Będziemy używać wariantów tej miniaturki w całej aplikacji.`,
"label.startuploadfile.step":`W przeciwnym razie nie pomyślnie przesłane pliki będą wyświetlane w górnym obszarze, należy je usunąć, a następnie wybrać nowy plik.`,
"component_assistant_label_overduetask":`Okazje z zaległymi zadaniami`,
"label.partnerCloud.financeSetting.information":`Jak skonfigurować informacje o subskrypcji Alipay?`,
"label.appupload.install.package.component":`Składniki pakietu`,
"label.emailobject.emaildetail.nextactivity.task":`Dodaj zadanie`,
"vue_label_chatter_edit_post":`Edytuj Post`,
"label.appupload.upload.logo":`Ikona`,
"label.role.selecteduser":`Wybrani użytkownicy`,
"label.letter.assign":`Określenie treści zaproszenia`,
"label.forecast.shrepage.title":`Szczegóły udostępniania prognozy`,
"lable.Generate.service.appointment":`Wizyty serwisowe generowane przez pozycję zlecenia pracy`,
"label.productsales.nodata":`Brak danych`,
"vue_label_email_Please_select_at_least_one_email":`Proszę wybrać co najmniej jeden e-mail`,
"label.data.downpage.i_title.num4":`4. Jeśli masz pole relacji lookup i pole relacji master-detail w obiekcie, który chcesz zaimportować, wartość dla tego pola musi być ID, w przeciwnym razie jest nieważna.`,
"label.new.exchagecurrency":`Nowe kursy wymiany`,
"label.layout.listtip":`W poniższej tabeli przedstawiono przyporządkowanie układu strony dla różnych profili.`,
"label.icon.2":`Portfel`,
"label.chat.topic.delete.prompt3":`Czy na pewno chcesz usunąć ten temat?`,
"UG_Lead_008":`Kod skanowania wizytówki`,
"label.multilang.databatchadd.fail":`{0} dane nie zostały dodane：`,
"front-kefu-moudle-v1-chzx-confirm":`Czy na pewno chcesz usunąć agenta?`,
"label.import.page1.matchlabel":`Sposób na dopasowanie {{$store.state.labelName}}`,
"label.dashboardSetup.showdw.d3":`Mln`,
"label.version.ifnecessary":`Jeśli to konieczne, proszę zaktualizować wersję CloudCC.`,
"label.confirm.delete.default.tab":`Czy na pewno chcesz usunąć domyślne zakładki logowania?`,
"label.emailtemplate.mergefields.tip":`Kiedy użytkownicy edytują treść emaila, mogą dodać pola połączone, aby zastąpić tekst w treści emaila. Kiedy wiadomości e-mail są wysyłane, system zastępuje je tekstem. Na przykład, {!Kontakt.nazwa} w twojej wiadomości e-mail stanie się nazwą kontaktu.`,
"vue_label_chatter_decline_members_join":`Odmówić członkom przyłączenia się do grupy`,
"label.role.no":`Brak ról`,
"label.service.gantt.resources":`zasoby`,
"label.knowledge.language.simplified":`Chiński uproszczony`,
"label.eidt.queue.length.cannot.than":`Długość imienia nie może przekraczać 50 postaci.`,
"label.mobile.quickcreate.default.tasks":`Zadania`,
"label.discount.yuan":`Dyskonto (juan)`,
"message.error.delete.pending":`Rekord jest w trakcie zatwierdzania, nie można go usunąć.<br>Kliknij <a href='javascript:history.back();'>here</a> aby powrócić.`,
"chatter.show.mostnews":`Pokaż więcej`,
"label.optionlist":`Picklist`,
"template.chart.cpdj":`Ustalanie cen produktów`,
"label.user.usernamepassword.error":`Proszę sprawdzić swoją nazwę użytkownika i hasło.`,
"label.file.sharetype.check":`Przeglądarka`,
"label.completed.generated.page":`Strona PC została zakończona`,
"label.martrixcross":`Matrix Cross`,
"label_tabpage_entercusnamez":`Proszę wpisać nazwę klienta`,
"lable.account.NextwDays":`Następne 30 dni`,
"label.list.userinterface.dashboard.hint":`Nowe wykresy szybko wyświetlane na telefonach komórkowych, tabletach, itp.`,
"message.fieldtrack.operatecreate":`Utworzony`,
"label.service.gantt.available.plan":`Skale czasowe, które mogą być zaplanowane:`,
"label.activity.setting":`Ustawienia działania`,
"label.tag.manage.record":`Liczba rekordów`,
"label.customcomponent.page.edit.title":`Edycja komponentów niestandardowych`,
"label.import.index.creationrecord":`Utwórz rekord`,
"label.tabpage.printz":`Drukuj`,
"label.appointment.wizard.subtitle4-1-5":`1.5 h`,
"label.partnerCloud.orderingPlatform.discountUnit":`Jednostka dyskontowa:`,
"label.weixin.micro.message.profile.associated":`Oficjalne konto WeChat powiązane z profilem firmy`,
"label.cpq.opportunity.pricebook.change":`Ta okazja została powiązana z notowaniem pierwotnym, a cennik nie może zostać zmieniony.`,
"vue_label_opportunity_business_opportunity":`Wyniki zamkniętej i wygranej przez klienta okazji biznesowej zawierają rekordy z jednym lub kilkoma takimi samymi polami jak bieżąca okazja biznesowa.`,
"message.standardreport":`Raporty standardowe`,
"vue_label_account_outstanding_business":`Przeniesienie wszystkich nieprzetworzonych możliwości biznesowych innych osób`,
"vue_label_commonobjects_detail_field":`Wybierz pole filtrujące`,
"pagecreator_page_button_delete":`Usuń`,
"label.leadconvers.permisson":`Brak uprawnień {!operator} dla obiektu {!objectname}, proszę skontaktować się z admministratorem!`,
"vue_label_systemSettings_customcode":`Kod niestandardowy`,
"button.partner.cancel":`Anuluj`,
"label.whChatBindingState":`Status wiązania WeChat`,
"label.appointmentconfirmail.wizard.subtitle6":`Telefon`,
"label.recycle.dis.tip2":`Kliknij przycisk Opróżnij kosz lub Opróżnij wszystko, aby opróżnić kosz użytkowników lub organizacji. To zajmie trochę czasu, kiedy opróżnianie jest zakończone, zostaniesz powiadomiony przez e-mail.`,
"batch.transfer.succ":`dane dotyczące udanego transferu masy`,
"label.chat.add.bookmark":`Zakładka do książki`,
"label.mr.object.contact":`Kontakty`,
"component_setup_label_parentobject":`Obiekt nadrzędny`,
"label.reportsSubscriptionPage.schedulereport.weekly.tuesday":`Wtorek`,
"vue_label_report_list":`Wybierz pole, które ma być wyświetlane w tytule listy.`,
"label.checkbox.false":`Nie`,
"label.chatter.followers":`Być śledzonym`,
"label.mr.loadReDate":`Załaduj wybrany`,
"label.versiontype.Essential":`Niezbędne`,
"front-project-module-v1-input-actual_working_hours":`Proszę podać liczbę roboczogodzin`,
"label.visualpage.staticresource.p2":`2. Zauważ, że obsługiwane typy plików zasobów statycznych to png, jpg, gif, js i css`,
"label.query.clone.detail.choose":`Proszę wybrać pozycje do sklonowania`,
"component.assistant.label.30daysnoact":`30 dni bez żadnej kampanii`,
"label.tianyancha.businessverify.relation":`Sporządza mapy`,
"vue_label_email_havent_received_the_email_yet":`Nie otrzymano już żadnej poczty`,
"label.isEnableVisualpage_new.title":`Włącz dostęp do stron niestandardowych`,
"lable.SalesCommitmentKanBan.allContractAmount":`Całkowita kwota umowy`,
"label.searchall":`Szukaj wszystkich`,
"label.h5.similar.opportunity.select.all":`Wybierz wszystko`,
"label.area.tree.intro":`Hierarchię terytoriów można zobaczyć tutaj.`,
"label.select.up.three.fields":`Uwaga: Można wybrać maksymalnie trzy pola.`,
"label.leadscore.doing":`Punktacja została rozpoczęta, proszę nie powtarzać punktacji.`,
"message.choosereportobj":`Proszę wybrać obiekty raportu`,
"button_partner_start":`Zacznij używać`,
"label.quote.print":`Drukuj ofertę`,
"label.workflowoperateselect":`Krok 3 Określenie akcji przepływu pracy`,
"label.greate":`> Większy niż`,
"lable.setting.qrcodeOrbarcode.rule":`Ustawienia zasad generowania QR Code/Bar Code`,
"label.partnerCloud.orderingPlatform.discounts":`Harmonogram obniżek`,
"label.ems.save2draft":`Zapisz jako szkic`,
"vue_label_homepage_editname":`Edytuj nazwę strony głównej`,
"label.ccdocument.save.error":`Zapis nie powiódł się, a kod błędu to`,
"label.samoa.standard.time":`Czas standardowy Samoa`,
"label.tianyancha.businessverify.msg7":`3. zakres usług`,
"vue_label_commonobjects_view_up_to_data":`Operacja obsługuje do 200 danych`,
"label.manage":`Zarządzaj stroną`,
"label.tooltip":`Użyto źródła danych raportu, nie można edytować relacji obiektu!`,
"vue_label_calendar_edit_calendar":`Edytuj kalendarz`,
"label.attendance.keywords":`Proszę wpisać słowa kluczowe`,
"label.otherinfo":`Inne informacje`,
"System_TAB_SeeViewAmount":`Wyświetl sumy`,
"label.recordtype.remark":`Opis`,
"label.object.cannot.delete":`Obiekt nie może zostać usunięty, ponieważ jest powiązany następującymi relacjami z innymi obiektami`,
"label.setup.mobile.bottombutton.saveprompt":`Proszę wybrać 4 strony pierwszego poziomu`,
"label.department.lastpage":`To ostatnia strona.`,
"label.emailtemplate.mergefield.use":`Kopiuj i wklej wartości pól scalania do wiadomości e-mail`,
"vue_label_salesfunnel_notice8":`Proporcja udanych konwersji z tego etapu do następnego`,
"lable.opppdt.addpdt.table.product":`Produkty`,
"vue_label_helpcenter_report2.2":`Krok 2: Wybierz sposób, w jaki chcesz podsumować kolumny: Total, Average, Max, Min. <br>? Sortowanie danych w raporcie rosnąco lub malejąco<br> Kliknij symbol ↑ lub ↓ obok dowolnego pola w nagłówku raportu podglądu. Dane w raporcie zostaną posortowane w kolejności rosnącej lub malejącej według tego pola. <br>? <br>Pokaż lub ukryj wiersze szczegółów<br>Po zgrupowaniu można pokazać lub ukryć wiersze szczegółów, wybierając przełącznik "Wiersz szczegółów" w prawym górnym rogu raportu. Domyślnie opcja "Wiersz szczegółów" jest wyłączona. <br>? Włączenie lub wyłączenie automatycznego podglądu aktualizacji<br> Przełącznik "Automatyczny podgląd aktualizacji" w prawym górnym rogu raportu podglądu pozwala na włączenie lub wyłączenie automatycznego podglądu aktualizacji. Po włączeniu tej opcji, wpływ każdego kroku na dane jest automatycznie wyświetlany w raporcie podglądu. ? Aby filtrować rekordy raportu, kliknij Filtry<br>Filtry dzielą się na filtry standardowe i filtry pól. <br>Filtry standardowe obejmują filtr "Rola", filtr "Pokaż mi" i filtr "Data". <br>A. Filtr "Rola" dzieli dane według bieżącej roli i ról bezpośrednio podrzędnych, można przełączać się między rolami klikając na nazwę roli. <br> B. Filtr "Pokaż mi" dzieli dane na "Pokaż mi" i "Pokaż wszystkim", przy czym "Pokaż mi" pokazuje dane, których właścicielem jest bieżący użytkownik, a "Pokaż wszystkim" pokazuje wszystkie dane, których właściciel ma uprawnienia do przeglądania. <br> C. Filtr "Zakres dat" dzieli dane według daty w określonym przedziale czasu, np. "Data utworzenia", "Data zakończenia". <br> Filtr "Pole" zawiera zarówno filtr pola, jak i filtr zaawansowany. <br>`,
"label.validate.function.funcFormat.YEAR":`ROK(data)`,
"label.service.gantt.timeScale":`Wybierz skalę czasu w Gantt`,
"label.data.dataexptemplate.desc1":`1. Pliki eksportu danych mają dwa formaty: Format CSV i format skompresowany. Domyślnie ustawiony jest format CSV.`,
"template.chart.btjbkhqk":`Różne poziomy klientów`,
"label.role.assign.select":`Usuń użytkownika z listy <b>Wybrani użytkownicy</b> i przypisz go do wybranej roli powyżej.`,
"label.event.lookupmulti.assigner":`Przypisany do`,
"label.appexchange.fieldupdata":`Aktualizacje pól przepływu pracy`,
"label.lookup.page.notexists":`Strona nie zamyka się.`,
"label.appupload.install.error.choice3":`Łączenie sprzecznych komponentów w jeden komponent`,
"vue_label_commonobjects_detail_team":`Zarządzanie zespołem`,
"label.approvereqiest":`Wniosek o zatwierdzenie`,
"message.error.id.replace":`Informacja o kalendarzu odpowiadająca {0} nie została znaleziona`,
"font-evaluate-module-v1-general":`Rodzaj oceny jest neutralny`,
"vue_label_report_whatweek":`Którego dnia`,
"vue_label_chatter_img_upload":`Możesz przesyłać pliki JPG, GIF lub PNG, maksymalny rozmiar pliku to 2M.`,
"label.checkbox":`Checkbox`,
"label.visualpage.component.n5":`5.Przykład. Wywołanie:`,
"chatter.updat":`Aktualizacja`,
"label.ems.emailaccount":`Konto poczty elektronicznej`,
"label.autoRegister.changepwd.setpwd.tip1":`Ustaw hasło do konta CloudCC`,
"label.import.step1.matchway":`Sposób na dopasowanie { labelNameshow }`,
"label.manageAll.sel.one4":`Pozycje, które odrzuciłem`,
"label.tabpage.lookatmorez":`Zobacz więcej`,
"label_tabpage_addadvancedoptions":`Dodaj opcje zaawansowane`,
"message.validation.accept":`Nieprawidłowy format`,
"label.handlingnooperate":`Dane są przetwarzane, proszę nie robić nic więcej, w przeciwnym razie przetwarzanie nie powiedzie się.`,
"label.mobile.buttom.homepage":`Strona główna`,
"lable.account.LastaDays":`Ostatnie 7 dni`,
"label.user.notexists":`Użytkownik nie istnieje.`,
"front-electronic-signature-isclose":`Nieaktywny`,
"label.optional.groups":`Opcjonalne grupy linii notowań`,
"pagecreator.layout.label.layoutname":`Nazwa układu`,
"label.error404":`Strona, którą próbujesz wyświetlić nie jest dostępna, spróbuj ponownie później.`,
"label.eventtrigger":`Wyzwalacze zdarzeń`,
"label.projectManagement.next.page":`Następna strona`,
"vue_label_SMS_chosen":`Wybrany`,
"label.part.cannot.empty":`Pole nie może być puste`,
"label.call.center.jilu":`Historia połączeń`,
"front-kefu-moudle-v1-tenant-reinput":`Proszę wpisać ID najemcy`,
"label.projectManagement.you.want.to.delete.this.data":`Czy na pewno chcesz usunąć ten rekord?`,
"label.projectManagement.nocharge":`Darmowy`,
"System_TAB_SeeViewPageAmount":`Zobacz strony`,
"label.password.query.error":`Błąd zapytania użytkownika.`,
"message.chooseatleastone":`Wybierz wartość co najmniej.`,
"label.sortasc":`Ascend`,
"label.stdashbord.xsld.business.jinezhb":`Kwota Proporcja`,
"label.attendance.add":`Dodaj frekwencję`,
"vue_label_account_invoices":`Przeniesienie wszystkich faktur właściciela klienta`,
"label_delete _model":`Usunięcie modelu spowoduje również usunięcie powiązanych z nim danych docelowych i jest nieodwracalne. Czy chcesz potwierdzić usunięcie?`,
"label.folder.sort。discreption":`Foldery zostaną wyświetlone w wybranej kolejności.`,
"label.partnerCloud.financeSetting.merchantPlatform":`Acces Path: Merchant Platform  Account Center  API Safety  API SecretＫey`,
"label.equal":`=równe`,
"lable.PowerProcess.Workorder":`Zamówienie robocze`,
"front-docusign-setting-error-tips":`Proszę wybrać pole niestandardowe`,
"template.report.lead.status":`Status leadów`,
"label.create.remark":`Dodaj notatkę`,
"font-evaluate-module-v1-one-points":`Ocena negatywna: 1 punkt`,
"label.validate.function.funcExplain.DATETIMEVALUE":`Zwraca wartość roku, miesiąca, dnia i czasu GMT (pole daty/czasu)`,
"label.report.select.group.mode":`Wybierz tryb grupowania`,
"label.h5.editmydetails":`Edytuj moje dane`,
"front-epwechat-module-v1-authorize":`Autoryzowana domena wywołania zwrotnego`,
"label.tabpage.kanban":`Konfiguracja tablicy poglądowej`,
"label.emailobject.emaildetail.button.addtocontact":`Dodaj do kontaktów`,
"lable.opppdt.selPbk.description":`Wybierz książkę cenową dla tej okazji. Możesz dodać produkt tylko z jednej książki cenowej, a zmiana wybranej książki cenowej spowoduje usunięcie wszystkich istniejących produktów z okazji.`,
"component.event.button.save":`Zapisz`,
"vue_label_homepage_homepage_assigned_success":`Strona główna przypisana pomyślnie`,
"message.duplication.label.blankmatch":`Dopasuj puste pola`,
"label.icon.24":`Apteczka pierwszej pomocy`,
"label.mobile.same":`Nowy numer telefonu jest taki sam jak stary numer telefonu.`,
"label.file.library.managemembers.addmember":`Dodaj członków`,
"chatter.sp":`Pokaż posty`,
"label.user.notlogin.range":`Poza zakresem czasu logowania.`,
"label.step3.total7":`Krok 3 z 7`,
"label.user.fullname":`Imię i nazwisko`,
"label.button.menubar":`Pasek menu`,
"#label.importfilestep3":`Krok 3 Wybierz i prześlij swój plik(i)#.`,
"label.appointment.wizard.subtitle6":`Opis`,
"message.lostnextapprover":`Jeśli chcesz złożyć wniosek o zatwierdzenie, wypełnij pole "Odpowiedni użytkownik", aby zdefiniować kolejnego zatwierdzającego. To znaczy, że pole "Odpowiedni użytkownik" nie może być puste. Wszelkie inne pytania, możesz skontaktować się z adminem.`,
"label.sso.saml.sp.logoutUrl":`Adres URL dostawcy tożsamości do pojedynczego wylogowania`,
"label.weixin.isgoon":`Twoje informacje o członkostwie już istnieje. Jeśli kontynuować, WeChat ID, który wiąże ten numer telefonu komórkowego przed nie będzie mógł korzystać z AidMax WeChat Oficjalne konto. Czy na pewno chcesz kontynuować?`,
"vue_label_notice_homepage1":`Proszę wprowadzić prawidłową wartość docelową w obrębie 12 cyfr.`,
"label.umeng.activity.event.will":`będzie`,
"label.insertURL":`Wstaw URL`,
"label.partnerCloud.orderingPlatform.administrator":`Brak dostępnego cennika. Prosimy o kontakt z administratorem.`,
"vue_label_systemSettings_emailtemplate":`Email Tamplate`,
"template.dashboard.market.analysis":`Analiza kampanii`,
"message.deleteapproval.tip":`Możesz usunąć tylko proces zatwierdzania, z którym nie są związane żadne dane lub rekordy.`,
"pagecreator_page_message_delete":`Czy usuwasz aktualnie wybraną stronę?`,
"component.telerecord.label.message":`Komentarz`,
"front-email-payment-Invoice-preview-opening":`Prosimy o kontakt z administratorem systemu w celu aktywacji funkcji płatności online i skonfigurowania odpowiednich parametrów metody płatności.`,
"noless":`Większe lub równe`,
"label_emailtocloudcc_button_back":`Anuluj`,
"lable.Please.select.a.template":`Proszę wybrać istniejący szablon.`,
"front-lightning-module-v1-details-page-chart-relevant":` Kiedy obiekty powiązane wybranego raportu zawierają bieżący obiekt, można dalej filtrować dane raportu według bieżącego rekordu; Ustawienie, czy pozwolić użytkownikom na ręczne odświeżanie danych cashe.`,
"label.object.page.head":`Nagłówek strony`,
"label.notification.time1":`w ciągu kilku sekund`,
"label.weixin.optionnine":`Wybór 9`,
"label.approval.content.tolang":`Wprowadzona treść jest zbyt długa, prosimy o ponowne wprowadzenie.`,
"label.leadconvers":`Konwersja leadów`,
"label.compact.layout.frame.tabseq":`Wyświetlanie kolejności stron zakładki:`,
"label.permission":`Zestawy uprawnień`,
"vue_label_notice_new_success":`Utworzony z powodzeniem`,
"label.money":`Waluta`,
"label.ccchat.person.invite.unsuppem":`Podany adres e-mail nie obsługuje {0}`,
"message.profile.del":`Ten profil jest profilem administratora i nie może zostać usunięty!`,
"vue_label_report_savelocation":`Zapisz lokalizację`,
"label.knowledgebase.select.lighting.target":`Proszę wybrać cel Lightning`,
"label.visualpage.labelname":`Nazwa etykiety strony`,
"label.notification.ccchat2":`【点赞用户名】 polubił twój post.`,
"label.htyj.wanchenglv":`Procent`,
"label.weixin.report.generatedchart":`Wygenerowany wykres`,
"label.customer.tab.please.label":`Proszę podać etykietę zakładki`,
"label.template.lookup":`Wyświetl szablon`,
"label.attendance.setting.wucha":`Odchylenie w granicach 200 metrów`,
"vue_label_opportunity_product_addproduct":`Dodaj produkt`,
"label.data.setok.t.desc3":`, Operacja.`,
"label.emailobject.template.public":`Publiczne`,
"label.setsubmit":`Ustawienia przesyłania`,
"chatter.feed.menutype.feed.companycom":`Wszystkie przedsiębiorstwa`,
"label.Generate.Document":`Wygeneruj dokument`,
"label.knowledge.setting.hint.six":`Uporządkuj artykuły według klasyfikacji danych.`,
"label.dashboard.show.total":`Pokaż całość`,
"attachment.select.warning.001":`Załącznik jest zarchiwizowany, a przycisk Archiwizuj nie jest dostępny, proszę ponownie wybrać załącznik.`,
"message.schedulejob.error.delete":`Wystąpił błąd podczas usuwania bazy zadań.`,
"setup.layout.group.pagecomponent":`Składniki strony`,
"label_partner_new_step3_meno":`Nie jesteś pewien co wpisać? Nie martw się, możesz to zmienić w każdej chwili.`,
"label.partnerCloud.orderingPlatform.mutex":`Mutex`,
"label.subtotalrely":`Suma cząstkowa Bazy`,
"label.file.library.selectFile2Lib":`Dodaj pliki`,
"label.lock.record":`Zablokowane są( zapisy`,
"label.multilang.addcustomreporttypestage2.description":`To źródło danych wygeneruje raport na temat {0}. Wybierając obiekt, który jest z nim powiązany,
możesz określić, które rekordy powiązane z innymi obiektami będą zwracane do wyników źródła danych.`,
"message.duplication.errorinscript.greaterthan10":`Można wybrać do 10 rekordów do połączenia.`,
"label.encd":`Wyświetlanie Zaszyfrowane`,
"UG.Account.03":`Proaktywne sprawdzanie i łączenie zduplikowanych kont`,
"label.salescloud.teamrole.main2":`Major`,
"label.email.to":`Odbiorca`,
"label.members.sign.notify":`Powiadomić przełożonego`,
"template.report.individual.case.priority":`Priorytet sprawy`,
"vue_label_report_selectfolder":`Wybierz folder`,
"label_partner_all":`Wszystkie chmury partnerów`,
"lable.custom.year":`Lata niestandardowe`,
"label.ispigeonhole":`Archiwum`,
"label.campaignmember.selectmember.steptotal":`Krok 2 z 2`,
"label.userphoto.save":`Zapisz`,
"label.knowledgebase.published.version.online":`Opublikowane wersje są nadal dostępne online, dopóki nie opublikujesz tego projektu.`,
"template.report.customer.level.statistics":`Statystyki poziomu konta`,
"label.mobile.phone.day.plan":`Jutro`,
"label.icon.95":`Nauczanie`,
"label.recordphone":`Rejestrowanie połączeń`,
"lable.currencyManage.unEnabledadvcurrency.discripation":`Wyłączenie zaawansowanego zarządzania walutami spowoduje zaprzestanie używania wszystkich datowanych kursów walut dla Twojej organizacji. Konwersje pól walutowych na szansach, produktach szans i raportach powiązanych z tymi obiektami nie będą już mapowane do zakresu dat - wszystkie konwersje walutowe będą używać statycznego kursu wymiany.`,
"label.service.gantt.is.candidate":`Kandydat z`,
"label.ruleofchecktask":`Zasady walidacji zadań`,
"label.whole.page.show":`Full Page Dispaly`,
"label.validate.function.funcFormat.ISNULL":`ISNULL(wyrażenie)`,
"label.ccdocument.template.set":`Funkcja zestawu szablonów`,
"label.icon.103":`Harmonogram`,
"lable.no.products.to.assets":`Żaden produkt nie może być przeniesiony na aktywa.`,
"label.fristname":`Imię`,
"label.appointmentconfirmail.wizard.subtitle5":`Organizator`,
"label.partner.workspace.myspace":`Moje miejsce pracy`,
"label.tabpage.optionsz":`Opcje`,
"component_chatter_link_button_save":`Opublikuj`,
"label.validate.function.funcFormat.NOW":`TERAZ()`,
"label.discountPlanEditor":`Redaktor planu rabatowego`,
"label.weixin.fmu.pm":`{0} PM`,
"front-gantt-module-milestone-sorting":`Segregowanie kamieni milowych`,
"label.partnerCloud.maximumNumber":`Maksymalna liczba stron partnerskich:`,
"label.mobile.place.record.interval.setup":`Częstotliwość udostępniania lokalizacji`,
"label.visiblelinenumber":`Widoczne linie`,
"front-kefu-moudle-nopower-calluser":`Brak zgody, prosimy o kontakt z administratorem`,
"label.field":`Pola`,
"label.projectManagement.groupbydate":`Grupa według daty`,
"label_vue_create_edit_obj_create_event_dialog_desc_deal_field":`planowany`,
"label.operation.monitoring.history":`Historia Monitora Pracy`,
"label.data.dataexpalltype.all_desc1":`Można wybrać automatyczne generowanie lub ręczne wprowadzanie hasła do eksportowanego pliku kompresji. Automatycznie wygenerowane hasło zostanie wysłane do skrzynki pocztowej użytkownika, gdy dane zostaną pomyślnie wyeksportowane. Hasło wpisane ręcznie nie zostanie wysłane do skrzynki pocztowej, więc użytkownicy muszą zapamiętać wpisane hasło. Jeśli hasło nie zostanie wprowadzone, domyślnie ustawione jest na brak hasła.`,
"front-web-module-v1-detail-comment-proposal":`Czekamy na Państwa cenne sugestie`,
"label_partner_workspace_member_selectedpermission":`Wybrany zestaw uprawnień`,
"vue_label_helpcenter_view1":`W widoku wersji oświetlenia, można intuicyjnie i elastycznie przeglądać i zarządzać danymi, do których masz dostęp. Poprzez widok, można realizować podstawowe funkcje, takie jak widok klasyfikacji danych, wyświetlanie danych na wiele sposobów, dodawanie, modyfikowanie i usuwanie danych, a także można wygodnie przeglądać raporty i wykresy do dalszej analizy danych.<br> 1. Zarządzaj widokiem<br> W menu rozwijanym w lewym górnym rogu widoku wybierz widok, który chcesz wyświetlić, i wybierz widok domyślny za pomocą stałych ustawień. <br> Użyj menu sterowania widokiem listy, aby tworzyć, edytować, usuwać lub sortować widoki. Jednocześnie użyj funkcji filtrowania w prawym górnym rogu, aby szybko edytować i tworzyć nowe widoki. <br> 2. Przeglądanie danych za pomocą wielu widoków<br> Dane można przeglądać na różne sposoby. W prawym górnym rogu, można przełączyć listę, Kanban i podzielony ekran, aby zobaczyć dane. <br>W widoku listy niektóre typy pól mogą bezpośrednio modyfikować pojedyncze lub wielokrotne dane. Kliknij dwukrotnie komórkę, która ma być edytowana, lub kliknij przycisk edycji, aby bezpośrednio edytować dane w wyskakującym okienku. Aby edytować wiele elementów danych, zaznacz najpierw wiele elementów danych, a następnie wybierz opcję "Zastosuj do wybranych danych" w oknie edycji. <br> W widoku listy można bezpośrednio edytować kolumnę, która ma być wyświetlana w lewym górnym rogu, kliknąć nagłówek w nagłówku tabeli, aby posortować, lub wybrać kolumnę, która ma być zablokowana przez rozwijane okno pływające. <br> Po ustawieniu widoku Kanban możesz przeglądać dane w grupach i wyświetlać wartość podsumowania każdej grupy. W ustawieniach widoku Kanban można edytować podstawę grupowania, podstawę podsumowania i metodę podsumowania widoku Kanban, a także wybrać maksymalnie cztery pola do wyświetlenia. Grupowanie danych można szybko zmienić, przeciągając je i upuszczając. <br>`,
"component.task.label.priority":`Priorytet`,
"label.datamanage.field.error":`Błąd pola obiektu zapytania.`,
"label.console.step3":`Krok 3. Wybierz źródło obrazu dla konsoli`,
"label.ems.emailsyncsetup":`Ustawienia synchronizacji poczty elektronicznej`,
"label_tabpage_placeenterz":`Proszę wpisać`,
"label.getontocolumn":`Przejdź do kolumny`,
"label.file.down.e":`Bieżący typ pliku nie może być pobrany.`,
"vue_label_notificationcenter_unreadonly":`Tylko nieprzeczytane`,
"label.login.access.change":`Zmiana`,
"label.globaloperation.operationtype.send_e-mail":`Wyślij e-mail`,
"label.dashboard.refresh.hint":`Kliknij Odśwież, aby załadować najnowsze dane do pulpitu. Uruchomienie źródła danych zajmie trochę czasu, czy jesteś pewien, że chcesz odświeżyć?`,
"front-kefu-moudle-open-free":`Enable (Trial)`,
"label.lanxin.setting.appsecret":`AppSecret`,
"label.payment.manage.order":`Zarządzaj swoją subskrypcją`,
"label.chatter.maturiyDate":`Data wygaśnięcia`,
"message.mobilechooseatmostthree":`W zakładce Mobile App można wybrać maksymalnie trzy pola.`,
"label.customfields.formula.tip":`Pole tylko do odczytu, którego wartość wynika z wyrażenia formuły, którą definiuje użytkownik. Pole formuły jest aktualizowane, gdy zmienia się którekolwiek z pól źródłowych.`,
"lable.PowerProcess.start.time":`Proszę wybrać godzinę rozpoczęcia.`,
"label.mr.title.button.group2":`zestaw(y) zduplikowanych rekordów, w sumie`,
"label.atlantic.standard.time":`Czas standardowy atlantycki`,
"label.account.LengthofTime":`Czas trwania pomocy`,
"label.ccchat.message.search.desc2":`wiadomości`,
"label.pigeonhole.desc":`Zarchiwizuj załącznik jest ważne tylko dla niezarchiwizowanych załączników.<br/>Jak załącznik zostanie zarchiwizowany, nie zostanie usunięty.`,
"label.partnerCloud.orderingPlatform.sure":`Przełącznik {alias} spowoduje opróżnienie koszyka. Czy na pewno chcesz potwierdzić operację?`,
"label.default.value.is.positive.integer":`Wartość domyślna musi być dodatnią liczbą całkowitą`,
"label.partnerCloud.selectOne":`Wybierz co najmniej jedno menu`,
"label.dashboard.more.condition":`Więcej warunków`,
"component.event.label.enddate":`*Godzina zakończenia`,
"label.forecast.settings.type":`Typ prognozy`,
"com.cloudcc.login.error.message.licensenotstart":`Licencja nie uruchamia się`,
"lable.list.queue":`Kolejki`,
"label.mobile.app.isdisablum":`Wyłączenie wybierania zdjęć z albumu telefonu komórkowego podczas zameldowania`,
"label.service.gantt.filter":`W przypadku filtrowania po umiejętnościach, na wykresie Gantta będą wyświetlane tylko zasoby z wybraną umiejętnością`,
"label.potentialcustomeronline":`Web-to-Lead`,
"label.campaignmember.main.deletecontactdesc":`Masowo usuń wszystkie kontakty z tej kampanii`,
"label.list.desc1":`Korzystając z Web to CloudCC, można przechwytywać informacje kontaktowe i profilowe od użytkowników oraz automatycznie generować nowe leady w CloudCC.com`,
"label.generatepage.title.desc3":`Nazwa musi być unikalna i musi zaczynać się od litery. Musi zawierać tylko duże i małe litery, cyfry i podkreślenia. Nie może być dłuższa niż 30 znaków.`,
"label.emailtocloudcc.step2total3":`Krok 2 z 3`,
"label.movablemenu":`Przyciski aktywności`,
"label.partnerCloud.partnerAccount.topUp":`Do góry`,
"label.data.standobject":`Obiekty standardowe`,
"label.frequency":`Częstotliwość`,
"label.schedulejob.setup.schedule.end":`Koniec`,
"label.chat.topic.following":`Śledząc stronę`,
"label.martrixreport.2018.step2":`Krok 2 Podsumuj informacje poprzez:`,
"label.event.moveup.11hour":`11 godzin do przodu`,
"label.forecast.customforecast.directorcommit":`Zobowiązanie bezpośrednich podwładnych`,
"vue_label_homepage_card_view":`Widok z karty`,
"vue_labenl_applauncher_notice_closecertification":`Dane zostaną utracone po wyłączeniu urządzenia. Czy jesteś pewien, że to zrobisz?`,
"component_setup_button_weburl":`Zewnętrzny adres url`,
"label_emailtocloudcc_button_addemailaddress":`Dodaj skrzynkę Enterprise Mailbox`,
"vue_label_campaign_added_campaign_members":`Pomyślne dodanie członków kampanii`,
"label_tabpage_rtemptyz":`Typ rekordu nie może być pusty`,
"label.martrixreport.2018.step5":`Krok 5 Wybierz typ wykresu i element podświetlenia`,
"label.moverecord":`Zapis transferu`,
"pagecreator_layout_label_layoutdesc":`Opis układu`,
"label.knowledge.setting.data.nine":`Tak, chcę usunąć tę grupę kategorii i kategorie w tej grupie.`,
"label.icon.90":`Ludzie`,
"label.weixin.micro.research.name":`Nazwa mikrosondażu`,
"label.ccchat.micropost.allowedit":`Pozwól użytkownikom na edycję postów i komentarzy`,
"vue_label_homepage_fixed_components":`Element standardowy`,
"label.version.document":`Biblioteka dokumentów`,
"label_assessment":`Ocena (Możliwości - Kwota)`,
"label.appupload.component.type.lookuplayout":`Układ wyszukiwania`,
"label_chatter_loadmore":`Załaduj więcej`,
"component_setup_tabs_label_memo":`Ustaw nazwę znacznika karty`,
"label.icon.167":`Kompas`,
"vue_label_chatter_enter_content_sharing":`Proszę wprowadzić treść udostępnienia i grupę udostępnienia`,
"vue_label_notice_modify_success":`Pomyślnie zmodyfikowano`,
"label.sharerules":`Zasady dzielenia się`,
"label.field.api.exists":`To pole Nazwa API już istnieje.`,
"label.icon.83":`Farba`,
"label.file":`Plik`,
"vue_label_report_foldernameisrequired":`Nazwa folderu jest wymagana`,
"label.emailobject.wizard.btn2":`Połączono, przejdź do wysyłania wiadomości e-mail`,
"label.data.downpage.i_title.num3":`3. Przed importem upewnij się, że zaimportowałeś wszystkie powiązane rekordy. Na przykład: jeśli istnieje relacja lookup pomiędzy obiektami, które obecnie importujesz, a kontaktami, powinieneś najpierw zaimportować kontakty, a następnie zaimportować swoje dane.`,
"label.email.original.content":`Zawartość odniesienia`,
"vue_label_campaign_add_to_campaign":`Dodaj do Kampanii`,
"label.dashboard.new":`Nowa tablica rozdzielcza`,
"label.console.detail":`Szczegóły konsoli`,
"label.view.desc":`Pole daty może być równe "yesterday", "today", "tomorrow", "last month", "this month", "next month", "last week", "this week", "next week" lub "YYYY-MM-DD、MM/DD/YYYY".`,
"label.emailobject.template.insert.continue":`Kontynuuj`,
"label.notification.appointment.overlapEvent":`Wybrany czas jest zaplanowany, proszę wybrać inny czas.`,
"label.console.step6.top":`Stały na górze i listy są zawsze widoczne.`,
"label.data.file.the_trigger":`Wykonaj wyzwalacz`,
"message.report.error.operation":`Akcja nie powiodła się, proszę zresetować raport`,
"vue_label_helpcenter_detail3":`<br>   Lubienie i nielubienie<br>   Możesz polubić komentarz do mikro-postu lub tylko mikro-post. Po polubieniu możesz zobaczyć liczbę polubień postu, a także możesz go odrzucić. <br>? Edycja i usuwanie postów<br>    Wydawca postu może go ponownie edytować lub usunąć. <br>    Krok 1: Kliknij przycisk po prawej stronie postu i wybierz Edytuj lub Usuń w rozwijanym oknie<br>   Krok 2: Otwórz wyskakujące okienko Edytuj/OK, aby usunąć<br>     Krok 3: Kliknij Zapisz/OK, aby zakończyć operację<br>5. Historia zatwierdzania<br>? Przekaż do zatwierdzenia<br>    Przycisk "Przekaż do zatwierdzenia" pojawia się, gdy tworzony jest nowy rekord, prośba o zatwierdzenie zostaje oddzwoniona lub zatwierdzenie zostaje ostatecznie odrzucone. <br>    Krok 1: Kliknij przycisk "Przekaż do zatwierdzenia". System określa, czy rekord i osoba składająca wniosek spełniają warunki projektu i warunki początkowe określone w procesie zatwierdzania, a jeśli wszystkie te warunki są spełnione, złożenie wniosku kończy się sukcesem. <br>    Jeśli następny krok zatwierdzenia w konfiguracji procesu zatwierdzania wymaga ręcznego wyboru zatwierdzającego, wówczas krok 2 jest wykonywany po "Prześlij do zatwierdzenia".<br>    Krok 2: Wybierz następnego zatwierdzającego i zakończ operację przesyłania. <br>? Historia zatwierdzania<br>     A. Przed wysłaniem:<br>    Kliknij na "Podgląd procesu zatwierdzania", system określi, czy rekord i operator składający spełniają elementy określone w procesie zatwierdzania, a następnie, jeśli wszystkie te warunki są spełnione, zostanie wyświetlony proces zatwierdzania. <br>    B. Po złożeniu:<br>   W historii zatwierdzania można nie tylko przeglądać kroki historii zatwierdzania i aktualny status zatwierdzenia rekordu, ale również podglądać kolejny proces zatwierdzania. <br>? Wycofywanie wniosków o zatwierdzenie<br>    Jeśli proces zatwierdzania jest ustawiony na wycofywanie wniosków o zatwierdzenie, można je wycofać w dowolnym momencie po ich złożeniu. <br>    Krok 1: Kliknij "Cofnij wniosek o zatwierdzenie" na stronie szczegółów rekordu <br>   Krok 2: Otwórz stronę Cofnij wniosek o zatwierdzenie i kliknij "Cofnij wniosek o zatwierdzenie", aby zakończyć operację.`,
"Opportunity_Detailed_Phase_Label_004":`dzień(y)`,
"PageLayout_Search_MultiSearch_001":`Wybierz maksymalnie 3 pola.`,
"vue_label_systemSettings_set_business":`Skonfiguruj układ i pola obiektów tak, aby pasowały do Twojej działalności.`,
"label.compact.layout.frame.select":`Proszę wybrać ramkę układu strony`,
"label.tabpage.rolez":`Rola`,
"label.weixin.appr.currentauditor":`Przypisany do`,
"label.knowledgebase.verification.status":`Status weryfikacji`,
"UG_Case_05":`Utwórz sprawę`,
"label.service.marking.completed":`Oznacz jako zakończone`,
"label.notification.ccchat1":`【发出@的用户名】 wspomniał o tobie.`,
"label.knowledgebase.no.action.available":`Brak dostępnego działania`,
"label.tabpage.newlybuildz":`Nowy`,
"label.appupload.install.error.choice2":`Zmień nazwę lokalnych komponentów, które są w konflikcie z pakietem`,
"label_tabpage_as":`Jak`,
"Opportunity.Detailed.Phase.Label.Popup.001":`Data rozpoczęcia bieżącego etapu`,
"vue_label_homepage_singlepage":`Dodaj do 10 komponentów do jednej strony`,
"font-evaluate-module-v1-fair-and-bad":`Gdy rodzaj oceny jest Neutralny i Negatywny`,
"label.partnerCloud.orderingPlatform.orderInformation":`Potwierdzenie zamówienia`,
"label.custom.lead.conversion.notice":`Przypomnienie o konwersji ołowiu`,
"label.re.upload":`Ponowne ładowanie`,
"label.knowledgebase.top.window":`Okno górne`,
"label.h5.allmarkedasread":`Wszystkie zaznaczono jako przeczytane`,
"vue_label_SMS_open_record_from_start_activation":`Otworzyć rekord z listy, który ma być aktywowany.`,
"label.customer.tab.step2":`Krok 2 Dodaj do profili`,
"label.campaign.channel.input.owner.select2":`Osoba nagabująca w tym kanale marketingowym`,
"component.task.button.save":`Zapisz`,
"front-kefu-moudle-v1-phone-type":`Typ telefonu`,
"label.wedge-shapearrows":`Strzałka ogonowa w kształcie klina`,
"vue_label_homepage_todaysevent":`Dzisiejsze wydarzenia`,
"label.data.exp.way.sel":`Wybierz tryb eksportu`,
"label.setting.intergrationlist.status1":`Ta integracja nie jest obecnie zainstalowana.`,
"button_partner_workspace_disable":`Anuluj aktywację`,
"label.customfields.reference":`Może być przywoływany przez inne pola, takie jak formuły, listy wyboru, pola wyszukujące itp.`,
"label.publicgroups.new":`New Pubilc Group`,
"label.data.setok.e_desc3":`， pobierz wyeksportowane dane.`,
"vue_label_commonobjects_view_chart_countmode":`Tryb liczenia`,
"label.service.appointmentList.earliest.allowedStart":`Najwcześniejsza data rozpoczęcia pracy`,
"label.data.choses.e.desc":`W zależności od potrzeb można wyeksportować wszystkie dane lub wyeksportować dane z danego obiektu.`,
"label.multilang.common.fieldlist.fieldremark":`Zastosuj do pól widocznych na stronie {0}`,
"label.umeng.activity.event":`wydarzenie`,
"label.project.hit.ten":`Przypomnienie o aktualizacji emisji`,
"label.c_d_least":`Każdy rekord "C" musi mieć co najmniej jeden powiązany rekord "D".`,
"label.emailobject.wizard.btn1":`Połącz swoją pocztę e-mail`,
"lable.product.pricebooks.info":`Szczegóły książki cenowej`,
"component_telerecord_label_message":`Komentarz`,
"lable.total.of.estimates":`0 szacunków ogółem`,
"label.stdashbord.xsld.business.oppcounts":`Ilość możliwości`,
"vue_label_commonobject_duplicatewith":`Duplikat {1} w {0}`,
"label.setpicandreport":`Ustawienia wykresu`,
"label.category.2":`Ogólne`,
"label.emailtocloudcc.reauthorization":`Reautoryzacja`,
"label.chatter.vote":`Sondaż`,
"label_emailtocloudcc_edit":`Edytuj`,
"label.pleaseinput":`Wejście`,
"vue_label_homepage_user_particular_application":`Strona główna, gdy użytkownik korzysta z danej aplikacji, zadania zastępują standardową stronę główną`,
"label.allianceID":`Identyfikator urządzenia`,
"label.h5.homepage.cannot.applied.mobile.terminal":`Strona główna profilu nie jest skonfigurowana dla tego profilu. Nie jest ona dostępna dla aplikacji mobilnej.`,
"label.appointmentpage.wizard.notif2":`Imię i nazwisko jest wymagane!`,
"label_emailsync_status_email":`Wykonane działanie Email`,
"label.icon.179":`Ludzie`,
"UG_Contract_03":`Tworzenie umowy`,
"label.cy.new":`Nowa waluta`,
"label.version.setup.controllist":`Lista kontrolna ustawień`,
"label.vlidaterule":`Zasady walidacji`,
"label.customer.tab.name":`Zakładka Nazwa`,
"label.recentview.seloption1":`Ostatnio oglądane`,
"vue_label_report_notice_nameisrequired":`Nazwa raportu jest wymagana`,
"label.createapproveprocessstep":`<li>1.Przeczytaj tematy pomocy</li><li>2.Utwórz szablony wiadomości e-mail</li><li>3.Utwórz szablony wiadomości SMS</li><li>4.Utwórz proces zatwierdzania, korzystając z kreatora Jump Start lub Standard</li><li>5.Dodaj listę powiązaną "Historia zatwierdzania" do wszystkich układów strony</li><li>6.Aktywuj proces, aby wdrożyć go u użytkowników</li>.`,
"label.gotocalendar":`Przejdź do kalendarza`,
"label.import.page1.pleaseselectobj":`Proszę najpierw wybrać obiekt`,
"label_tabpage_messagez":`Proszę wpisać komentarz`,
"vue_label_homepage_profilepage":`Strona główna profilu`,
"label.tabpage.choose":`Wybierz`,
"label.campaignmember.setup.lead.field":`Pola tropów`,
"label.setalipay.null":`Informacje wymagane do skonfigurowania Alipay są puste.`,
"label.custom.Current.and.NextCQ":`Aktualne i następne CQ`,
"label.knowledgebase.needto.publish.articles":`Resotre zarchiwizowanego artykułu utworzy wersję roboczą. Czy chcesz opublikować artykuł?`,
"pagecreator.layout.message.save.success":`Układ został zapisany pomyślnie`,
"homepage.componet.approval.label":`Punkty do zatwierdzenia`,
"label.last_submission":`Ostatni zgłoszony czas`,
"lable.outlook.detail.prefo":`Wymiana zawsze wygrywa`,
"label.projectManagement.new.subtask":`Nowe podzadanie`,
"label.service.appointmentList.checkThe":`Sprawdzono`,
"message.error.searchlayoutselectdefields":`Nie może być usunięty i musi być pierwszym polem w układzie wyszukiwania.`,
"label.ems.normal":`Normalna`,
"vue_label_notice_pleaseselectobject":`Proszę wybrać obiekt`,
"component.sendmail.button.send":`Wyślij`,
"label.relevant.records":`Powiązane zapisy`,
"label.weixin.login.CloudCC":`Zaloguj się`,
"label.tag.addtags.private":`Prywatna`,
"label.appointment.disable.remark":`Przepraszamy, ta funkcja jest obecnie wyłączona. Jeśli chcą Państwo zmienić termin lub odwołać spotkanie, prosimy o kontakt z osobą odpowiedzialną pod numerem telefonu {邮箱地址}.`,
"label.campaignmember.main.addMember1":`Dodaj członków`,
"message.error.objectnofound":`Obiekt nieokreślony`,
"label.employeenum":`Numer pracownika`,
"label.search.applyfilter":`Zastosuj filtr`,
"label.version.history.track.nonsupport":`Tylko wersja nieskończona obsługuje funkcję historii śledzenia pól.`,
"label.ccpeak.direction.for.use.time":`Instrukcja do zajęć planowych [Wersja 2.0]`,
"label.ems.settings":`Ustawienia`,
"label_tabpage_arecordtypez":`Dostępny typ rekordu`,
"vue_label_pool_assign1":`{1}{2}`,
"label.customcomponent.direction.for.use":`Instrukcja dla komponentów własnych [ wersja 2.0]`,
"label.appupload.appname":`Nazwa pakietu`,
"label.cpq.order.status.no.active":`Tylko zlecenia z aktywnym statusem mogą generować umowy`,
"label.dashboard.maxlength":`Można wprowadzić do 255 znaków`,
"label.customize.memory.function.sorting.title2":`Pamięć sortowania nagłówków`,
"label.report.chose.obj":`Proszę wybrać relację obiektową i źródło danych raportu`,
"label.partner.step3":`Krok 3 Informacje podstawowe`,
"message.report.type.error.fail":`Nieprawidłowe źródło danych raportu.`,
"pagecreator.page.message.publish.fail":`Publikacja strony nie powiodła się`,
"label.minimun":`Minimum`,
"label.state":`Status`,
"label.customcomponent.referencetype":`Typ odniesienia`,
"label.nameandemailtemplate":`Wprowadź nazwę procesu w polu poniżej, a następnie wybierz szablon wiadomości e-mail, aby powiadomić osobę zatwierdzającą (opcjonalnie).`,
"label.customobjects.track.introduce":`Ta strona umożliwia wybranie pól, które mają być śledzone na stronie`,
"label.campaign.matchway.label":`Metoda dopasowania`,
"label.redistribution":`Ponownie przyporządkuj`,
"label.groupmanage":`Zarządzanie organizacją`,
"label.icon.157":`Kamera`,
"label.quickbooks.viewlist.total":`OGÓŁEM`,
"label.file.copy.file.fail":`Kopiowanie nie powiodło się, proszę skopiować ręcznie`,
"label.outline.selectfield":`Wybrane pola w podsumowaniu:`,
"label.datetime.maxsize":`Cykl zapytania nie może być dłuższy niż trzy miesiące.`,
"label.dashboard.CustomDashboardMyHomePage":`Dostosuj pulpity mojej strony głównej`,
"label.data.customobject":`Obiekty niestandardowe`,
"vue_label_SMS_noselected":`Nie wybrano żadnego zapisu`,
"label_tabpage_value":`Wartość`,
"label.quote.qianming":`Podpis`,
"label.view.source":`Wyświetl kod źródłowy`,
"label_popup_infoz":`Prompt`,
"label.emailtocloudcc.redmessage8":`Błąd parametru, prosimy o kontakt z administratorem.`,
"label.tianyancha.Search.business":`Wyszukiwanie informacji dotyczących rejestracji przedsiębiorstw`,
"vue_label_systemSettings_server":`Serwis`,
"vue_label_homepage_dashboard_components":`Komponent tablicy rozdzielczej`,
"label.search.listview":`Widok listy`,
"label.service.gantt.distribution.success":`Przydzielony z powodzeniem`,
"label.icon.4":`Portfel`,
"label.partnerCloud.orderingPlatform.calculate":`Oblicz cenę`,
"label.forecast.edittotal.ycyx":`Prognoza Priorytety`,
"vue_label_commonobjects_detail_to_precise_search":`Dokładne wyszukiwanie`,
"label.order.number":`Zamówienie`,
"setup.mainpage.label.welcome7":`Instrukcje: Klikamy na menu po lewej stronie → Ustawienia aplikacji → Utwórz → Obiekt → Nazwa obiektu → Pole własne.`,
"label.weixin.user.binding":`Wiązanie użytkownika`,
"label.custom.canvas.size":`Rozmiar płótna`,
"label.projectManagement.recent.projects":`Najnowszy projekt`,
"vue_label_helpcenter_lead":`Śledź i zarządzaj swoimi leadami poprzez Cloud CC. Użyj skonfigurowanych reguł, aby oceniać i przypisywać leady oraz konwertować je na klientów, kontakty i odpowiednie możliwości biznesowe we właściwym czasie.<br>Ocena<br>W prawym górnym rogu widoku użyj przycisku oceny partii, aby oceniać leady w widoku.<br>Dystrybucja<br>Podczas tworzenia lub edycji leadu wybierz opcję Przypisz na dole strony, aby przypisać lead do odpowiedniego personelu w celu przetworzenia go zgodnie z istniejącymi zasadami.<br>Konwersja<br>W odpowiednim momencie możesz przekonwertować leady na klientów i kontakty, klikając przycisk konwersji w prawym górnym rogu strony szczegółów. W tym samym czasie, można tworzyć odpowiednie możliwości biznesowe i zadania, aby ułatwić dalsze śledzenie możliwości transakcji.`,
"label.enabledprocess":`Aktywne procesy zatwierdzania`,
"label.emailobject.noemail":`Nie ma jeszcze maila, wyślij go!`,
"label.validate.remark3":`Określenie, czy pole jest wymagane na podstawie wartości innego pola`,
"vue_label_salesadvance_retention":`Retencja`,
"label.product.managep":`Zarządzaj ceną książek`,
"font-evaluate-module-v1-not-report":`Nie otwierać ponownie`,
"label.emailmerge.mergepage.step1":`1.Wybierz rekordy do połączenia:`,
"front-epwechat-module-v1-epwechat-describe":`CloudCC zapewnia integrację z WeCom, łącząc potężne funkcje WeCom z lekkiej wersji H5 systemu CloudCC,<br /> pomagając wygodnie zarządzać relacjami z klientami, obsługiwać prywatny ruch domenowy i poprawić przychody przedsiębiorstwa.`,
"label.partner.template.detailimage":`Zdjęcie`,
"label.recycle.clearall":`Opróżnij kosz swojej organizacji`,
"chatter.error.nottype":`Error:Invalid file type.Please use JPG,GIF or PNG files.`,
"pagecreator.button.cancel":`Anuluj`,
"front-market-form-quired-ziduan":`Wymagane pola na stronie rejestracji`,
"vue_label_report_columnname":`Nazwa kolumny`,
"message.notdelete.type":`Nie można usunąć tego typu rekordu, ponieważ poniższe profile używają tego typu rekordu jako wartości domyślnej.`,
"label.ccpeak.folder.all.time":`Wszystkie foldery z planowanymi zajęciami`,
"label.quickbooks.searchlist.total3":`Istnieje {0} niepowiązanych szacunków o łącznej wartości {1}.`,
"label.forecast.detailforecast.quantity":`Ilość Prognoza`,
"label.knowledge.language.british":`Brytyjczycy`,
"label.vlidaterule.example.messagelocation":`Ten komunikat o błędzie może pojawić się na górze strony lub pod określonym polem na stronie`,
"front-kefu-moudle-chf-success":`Pomyślny podział`,
"vue_label_jihui_yi":`Szansa 1`,
"label.import.step1.null":`Brak dostępnych opcji`,
"label.console.step5.tab.subtab":`Jako podzakładka`,
"batch.edit.permission":`Brak uprawnień do edycji`,
"label.weixin.fmu.before.min":`{0} minut przed czasem`,
"chatter.up.file":`Przesyłanie plików zajmuje trochę czasu, w zależności od wielkości przesyłanego pliku, proszę czekać.`,
"setup.layout.group.field":`Pola`,
"label.chat.unlike":`Lubiana`,
"vue_label_dashboard_updatefrequency":`Częstotliwość aktualizacji`,
"label.trigger.folder.new":`Strony wyzwalające: Nowy Folder`,
"label.process.des.app":`Kliknij prawy link, aby wyświetlić szczegóły bieżącego rekordu.`,
"vue_label_pool_assignselect":`Wybierz, aby przypisać członków`,
"label.lookup.user":`Wyszukaj współpracowników`,
"label.mobilescreentablayoutedit.remark2":`Wybierz pola filtrujące wyświetlane na stronie głównej zakładki w aplikacji mobilnej.`,
"label.data.exp.objtemp":`Szablon do eksportu danych tego obiektu stworzysz w następujący sposób cretira`,
"label.weixin.moreselect.error":`Tylko 10 rekordów, które można wybrać`,
"label.icon.25":`Bandaż`,
"lable.sample.text":`Przykładowy tekst`,
"label.most.setup.obj":`Można ustawić do 10 obiektów.`,
"label.weixin.coming":`Wejście na stronę`,
"label.editdescription":`Uwaga`,
"label.multipleactivity.multiple":`Wielu użytkowników`,
"label.sso.saml.idp.entityid":`Identyfikator podmiotu`,
"label.SMS.pho.filed":`Pole telefoniczne`,
"message.serviceabsence.violation":`Naruszenie okresu przydziału: jest w konflikcie z zapisem nieobecności.`,
"label.forecast.settings.type.clist":`Użyj Rodziny produktów`,
"label.state.noend":`Niekompletny`,
"label.sourcetemp":`Źródło`,
"vue_label_chatter_name_link":`Proszę wpisać imię i nazwisko oraz link`,
"label.emailobject.attach":`Dołącz`,
"label.everyother":`Każdy inny`,
"label.title":`CloudCC.com`,
"vue_label_chat_haventactivate":`Nie aktywowałeś jeszcze konta czatu. Czy chcesz aktywować teraz?`,
"pagecreator_layout_button_delete":`Usuń układ`,
"label.transfer.temporarily":`Zadzwoń na`,
"label.service.dispatchingUnits.search.services":`Wyszukiwanie terminów usług`,
"customer.message.fail.chat":`Nie udało się uzyskać rekordów wiadomości, proszę skontaktować się z administratorem w celu uzyskania pomocy`,
"label.apiname.toolong":`Nazwa API jest zbyt długa.`,
"label.empty.filter":`Wyczyść filtry`,
"label_tabpage_personalCenterz":`Centrum osobiste`,
"label.minutes":`Minuta`,
"label.multipleactivity.atasks":`Zadanie(a)`,
"label_tabpage_deleteview":`Usuń widok`,
"pagecreator_layout_message_save_success":`Układ został zapisany pomyślnie`,
"label.reportlineorder":`Kolejność kolumn raportu`,
"label.total.forecast.have.priority":`każda predykcja jest wcześniejsza, ale te, które akceptują inne podpredykcje są wcześniejsze`,
"label.custom.quarter.subtitle":`Custom Quarter`,
"label.icon.79":`Drukuj`,
"label.hiddenoperate":`Ukryj działania`,
"label.project.hit.six":`Zawiadomienie o przydziale zadań`,
"label.visualpageaction.errordesc":`Nie masz uprawnień do wykonania żądanej operacji. Skontaktuj się z właścicielem rekordu lub swoim administratorem.`,
"label.chat.unmute":`Anuluj "nie rozpowszechniać"`,
"label.zhaiyao":`Streszczenie`,
"vue_label_commonobjects_detail_bcc":`Bcc`,
"label.customcomponent.page.index.table.version":`Wersja API`,
"UG.quota.06":`Utwórz ofertę`,
"label.icon.152":`Robot`,
"label.partnerCloud.partnerAccount.account":`Nazwa użytkownika`,
"label.file.sharewith":`Sharer`,
"label.data.dataexptemplate.desc2":`2. Format kompresji jest podzielony na dwa typy: jeden to automatyczne generowanie hasła do skompresowanego pliku, drugi to ręczne wprowadzanie hasła do skompresowanego pliku.`,
"vue_label_dashboard_newfoldersuccessfully":`Pomyślne utworzenie nowego folderu`,
"label.campaignmember.main.importmember":`Członkowie kampanii na rzecz masowego przywozu`,
"label.htyj.completed":`Zakończono`,
"label.reportTypeLabel":`Typ raportu Etykieta`,
"label.customer.tab.label":`Zakładka Etykieta`,
"label.dashboard.component":`Komponenty`,
"label.safetystatement.dialog":`Oświadczenie o bezpieczeństwie (nowe okno)`,
"label.forecast.settings.data":`Prognoza Data`,
"label.knowledgebase.modifiedby":`Zmodyfikowane przez`,
"label.batchadd.remark":`Dodaj wiele rekordów`,
"button.partner.delete":`Usuń`,
"Pagelayout_Setup_005":`Nazwa musi być umieszczona na pierwszym miejscu.`,
"label.forecast.edit.wcpxl":`Brak Rodziny produktów`,
"lable.PowerProcess.seq.input":`Proszę wprowadzić zamówienie.`,
"pagecreator.layout.message.delete.fail":`Usuwanie układu nie powiodło się`,
"label.emailobject.edit":`EDIT`,
"label.weixin.million":`Dziesięć tysięcy juanów`,
"setup.mainpage.button.manageobject":`Zarządzanie obiektami`,
"label.weixin.participants.perfect.information":`Uczestnicy są zobowiązani do poprawy informacji`,
"vue_label_campaign_campaign_members":`Dodaj członków kampanii`,
"label.ccchat.person.invite.emplaceholder":`Wpisz adresy e-mail i oddziel je średnikami.`,
"label.mobile.phone.new":`Nowy`,
"font-evaluate-module-v1-small-program-evaluation-settings":`Konfiguracja oceny miniprogramu`,
"UG.opportunity.005":`Wielokrotny proces sprzedaży`,
"vue_label_report_polymerization":`Agregat`,
"label.multilang.lookfiltercondition.fieldtypenotmate":`Warunek linii {0} jest nieprawidłowy, typ pola nie pasuje!`,
"label.knowledgebase.delete.draft":`Usunąć projekt?`,
"label.mr.descreption.condition3":`Reguła - dokładne dopasowanie: sprawdź tę pozycję i znajdź duplikaty rekordów według tych samych znaków pola. Jeśli zaznaczone, znajdź duplikaty po kilku pierwszych znakach zostaną unieważnione.`,
"Lead.Auto.Scoring.Setting":`Lead Scoring Setting`,
"label.marketing.channel.default":`Kanał marketingowy (domyślnie włączony)`,
"front-project-module-v1-select-projecttemplate":`Wybierz szablon projektu`,
"front-email-payment-select-area":`Proszę podać dzielnicę`,
"lable.PowerProcess.message":`Informacja o procesie nabywania uprawnień`,
"label.weixin.free.get.captcha":`Pobierz kod weryfikacyjny za darmo`,
"label.projectManagement.please.select.task.or.question":`Proszę wybrać zadanie/problem`,
"label.pacific.daylight.time":`Czas pacyficzny (Pacific Daylight Time)`,
"label.sendsms.batch.step1.introduce":`Wybierz jeden z poniższych widoków (który zawiera odbiorców tej wiadomości SMS)`,
"label.same.analyze.account.name":`Nazwa konta`,
"Homepage.Contract.FieldMissed.DoesntSupport":`W obiekcie umowy nie ma pól "qdrq" i "htje", więc nie można pokazać tych danych.`,
"label.partnerCloud.orderingPlatform.noProduct":`Nie jest wymagana konfiguracja opcji produktu w ramach tego produktu.`,
"label.totalsummary":`Podsumowanie rozwinięcia`,
"label.partner.workspace.tab":`Zakładka`,
"label.entitlement.process.name.unique":`Ta nazwa już istnieje. Proszę wpisać ponownie.`,
"report.label.norole":`Nie masz na to pozwolenia, skontaktuj się z administratorem.`,
"label.password.old.error":`Stare hasło jest nieprawidłowe, proszę wpisać ponownie.`,
"lable.account.quarter.stadate":`Dzień rozpoczęcia kwartału podatkowego`,
"label.salescloud.contactrole.choose.correct":`Wybrano podwójne kontakty, proszę poprawić.`,
"label.schedulejob.setup.schedule.day":`Dzień`,
"label.communalusergroup":`Grupy publiczne`,
"label.Display.Fields":`Pola wyświetlane na liście przydziałów służbowych`,
"label.marketsea":`Basen`,
"label_partner_setup_address":`Adres chmury partnera`,
"label.industrialandcommercialverification.label.url":`URL`,
"lable.data.exp.newtemp":`Eksport danych i tworzenie szablonów`,
"label.pc.ui.2018":`Pionowe`,
"label.version.free":`Free Edition`,
"label.dataimport.contact.length":`Błąd: długość nazwy kontaktu jest zbyt duża`,
"label.cy.vlidate":`Akcja włączonej waluty jest nieodwracalna. Czy na pewno chcesz włączyć zarządzanie walutami?`,
"label.recycle.all":`Wszystkie pojemniki na surowce wtórne`,
"label.message.changeaccount.isnot":`Kontakt ma włączonego użytkownika partnerskiego, nie może zmienić konta`,
"label.searchlayout.exactsearch":` Wskazówka: Zaznacz pole wyboru za polem wyszukiwania, aby przeprowadzić dokładne wyszukiwanie dla tego pola.`,
"label.file.size.limit":`Uwaga: Maksymalny rozmiar pliku to 10M.`,
"label.mobileapp.modelsetting1":`Ustawienia standardowego modułu mobilnego`,
"template.report.overall.sales.opportunities":`Całkowity okres sprzedaży (według typu możliwości)`,
"label.password.update.success":`Hasło zostało zmienione pomyślnie.`,
"label.import.page3.gobackhome":`Powrót do domu`,
"label.phone":`Telefon`,
"label.detail.vlidaterule":`Wyświetlanie reguł walidacji`,
"label.weixin.input.usernames":`Wpisz swoją nazwę użytkownika`,
"label.icon.85":`Transformator`,
"vue_label_systemSettings_partner":`Partner`,
"label.processsetting.new.process":`Nowy proces`,
"Lead_Scoring_Setting_Rule_Setup_01":`Lista zasad Lead Scoring`,
"setup.layout.component.area":`Obszar`,
"label.createnewpwdinformuser":`Wygeneruj nowe hasło i natychmiast powiadom użytkownika`,
"label.pwinfo":`Szczegóły hasła`,
"label.imgfield.type.url":`Obraz referencyjny`,
"label.attendance.sxccheckincy":`Odprawa członków kampanii`,
"lable.PowerProcess.condition.input":`Proszę wybrać stan.`,
"label.partnerCloud.partnerAccount.topUpFailure":`Uzupełnienie fialed`,
"label.document.size.too.long":`Przekroczony rozmiar dokumentu`,
"label.link":`Link dostępu`,
"label.partnerproduct.sort.repeat":`Pobierana jest nazwa rodziny produktów.`,
"label.data.setok.e_desc2":`Strona z listą eksportowanych danych`,
"front-project-module-v1-plase-input-project-name":`Proszę wpisać nazwę projektu`,
"label.export":`Eksport`,
"label.icon.45":`Kocioł`,
"label.autoRegister.changepwd.title":`Ustaw swoje hasło logowania`,
"label_clear_adjust":`Wyraźna regulacja`,
"front-kefu-moudle-return-visit":`Przegląd`,
"label.ems.compose":`Skomponuj`,
"Pagelayout_Setup_002":`Wybrałeś 3 listy powiązane, a dodanie kolejnych list powiązanych będzie miało wpływ na układ strony.`,
"label.service.gantt.skill.screening":`Użyj filtra umiejętności`,
"label.partnerCloud.basicSetting.enable":`Chmura Partnerska zostanie dezaktywowana. Czynności logowania i edycji w Twojej organizacji zostaną automatycznie wyłączone przez system.`,
"label.workbanch.setup.description":`Możesz skonfigurować następujące widoki, które będą wyświetlane w My Workbanch.`,
"label.category.1":`Wszystkie`,
"label.foldername":`Nazwa folderu`,
"label.forecast.settings.shuliang":`Ilość`,
"label.emailmerge.newtemplate.word":`Prosimy o przesłanie dokumentów Microsoft Word.`,
"message.error.type":`typ nie może być pusty, musisz podać typ public public lub personnel private!`,
"label.manualallocation":`Przypisz ręcznie`,
"label.addattachment.step2":`Krok 3 Kliknij przycisk Prześlij plik, aby przesłać plik`,
"label.company":`Firma`,
"label_emailsync_status_export":`Eksport jako plik w formacie Excel_csv`,
"label.eventreminder":`Przypomnienie o imprezie`,
"label.emailtemplate.lookup":`Wyświetl szablony wiadomości e-mail`,
"label.customsetting.touse.getCustomSetting":`Zapytać o typ "hierarchii" ustawień niestandardowych, zwrócić odpowiednią apiName i uprawnienia (ID jest ID profilu lub ID użytkownika), Map = cs.getCustomSetting(String apiName, String id);`,
"label.projectManagement.Resourceuse":`Wykorzystanie zasobów`,
"label.appointment.wizard.subtitle4":`Ustawienia bufora i czasu`,
"label.donot.close.your.browser":`Podczas tego procesu nie należy klikać na inny link ani zamykać przeglądarki internetowej.`,
"label.multilang.customforcast.target":`Cel {0}：`,
"setup_layout_label_newarea":`Nowy obszar`,
"component.timeline.button.more":`Więcej kroków`,
"label.appointmentdetail.wizard.title3":`Czas trwania pomocy`,
"label.help.new.features.pc":`Instrukcja obsługi nowych funkcji po stronie komputera`,
"label.mr.record":`Zapis`,
"label.trigger.wgd":`Niewypełnione wyzwalacze`,
"label.icon.72":`Skrzynka narzędziowa`,
"setup.layout.label.detailpage":`Szczegółowa strona`,
"frame.personinfo.label.usethisimage":`Będziemy używać wariantów tej miniaturki w całej aplikacji.`,
"label.multilingual.confirm.open":`Czy na pewno chcesz włączyć? Po włączeniu można używać wielu języków.`,
"label.recordcreater":`Utworzony przez`,
"label.afterfinish":`Po zakończeniu kliknij przycisk Zapisz.`,
"label.companyinformation":`Informacje o firmie`,
"step1":`Krok 1`,
"label.sales.page.dashboard.add":`Dodaj do pulpitów głównych`,
"label.processsetting.process.enabled.failed":`Nie udało się usunąć procesu!`,
"label.document.history.date":`Data`,
"label.linkedin.title":`LinkedIn-H5MiniApp`,
"label.foldervisitlimit1":`Dostęp do tego folderu mają wszyscy użytkownicy`,
"april":`Kwiecień`,
"label_emailsync_form_disconnect":`Anuluj połączenie`,
"label.appointment.wizard.subtitle4-2-6":`2 dni`,
"vue_label_notice_follow_success":`Followed`,
"label.startuploadfile.success":`Po kliknięciu na "Start Upload", jeśli pasek postępu osiągnie 100%, plik został przesłany pomyślnie i znika w górnym obszarze.`,
"message.accesstoken.acquisition.failed":`Nie udało się uzyskać tokena dostępu!`,
"label.quickbooks.fieldlabel.fistname":`Imię`,
"label.appointment.wizard.subtitle1-5":`1 h`,
"2018UI.Homepage.DataNoAccess.Info":`Nie masz uprawnień do przeglądania tego rekordu, kliknij, aby powrócić do poprzedniego kroku.`,
"label.batchaddattachments":`Masa Dodaj załącznik`,
"label.ems.next":`Następny`,
"label.quote.zhekou":`Rabat`,
"lable.product.notdel":`Ponieważ jest to nadal w podręczniku z innym rekordem książki cenowej.Powiązane rekordy są następujące.`,
"label.ems.action":`Działanie`,
"message.error.chart.type":`Typy wykresów nie mogą być puste.`,
"label.conditiontag.lookup.value":`Wartość`,
"label.chatter.allactivity":`Wszystkie działania`,
"label.summaryreport":`Raporty podsumowujące`,
"label.textmessage.vonage.action":`Działanie`,
"label.ccpeak.must.result":`Musi użyć as, a następnie aliasów, aby pobrać z wyniku`,
"label.data.newtemplate.savetemp.desc":`Proszę dokładnie wpisać nazwę szablonu i opis, aby ułatwić korzystanie z niego.`,
"label.projectManagement.search.for.users":`Wyszukaj użytkownika`,
"component.milestones.label.title":`Kamień milowy`,
"vue_label_applauncher_description_accountpool":`Wykorzystaj Pulę Kont, aby wygodnie zarządzać statusem kontynuacji w organizacji i motywować pracowników do realizacji transakcji.`,
"label.import.index.startimport":`Rozpocznij import`,
"page.field.masterinput2":`Wejście główne-szczegółowe`,
"label.mobile.change.owner.permission":`Nowy właściciel musi mieć uprawnienia "Odczyt" do tego typu rekordu.`,
"label_partner_common_enable":`Włączenie chmury partnerskiej`,
"label.log.browser":`Przeglądarka`,
"label.app.step4":`Krok 4 Wybierz zakładki`,
"lable.quote.syncing.opportunity":`Możliwości`,
"label.forecast.customforecast.foredis.jqz":`Dokładna wartość`,
"label.forecast.forecastroleuserpage.title":`Kierownik Prognoz Przydziału`,
"label.starting.quarter":`Kwartał początkowy`,
"label-combination-record":`Rekord {index}`,
"label.here":`tutaj`,
"label.weixin.underfind.error":`Nieznany błąd`,
"label.cloudccclass.list.tip.time":`Umożliwienie programistom tworzenia zaplanowanych zajęć na platformie CloudCC.com, które mogą być wykorzystywane w zaplanowanych programach.`,
"label.data.setok.t_desc1":`Jeśli chcesz użyć tego szablonu danych pochodnych, proszę kliknąć`,
"label.service.gantt.break.rules":`Łamanie zasad`,
"label.weixin.no.pending.ywjh.qin":`Brak możliwości w ciągu najbliższych 30 dni`,
"label.view.atleastone":`Lista nie może być pusta.`,
"label.attendance.sxccheckin":`Uczestnictwo w kampanii`,
"label.custom.split":`Split`,
"front-kefu-moudle-v1-yesorno-delete-templete":`Czy na pewno chcesz usunąć ten szablon?`,
"label_chatter_theme":`Tematy`,
"label.partner.new.step1":`Krok 1 Wybierz szablon, który Ci się podoba`,
"vue_label_commonobjects_view_settings":`Ustawienia widoku Kanban`,
"UG_Contract_02":`Kontrakt jest pisemną umową pomiędzy stronami. Wiele firm korzysta z kontraktów, aby określić warunki prowadzenia działalności z innymi firmami. Wykorzystaj CloudCC do tworzenia i dokumentowania istniejących umów z klientami i możliwościami biznesowymi. Śledź umowę przez proces zatwierdzania. Używaj przypomnień o przepływach pracy, aby przypomnieć o przedłużeniu umowy.`,
"label.setup.mobilesetup.isenableh5newandedit":`Włącz możliwość edycji i tworzenia nowych H5 w aplikacji mobilnej.`,
"label.attendance.edit":`Frekwencja Edycja`,
"label.service.miniProgram.fillImageLink":`Proszę wpisać link karuzeli.`,
"label.b.c.without":`Rekordy B mogą, ale nie muszą mieć powiązanych rekordów C.`,
"label.sso.key":`Kod autoryzacji`,
"label.star_click":`Kliknij, aby wyczyścić`,
"vue_label_SMS_name_or_phone_number_lookup":`wyszukiwanie nazwy rekordu`,
"label.case.copre.text":`Możesz również pobrać dedykowany Twojej firmie kod QR portalu internetowego i umieścić go na swojej stronie internetowej lub urządzeniu, wówczas klienci będą mogli zeskanować kod QR, aby skorzystać z internetowej wersji portalu dla klientów.`,
"label.salescloud.forbidden.confirm":`Czy na pewno chcesz wyłączyć zespoły możliwości?`,
"vue_label_chat_conformactivation":`Potwierdź aktywację`,
"label.emailtocloudcc.redmessage9":`Błąd bazy danych, prosimy o kontakt z administratorem.`,
"label.sahreto":`Podziel się z`,
"label.recordtype.sort":`Typy rekordów są wyświetlane w kolejności, w jakiej zostały zapisane.`,
"label.allreport":`Wszystkie raporty`,
"front-gantt-module-drag-and-drop-subtask":`Przeciągnij (umieść w zadaniu), aby uczynić je podzadaniem!`,
"label.permission.objlist.nopermission":`Brak dostępu`,
"label_file_num":`Ilość`,
"chatter.mostword":`Twój komentarz ma więcej niż 500 słów, proszę usunąć i wpisać ponownie.`,
"label.h5.chatter.comment":`Komentarz na temat ciała`,
"vue_label_calendar_notice_havecreated":`Utworzyłeś kalendarz`,
"label.tabpage.loadz":`Ładowanie strony, proszę czekać...`,
"chatter.w.p":`Telefon służbowy`,
"label.chat.topic.name.desc":`Możesz zmienić tylko wielkość liter i odstępy w nazwach tematów.`,
"label_partner_template_name":`Nazwa szablonu`,
"label.mobile.phone.required.examines.people":`Wymagany jest dokument Revised By.`,
"message.error.view.notexists":`Widok nie istnieje.</br> Lub widok mógł zostać zmodyfikowany przez kogoś innego, kliknij <a href='javascript:history.back();'>tutaj </a>aby powrócić.`,
"label.custom_time":`Czas niestandardowy`,
"label_partner_workspace_member_all":`Wszystkie`,
"lable.custom.year.name":`Nazwa własna Rok`,
"label.account.previous.M":`Ostatni miesiąc`,
"vue_label_commonobjects_detail_locking":`Zamek`,
"label.brief.lead":`Leads`,
"label.linkedin.setting.appsecret":`Hasło tajnego klucza`,
"label.query.detail.closepartner":`Wyłączenie partnerów`,
"label.isEnableVisualpage_new.rightlist":`Aktywne strony niestandardowe`,
"front-epwechat-module-v1-unbound-item3":` dane autoryzowanych informacji`,
"label.exchange.sync.setting.info":`Po skonfigurowaniu konta serwisowego z uprawnieniami do podszywania się pod użytkowników w Microsoft©Exchange, wprowadź dane uwierzytelniające konta serwisowego, aby umożliwić CloudCC komunikację z serwerem Exchange. Jeśli dane uwierzytelniające konta serwisowego zostały zapisane, ale użytkownik nadal nie może synchronizować rekordów, należy upewnić się, że została skonfigurowana synchronizacja Exchange Sync.`,
"label.emailobject.groupemail.fail.title":`Nie udało się wysłać wiadomości e-mail do grupy CloudCC`,
"label.the.upper.bound.of.each.level.of.edit.discount.must.be.greater.than.the.lower.bound.":`Górna granica dla edycji każdego poziomu rabatu jest większa niż dolna granica.`,
"label.visualpage.list.vpname":`Własna nazwa strony`,
"label.mask.length.error.message":`Zaszyfrowane pole tekstowe nie może zawierać więcej niż 255 znaków`,
"label.h5.approval.actorname":`Zgłoszony przez`,
"label.knowledgebase.view.translation":`Zobacz tłumaczenie`,
"label.ems.edit":`Edytuj`,
"vue_label_commonobjects_view_reset_width":`Wyzeruj szerokość kolumny`,
"label.version.feature.controllist":`Lista limitów funkcji`,
"label.setuppagelayout":`Układy stron`,
"vue_label_commonobjects_view_new_view":`Nowy widok`,
"label_tabpage_queuez":`Kolejka`,
"label.direct.dashboard.wait.me.approval":`Punkty do zatwierdzenia`,
"message.report.error.noRelatedField":`Brak powiązanych pól z raportem. Mogły zostać usunięte, prosimy o kontakt z administratorem.`,
"label.ccchat.person.invite.notme":`Nie możesz wysyłać zaproszeń na swój własny adres e-mail.`,
"label.weixin.jieduan.finish":`Oznacz bieżący etap jako zakończony`,
"vue_label_commonobjects_detail_?enter_subject":`Proszę wpisać temat`,
"label_starting_month":`Miesiąc początkowy`,
"label.address_linetwo":`Adres Linia 2`,
"message.error.select.contiguous.item":`Wybór odpowiednich pozycji z`,
"vue_label_pricebook_enterbookname":`Proszę wpisać nazwę cennika`,
"label.cycleworkflowoperate":`Okresowe akcje przepływu pracy`,
"label.ems.withoneday":`Dzisiaj`,
"component.todaytask.label.notask":`Dzisiaj nie ma zadania wygaśnięcia, weź kawę.`,
"label.tianyancha.id":`Identyfikator firmy`,
"label.user.illegal.login":`Nielegalne logowanie`,
"label.withgathercondition":`Według podsumowanych kryteriów`,
"label.foldervisitlimit":`Uprawnienia dostępu`,
"label.ccchat.search.conversation":`Przeszukaj tę rozmowę`,
"lable.annual.project.report":`Raport z rozliczenia projektu w bieżącym roku`,
"template.chart.qzkhzhfx":`Analiza konwersji leadów`,
"label.my":`Mój`,
"label.sendsms.batch.chosetemplate":`Masowa wysyłka SMS: Wybierz szablon lub edytuj treść`,
"label.callcenter.enterprise.number":`Nr przedsiębiorstwa.`,
"label_last_modified_by_time":`Ostatni modyfikator i czas`,
"message.fieldtrack.operaterecord":`Zmieniono nazwę <b>operatefield</b> z<b>operateold</b> na<b>operatenew</b>.`,
"label.mobile.more.openin":`Otwarte w...`,
"label.multilingual.tip2":`Można włączyć lub wyłączyć wielojęzyczność.`,
"label.datamanage.lead.novalue":`Uwaga: Jeśli pole lead name jest puste, rekordy kontaktów nie zostaną zaimportowane.`,
"label.custom.revoke":`Undo`,
"label_chatter_leaveword":`Komentarz`,
"vue_label_ccchat_group_deletedgroup":`Grupa została usunięta.`,
"label.tabpage.operationz":`Pole, operacja nie może być pusta`,
"label.user.organization.permit.overdue":`Twoja licencja organizacyjna wygasła, skontaktuj się z administratorem!`,
"label.log.datetimeoruser.value":`Proszę podać czas zapytania i nazwę użytkownika.`,
"lable.product.stsp.noavailable":`Brak dostępnej ceny standardowej`,
"label.appservice.cannot.delete.app":`Nie można usunąć tej niestandardowej aplikacji, ponieważ niektóre profile używają jej jako aplikacji domyślnej.`,
"component.event.label.newevent":`Nowe wydarzenie`,
"label.view.sortview.exportview":`Widok eksportu`,
"label.uploadfilemaxsize":`Maksymalna dozwolona wartość wysyłania plików to`,
"label.event.weekview":`Widok tygodnia`,
"label.conversion_rate":`Wskaźnik konwersji`,
"label.partnerCloud.partnerAccount.useWechat":`Użyj skanu WeChat, aby zapłacić.`,
"UG_Forcast_05":`Ustawienia prognozy: krok {0}/{1}`,
"label.service.gantt.jobresour":`Pokaż tylko zasoby pracy`,
"vue_label_campaign_fromopprotunities":`Od {dsrjine} możliwości biznesowych`,
"label.app.skyblue":`Sky Blue`,
"label.chinacloudcc":`Chmura obliczeniowa Chiny`,
"label.connectOtherFinalNumber":`Osiągnięto limit obiektów<br/>Do źródła danych raportu niestandardowego można przypisać maksymalnie cztery obiekty.`,
"label.redistributionrequest":`Ponowne przypisanie żądań zatwierdzenia`,
"label.knowledge.category.button.one":`Dodaj podkategorię`,
"label.campagin.pcandmo":`PC i Mobile`,
"label.project.milestone.date":`Data kamienia milowego musi znajdować się w zakresie dat projektu, do którego należy.`,
"assetbom.transfer.notpermission":`Nie masz uprawnień do migracji BOM aktywów. Prosimy o kontakt z administratorem.`,
"label.marketing.setting1":`Kanały marketingowe`,
"label.select.file":`Wybierz Plik`,
"message.error.object.contactadministrators":`System działa nieprawidłowo, należy skontaktować się z administratorem systemu w celu uzyskania pomocy.`,
"label.custom.quarter.title":`Custom Quarter`,
"label.knowledge.case.settings":`Przypadki Ustawienie`,
"front-service-cloud-transfer-title":`Transfer aktywów Właściciel BOM`,
"label.group.search.searchthisfeed":`Przeszukaj ten kanał`,
"label.report.action.addtodashboard5":`Dodaj do nowego pulpitu`,
"label.mobile.side.tab.remark2":`Ustawiając suwak, można umieścić najczęściej używane elementy na pierwszej pozycji. historia połączeń, pozycja menu może być używana tylko dla androidowej wersji CloudCC po stronie mobilnej.`,
"contain":`Włącz`,
"label.select.template":`Wybierz szablon`,
"label.addattachment.step3.weixin":`Krok 3 Kliknij przycisk "Complete" i wróć do poprzedniej strony.`,
"lable.Order.successfully":`Przekazanie zlecenia do aktywów zakończone sukcesem.`,
"label.user.title":`Tytuł`,
"label.weixin.check.agreement":`Proszę sprawdzić odpowiednią umowę`,
"label.SMS.pfi":`Pole numeru telefonu`,
"label.weixin.micro.research":`Mikroankieta`,
"label.projectManagement.assigned.work":`Praca zlecona`,
"label.document.login.error":`Logowanie nie powiodło się, proszę spróbować ponownie.`,
"label.mobile.phone.examines.people":`Zmieniony przez`,
"label.safetyset":`Ustawienia bezpieczeństwa`,
"label_function_tip":`Ta funkcja nie jest obecnie obsługiwana dla użytkowników z Chin kontynentalnych. Dziękujemy za zrozumienie!`,
"label.app.sort":`Sortuj aplikacje`,
"component.sendmail.label.cc":`Cc`,
"label.titlename":`Tytuł`,
"label.event.moveup.3day":`3 dni naprzód`,
"label.condition":`Warunki`,
"label.description.message":`Maksymalnie 500 znaków.`,
"label.ems.detailedsettings":`Ustawienia szczegółowe`,
"label.repeat.condition.field.prompt":`Prosimy o wpisanie liczby w polu "Zgodnie z długością znaków" Filed！.`,
"label.validate.function.funcExplain.OR":`Sprawdza, czy wszystkie parametry są prawdziwe i zwraca TRUE lub FALSE. Zwraca FALSE tylko wtedy, gdy wszystkie parametry są fałszywe.`,
"label.salecommit.allow.prediction.query":`Nie można wyświetlić pulpitów zobowiązań sprzedaży, ponieważ nie zaznaczono opcji Zezwalaj na prognozy w Konfiguracja - Moje informacje osobiste - Ustawienia osobiste.`,
"front-kefu-moudle-soft-phone":`Softphone`,
"label.view":`Zobacz`,
"front-gantt-module-quick-create-task":`Szybkie tworzenie zadań`,
"label.all_forms":`Wszystkie formy`,
"front-lightning-module-v1-dashborad-statistical-dimension":`Wymiar statystyczny`,
"label.forecast.settings.data.chanpin":`Data produktu`,
"label.appointment.wizard.subtitle4-2-7":`3 dni`,
"front-web-module-v1-detail-comment-please":`Proszę wpisać informację zwrotną`,
"label_chatter_nextSevenday":`Następne 7 dni`,
"homepage.components.desctiption":`Ta strona umożliwia tworzenie i edycję komponentów, które mogą być wyświetlane na jednym lub wielu układach strony głównej.`,
"label.customcomponent.page.index.table.namespace":`Prefiks przestrzeni nazw`,
"label_emailtocloudcc_exists":`Email już istnieje.`,
"label_tabpage_save":`Zapisz`,
"label.mergeRechecking":`Powielanie i łączenie czeków`,
"vue_label_helpcenter_view2":`W widoku podzielonego ekranu, można szybko przełączyć się do wyświetlania szczegółowych informacji o każdej danych. <br> 3. Szybko analizować dane sprzedaży<br> W prawym górnym rogu widoku, można otworzyć wykres w widoku, aby wykonać prostą analizę wizualną danych w widoku. W tym samym czasie można wyświetlić pulpit nawigacyjny i listę raportów związanych z danymi widoku do dalszej analizy. <br>?Kliknij przycisk wykresu w prawym górnym rogu, możesz przeglądać, tworzyć, edytować proste wykresy utworzone z danych widoku lub przeglądać pulpity związane z bieżącym widokiem. <br> Krok 1: Kliknij przycisk wykresu w prawym górnym rogu, aby rozwinąć wykres na stronie. Możesz przeglądać i zarządzać istniejącymi wykresami zgodnie z uprawnieniami, a także przeglądać listę pulpitów powiązanych z danymi widoku. <br> Krok 2: Kliknij przycisk Ustawienia, można tworzyć, edytować i usuwać wykresy zgodnie z uprawnieniami. Można utworzyć cztery style wykresów, pionowy wykres kolumnowy, poziomy wykres kolumnowy, wykres kołowy i wykres lejkowy. <br>?Kliknij przycisk raportu, aby wyświetlić raporty związane z bieżącym widokiem. <br>4. Zarządzanie danymi w widoku<br>?W widoku, zgodnie z Twoimi uprawnieniami, możesz dodawać, edytować, usuwać i zmieniać właściciela danych za pomocą przycisków w prawym górnym rogu widoku lub obok każdego elementu danych. <br>?Użyj znaczników, aby pomóc w zarządzaniu danymi. Użyj przycisku po prawej stronie, aby rozwinąć listę zarządzania znacznikami, a następnie możesz filtrować dane w widoku na podstawie znaczników. Po kliknięciu przycisku Zarządzaj znacznikami możesz również utrzymywać i zarządzać biblioteką znaczników. Po wybraniu danych użyj przycisku Dodaj znacznik w prawym górnym rogu, aby dodać znaczniki do danych w partiach.`,
"label.app.ismobile":`Wyświetlane w aplikacji mobilnej`,
"chatter.group.changeTheGroupPicture":`Zmień zdjęcie grupowe`,
"label.mr.descreption.reDataList2":`zapisy powtarzających się`,
"vue_label_chatter_agree_join":`Zgoda na przystąpienie`,
"label.planned.nextrun":`Uruchom w następnym harmonogramie`,
"Homepage.News.003":`Nie można wyświetlić wiadomości bez danych konta, proszę utworzyć nowe konto, a powiązane wiadomości zostaną wyświetlone.`,
"label.summaryreport.selectpictype":`Wybierz typ wykresu i inne opcje graficzne`,
"label.app":`Zastosowania`,
"label.trigger.name":`Nazwa wyzwalacza`,
"vue_label_email_private_template":`Prywatny szablon`,
"label.appointmentpage.wizard.subtitle1":`Wybierz datę i godzinę Strefa czasowa Inviter'a to {0}.`,
"label.partnerCloud.orderingPlatform.payment":`Zamówienie Płatność`,
"label.stdashbord.xsld.title":`Lejek sprzedaży`,
"vue_label_pool_poolname":`Nazwa puli rachunków`,
"label.ServiceCloud.fuwuyuyue.distributionMap":`Mapa rozmieszczenia wizyt serwisowych`,
"front-lightning-module-v1-dashborad-target-value":`Wartość docelowa`,
"label.reportsSubscriptionPage.email.keywords":`Wyszukiwanie po wprowadzeniu słowa kluczowego`,
"label.appointmentconfirmail.wizard.subtitle1":`Nazwa wydarzenia`,
"label.limited_scanning":`Bilet wstępu jest przeznaczony tylko do skanowania w celu zarejestrowania się na miejscu.`,
"label.weixin.nomore":`Nie więcej`,
"february":`Luty`,
"label.view.filterbyowner":`Filter By Owner:`,
"label.contentType":`Rozszerzenie dokumentu`,
"label.customobjdel.master.hsiang":`Pole relacji mistrz - szczegół jest utworzone w tym obiekcie, więc nie można go usunąć.`,
"lable.Removal.succeeded":`Usunięto pomyślnie.`,
"label.weixin.end.incorrect":`Nieprawidłowa data końcowa`,
"label.email.cc.recipients":`Adresaci Cc`,
"label.taskevent.list":`Lista działań`,
"label.formula":`Formuła`,
"label.h5.new.errorheader":`Przejrzyj błędy na tej stronie.`,
"label.emailobject.template.private":`Prywatna`,
"label.visualpage.component.n4":`4.Variable. Możesz używać zmiennych bezpośrednio i uważaj, aby nie mieć pojedynczych cudzysłowów.`,
"label.newemailnotice.step1":`Krok 1 Wybierz obiekt`,
"label.chatter.file":`Plik`,
"vue_label_checkduplicate_rules":`Ustawianie reguł kontroli duplikatów`,
"label.appointment.wizard.subtitle1-6":`1.5 h`,
"label.customReportType":`Źródło danych raportu niestandardowego`,
"vue_label_email_with_accessories":`Wiadomości email z załącznikami`,
"label_efine_assessment_cycle":`Ustalenie okresu oceny wyników pracy`,
"label_emailtocloudcc_button_sure":`Potwierdź`,
"label.forecast.userenablepage.isusing":`Włączeni użytkownicy`,
"lable.goal.description":`Opis celu`,
"message.error.serviceresource.relatedrecordid":`Każdy użytkownik może być dodany tylko jako jeden zasób usługowy typu {0}`,
"label.weixin.addbus.information":`Dodaj informacje o pojeździe`,
"label.emailtocloudcc.button.view":`Zobacz`,
"label.detail.workflow":`Wyświetlanie przepływów pracy`,
"label.standardfilter":`Filtry standardowe`,
"label.mobile.phone.results":`Wydajność`,
"chatter.feed.unavailabled":`Odblokować`,
"label.view.sortview":`Sortuj widok`,
"label.availabilityobject.wizard.title":`Dostępność`,
"Main_Menu_Mobiledownload":`WŁĄCZ SIĘ`,
"chatter.sticker":`Śledzona`,
"label.workflow.intruduce":`Konfiguracja przepływu pracy w organizacji poprzez tworzenie reguł przepływu. Każda reguła przepływu składa się z:`,
"label.customfields.richtext.tip":`Umożliwia użytkownikom wprowadzanie sformatowanego tekstu, dodawanie obrazów i linków.Do 32 768 znaków w oddzielnych liniach.`,
"label.new.cy.select":`Wybierz nową walutę z dostępnej listy.`,
"template.chart.schdzqzkhzhqk":`Konwersja leadów w kampaniach`,
"label.forecast.customforecast.cpxl":`Rodzina produktów`,
"front-electronic-signature-open-service":`Włącz epodpis`,
"label.datamanage.import.field":`Pola importowe`,
"chatter.email.sendMessageToMe":`Wysyła mi wiadomość`,
"message.cannotusebefore":`Proszę pamiętać, że nie będą Państwo mogli korzystać z tego procesu zatwierdzania, dopóki nie zostanie on aktywowany.`,
"label.textmessage.vonage.api.secret":`Sekret API`,
"label_chatter_newEvent":`Nowe wydarzenie`,
"label.ji.year":`{a} rok`,
"label.sendmail.step2":`Krok 2 Wybierz szablon wiadomości e-mail`,
"label.console.step5.record":`zapisy jawne`,
"label.customfields.totalsummary.gettogetherfield.isnull":`Proszę wybrać pole do agregacji`,
"vue_label_commonobjects_detail_current_recorder":`Nowy właściciel stanie się również właścicielem dokumentacji związanej z tym projektem, a dokumentacja ta jest własnością obecnego rejestratora.`,
"label.SMS":`Powiadomienia SMS`,
"label.reconfigure.bundle":`Przekonfiguruj pakiet`,
"front-kefu-select-region":`Proszę wybrać obszar, w którym znajduje się instancja`,
"chatter.feed.deletefeeds":`Czy na pewno chcesz usunąć ten post i jego komentarze?`,
"label.customsetting.manage.introduce.h":`Jeśli ustawienie niestandardowe jest hierarchią, możesz dodać dane dla poziomu użytkownika, profilu lub organizacji. Na przykład, możesz chcieć, aby różne wartości były wyświetlane w zależności od tego, czy konkretny użytkownik uruchamia aplikację, konkretny profil lub po prostu ogólny użytkownik.`,
"label.product.name":`Nazwa produktu`,
"vue_label_commonobjects_view_saveas":`Zapisz jako`,
"label.group.my.archived":`Moje zarchiwizowane grupy`,
"vue_label_pool_coflictmethods":`Konflikt z bieżącym trybem sprzedaży`,
"label.appupload.upload":`Prześlij`,
"lable.SalesCommitmentKanBan.signedTaskRate":`Podpisany wskaźnik wykonania zadania`,
"label.dashboardStandard":`Standardowe pulpity`,
"label.niboer.time":`Czas Nepalu`,
"label.emailtocloudcc.filed.email":`E-mail`,
"market.name.social.post":`Posty społeczne`,
"evaluation.detail.notfound":`Nie znaleziono szczegółów komentarza`,
"label.layoutoftestobj":`Układy obiektów testowych`,
"label.example":`Przykłady`,
"label.campaign.channel.step6.remark6":`proszę odwiedzić tutaj`,
"chatter.emailLike":`Lubi`,
"label.knowledge.category.button.two":`Edytuj kategorię`,
"label.alluser":`Wszyscy użytkownicy`,
"addadvancedconditions":`Dodaj warunki zaawansowane`,
"message.selectgsummarycondition":`proszę wybrać kryteria podsumowania`,
"message.duplication.label.sectionremar2":`Uwaga Wszystkie powiązane rekordy, w tym wszelkie notatki, załączniki i czynności zostaną powiązane z nowym połączonym rekordem.`,
"vue_label_helpcenter_product&pricebook":`Produkty to Twój podstawowy katalog wszystkich przedmiotów i usług, które sprzedajesz wraz z ich standardowymi cenami. Cennik pozwala na stworzenie spersonalizowanego zbioru produktów i powiązanych z nimi cenników dla konkretnych użytkowników.`,
"message.duplication.label.isprofile":`Za zgodą`,
"component_setup_label_milestonesfield":`Pole kamienia milowego`,
"setup_layout_label_required":`Wymagany`,
"component_chatter_label_title":`Najnowszy wpis`,
"label.assignment.setup.detail.order":`Kolejność sortowania`,
"vue_label_pool_unassigned":`Nieprzypisane`,
"UG_Lead_007":`Synchronizacja Google`,
"label.knowledge.record":`Nie istnieją żadne istotne dane!`,
"label_tabpage_filetypez":`Typ pliku`,
"label.ccpeak.if.error.message":`Jeśli zwrócono błąd: użyj`,
"label.intialsubmitter":`Podmioty składające wniosek początkowy`,
"label.wei.icon":`Ikona`,
"label.mask.show.last.4":`Zamaskuj ostatnie cztery znaki`,
"lable.PowerProcess.time.trigger":`Czas wyzwalania (min)`,
"july":`Lipiec`,
"label.usestandardwizard":`Użyj Kreatora konfiguracji standardowej`,
"label.two.quarter":`II kwartał`,
"label.size":`Rozmiar`,
"label.integrations.mailchimp.massage4":`Mailchimp nie jest obecnie zainstalowany. Proszę zainstalować Mailchimp w "Integrations"`,
"label_emailtocloudcc_step2total3":`Krok 2 z 3`,
"vue_label_chat_customer_group_strategy":`Zespół Klienta`,
"label.searchvalue":`Znajdź wartości`,
"label.sendemail.birthday.title":`Przypomnienie o urodzinach`,
"label.projectManagement.planned.days":`Dni planowania (dzień)`,
"label.service.gantt.workhours":`W oparciu o roboczogodzinę`,
"label.notification.approval5":`Aprobata delegowana：【提交人】jest prośbą o 【对象】aprobatę`,
"label.service.miniProgram.bindAddressDesc":`CloudCC Oficjalna Obsługa Klienta Mini Portal Programu:`,
"chatter.error.wt":`Błąd:Nieprawidłowy typ pliku.`,
"vue_label_calendar_my_calendar":`Mój kalendarz`,
"label.customername":`Nazwa konta`,
"label.salescloud.salesdashboard.huikuan.rankings":`Rankingi płatności zespołowych`,
"message.query.opportunity.contactrole.error":`Zapytanie o domyślną rolę kontaktową okazji biznesowej nie powiodło się, skontaktuj się z administratorem!`,
"noequal":`nie równa się`,
"label.document.searchcustominfo":`Wprowadź słowa kluczowe, aby znaleźć pasujące dokumenty.`,
"label.account.PreviousFQ":`Poprzedni FQ`,
"label.file.f":`Pliki`,
"label.dashboard":`Tablice rozdzielcze`,
"label.report.folder":`Foldery`,
"batch.edit.permission.list":`Brak uprawnień do edycji listy danych`,
"label.file.orderbyowner":`Posortowane według właściciela`,
"label.exchange.sync.account.password":`Hasło do konta serwisowego:`,
"pagecreator.button.publish":`Opublikuj`,
"label.modify":`Edytuj`,
"label.exchange.sync4":`Państwa`,
"label.remark.information":`Opis Informacje`,
"label.service.without.major.event":`Brak ważnego wydarzenia do wyświetlenia`,
"label.knowledgebase.release.status":`Status publikacji`,
"label.tabpage.ok":`Potwierdź`,
"label_screening_assessment_content":`Filtrowanie treści oceny`,
"label_partner":`Chmura partnerska`,
"label.user.detail":`Wyświetl użytkowników`,
"front-kefu-moudle-or-this":`czy tak?`,
"label.unselect.object":`Obiekt Opcjonalny`,
"label.quote.contactfax":`Faks`,
"label.weixin.appmanage.alert":`Naciśnij {0}, aby usunąć aplikację z Moich Aplikacji, Naciśnij {1}, aby dodać aplikację do Moich Aplikacji.`,
"vue_label_dashboard_thisfolder":`Dodaj publiczny dashboard do tego folderu`,
"label.delete":`Usuń`,
"label.appexchange.installedpage.message1":`Możesz przeglądać i pobierać aplikacje bezpośrednio w CloudCC App Store i instalować je w swoim środowisku CloudCC.com.`,
"label.mobile.phone.required.summary":`Wymagane jest podsumowanie`,
"label.batchadd.newbatchpage.addtr":`Można dodać maksymalnie 30 rekordów.`,
"label.partnerCloud.partnerAccount.lockLine":`Kwota zablokowana`,
"label.emailsync.status.connectstatus":`Status połączenia`,
"label.campaignmember.main.importmember.lead":`Importuj Członków-Leads`,
"message.username.isnull":`Musisz podać wartość dla nazwy użytkownika.`,
"label.forecast.tree.enableuser":`Włącz użytkowników`,
"label.multilang.view.viewmessage":`Ten widok został zastosowany do urządzenia mobilnego. Można wybrać maksymalnie 10 pól, obecnie jest ich {0}:`,
"friday":`Piątek`,
"label.sendemail.activity.neweventtitle":`Powiadomienie o nowym zdarzeniu`,
"label.page.addtabto.user":`Dołączanie karty do istniejących dostosowań osobistych`,
"front-kefu-moudle-v1-connect-phone":`Numer telefonu współpracownika`,
"label.wei.pollis":`Głosuj na`,
"lable.opppdt.editPdt.title":`Edytuj produkty możliwości`,
"label.permission.objectpermission.recordfenpei":`Przypisanie typu rekordu`,
"pagecreator.layout.message.delete.success":`Układ usunięty pomyślnie`,
"label.dataimport.isdupecatcher":`Wykonaj filtry`,
"label.deletelayout.tip":`Aby usunąć układ strony, musisz wybrać inny, którym chcesz go zastąpić.`,
"label.projectManagement.No.matching.data":`Brak pasujących danych.`,
"pagecreator_page_message_delete_success":`Strona usunięta pomyślnie`,
"label_tabpage_equalz":`Równe`,
"label.ems.emailsetup":`Ustawienie poczty elektronicznej`,
"label.decimaldigits":`Miejsca dziesiętne`,
"component.chatter.button.delete":`Usuń`,
"label.isallowreport":`Zezwalaj na raporty`,
"label.view.appliedMobile.message":`Zaznacz ten element, Krok 3. Wybierz pola do wyświetlenia, możesz wybrać do 6 pól`,
"label.must.positive.integer":`Liczba ta musi być liczbą całkowitą.`,
"label.preview.print.template":`Podgląd szablonu wydruku`,
"label.schedulejob.setup.schedule.start":`Start`,
"UG.Case.04":`Przydzielanie przypadków`,
"vue_label_pool_move1":`{1}{2}`,
"label.list.userinterface.enableHoverDetails":`Włącz szczegóły przy najechaniu kursorem`,
"vue_label_email_alltemplates":`Wszystkie szablony`,
"label_report_chose_obj":`Proszę wybrać relację obiektową i źródło danych raportu`,
"label.partnerCloud.productSet.del":`Usuń pozycję`,
"label.quote.shrdz":`Adres odbiorcy`,
"page.approval.history":`Historia zatwierdzenia`,
"lable.outlook.detail.prefc":`Zawsze preferowane CloudCC.com`,
"label.translation.unable.display.view":`Nie można wyświetlić widoku`,
"label.encrypt.change":`Konwertuj typ zaszyfrowany`,
"button.partner.workspace.login.logo.upload":`Prześlij obraz`,
"label.batchadd.mustinput2":`jest wymagany, to rekord ten nie może być zapisany, jeśli wymagane informacje są puste.`,
"label.dataimport.update.error.check":`Wystąpił błąd podczas aktualizacji danych. Prosimy o dokładne sprawdzenie tych danych.`,
"label.staticresource.name.already.exists":`Unikalna nazwa zasobu statycznego już istnieje!`,
"label.appupload.upload.install.success":`Zainstalowano pomyślnie`,
"label.conditiontag.lookup.true":`TRUE`,
"label.quickbooks.viewlist.customer":`KLIENT`,
"label.field.edit.change2":`Najwyższy wynik to co najmniej 1`,
"label.fianalrejectoperate":`Czynności związane z ostatecznym odrzuceniem`,
"label.ccpeak.wgd":`Zajęcia niezłożone`,
"label.reportsSubscriptionPage.condition.emailreport":`Podsumowanie   sprawozdanie`,
"label.detailinf":`Szczegóły`,
"label.eastem.standard.time":`Czas wschodni`,
"chatter.group.manager":`Kierownik`,
"label.manage_columns":`Zarządzaj nagłówkiem`,
"label.daylight.time":`Czas letni`,
"label.weixin.mycar.information":`Moje pojazdy`,
"label.ccpeak.help":`Pomoc dla klas`,
"lable.outlook.detail.match":`Kryteria dopasowania`,
"label.version.nonsupport.approval":`Procesy zatwierdzania nie są tymczasowo obsługiwane.`,
"label.custom-tailor":`Dostosuj`,
"label.showoperate":`Pokaż działania`,
"label.view_edit":`Podgląd i edycja`,
"label.lead.score.prompt2":`Po wybraniu zakresu punktacji system oceni wybrane leady zgodnie z aktywną regułą Lead Scoring Rule.`,
"label.datamanage.savetemplate.error":`Zapis szablonu nie powiódł się.`,
"label.source":`Źródło`,
"label.multilang.customfieldsetup.reference":`Pole to jest wskazywane przez {0}.`,
"chatter.poll.option7":`Wybór 7`,
"label.login.access.day":`dzień(y)`,
"label.icon.66":`Sprzęt`,
"label.tabpage.kanbansetup":`Konfiguracja tablicy poglądowej`,
"label_emailtocloudcc_step1_lead2":`Po skonfigurowaniu, wiadomości otrzymywane na tę skrzynkę będą automatycznie rejestrowane jako rekordy leadów w CloudCC. Upewnij się, że żadna oferta nie zostanie pominięta.`,
"label.partnerCloud.partnerAccount.numericValue":`Kwota uzupełniająca jest wartością liczbową.`,
"label.permission.detail.app.object.tip":`Obiekty, pola i karty Ustawienia dostępu`,
"label.emailobject.template.subject":`Przedmiot:`,
"template.report.month.customer":`Rachunki z tego miesiąca`,
"label.weixin.formerly":`W przeszłości`,
"label.contract":`Kontrakty`,
"label.help":`Pomoc`,
"vue_label_homepage_setdefault":`Ustaw jako domyślną stronę główną`,
"label.icon.52":`Wytwarzanie energii elektrycznej`,
"label.customfields.file.count":`Liczba plików`,
"UG_Account_07":`Konto importowe`,
"label.addattachment.ntko":`Edytuj online`,
"label.service.ganttBaiduMap.assign.service":`Przyznanie nominacji służbowej tej osobie`,
"vue_label_file_my_file":`Moje akta`,
"label.custom.page.hide":`Ukryj`,
"label.addexistoperate":`Dodaj istniejącą operację`,
"label.already.startdate":`Czas rozpoczęcia`,
"label.partnerCloud.financeSetting.alipay":`Musisz otworzyć konto biznesowe Alipay. Tylko konto biznesowe może być obsługiwane jako konto odbiorcy. Opłaty za transakcje będą pobierane przez Alipay od odbiorcy płatności.`,
"label.dashboard.summary.editPageFooter":`Edytuj stopkę`,
"label.category.8":`Dobra konsumpcyjne`,
"label.forecast.customforecast.foretype.best":`Najlepszy przypadek`,
"message.validation.isnull":`Proszę wprowadzić wartość`,
"label.savewxpay.failure":`Nie udało się zapisać informacji o handlowcu płatności WeChat`,
"label.file.stop.sharing.desc1":`Przestań dzielić się z`,
"label.opportunity.setting.showstage。read.info":`Po zaznaczeniu nie można ręcznie modyfikować etapów tworzenia możliwości.`,
"UG_Campaign_003":`Utwórz kampanię`,
"label.edit.field.select.showoptions":`Pokaż wszystkie opcje`,
"message.inputplatformpwd":`Wprowadź hasło administratora`,
"vue_label_systemSettings_mobel_set":`Konfiguracja aplikacji mobilnej`,
"label.projectManagement.thefirstone":`Jest to pierwsza płyta`,
"label.data.newtemplate":`Tworzenie szablonu eksportu danych`,
"label.monitorsys.delete.log":`Dziennik audytu operacji kluczowych`,
"label.template":`Szablony`,
"Lead.Auto.Scoring.Setting.001":`Automatyczny wynik podczas edycji lub zapisywania (z wyjątkiem leadów, które są importowane wsadowo lub tworzone przez interfejs)`,
"label.operatesuccess":`Operacja się powiodła.`,
"label.send":`Wyślij`,
"chatter.yp":`Ukryj Feed`,
"label.overall_responses":`Ogólna odpowiedź`,
"vue_label_systemSettings_server_report":`Sprawozdanie z usługi`,
"label.icon.113":`Dom`,
"label.partnerCloud.basicSetting.domainSet":`Konfiguracja nazwy domeny`,
"label.login.access.text":`Aby pomóc w obsłudze, możesz przyznać administratorowi dostęp do logowania i odwiedzania Twoich danych.`,
"vue_label_report_addrowlevelformula":`Dodaj formułę na poziomie wiersza`,
"message.duplication.label.mergeTitle":`Połącz moje`,
"label.event.add":`Dodaj wydarzenie`,
"vue_label_homepage_bigscreen_light":`Światło`,
"setup.chatter.enabled":`Niedostępne, prosimy o kontakt z Administratorem w celu włączenia CCChat.`,
"label.inputreceiver":`Możesz wprowadzić do pięciu (5) adresów e-mail, które mają być powiadamiane. Każdy adres e-mail jest oddzielony znakiem ";".`,
"label.custom.page.custom.page":`Własne strony`,
"label.data.exp.csv":`Format CSV`,
"label.searchlayout.view.example":`Zobacz przykład`,
"label_tabpage_fullscreenz":`Pełny ekran`,
"label.tabpage.last":`Ostatni krok`,
"lable.outlook.mcto.accepemail":`Moje dostępne adresy e-mail`,
"front-electronic-signature-isopen":`Aktywny`,
"vue_label_commonobjects_detail_earlier":`Zobacz wcześniej`,
"label.name.cannot.greater.str":`Nazwa może zawierać do 255 znaków.`,
"label.weixin.activity.email":`Działalność: E-mail`,
"label.tabpage.unequalz":`Nierówny do`,
"label_calendar_year":`Rok kalendarzowy`,
"label.appupload.upload.installor":`Zainstalowane przez`,
"label.jixiaoswitchon":`Rozwiń`,
"label.user.congratulations.send.finish":`Gratulacje, zakończono wysyłanie wiadomości masowych.`,
"label.customsetting.touse.getListCustomSetting2":`Wyszukuje dane typu "list" ustawień niestandardowych, zwraca pojedyncze dane odpowiadające nazwie API. Map map = cs.getListCustomSetting(String apiName, String Name);`,
"label.recordtype.masterrecordtype.selectedTip":`Typ rekordu głównego nie może być przypisany do profilu, który ma już przypisany typ rekordu.`,
"label.tippage.li3":`Tak, że wszelkie elementy tablicy rozdzielczej oparte na zgłoszeniu awarii zostały usunięte`,
"label.weixin.no.name":`Nie ma tematu`,
"label.tabpage.viewz":`Drukuj bieżący widok`,
"label.create_contacts":`Tworzenie listy kontaktów`,
"vue_label_homepage_operationitem":`Proszę wybrać przycisk`,
"label.pc.ui.2018.switch.version":`Przejście do wersji`,
"label.salescloud.teamrole.main":`Główny kontakt`,
"label.reportsSubscription.format.report":`Sformatowany raport (format Excel .xlsx)`,
"label.forecast.customforecast.total":`Kwota`,
"label.quickbooks.fieldlabel.lastname":`Nazwisko`,
"label.appointment.wizard.title2":`Szczegóły spotkania`,
"label.project.template.one":`Tworzenie projektu z szablonu projektu wymaga 2~3 minut. Dziękujemy za cierpliwe oczekiwanie.`,
"label.timetrigger.workflow":`Gdy przepływ pracy jest aktywny.`,
"label.projectManagement.creator":`Twórca`,
"label.customfields.formula.selectreturnfieldtype":`Proszę wybrać typ zwrotu formuły`,
"label.list.userinterface.dashboard.enable":`Włącz nowe komponenty pulpitu nawigacyjnego`,
"label.email.delete.html.format":`Wszystkie formaty html zostaną usunięte. jesteś pewien?`,
"label.appupload.install.modifyapi":`Zmień nazwę sprzecznego api:`,
"label.chat.add.topics":`Dodaj temat`,
"label.savepartner.fail":`Nie udało się zapisać ustawień dla Partner Cloud`,
"label.pc.query.new":`Zobacz swoje ostatnie`,
"message.duplication.label.editfiltertitle":`Znajdź duplikat Filtr Edytuj`,
"label.task":`Zadania`,
"label.emailobject.emaildetail.title.toaddress":`Do:`,
"label.setup.mobile.bottombutton.select":`Wybierz 4 strony pierwszego poziomu, które chcesz pokazać w aplikacji mobilnej`,
"label.loginip.pagecue.invalido":`Nieprawidłowy adres internetowy`,
"label_tabpage_listshow":`Lista pokazuje`,
"component.newrecords.label.10records":`10 zapisów`,
"label_chatter_file":`Plik`,
"pagecreator.systemstyle.label.detailcolor":`Kolor tekstu szczegółowego`,
"label.forecast.userenablepage.title":`Prognozy Użytkownicy`,
"front-project-module-v1-actual_working_hours":`Zgłoszona osobogodzina`,
"vue_label_systemSettings_Security":`Zabezpieczenia`,
"label.processsetting.two.select.key.fields":`Krok 2: Wybierz kluczowe pola dla każdego kroku w procesie i zapewnij wskazówki`,
"label.page.display1":`Rekordy na stronę`,
"label.appointmentpage.wizard.subtitle1.2":`Inviter's Time Zone is {0}`,
"label.ggReleaseRange.searchTeam":`Wyszukaj grupę publiczną`,
"chatter.group.searchGroup":`Wpisz nazwę grupy...`,
"label_card_type":`Układ karty`,
"label.appupload.managed.tip":`Bycie kontrolowanym oznacza, że możesz edytować tylko niektóre atrybuty.`,
"label.changemyshow":`Zmień mój wyświetlacz`,
"label.custom.CustomQuarter":`Custom Quarter`,
"label.tobedelete":`Do skreślenia`,
"label.newPage.unuse":`Twoja strona została utracona.`,
"label.product.pricebooks":`Książki z cenami`,
"label.mobile.layout":`Układy stron dla urządzeń mobilnych`,
"label.multilang.file.items":`{0} projektów:`,
"label.app.step4.tabused":`Wybrane zakładki`,
"label_ccchat_create_account":`Załóż konto`,
"message.startusingprocess":`Po aktywacji tego procesu zatwierdzania nie można dodawać ani usuwać kroków zatwierdzania. Ponadto niektóre atrybuty kroków zatwierdzania nie będą mogły być edytowane. Czy na pewno chcesz kontynuować?`,
"vue_label_email_please_add_a_theme":`Proszę dodać motyw przed zapisaniem jako szablon`,
"label.please.create.a.target.record.first.":`Proszę najpierw utworzyć rekord wskaźnika`,
"label.processsetting.set.objandfile":`Krok 1: Wybierz obiekty i pola, dla których chcesz ustawić proces`,
"label.newreport.group.data":`grupa（s）`,
"label.notcreatenew":`Nie twórz nowej szansy po konwersji.`,
"lable.custom.CurrentandPreviousCY":`Obecny i poprzedni CY`,
"front-epwechat-module-v1-input-androidschema":`Proszę wprowadzić schemat Androida`,
"label.projectManagement.unfinished.quantity":`Liczba niezrealizowanych`,
"label.visualpage.idandname":`ID strony i nazwa strony to:`,
"label.approvingprojects":`Punkty do zatwierdzenia`,
"label.partnerCloud.financeSetting.weChat":`Konieczne jest otwarcie serwisu WeChat i zawarcie umowy o świadczenie usług inkasenckich z firmą Tencent. Opłata za transakcję zostanie pobrana przez Tencent od odbiorcy.`,
"label.quickbooks.viewlist.view":`Zobacz`,
"label.knowledge.category.hint.ten":`Nieaktywna Grupa kategorii`,
"report_type_label_productPricebooks":`Produkty i Książki Cenowe`,
"label.fenbeitong.description":`Sprawdź i włącz formularz wniosku o podróż FenBeiTong, aby pomóc pracownikom w składaniu wniosków o podróż służbową i zwrot kosztów podróży.
`,
"label.ccchat.upload.change":`Co się zmieniło? (opcjonalnie)`,
"label.emailsync.status.log":`Dziennik połączeń`,
"label.addnew":`Dodaj nowy`,
"UG_contact_05":`Utwórz kontakt`,
"label.appupload.componet.queryerror":`Wystąpił błąd podczas wyszukiwania omponentu. Proszę skontaktować się z administratorem.`,
"label.salescloud.setting":`Ustawienie sprzedaży zespołowej`,
"label.recurrencetimetriggeroperate":`Akcje wyzwalające okresowe`,
"label.event.moveup.4day":`4 dni naprzód`,
"No.Hisitory.Activity":`Brak działalności historycznej`,
"label.validate.function.funcFormat.MINUTE":`MINUTE(data)`,
"label.recentview.seloption3":`Ostatnio zmodyfikowane`,
"label.login.access.nopermission":`--Nie ma dostępu...`,
"label.taskmenuandlink":`Przyciski i łącza do zadań`,
"label.forecast.customforecast.foredis.sbw":`Miliony`,
"lable.PowerProcess.created.event":`utworzyć kamień milowy`,
"label.stdashbord.xsld.funnelchat":`Wykres lejka sprzedaży`,
"label.step1.total7":`Krok 1 z 7`,
"label.sendsms.batch.chosepersion":`Masowa wysyłka SMS: Wybierz odbiorców`,
"Lead.Scoring.Setting.Rule.Setup.Value":`Wynik`,
"label.ccdocument.isdel.folder":`Czy na pewno chcesz usunąć ten folder?`,
"label.discard_change":`Tak, odrzuć zmiany`,
"label.knowledgebase.assign":`Przyporządkuj`,
"PersonalInfo_LoginHistory_001":`Broswer sprawdza poprawność linku do rejestracji w skrzynce pocztowej`,
"label.globalselect.deletedvlaue":`Usunięto zestaw wartości globalnych`,
"label.ems.lookup2":`Szukaj`,
"label.dataimport.system.unable.determine":`system nie jest w stanie określić utraty`,
"label.weixin.invitation.consultant":`Zaproszony konsultant`,
"label.salescloud.salesdashboard.phone.rankings":`Rankingi wybierania numerów`,
"label.knowledgebase.plan.release":`Plan publikacji`,
"label.integrations.first.half":`Aktualny widok w całości`,
"label.icon.123":`Apteczka pierwszej pomocy`,
"label.leadscore.isactivity":`Aktywny`,
"front-epwechat-module-v1-corpid":`WeCom ID (Corpld)`,
"label.createnewcustomer":`Nowe konto`,
"front-lightning-module-v1-details-page-chart-tittle":`Na stronie szczegółów można wstawić moduły wykresów i diagramów, można wstawić do 10 wykresów raportowych. Przykładowo, można dodać moduł wykresów raportowych dla rekordu o typie rekordu Agent w obiekcie Konta, dodać do modułu wykresy kwoty sprzedaży zamówienia agenta i kwartalnego raportu sprzedaży agenta oraz filtrować po nazwie konta, aby wyświetlić powiązane dane bezpośrednio na stronie szczegółów konta agenta.`,
"label.customobjects.fieldsrelation":`Pola niestandardowe i relacje`,
"label.dashboardSetup.left":`Lewa`,
"label.mobile.app.sectionpart":`Sekcja aplikacji mobilnych`,
"setup.mainpage.label.welcome25":`Instrukcje: Kliknij menu po lewej stronie tej strony → Zarządzaj ustawieniami → Kontrola bezpieczeństwa → Ustawienia udostępniania.`,
"label.custombutton.edit.error":`Błąd: Nazwa jest już w użyciu lub była wcześniej używana, proszę wybrać inną nazwę.`,
"label.icon.48":`Wentylator wyciągowy`,
"label.tabularreport.step2":`Krok 2 Wybierz kolumnę raportu`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.two":`Dwa`,
"UG_quota_01":`Zarządzaj kwotami rachunków`,
"label.customcomponent.btn.usewhere":`Gdzie jest to wykorzystywane?`,
"label.quickbooks.searchresault.email":`E-mail`,
"label.emailobject.appointment.urltext2":`zarezerwuj czas tutaj`,
"label.tianyancha.field.relation.error":`Proszę najpierw ustawić relację mapowania pomiędzy polem tianyancha a polem customer.`,
"APPIntegration_Social_facebookerror":`Musisz wpisać poprawny adres URL dla facebook.com`,
"label.notification.arketsea.transfer":`{5} przeniósł {0}：{1} z {2} do {3}.`,
"lable.SalesCommitmentKanBan.allreceivingTaskRate":`Wpływy ogółem Wskaźnik realizacji zadań`,
"UG.Account.04":`Pasywne filtrowanie kont zapytań`,
"this.week":`W tym tygodniu`,
"label.email.track.attachment.num.control1":`Liczba przesłanych plików przekracza 10 i nie można ich przesłać.`,
"label.exchange.sync.state.event":`Wydarzenia`,
"vue_label_systemSettings_websitesetting":`Konfiguracja sieci Web`,
"vue_label_file_replace_reason":`Powód zastąpienia`,
"label.version.feature":`Cechy`,
"E":`E-mail`,
"label.escalation.setup.entrydetail.escalation.notifyTemplate":`Szablon`,
"label.chosesubject.meet":`Zorganizuj spotkanie`,
"UG.ST.003":`Nie masz uprawnień do tworzenia {0}, skontaktuj się z administratorem, kliknij przycisk Zatwierdź, aby przejść bezpośrednio do interfejsu {0}.`,
"label.authorization.failure":`Autoryzacja nie powiodła się. Prosimy o ponowną autoryzację!`,
"label.newprocessstep3":`Krok 3 Określenie właściwości pola zatwierdzającego i możliwości edycji zapisów`,
"lable.outlook.mcto.mostrecord":`Rekord z największą liczbą aktywności`,
"vue_label_normal_select":`Wybierz`,
"label.partner.workspace.login.buttontext":`Tekst przycisku`,
"template.chart.ydschdtj":`Miesięczne statystyki kampanii`,
"label.ServiceCloud.zichanmingcheng":`Nazwa aktywów`,
"label.productsales.oppor.nooverdue":`Dobra robota, żadnych zaległych okazji.`,
"label.appointment.wizard.subtitle3-5":`Piątek`,
"label.payment.the.current.version":`Aktualne wydanie prenumeraty`,
"label.reportlist.top":`Zamocowane na górze`,
"label.emailobject.emaildetail.prompt":`Prompt`,
"label.weixin.endst":`Godzina zakończenia nie może być wcześniejsza niż godzina rozpoczęcia.`,
"report_label_knowcreatehighlevelreport":`Jak stworzyć raport zaawansowany?`,
"label.quickbooks.view.openestimates":`Szacunki otwarte`,
"label.url.cannot.empty":`URL nie może być pusty!`,
"label.emailnoticetemplate":`Szablony powiadomień e-mail`,
"calendar.tips.task":`Brak zadania na dziś`,
"label_partner_all_operate":`Operacja`,
"message.duplication.label.cancelbutton":`Anuluj`,
"vue_label_SMS_addcontact":`Dodaj kontakt`,
"label.martrixreport.setsumfield2":`Wybierz pole, które będzie używane jako kolumna podsumowująca w raporcie macierzowym.`,
"approval_request_email_body":`Następujące elementy wymagają zatwierdzenia kliknij na poniższy link, aby zatwierdzić`,
"label.emailobject.emaildetail.field.record":`Zapis`,
"label.tab.page":`Strona`,
"label_tabpage_prepagez":`Wyświetlanie na każdej stronie`,
"label.iran.daylight.time":`Czas standardowy Iranu`,
"label.event.nextweek":`Następny tydzień`,
"fliter.lastmonth":`Ostatni miesiąc`,
"label.group.no.recent.search":`Nie ma pasujących ostatnio oglądanych grup.`,
"label.h5.act.confirm":`Potwierdź`,
"label_tabpage_mypotentialcustomers":`Moje tropy`,
"label.tabpage.queuez":`Kolejka`,
"label.batch.edit.description":`Wybierz pola, które chcesz edytować, wybierz co najmniej jedno pole i maksymalnie 5.`,
"label.batchadd.newbatchpage.deltr":`Trzymaj się przynajmniej na linii.`,
"label.industrialandcommercialverification.instructions2":`Wersja, z której korzystasz jest darmowa, a maksymalna ilość zapytań to 10 000 razy dziennie. Jeśli potrzebujesz zwiększyć liczbę zapytań, zalecane jest wykupienie usługi. Po zakupie usługi, otrzymasz od dostawcy token, ustaw go na tej stronie. Sprzedawca będzie nadal dostarczać Ci odpowiednią płatną usługę.`,
"label.rejectrequestbehaviour":`Wykonaj wszystkie odrzucenia <strong>i</strong> wszystkie ostateczne odrzucenia dla tego kroku. (Ostatnie odrzucenie)`,
"label.batchCopy":`Klonowanie partii`,
"label.service.two":`Niektóre filtry są zdefiniowane, ale nie mają odniesienia w filtrach zaawansowanych.`,
"label.data.import.setup.detail.remark":`W przypadku zaznaczenia poniższych opcji import danych jest wykonywany.`,
"vue_label_file_delete_lib":`Usuń bibliotekę plików`,
"label.integerdigit":`Liczba cyfr po lewej stronie przecinka dziesiętnego`,
"label.profile.standardobjcontrol":`Standardowe uprawnienia do obiektów`,
"label.reportrecords":`Zapisy`,
"label.noplan":`Nie masz zaplanowanych żadnych wydarzeń w ciągu najbliższych 7 dni.`,
"label.visualpage.ytype":`Tablice rozdzielcze`,
"label.branch":`;`,
"label.knowledgebase.new.article":`Nowy artykuł`,
"label.Addressbook":`Kontakty`,
"label.delete.reward.groups":`Usuń grupę linii notowań`,
"label.appexchange.uninstallpage.message1":`Trwale usuń wszystkie komponenty z tego pakietu (wymienione poniżej)`,
"chatter.group.everyone":`Wszyscy użytkownicy`,
"label.cooperation":`Współpraca`,
"label.uploadfail":`Przesyłanie nie powiodło się`,
"to":`do`,
"button_partner_delete":`Usuń`,
"attachment_select_warning_001":`Załącznik jest zarchiwizowany, a przycisk Archiwizuj nie jest dostępny, proszę ponownie wybrać załącznik.`,
"label.step4.total4":`Krok 4 z 4`,
"label.login.access.avalid":`Wygasa dzisiaj`,
"label.defaultview2":`Lista pinezek`,
"vue_label_commonobjects_detail_style":`Styl kupowania`,
"label.selectfield":`Wybierz pola`,
"label.report.select.column.collect":`Wybierz kolumnę do podsumowania`,
"lable.currencyAdv.newdaterate.existeddate":`Data jest już używana dla HKD.Proszę podać inną datę początkową.`,
"pagecreator_systemstyle_button_new":`Nowy styl`,
"label.ccchat.person.invite":`Zaproszenie dla kolegów`,
"label.sendemail.recycle.clear":`Czysty recykling`,
"label.usermanage.view.notexist":`Widok nie istnieje`,
"setup_chatter_enabled":`Niedostępne, prosimy o kontakt z Administratorem w celu włączenia CCChat.`,
"UG.Contract.01":`Zarządzaj umową`,
"label.martrixreport.2018.step4":`Krok 4 Wybierz kryteria raportowania`,
"message.errorinscript":`Problemy ze skryptem wykonawczym.`,
"label.knowledgebase.modification.date":`Zmieniona data`,
"label.projectManagement.the.maximum.number.of.fees.is.10":`Można wprowadzić do 10 cyfr dla kosztów`,
"label.list.isActiveNewApproval":`Włącz stronę Nowe zatwierdzenie`,
"label.mobile.main.page.icon.setup":`Ustawienia ikony aplikacji mobilnej`,
"label.select.customer":`Wybierz konto`,
"label.sharerule":`Ustawienia udostępniania`,
"label.fiscal.FY":`Rok podatkowy`,
"label.appupload.component.type.customfield":`Pole niestandardowe`,
"label.emailobject.emailsend.sendindividually":`Wyślij indywidualnie`,
"label.new_formname":`Nazwa nowego formularza`,
"label.appointment.wizard.notif1":`Godzina zakończenia nie powinna być wcześniejsza niż godzina rozpoczęcia`,
"front-console-conversation-evaluate-desc":`Odpowiedź oceny z {evaluateInfoName}`,
"homepage.components.lasttime":`Data ostatniej modyfikacji`,
"vue_label_commonobjects_view_chart_deletechart":`Usuń wykres`,
"label.multilang.document.upload.fail":`{0} pliki zostały przesłane pomyślnie, a {1} pliki nie zostały przesłane.`,
"UG_contact_03":`Śledzenie kontaktów w jednym miejscu, sygnały sprzedaży`,
"label.marketsea.istoseafromother":`Umożliwić transfer z innych puli ołowiu`,
"label.datamanage":`Administracja danymi`,
"label.globaloperation.operationtype.create.data":`Utwórz rekord`,
"label.customer.tab.step2.see":`Widoczność zakładki`,
"label.wtd.changefields.desc":`Po tym jak użytkownicy prześlą formularz, zostaną przeniesieni do określonego adresu zwrotnego na Twojej stronie, np. na stronę "dziękuję".`,
"label.ems.eamilinfo":`Informacja e-mail`,
"label.recordtypeselect.new":`Nowy typ rekordu`,
"vue_label_report_output":`Typ wyjścia formuły`,
"label.emailnotice":`Email Alert`,
"label.icon.196":`Papier toaletowy`,
"label.emailsync.status.disabel":`Nieaktywny`,
"label.tabpage.isdeleterecord":`Jeśli usuniesz wybrany rekord`,
"message.selectoneoftypes":`Proszę wybrać jeden z następujących rodzajów`,
"label.import.index.createid":`Utwórz identyfikator`,
"vue_label_systemSettings_social2":`Konfiguracja kont w mediach społecznościowych`,
"label.ccpeak.sel.time":`Zaplanowane zajęcia w tym folderze`,
"label.data.downpage.i_list.desc1":`Podczas importu dane, które nie zostaną pomyślnie zaimportowane, ponieważ dane są nieprawidłowo sformatowane, lub ponieważ wyzwalacz lub reguła walidacji nie powiodła się, generuje plik CSV do wyświetlenia na bieżącej stronie. Dane zaimportowane pomyślnie nie będą wyświetlane na bieżącej stronie.`,
"label_adjust_forecast":`Dostosuj prognozę`,
"vue_label_normal_lead_sf":`Ołów`,
"vue_label_report_notice1":`Raport zawiera niezapisane zmiany. Jeśli zamkniesz raport, zmiany te zostaną utracone. Kliknij poniżej przycisk "Zapisz i zamknij", aby zapisać zmiany.`,
"label.notfiledpublicreport":`Niewypełnione sprawozdania publiczne`,
"one":`Jeden`,
"UG.Lead.008":`Kod skanowania wizytówki`,
"label.archived":`Zarchiwizowane`,
"label.standardabstractfield":`Standardowe pola podsumowujące`,
"vue_label_notice_add_fail":`Dodać nieudane`,
"label.sendemail.registIMUser.addresserror":`adres e-mail odbiorcy jest nieprawidłowy`,
"label.ccdocument.toolbar.switch":`Przełącznik paska narzędzi`,
"first":`Pierwszy`,
"label.icon.147":`Mysz`,
"vue_label_jihui_er":`Szansa 2`,
"label.ccchat.micropost.isedit":`Modyfikacja postów i komentarzy`,
"label.department.next":`Następna strona`,
"front-kefu-moudle-confirm-disable-phone-user":`Czy na pewno chcesz wyłączyć wybieranie dla użytkownika {0}?`,
"label.reportsSubscription.time.meets.subscription.frequency":`Data rozpoczęcia i zakończenia nie jest zgodna z częstotliwością subskrypcji!`,
"lable.account.NextpDays":`Następne 120 dni`,
"UG_opportunity_007":`Funkcja kontaktu`,
"label.encrypt":`Zaszyfrowany`,
"label.knowledge.category.hint.three":`Usuń lub zastąp istniejącą kategorię, co spowoduje usunięcie wszystkich katetogów powiązanych z artykułem.`,
"label.customcomponent.usewhere.info":`Poniżej znajdują się wszystkie referencje do tego komponentu. Kliknij etykietę odnośnika, aby wyświetlić definicję.`,
"vue_label_import_addandupdate":`Dodaj i zaktualizuj`,
"label.email.all.members":`Wyślij do wszystkich członków grupy za pośrednictwem poczty elektronicznej`,
"component_task_button_save":`Zapisz`,
"label.file.deleted.unavailable.desc":`Plik został usunięty, nie jest dostępny lub jest niedostępny.`,
"label.emailsync.status.viewlog":`Wyświetl dziennik`,
"label.marketsea.othersetup":`Inne ustawienia`,
"label.data.exp.newtemppage":`Szablon Utwórz stronę`,
"vue_label_lead_score_successsful":`Zdobyty z powodzeniem`,
"label.sendemail.activity.newtask":`Drogi #belongtoidccname, hello:\NTwój kolega #createbyidccname przydzielił Ci nowe zadanie w #createdate, które brzmi następująco:\n subject:#subject:\n due date:#expireDate:\n related item: #relatedstr:Treść: #Aby uzyskać więcej szczegółów, odwiedź ten link:\N #path\n #orgNameCRM system`,
"component.event.label.soon":`Natychmiast`,
"label.forecast.shrepage.getlist":`Powrót do Hierarchii prognoz`,
"UG.solution.02":`Rozwiązanie jest wewnętrznym rozwiązaniem instytucji na problem, który napotykają rachunki.`,
"label.weixin.data.approval":`Zapis jest w trakcie zatwierdzania`,
"label.build.pagelist":`Lista stron kreatora stron`,
"label.customsetting.type.hiberarchy":`Hierarchia`,
"label.forecast.ccfh":`Przechytrzyć`,
"label.Current.Window":`Wyświetlanie w istniejącym oknie`,
"label.appointmentdetail.wizard.title20":`Plan na niedzielę`,
"label.emailaddress":`Adres pocztowy`,
"label.qetting_notifications":`Nie otrzymujesz naszych emaili? Upewnij się, że dodałeś adresy email CloudCC do swojej listy dozwolonych użytkowników i włączyłeś powiadomienia o eksporcie.`,
"Homepage.News.001":`Wiadomości`,
"label.runreport":`Raport z przebiegu`,
"label.customer.tab.step3":`Krok 3 Dodaj do aplikacji niestandardowych`,
"label.dashboard.snapshot.refresh":`Odśwież`,
"label.approvepagelayout3":`Zatwierdź układ strony`,
"vue_label_SMS_send_messages":`Wyślij wiadomość`,
"label.executestate.old":`Zrealizowano`,
"label.approvalstep3":`Krok 3 Wybierz przypisanego zatwierdzającego`,
"label.step3.total6":`Krok 3 z 6`,
"front-kefu-moudle-v1-delete-templete":`Usuń szablon`,
"label.data.downpage.e.title.num3":`3、Użytkownicy mogą tworzyć szablony eksportu według ich potrzeb i wybrać element "Export By Template", co może sprawić, że operacja eksportu bardziej wygodne.`,
"label.attendance.outer":`Pracownik mobilny`,
"setup_layout_button_selectall":`Wybierz wszystko`,
"chatter.photo.img":`Maksymalna wielkość pliku to 2 MB.`,
"front-dynamiclayout-module-v1-required":`Pole {required} jest ustawione jako wymagane.`,
"label.mytask":`Moje zadania`,
"label.edit.customerinfo":`Profil firmy Edytuj`,
"label.processsetting.process.explain":`Konfigurowanie i korzystanie z procesu pozwala użytkownikom skupić się na najważniejszych elementach i w odpowiednim momencie wyświetla słowa kluczowe i wskazówki, które pomagają im ukończyć proces.`,
"label.emailobject.subject":`Przedmiot:`,
"label.mobileapp.scansetting.message":`Wybrać, czy zeskanowane karty w formacie obrazu mają być zapisywane na powiązanej liście "Notatek i załączników" zgodnie z rzeczywistym scenariuszem użycia. <br>Włącz: zeskanowana karta jest automatycznie zapisywana do załącznika podczas zapisywania rekordu. <br>Dezaktywuj: zapisuj tylko zapis.`,
"front-epwechat-module-v1-android-autograph":`Podpisywanie aplikacji na Androida`,
"label_component_helper_potentialcustom":`Leady przypisane do Ciebie dzisiaj`,
"label.projectManagement.nodata.week.work":`Dodajmy zadania, aby lepiej zorganizować pracę w tym tygodniu.`,
"label_tabpage_rolez":`Rola`,
"label.importsourcestep4":`Krok 3 Importuj swoje pliki`,
"label.icon.50":`Kompas`,
"lable.service.prompt":`Nie można utworzyć nowego pola，Liczba pól osiągnęła limit.`,
"label.campaign.channel.input.page":`Określ stronę internetową, zazwyczaj ustawiając stronę główną kampanii jako stronę z podziękowaniami.`,
"UG.homepage.001":`Wygraj więcej transakcji w krótszym czasie`,
"label.step4.total6":`Krok 4 z 6`,
"label.partner.required":`Błąd: domena nie może być pusta`,
"label.tag.manage.title":`Zarządzaj- {0}`,
"label.data.downpage.i_title.num1":`1. System obsługuje tylko popularny format CSV.`,
"label.custom.quarter.end":`Niestandardowa data zakończenia kwartału`,
"label.layout.distribute":`Układ strony Przydział`,
"label.version.allsms":`Mas SMS`,
"label.tolead":`Import`,
"label.texttemplate.usemergefields":`Użyj pól wbudowanych w szablon SMS.`,
"label.emailobject.sure":`Jasne`,
"lable_setup_mobilesetup_isenbaleh5newandedit":`Jeśli włączyć h5 w mobile-side i edytować`,
"label.tabpage.messagez":`Proszę wpisać komentarz`,
"label.mobile.phone.write.day.report":`Nowe dzienne notatki robocze`,
"label.data.setok.e.desc2":`Strona z listą eksportowanych danych`,
"label.emailsync.message":`Prompt`,
"label.sales.page.mubiao":`Osiągnąć cel`,
"label.ccdocument.list":`Zobacz swój ostatni dokument`,
"label.tabpage.userGuidez":`Podręcznik użytkownika`,
"label.report.fields":`Dostępne pola dla raportów`,
"vue_label_checkduplicate_at_same_time":`Zaspokoić wszystkich w tym samym czasie`,
"label.sms.phone":`Telefon służbowy`,
"UG_ST_004":`Nie posiadasz uprawnienia do zarządzania danymi - "import danych, skontaktuj się z administratorem, kliknij zatwierdź i przejdź bezpośrednio do interfejsu {0}.`,
"label.mobile.nobindmobile":`Ten numer telefonu komórkowego już nie istnieje. Proszę powiązać numer telefonu komórkowego z informacjami o użytkowniku.`,
"label.partnerCloud.basicSetting.intro":`CloudCC wspiera tworzenie wielu stron dla partnerów różnych typów i osobne konfigurowanie strony logowania, menu i uprawnień. Na przykład, sprzedawcy detaliczni mogą tworzyć różne strony dla lokalnych agentów i partnerów reklamowych.`,
"label.trigger.targetobject":`Obiekty docelowe`,
"label.ems.emailsyncperiod":`Okres synchronizacji poczty elektronicznej`,
"lable.Transformation.mode":`Tryb transformacji`,
"label.emailobject.new.template":`Dodaj nowy szablon`,
"label.System.Setting":`Ustawienia systemowe`,
"label.emailtocloudcc.button.addemailaddress":`Dodaj skrzynkę Enterprise Mailbox`,
"lable.a.total.of.invoices":`Łącznie 0 faktur`,
"label.multilang.customforcast.forecasthistory":`Historia prognozy dla {0}：`,
"label.role":`Role`,
"advancedconditions":`Zaawansowane warunki filtrowania`,
"label.tabpage.beginz":`Rozpocząć`,
"label.campagin.roi.khzhsl":`Ilość Konwersji Rachunku`,
"chatter.poll.option5":`Wybór 5`,
"label.weixin.horse.club.registered":`Rejestracja użytkowników Aid-Max`,
"frame_personinfo_label_resizeimage":`Aby zmienić rozmiar miniaturki, przeciągnij i zmień rozmiar przerywanych linii na zdjęciu profilowym powyżej.`,
"label.file.share.select.warning":`Została ona ustawiona do udostępniania!`,
"label.event.this.week":`W tym tygodniu`,
"label.data.import.object.label":`Etykiety obiektów`,
"label.visualpage.folder":`Teczki na strony nieopracowane`,
"vue_label_report_saveandclose":`Zapisz i zamknij`,
"label.newdashboardpage.saveto":`Zapisz do`,
"label.partnerCloud.financeSetting.developerIDTwo":`Identyfikator dewelopera`,
"lable.PowerProcess.created.ago.please":`Przed utworzeniem procesu należy`,
"label.chatter.myfollowers":`Moi zwolennicy`,
"label.campaignmember.main.duplicatelist.title":`Uczestnicy Kampanii: Zeskanuj kod, aby znaleźć duplikaty ustawień`,
"label.group.no.recent2":`Znajdź grupy, do których możesz dołączyć`,
"label.icon.110":`Książka`,
"label.merge.my.account":`Połącz moje konta`,
"setup.layout.button.quicksave":`Quick Save`,
"pagecreator.page.message.canntdelete":`Bieżąca strona nie może zostać usunięta`,
"label.report.printable.view":`Podgląd wydruku`,
"ccchat_fieldtrack_fieldchange":`Zmiana z {0} na {1}.`,
"label.email.bcc":`Bcc`,
"label.sso.saml.sp.idpcert":`Certyfikat dostawcy tożsamości`,
"label.step2.total2":`Krok 2 z 2`,
"lable.product.pricebooks.isn":`Active Price Books`,
"labal.emailtemplate.namemassage":`Unikalna nazwa szablonu poczty już istnieje, prosimy o ponowną edycję`,
"only.one.field":`Można wybrać tylko jedno pole.`,
"label.weixin.appr.audittime":`Data zatwierdzenia`,
"pagecreator.page.button.delete":`Usuń`,
"front-kefu-moudle-v1-Session-start-time":`Sesja rozpoczyna się o godz:`,
"label_chatter_state":`Status`,
"vue_label_systemSettings_lightningcustom":`Niestandardowe UI w Błyskawicy`,
"label.searchs":`Szukaj`,
"label.mobile.phone.not.read":`Niepoprawione`,
"label_chatter_allweather":`Na każdą pogodę`,
"label.enter.number":`Proszę wpisać liczbę całkowitą z przedziału 0-6.`,
"front-epwechat-module-v1-addressbook-desc":`Po włączeniu tej opcji kontakty i działy w WeComie będą synchronizowane z użytkownikami i rolami w CloudCC`,
"label.emailfield":`Email Fields`,
"pagecreator_button_next":`Następny krok`,
"label.more.select.merge.records":`Można wybrać tylko 3 dane do scalenia`,
"lable.edit.queue.selobjct":`Wybrane obiekty`,
"label.reportsSubscription.editsubscribe":`Edytuj subskrypcję`,
"label.selectfieldtoautotransmit":`Wybierz pole używane do automatycznego przesyłania zatwierdzeń`,
"label.ccpeak.need.topass":`Konieczność przejścia do`,
"label.checkfield.merge":`Merge`,
"front-lighting-module-v1-detail-file-downlaodInfo":`Rekord jest zablokowany i nie można z niego pobierać plików. Prosimy o kontakt z administratorem w celu odblokowania.`,
"vue.please.enter.a.chart.name":`Proszę wpisać nazwę wykresu.`,
"label.data.dataexptemplate.desc3":`3. Tryb eksportu jest ważny tylko dla eksportowanych danych i nie jest ważny dla szablonu eksportu. Format pliku dla szablonu eksportu to CSV.`,
"label.setup.mobile.homepageshortcuts.setting":`Strona główna ustawienia funkcji swift`,
"label.ems.connect.success":`Test wiadomości e-mail zakończył się powodzeniem`,
"label.applet.text":``,
"label.knowledgebase.parent.window":`Okno dla rodziców`,
"label_file_size":`Wykorzystana przestrzeń`,
"label.allocation.department":`Przydzielanie użytkowników`,
"label.browser":`Przeglądarka`,
"label.reportsSubscriptionPage.schedulereport.weekly.wednesday":`Środa`,
"label.integrations.description1":`Eksport danych w bieżącym widoku`,
"label.project360":`Projekt 360`,
"label.choose_formtype":`Wybierz typ formularza`,
"label_emailsync_status_connectstatus":`Status połączenia`,
"label.bmap.beijing.city":`Pekin`,
"label.mask.encryption.scheme":`Format zaszyfrowany`,
"label.imgfield.type":`Typ obrazu`,
"label.person.target.responsible":`Wybierz opiekuna celu.`,
"label.appexchange.installedpage.installdate":`Data instalacji`,
"label.partnerCloud.orderingPlatform.partnerUsers":`Ta funkcja jest dostępna tylko dla użytkowników partnerskich.`,
"label.profile.customfieldsafety":`Niestandardowe zabezpieczenia na poziomie pola`,
"label.no.target.models.available.":`Brak dostępnych modeli wskaźników. Proszę utworzyć model wskaźnika lub skontaktować się z administratorem.`,
"label.process.execute.tip":`Twój wniosek został przetworzony, masowe zatwierdzenie lub odrzucenie zajmie trochę czasu, a system poinformuje Cię pocztą, gdy przetwarzanie zostanie zakończone.`,
"label.app.step2.introduce":`Wprowadź następujące pola, aby zdefiniować aplikację niestandardową`,
"label.loginip.cue":`Nie jest określony zakres IP i użytkownicy z dowolnego adresu IP mogą się zalogować.`,
"label.step1.select.tablayout":`Krok 1 Wybierz układ zakładki`,
"mainpage.setup.chosecomponent.leastone":`Musisz wybrać przynajmniej jeden komponent na stronie głównej.`,
"label.custom.quarter.name":`Własna nazwa kwartału`,
"chatter.ptup.link":`Zamieść link`,
"label.compact.layout.frame.error2":`Szczegółowe informacje i lista powiązań muszą znajdować się na lewym ekranie`,
"vue_label_salesfunnel_notice7":`Całkowita liczba szans biznesowych z prawdopodobieństwem 100%/Totalna liczba szans biznesowych z prawdopodobieństwem 0% lub 100%`,
"label.multilang.datamanage.dataimport.lostmsg":`Długość tytułu jest &nbsp;{0}&nbsp;, ale długość danych jest &nbsp;{1}&nbsp;, system nie może określić, które &nbsp;{2}&nbsp; pola są zbędne.`,
"label.owner.notnull":`Właściciel nie może być pusty`,
"label.logintime.pagecue.invalidt":`Czas rozpoczęcia nie może być większy niż czas zakończenia.`,
"vue_label_file_checked_num_limit":`Liczba wybranych plików przekracza limit`,
"front-email-payment-repayments":`Zapłać jeszcze raz`,
"template.report.today.prospects":`Leads of Today`,
"label.weixin.appr.status":`Status`,
"label.knowledge.language.japanese":`Japońska`,
"label.event.reminder.lead.time":`Przypomnienie`,
"lable.custom.dep":`Kliknij przycisk Nowy, aby zdefiniować nowy rok niestandardowy.`,
"Dashboard_View_Createdbyme":`Tablice rozdzielcze stworzone przeze mnie`,
"label.file.upload.fail":`Przesyłanie pliku nie powiodło się`,
"label.manager":`Kierownik`,
"label.stdashbord.xsld.business.jine":`Kwota`,
"label.tag.manage.tag":`Tag`,
"chatter.nlk":`W przeciwieństwie do`,
"label.file.search.people":`Szukaj ludzi`,
"message.error.domain.format":`Nazwy domen mogą składać się tylko z języka angielskiego i tablic`,
"label.firstisdefault":`Użyj pierwszej wartości jako wartości domyślnej`,
"label.discount":`Rabat`,
"label.mobile.phone.have.read":`Zmieniony`,
"label.field_selected":`To pole zostało wybrane`,
"label.payment.renew.now":`Odnów teraz`,
"label.multilang.lookfiltercondition.notsetup":`Warunek linii {0} jest nieprawidłowy, nie jest ustawiony żaden operator!`,
"label.projectManagement.Selectionday":`Wybierz dzień`,
"label.user.organization.permit.licensenotstart":`Licencja Twojej organizacji nie została aktywowana, spróbuj ponownie po aktywowaniu licencji.`,
"label.download.save.attachment":`Pobierz i zapisz w załączniku`,
"lable.outlook.mcto.must":`Musi być w formacie e-mail.`,
"vue_label_notice_unfollow_success":`Unfollow pomyślnie`,
"label.taskinfo":`Krok 2 Konfiguracja zadania`,
"label.other.SMS":`Inne numery telefonów`,
"label_partner_workspace_login_logo":`Logo nagłówka`,
"label.weixin.data.lock":`Zapis jest zablokowany.`,
"label.Yaxis":`Oś Y`,
"lable.edit.queue.selobjdes":`Wybierz obiekty, które chcesz przypisać do tej kolejki. Poszczególne rekordy dla tych obiektów mogą być wtedy własnością tej kolejki.`,
"label.campagin.roi.dcfezb":`Wskaźnik frekwencji`,
"label.marketseamemset.maximum":`Maksymalna kwota`,
"label.owner":`Właściciel`,
"label.reportsubscribe.error.noview":`Proszę podać użytkownika, jako którego chcesz uruchomić ten raport w polu "Uruchom jako".`,
"label.icon.133":`Folder`,
"vue_label_file_share_files":`wspólne dokumenty`,
"label.searchlayoutfilterfields.remark":`Wybierz kolumny pola filtra, które mają być wyświetlane podczas przeszukiwania paska bocznego strony głównej i strony głównej zakładki.`,
"vue_label_help_contract":`Umowa i plan odbioru`,
"component.chatter.button.message":`Komentarz`,
"label.marketsea.recyclereminddays2":`Dzień przypomnienia (musi być krótszy niż liczba dni bez dalszych działań po uzyskaniu)`,
"label.webtocloudcc.input.information":`Wymagane jest podanie informacji.`,
"vue_label_chatter_exit_group":`Opuścić grupę`,
"vue_label_lead_notcreatetask":`Nie twórz zadania`,
"front-lightning-module-v1-dashborad-date-dimension":`Data Wymiar`,
"setup.layout.label.fieldlist":`Dostępne pola`,
"label.leadscore.charname":`Nazwa pola`,
"label.forecast.customforecast.mybest":`Mój najlepszy przypadek`,
"setup_mainpage_label_welcome24":`Platforma chmurowa CloudCC zapewnia ustawienia bezpieczeństwa dostępu dla wszystkich danych obiektów w systemie. Współdzielenie danych i prawa dostępu mogą być kontrolowane poprzez ustalanie różnych reguł i warunków.`,
"label.queue":`Kolejki`,
"label.icon.159":`Chip`,
"label.path":`Ścieżka do odniesienia`,
"label.app.message.failtoget":`Nie udało się uzyskać listy aplikacji`,
"label.returntoprocess":`Powrót do listy: Procesy zatwierdzania`,
"vue_label_commonobjects_detail_more_data":`Nie ma więcej danych`,
"label.number":`Numer`,
"label.product.find":`Znajdź ceny książek`,
"label.legend":`Legenda`,
"label.partner.workspace.member.profile":`Dostępne profile`,
"label.service.gantt.sum.appointments":`Zrealizowane wizyty serwisowe/wszystkie wizyty serwisowe`,
"label.partnerCloud.financeSetting.paymentAllowed":`Zezwolenie na doładowanie online`,
"label.integrations.upgrate":`Uaktualnij`,
"label.timzone.tip.info3":`Kiedy używasz klasy kalendarza do przetwarzania dat, powinieneś ustawić strefę czasową dla instancji kalendarza, i możesz wybrać jedną z dwóch poniższych metod, aby uzyskać obiekty kalendarza: Calendar cal=Calendar.getInstance(TimeUtil.getUserTimeZone(userInfo))和Calendar cal=TimeUtil.getCalendar(userInfo)`,
"label.ems.addaccount2":`Dodaj konto e-mail`,
"label.partneruser":`Partner Użytkownik`,
"label.validate.globalvariable.user.roleId":`Identyfikator roli`,
"pagecreator.layout.button.mergecell":`Łączenie komórek`,
"label.evacuantvalue":`Wyklucz wartości`,
"label.setup.mini.msg":`Opowieść o marce/ustawienie przekazu`,
"label.icon.178":`Ludzie`,
"vue_label_pricebook_notice_cantbedeleted":`Pozycji cennika nie można usunąć, ponieważ do cennika są już przypisane rekordy. Zamiast tego można oznaczyć pozycje cennika jako nieaktywne.`,
"vue_label_appstore_application_recommendation":`Popularne rekomendacje aplikacji`,
"label.version.createlimit":`Twoja obecna edycja CloudCC to {0}, a możesz utworzyć {1} {2}. Teraz liczba {2} przekroczyła maksimum twojego planu subskrypcji, proszę zaktualizuj swoją edycję CloudCC.`,
"message.duplication.label.sectionremar1":`Wybrać wartości, które mają być zachowane w połączonym rekordzie. Podświetlone wiersze wskazują pola, które zawierają sprzeczne dane. Wybrany Rekord Główny zachowa wartości pól tylko do odczytu i ukrytych.`,
"label.icon.1":`Chmura`,
"label.salescloud.salesdashboard.sales.performance":`Ogólne wyniki umowy sprzedaży`,
"System_AddressFieldType_Post":`Kod pocztowy`,
"setup_object_field_dependency_label_mustone":`Musisz wybrać co najmniej 1 wartość pola zależnego.`,
"label.appointmentdetail.wizard.title6":`Lokalizacja`,
"label.layout.testobj2":`Obiekt testowy 2`,
"label.searchlayout.dupcacher.field":`Kliknij link Znajdź duplikaty i połącz, aby wyświetlić zduplikowane pola.`,
"label.attendance.persons.title":`Odpowiedni użytkownicy`,
"template.report.product.sales":`Sprzedaż produktów`,
"label.editCustomReportType":`Edycja źródła danych raportu niestandardowego`,
"label.multilang.ui.setup.profile.alltime":`Wszystkie czasy są {0}`,
"label.service.dispatchingUnits.noservice.booking":`Bez wizyty w serwisie`,
"label.validate.remark4":`Upewnij się, że liczba ta mieści się w określonym przedziale, np. rabat mniejszy niż 30%.`,
"front-kefu-moudle-v1-Waiting-time":`Czas oczekiwania:`,
"label.weipagelayout.remark":`Używane w aplikacji mobilnej lub na stronie WeChat`,
"vue_label_wang_er":`Michael`,
"label.pw.text":`Proszę wprowadzić hasło dla {user}, i upewnić się, że zawiera ono co najmniej`,
"message.error.user.data.null":`Dane użytkownika nie mogą być puste!`,
"chatter.like.p":`Lubię ten post`,
"label.page.double.column.style.cloudcc":`Styl dwukolumnowy udostępnia przydatne funkcje CloudCC.com, takie jak Wyszukiwanie i Ostatnie elementy, na tej samej stronie co osadzona treść.`,
"label.h5.iscloseaccount":`Czy na pewno chcesz się wylogować?`,
"label.dataimport.insertdata.id.error":`Błąd formatu, proszę używać kombinacji liter i cyfr.`,
"label_tabpage_sum":`Ogółem`,
"front-epwechat-module-v1-addressbook-sync":`Synchronizacja książki kontaktowej`,
"label.setup.mobile.offlinecache.mostsave":`Platforma może ustawić domyślnie włączoną stronę mobilną w zakładce offline do 10`,
"label.weixin.quickcreate":`Quick Create`,
"label.forecast.edittotal.de.mubiao":`Kontyngent`,
"label.icon.144":`Gwarancja`,
"label.icon.155":`Obraz`,
"label.In.the.search":`Wyszukiwanie`,
"message.validation.isnotdateISO":`Nieprawidłowa data (ISO)`,
"label.service.appointmentList.send.successfully":`Wysyłanie zakończone sukcesem`,
"label.dynamicpage.error.exist":`Dane dynamicznego układu strony nie istnieją`,
"vue_label_SMS_otherpeople":`i {0} inne`,
"label.cloudccsite.url":`URL strony`,
"label.tabpage.contactsz":`Kontakty`,
"vue_label_commonobject_notice_clickthename":`Jeśli chcesz pobrać załadowany plik, kliknij na jego nazwę.`,
"vue_label_file_new_lib":`Nowa biblioteka plików`,
"label.chatter.card":`Karta`,
"chatter.feed.menutype.user.allusercom":`Wszystkie koleżanki i koledzy`,
"label.exchange.sync2":`Ustawienia`,
"template.report.year.income":`Dochody w tym roku`,
"label.partner.template.detail":`Opis funkcji`,
"label.setup.service.template":`Szablon raportu serwisowego`,
"label.dataimport.insertdata.id.length":`Błąd formatu, proszę sprawdzić ten rekord i zmodyfikować go. Proszę zwrócić uwagę, że długość jest mniejsza niż 20 znaków.`,
"label.partnerCloud.financeSetting.collaborator":`Identyfikator współpracownika`,
"label.processskipwizard":`Kreator szybkiego startu procesu zatwierdzania`,
"label.weixin.inputbusnumber":`Proszę wpisać numer rejestracyjny`,
"label.dashboardSetup.d1":`Punkt przerwania 1`,
"template.report.conversions.number.industry":`Liczba konwersji leadów (wg branż)`,
"vue_label_chat_group_chat":`czat grupowy`,
"label.file.publicview.error":`Plik został usunięty, nie istnieje lub nie ma możliwości podglądu`,
"label.customfields.location.locationHelpText":`Proszę wprowadzić nazwę lokalizacji, taką jak "siedziba główna". Proszę być opisowym i konkretnym, i należy pamiętać, że rekord może mieć wiele lokalizacji, takich jak "biuro sprzedaży na zachodnim wybrzeżu" i "biuro sprzedaży na wschodnim wybrzeżu".`,
"message.duplication.label.blankmatchtip":`Ustaw puste pole na dopasowanie, domyślnie False`,
"message.appexchange.addtopackage":`Wybierz jeden lub więcej komponentów, aby dodać do tego pakietu!`,
"label.ems.return2query":`Powrót do strony z zapytaniami o dodane konta e-mail`,
"label_model_name":`Nazwa modelu`,
"label.apiname.retainapi":`Nazwa jest zastrzeżona nazwa systemu, proszę użyć innego pola API nazwa.`,
"lable.Cancel.the.search":`Anuluj wyszukiwanie`,
"label.custom.viewport":`Viewpoint`,
"label.weixin.polls.type":`Typ`,
"label.opportunity.setting.showstage.label":`Autopromocja`,
"label_component_helper_businesschange_expiredtask":`Okazje z zaległymi zadaniami`,
"label.operator":`Operator`,
"label.ccpeak.use.class.time.listmap":`Dostęp poprzez przekazanie kolekcji List<Map>`,
"component_timeline_label_past":`Wcześniejsze działania`,
"label.mobile.phone.submit":`Zgłoszony przeze mnie`,
"message.recordtype.new.subtip":`Podaj nazwę i opis dla nowego typu rekordu. Nowy typ rekordu będzie zawierał wszystkie wartości listy wyboru z istniejącego typu rekordu wybranego poniżej. Po zapisaniu nowego typu rekordu będziesz mógł zmodyfikować wartości list pickupów.`,
"UG_product_05":`Produkt importowany`,
"label.validate.globalvariable.user.id":`Identyfikator użytkownika`,
"label.umeng.activity.distribute":`przypisujesz do`,
"label.weixin.avote":`głosowanie`,
"label.weixin.already.sign":`Już zalogowany.`,
"label.emailmerge.mergepage.generator":`Wygeneruj`,
"label.batchtransfer.transferto":`Przeniesienie do`,
"label.tianyancha.industry":`Przemysł`,
"label.addattachment.name":`Nazwa pliku`,
"label.customfields.formula.date.tip":`Aby obliczyć datę, na przykład dodać dni do innych dat lub odjąć dni od innych dat.`,
"label.partnerCloud.orderingPlatform.noPayment":`Nie płacić`,
"label.emailobject.failedtosend":`Nie udało się wysłać`,
"label.knowledge.setting.data.three":`Można wybrać maksymalnie {count} danych grup kategorii.`,
"label.weixin.input.maxlength.langtext":`Proszę wpisać tutaj, do 32000 znaków`,
"vue_label_calendar_delete_calendar":`Usuń kalendarz`,
"vue_label_commonobjects_detail_filter":`Zapadnij Filtr`,
"setup.layout.group.custompage":`Dostosuj stronę`,
"component_sendmail_label_subject":`Temat`,
"label_tabpage_maxfilez":`Maksymalny rozmiar pliku wynosi`,
"label.logintime.pagecue":`Wybrać datę i godzinę, o której użytkownicy o tym profilu mogą się zalogować. Należy pamiętać, że dla wszystkich czasów używany jest dokładny czas z określonej strefy czasowej. Nawet jeśli użytkownik znajduje się w różnych strefach czasowych, te dokładne czasy są używane dla czasu logowania.`,
"label.salescloud.salesdashboard.datetime":`Data zamknięcia`,
"label.format":`Format`,
"label.newfoundland.daylight.time":`Czas letni Nowej Fundlandii`,
"front-kefu-moudle-v1-messagetemplate.finishdetailinfo":`Skopiuj i wklej wartość pola merge do treści wiadomości SMS`,
"message.chooseatleastoneforshare":`Proszę wybrać co najmniej jednego użytkownika, z którym chcesz się podzielić`,
"label.multilang.datamanage.importobjfield":`Kolumna {0}`,
"label.denglu":`Login`,
"label.popup.infoz":`Prompt`,
"label.schedulejob.setup.schedule.onday":`W każdym miesiącu`,
"label.appointmentdetail.wizard.title16":`Plan na środę`,
"label.userphoto.dragtoadjust":`Przeciągnij, aby dostosować miniaturę`,
"label.product.series":`Rodzina produktów`,
"message.view.kanban.not.set.group.summary.field":`Tablica rozdzielcza widoku nie ustawia pola podsumowania grupy`,
"page.un.activities":`Nie rozpoczęte Działania`,
"label.exchange.sync3":`Konfiguracje`,
"label.login.activityExpired":`Okres aktywności użytkownika wygasł, skontaktuj się z administratorem systemu.`,
"component_chatter_file_button_files":`Wybierz dokument`,
"message.onlydelete.type":`Można usunąć tylko nieaktywne typy rekordów. Więc możesz wyłączyć typy rekordów najpierw, jeśli chcesz je usunąć.`,
"message.recordtype.selectlayouttouse":`Układ strony do użycia`,
"label.knowledgebase.unable.restore.draft":`Nie można odzyskać usuniętych wersji roboczych.`,
"label.shangqing.name":`Informacje biznesowe`,
"label.weixin.target.payment":`Płatność docelowa`,
"label.chatter.sendEmailToGroupMember.check":`Wyświetl posty`,
"front-kefu-moudle-v1-input-single-login-area":`Proszę wprowadzić nazwę domeny pojedynczego logowania`,
"vue_label_zhang_yi":`Alice`,
"label.icon.190":`Suszarka do włosów`,
"label.quickbooks.fieldlabel.company":`Firma`,
"vue_label_email_are_you_sure_to_delete":`Czy na pewno chcesz usunąć tę pocztę?`,
"Pagelayout.Setup.005":`Nazwa musi być umieszczona na pierwszym miejscu.`,
"label.object.name.two":`Nazwa obiektu 2`,
"label.tabpage.completez":`Zaznacz wybrany status jako zakończony`,
"label.setup.mobile.bottombutton.saveerror":`Nie udało się zapisać ustawień strony pierwszego poziomu`,
"label.report.action.addtodashboard8":`Wybierz folder Dashboard`,
"label.data.downpage.i_list.desc3":`Użytkownicy mogą zobaczyć przyczynę niepowodzenia importu w ostatniej kolumnie pliku po pobraniu.`,
"label.layout":`Układ`,
"label.marketsea.button.assign":`Przyporządkuj`,
"UG.solution.03":`Stwórz rozwiązanie`,
"label.ccchat.person.invited":`Zaproś kolegów`,
"label.ccchat.person.invite.address":`Odbiorca`,
"label.displaytype1":`Link do strony szczegółowej`,
"label.tianyancha.h5.ziranrengudong":`Akcjonariusz będący osobą fizyczną`,
"lable.SalesCommitmentKanBan.targetReceipts":`Wpływy docelowe`,
"message.error.getitems.type":`getItems:type nie może być pusty`,
"label.addattachment.list":`Następujące pliki zostały załadowane`,
"label.datamanage.export.false":`Wystąpił błąd podczas eksportowania.`,
"pagecreator.systemstyle.label.buttonfontcolor":`Tekst przycisku`,
"label.emailtocloudcc.redmessage1":`Nieprawidłowy adres e-mail`,
"label.weixin.polls.closed":`Głosowanie jest zamknięte, termin upływa`,
"label.icon.165":`Kapelusz`,
"vue_label_report_detailsonly":`Tylko szczegóły`,
"component.salesperformance.label.100finish":`Zakończono`,
"november":`Listopad`,
"label.data.file.generatejwd":`Generowanie usługi szerokości i długości geograficznej według adresu`,
"label.salescloud.opportunity.access":`Możliwości Dostęp`,
"label.isremider.remider":`Przypomnienie`,
"vue_label_total":`Ogółem`,
"label.email.prompt.using.lightning.link":`Ustaw link email w powiadomieniach systemowych tak, aby był zgodny z linkami Lightning.`,
"label.knowledgebase.cancel.attached.articles":`Odwołanie Załączony artykuł`,
"label.version.custom.xslc":`Indywidualny proces sprzedaży`,
"component_setup_button_save":`Zapisz`,
"label.ems.cc":`Cc`,
"label.edit.user":`Użytkownicy Edytuj`,
"label.emailtocloudcc.select2":`Proszę wybrać typ`,
"label.industrialandcommercialverification.fieldnumber":`Liczba mapowanych pól:4`,
"label.ccchat.havenot.joined.group":`Nie jesteś w żadnej aktywnej grupie`,
"pagecreator_page_label_pagename":`Nazwa strony`,
"setup.layout.button.save":`Zapisz`,
"label.campaignmember.main.updatestatus":`Masowa aktualizacja statusu członków kampanii`,
"label.tab.web.edit":`Karta sieciowa Edycja`,
"label.ring_chart":`Wykres pączków`,
"label.usermanage.resetpwd.error":`Resetowanie hasła nie powiodło się, a użytkownik nie istnieje.`,
"label.Xaxisscope":`Zakres osi X`,
"label.app.new":`Nowa aplikacja własna`,
"message.modifythereport":`Pulpit nawigacyjny korzysta z tego raportu. Zmiany mogą spowodować unieważnienie pulpitu nawigacyjnego, który odwołuje się do tego raportu.`,
"label.component.helper.businesschange.0activity":`30 dni bez żadnej aktywności`,
"label.weixin.fmu.noon":`{0} PM`,
"label.enter.rule.name":`Wprowadź nazwę reguł.`,
"lable.Confirm.recovery.potential.customers":`Potwierdzam odzyskanie leadu {nazwa}.`,
"lable.PowerProcess.type.created":`Jaki rodzaj procesu uprawnień chcesz stworzyć?`,
"front-lightning-module-v1-dashbord-rectangle-size":`Ortogon Wielkość`,
"label.projectManagement.new.service.appointment":`Nowa wizyta serwisowa`,
"label.multilang.totalpage2":`W sumie`,
"pagecreator.systemstyle.label.styledesc":`Opis stylu`,
"chatter.up":`Przesyłanie`,
"2018UI_Homepage_DataDeleted_Info":`Dane, które chcesz zobaczyć zostały usunięte, kliknij, aby powrócić do poprzedniego kroku.`,
"label.knowledge.draft.recordid":`Identyfikator projektu nie może być pusty!`,
"vue_label_pool_recyclecertification":`{0}{1}{2}{3}？`,
"label.setting.intergrationlist.viewall":`Zobacz wszystkie integracje`,
"vue_label_file_num_limit_tip":`Liczba plików przekracza ustawioną liczbę. Jeśli chcesz zastąpić pliki, najpierw usuń przesłane pliki.`,
"vue_label_commonobjects_view_refreshat":`Odświeżony {timeInterval} temu`,
"laebe.data.exp.save.success":`Jeśli potrzebujesz użyć tego szablonu do eksportu danych, wróć do "Eksportu według szablonu", aby go obsługiwać.`,
"label.mr.caption.contact":`Znajdź duplikaty i połącz: Kody do wyszukiwania duplikatów kontaktów.`,
"label.webtocloudcc.submit.error":`Niepowodzenie przedłożenia`,
"label.multilang.datadelete.delmessage":`Rekordy zablokowane ({0}) nie mogą być usunięte:`,
"label.quickbooks.searchlist.total2":`Istnieje {0} niepowiązanych płatności o łącznej wartości {1}.`,
"label.createnew":`Utwórz nowy...`,
"component.milestones.label.choicestate":`Potwierdzić ten status`,
"lable.outlook.edit.exist":`Ta nazwa pola już istnieje. Podaj unikalną nazwę pola.`,
"vue_label_dashboard_eachother":`Łączone mogą być tylko widoki z tego samego raportu lub tego samego obiektu`,
"label.new.role":`Nowa rola`,
"message.error.operationType":`Przy wywołaniu usługi operacja nie jest określona.`,
"label.fenbeitong.name":`FenBeiTong`,
"label.choose.person":`Proszę wybrać adresatów do wysłania`,
"label.attendance.thanks":`Dzięki za udział.`,
"label.invoice.message.statusupdatefailed":`Aktualizacja statusu faktury nie powiodła się, proszę spróbować ponownie później.`,
"template.chart.yzhqzkhlyfx":`Analiza źródłowa skonwertowanego Lead'a`,
"chatter.feed.menutype.user.alluser":`Wszystkie koleżanki i koledzy`,
"UG_Forcast_04":`Rozpoczęcie procesu`,
"label.appupload.upload.tips.profile":`Uwaga: komponent "profil" został dodany do tego pakietu i nie może być dodany ponownie (dozwolone jest dodanie maksymalnie jednego komponentu profilu na pakiet).`,
"lable.PowerProcess.leave.the.process":`{describeName} Wyjście z procesu`,
"template.report.sales.cycle.opportunities":`Czas trwania cyklu sprzedaży (według typu szansy)`,
"vue_label_calendar_please_fill_in_the_calendar":`Proszę wpisać nazwę kalendarza`,
"label.salescloud.unit.wanyuan":`jednostka ( juan chiński)`,
"label.fileAPI":`Unikalna nazwa dokumentu`,
"label.weixin.link":`Related To`,
"label.service.seconds":`sek.`,
"label.encd.visible":`Widoczne pole zaszyfrowane`,
"label.tianyancha.regstatus":`Stan roboczy`,
"label.event.moveup.18hour":`18 godzin naprzód`,
"label.upper.bound":`Górna granica`,
"label.please.insertURL":`Proszę podać adres URL, który ma zostać wstawiony.`,
"label.approval.notallowed.reject":`Odmowa Niedozwolona`,
"label.permission.fieldpermission":`Ustawienia uprawnień do pól`,
"label.customcomponent.page.index.title":`Komponenty niestandardowe`,
"label.quickbooks.viewlist.number":`NIE.`,
"lable.list.queue.sendemail":`Wyślij wiadomość e-mail do członków`,
"label.productsales.today.noevtadd":`Nie ma żadnych otwartych wydarzeń, możesz kliknąć " " w prawym górnym rogu, aby dodać nowe wydarzenie.`,
"label.report.line.daixuan":`Kolumna raportów oczekujących`,
"label.reportsSubscription.select.start.endtime":`Proszę wybrać czas rozpoczęcia i zakończenia!`,
"template.chart.schdyscb":`Budżetowane koszty kampanii`,
"label.sendemail.chat.addPostatsubject":`Zostałem wspomniany w mikropoście CloudCC CCChat`,
"label.RelatedList":`Powiązane listy`,
"label.knowledgebase.delete.translation.associated.with.draft":`Istniejące tłumaczenia robocze będą powiązane z ostatnią opublikowaną wersją artykułu w języku głównym. Jeśli nie istnieje żadna opublikowana wersja, wszystkie tłumaczenia zostaną usunięte.`,
"vue_label_chatter_submitted_review":`Złożyłeś podanie o przyjęcie do grupy, poczekaj aż administrator je rozpatrzy.`,
"label.layout.list2":`Wykaz 2`,
"label.manage.area":`Zarządzaj terytoriami`,
"label.manageapproveprocess":`Zarządzaj procesami zatwierdzania dla`,
"workflow.action.tasks.assignortype.created":`Utworzony przez`,
"label.custombutton.nonsupport.operation":`Obecna wersja nie wspiera działania standardowych przycisków i linków.`,
"label.ip":`Adres IP`,
"label.chat.topic.desc.error.info":`Opis tematu nie może przekroczyć 1000 znaków. Spróbuj użyć krótszego opisu tematu.`,
"label_tabpage_cue":`Przypomnienie informacji`,
"label.integrations.mailchimp1":`Dzięki integracji CloudCC z Mailchimp, Twoi użytkownicy będą mogli importować wybrane leady i kontakty z konta CloudCC do Mailchimp.`,
"label.email.track.required":`Wymagane informacje`,
"label.set.case":`Proszę najpierw ustalić właściciela sprawy.`,
"label.weixin.newspaper.coverage.number":`Numer karty ryzyka`,
"vue_label_approve_submitreason":`Powód złożenia wniosku`,
"message.oppdt.noenabledpricebook":`Brak aktywnych ksiąg cenowych`,
"label.partner.workspace.setup":`Ustawienia`,
"label.version.nonsupport.feature":`Ta funkcja nie jest tymczasowo obsługiwana. Jeśli to konieczne, prosimy o aktualizację wersji CloudCC.`,
"com.cloudcc.login.error.message.licenseexpired":`Licencja wygasła`,
"label.emailsync.form.signin":`Login`,
"label.campaign.channel.input.to.chooselanguage":`Proszę wybrać język`,
"label.tabpage.gotit":`Mam to.`,
"front-console-no-contact-tip":`Brak danych. Proszę skontaktować się z odpowiednią osobą i sprawdzić.`,
"label.approval.apiname":`Unikalna nazwa używana przez API i pakiety zarządzane musi zaczynać się od litery, i używać tylko znaków alfanumerycznych i podkreślników. Nazwy nie mogą kończyć się podkreślnikiem ani posiadać dwóch kolejnych podkreśleń.`,
"label_emailtocloudcc_filed_ssl":`Bezpieczne połączenie`,
"component_sendmail_label_fromuser":`Nadawca`,
"front-kefu-moudle-v1-new-online-chats":`Nowy agent online`,
"label.searchlayout.merge.duplicated.results":`Umożliwia wyszukiwanie duplikatów i łączenie`,
"label.weixin.input.maxlength.remark":`Proszę wpisać tutaj, do 500 znaków`,
"component.telerecord.label.related":`Powiązane elementy`,
"label.note":`Uwagi`,
"message.duplication.label.nletters":`postacie`,
"label.productsales.payment.phb":`Lista płatności`,
"label.forecast.editshrepage.desc":`Prognoza: Określenie sposobu udostępniania tego rekordu. Można udostępnić ten rekord i powiązane z nim dane użytkownikowi, użytkownikom z określoną rolą lub użytkownikom z określoną rolą i wszystkim użytkownikom z rolami poniżej tej roli.`,
"vue.dashboard.setPenetrationSuccessful":`Udało się skonfigurować penetrację!`,
"label.tabpage.noOperationz":`Ta zawartość jest elementem stałym i nie może być obsługiwana!`,
"label.email.jump":`Przekierowanie na stronę internetową innej firmy...`,
"label.appointmentpage.wizard.btn1":`Potwierdź rezerwację`,
"label.umeng.approval.pass":`#approver zatwierdził Twój wniosek o zatwierdzenie #obj.`,
"label.project.hit.twelve":`Przypomnienie o wygaśnięciu kamienia milowego`,
"two":`Dwa`,
"label.approvedinfo":`Informacja o zatwierdzeniu`,
"label.import.step1.choosecsv":`Proszę wybrać plik csv`,
"vue.please.select.the.expansion.method":`Proszę wybrać sposób rozszerzania.`,
"UG.homepage.005":`Informacje o sprzedaży`,
"Account.News.Setting.003":`Ustawienia ogólne`,
"label.quickbooks.button.actions":`Działania`,
"lable.list.queue.email":`Kolejka Email`,
"label.name.lastname":`Nazwisko`,
"message.confirm":`Jest pan pewien?`,
"Opportunity.Detailed.Phase.Label.Popup.002":`Data zamknięcia bieżącego etapu`,
"label.knowledge.setting.title":`Ustawienia wiedzy`,
"label.helptocreateprocess":`Aby utworzyć nowy proces zatwierdzania, kliknij "Create New Approval Process" (Utwórz nowy proces zatwierdzania), a następnie wybierz opcję "Use Jump Start Wizard" (Użyj kreatora startowego), aby skonfigurować proces zatwierdzania w kilku krótkich krokach. Lub wybierz opcję "Użyj kreatora standardowego", aby skonfigurować wszystkie opcje zatwierdzania.`,
"label.batcheditor.remark":`Można edytować wiele rekordów.`,
"label.page":`Strona`,
"label.newfolder":`Utwórz nowy folder`,
"label.version.interceptor.api":`Interfejs API`,
"label.sms.toaddress":`otrzymał wiadomość SMS`,
"front-kefu-moudle-noopen-callcenter":`Organizacja nie aktywowała funkcji call center, prosimy o kontakt z administratorem`,
"label.data.exp.zip":`Format kompresji`,
"lable.account.LastcDays":`Ostatnie 60 dni`,
"label.import.index.starttime":`Czas stat.`,
"label.dashboardall":`Wszystkie pulpity`,
"label.create_socialpost":`Nowy post`,
"label.searchlayoutedit.remark":`Wybierz pola i przyciski wyświetlane po kliknięciu wyszukiwania na pasku bocznym na stronie głównej lub kliknięciu wyszukiwania na karcie.`,
"message.servicecrew.violation":`Naruszenie alokacji zasobów: zasoby serwisowe są w tym okresie członkami zespołu.`,
"label.email.attrach.file":`Załącznik`,
"report.label.folderandreport":`Raporty i foldery`,
"label.list.userinterface.sales.setup":`Ustawienie strony głównej sprzedaży`,
"label.martrixreport.2018.step1":`Krok 1 Tworzenie grupowania`,
"label.campaignmember.selectmember.memberstatus":`Status członka kampanii`,
"label.textmessage.vonage.api.key":`Klucz API`,
"label.tabpage.next":`Następny krok`,
"UG_Lead_006":`Odwiedzający stronę internetową`,
"label.salescloud.salesdashboard.visit.rankings":`Odwiedź rankingi`,
"label.myevent":`Moje wydarzenia`,
"label.activity.history":`Historia`,
"label_tabpage_kanban":`Konfiguracja tablicy poglądowej`,
"label.weixin.allapp":`Wszystkie aplikacje`,
"label.query.clone.detail.choose.choosed":`Wybrane pozycje`,
"message.error.view.errvalid":`Błąd: Pole unikalnej nazwy widoku może zawierać tylko znaki podkreślenia i znaki alfanumeryczne. Musi być unikalna, zaczynać się od litery, nie może zawierać spacji, nie może kończyć się podkreślnikiem i nie może zawierać dwóch kolejnych podkreśleń.`,
"label.customfields.searchrelation.dependobject.tip":`Wybierz inny obiekt powiązany z tym obiektem`,
"label.appointment.wizard.subtitle4-4-3":`3 tygodnie`,
"label.setup.mobile.offlinecache.saveerror":`Ustawienie pamięci podręcznej Mobile offline nie zostało zapisane.`,
"label.planned.started":`Uruchomiono`,
"label.page.step4.of.step5":`Krok 4 z 5`,
"label.tabpage.value":`Wartość`,
"label.reportlist.allfolder":`Wszystkie foldery`,
"label.callcenter.sure.disable.center":`Czy na pewno chcesz dezaktywować obecne call center?`,
"vue_label_commonobjects_detail_activity_tocalendar":`Przejdź do Kalendarza`,
"label.setup.mobile.bottombutton.recovery.default":`Przywróć ustawienia domyślne`,
"label.appointmentdetail.wizard.title15":`Plan na wtorek`,
"label.icon.15":`Zlecenie naprawy`,
"component_sendmail_label_touser":`Do`,
"template.report.all.owner":`Właściciel leadów`,
"front-Partner-email-tips":`Proszę wpisać email jako nazwę użytkownika`,
"vue_label_systemSettings_mobelhomepagesetting":`Konfiguracja strony głównej aplikacji mobilnej`,
"label.service.newBuildDialog.aswellas":`oraz`,
"label.name":`Nazwa`,
"label.tag.search.taglist":`Tag Lista`,
"label.partnerCloud.priceOfManual.theOnly":`Zalecane jest ustawienie jedynej książki cenowej dla każdego użytkownika partnerskiego. Albo podczas zamawiania mogą oni wybrać jedną z wielu książek cenowych. Jeśli nie została ustawiona żadna konkretna książka cenowa, to zostanie zastosowana standardowa książka cenowa.`,
"label.knowledge.field.update":`{1} zmienia się z {2} na {3}.`,
"label.emailobject.save":`Zapisz`,
"label.top.changeVersion":`Poziome`,
"label.recordtype.edit.unselected":`Wartości istniejące`,
"label.knowledgebase.additional.articles":`Dołączanie artykułu`,
"label.lead.score.confirm":`Proszę wybrać zakres punktacji, a system oceni wybrane leady zgodnie z aktywną regułą Lead Scoring.<br><br>Może to potrwać kilka minut.<br><br>Po zakończeniu otrzymasz e-mail z potwierdzeniem.`,
"label.projectManagement.pleaseselectadate":`Proszę wybrać datę`,
"label.appointment.wizard.subtitle5":`Nazwa spotkania`,
"label_setup_failed":`Konfiguracja nie powiodła się`,
"label.chatter.collect":`Zakładka do książki`,
"label.appointment.cancelappointment":`Anuluj`,
"front-console-response":`Czas reakcji`,
"message.delete":`Czy na pewno chcesz usunąć?`,
"label.dataimport.type.selected":`Wybierz typ importu`,
"label.new.target":`Nowy wskaźnik`,
"vue_label_report_autoupdatepreview":`Podgląd automatycznej aktualizacji`,
"label.knowledgebase.guidance":`Wskazówki`,
"label.chatter.mail":`Mail`,
"label.login.verification.scan.code.acquisition":`Zeskanuj kod, aby otrzymać:`,
"label.customsetting.changefieldtype":`Zmień typ pola`,
"label.data.dataexpalltype.all_desc2":`2. Eksport wszystkich danych zajmie trochę czasu. Po zakończeniu eksportu otrzymasz wiadomość e-mail z przypomnieniem, że eksport danych zakończył się pomyślnie.`,
"label.opportunity.contactisnull":`Brak informacji o kliencie, nie można wyświetlić.`,
"pagecreator_layout_button_upload":`Prześlij układ`,
"label.dashboard.noRecord":`Brak zapisów`,
"label.SMS.template":`Nazwa szablonu SMS`,
"label.c.d.without":`Rekordy "C" mogą, ale nie muszą mieć powiązanych rekordów "D".`,
"UG.Case.05":`Utwórz sprawę`,
"front-epwechat-module-v1-edit-selfapp":`Edycja aplikacji stworzonej w Sefl`,
"label.role.createrole.tip":`Możesz rozbudować istniejącą hierarchię ról pokazaną na tej stronie. Aby wstawić nową rolę, kliknij przycisk <b>Dodaj rolę</b>.`,
"label.grouping":`Grupa Przez`,
"vue_label_email_upload_new_file":`Prześlij nowy plik`,
"label.notification.event3":`Twoja impreza 【事件名】 zaczyna się od 【开始时间】`,
"labe_benchmark_objects":`Obiekt odniesienia`,
"component.chatter.button.collect":`Zakładka do książki`,
"front-QBtoCC-sinchronies":`Synchronizacja...`,
"message.submitpage.sms":`Gratulacje. SMS został wysłany pomyślnie.`,
"label.imgfield.width":`Szerokość`,
"label.send_email":`Wyślij powiadomienia email o złożeniu wniosku do`,
"label.queue.list":`Lista kolejek`,
"label.tabpage.fieldoptions":`Pole typu rekordu, pole listy opcji i pole listy opcji (wielokrotnego wyboru). zaleca się wprowadzenie co najwyżej 10 słów kluczowych, oddzielonych przecinkami, aby uzyskać "lub związek", np: "Nowy Jork, Toronto, Tokio".`,
"component.chatter.post.button.save":`Opublikuj`,
"chatter.group.groupDescriptionInformation":`Opis grupy`,
"label_setup_mobilesetup_isenableh5newandedit":`Włącz możliwość edycji i tworzenia nowych H5 w aplikacji mobilnej.`,
"lable.Confirm.recallpotential.customers":`Potwierdź recykling {num} przewodów.`,
"label.knowledge.setting.hint.seven":`Wybierz nazwę z poniższych i daj dostęp do zapisu, aby wnieść swój wkład.`,
"label.emailtocloudcc.redmessage2":`Proszę wprowadzić prawidłowe hasło do konta e-mail`,
"message.validation.equalTo":`Wprowadź te same wartości.`,
"vue_label_help_golbal":`Nawigacja ogólna`,
"vue_label_chatter_delete_group_title":`Usuń grupę`,
"label.user.login.success":`Sukces logowania`,
"label.chatham.standard.time":`Czas standardowy Chatham`,
"label.vlidaterule.example.percent":`Rabat procentowy nie może przekroczyć 30%.`,
"label.group.field":`Określ pole grupowania`,
"label.trigger.operation.sharetab":`Trigger Actions Shared Form:`,
"label.mobile.phone.write.month.report":`Miesięczne notatki robocze`,
"label.statusofconvers":`Status przekształcenia`,
"label.version.emailtemplate.track":`Szablon e-mail`,
"label.customobjects.onlytrackforupdate":`Tylko śledzenie zmian`,
"label_tabpage_enterviewname":`Krok 1: wprowadź nazwę widoku`,
"label.processsetting.three.enable":`Krok 3: Aktywacja`,
"label.service.show.more.info":`Pokaż więcej informacji`,
"front-epwechat-module-v1-input-iosschema":`Proszę wprowadzić schemat iOS`,
"label.dataimport.datatype.error":`Błąd typu danych, proszę dokładnie sprawdzić, czy dane i tytuł pasują do siebie jeden po drugim.`,
"label.staticresource":`Zasoby statyczne`,
"label.weixin.customize":`Dostosuj`,
"label.product.edit.sel":`Edytuj Wybrane`,
"label.appointmentpage.wizard.notif5":`Nieprawidłowy format telefonu`,
"label.marketsea.basicsetup":`Ustawienia podstawowe`,
"label.workflow.supplyintruduce":`1.Kryteria, które powodują uruchomienie reguły przepływu.<br/>2.Akcje natychmiastowe, które są wykonywane, gdy rekord spełnia kryteria. Na przykład, CloudCC może automatycznie wysyłać wiadomość e-mail, która powiadamia zespół ds. kont, gdy zostanie utworzona nowa szansa.<br/>3.Akcje zależne od czasu, które ustawiają się w kolejce, gdy rekord spełnia kryteria, i wykonują się zgodnie z wyzwalaczami czasowymi.`,
"label_report_line_tuozhuai":`Proszę przeciągnąć i upuścić lub kliknąć dwukrotnie, aby wybrać kolumny raportu i dostosować ich kolejność.`,
"label.add.new.rule":`Dodaj nowe reguły generowania`,
"label.marketing.setting2":`Ustawienie`,
"vue_label_chatter_delete_some_group":`Czy jesteś pewien, że chcesz usunąć grupę "{groupInfoList}"`,
"label.appupload.uploading.wait":`Proszę czekać`,
"label.linecondition.error":`Błąd warunku wiersza, niedopasowanie typu pola!`,
"chatter.group.request":`Wniosek`,
"label.recordtype.tabname.remark":`Użyj tej strony, aby utworzyć i utrzymać typy rekordów dla swojej organizacji. Można wyświetlać różne układy stron i wartości list wyboru w oparciu o typy rekordów. Aby używać typów rekordów, należy dodać pole Typ rekordu do układu strony.`,
"setup_mainpage_label_welcome4":`Instrukcje: Kliknij w menu po lewej stronie → Ustawienia aplikacji → Utwórz → Obiekt.`,
"vue_label_salesadvance":`Zaawansowany etap sprzedaży`,
"vue_label_campaign_of_existing_campaign_members":`Proszę ustawić status istniejących członków kampanii`,
"label.report.object.detail.no.permission":`Typ raportu został zmieniony lub przeniesiony. Prosimy o kontakt z administratorem w celu uzyskania pomocy.`,
"label.weixin.untreated":`Otwórz`,
"label.service.miniProgram.bindSetOwnerDesc":``,
"label.autoassigntoapprover":`Automatycznie przypisać do zatwierdzającego(ych).`,
"label.marketseamemset.containself":`Zawiera samodzielnie sporządzone rekordy`,
"vue_label_report_drill":`Wiertło`,
"label.order.products.to.assets":`Przekształcenie produktu zamówienia w aktywa`,
"label.recordtype.list":`Istniejący typ zapisu`,
"lable.outlook.detail.conflict":`Zachowania w sytuacjach konfliktowych`,
"pagecreator.page.label.layoutpreview":`Podgląd układu`,
"front-kefu-moudle-v1-zxltyhxzc-buyuser":`Czat agenta jest obsługiwany przez Easemob. Prosimy najpierw zakupić konto Easemob.`,
"label.convers":`Konwertuj`,
"serviceappointment.worktype.isnot.father.worktype":`Dla tego spotkania serwisowego musi być wybrany rodzaj pracy związany z jego rekordem nadrzędnym.`,
"lable.tianyancha.h5.relatedcom":`Firmy Relavant`,
"label.reportsSubscriptionPage.schedulereport":`Sprawozdanie z harmonogramu`,
"label.workbanch.setup.showinworkbanch":`Wyświetlacz na moim stanowisku pracy`,
"label_emailsync_connectaccount":`Podłącz konto e-mail`,
"label.usermanage.license.not.qualified":`System wykrył, że jest to licencja niezgodna z wymaganiami, skontaktuj się ze sprzedawcą, aby ponownie uzyskać licencję!`,
"component_setup_label_displayfield":`Pole wyświetlacza`,
"setup_layout_label_buttonarea":`Obszar przycisków`,
"label.weixin.input.content":`Proszę wprowadzić treść`,
"label.operatedata.importsuc":`Po pomyślnym zaimportowaniu można sprawdzić wynik importu klikając na zakładkę obiektu.`,
"label_tabpage_yes1z":`Tak1`,
"front-electronic-signature-describe":`Dostęp do Epodpisu, podpisz umowę w dowolnym miejscu i czasie. Podpisz za pomocą jednego kliknięcia, bezpiecznie i skutecznie!`,
"label.event.this.month":`W tym miesiącu`,
"label.document.replaces":`Wymienić`,
"label.email.cc":`Cc`,
"chatter.feed.sticker":`Śledzenie paszy`,
"vue_label_commonobjects_view_chart_notice_pleaseaddchart":`Proszę dodać wykres`,
"label.cpq.main.quote.transfer.order":`Tylko notowanie pierwotne może generować zlecenia.`,
"label.partnerCloud.partnerAccount.topUpSuccess":`Doładuj z powodzeniem`,
"label.appexchange.uninstallpage.uninstall":`Odinstaluj`,
"label.campagin.roi.channel":`Kanały`,
"label.multilang.versioncontrol.checkversion":`Twoja aktualna wersja CloudCC to {0}, która pozwala Ci na tworzenie {1} {2}, które osiągnęły już limit! Jeśli to konieczne, zaktualizuj wersję CloudCC!`,
"label.emailobject.my.template":`Tylko moje szablony`,
"label.edittimetrigger":`Edycja wyzwalacza czasowego`,
"label.setup.mobile.homepageshortcuts.saveerror":`Ustawienia funkcji szybkiego dostępu do mobilnej strony głównej nie są zapisywane.`,
"label.address.street":`Ulica`,
"label.workflow.estimatecondition2":`utworzony`,
"label.wei.expiresdate":`Data wygaśnięcia`,
"label.quickbooks.viewlist.date":`DATA`,
"label.page.select.field.type":`Wybierz typ pola`,
"label.tabpage.mypotentialcustomers":`Moje tropy`,
"label.file.library.editlib":`Edytuj szczegóły biblioteki`,
"label.weixin.message.operateexception":`Prompt`,
"label.visualpage.staticresource.p1":`1.Wywołanie metody.Odwołanie się do wybranych zasobów statycznych poprzez odwołanie się do przycisków zasobów statycznych`,
"label.icon.175":`Bilety lotnicze`,
"chatter.edit.r":`Napisz komentarz...`,
"label.examinationandapproval.flow":`Procesy zatwierdzania`,
"label.mr.descreption.reDataList5":`zestawy danych.`,
"label.edit.field.select.showstyle":`Styl wyświetlania`,
"label.reportsSubscriptionPage.condition.and":`ORAZ`,
"label.please.associations":`Proszę wybrać powiązany obiekt.`,
"label.service.dispatchingUnits.displays.service.appointments":`Pokaż wizyty serwisowe, które nie są powiązane z regionem`,
"label.addcurrent":`Dodaj istniejące`,
"label.search.change":`Dostosowywanie obiektów do wyszukiwania`,
"message.schedulejob.error.modify":`W oparciu o skonfigurowany harmonogram, dane zadanie nigdy nie zostanie uruchomione. Sprawdź dane i wyślij ponownie.`,
"label.chatter.sendEmailToGroupMember.subject.L":`{0} opublikowane linki dla wszystkich w {1}`,
"label.weixin.micro.oldid":`Oryginalny identyfikator oficjalnego konta WeChat`,
"label.employees.only.invitation.code":`System wygeneruje dla pracownika unikalny kod zaproszenia, który może być wykorzystany do wykonania zaproszeń oraz może być zaliczony do indywidualnej wydajności. Należy pamiętać, że właścicielem leadów będzie aktualny właściciel kampanii marketingowej lub zapraszający kanału marketingowego. Możesz ponownie przydzielić leady poprzez reguły alokacji leadów. Dla reguł alokacji`,
"lable.PowerProcess.event.msg":`Można dodać akcje przepływu zależne od czasu, które występują na każdym kroku (kamieniu milowym) w procesie uprawnienia. Na przykład, można skonfigurować akcje, aby wysłać wiadomość e-mail do właściciela sprawy na godzinę przed wygaśnięciem kamienia milowego lub automatycznie zaktualizować określone pola sprawy, gdy pierwsza odpowiedź na kamień milowy zostanie zakończona.`,
"label.file.share.email.content2":`Premisja: #sharerole`,
"label.querydetailservice.datalayout.notexist":`Odpowiedni układ rekordu nie istnieje.`,
"label.group.items":`Pozycja grupy`,
"label.istouse":`Dostępny`,
"front-electronic-signature-explain":`Opis podpisu elektronicznego Fadada:`,
"label.partner.template.thumbnail":`Miniaturka`,
"registration.page.selected.fields":`Wymagane pola na stronie rejestracji`,
"label.reportTypeCategoryLabel":`Źródło danych`,
"vue_label_email_You_have_not_activated_the_mailbox":`Nie aktywowałeś skrzynki pocztowej`,
"lable.SalesCommitmentKanBan.taskCompletionRate":`Wskaźnik wykonania zadania`,
"label.forecast.detailforecast.program":`Pozycje prognozy`,
"label.page.display":`Wyświetlacz`,
"label.passwordPolicy.setup.minute":`minuty`,
"label.emailtocloudcc.step1total3":`Krok 1 z 3`,
"label.file.title":`Tytuł`,
"label.callcenter.private.key":`Prywatny tajny klucz dostępu`,
"com.cloudcc.login.error.message.loginerror":`Twój identyfikator lub hasło są nieprawidłowe`,
"UG_Lead_004":`Formularz internetowy`,
"label_tabpage_recordsz":`Zapis`,
"label.shangqing.discovery":`Odkrywanie informacji biznesowych`,
"vue_label_notice_change_success":`Zmieniono pomyślnie`,
"label.ems.other":`Inne`,
"loading":`Ładowanie...`,
"label.committedtoapprove":`Złożone wnioski o zatwierdzenie`,
"label.category.4":`Finansowy`,
"template.report.folder.customer.situation":`Analiza sytuacji w zakresie rachunków`,
"label.quickbooks.searchresault.phone":`Telefon`,
"label.ccpeak.ccobj.save":`Aby zapisać CCObject do bazy danych, metoda wywołania to`,
"label.knowledge.delete.linked":`Błąd podczas usuwania powiązanego artykułu`,
"label.forecast.settings.future2":`Przyszłe 2 cykle`,
"message.error.displaytype.detail":`Typ wyświetlacza nie może być pusty, Dzień: dzień, Miesiąc: miesiąc, Tydzień: tydzień, Dostępność: dostępność!`,
"front-template-V1-search-template-name":`Wpisz nazwę obiektu i znajdź`,
"label.sendsms.batch.step3.introduce":`Zapisywanie aktywności każdego SMS-a`,
"UG.Forcast.08":`Poprzedni krok`,
"label.inputnameandintro":`Wprowadź nazwę i opis`,
"label.redistributioned":`Przeniesiony`,
"label.service.dispatchingUnits.left.right.total":`{left}-{right} records , {totalCount} records in total.`,
"label.projectManagement.Pleaseentertheactualworkinghours":`Proszę wpisać rzeczywiste godziny pracy`,
"label.exporttemplate":`Eksport szablonu`,
"label.data.downpage":`Strona pobierania danych`,
"message.please.choose.contact":`Proszę wybrać kontakt`,
"message.error.dataformat.error":`Błąd formatu danych`,
"label.customsetting.changefieldtype.losevalue":`Zmiana na wybrany typ danych spowoduje utratę wszystkich danych istniejących w polu.`,
"label.sendemail.chat.chattype":`Typ głównego postu:`,
"label.ccdocument.upload.error":`Błąd przesyłania dokumentu.`,
"label.quickbooks.view.all":`Wszystkie`,
"label.data.downpage.e_title":`Etapy eksportu danych`,
"lable.data.lock":`Dane są zablokowane, jeśli chcesz je edytować, najpierw je odblokuj.`,
"label.locked":`Zablokowane`,
"label.customfields.beforedeletedata":`Aby zachować zapis danych do wykorzystania w przyszłości, przed usunięciem pól niestandardowych należy uruchomić eksport danych, klikając Konfiguracja | Zarządzanie danymi | Eksport danych.`,
"label.productsales.oppor.noapproach":`Brak możliwości zawarcia umowy z przewidywanym terminem realizacji krótszym niż 30 dni`,
"label.input.notmore.than.number":`Proszę wpisać liczbę mniejszą lub równą {0}.`,
"label.list.userinterface.isenable":`Włącz edycję w linii`,
"label.listofshare":`Lista informacji o akcjach`,
"label.emailsync.status.role":`Rola`,
"label.staticresource.useful.realtion":`Gdzie jest wykorzystywany ten zasób statyczny?`,
"label.sharerule.tip":`Ta strona wyświetla ustawienia udostępniania danych w Twojej organizacji. Ustawienia te określają poziom dostępu użytkowników do danych innych osób.`,
"label.qrcodelogin.message.expired":`Kod QR stracił ważność`,
"label.marketing.setting3":`Kanały marketingowe Ustawienie`,
"vue_label_statistical_field":`Dziedzina statystyczna`,
"message.view.addtomyhomepage":`Dodaj do mojej strony domowej Stół warsztatowy`,
"label.customfields.percent.tip":`Umożliwia użytkownikom wprowadzenie liczby procentowej, na przykład "10", i automatycznie dodaje znak procentu do liczby.`,
"component_newrecords_label_10records":`10 zapisów`,
"Lead_Scoring_Warning_001":`Oceniaj pojedynczy rekord leadu automatycznie podczas tworzenia lub edycji. Ale trzeba ręcznie punktować wiele rekordów leadów, podczas importu wsadowego lub tworzenia przez interfejs.`,
"label.project.planing":`Manogodzina dyspozytorska VS zgłoszona manogodzina w tym roku`,
"label.data.exp.pwdverif":`W hasłach dozwolone są tylko litery i cyfry.`,
"coderules.notEnable":`Prosimy o kontakt z administratorem w celu aktywacji reguł generowania kodu QR i kodu kreskowego.`,
"label.weixin.wdyj.jxhk":`Osobiste-Wyniki sprzedaży-Płatności`,
"label.data.expnode.e_desc3":`3. Template Create: użytkownik może stworzyć szablon zgodnie z polami i warunkami, które będą eksportowane w celu zaspokojenia potrzeb, co jest wygodne w użyciu następnym razem.`,
"chatter.group.join":`Dołącz do`,
"vue_label_systemSettings_monitoring":`Monitor`,
"front-kefu-moudle-v1-yesorno-delete-folder":`Czy na pewno chcesz usunąć ten folder?`,
"label.exchange.sync.state.info":`Sprawdź stan systemu, aby upewnić się, że rekordy są synchronizowane pomiędzy Exchange a CloudCC.`,
"lable.outlook.mcto.emaildes":`Wprowadź wszystkie adresy e-mail leadów i kontaktów, które zostały użyte do wysłania wiadomości e-mail, oddzielając je przecinkami. tylko wiadomości e-mail wysłane z poniższego adresu e-mail mogą zostać dodane do historii aktywności, jeśli powiązane rekordy.`,
"label.ems.save":`Zapisz`,
"vue_label_dashboard_maximumvalue":`Proszę wpisać wartość maksymalną`,
"label.passwordPolicy.setup.norestriction":`Brak ograniczeń`,
"label.multilang.customforcast.total":`Akumulacja {0}：`,
"label_partner_all_memo":`Lista pokazuje wszystkie chmury partnerskie w Twojej organizacji. kliknij url aby się zalogować.`,
"Account.News.Setting.002":`Użyj poniższych ustawień konta, aby określić domyślne zachowanie konta dla Twojej organizacji.`,
"label.essential":`wymagane`,
"label.nonotice":`Koniec z przypomnieniami`,
"vue_label_calendar_calendar_deleted_successfully":`Kalendarz usunięty pomyślnie`,
"message.huanxinagent.disable":`Agent nieaktywny`,
"label.goto":`Skocz do`,
"label.chat.topic.add.favorite":`Dodaj do zakładek`,
"label.trigger.targetobj":`Obiekt docelowy`,
"label.form_fields":`Pola formularza`,
"this.month":`W tym miesiącu`,
"vue_label_homepage_select_view":`Wybierz widok`,
"label.weixin.input.subject":`Proszę wpisać temat`,
"label.ems.emailType":`Typ skrzynki pocztowej`,
"vue_label_file_safe_type_file":`Prosimy o potwierdzenie, że plik nie zawiera informacji poufnych. Proszę rozważyć udostępnianie plików określonym użytkownikom lub rekordom`,
"label.version.case.automatic.upgrade":`Zasady eskalacji i przydzielania spraw`,
"label.input.invalid.credit.card.number":`Proszę wpisać numer ważnej karty kredytowej`,
"component_timeline_label_future":`Następny krok`,
"label.emailtemplate.cannotsupporthtml":`Typ HTML nie jest obecnie obsługiwany`,
"label.appupload.install.error.info2":`{1} '{0}' koliduje z istniejącymi komponentami.`,
"label.custom.field.maping":`do tego pola.`,
"encd":`Tekst zaszyfrowany (wyświetlanie zaszyfrowane)`,
"label.service.newBuildDialog.filter.logic":`Logika filtra`,
"label.customerinfo":`Profil firmy`,
"vue_label_applauncher_notice_activepoolsuccess":`Pomyślna aktywacja puli leadów`,
"label.partner.workspace.member.choicepermission":`Wybierz zestaw uprawnień`,
"front-gantt-module-this-task-of-other-tasks":`To zadanie istnieje jako podzadanie i nie może być podzadaniem innego zadania!`,
"label_chatter_publish":`Opublikuj`,
"label.forecast.settings.mrfw":`Począwszy od`,
"label.Named.Filter":`Nazwa filtra`,
"label.department.email":`Adres e-mail`,
"label.updatingfield":`Pole do aktualizacji`,
"label_partner_template_detail":`Opis funkcji`,
"front-epwechat-module-v1-unbound-item":` wiązanie wszystkich przedsiębiorstw`,
"vue_label_file_lib_name":`Nazwa biblioteki plików`,
"label.notification.arketsea.distribution":`{5} przypisane {2}{0}：{1} do ciebie`,
"vue_label_norm_removecomponent":`usunąć składnik`,
"component.event.label.begindate":`*Godzina rozpoczęcia`,
"chatter.note":`otrzymana(e) uwaga(e)`,
"label.forecast.settings.type.all":`Prognoza nadwyżki`,
"label.compact.layout.frame.full":`Wyświetlanie na pełnym ekranie`,
"label.approvalstep3intro":`Korzystając z poniższych opcji, należy określić użytkownika, do którego ma zostać przypisane żądanie zatwierdzenia.`,
"label.notification.approval6":`【被委派人名称】approved 【提交人】 wniosek o zatwierdzenie 【对象】【对象名称】for użytkownika.`,
"setup.object.field.dependency.label.actionfieldvalue":`Pole kontrolne`,
"label.multilang.page2":`Strona`,
"vue_label_email_submitted":`Zgłoszony`,
"label.Standard.button":`Przyciski standardowe`,
"vue_label_report_emailchoose":`Opcja e-mail`,
"page.field.masterinput.list":`Lista danych wejściowych matryca-szczegół`,
"label.martrixdown":`Matryca w dół`,
"vue_label_helpcenter_opportunity":`W prawym górnym rogu widoku, kliknij ikonę lejka sprzedaży, aby przejść do wyświetlania lejka sprzedaży.<br>Poprzez intuicyjny pasek postępu, śledzić postęp każdej okazji biznesowej, i kliknij przycisk, aby zaznaczyć zakończenie bieżącego etapu, lub dostosować bieżący etap. Jeśli napotkasz przeszkody w rozwoju możliwości biznesowych, możesz również rozwinąć pasek postępu, aby wyświetlić informacje i kilka ciepłych wskazówek, na które należy zwrócić większą uwagę na obecnym etapie.<br>Dzięki powiązanej liście grupy możliwości biznesowych, dane dotyczące możliwości biznesowych mogą być udostępniane innym osobom, które nie mają dostępu do ich przeglądania, aby ułatwić współpracę.<br>Na liście powiązanych ról kontaktów w ramach możliwości biznesowych, szybko dodaj rolę w możliwości do kontaktu w odpowiednim kliencie, a następnie zobacz powiązaną relację przełożonego i podwładnego kontaktu poprzez sieć relacji, i użyj wykresu radarowego, aby ocenić bieżący kontakt Wartość możliwości, kontynuuj, zlokalizuj kluczowe osoby i sprawdź kontakty. Rola, status wizyty, stopień relacji, styl zakupu i czas wizyty<br>Poprzez powiązaną listę produktów możliwości biznesowych, można dodać produkty w tym samym cenniku dla możliwości biznesowych, a także edytować cenę i ilość produktów.`,
"label.sso.ssoKeyMan":`Zarządzanie kluczami jednokrotnego logowania`,
"label.forecast.edit.desc":`Ustaw limit dla użytkownika na następujący okres`,
"label.weixin.newspaper.coverage.time":`Ryzyko Data`,
"label.pleaseselectpro":`Proszę wybrać produkty`,
"label.bottonandlink":`Przyciski i linki`,
"label.donot.know.error":`Wystąpił nieznany błąd, prosimy o kontakt z administratorem.`,
"label.account_noordab":`Twoje konto ma 0 raportów niestandardowych i 2 pulpity.`,
"label.partnerCloud.orderingPlatform.toPay":`Płatność przez Fundusz Partnerski`,
"label.many.dayline.nextday":`Następny dzień`,
"lable.showmorerecords":`Pokaż więcej`,
"front-lightning-module-v1-details-page-chart-record-type":`Proszę wybrać rodzaj rekordu`,
"label.ccpeak.query.record":`wyszukiwanie zapisów`,
"pagecreator.systemstyle.message.save.fail":`Nie udało się zapisać stylu`,
"label.weixin.share.file":`Share File`,
"errormessage.email.relatedorreceivermusthaveone.z":`Musisz wybrać co najmniej jednego odbiorcę lub temat pokrewny.`,
"chatter.save.f":`Zapisanie nie powiodło się`,
"button.partner.create":`Nowy`,
"label.marketseamemset.lead.title2":`Proszę ustalić górną granicę liczby leadów, które dotyczą wszystkich członków. Limit ten nie ma nic wspólnego z basenem pełnomorskim.`,
"label.service.major.event.new":`Nowy kamień milowy`,
"label.version.custom.site":`Własna strona`,
"label.permission.visualpagepermission":`Przypisane strony niestandardowe`,
"lable.product.zongjia":`Cena całkowita`,
"label.viewchart":`Wyświetlanie wykresów`,
"label.alaska.daylight.time":`Czas letni Alaska`,
"front-kefu-moudle-v1-rgdyhcwzx-reply":`Niech więcej użytkowników, aby stać się agentów i służyć gościom, poprawę obsługi klienta.`,
"component_assistant_label_todaylead":`Przydzielone Ci dzisiaj tropy`,
"label.sendemail.chat.addComentsfavorite":`Drogi #name:\u0026apos; hello! #userName odpowiedział na Twój wpis w zakładce.`,
"label.smstemplate.tip":`Wszystkie szablony SMS w wybranym folderze są wymienione poniżej. Kliknij przycisk "Nowy", aby utworzyć nowy szablon SMS tekstowy lub HTML. Szablony te można wykorzystać podczas wysyłania wiadomości SMS. Kliknij na link roli, aby zobaczyć więcej szczegółowych informacji".`,
"label.documentname":`Nazwa dokumentu`,
"label.icon.162":`Krajobraz`,
"label.salescloud.wanyuan":`Yuan`,
"label.view.desc1":`Pole typu Record, pole listy wyboru i pole listy wyboru (multi-select), zaleca się wprowadzenie do 10 słów kluczowych, oddzielonych przecinkami. Na przykład "Nowy Jork, Toronto, Tokio".`,
"label.searchlayout.lookup.newfield":`Okna dialogowe odsyłaczy, które pojawiają się po kliknięciu nowego przycisku na polach odsyłaczy.`,
"label.emailobject.bcc":`Bcc:`,
"label.manageAll.pagenum1":`To jest pierwsza strona.`,
"vue_label_appstore_crm_used_companies":`CRM stosowany przez spółki giełdowe`,
"label.document.replace":`Wymienić`,
"label.assignment.setup.newrule.title":`Nowa reguła przydziału spraw`,
"component.chatter.label.mygroup":`Moja grupa`,
"lable.currencyAdv.exchangedate":`Zakres dat`,
"label.quickbooks.button.viewinqb":`Wyświetl w QuickBooks`,
"UG.homepage.004":`Automatyka`,
"label.currencyName":`Nazwa waluty`,
"Homepage_News_001":`Wiadomości`,
"front-lightning-module-v1-details-page-chart-refresh-button":`Pokaż przycisk odświeżania`,
"label.list.projectSetting.isenable":`Włącz timer projektu (Uwzględnij: kamień milowy, zadanie, podzadanie, problem)`,
"setup.layout.message.relatedlistbutton":`Wybierz standardowe przyciski, które mają być wyświetlane na ekranie`,
"vue_label_homepage_homepageassignment":`Przydział strony głównej aplikacji`,
"label.pending":`W oczekiwaniu na`,
"component.timeline.label.today":`Dzisiaj`,
"front-kefu-moudle-free-hasexpire":`Twój bezpłatny okres próbny wygasł`,
"homepage.layout.customlayout":`Niestandardowy układ strony`,
"label.service.miniProgram.content":`Proszę uzupełnić treść.`,
"label.defaultline.must.int":`Domyślna liczba wierszy może być tylko dodatnią liczbą całkowitą.`,
"label.mirror_issues":`Jeśli formularz nie odzwierciedla tego, co widzisz na swojej stronie, przeczytaj nasz artykuł na temat rozwiązywania typowych problemów z wyświetlaniem.`,
"label.edit.select.two":`Lista skrzynek jednokrotnego wyboru`,
"label.emailmerge.mergeFolder.tip":`Scalanie szablonów zajmuje trochę czasu, podczas scalania prosimy nie klikać na inne linki, zamknąć przeglądarkę lub odświeżyć stronę.`,
"label.ServiceCloud.zichan.distributionMap":`Mapa rozmieszczenia aktywów`,
"label.selectfile":`Wybierz pliki`,
"vue_label_account_equitymanage":`Zarządzanie relacjami kapitałowymi`,
"label.email.clearAll":`Wyczyść wszystko`,
"label.selecting.parent.assets":`Wybierz Aktywa macierzyste`,
"component.setup.tabs.label.delete":`Usuń`,
"label.visualpage.top.must.is":`Pierwszą linią nagłówka oage musi być:`,
"label.SalesCommitmentDashboard":`Pulpity menedżerskie zobowiązań sprzedażowych`,
"chatter.group.changeTheRole":`Zmień rolę`,
"label.dataimport.insertdata.error":`Wystąpił błąd podczas wstawiania nowych danych. Proszę dokładnie sprawdzić te dane.`,
"label.partner":`Chmura partnerska`,
"label.process.async.execute.tip":`Twój wniosek jest w trakcie przetwarzania. Zatwierdzenie zgłoszenia zajmuje trochę czasu, a rezultat zostanie wyświetlony na stronie szczegółów. Proszę czekać.`,
"label.service.newBuildDialog.additional.conditions":`Warunki dodatkowe`,
"label.name_copy":`Sklonujesz ten istniejący formularz. Proszę podać nazwę dla kopii.`,
"label.integrations.install":`Zainstaluj`,
"label.edit.ccpeakfolder.time":`Zaplanowane zajęcia: Folder Edycja`,
"label.knowledgebase.filing.time":`Czas archiwalny`,
"vue_label_chatter_success_exit_group":`Pomyślne wyjście z grupy`,
"font.market.module.v1.save.name":`Proszę wpisać nazwę spotkania`,
"label.a.b.without":`Rekordy typu "A" mogą, ale nie muszą mieć powiązanych rekordów typu "B".`,
"label.chat.topic.desc":`Opis`,
"label.field.editoptionlist.introduce":`Wprowadzić nazwę wartości listy pickupów.`,
"label.versiontype.Enterprise":`Przedsiębiorstwo`,
"message.selectrulecondition":`Prosimy o sprecyzowanie kryteriów reguły`,
"label.custombutton.unknown.operation":`Nieważne działania`,
"label.pricecannotnull":`Cena jest wymagana`,
"component_salesperformance_label_target":`Target`,
"pagecreator.page.message.delete.success":`Strona usunięta pomyślnie`,
"label.help.new.features":`Nowe funkcje CloudCC`,
"label.weixin.vehicle.owner.information":`Dane właściciela pojazdu`,
"label.exchange.sync.state.user.info":`Sprawdź status synchronizacji użytkownika, aby upewnić się, że rekordy są synchronizowane między Exchange a CloudCC. Jeśli użytkownik ma problem z synchronizacją między Exchange a CloudCC, można zresetować proces synchronizacji. Resetowanie informacji używanych tylko przez CloudCC for Exchange nie powoduje usunięcia danych z serwera Microsoft Exchange ani z CloudCC.`,
"label.batcheditor":`Edycja masowa`,
"report.label.knowcreatehighlevelreport":`Jak stworzyć raport zaawansowany?`,
"label.dataimport.title.length":`Długość tytułu wynosi`,
"label_model_description":`Opis modelu`,
"label.tabpage.ctbtsftcz":`Kliknij przycisk wstecz, aby wyszukać zawartość`,
"label.channel.activity.member.owner":`Właściciel członka kampanii`,
"label.ems.serverinfo":`Informacje o serwerze`,
"tjinvilid":`Warunki niezgodne z prawem`,
"label.nameofreport":`Nazwa raportu`,
"label.ifapproverreject":`Co się stanie, jeśli osoba zatwierdzająca odrzuci ten wniosek?`,
"label.wtd.changefields.title.desc2":`Jeśli potrzebujesz rekordu w aplikacji mobilnej "Web to CloudCC", aby skojarzyć lead, musisz utworzyć pole w bieżącym obiekcie, aby wyszukać lead, a nazwa API pola to " lead_wtd".`,
"label_emailsync_form_connecttime":`Czas pokrewny`,
"label.visualpage":`Własna strona`,
"label.customlink":`Własne linki`,
"label.lead.score.doing.remark":`Twój wniosek został przetworzony i zajmie to pewien czas dla lead scoringu. a system poinformuje Cię e-mailem o jego zakończeniu.`,
"label.h5.act.details":`Szczegóły działalności`,
"label.profile.setrecordtype":`Ustawienia typu zapisu`,
"label.processsetting.process.enabled.successfully":`Włącz proces pomyślnie!`,
"label.campaign.url.overtime":`Link wygasł.`,
"label.structureChart.notFiled":`Niewypełniony`,
"label.h5.chatter.something":`Powiesz coś`,
"label.pm":`PM`,
"template.chart.rwlx":`Rodzaj zadania`,
"label.icon.42":`Chmura`,
"label.project.hit.one":`Zawiadomienie o przydzieleniu podzadania`,
"label.martrixreport.2018.step3":`Krok 3 Wybierz nagłówki kolumn`,
"label.wtd.changefields.newmo":`Wygeneruj stronę mobilną`,
"label.downloadTheTemplate":`Pobierz szablon`,
"label_chatter_assignPerson":`Osoba wyznaczona`,
"label_emailtocloudcc_license":`Licencja`,
"label.willdeletedlayout":`Układy stron, które chcesz usunąć`,
"label.projectManagement.delete.question":`W przypadku usunięcia tej sprawy wszystkie powiązane z nią informacje również zostaną usunięte, a danych nie będzie można odzyskać. Czy na pewno chcesz potwierdzić usunięcie?`,
"lable_setup_mobilesetup_isEnableValidationRulesForScan":`Włącz reguły walidacji podczas skanowania`,
"label.salescloud.opportunity.addandedit.contactrole.note":`Uwaga：dwukrotne kliknięcie pustych kontaktów，można dodać pusty rekord`,
"label.step6.total6":`Krok 6 z 6`,
"label.knowledge.setting.hint.one":`Knowledge pozwala pracownikom obsługi klienta i serwisu w pełni wykorzystać artykuły Knowledge.`,
"label.usefieldautoassign":`Automatycznie przypisz zatwierdzającego za pomocą standardowego lub niestandardowego pola hierarchii:`,
"label.partnerCloud.orderingPlatform.orderAmount":`Kwota zamówienia:`,
"chatter.fieldtrack.operateupdate":`zmienił się`,
"chatter.del.com":`Usuń ten komentarz`,
"report.reportdatasource.label":`Raport Źródło danych`,
"label.text":`Tekst`,
"label.marketsea.select.member":`Członkowie fakultatywni`,
"label.typeofreceivers":`Typ odbiorcy`,
"label.knowledgebase.affect.existing.translations":`Tak, moje modyfikacje będą miały wpływ na istniejące tłumaczenie. Oznacz jako "Wygasłe"`,
"label.marketing.invitationmail":`Witamy w naszej działalności, Twój link do zaproszenia to:`,
"label.version.quotation.management":`Zarządzanie ofertami`,
"label.dataimport.insertdata.error.unique":`$fieldName$ narusza ograniczenia unikalności podczas wstawiania nowych danych.`,
"label.emailmerge.list.newtemplate":`Nowy szablon`,
"label.salescloud.salescloud.allteam":`Zespół wszystkich możliwości dla wszystkich zespołów`,
"vue_label_commonobjects_detail_record_changes":`Zmiany w zapisie pola`,
"label.file.delete.info":`Usuń pliki`,
"vue_label_calendar_name":`Nazwa kalendarza`,
"label.version.support":`Wsparcie`,
"label.event":`Wydarzenia`,
"label.searchlayout.lookup.searchdialog":`Okna dialogowe odnośników, które pojawiają się po kliknięciu ikony odnośnika na polach odnośników.`,
"label.data.downpage.e_list.desc2":`Po zakończeniu otrzymasz wiadomość e-mail z przypomnieniem, że dane zostały pomyślnie wyeksportowane.`,
"label.partnerCloud.productSet.delIsTrue":`Czy chcesz usunąć ten produkt?`,
"label.tianyancha.businessverify.msg2":`Niniejsza umowa jest umową pomiędzy Użytkownikiem (zwanym dalej Użytkownikiem) a CloudCC dotyczącą korzystania z funkcji weryfikacji danych biznesowych. Umowa opisuje prawa i obowiązki związane z korzystaniem z funkcji weryfikacji danych biznesowych oraz usług powiązanych pomiędzy CloudCC a Użytkownikiem. Niniejsza umowa może być aktualizowana przez CloudCC w dowolnym czasie. Raz opublikowane zaktualizowane warunki umowy zastąpią pierwotne warunki umowy bez wcześniejszego powiadomienia.`,
"label.customobjects.cancleselectallfield":`Anuluj wszystkie wybrane pola`,
"image.up.maxsize":`Przesłany plik jest zbyt duży, proszę nie przekraczać 2M.`,
"label.icon.8":`Plik`,
"label.donot.delete":`Nie masz uprawnień do usuwania`,
"label.version.profile.and.layoutpage":`Profile i układy stron`,
"chatter.coll.s":`Usuń tę zakładkę`,
"label.icon.163":`Ziemia`,
"label_chatter_myfollowers":`Moi zwolennicy`,
"label.multilang.customforecast.refuse":`Odrzuć wszelkie priorytety predykcyjne {0}, ale zaakceptuj priorytety predykcyjne od innych podwładnych`,
"label.tabpage.findz":`Szukaj`,
"label.smstemplate.detailinfo":`Szczegóły szablonu SMS`,
"label.knowledge.setting.hint.nineteen":`Zaczynajmy`,
"label.mr.tip":`Proszę uzupełnić zasady w wierszu {0}.`,
"label.icon.132":`Gwarancja`,
"label.customobjects.track.introduce2":`Lista powiązana z historią. Za każdym razem, gdy użytkownik modyfikuje dowolne z pól wybranych poniżej, do listy powiązanej z historią dodawane są stare i nowe wartości pola, a także data, godzina, charakter zmiany i użytkownik dokonujący zmiany.`,
"label_emailtocloudcc_redmessage5":`Nieznany status, proszę skontaktować się z administratorem.`,
"label.must.select.field":`Błąd warunku linii, musisz wybrać pole.`,
"label.tag.manage.modifiedby":`Ostatnio zmodyfikowany przez`,
"label.translation.start1":`Wybierz język (jeśli jesteś tłumaczem).`,
"label.ccchat.topic.searchs":`Szukaj Temat`,
"label.mask.custom.example":`{AAA}{****}{AAA} reprezentuje zaszyfrowane wyświetlanie od piątego do ósmego znaku.`,
"setup_object_field_dependency_label_addtolist":`Dodaj wybrane wartości`,
"label.view.total.record":`Łącznie wybrano 0 rekordów.`,
"label.service.without.right":`Brak powiązanego uprawnienia`,
"template.chart.wxqzkhyy":`Przyczyny występowania nieważnych leadów`,
"vue_label_dashboard_pleaseenterabreakpoint1value":`Proszę wprowadzić wartość punktu przerwania 1`,
"message.pleaseinputmouthdistance":`Proszę wprowadzić prawidłowy przedział miesięczny.`,
"label.forgetPsd.tip":`Zapomniałeś hasła, skontaktuj się z administratorem.`,
"label.projectManagement.planned":`Zaplanowane`,
"lable.Product.conversion.asset.operation":`Przeniesienie produktu do aktywów`,
"label.search_forms":`Wyszukiwanie formularzy`,
"label.sendemail.chat.addPostmainPagesubject":`CloudCC CCChat wiadomość na stronie głównej`,
"label_tabpage_viewNamez":`Proszę wprowadzić nazwę widoku`,
"label_chatter_addresser":`Nadawca`,
"Opportunity_Detailed_Phase_Change_Text_001":`Etap możliwości zmiany`,
"label.what":`Strona`,
"vue_label_systemSettings_set_android":`Skonfiguruj menu i funkcje dla systemów Android i IOS, aby dostosować je do potrzeb użytkowników biznesowych.`,
"label.sell":`Sprzedaż`,
"template.report.folder.case":`Analiza przypadków`,
"label.customfields.profilefieldsafety":`Bezpieczeństwo profilu na poziomie pola walki`,
"label.industrialandcommercialverification.label.token":`Żeton`,
"label.finished":`Zakończono`,
"label.sendmail.step3.introduce1":`Obecnie posiadasz`,
"vue_label_calendar_other_calendars":`Inne kalendarze`,
"label.donot.know.validate.field":`Nieprawidłowe pola walidacji`,
"label.exportdetail":`Szczegóły eksportu`,
"label.step.filter":`Określenie warunków filtrowania`,
"label.campaignmember.main.hasMember":`Obecni członkowie`,
"label.updown.suess":`Pobierz z powodzeniem`,
"label.ems.browse":`Przeglądaj`,
"front-email-payment-Invoice-login-account-describe":`Kliknij "Kontynuuj", aby zakończyć płatność za fakturę skanując kod QR Alipay lub logując się Alipay.`,
"label.copyCustomReportType":`Klonowanie źródła danych raportu niestandardowego`,
"label.visualpage.write.class":`Edytuj kod klasy na stronie z taką samą składnią jak w Javie.`,
"label.setsharerule.tip":`<br>Użyj reguł udostępniania, aby wprowadzić automatyczne wyjątki od ogólnoorganizacyjnych ustawień udostępniania dla zdefiniowanych grup użytkowników.<br>Uwaga: "Role i podwładni" obejmują wszystkich użytkowników w danej roli oraz role poniżej tej roli.`,
"label.report.action.addtodashboard9":`Strona listy pulpitów nawigacyjnych`,
"label.cloudccsite.remark":`Opis terenu`,
"label_tabpage_noz":`Nie`,
"chatter.up.limit":`Przesłany plik jest zbyt duży, proszę nie przekraczać`,
"label.leadmarketsea.grouplist.title":`Ustawienia grupy puli liderów`,
"label.pc.user.help":`Podręcznik użytkownika`,
"label.partnerCloud.orderingPlatform.relyOn":`Zależność`,
"label.appointmentpage.wizard.subtitle2":`Wybierz czas`,
"label.deleteoneormore":`Usuń jeden lub wiele`,
"january":`Styczeń`,
"label.delete.profile":`Usuń profil`,
"label.appointment.wizard.subtitle1-7":`2 h`,
"label.icon.188":`Kosmetyka`,
"vue_label_file_already_in_lib":`Już istnieje w tej bibliotece plików`,
"label.icon.151":`VR`,
"label.withvalue":`Według wartości`,
"label.tianyancha.businseeverify.opererror":`Nie udało się otworzyć danych biznesowych. Proszę spróbować ponownie lub skontaktować się z administratorem systemu!`,
"label.tabpage.individual":`Wybór indywidualny`,
"label.layout.editdistribute":`Edycja Przydziału`,
"label.smstemplate.lookup":`Zobacz szablon SMS`,
"pagecreator.systemstyle.button.delete":`Usuwanie stylu`,
"label.customer.tab.step2.same.option1":`Domyślnie Wł.`,
"label.knowledgebase.no.results.knowledge":`Brak wyników w zakresie wiedzy`,
"label.data.exp.newtemporexp":`Wybierz metodę eksportu danych lub utwórz nowy szablon`,
"vue_label_chatter_refuse_join":`Odmowa przyłączenia się`,
"Homepage.News.002":`Komponent wiadomości nie jest obecnie dostępny.`,
"label.log.requesttype":`Metoda wnioskowania`,
"vue_label_dashboard_generatefromreport":`Generuj z raportu`,
"label.knowledge.create.version":`Utwórz wersję`,
"label.emailtocloudcc.description2":`Połącz swoją pocztę e-mail`,
"label.partnerCloud.partnerAccount.recharge":`Kwota doładowania musi mieścić się w przedziale od 0,1 do {upperlimit}.`,
"label.customobjects":`Obiekty niestandardowe`,
"label.schedulableprg.endtime":`Data końcowa musi być późniejsza niż bieżąca data systemu`,
"message.error.viewreport.confirmdelete":`Istnieją wykresy, które używają bieżącego widoku/raportu jako źródła danych. Czy chcesz również usunąć ten wykres?`,
"label.marketing.social.seting":`Konfiguracja mediów społecznościowych`,
"chatter.follow.stop":`Przestań śledzić tego użytkownika`,
"label.notification.arketsea.return":`{5} zwrócił {0}：{1} do {2}.`,
"label.conditionsofnextapprover":`W wybranym żądaniu zatwierdzenia jest jeden lub więcej następnych określonych zatwierdzających. Proszę użyć poniższego okna wyszukiwania, aby określić następnego zatwierdzającego.`,
"label.partner.all.state":`Status`,
"mobel_web_closed":`Zamknięte`,
"label.icon.65":`Sprzęt`,
"label.stdashbord.xsld.business.jinehj":`Kwota ogółem`,
"label.selectobject":`Wybierz obiekt`,
"label.account.CurrentFQ":`Aktualne FQ`,
"label.workflow.estimaterule":`Oceniaj regułę, gdy rekord jest:`,
"label.list.userinterface.shownewrecordssetup":`Ustawienia ostatniego zapisu`,
"label.tianyancha.businessverify.msg3":`1. opłata`,
"label.weixin..xsld.jieduan":`Scena`,
"label.first.quarter":`Pierwszy kwartał`,
"Opportunity.Detailed.Phase.Label.002":`{0} dzień(y) w bieżącym etapie`,
"label_tabpage_page":`Strona`,
"label_emailsync_status_time":`Czas`,
"label.pleaseselectaapprover":`Proszę wybrać zatwierdzającego`,
"label.emailtocloudcc.redmessage5":`Nieznany status, proszę skontaktować się z administratorem.`,
"label.four.quarter":`IV kwartał`,
"label_chatter_relateList":`Odpowiednia lista`,
"label.customfields.new.step2.opration.exid.info":`Ustaw to pole na unikalny identyfikator rekordu dla systemu zewnętrznego`,
"label.projectManagement.nodata.overdue.tasks":`Świetnie! Brak zaległych zadań`,
"label.sendemail.activity.task.statuscompleted":`Drogi #createbyidccname Witaj! \Zadanie, które zleciłeś #belongtoidccname w dniu #createdate jest następujące: \N Subject: #subject Czas trwania: #expireDate \N Related Items: #relatedstr:\N Treść: #remark Proszę odwiedzić link, aby uzyskać więcej szczegółów: \N #path\N Proszę zwrócić uwagę: #belongtoidccname jest oznaczony jako zakończony. \™ #orgNameCRM System`,
"label.sso.saml.idp.config.issuer":`Emitent`,
"label.cannot.delete":`pozycje) nie mogą być usuwane`,
"label.pigeonhole.sel_f":`Wybierz foldery do archiwizacji`,
"label.customfields.text.tip":`Umożliwia użytkownikom wprowadzenie dowolnej kombinacji liter i cyfr.`,
"message.error.user.service.common":`Operacja nie powiodła się, prosimy o kontakt z administratorem w celu uzyskania pomocy.`,
"label.datamanage.account.information":`Informacje o koncie`,
"vue_label_homepage_deleteprofilepage":`Usuń stronę główną profilu`,
"label.sendmail.step3.introduce3":`odbiorca(y) wybrany(i) do otrzymania tej wiadomości SMS.`,
"label.pc.ui.2018.recentitem":`Ostatnie pozycje`,
"label.report.loading":`Oczekiwanie na załadunek`,
"vue_label_globalsearch_adjustment":`Metoda regulacji`,
"label_report_line_yixuan":`Wybrana kolumna raportu`,
"label.h5.similar.opportunity.only.view":`Tylko wyświetlacz`,
"label.marketactivitymember":`Członkowie kampanii`,
"label.recycle.execute.tip":`Twoja prośba została przetworzona i zajmie to trochę czasu, aby wyczyścić kosz. Zostaniesz powiadomiony przez e-mail, gdy zostanie to zakończone.`,
"label.permission.detail.system.setting":`Ustawienia uprawnień systemowych`,
"label.RecordType":`Typy rekordów`,
"label.custom.error.between":`Niestandardowa data rozpoczęcia roku lub niestandardowa data zakończenia roku znajduje się pomiędzy niestandardowymi latami historii, proszę sprawdzić i zresetować.`,
"vue_label_dashboard_selectview":`Wybierz widok`,
"label.tianyancha.businessverify.cancel":`Wyłączenie weryfikacji danych biznesowych`,
"label.partnerCloud.financeSetting.MD5":`MD5 Tajny klucz`,
"label.multilang.messagedetail.new.error":`Nie możemy znaleźć użytkownika Czatu o dowolnej nazwie z {0}:`,
"label.callcenter.pleaseenter.private.key":`Proszę wprowadzić prywatny, tajny klucz dostępu`,
"label.umeng.activity.youdistribute":`Przydzielony do`,
"label.weixin.nickname":`Pseudonim`,
"label.customerinfo.mailusername":`Nazwa użytkownika e-mail`,
"label.partnerCloud.orderingPlatform.discountPlan":`Nazwa harmonogramu rabatowego:`,
"lable.account.year":`Rok podatkowy`,
"T":`Czas`,
"System.Email.Template.Title":`Witamy na platformie CloudCC CRM`,
"label.login.type":`Typy logowania`,
"label.notification.evaluation":`{0} lewy komentarz {2} dla przypadku {1}`,
"label.turntolist":`Przejdź do listy`,
"label.sort":`Sortuj`,
"vue_label_commonobject_notice_clickcross":`Jeśli chcesz zastąpić przesłany plik, kliknij przycisk [X] i prześlij go ponownie.`,
"label.Select.maximumecords.operate":`Do przetwarzania można wybrać do 200 rekordów.`,
"label.submission_rate":`Stawka za złożenie wniosku`,
"label.datadelete.record.sucessfully":`rekord(y) zakończony(e) sukcesem`,
"label.version.standard.dashboard":`Standardowe pulpity`,
"label.task.postunsolve":`Zaległe zadania`,
"label.Receivables.name":`Należność Nazwa`,
"label_tabpage_noOperationz":`Ta zawartość jest elementem stałym i nie może być obsługiwana!`,
"label.attendance.onrecord":`Wybierz jeden rekord, co najmniej`,
"label.partner.error2":`Błąd: Nazwa domeny może zawierać tylko cyfry lub litery.`,
"label.account.map":`Mapa konta`,
"label.dashboardSetup.reference.legend":`Schemat odniesienia`,
"label.Yaxisscope":`Zakres osi Y`,
"label.hierarchy.tree.tip":`Wybierz rekord w polu wyszukiwania w każdej zakładce, aby utworzyć hierarchię. Hierarchia wygląda następująco:`,
"label.permission.objlist.columnsize":`Całkowita liczba pól`,
"label.setup.mobile.bottombutton.savesuccess":`Ustawienia strony pierwszego poziomu zapisane`,
"label.mobile.side.tab.selected":`Już wybrano`,
"label.partner.donotdel.cause":`Ponieważ ma powiązania z następującą chmurą partnerską`,
"label.ccchat.message.new.error4":`Przypominamy:`,
"vue_label_systemSettings_setorganization":`Skonfiguruj aplikacje dla swojej organizacji, dostosuj różne menu dla różnych działów funkcjonalnych.`,
"label.umeng.approval.approvalmes4obj1":`Proszę sprawdzić zatwierdzenie w terminie`,
"UG_opportunity_010":`Tworzenie transakcji`,
"label.tag.addtags.public":`Publiczne`,
"System.TAB.SeeViewPageAmount":`Zobacz strony`,
"label.filterconditions":`Filtr`,
"front-personalEmailBox-module-v12-clear-not-associated":`Anuluj połączenie wyczyści wszystkie niepowiązane emaile, czy jesteś pewien, że chcesz anulować połączenie?`,
"label.assign":`Przyporządkuj`,
"label.layout.clone.tip":`Możesz wybrać istniejący układ do sklonowania`,
"label.choose.relatedlist":`Wybierz listę powiązaną, którą chcesz przenieść`,
"label_chatter_recordcall":`Nagrywane połączenie`,
"label.product.proofOne":`W {0} należy wybrać do {1} opcji produktu.`,
"label.layout.availablefield.relatedlist":`Dostępne pola / Powiązane listy`,
"label.campaignmember.main.updateleadstatus":`Aktualizuj status - istniejące leady`,
"label.custom.buttonandlink":`Własne przyciski`,
"label.view.manage":`Zobacz Zarządzanie`,
"label.search.exp":`Wybierz obiekty, dla których chcesz włączyć poniższe funkcje i kliknij Zapisz:`,
"vue_label_appstore_apply_to":`Zgłoś się do`,
"label.dashboard.message.refreshfail":`Odświeżanie tablicy rozdzielczej nie powiodło się`,
"UG_Case_02":`Przypadki pozwalają na reagowanie i rozwiązywanie problemów z kontami. Sprawy są potężnym zapisem w Cloud CC, który nie tylko śledzi sprawy związane z kontem, ale także wyświetla pełny obraz konta.`,
"label.project.hit.three":`Codzienne przypomnienie o podzadaniu`,
"label.tianyancha.businessverify.tip":`Funkcja weryfikacji danych biznesowych jest włączona, aby pomóc użytkownikom we wprowadzaniu prawidłowych informacji o rejestracji biznesowej klienta podczas wprowadzania danych klienta przedsiębiorstwa.`,
"label_emailsync_status_disconnect":`Anuluj połączenie`,
"label.rule.disabled.successfully":`Pomyślne wyłączenie reguł`,
"label.custombutton.queryerror":`Zapytanie nie powiodło się, prosimy o ponowne uruchomienie.`,
"label.customfields.deletecannotresume":`Odpowiednie dane zostaną trwale usunięte i nie będzie można ich odzyskać.`,
"label.account.current.M":`W tym miesiącu`,
"label.under.approve.data":`sprawdzane są zapisy(`,
"vue_label_title_remainingdays":`Pozostałe dni`,
"label.partnerCloud.orderingPlatform.refundable":`Dostępny Rebate`,
"label.lookup.iscover":`Zezwalaj na synchronizację podczas edycji`,
"label.recordtype.detail.selectlist":`Listy wyboru dostępne do edycji`,
"label.sso.isActiveYes":`Tak`,
"label.service.appointmentList.canceltheSuccess":`Pomyślnie anulowane`,
"label.escalation.setup.newentries.createfirst":`Kiedy sprawa jest tworzona, i wyłączana po pierwszej modyfikacji sprawy`,
"label.new.ccpeakfolder":`Klasa : Nowy Folder`,
"lable.currencyAdv.exchagecurrency.after":`i po`,
"label.majoranddetailrelation":`Relacje mistrz-szczegół`,
"label.appointment.wizard.subtitle4-2-1":`1 h`,
"label.projectManagement.working.hours":`Godziny pracy`,
"label.forecast.customforecast.button.forehistory":`Historia prognozy`,
"label.mymasterplate":`Moje szablony`,
"component.setup.tabs.label.memo":`Ustawianie nazwy znacznika karty`,
"label.customfields.longtextarea.tip":`Pozwala użytkownikom na wprowadzenie do 32,000 znaków w oddzielnych liniach. Możesz utworzyć do 10 pól Text(Long) na obiekt.`,
"label.service.miniProgram.fillJumpLink":`Proszę wypełnić link skokowy.`,
"label.british.summer.time":`Czas średni Greenwich`,
"label.nogreate":`<=mniejszy lub równy`,
"label.assignment.setup.detail.sameuser":`Ten sam użytkownik`,
"mesage.error.profile.delate.user":`Nie można usunąć profilu, ponieważ użytkownik jest przypisany do bieżącego profilu.`,
"label.tabpage.cownerz":`Zmienić właściciela`,
"label.multilang.dupicatecheck.processedcount":`Powielone dane，{0} grupy zostały poddane obróbce，{1} grupy danych nie zostały poddane obróbce：`,
"vue_label_report_notice_leavecertification":`Czy na pewno chcesz opuścić tę stronę - wprowadzone dane mogą nie zostać zapisane`,
"label.master.required":`Posiadanie wymaganych pól brakujące rekordy dziecka`,
"label.chatter.follow":`Śledź`,
"label.dataimport.insertdata.error.repeat":`Rekord powiela dane w oryginalnej bazie danych i został zignorowany import.`,
"label.sms.cgid":`Galeria Liczba`,
"label.knowledge.article.rator":``,
"label.datamanage.object.field":`Pola obiektów`,
"label.forecast.editshrepage.quanxian":`Sharing Peimission Poziom dostępu`,
"label.weixin.interactive.log":`Dziennik interakcji`,
"label.batchedit.remark":`Edycja wielu rekordów`,
"label.user.permissions.message":`Brak uprawnień do ustawiania informacji o użytkowniku.`,
"label.mobile.phone.month":`miesiąc`,
"chatter.sel.u":`Wybierz użytkowników, których chcesz @ wymienić, lub wpisz nazwę użytkownika, którego chcesz @ wymienić.`,
"label.service.gantt.assigned.work":`Praca przypisana`,
"UG_ST_001":`Prompt`,
"label.edit.select.one":`Lista rozwijana`,
"label.forecast.shrepage.desc0":`Ta strona zawiera listę użytkowników, ról i stref, które mają współdzielony dostęp do {0}.`,
"label.multilingual.confirm.close":`Czy na pewno chcesz wyłączyć? Po wyłączeniu nie będzie można używać wielu języków, a język użytkownika zostanie zmieniony na język domyślny.`,
"label.setting.intergrationlist.integration":`Integracja`,
"label.leadscore.rule.list":`Lista zasad scoringu leadów`,
"component_telerecord_button_save":`Zapisz`,
"label.weixin.save.log":`Zapisz dziennik`,
"label.validate.function.funcExplain.DAY":`Zwraca dzień miesiąca, należy wprowadzić liczbę z przedziału od 1 do 31.`,
"label.appointmentdetail.wizard.title1":`Nazwa`,
"label.multilang.feedtrack.dealkey":`Zmień {0} z {1} na {2}.`,
"label.optional.features":`Funkcje opcjonalne`,
"vue_label_email_no_email":`Brak poczty elektronicznej`,
"label.sendemail.chat.messagecontent":`Treść komunikatu:`,
"label.tabpage.lessequalz":`Mniej niż lub równa`,
"setup.layout.label.setupfield":`Właściwości pól`,
"label.approved.receiveApprovalEmail.option1":`Jeśli jestem zatwierdzającym lub oddelegowanym zatwierdzającym`,
"label.chatter.relateList":`Odpowiednia lista`,
"component.sendmail.label.fromuser":`Nadawca`,
"label.projectManagement.problem.status":`Status zagadnienia`,
"label.weixin.fmu.before.hour":`{0} godzina(y) do przodu`,
"chatter.feed.menutype.feed.mark":`Zakładka:`,
"label.addQuoteLineGroup":`Dodaj grupę linii wyceny`,
"label.report.action.addtodashboard6":`Dodaj`,
"label.url":`URL`,
"lable.account.CurrentandPreviousCQ":`Obecne i poprzednie CQ`,
"label.tabpage.emptyz":`Puste`,
"less":`Mniej niż`,
"label.h5.selectmostphotos":`Można wybrać maksymalnie dziewięć zdjęć`,
"UG.activity.04":`Skrzynka pocztowa Outlook/Gmail, zapisywanie poczty`,
"template.chart.qbhtje":`Wszystkie Kwota umowy`,
"label.tabpage.endz":`Koniec`,
"label.partner.workspace.member":`Członek`,
"label.filter.error.filedvaluetoolong":`Błąd: Wartość pola przekracza maksymalny limit.`,
"label.months":`Miesiąc`,
"button.partner.workspace.disable":`Anuluj aktywację`,
"label.visualpage.checkpinyin.grammar":`Proszę sprawdzić pisownię i gramatykę.`,
"label.dashboardSetup.geshihua":`Formatowanie`,
"label.belongto":`Należeć do`,
"label.upload.cannot.empty":`Musisz wybrać plik, który chcesz przesłać.`,
"label.number.MaxCheck":`Maksymalna wartość dla {0} to {1}. Proszę zmodyfikować ilość i zapisać zmiany.`,
"pagecreator.page.message.save.fail":`Nie udało się zapisać strony`,
"label.edit.SMS":`Powiadamianie SMS Edycja`,
"UG_Lead_002":`Istnieje wiele sposobów na identyfikację "leadów" dla Twojego produktu lub usługi.`,
"label.quickcreate.active.quickcreate":`Włącz opcję Szybkie tworzenie`,
"label.recordtypeselect.tip":`Aby pominąć ten krok w przyszłości, należy ustawić domyślne typy rekordów.`,
"label.form_content":`Formularz`,
"workflow.action.tasks.assignortype.related":`Użytkownik powiązany`,
"vue_label_allsearch_set_more_items":`Możesz ustawić więcej pozycji wyszukiwania w polu rozwijanym po lewej stronie pola wyszukiwania, aby kontynuować wyszukiwanie.`,
"label.tianyancha.businessverify.title":`Weryfikacja biznesowa`,
"label.errormessage.batchedit.norecord":`Brak danych.`,
"label.permission.appname":`Nazwa aplikacji`,
"label.report.action.addtodashboard7":`Anuluj`,
"label.generated.transfer.product":`Generuj aktywa zgodnie z metodą Konwersji Aktywów.`,
"vue_label_commonobjects_detail_you":`Ty`,
"label.user.captcha":`Zweryfikuj swoją tożsamość`,
"label.notification.event4":`Zdarzenie 【事件名】, które przypisałeś do 【被分配人】 zaczyna się od 【开始时间】`,
"label.version.setup":`Ustawienie`,
"setup.object.layout.message.selectedlayoutandrecordtype":`Proszę wybrać układ i rodzaj płyty`,
"label.role.add":`Dodaj rolę`,
"label.versiontype.Unlimited":`Bez ograniczeń`,
"label.partnerCloud.financeSetting.developerID":`Proszę podać ID dewelopera.`,
"front-invoice-online-payment-setup-global":`Aplikuj do działu klientów globalnych`,
"vue_label_commonobjects_view_basis":`Podstawa klasyfikacji`,
"label.decimaldigits.tip":`Liczba cyfr po prawej stronie przecinka dziesiętnego`,
"vue_label_commonobjects_detail_selected":`Oznacz jako bieżący etap`,
"label.data.export.page":`Przejdź do strony eksportu`,
"message.error.serviceresource.servicecrewid":`Każda załoga serwisowa może być dodana tylko jako jeden rekord zasobu serwisowego typu załoga.`,
"label.loginttime.alltime":`Cały czas jest`,
"label.requiredinfo":`Wymagane informacje`,
"label.forecast.edit.di":`FY`,
"vue_label_calendar_failed_to_remove_calendar":`Nie udało się usunąć kalendarza`,
"pagecreator_systemstyle_button_delete":`Usuwanie stylu`,
"label.import.page3.continueimport":`Kontynuuj import`,
"label.page.width":`Pełna szerokość strony`,
"label.campaignmember.selectmember.addmember":`Dodaj członków z`,
"label.finalreject":`Ostateczne odrzucenie`,
"label.isend":`Jest zakończona`,
"front-console-conversation":`Dialog`,
"label.mr.theLastGroupOfThisPage":`Jest to ostatni zestaw danych na tej stronie.Kliknij przycisk [Back to Duplicate Data List], aby wyświetlić więcej zduplikowanych danych.`,
"label.data.dataexpalltype.all_desc":`Eksport danych wszystkich obiektów, do których odczytu ma dostęp bieżący użytkownik.`,
"label_emailtocloudcc_redmessage7":`Błąd konfiguracji, proszę skontaktować się z administratorem.`,
"label.forecast.shrepage.classdes.all":`Pełny dostęp - Użytkownicy mogą przeglądać i zmieniać dane prognozy oraz rozszerzać dostęp dla innych użytkowników poprzez współdzielenie.`,
"market.contacts":`Market Contact`,
"label.weixin.polls.voter":`Lista osób, które wzięły udział w głosowaniu`,
"template.report.industry.distribution.customers":`Branżowy podział rachunków`,
"front-electronic-signature-setup":`Umowa Infor Autofill i Backfill Setup`,
"vue_label_chatter_removecertification":`Czy na pewno chcesz usunąć członka "{name}"?`,
"label.appointment.wizard.subtitle1-2":`15 min`,
"label.sso.saml.idp.config.custattr":`Atrybut niestandardowy`,
"label_tabpage_totalTeamz":`Łącznie grupy`,
"lable.outlook.detail.assigned":`Przypisani użytkownicy i profile`,
"label.department.user.delete":`Usuń`,
"label.customcomponent.check.label.same":`Ta etykieta już istnieje.`,
"label.partner.error1":`Błąd: długość domeny jest zbyt duża`,
"label.escalation.setup.entrydetail.escalation.notify":`Powiadomić`,
"component_todaytask_label_choicestate":`Wybierz status`,
"label.customfields.fielddependency.new.step1":`<b>Krok 1a</b> Wybierz pole kontrolne i pole zależne. Kliknij Kontynuuj po zakończeniu.`,
"chatter.group.anyoneCanSeeTheUpdateAndJoin":`Każdy może zobaczyć tę grupę i ubiegać się o przyjęcie do niej`,
"label.custom.pixel":`piksel`,
"label.quicksave":`Quick Save`,
"label.approved.persion":`Zatwierdzający delegowany`,
"lable.info.queue.member":`Członkowie kolejki`,
"label.addattachment.step2.weixin":`Krok 2 Kliknij przycisk Prześlij, aby przesłać pliki`,
"label.forecast.customforecast.title":`Prognozy`,
"mainpage_setup_chosecomponent_leastone":`Musisz wybrać przynajmniej jeden komponent na stronie głównej.`,
"label.appointmentconfirmpage.wizard.title2":`Zaproszenie do kalendarza zostało wysłane na Twój adres e-mail.`,
"label.useallselectedapprover":`Wymaga, aby wszyscy wybrani zatwierdzający <strong>jednogłośnie </strong>zatwierdzili`,
"label.ccpeak.current.line.return":`Powraca z bieżącej linii i nie jest już wykonywana w dół.`,
"label_new_target_model":`Nowy model docelowy`,
"label.saving":`Oszczędzanie...`,
"label.mobile.phone.write":`Napisz`,
"label.applt.updown.text":`Możesz również pobrać kod QR mini programu portalowego dedykowanego Twojej firmie i umieścić go na stronie internetowej lub w ogólnodostępnym artykule, a klienci będą mogli zeskanować kod QR, aby skorzystać z mini programu.`,
"label.partner.common.manageSetup":`Ustawienia administracyjne chmury partnerskiej`,
"label.quickbooks.new":`Nowy klient`,
"message.error.color":`kolor nie może być pusty!`,
"label.project.template.two":`W każdym obiekcie może być tylko jeden zestaw konfiguracji pod każdym typem rekordu!`,
"label.approval.input.des1":`Zatwierdź lub odrzuć poziom po poziomie, a maksymalny poziom hierarchii to:`,
"label.x.axis.cannot.empty":`Oś X nie może być pusta`,
"label.solomon.isiands.time":`Solomon jest. Time`,
"label.login.access.duedate":`Czas trwania dostępu`,
"label.service.dispatch.booking.order":`Przydzielanie terminu serwisowego`,
"label_shareme_forecast":`Podziel się ze mną prognozą`,
"label.custom.page.cuspage.height":`Wysokość(Piksele)`,
"label.quote.line.group.":`Czy na pewno chcesz usunąć grupę wierszy cytatu o nazwie {groupName}? Linie cytatu w tej grupie również zostaną usunięte po wykonaniu operacji.`,
"label.data.downpage.i_title.num6":`Zaleca się, aby przed zaimportowaniem danych zaimportować plik testowy zawierający 5 rekordów, aby upewnić się, że dane, które chcesz zaimportować są poprawne.`,
"label.\u2019s":`s`,
"label.version.contact.management":`Zarządzanie umowami`,
"label.document.history.user":`Użytkownicy`,
"vue_labenl_commonobjects_opportunity_product_edit_notice1":`Proszę wpisać prawidłową kwotę, do dwóch miejsc po przecinku.`,
"label.weixin.target.contract.jine":`Docelowa kwota umowy`,
"lable.common":`￥0 w sumie`,
"front-kefu-moudle-sendemail-success":`Email został wysłany, a pracownicy działu sprzedaży skontaktują się z Tobą tak szybko, jak to będzie możliwe.`,
"label.service.no.operation.time":`Obecny rekord nie ma powiązanego czasu operacji!`,
"label.info":`Informacje`,
"label.ccchat.zw":`NOON`,
"label.assignment.setup.newentries.title":`Edycja wpisu reguły`,
"label.weixin.report.timeline":`Pole daty`,
"UG.quota.04":`Cytat z druku`,
"label.social.user.exception":`Nieprawidłowe informacje o użytkownikach społecznych.`,
"label.import.index.failed":`Nieudana`,
"label.common.settings":`Ustawienia ogólne`,
"label.nullvalue":`Wartość zerowa`,
"PageLayout_Search_MultiSearch_002":`Włącz niestandardowe pole wyszukiwania (Wyszukiwanie pojedynczego pola)`,
"message.myselfreport":`Moje osobiste raporty niestandardowe`,
"label.productsales.today.noevttskaddtsk":`Nie ma żadnych otwartych zdarzeń i wygasających zadań, możesz kliknąć " " w prawym górnym rogu aby dodać nowe zadanie.`,
"lable.oppdt.noconditionrecrods":`Brak rekordów do wyświetlenia`,
"label.campaignmember.selectmember.deletelead":`Kampania: usuń członków z leadów`,
"label.marketingactivity":`Kampanie`,
"vue_label_pool_self-built":`Samodzielnie zbudowany`,
"message.textareamaxlength":`Długość nie powinna przekraczać 4000 znaków`,
"label.valadate.must.value":`Musi wprowadzić wartość`,
"label.tabpage.groupsVisiblez":`Niektóre grupy użytkowników są widoczne`,
"component.button.cancel":`Anuluj`,
"label.emailobject.list.inbox":`Skrzynka odbiorcza`,
"label.app.step1.error.labelexist":`ERROR Ta etykieta już istnieje lub była wcześniej używana.`,
"front-calendar-V1-Unable-to-display":`Rekord nie może być wyświetlany w kalendarzu, ponieważ pole końca jednego lub więcej niż jednego rekordu jest wcześniejsze niż pole początku.`,
"label.forecast.settings.prompt1":`Należy wybrać co najmniej jeden z pomiarów prognozy: Przychody lub Ilość.`,
"front-kefu-moudle-callout-missphone":`Wywoływanie nieodebranych połączeń`,
"label.tabpage.editz":`Edytuj`,
"vue_label_chatter_label_new_team":`Nowa grupa`,
"label.version.formulafield":`Pole wzoru`,
"label.partner.step1":`Krok 1 wybór szablonu`,
"label.weixin.perfect.url":`Wprowadź szczegóły adresu URL`,
"label.appointmentconfirmail.wizard.subtitle4":`Opis`,
"label.step7.total7":`Krok 7 z 7`,
"setup.object.layout.label.selectedprofile":`Wybrane profile`,
"label.payments.paytip5":`Proszę podać prawidłową liczbę użytkowników!`,
"label.visualpage.open.type":`jest otwarty niestandardowy styl strony`,
"lable.Sort.field.tips":`Dostosuj kolejność zapisu na liście powiązanych poprzez wybór pól do sortowania. Porządkować można na podstawie dowolnych pól numerycznych lub dat obiektów.`,
"label.nosharerules":`Nie określono zasad udostępniania.`,
"label.service.miniProgram.bindSetOwner":`Zestaw Przypadki Właściciel`,
"report_label_highlevelreport":`Raporty zaawansowane pozwalają na tworzenie relacji pomiędzy maksymalnie 4 obiektami.`,
"S":`Tekst`,
"label.lastmodifyby":`Ostatnio zmodyfikowane przez`,
"label.customerinfo.mailaddress":`Adres e-mail`,
"vue_label_pool_converted":`Przekształcona`,
"UG.ST.004":`Nie posiadasz uprawnienia do zarządzania danymi - "import danych, skontaktuj się z administratorem, kliknij zatwierdź i przejdź bezpośrednio do interfejsu {0}.`,
"label.view.application.mobile.terminal.filed":`Ten widok został zastosowany w aplikacji mobilnej. Dostępnych jest maksymalnie 10 pól, które zostały wybrane.`,
"chatter.feed.limitentity500":`Możesz śledzić 500 kolegów i rekordów.`,
"label.starttime":`Start`,
"chatter.emailToMe":`Przypomnij mi, kiedy ktoś:`,
"label.custom.Current.and.PreviousCQ":`Obecne i poprzednie CQ`,
"label.my.logout":`Ja`,
"label.quickbooks.searchlist.enddate":`Data końcowa`,
"label.ccservice.validate.length":`Długość odpowiedniej wartości {2} pola {1} w obiekcie API {0} została przekroczona. Proszę ją zresetować!`,
"label.integrations.installed":`Zainstalowany`,
"label.integrations.mailchimplist":`Lista Mailchimp`,
"label.checkfield.matchothers":`Dopasowanie do innych zapisów`,
"label.umeng.activity.event.distributewillbegin":`Wydarzenie #event, które przypisałeś do #name rozpocznie się w #time.`,
"pool.notice.gotolightning":`Jeśli chcesz skorzystać z tej funkcji, przejdź do Menu Błyskawica.`,
"label.batchtransfer.pleaseselecttransferreddata":`Wybierz dane, które chcesz przenieść`,
"label.mr.title.mailingAddress":`Adres korespondencyjny`,
"vue_label_approve_no_response":`Brak odpowiedzi`,
"component.event.label.title":`Nadchodzące wydarzenia`,
"label.mobile.setup.confirm":`Zmieniasz położenie domyślnej ikony zakładki w aplikacji mobilnej. Po udanej zmianie, wszystkie poprzednie konfiguracje ikony zakładki zostaną usunięte, musisz zresetować ikonę zakładki używaną w aplikacji mobilnej. Jeśli nie wybierzesz, system wybierze losowo w katalogu ustawień.`,
"label.tianyancha.approvaltime":`Data zatwierdzenia`,
"label.download_merge_file":`Pobierz połączony plik`,
"label_display_quota":`Pokaż kontyngent`,
"label.publishreadonly":`Publiczny Tylko do odczytu`,
"label.campagin.roi.query.roi":`ROI kampanii`,
"label.dashboardSetup.lookup":`Znajdź pulpity`,
"vue_label_notificationcenter_nomessages":`Brak nieprzeczytanych wiadomości`,
"label.create.object":`Utwórz obiekt`,
"label.social.campaign.null":`Informacje o kamaginie nie mogą być puste`,
"label.console.step6.left":`Stały w lewo i listy są zawsze widoczne.`,
"label.line":`Kolumna`,
"label.bottonandlink.introduce":`Tutaj jest lista przycisków i linków. Dodaj przyciski lub linki, proszę edytować układ.<br/>Przyciski i linki mogą być dodawane do strony szczegółów, listy powiązanych i widok listy.<br/>`,
"label.layout.list1":`Wykaz 1`,
"label.mr.title.customerName":`Nazwa konta`,
"label.user.text":`Tekst`,
"label.nolastestrecord":`Brak ostatniego zapisu`,
"label.emailobject.appointment.urltext1":`Zobacz mój harmonogram i`,
"label.chat.topic.my.favorites":`Zakładka:`,
"label.select.dashboar.cd0":`Pole grupowania nie może być puste`,
"label.data.downpage.e_title.num2":`2. W przypadku eksportu danych pojedynczego obiektu należy wybrać sposób eksportu danych: eksport niestandardowy, eksport wg szablonu oraz szablon eksportu.`,
"message.error.user.service.login.unconn":`Sieć zajęta, spróbuj ponownie lub skontaktuj się z administratorem.`,
"label.escalation.setup.newentries.title":`Edycja wpisu reguły`,
"label.import.step1.above2000":`Podczas wykonywania trigera może zostać zaimportowanych maksymalnie 2000 rekordów jednocześnie. Proszę podzielić na wiele plików i importować je partiami.`,
"label.ccchat.person.allowinvite":`Pozwól współpracownikom zapraszać`,
"label.input.number.between":`Proszę wpisać liczbę z przedziału od {0} do {1}.`,
"label.forecast.shrepage.wpfmanager":`Delegowany kierownik prognozy`,
"label_server_is_time_out":`Czas oczekiwania na połączenie z serwerem został przekroczony. Proszę spróbować ponownie później.`,
"label.indochina.standard.time":`Czas standardowy Indii`,
"label.cpq.quote.sync.opportunity.failure":`Tylko podstawowa wycena może być zsynchronizowana z szansą. Proszę zaznaczyć pole oferty głównej, a następnie rozpocząć synchronizację.`,
"label.emailobject.send100emails":`Przepraszamy, możesz wysłać tylko 100 maili dziennie, proszę wybierz ponownie!`,
"label.dashboard.snapshot.end":`Na dzień`,
"label.jiandangfenpei.rightlist":`Przypisane profile`,
"label.input.string.length.between":`Wprowadź ciąg znaków o długości od {0} do {1}.`,
"label.multilang.lookfiltercondition.select":`Warunek wiersza {0} jest nieprawidłowy. Musisz wybrać pole!`,
"label.datamanage.lead.namenull":`Uwaga: Jeśli pole "lead name" jest puste, rekord nie zostanie zaimportowany.`,
"label.forecast.detailforecast.button.saveandfresh":`Zapisz`,
"label.venezuela.time":`Wenezuela Czas`,
"label.same.analyze.miaoshu1":`Jeśli potrzebujesz więcej zasad, użyj "`,
"label.twomb":`Można przesyłać tylko pliki jpg/png o maksymalnej wielkości 2MB.`,
"label.event.moveup.7hour":`7 godzin naprzód`,
"label.weixin.forgot.password":`Zapomniałeś hasła?`,
"label.import.page1.diledsizelimited":`2. Maksymalny dozwolony rozmiar pliku to 100M.`,
"label.file.foldername":`Nazwa folderu`,
"label.multilingual.open":`Zarządzanie wieloma lokalizacjami jest włączone.`,
"label.dashboard.snapshot.refresh.failed":`Odświeżanie migawek tablicy rozdzielczej nie powiodło się`,
"label.marketsea.memberfieldselectone":`Wyświetl pola i członkowie mogą wyświetlać pola Proszę wybrać co najmniej jedno pole`,
"label.trigger.createdate":`Data utworzenia`,
"label.ccpeak.operation.sharetab":`Operować na formularzu udostępniania:`,
"label.partner.message.admin.access":`Tylko administratorzy mogą się zalogować`,
"label.emailsync.status.email":`Wykonane działanie Email`,
"chatter.error":`Błąd:Proszę wybrać plik do przesłania!`,
"label.role.viewinlist":`Pokaż w widoku listy`,
"label.tag.addtags.title":`Tag`,
"setup.mainpage.label.welcome6":`Użytkownicy mogą tworzyć różne typy pól we wszystkich obiektach systemu CloudCC bez konieczności posiadania wiedzy programistycznej czy tworzenia kodu. Typy pól obejmują: relację wyszukiwania, pole jednokrotnego wyboru, wybór dwuelementowy, formułę, automatyczną numerację. URL, telefon, fax, email, pole wyboru, data, czas, liczba, tekst, obszar tekstowy, lista opcji (wybór pojedynczy/wielokrotny), waluta, itp.`,
"label.delete.rule.successfully":`Pomyślne usunięcie reguł`,
"label.field.duplicate.error.msg6":`Zduplikowana wartość pola. Wartość ta występuje w rekordzie:`,
"label.stdashbord.xsld.business.jhzsl":`Łączne możliwości (ilość)`,
"label.compact.layout":`Układ kluczowych informacji`,
"label.checkfield.merge.introduce":`Wybrać wartość, która ma być zachowana w połączonym rekordzie.`,
"earlieststarttime.duedate.time.illegal":`Rzeczywisty czas rozpoczęcia wizyty serwisowej powinien być krótszy lub równy rzeczywistemu czasowi zakończenia.`,
"label.dataimport.validate.prompt":`Reguła walidacji Prompt`,
"message.setuptip":`Możesz usunąć utworzone pakiety.`,
"template.report.customer.collection.statistics":`Statystyki Płatności Rachunku`,
"vue_label_homepage_dashboardcomponents":`Edycja elementów pulpitu nawigacyjnego`,
"setup.mainpage.label.welcome30":`Platforma CloudCC to prawdziwa platforma chmury obliczeniowej. Otwarte atrybuty platformy, standardowe metody integracji i elastyczne dostosowywanie mają zastosowanie we wszystkich branżach, integrując oprogramowanie innych firm, ujednolicając w czasie rzeczywistym dane zarządzania przedsiębiorstwem i maksymalizując wszechstronne i dogłębne potrzeby naszych klientów w zakresie zarządzania. Platforma CloudCC może być zintegrowana z dowolną aplikacją lub systemem przedsiębiorstwa, w tym z oprogramowaniem firm trzecich, takich jak SAP, Kingdee i UF. Standardowa metoda Web Service w ramach elastycznej architektury SOA nie ma żadnych destrukcyjnych, technicznych zależności ani uzależnienia od dostawcy.`,
"label.SMS.new.det":`Utwórz powiadomienie SMS, aby powiązać z nim jedną lub więcej reguł przepływu pracy, procesów zatwierdzania. Jeśli powiadomienie SMS zostanie zmienione, wszelkie zmiany zostaną zastosowane do wszystkich reguł i zatwierdzeń z nim powiązanych.`,
"lable.product.page.previous":`Powrót do poprzedniego`,
"label.recordtype.labelname":`Typ płyty Etykieta`,
"message.error.system.service.failure":`Wykonanie usługi nie powiodło się, prosimy o kontakt z administratorem.`,
"label.visualpagefolder":`Foldery stron`,
"label.username":`Nazwa użytkownika`,
"label.data.downpage.i.title.num5":`5、Please sprawdzić dokładność danych.`,
"label.permission.manage":`Zarządzaj zadaniami`,
"label_emailsync_status_user":`Użytkownicy`,
"label.weixin.voting.least.two":`Istnieją co najmniej dwie możliwości głosowania.`,
"label.tabpage.thisrecord":`Ten zapis`,
"label.icon.119":`Blackboard`,
"label.partner.common.webSit":`Domena`,
"label.email.form.html2":`[przełącz na tekst]`,
"label.appupload.upload.noversion":`Brak przesłanych wersji`,
"label.appointmentpage.wizard.subtitle1_2":`Inviter's Time Zone is {0}`,
"MR":`Lookup Relationship (Multi-Select)`,
"label.partnerCloud.orderingPlatform.availableBalance":`Dostępne saldo`,
"label.schedulejob.setup.schedule.st3":`3.`,
"label.reportsSubscriptionPage.email.general":`Ogólne`,
"label.setsharerule.step4":`Krok 4 Wybierz poziom dostępu dla użytkowników`,
"front-epwechat-module-v1-info-desc":`Proszę pobrać informacje z backend'u WeCom i wypełnić tutaj`,
"message.duplication.label.isactive":`Aktywny`,
"pagecreator_systemstyle_label_linkcolor":`Kolor łącza`,
"label.import.page1.alertfiledsize":`Wczytane pliki nie mogą przekraczać 100MB!`,
"tomorrow":`Jutro`,
"label.publicdashboard":`Niewypełnione pulpity publiczne`,
"label.knowledgebase.same.taborworkspace":`Ta sama karta lub obszar roboczy`,
"homepage.layout":`Układy strony głównej`,
"label.emailobject.trackemailopening":`Śledzenie otwarć wiadomości e-mail`,
"label.unlock.tip":`Odblokowanie rekordów do edycji`,
"lable.account.NextzDays":`Następne 90 dni`,
"vue_label_report_throw":`Odrzuć`,
"label.icon.102":`Harmonogram`,
"label.payments.paytip2":`Dokonałeś aktualizacji do naszej płatnej edycji, kliknij przycisk Potwierdź, aby zamknąć okno i odświeżyć swój system CRM.`,
"label.customfields.email.tip":`Umożliwia użytkownikom wprowadzenie adresu e-mail, który jest sprawdzany w celu zapewnienia poprawności formatu. Jeśli to pole jest określone dla kontaktu lub leadu, użytkownicy mogą wybrać adres po kliknięciu przycisku Wyślij wiadomość e-mail. Zwróć uwagę, że niestandardowe adresy e-mail nie mogą być używane w masowych wiadomościach e-mail.`,
"label.test_visitors":`Przetestuj, jak Twój formularz powinien wyglądać, gdy jest oglądany przez odwiedzających.`,
"label.workflow.immediatelyoperate":`Natychmiastowe działania przepływu pracy`,
"label.approvalstep4.tip":`Strona zatwierdzania jest miejscem, w którym osoba zatwierdzająca faktycznie zatwierdza lub odrzuca wniosek. Użyj następujących opcji, aby wybrać pola do wyświetlenia na tej stronie.`,
"label.ccchat.person.invite.failsend":`Poniższe zaproszenie nie zostało wysłane. Prosimy o kontakt z administratorem.`,
"label.import.index.obj":`Obiekt`,
"label.multilang.leadscore.countnum":`{0} razy:`,
"label.report.error.typefind":`Nie znaleziono typu raportu na podstawie informacji o grupowaniu`,
"label.validate.function.funcFormat.SUBSTITUTE":`SUBSTITUTE(text, old_text, new_text)`,
"label_tabpage_unpacketz":`Brak danych dotyczących grupowania!`,
"lable.Create.new.template":`Wzór raportu o nowej usłudze`,
"label.knowledgebase.display.error":`Pokaż {a} Błędy`,
"label.emailobject.template.message2":`Pole wstawione w bieżącej wiadomości e-mail nie pasuje do powiązanego rekordu, co może powodować wartości null.`,
"label.productsales.today.taskcomplete":`Ustawienie na zakończone`,
"label.emailobject.selectone":`Proszę wybrać co najmniej jeden rekord jako odbiorcę wiadomości e-mail`,
"button_partner_workspace_saveas_memo":`Zapisz bieżącą chmurę partnerów jako "szablon".`,
"vue_label_help_detail":`Szczegóły zapisu`,
"label.tabpage.minutesagoz":`Protokół`,
"label_tabpage_characterz":`Postać początkowa`,
"message.error.accesstoken.null":`Token nie może być pusty!`,
"label.textMessageObject.send100":`Przepraszamy, możesz wysłać tylko 100 wiadomości tekstowych dziennie, proszę wybrać ponownie!`,
"vue_label_commonobjects_detail_record_call":`Rejestrowanie połączeń`,
"label.campaignmember.main.addlead":`Dodaj członków - istniejące leady`,
"setup_mainpage_label_welcome30":`Platforma CloudCC to prawdziwa platforma chmury obliczeniowej. Otwarte atrybuty platformy, standardowe metody integracji i elastyczne dostosowywanie mają zastosowanie we wszystkich branżach, integrując oprogramowanie innych firm, ujednolicając w czasie rzeczywistym dane zarządzania przedsiębiorstwem i maksymalizując wszechstronne i dogłębne potrzeby naszych klientów w zakresie zarządzania. Platforma CloudCC może być zintegrowana z dowolną aplikacją lub systemem przedsiębiorstwa, w tym z oprogramowaniem firm trzecich, takich jak SAP, Kingdee i UF. Standardowa metoda Web Service w ramach elastycznej architektury SOA nie ma żadnych destrukcyjnych, technicznych zależności ani uzależnienia od dostawcy.`,
"label.file.library.deleteprompt":`Usunąć {0} z biblioteki zasobów ?`,
"label.wtd.changefields.title":`Konfiguracja połączenia internetowego z CloudCC`,
"label.sendmail.step1":`Krok 1 Określenie odbiorców, którzy mają być uwzględnieni`,
"label.cpq.newquote.createorder.checkbox.selected":`Podczas tworzenia nowej oferty nie można zaznaczyć pola wyboru Utwórz zamówienie.`,
"label.emailtocloudcc.name":`Nazwa`,
"message.error.object.nullbinding":`wiązanie jest puste`,
"B":`Checkbox`,
"label.pc.endtime":`Twoja licencja wygaśnie za mniej niż 30 dni. Odnów ją na czas, aby zapewnić ciągłość użytkowania.`,
"label.visualpage.section.start":`Użyj tagu na początku`,
"label.partnerCloud.basicSetting.available":`Nazwa domeny jest dostępna.`,
"label.data.exportall.all_desc":`Eksportuje wszystkie dane dla wszystkich obiektów, które bieżący użytkownik ma uprawnienia do przeglądania.`,
"label.editor.layout":`Edytuj układ wyszukiwania`,
"label.send.chatter":`Wyślij gadkę`,
"label.h5.chatter.reply":`Szybka odpowiedź`,
"component_chatter_post_button_file":`Dodaj załączniki`,
"label.emailobject.emaildetail.button.reply":`Reply`,
"label.eidt.queue.title.desc":`Nazwa musi być unikalna i musi zaczynać się od litery. Musi ona zawierać tylko duże i małe litery, cyfry i podkreślenia. Nie może być dłuższa niż 40 znaków.`,
"label.campaign.channel.input.url":`5.Skonfiguruj informacje, które użytkownicy zobaczą po zapisaniu się, może to być strona z podziękowaniami, ulotka lub bilet.`,
"label.compact.layout.assign.tip":`W tabeli przedstawiono przypisania układu kluczowych informacji dla różnych typów rekordów.`,
"vue_label_fall":`Zejdź`,
"label.trigger.save.failed":`Zapis nie powiódł się, dane nie mogą być puste`,
"label.appupload.upload.tips.report":`UWAGA: Raporty i stare raporty w My Custom Reports" i "Unfiled Public Reports" nie mogą być dodawane do pakietów i nie będą wyświetlane w tym folderze."`,
"label.tianyancha.businessverify.rewriteall":`Uzupełnij wszystkie dane`,
"label.campaign.channel.step6.remark4":`Należy pamiętać, że właścicielem leadu może być właściciel bieżącej kampanii lub osoba pozyskująca w bieżącym kanale marketingowym.`,
"front-kefu-moudle-called-num":`Wybrany numer`,
"label.approvalstep4":`Krok 4 Wybierz pola, które mają być wyświetlane w układzie strony zatwierdzania`,
"label.login.verification.please.scan":`Proszę zeskanować kod za pomocą aplikacji MFA na swoim smartfonie.`,
"label.invoice.message.statusupdated":`Status faktury zaktualizowany`,
"label.pc.ui.2018.subject":`Temat`,
"label.area.notexist.userinfo":`Grupa użytkowników nie istnieje.`,
"label.newuser":`Nowy użytkownik`,
"label.chat.micropost.share":`Share the post`,
"label.locatedupcurrentvalue":`Wartość powyżej bieżącej`,
"vue_label_systemSettings_course":`Ustawienie ścieżki błyskawicy`,
"chatter.group.public":`Publiczne`,
"label.reportsSubscription.entrance":`Subskrybuj`,
"front-kefu-moudle-v1-online-at":`Agent online`,
"label.rejectbehaviourselect":`Wykonaj <strong>tylko</strong> odrzucenie tego kroku i odeślij wniosek o zatwierdzenie do ostatniego zatwierdzającego.(Wróć do poprzedniego kroku)`,
"vue_label_commonobjects_view_currentviewset":`Aby anulować ustawienie bieżącego widoku domyślnego, można ustawić inny widok jako widok domyślny.`,
"lable.currencyAdv.and":`oraz`,
"label.appexchange.installedpage.publish":`Opublikowane przez`,
"label.tab.profile.ismobile":`Aplikuj do aplikacji mobilnej`,
"label.data.setok.t.desc2":`Powrót do strony z szablonami danych`,
"label.email_required":`Wymagane jest podanie adresu email.`,
"label.tabpage.fullscreenz":`Pełny ekran`,
"chatter.sticker.set":`Śledzenie paszy`,
"label.mobile.phone.year":`rok`,
"label.projectManagement.next.page.before":`Poprzednia strona`,
"pagecreator_button_pcpage":`Końcówka Pc`,
"label.dashboard.xsld.percent":`Procent`,
"label.ccpeak.service.checkerror":`Błąd sprawdzania składni.`,
"label.icon.26":`Folder`,
"label_partner_common_webSit_memo":`Domyślna nazwa domeny:`,
"label.unselectfile":`Nie wybrano żadnych plików`,
"label.take.notice":`Ogłoszenie`,
"message.error.filename.null":`FileName nie może być puste!`,
"vue_label_SMS_nophone":`Brak numeru telefonu`,
"label.area.assignuser":`Przydzielanie użytkowników`,
"label.icon.176":`Prompt`,
"label.icon.21":`Waluta`,
"message.error.system.service.deletedeny":`Dada jest powiązana i nie może być usunięta.`,
"label.compact.layout.main.tip":`Wybierz układ kluczowych informacji, które mają być używane, gdy ten rekord pojawi się jako element listy w CloudCC.`,
"label.emailtocloudcc.delete":`Usuń`,
"label.dashboardSetup.showdw.d2":`10 Milionów`,
"front-kefu-moudle-hqyyjlsb-admin":`Nie udało się uzyskać nagrania głosu, proszę skontaktować się z administratorem w celu uzyskania pomocy`,
"label.partnerCloud.basicSetting.userCounts":`Łączne role partnerów`,
"front-kefu-moudle-calling-num":`Numer wywoławczy`,
"label.alldocument":`Wszystkie dokumenty`,
"coderules.nullvalue1":`Nie udało się wygenerować. Proszę wprowadzić wartość dla 【{0}】 użytą w regułach generowania.`,
"lable.automatically.shared":`Automatycznie udostępniane`,
"label.batchadd.newbatchpage.save.emptyselect":`Proszę sprawdzić, czy są wymagane opcje, które nie zostały wybrane.`,
"vue_label_homepage_card_30dayswithout":`Brak kontaktu z okazjami przez 30 dni`,
"label.multilang.dupicatecheck.onegroupnote":`Proszę wybrać co najmniej dwie dane, kliknąć przycisk [Załaduj wybrane informacje], aby wejść na stronę łączenia danych. Obecnie w {0}-tej grupie danych przedsiębiorstwa znajduje się łącznie {1} rekordów... :`,
"UG.activity.03":`Zarezerwuj harmonogram`,
"label.pc.oldpage":`Stara strona`,
"label.exchange.sync.state.task.m2":`Rekordy zsynchronizowane w ciągu ostatnich 60 minut:`,
"label.setmovable":`Ustawienia aktywności`,
"label.sendemail.send.loginfail":`Nie udało się zalogować do skrzynki pocztowej, proszę zresetować dane e-mail.`,
"label.copy.quote.lines":`Sklonuj linię cytatu`,
"label.copying.reward.to.groups":`Kopiuj do grup linii notowań`,
"label.ems.connect.error":`Błąd połączenia z serwerem, proszę sprawdzić.`,
"lable.account.Tomorrow":`Jutro`,
"label.manageAll.sta2":`Zatwierdzony`,
"label.create_form":`Nowy formularz`,
"label.ems.saveDetail.error.msg":`Proszę sprawdzić konto pocztowe i hasło.`,
"label.service.gantt.distribution.recommendation":`Przydziel sugerowane`,
"label.email.track.attachment.size.control2":`Rozmiar wysyłanego pliku przekracza 10m i nie może zostać wysłany.`,
"lable.product.pricebooks.add":`Dodaj do cennika`,
"label.login.time":`Czas logowania`,
"label.tabpage.yes1z":`Tak1`,
"label.SalesCommitmentKanBan":`Pulpity menedżerskie zobowiązań sprzedażowych`,
"label_partner_workspace_myspace":`Moje miejsce pracy`,
"chatter.like":`otrzymany(-e)`,
"lable.PowerProcess.number.input":`Proszę wprowadzić liczbę całkowitą.`,
"chatter.coll":`Zakładka do książki`,
"label.campaign.channel.img.remark":`Uwaga: Rozmiar obrazu nie powinien przekraczać 2M.`,
"label.field.duplicate.error.msg7":`Zduplikowane dane`,
"vue_label_pool_discard":`Odrzuć`,
"label.service.gantt.total.planned.duration":`Suma planowanego czasu trwania wizyt serwisowych`,
"label.weixin.click.loadmore":`Kliknij, aby załadować więcej`,
"label.help.new.features.yd":`Instrukcja obsługi nowego interfejsu Mobile-sade`,
"label":`Etykieta`,
"label.quickbooks.viewlist.total1":`Istnieje {0} faktur o łącznej wartości {1}.`,
"front-kefu-moudle-v1-input-publicKey":`Proszę wprowadzić klucz współdzielony`,
"label.approval.allowed.reject":`Dozwolona odmowa`,
"label.visualpage.folder.notdel":`Nie można usunąć tego folderu, ponieważ znajdują się w nim niektóre pliki.`,
"label.projectManagement.charging":`Ładowanie`,
"label.ccservice.validate":`Format odpowiedniej wartości {2} pola {1} w obiekcie API {0} jest nieprawidłowy. Proszę wprowadzić prawidłową liczbę!`,
"message.unbind.mfadevice.no.permission":`Nie masz uprawnień do odblokowania urządzeń MFA. Skontaktuj się z administratorem.`,
"label.partner.new.step3.meno":`Nie jesteś pewien co wpisać? Nie martw się, możesz to zmienić w każdej chwili.`,
"label.import.page3.importsucceedtip":`Rozpocznij import pomyślnie. Po zakończeniu importu, na Twoją skrzynkę pocztową zostanie wysłany e-mail.`,
"label.customsetting.visible.protect":`Chroniony`,
"label.publishreadandwrite":`Publiczny odczyt/zapis`,
"vue_label_file_add_most_once":`Dodać co najwyżej raz`,
"label.salescloud.teamrole.optionlist.group":`Przydziel role członkom zespołu ds. okazji i członkom zespołu ds. kont.`,
"label.appointment.wizard.subtitle7":`Lokalizacja`,
"label.task.dateminus":`Minus`,
"label.data.exp.zippwd":`Ręczne wprowadzanie hasła do plików skompresowanych`,
"UG_Forcast_09":`Następny krok`,
"message.duplication.label.allselectlink":`[Wybierz wszystko]`,
"label.file.ccchat.selectfromcloudcc":`Wybierz plik z CloudCC`,
"label.ems.addaccount3":`Dodaj konto`,
"front-epwechat-module-v1-schedule-sync":`Harmonogramy synchronizacji`,
"label.h5.manage":`Zarządzaj aplikacjami`,
"setup.layout.label.nobutton":`Brak dostępnych przycisków`,
"label_component_hotdeal":`Gorące okazje`,
"template.dashboard.contract.analysis":`Analiza Umów i Należności`,
"vue_label_dashboard_editcomponent":`Edytuj składnik`,
"label.quotationInformation":`Informacje o cytatach`,
"label.data.file.validation_rules":`Wykonaj reguły walidacji`,
"label.ccpeak.construction.shareobj":`Aby skonstruować obiekt formularza udostępniania obiektu, musisz przekazać nazwę API i znak udostępniania.`,
"label.wei.pollinformation":`Szczegóły mikrogłosowania`,
"label.quickbooks.viewlist.total3":`Jest {0} płatności o łącznej wartości {1}.`,
"label.paging.totalofpagesnoid":`Łącznie {0} stron`,
"label.unlock":`Odblokuj`,
"front-invoice-online-payment-information":`Informacje o fakturze`,
"label.permission.systempermission":`Przypisane uprawnienia systemowe`,
"message.error.object":`Przy wywołaniu usługi okazuje się, że obiekt nie jest zdefiniowany.`,
"font-trade-module-v1-invoice-intro":`Proszę wpisać numer lub nazwę faktury.`,
"label.userinfo.pwdexpired":`Aktualne hasło straciło ważność. Ze względów bezpieczeństwa musisz teraz zmienić swoje hasło.`,
"label.userphoto.photo":`Zdjęcie`,
"label.tabularreport.filterrecord":`Wybierz kryteria określające, które rekordy mają być wyświetlane`,
"label.partnerCloud.orderingPlatform.rechargeIt":`Stan Twojego konta jest niewystarczający, prosimy o doładowanie.`,
"label.icon.120":`Komputer`,
"label.projectManagement.select.new.type":`Wybierz typ tworzenia`,
"vue_label_commonobjects_detail_customer_details":`Wczytywanie danych klienta`,
"label.ems.status":`Status`,
"label.validate.function.description":`Każda funkcja, która jest zgodna ze składnią java może być użyta w regule walidacji, a wyrażenie musi zwracać wartość Boolean.<br>Możesz również użyć specyficznej funkcji dostarczonej przez CloudCC.
Na przykład, isNew(),isChanged(FieldAPIName__c),priorValue(FieldAPIName__c),priorValue() zwraca obiekt, musi on zostać przekonwertowany na odpowiedni typ pola.`,
"label.escalation.setup.newaction.step2":`Krok 2 Wybierz użytkownika, któremu chcesz automatycznie przydzielić sprawy`,
"label.forecast.customforecast.searchforecast":`Znajdź prognozę`,
"label.the.upper.bound.of.each.level.of.block.pricing.must.be.greater.than.the.lower.bound.":`Górna granica każdego poziomu jest większa niż dolna granica przy ustalaniu cen za pomocą bloków.`,
"vue_label_commonobjects_view_notice_deletefailreason":`Nie udało się usunąć danych o identyfikatorze rekordu {0}，powód niepowodzenia: {1};`,
"page.field.masterinput.remark":`Włączone Wejście główne-szczegółowe służy do tworzenia rekordów listy powiązanej na stronie zakładki.`,
"lable.SalesCommitmentKanBan.contractName":`Nazwa kontraktu`,
"front-gantt-module-add-milestone":`Dodaj kamień milowy`,
"label.callcenter.save.error":`Proszę nie zapisywać ponownie`,
"label.workflow.selectobj":`Krok 1 Wybierz obiekt`,
"label.validate.function.category.all":`Wszystkie kategorie funkcji -- Wszystkie kategorie funkcji --`,
"label.multilang.uploadifupage.select":`Całkowicie wybrałeś {0} plików:`,
"label.weixin.dragsort":`Przeciągnij ikony w aplikacji Moje aplikacje, aby je posortować.`,
"N":`Numer`,
"label.knowledge.article.translation.completed":`Zakończono tłumaczenie artykułu`,
"label.weixin.myapp":`Moje aplikacje`,
"label.icon.138":`Waluta`,
"vue_label_chat_create_discussion_now":`Rozpocznij dyskusję już teraz`,
"label.knowledge.recover.article":`Przywróć artykuł`,
"label.ccpeak.use.class.time.map":`Dostęp przez przejście w kolekcji map`,
"front-email-payment-error-tips":`Błąd interfejsu`,
"label.service.gantt.ziyuan":`Tylko dla`,
"label.upload.error":`Nieudana`,
"label.staticresource.upload.error":`Błąd przy przesyłaniu zasobów statycznych!`,
"com.cloudcc.login.error.message.loginfail":`Operacja nie powiodła się, skontaktuj się z administratorem`,
"pagecreator_button_back":`Ostatni krok`,
"label_tabpage_skip":`Przejdź do`,
"label.pw.old":`Proszę wprowadzić stare hasło`,
"pagecreator.layout.label.modifylayout":`Edytor układu`,
"vue_label_chatter_share_group":`Podziel się z grupą`,
"label.app.edit":`Edycja aplikacji`,
"label.user.Email.repeat":`Duplikat emaila. Ten użytkownik nie jest obsługiwany do łączenia się z agentem`,
"label.field.quilt":`To pole jest`,
"label.projectManagement.Groupuser":`Grupowanie według użytkowników`,
"label.deleteall":`Usuń wszystko`,
"label.appexchange.download.tiaoguo.mes":`Zignoruj instalację następujących, kolidujących ze sobą komponentów:`,
"label.sendemail.recycle.operatehello":`#username hello:\N`,
"label.emailmerge.mergeFolder.max20templates":`Możesz wybrać aż do 20 szablonów!`,
"label.campaignmember.main.deleteleaddesc":`Masowe usuwanie wszystkich leadów z tej kampanii`,
"Opportunity_Detailed_Phase_Label_Popup_003":`Dni w bieżącym etapie`,
"vue_label_file_no_title":`Bez tytułu`,
"label.data.dataexpalltype.all.desc":`Eksport danych wszystkich obiektów, do których odczytu ma dostęp bieżący użytkownik.`,
"label.dashboard.unit2":`Jednostka: milion`,
"label.list.userinterface.isrelatedlist":`Włącz odnośniki na liście powiązanych obiektów`,
"label.role.tree":`Hierarchia ról w Twojej organizacji`,
"label.campagin.roi.zcsl":`Zapisy`,
"message.error.forecast.setupchange":`Dane, do których próbowałeś uzyskać dostęp, nie zostały odnalezione. Mogły one zostać usunięte przez innych użytkowników lub zmienione.`,
"label.sendemail.changeowner.dataname":`Nazwa dokumentu to: #dataname plik`,
"label.salescloud.opportunity.contactrole.optionlist":`Możliwości Kontakt Role Lista wyboru Wartości`,
"setup_mainpage_label_welcome1":`Potrzeba odpowiedniego pozwolenia`,
"UG_activity_02":`Przydzielanie zadań`,
"label.tabpage.erraddressz":`Nieprawidłowy format adresu e-mail, proszę wpisać prawidłowy adres e-mail`,
"label.weixin.nicheng":`WeChat Nickname`,
"label.forecast.settings.mrsz":`Prognoza Pomiar`,
"label.campaign.channel.download.size3":`Mały rozmiar: 300*300 pikseli`,
"label.icon.73":`Obrabiarka`,
"label.ServiceCloud.suoxuchanpin":`Wymagane produkty`,
"label.escalation.setup.newrule.description":`Wprowadź nazwę reguły i aktywuj ją. Aktywacja tej reguły spowoduje dezaktywację bieżącej reguły eskalacji spraw. Aby wyłączyć automatyczną eskalację spraw, dezaktywuj wszystkie reguły eskalacji spraw.`,
"label.data.import.setup.whichfield.cloudccid":`Identyfikator CloudCC`,
"label.validate.function.funcExplain.PRIORVALUE":`Zwraca typ obiektu, odpowiadający typowi pola, które musi zostać przekonwertowane.`,
"Lead.Scoring.Warning.001":`Oceniaj pojedynczy rekord leadu automatycznie podczas tworzenia lub edycji. Ale trzeba ręcznie punktować wiele rekordów leadów, podczas importu wsadowego lub tworzenia przez interfejs.`,
"label.tianyancha.businessverify.msg9":`Prawo do interpretacji niniejszej umowy przysługuje beijing shenzhou yundong science and technology co., ltd.`,
"label.compact.layout.tip":`Układ informacji kluczowych służy do wyświetlania pola kluczowego dla szczegółów rekordu na stronie szczegółów.`,
"label.visualpage.btype":`Raporty`,
"label.textmessage.vonage.settings":`Ustawienia`,
"label.field.not.exites":`nie istnieć`,
"label.payment.switch.version":`Przejście na nowe wydanie`,
"label.ems.hour":`Godzina`,
"label.weixin.cannot.edit":`Typ pliku nie może być edytowany`,
"chatter.pt.limit":`Maksymalny rozmiar pliku wynosi`,
"label.quote.detailinfo.add":`Dodaj pozycje kosztorysowe`,
"component.setup.label.displayfield":`Pole wyświetlacza`,
"vue_label_report_reportfolder":`Folder z raportami`,
"label.gbkencoding":`chiński (GBK)`,
"front-kefu-moudle-v1-Transfer-to":`Transfer do {TransferName}`,
"label.file.stop.sharing.desc2":`Dzielenie się`,
"label.textmessage.messageCannoutuse":`Nieaktywne, skontaktuj się z administratorem w celu włączenia funkcji wiadomości tekstowych.`,
"component_newrecords_label_type":`Typ przechowywania`,
"label.validate.function.funcFormat.ISNEW":`ISNEW()`,
"lable.product.pricebooks.new":`Nowa książka cen`,
"vue_label_newfile":`New File`,
"label.reportTypcrtB":`Obiekt powiązany (b) proszę kliknąć, aby wybrać obiekt powiązany`,
"label.knowledgebase.type":`Kategoria`,
"label.report.select.format":`Wybierz format raportu`,
"component.todaytask.label.title":`Dzisiaj`,
"message.undelete":`Czy na pewno chcesz anulować usuwanie?`,
"label.ccdocument.trace.retention":`Funkcja zatrzymywania śladów`,
"label.publicgroup.tip":`Grupa publiczna jest zbiorem użytkowników. Może ona zawierać pojedynczych użytkowników, inne grupy, użytkowników w określonej roli lub terytorium, lub użytkowników w roli lub terytorium oraz wszystkich użytkowników znajdujących się poniżej tej roli lub terytorium w hierarchii.`,
"label.forecast.settings.lable2":`Skonfiguruj domyślny wyświetlacz prognozy`,
"label.projectManagement.positive.integer":`Proszę wprowadzić dodatnią liczbę całkowitą z przedziału 0-24.`,
"label.projectManagement.one.work.list":`Proszę wypełnić co najmniej jedną listę prac!`,
"label.or":`|Or`,
"label.projectManagement.no.person.in.charge":`Brak inspektora`,
"vue_label_commonobjects_detail_an_email":`wiadomość email`,
"front-electronic-signature-field-mapping":`Dodaj mapowanie pól`,
"label.marketsea.name.error":`Nazwa puli wiodącej nie może być pusta`,
"component.setup.button.appurl":`Adres URL systemu`,
"label.mr.title.button.group1":`Strona`,
"chatter.contact":`Kontakt`,
"vue_label_pool_hasfixed":`stałe kanały współpracy`,
"lable.list.queue.des":`Kolejki pozwalają grupom użytkowników na bardziej efektywne zarządzanie wspólnym obciążeniem pracą. Kolejka jest miejscem, do którego rekordy mogą być kierowane w oczekiwaniu na przetworzenie przez członka grupy. Rekordy pozostają w kolejce do czasu, aż użytkownik zaakceptuje je do oceny lub zostaną przeniesione do innej kolejki. Można określić zestaw obiektów, które są obsługiwane przez każdą kolejkę, jak również zestaw użytkowników, którzy mają prawo do pobierania rekordów z kolejki.`,
"label.reportsSubscriptionPage.condition":`Warunki`,
"label.transwork":`Translation Workbench`,
"label.batch.batchopration.resel":`Proszę ponownie wybrać dane, które chcesz przenieść i kliknąć "OK", aby przejść do strony z listą widoków.`,
"label.cloudccsite.new":`Nowa strona`,
"label.button.select.page.required.field":`Wybierz wymagane pola, które chcesz umieścić na swojej stronie:`,
"label.pagelayout":`Układy stron`,
"label.weixin.trace.record":`Rekordy trasy`,
"label.emailtocloudcc.clear":`Jasne`,
"label.checkfield.find":`Znajdź duplikaty`,
"message.view.count.title0":`Podsumowanie bieżącej strony`,
"label.reportsSubscriptionPage.schedulereport.frequency":`Częstotliwość`,
"setup.mainpage.label.welcome5":`Pole niestandardowe`,
"label.implementation.details":`Wykonaj Szczegóły`,
"label.attendance.history":`Historia frekwencji`,
"label.is.pigeonhole":`Archiwum`,
"lable.account.CurrentandPreviousFYt":`Bieżące i poprzednie 2 lata`,
"label.forecast.customforecast.tab.opportunity":`Możliwości`,
"label.version.business.track":`Śledzenie możliwości`,
"label.profilelayoutedit.selectrecordtype.tip":`Wybierz typ rekordu dla tego profilu użytkowników. Należy dodać pole typu rekordu do układu strony powiązanego z tym profilem, aby można je było wyświetlić na stronach szczegółów i stronach edycji.`,
"label.campagin.roi.zclzb":`Stawka rejestracyjna`,
"label.validate.function.funcFormat.WEEKDAY":`TYDZIEŃ(data)`,
"label.view.sort.message":`Posortowane według {!sort}`,
"page.field.masterinput.sort":`Wejścia Master-Detail są wyświetlane w kolejności, w jakiej zostały zapisane.`,
"label.selected.field":`Wybrane pola wyszukiwania`,
"label.product.proofTwo":`W {0} należy wybrać co najmniej {1} opcji produktowych.`,
"vue_label_report_filtercondition":`Stan filtra`,
"label.forecast.shrepage.desc1":`Ta strona zawiera listę użytkowników, ról i obszarów, które mają dostęp do udostępniania`,
"label.file.copy.link":`Link do kopiowania`,
"vue_label_chat_movedto":`{name} przeniósł {label} do {newField}.`,
"label.layout.new.built":`Nowa sekcja`,
"label_tabpage_crecordtypez":`Zmiana typu rekordu`,
"label.report.searchcustominfo":`Wprowadź słowa kluczowe, aby znaleźć pasujące raporty niestandardowe`,
"chatter.feed.menutype.user":`Koledzy`,
"label.recordtypeselect":`Wybierz typ zapisu`,
"label.partner.new.step3":`Krok 3 Wprowadź nazwę i adres url`,
"label.newCustomReportType":`Nowe źródło danych raportu niestandardowego`,
"label.service.gantt.day.timescale":`Skala czasu na widoku dziennym:`,
"label.displaytype3":`Przycisk listy`,
"label.weixin.discharge.rate":`Objętość wydechu`,
"label.weixin.menu.message":`Menu`,
"label.mask.show.all.characters":`Maska wyświetla wszystkie znaki`,
"label.quickbooks.fieldlabel.billingaddress":`Adres rozliczeniowy`,
"Dashboard.View.All":`Wszystkie pulpity`,
"setup_mainpage_label_welcome22":`Instrukcje: Kliknij w menu po lewej stronie tej strony → Zarządzaj ustawieniami → Szablon newslettera → Szablon e-mail.`,
"chatter.group.groupInformation":`Informacje o grupie`,
"front-epwechat-module-v1-input-secret":`Proszę wpisać Sekret`,
"lable.Set.value.prompt":`Lub filtrować rekordy wyświetlane na liście powiązanych. Wybierz pola checkbox, lub picklisty i wartości, które chcesz filtrować. Jeśli wpisujesz wartości ręcznie, oddziel je przecinkami.`,
"label.appupload.upload.from":`Przez`,
"label.weixin.postunsolve":`Zaległe`,
"label.cooperation.all":`Cała współpraca`,
"lable.PowerProcess.close.time":`W oparciu o czas zamknięcia {detailInterestType}`,
"lable.opppdt.selPdt.leastone.fields":`Proszę wybrać co najmniej jedno pole.`,
"label.emailtocloudcc.help":`Proszę wprowadzić prawidłowe hasło e-mail lub kod autoryzacji. Jeśli Twój serwer poczty elektronicznej wymaga włączenia usługi IMAP/SMTP do logowania za pomocą konta innej firmy, musisz najpierw zalogować się do ustawień konta poczty elektronicznej, aby włączyć tę usługę, a następnie skopiować odpowiedni kod autoryzacji do pola wprowadzania hasła.`,
"label.attendance.offwork.time":`Koniec dnia`,
"front-gantt-module-v1-project-gantt":`Wykres Gantta projektu`,
"label.chuangming.description":`Skonfiguruj informacje Chuangming tak, aby spełniały potrzeby Twojej organizacji w zakresie wysyłania i odbierania SMS-ów.`,
"label.custom.lead.notice.account.name":`Istnieje lead, który został przekonwertowany, określ, że jesteś właścicielem konta, kontaktu i możliwości. Nazwa konta:`,
"label.emailobject.failedtosend1":`Wysyłanie nie powiodło się: Uwierzytelnienie e-mail jest nieprawidłowe, proszę połączyć się ponownie".`,
"vue_label_ccchat_notice_updaterecordsuccess":`Ten zapis został zaktualizowany`,
"label.dayinmonth":`Miesiące`,
"label.sendemail.chat.follow":`Drogi #name:witaj! #userName podąża za Tobą.`,
"label.emailsync.form.emialpassword":`Hasło`,
"component_task_label_subject":`Temat`,
"label.projectManagement.please.enter.a.positive.integer":`Proszę wpisać dodatnią liczbę całkowitą.`,
"lable.account.NexteDays":`Następne 7 dni`,
"label.appupload.upload.managed":`Można utworzyć maksymalnie jeden pakiet kontrolowany!`,
"label.data.dataexpalltype.all.desc1":`1、Możesz shoose do automatycznego generowania i ręcznie wprowadzić hasło wyeksportowanego pliku kompresji. Automatycznie generowane hasło zostanie wysłany do skrzynki pocztowej użytkowników, gdy dane są eksportowane pomyślnie. Hasło wpisane ręcznie nie zostanie wysłane do skrzynki pocztowej, więc użytkownicy muszą zapamiętać wpisane hasło. Jeśli hasło nie zostanie wprowadzone, domyślnie ustawione jest na brak hasła.`,
"label.step1.total3":`Krok 1 z 3`,
"label.escalation.setup.detail.section":`Zasada Szczegółowa`,
"front-gantt-module-drag-task-sorting":`Przeciąganie zadań w celu uporządkowania`,
"label.isEnableVisualpage.new.title":`Włącz dostęp do stron niestandardowych`,
"label_tabpage_yesz":`Tak`,
"label.emailobject.emaildetail.button.replyall":`Odpowiedz wszystkim`,
"label.knowledge.setting.data.one":`To nie może dodawać więcej podkategorii.`,
"label.manageAll.sel.one3":`Punkty I Zatwierdzone`,
"UG_contact_01":`Jak najlepiej wykorzystać swoje kontakty?`,
"font-trade-module-v1-invoice-name":`Nazwa faktury`,
"label.central.daylight.time":`Czas letni środkowy`,
"label.chatter.pastThirtyday":`W ciągu ostatnich 30 dni`,
"vue_label_commonobjects_detail_activity_ownevent":`Dostępne wydarzenie`,
"label.user.modify":`Użytkownik Edytuj`,
"label.uploadTemplate":`Prześlij szablon`,
"setup_mainpage_label_welcome14":`Zarządzanie procesami dostosowywania przepływu pracy, zatwierdzania`,
"label.workmate":`Koledzy`,
"label.displaycolumns":`Wyświetl kolumny`,
"label.emailnoticeintro":`Alerty e-mailowe to wiadomości e-mail, które reguły przepływu pracy wysyłają, gdy zostaną wyzwolone.`,
"label.knowledge.category.button.five":`Usuń kategorię`,
"template.report.business.opportunities.type":`Możliwości według typów`,
"vue_labenl_applauncher_moreapp":`Więcej Aplikacji`,
"label.captcha.expired":`Kod weryfikacyjny wygasł, prosimy o ponowną weryfikację.`,
"template.chart.bnqzkhslmb":`Docelowa liczba leadów na rok`,
"chatter.up.user.pic":`Prześlij zdjęcie użytkownika`,
"label.timezone.importtimezone.gmt":`Użyj strefy czasowej gmt`,
"label.step.type":`Wybierz typ członka, który chcesz przeszukać`,
"Dashboard.View.RecentlyView":`Ostatnio oglądane`,
"label.reportinthisfolder":`Raporty w tym folderze`,
"label.product.vies":`Widoki produktów`,
"pagecreator_systemstyle_message_delete_fail":`Usuwanie stylu nie powiodło się`,
"label.multipleactivity.singleUser":`Jeden użytkownik`,
"vue_label_email_enter_subject":`Podaj temat`,
"label_tabpage_alltabs":`Wszystkie karty`,
"label.publicgroup.groupname":`Nazwa grupy`,
"template.report.sales.performance":`Wydajność sprzedawców`,
"label.newWindow":`Nowe okno`,
"label.forecast.editopp.forecastedit":`Prognoza Edycja`,
"label.data.import.setup.whichfield":`Które pole chcesz wykorzystać do dopasowania?`,
"label.noadd_dashboard":`Nie dodawaj do tablicy rozdzielczej`,
"label.subtotal":`Suma cząstkowa`,
"front-email-payment-weichat":`Proszę użyć WeChat "Scan"`,
"label.attendance.position.alert":`Proszę najpierw wybrać maskę`,
"chatter.follow.me":`Follow me`,
"label.mobile.more.details":`Edytuj szczegóły pliku`,
"Dashboard_SelectBoardToDisplay":`Proszę wybrać pulpity, które mają być wyświetlane w zakładce dashborad`,
"front-gantt-module-v1-search-project":`Wyszukaj swój projekt...`,
"label.paging.totalofpagereport":`Łącznie {0} stron({1})`,
"label.from.phone":`Ze strony`,
"lable.Signatory":`Signtory:`,
"label.campagin.roi.query.roi2":`Kanały marketingowe ROI`,
"label.tabpage.selectcontentz":`Proszę wybrać treść`,
"label.multilang.lookfiltercondition.valuetypenotmate":`Warunek linii {0} jest nieprawidłowy, typ wartości nie pasuje!`,
"label.interfaceconstraint.disabled":`Interfejs został wyłączony, skontaktuj się z administratorem systemu.`,
"third":`Trzeci`,
"label.quickbooks.viewlist.status":`STATUS`,
"label.emailtocloudcc.select3":`Proszę wybrać właściciela rekordu`,
"label.projectManagement.week.work":`Moja praca na ten tydzień`,
"vue_label_pool_nodemand":`Brak zapotrzebowania`,
"label.version.two.developapi":`Drugi interfejs API`,
"label.icon.82":`Drukarka`,
"label.batchadd.newbatchpage.suclist":`fragment(y) danych dodany(e) pomyślnie`,
"label.checkfield.chooseatlast":`Proszę wybrać co najmniej dwa`,
"label.quotation.deleteTip":`Proszę wybrać wiersze cytatów, które mają zostać usunięte`,
"label.generatepage.title.desc2":`Kliknij przycisk Zapisz, aby wygenerować stronę internetową i łącze Web URL, do którego można uzyskać dostęp.`,
"label.licence.total":`Licencje ogółem`,
"Y":`Relacja Lookup`,
"label.wuzibiekesitan.time":`Czas Uzbekistanu`,
"label.component.hotdeal.nodata":`Brak danych związanych z możliwościami biznesowymi.`,
"label.data.exp.save":`Zapisz szablon`,
"label.appupload.upload.tips.dashboard":`UWAGA: Hasła w My Custom Dashboards" i "Unfiled Public Dashboards" nie mogą być dodane do pakietów i nie będą widoczne na tej liście. Powiązane z nimi stare raporty nie mogą być przesłane."`,
"lable.PowerProcess.new.PowerProcess":`Nowy proces nabywania uprawnień`,
"label.loginhis.search.download":`Biorąc pod uwagę, że istnieje wiele historii logowania, tylko historia z okresu 2 miesięcy może być pobrana podczas wyszukiwania plików do pobrania.`,
"label.tabpage.deleteview":`Usuń widok`,
"label.chatter.recently":`Ostatnio`,
"label.industrialandcommercialverification.title":`Weryfikacja przemysłowa i handlowa`,
"message.nextapproverlost":`Następny podany zatwierdzający jest pusty.`,
"front-kefu-moudle-v1-mfsysy-time":`Pozostałe dni do bezpłatnej trasy`,
"label.role.assign.tip":`Wybierz użytkownika z listy Dostępni użytkownicy i dodaj go do listy Wybrani użytkownicy, aby przypisać użytkowników do roli`,
"label.addattachment.step2.intruduce":`Powtórz krok 1 i krok 2, aby dodać wiele plików.`,
"vue_label_pool_returnreasondiscription":`Opis przyczyny zwrotu`,
"label.weixin.report.range":`Zakres`,
"label.wei.weiresearchtab":`Mikro głosowanie Wybór`,
"vue_label_report_setdrill":`Ustawić wiertło`,
"page_404_button_back":`Powrót do poprzedniego kroku`,
"label.customfields.autonumber.tip":`Numer sekwencji generowany przez system, który wykorzystuje zdefiniowany przez użytkownika format wyświetlania. Numer ten jest automatycznie zwiększany dla każdego nowego rekordu.`,
"label.ccpeak.return.allrecords":`Zwróć wszystkie rekordy`,
"label.ccchat.notmember.active.group2":`Nie jesteś w nazwie z`,
"label.uniquename":`Nazwa unikatowa`,
"label.emailtocloudcc.filed.ssl":`Bezpieczne połączenie`,
"chatter.emailFollowMe":`Podąża za mną`,
"label.allrightsreserved.allrightsreserved.customerServiceHotline":`Copyright. Wszystkie prawa zastrzeżone. Infolinia Obsługi Klienta`,
"label.projectManagement.actualworkinghours":`Faktyczne godziny pracy`,
"label.quickbooks.fieldlabel.taxresale":`Podatkowa odsprzedaż`,
"label.icon.12":`Serwis`,
"label.data.exp.dataexptemp":`Szablony eksportu danych`,
"component_setup_tabs_label_add":`Dodano`,
"label.appointmentdetail.wizard.title10":`Data rozpoczęcia`,
"label.multilingual.close":`Zarządzanie wieloma językami nie jest włączone.`,
"message.error.username.notexist":`Nieprawidłowa nazwa użytkownika, proszę wpisać ponownie.`,
"label.batchadd.newbatchpage.des2":`Jeśli typ pola to Auto Numer, numer jest automatycznie zwiększany dla każdego nowego rekordu bez konieczności ręcznego wprowadzania.`,
"vue_label_SMS_search":`Wyszukiwanie leadów lub kontaktów`,
"label.appupload.successWithUrl":`Twój pakiet jest teraz dostępny do instalacji przy użyciu poniższego adresu URL instalacji.`,
"UG_Forcast_06":`Proszę wybrać użytkowników, którzy mają prawo do prognozowania`,
"vue_label_dashboard_secondarygroup":`Proszę wybrać grupę dodatkową`,
"label.weixin..xsld.total":`Całkowita kwota w lejku sprzedaży`,
"label.setup.mobile.bottombutton.recovery.default.fail":`Nie udało się przywrócić ustawień domyślnych`,
"label.addrecurrencetimetrigger":`Dodaj wyzwalacz czasowy okresowy`,
"label.emailsync.connectaccount":`Podłącz konto e-mail`,
"label_fiscal_years":`Rok podatkowy`,
"label.icon.164":`Trener`,
"label.batchadd.mustinput":`Pole z`,
"message.newtabpage.nokeywords":`Wyszukiwane hasło musi mieć 1 lub więcej znaków. Możesz też dodać zaawansowane kryteria wyszukiwania.`,
"label.login.verification.mfa.desc3":`Jeśli Twoje konto zostało udostępnione wielu osobom, inne osoby bez powiązania MFA nie będą mogły się zalogować po pomyślnym powiązaniu MFA. Rozwiązaniem jest zlecenie komuś innemu zainstalowania aplikacji MFA i zeskanowania kodu QR dla tej strony lub zapisanie obrazu kodu QR do późniejszego zeskanowania przez inne osoby. Jednakże, jeśli chodzi o najlepsze praktyki bezpieczeństwa, zalecamy rezygnację z wielu kont współdzielonych.`,
"label.partnerCloud.basicSetting.initialize":`Nie ma możliwości zmiany nazwy domeny po inicjalizacji.`,
"label.address.county":`Hrabstwo`,
"label.validate.function.funcFormat.TODAY":`TODAY()`,
"label.sso.addAKey":`Dodaj klucze`,
"label.myusergroup":`Moje grupy użytkowników`,
"label.import.index.time-consuming":`Czas`,
"label_tabpage_systems":`Istnieją * systemy`,
"batch.sendemail.s":`, Poczta wysłana pomyślnie.`,
"label.appointment.wizard.subtitle4-1-1":`15 min`,
"label.projectManagement.delete.milestone":`Wszystkie informacje związane z tym kamieniem milowym zostaną również usunięte po usunięciu tego kamienia milowego, a danych nie będzie można odzyskać. Czy na pewno chcesz potwierdzić usunięcie?`,
"label.umeng.chatter.praise":`podobał mi się twój wpis.`,
"font-evaluate-module-v1-evdetails":`Szczegóły oceny:`,
"label.group.filter.resources.and":`Wybierz metodę filtrowania zasobów, relację AND.`,
"label_emailtocloudcc_description":`Podłącz swoje firmowe konto e-mail, takie jak sales@company.com, info@company.com, support@company.com. Automatycznie rejestruj otrzymane wiadomości e-mail jako leady i rekordy spraw w CloudCC, aby zapewnić terminowe śledzenie listów od klientów.`,
"label.chat.topic.delete.prompt2":`Proszę pamiętać, że tematy o tej samej nazwie w innych społecznościach nie będą usuwane.`,
"message.error.group.authorization":`Nie masz dostępu do zakładania tej grupy`,
"label.attendance.wz":`Lokalizacja`,
"vue_label_activity_notice_logacal_success":`Zalogowałeś połączenie`,
"label.emailtocloudcc.step1.case1":`E-mail do sprawy`,
"label.h5.chatter.praisenum":`Otrzymał pochwałę`,
"label_time_statistics_basis":`Podstawa statystyk czasowych`,
"label.onlyadmincanedit":`Administratorzy <strong>TYLKO</strong> mogą edytować rekordy podczas procesu zatwierdzania.`,
"label.fieldtoolongmassage":`Pole`,
"label.sales.team.shared":`Grupowe udostępnianie możliwości handlowych`,
"label_emailsync_status_department":`Dział`,
"label.mobile.quickcreate.default.sellingfunnel":`Lejek sprzedaży`,
"label.tabpage.closez":`Zamknij`,
"homepage.components.two":`Krok 2 wybór lokalizacji, w której będą wyświetlane komponenty niestandardowe`,
"label.everyday":`Codziennie`,
"lable.Product.to.asset.BOM":`Produkt do BOM zasobów`,
"label.appointment.wizard.subtitle4-3":`Zapraszający ma możliwość wyboru startu w każdej`,
"label.customobjects.standardfieldslist":`Lista pól standardowych`,
"label.customfields.suretodelete":`Tak, chcę usunąć pole niestandardowe.`,
"component.chatter.label.to":`Do`,
"label.emailsync.form.seversetting":`Ustawienie`,
"label.service.gantt.enabled.resources":`Zasoby aktywowane`,
"label.tianyancha.h5.weibo":`Mikroblog`,
"template.chart.dddje":`Kwota utraconych zleceń`,
"label.pc.trigger.apiname":`Nazwa API już istnieje, proszę spróbować ponownie.`,
"label.icon.34":`Ustawienie`,
"label.schedulejob.setup.schedule.prgname":`Nazwa aplikacji`,
"label.weixin.free.registration":`Zarejestruj się za darmo`,
"label.placeholder":`Quick Find`,
"label.emailobject.manage.template":`Zarządzaj szablonami`,
"label.knowledge.article.existsdata":`Istnieją również inne dane bez zastrzeżeń.`,
"label.campaign.channel.lookup.ticket":`Sprawdź bilet`,
"label.searchlayout.relation.searchfield":`Pola filtra wyszukiwania dla powiązanych list.`,
"label.recordid.cannot.empty":`ID rekordu nie może być puste`,
"label_partner_workspace_member_choice":`Wybierz profil`,
"vue_label_campaign_amount":`Kwota dochodu`,
"label.niue.time":`Czas Niue`,
"front-homepageobject-module-v1-workload-ranking":`Ranking obciążenia pracą`,
"message.error.datainvalid":`Błąd: Nieprawidłowe dane.`,
"vue_label_helpcenter_salesfunnel":`Skorzystaj z nowej wersji lejka sprzedaży, aby przeanalizować kontynuację możliwości biznesowych i dostarczyć dane referencyjne dla procesu sprzedaży.<br> W lewym górnym rogu rekordy będą filtrowane według warunków, takich jak rola lub właściciel, a wszystkie widoczne możliwości biznesowe w odpowiednich warunkach będą przeglądane i analizowane. Kliknij na etap wykresu lejka sprzedaży, aby wyświetlić wszystkie rekordy w ramach tego etapu.`,
"vue_label_transferownernotice":`Właściciel rekordu powiązanego z tą pozycją również zostanie zmieniony`,
"label.monitorsys.operator":`Acted By`,
"label.please.codeNorm":`Proszę wybrać standard kodu.`,
"label.campaign.channel.step6.remark2":`Umożliwienie pozyskiwania pracowników`,
"market.potential.customers":`Market Lead`,
"label.customfields.phone.tip":`Umożliwia użytkownikom wprowadzenie dowolnego numeru telefonu. Automatycznie formatuje go jako numer telefonu.`,
"label.currency.edit":`Edycja waluty: Zmień walutę korporacyjną`,
"label.emailobject.emaildetail.button.markasunread":`Oznacz jako nieprzeczytane`,
"label_partner_template_memo":`Tytuł`,
"label.chat.message.search.all":`Wyszukaj wszystkie informacje`,
"label_tabpage_hoursagoz":`godziny`,
"label.customcomponent.developer.help":`Pomoc programisty komponentów niestandardowych`,
"setup_mainpage_label_welcome":`Witamy na platformie CloudCC PaaS, główne funkcje platformy są następujące:`,
"label.h5.similar.opportunity.list":`Wyniki zawierają zamknięte, wygrane okazje, które mają jedno lub więcej pól wspólnych z Twoją okazją. Zakładki szans dodają je do listy podobnych szans na stronie szczegółów szansy.`,
"vue_label_record_count":`Liczba zapisów`,
"label.icon.29":`Demo`,
"pagecreator.page.label.pagelayout":`Układ strony`,
"label.ggReleaseRange.searchRole":`Wyszukaj rolę`,
"label.campagin.member.field.setup":`Ustawienia pól członków kampanii`,
"augest":`Sierpień`,
"label.salescloud.massloss.content":`Wyłączenie zespołów szans spowoduje nieodwracalne usunięcie istniejących zespołów ze wszystkich szans oraz usunięcie domyślnych zespołów szans użytkowników.`,
"label.customfields.new.step2.opration.unique.info":`Duplikaty wartości są niedozwolone.`,
"vue_label_email_optional_members":`Członkowie fakultatywni`,
"label.emailobject.attachment.download":`Pobierz`,
"label.recordamount":`Liczba zapisów`,
"front-kefu-moudle-call-recorder":`Nagrywanie rozmów`,
"label.more.info":`Szczegóły`,
"vue_label_commonobjects_view_secondsbefore":`{seconds} sekundy`,
"label.emailsync.status.action":`Działanie`,
"label.customfields.totalsummary.collectedfields":`Obiekt podsumowany`,
"label.knowledge.setting.hint.two":`Uwaga: Raz włączonej wiedzy nie można wyłączyć.`,
"label.login.access.yujidao":`Exp.`,
"label.assignment.setup.detail.description":`Dodaj wpisy reguł, które określają kryteria automatycznego przypisywania leadów do użytkowników.`,
"message.error.marketsea.null":`Lead Pool nie istnieje`,
"lable.account.Current.CY":`Bieżący CY`,
"vue_label_salesadvance_lost":`Strata`,
"label.file.ownedbyme":`Należą do mnie`,
"label.component.helper.nodata":`Nic nie wymaga teraz Twojej uwagi. Sprawdź później.`,
"label.weixin.appr.pending.auditor":`Zgłoszony przez`,
"UG_opportunity_004":`Typ wielousługowy`,
"label.leadscore.setup":`Ustawienia punktacji leadów`,
"label.addtimetrigger":`Dodaj wyzwalacz czasowy`,
"label.mr.title.match":`Jeśli dokładne dopasowanie`,
"label.projectManagement.Newmilestone":`Nowy kamień milowy`,
"label.preview":`Podgląd`,
"label.tabpage.issuez":`Kwestia`,
"label.img.max.size":`Wgrany obrazek jest zbyt duży, a maksymalny rozmiar wgranego obrazka to 500K, proszę wgrać go ponownie.`,
"label.mainpageset":`Skonfiguruj komponenty strony głównej`,
"label.user.login.false.lock":`Przekroczono liczbę prób logowania. Konto jest zablokowane.`,
"UG_solution_02":`Rozwiązanie jest wewnętrznym rozwiązaniem instytucji na problem, który napotykają rachunki.`,
"vue_label_approve_put_away":`Zapadnij się`,
"label.profile.existing":`Istniejący profil`,
"label.ems.logininfo":`Informacje dotyczące logowania`,
"label.weixin.location.service":`Obiekty wspierające usługi lokalizacyjne`,
"label.multilang.datamoveaction.totaldata":`Istnieje łącznie {1} rekordów spełniających warunek，maksymalnie 100 rekordów może być przeniesionych w tym samym czasie！：`,
"label.ccdocument.cannot.update.set":`Ten dokument nie należy do Word lub Excel lub PPT typu pliku, nie załadowany do czerwonego folderu szablonu.`,
"vue_label_fliter_addfliter":`Dodaj Fliter`,
"label.custom.page.or.trigger":`(Strony niestandardowe lub wyzwalacze)`,
"label.tag.filter1":`Odfiltrować rekordy, które zawierają wszystkie wybrane tagi`,
"UG.homepage.006":`360-stopniowy wgląd w aktywność konta za pośrednictwem ankiet, czatów na żywo, wiadomości e-mail, zleceń roboczych, postów w mediach społecznościowych, a nawet działań sprzedażowych (takich jak leady, wsparcie serwisowe i działania).`,
"SCORE":`Wynik`,
"label.file.library.managemembers2":`Zarządzaj członkami biblioteki`,
"label.email.template.public.SMS":`Publiczny Folder Szablonów SMS`,
"label.leadscore.donot":`Brak możliwości zdobycia leadów`,
"label.gaode.map":`Amap`,
"pagecreator_button_preview":`Podgląd`,
"UG_contact_04":`Lub`,
"label.ccchat.person.invite.eminfo":`{0} zaprosił Cię do dołączenia do {1} na CCChat.Dzięki ccchat możesz czatować ze swoimi współpracownikami, tworzyć zespoły do swoich projektów i udostępniać pliki.`,
"setup_object_field_dependency_label_actionfieldvalue":`Pole kontrolne`,
"lable.Product.options":`Opcje produktu`,
"front-electronic-signature-add-autofill-field":`Dodaj pole autouzupełniania`,
"label.customfields.totalsummary.selectcollectedfields":`Wybierz obiekt do podsumowania`,
"label.projectManagement.the.maximum.contract.amount.is.10.digits":`Można wprowadzić do 10 cyfr dla kwoty kontraktu.`,
"label.forecast.shrepage.pagetitle":`Współdzielenie użytkowników, ról i terytoriów`,
"label.login.access.mark":`Aby pomóc w kwestiach związanych z pomocą techniczną, użytkownik może przyznać administratorowi lub pracownikom pomocy technicznej możliwość zalogowania się jako użytkownik i uzyskania dostępu do swoich danych.`,
"lable.outlook.edit.zdyout":`Niestandardowe mapowanie pól Exchange`,
"label.approveoperate":`Czynności zatwierdzające`,
"label.tabpage.linknamez":`Nazwa związku`,
"label.report.error.deletehavedashboard":`Ten raport ma nową tablicę rozdzielczą i nie może zostać usunięty.`,
"label.summaryreport.2018.step1":`Krok 1 Tworzenie grupowania`,
"label.campaignmember.main.leadtomember.title":`Konfiguracja mapowania pól`,
"label.select.dashboar.type":`Proszę wybrać typ tablicy`,
"message.setup.field.picklist.valueexists":`Ta wartość listy wyboru już istnieje.`,
"label.loading":`Ładowanie...`,
"label.payments.paytip1":`Twoja obecna subskrybowana edycja nie jest edycją darmową, proszę kliknąć Potwierdź, aby odświeżyć lub ponownie się zalogować.`,
"label.view.appliedMobile":`Aplikuj do aplikacji mobilnej`,
"label.multilang.forcast.financialyear":`{0} rok podatkowy：`,
"front-web-module-v1-detail-comment-opinion":`Informacje zwrotne`,
"UG_Forcast_10":`Pełny`,
"label.optionlistset":`Opcje listy wyboru`,
"label.visualpage_list.vpname":`Własna nazwa strony`,
"vue_label_calendar_failed_to_delete_calendar":`Nie udało się usunąć kalendarza`,
"label.json.string.null":`Puste`,
"message.serviceappo.time.violation2":`Dostępne naruszenie czasu umówionej wizyty serwisowej: Ustalony czas zakończenia spotkania jest wcześniejszy niż termin wykonania usługi.`,
"label.productsales.today.noevttsk":`Nie ma otwartych wydarzeń i wygasających zadań.`,
"label_tabpage_emptyz":`Puste`,
"front-kefu-moudle-no-create":`Nie utworzono`,
"label.wedge.shaped.tail.arrow.cannot.empty":`Strzałka ogona klina nie może być pusta`,
"label.continue.shopping":`Kontynuuj zakupy`,
"label.turntomain":`Przejdź do zawartości głównej`,
"component.assistant.label.nodata":`Dziś nie ma imprezy, sprawdź później.`,
"label.payments.paytip4":`Proszę podać liczbę użytkowników".`,
"label.appupload.upload.versionName":`Nazwa wersji`,
"label.chatter.endData":`Data końcowa`,
"front-kefu-moudle-buytr-tip":`Mamy nadzieję, że będziesz miał wspaniałe doświadczenia z call center CloudCC, i że możesz kupić oficjalne konto call center, a my zapewnimy lepszą obsługę.`,
"label.repw":`Powtórzenie hasła`,
"label.tabularreport.intro":`Raport tabelaryczny jest jednym z najprostszych i najszybszych sposobów zestawienia danych.`,
"label.selectoperatetype":`Wybierz typ działania`,
"setup.layout.label.required":`Wymagany`,
"label.default.designee":`Domyślnie wysłany Peron`,
"label.ccdocument.cannotdel.folder":`Nie można usunąć tego folderu, ponieważ niektóre pliki w tym folderze.`,
"label.escalation.setup.newentries.inputentries":`Wprowadź wpis reguły`,
"label.emailobject.addnewtemplate":`Dodaj nowy szablon`,
"label_chatter_content":`Treść`,
"label.htyj.mubiao":`Cel`,
"label.reportsSubscriptionPage.schedulereport.weekly.friday":`Piątek`,
"label_tabpage_fieldoptions":`Pole typu rekordu, pole listy opcji i pole listy opcji (wielokrotnego wyboru). zaleca się wprowadzenie co najwyżej 10 słów kluczowych, oddzielonych przecinkami, aby uzyskać "lub związek", np: "Nowy Jork, Toronto, Tokio".`,
"label.mobiletablayoutedit.remark2":`Wybierz pola wyświetlane na stronie głównej zakładki w aplikacji mobilnej.`,
"label.sendemail.chat.addComentsat":`Drogi #name:\u0026apos; #userName wspomniał o tobie w komentarzu.`,
"Z":`Formuła`,
"label.multilang.batchdeleteaction.movesuccess":`Łącznie {0} rekordów zostało usuniętych z powodzeniem！：`,
"label.textmessage.vonage.message2":`Zakładając konta Vonage API, użytkownicy umożliwiają CloudCC dostęp do swojego konta API Nexmo w celu wysyłania i odbierania wiadomości tekstowych.`,
"label.file.use.document":`Wykorzystanie przestrzeni dyskowej`,
"UG.Lead.011":`Utwórz wskazówkę`,
"label.view.name":`Zobacz nazwę`,
"label.data.downtemplate":`Pobierz szablon`,
"vue_label_appstore_get_now":`Pobierz teraz`,
"label.controlfield":`Pole kontrolne`,
"label.dataimport.type.insert":`Wkładka`,
"label.customfields.multiselect.tip":`Umożliwia użytkownikom wybór wielu wartości z listy zdefiniowanej przez użytkownika.`,
"label.weixin.approval.qxzjl":`Proszę wybrać płytę`,
"component.salesperformance.label.70finish":`Zakończone - nieprzetworzone (>70%)`,
"Lead_Auto_Scoring_Setting":`Lead Scoring Setting`,
"pagecreator_layout_message_canntdelete":`Bieżący układ nie może być usunięty`,
"vue_label_report_exprotpage":`Eksportowanie strony: Strona {page}`,
"label.campaign.channel.step4":`Krok4: Wybierz wymagane pola, które mają być wyświetlane na stronie rejestracji kanału marketingowego.`,
"label.app.launcher":`Program uruchamiający aplikację`,
"vue_label_campaign_selectedmember":`Wybrani członkowie kampanii`,
"label.mobile.quickcreate.default.approvals":`Zatwierdzenia`,
"label.view.step4":`Krok 4 Ograniczenie widoczności`,
"label.exchange.sync.state.user":`Stan synchronizacji użytkownika`,
"label.forecast.customforecast.tab.forecast":`Prognozy`,
"label.theUserLoginForTheFirstTime":`Pierwsze logowanie użytkownika.`,
"label.workflowoperate.tip":`Określenie akcji przepływu pracy, które zostaną uruchomione, gdy spełnione zostaną kryteria reguły.`,
"font-evaluate-module-v1-ten-points":`Ocena pozytywna: 10 punktów`,
"label.knowledge.delete":`Błąd przy usuwaniu wiedzy`,
"front-console-see-contacts":`Zidentyfikowane kontakty {num}`,
"label.h5.similar.opportunity.add.to.favorites":`Dodaj do zakładek`,
"front-epwechat-module-v1-install-app":`Zainstaluj w WeCom`,
"setup_layout_message_relatedlistbutton":`Wybierz standardowe przyciski, które mają być wyświetlane na powiązanej liście.`,
"label.salescloud.massloss.title":`Może to prowadzić do dużej utraty danych.`,
"front-console-conversation-btn1":`Ring Back`,
"label.custom.canvasScale":`Skala płótna`,
"label.lead.score.doing":`W procesie lead scoringu`,
"message.approval.step.validation.invalid.number":`Nieprawidłowy numer`,
"chatter.lk":`Jak`,
"label.dashboardSetup.showmaxval":`Maks. wyświetlane`,
"label.keywords":`Słowa kluczowe`,
"vue_label_helpcenter_SMS":`Włącz funkcję SMS<br>Jeśli kod kraju zakupionego systemu CRM to USA, to funkcja SMS jest dostępna w systemie Twojej organizacji. Administrator organizacji może wprowadzić numer telefonu zakupiony przez Państwa organizację w systemie vonage w bramce vonage w aplikacji integracji w tle, a następnie użyć funkcji SMS w menu aplikacji chmury sprzedaży.<br>Skrzynka SMS<br> Skrzynka SMS podzielona jest na dwie części. Po lewej stronie znajduje się rekord leadów lub kontaktów z SMS-em. Po kliknięciu w rekord, po prawej stronie zostaną wyświetlone szczegóły wysyłania i odbierania. Możesz przeglądać rekordy swoje i swoich podwładnych.<br>Wyślij wiadomość grupową<br> W menu SMS, na liście leadów lub kontaktów oraz przycisku wysyłania wiadomości SMS na członków kampanii możesz wysyłać grupowe wiadomości tekstowe. Wiadomości tekstowe możesz wysyłać tylko do potencjalnych klientów lub kontaktów w CRM. Po edycji wiadomości tekstowej wybierz "Wyślij", a zostanie wygenerowany rekord grupy niezależnie od liczby odbiorców, lub możesz wybrać "Wyślij osobno", aby wysyłać wiadomości tekstowe osobno Obsługa osobnych wiadomości SMS pokazująca połączone pola wstawione w szablonie SMS.`,
"label.emailobject.createnewavailability":`Utwórz nową dostępność`,
"front-kefu-moudle-buytr-send-email":`Nie skojarzyłeś się jeszcze z systemową skrzynką pocztową. Proszę wysłać wiadomość email na adres support@cloudcc.com i napisać swój zamiar, nazwę firmy i dane kontaktowe, pracownicy działu sprzedaży skontaktują się z Państwem tak szybko, jak to możliwe.`,
"front-kefu-moudle-v1-Put-away-the-chat":`Zwiń szczegóły czatu`,
"label.marketseamemset.lead.maxuser":`Maksymalna liczba członków wiodących`,
"label.forecast.forecastroleuserpage.shre.manager":`Tylko administratorzy mogą udostępniać tę prognozę`,
"label.file.noselect":`Nie wybrano żadnego pliku`,
"label.notification.task3":`【被分配人】 zmień status zadania, do którego zostałeś przypisany 【新状态】`,
"label.dependfield":`Pole zależne`,
"lable.SalesCommitmentKanBan.receipts":`Wpływy`,
"label_partner_workspace_member_search":`Szukaj`,
"label.share.originally.posted":`Wstępny plakat`,
"label.autonumber":`Auto Numer`,
"label.view.sortview.name":`Zobacz nazwę`,
"label.h5.add.activity":`Dodaj aktywność`,
"label.textmessage.vonage.phone.number":`Numer telefonu`,
"label.partnerCloud.financeSetting.enterApiKey":`Proszę wprowadzić tajny klucz API`,
"label.industrialandcommercialverification.enablestatus":`Status Enable`,
"label.reportTypeFocusD1":`Określenie typu rekordów (wierszy), które będą głównym elementem raportów generowanych przez to źródło danych.`,
"vue_label_report_four-levelseriesobjecttree":`Czteropoziomowe drzewo obiektów serii`,
"label.mobile.default.catalogue":`Katalog domyślny`,
"label.partnerCloud.partnerAccount.again":`Doładowanie`,
"label.summaryreport.step2.new":`Krok 2 Wybór metody grupowania podsumowanych danych`,
"label.tabpage.cancel":`Anuluj`,
"label.multilang.datamovelist.datamove":`Przekazanie kilku {0} od użytkownika do innego użytkownika:`,
"label.conferloginandvisitlimit":`Przyznany dostęp do logowania`,
"vue_label_help_viewhelpcenter":`Wyświetl Centrum pomocy CloudCC`,
"label.leadscore.norule":`Brak reguł punktacji leadów, proszę utworzyć regułę punktacji leadów lub uaktywnić istniejącą regułę`,
"label.tabpage.exitz":`Wyjście`,
"label.DeploymentStatus":`Status wdrożenia`,
"label.layout.saving":`Oszczędność układu...`,
"label.emailobject.emaildetail.field.object":`Obiekt`,
"label.customfields.searchrelation.fieldtag.tip":`Podaj etykiety, które mają być używane w widoku wyświetlania, widoku układu strony, widoku raportu i widoku listy.`,
"message.huanxin.bindtenant.notfound":`Niezwiązany agent`,
"label.referpersonalias":`Zgłoszony przez`,
"label.icon.31":`Komputer`,
"label.appupload.upload.install.thispackage":`Pakiet ten`,
"label.appointment.wizard.subtitle1-1":`Własna`,
"pagecreator_page_message_save_fail":`Nie udało się zapisać strony`,
"label.lastset":`Wreszcie Według`,
"label.version.support.limited":`Wsparcie ograniczone`,
"vue_label_homepage_kanban":`Kanban`,
"label.layout.editsearchdistribute":`Edytuj układ wyszukiwania`,
"template.dashboard.customer.analysis":`Analiza kont`,
"label.continue_editing":`Kontynuuj edycję`,
"label.version.sum.customtab":`zakładka(i) niestandardowa(e)`,
"label.validate.function.funcExplain.TIMEVALUE":`Zwraca wartość czasu lokalnego bez daty`,
"label.import.page1.selectobjfromdata":`Wybierz obiekty do importu danych`,
"label.partnerCloud.basicSetting.success":`Inicjalizacja zakończona powodzeniem`,
"label.customfields.fielddependency.cannotcreat":`Wybrane pole jest zależne bezpośrednio lub pośrednio od siebie, więc nie można utworzyć wzajemnego powiązania.`,
"label.umeng.activity.youhaveatask":`Masz nowe zadanie.`,
"label.file.folder.create":`Nowy Folder`,
"vue_label_campaign_member_status":`Status członka`,
"lable.opppdt.addpdt.table.date":`Data`,
"label_partner_workspace_login_buttontext":`Tekst przycisku`,
"label_other_mistakes":`Inne błędy`,
"label.must.be.configured":`Musi być skonfigurowany`,
"label.customize.memory.function.sorting.enable":`Aktywuj pamięć o sortowaniu nagłówków`,
"setup.layout.label.areaname":`Nazwa sekcji`,
"label_chatter_pastThirtyday":`W ciągu ostatnich 30 dni`,
"setup_mainpage_label_welcome25":`Instrukcje: Kliknij menu po lewej stronie tej strony → Zarządzaj ustawieniami → Kontrola bezpieczeństwa → Ustawienia udostępniania.`,
"label.ccchat.person.invite.succsend":`Zaproszenie do przyłączenia się do CCChat wysyłane jest na adres`,
"label.select.time.range":`Proszę wybrać zakres czasowy`,
"label.partnerCloud.orderingPlatform.djustQuantity":`Dodaj produkty do koszyka, gdzie możesz dostosować ilość i zobaczyć cenę.`,
"label.manageAll.sta1":`W oczekiwaniu na`,
"label.cy.select":`Wybierz nową walutę z dostępnej listy.`,
"chatter.lam":`Komentarz`,
"label.partner.setup.title":`Ustawienia`,
"component.setup.label.displaybutton":`Przycisk wyświetlacza`,
"component.salesperformance.label.target":`Cel`,
"label.campagin.channel":`Proszę wprowadzić wartość kanału`,
"label.validate.function.funcFormat.ISCHANGED":`ZMIENIONE(pole)`,
"UG.homepage.009":`Dostęp do CRM`,
"label.file.item":`Projekt`,
"label.file.library.addmembprompt":`Następujące osoby są już członkami.`,
"label.bmap.releasePosition":`Lokalizacja`,
"setup_object_layout_label_selectedprofile":`Wybrane profile`,
"label_emailsync_message":`Prompt`,
"label.view_submissions":`Zobacz zgłoszenia`,
"lable.tianyancha.repeated":`Powtórzony wybór`,
"label.import.index.introduce":`Importuj swoje dane do systemu w trzech prostych krokach`,
"label.time.operation.new":`Nowe zaplanowane zadanie`,
"label.projectManagement.Pleaseentersettlementtype":`Proszę wpisać typ rozliczenia`,
"label.icon.169":`Samochód wycieczkowy`,
"vue_label_commonobjects_detail_related_listview":`Lista`,
"label.view.step1":`Krok 1 Wprowadź nazwę widoku`,
"label.summaryreport.intro":`Raporty podsumowujące pokazują zarówno sumy cząstkowe danych, jak i inne informacje podsumowujące.`,
"vue_label_file_input_correct_name":`Proszę wpisać prawidłowe nazwisko`,
"System_Email_Template_Title":`Witamy na platformie CloudCC CRM`,
"label.tianyancha.province":`Skrót nazwy prowincji`,
"label.deleteall.sure":`Czy na pewno chcesz usunąć wszystkie?`,
"label.passwordPolicy.setup.uppercasealpandnum":`Musi łączyć liczby oraz wielkie i małe litery.`,
"front-lightning-module-v1-details-page-chart-select":`Wybierz obiekt i wyświetlanie`,
"setup_mainpage_label_welcome8":`Dostosowywanie interfejsu metodą "przeciągnij i upuść`,
"lable.outlook.edit.lastupc":`Ostatnia aktualizacja Kontakt`,
"label.weixin.registered":`Zarejestruj się`,
"vue_label_file_history_version":`Zmiany`,
"vue_label_campaign_earned":`Kwota do pobrania`,
"label.staticresource.useful.realtion.tip":`Poniżej znajduje się lista wszystkich stron CloudCC.com odwołujących się do tego statycznego zasobu.`,
"vue_label_file_libraray":`Biblioteki`,
"label.department.phone":`Numer telefonu komórkowego`,
"label.emailtemplate.edit":`Edytuj szablon wiadomości e-mail`,
"label.processsetting.key.information.tips":`Kluczowe informacje i wskazówki`,
"label.summaryreport.step7":`Krok 7 Wybierz typ wykresu i element podświetlenia`,
"label.chat.topic.remove.favorite":`Usuń z zakładek`,
"label.campagin.roi.ksrq":`Data rozpoczęcia`,
"label.data.downpage.e_title.e_btn":`Przejdź do strony eksportu i rozpocznij eksportowanie`,
"label.approvaldatamove.dname":`Aktualny zatwierdzający`,
"lable.Partial.attributes":`Atrybut częściowy`,
"template.report.enabled.products":`Produkty aktywowane`,
"lable.outlook.detail.cto":`CloudCC.com do Exchange`,
"label.sendemail.activity.newtasktitle":`Powiadomienie o nowym zadaniu`,
"label.validate.function.funcFormat.DAY":`DZIEŃ(data)`,
"label.log.datetime.value":`Proszę wprowadzić czas zapytania`,
"label.import.index.updaterecord":`Aktualizacja zapisu`,
"label.registration.page.invitation":`Zaproszenie na stronę rejestracyjną`,
"pagecreator_systemstyle_label_detailcolor":`Kolor tekstu szczegółowego`,
"label.tabname.cannot.empty":`Nazwa karty nie może być pusta`,
"label.data.newtemplate.savetemp":`Możesz zapisać jako szablon i użyć pól i kryteriów tego eksportu danych jako szablonów eksportu danych. Proszę starannie wprowadzić nazwę i opis szablonu, aby ułatwić jego użycie.`,
"label.ems.body":`Body`,
"enc":`Tekst zaszyfrowany (szyfrowanie pamięci masowej)`,
"label.profile.mobile.setup.commonSaler":`Sprzedaż ogólna`,
"label.continueselectproduct":`Kontynuuj wybór produktów`,
"label.event.new":`Nowe wydarzenie`,
"label.renametabandtaglib":`Zmień nazwę karty i etykiety`,
"label.qrcodelogin.message.exception":`Wyjątek stanowią serwery, prosimy o kontakt z administratorem.`,
"label.service.gantt.locationToGantt":`Wykres Gantta`,
"label.mr.theLastGroup":`Jest to ostatnia grupa. Kliknij "Powrót do listy zduplikowanych rekordów", aby wyświetlić zduplikowane rekordy.`,
"label.report.export.format.content":`Eksportuj bieżący nagłówek raportu, grupy i szczegóły. Maksymalna liczba szczegółów, które mogą być eksportowane to`,
"label.version.accountandcontact":`Konta i kontakty`,
"label.partnerCloud.financeSetting.enterMd5Key":`Proszę wprowadzić tajny klucz MDS.`,
"label.login.access.quater":`Tydzień`,
"vue_label_commonobjects_view_searchthisview":`Przeszukaj tę listę`,
"label.import.step1.allobj":`Wszystkie obiekty`,
"front-efficient-project-management":`Project Cloud zapewnia pełne zarządzanie cyklem życia projektu od rozpoczęcia, planowania, realizacji, kontroli do zamknięcia, optymalizując proces zarządzania projektami zgodnie z potrzebami biznesowymi i pomagając w efektywnym zarządzaniu projektami.`,
"label.includedvalue":`Uwzględnij wartości`,
"label.service.newBuildDialog.past.days":`minione dni`,
"vue_label_report_sortup":`Sortuj w kolejności rosnącej`,
"label.appointment.wizard.subtitle3-2":`Wtorek`,
"label.dashboard.trend":`Tendencja`,
"label.schedulejob.setup.schedule.st2":`2.`,
"label.view.sortview.number":`Liczba rekordów`,
"lable.Please.enable.order":`Zamówienie nie jest aktywowane, proszę aktywować.`,
"label.datamanage.immediately.import":`Import`,
"label.delete.condition":`Jasne`,
"label.dashboard.chooseDispalyOnTheHomePage":`Wybierz stronę główną do wyświetlenia`,
"asset.accountid.contactid.required":`Każdy składnik aktywów musi być powiązany z kontem lub kontaktem.`,
"label.mask.character":`Maska Charakter`,
"lable.account.Previous.FY":`Poprzedni FY`,
"chatter.attachment":`Dodaj pliki`,
"label.view_only":`Tylko widok`,
"label.tianyancha.name":`Nazwa firmy`,
"label.service.gantt.avg.traveltime":`Średni czas podróży dla wizyt serwisowych`,
"vue_label_pool_move":`Przesuń`,
"label.import.index.beforeexport":`2、Przed importem, należy upewnić się, aby zaimportować wszystkie powiązane rekordy. Na przykład, jeśli importujesz rekordy kontaktu i chcesz wypełnić pole konta, które jest pole lookup, trzeba utworzyć rekord konta, które wypełniasz w pierwszy, a następnie zaimportować rekord kontaktu i wypełnić pole konta z nazwą lub ID odpowiedniego klienta.`,
"label.view.delete":`Usuń`,
"template.detail.info.link":`Szczegóły Link`,
"label.sendemail.send.setfail":`Ustawienie informacji e-mail nie powiodło się, proszę wpisać prawidłowe informacje.`,
"label_emailtocloudcc_redmessage11":`uwierzytelnianie SMTP zakończone. Proszę sprawdzić, czy adres e-mail i hasło są poprawne.`,
"label.campaigns.memberalert":`Proszę wybrać członka co najmniej`,
"label.schedulejob.setup.schedule.frequency":`Częstotliwość`,
"component.newrecords.label.all":`Zobacz wszystkie`,
"label.mr.caption.opportunity":`Znajdź duplikaty i połącz: Kody do wyszukiwania duplikatów szans`,
"chatter.group.onlyMembers":`Tylko członkowie mogą widzieć tę grupę. I tylko właściciel grupy ma prawo dodawać członków zespołu.`,
"label.recordtype.edit.selectvalue.show":`Wartości z listy pickupów są wyświetlane w kolejności, w jakiej zostały zapisane.`,
"message.textmaxlength":`Długość nie powinna przekraczać 255 znaków`,
"label.reportsSubscriptionPage.visibility":`Biegnąc jako`,
"label.umeng.chatter.addcoments":`Twój post o chmurach ma 1 nową odpowiedź`,
"chatter.up.f":`Upload Failed, nieznany błąd.`,
"label.icon.146":`Klawiatura`,
"lable.custom.CY.Ago":`2 CY Ago`,
"label.tabpage.step3":`Krok 3 wybierz pola do wyświetlenia`,
"label.checkfield.introduce":`Ustaw pola obiektu, które mają być użyte do sprawdzenia duplikatów, a następnie znajdź duplikaty na liście rekordów po ustawionych polach.`,
"label.tag.addtags":`Dodaj tagi`,
"label.service.newBuildDialog.characterlimit":`Nazwa przekracza limit 25 znaków.`,
"font-evaluate-module-v1-evquestions":`Pytanie oceniające`,
"label.knowledge.only.update.draft":`Tylko aktualizacja projektu`,
"label.partnerCloud.basicSetting.defaultCounts":`Domyślny numer roli przy dodawaniu konta partnerskiego`,
"label.chat.topic.delete":`Usuń`,
"label.workflow.contentcondition":`spełnione są kryteria`,
"vue_label_commonobjects_view_sortby":`Sortuj według {pole}`,
"label.passwordPolicy.setup.pwdremember24":`Przypomnij (0) hasło`,
"front-kefu-moudle-free-account":`Rachunek próbny`,
"label.marketsea.isautorecycle":`Włącz automatyczny recykling`,
"label.addattachment.view":`Wyświetl pliki`,
"vue_label_helpcenter_contact":`W informacjach szczegółowych kliknij przycisk diagramu drzewa obok kontaktu, możesz wyświetlić diagram hierarchii kontaktu, zrozumieć relacje lider-członek powiązanych kontaktów i wyświetlić niektóre informacje o polu każdego kontaktu.`,
"label.taskevent":`Działania`,
"label.industrialandcommercialverification.message":`Skończyły się dzisiejsze bezpłatne zapytania ofertowe`,
"label.object.already.delete":`Obiekt usunięty`,
"label.project.hit.four":`Zawiadomienie o aktualizacji podzadania`,
"label.taskpagelayout":`Układy stron zadań`,
"label.version.sum.locationfield":`Pola geolokalizacyjne`,
"front-sales-button-toQB":`Synchronizacja z QuickBooks`,
"label.app.oceanblue":`Ocean Blue`,
"label.operating":`Obsługa...`,
"label.customfields.formula.dateexample":`Data przypomnienia = CloseDate - 7`,
"label.happen_delete":`Co się stanie, jeśli usunę formularz?`,
"label.service.appointmentList.plansToStart":`Plan startowy`,
"label.persmets.operate.licence":`Pozwolenie`,
"label.mobile.quickcreate.default.activities":`Kalendarz`,
"label.australian.eastem.standard.time":`australijski czas letni wschodni （Nowa Południowa Walia）`,
"label.emailobject.remove":`USUŃ`,
"label.weixin.vote":`głosowanie`,
"label.reportsSubscriptionPage.condition.aggregate":`Agregat`,
"front-kefu-moudle-has-unbind":`Zostałeś wyzwolony`,
"chatter.group.newGroup":`Nowa Grupa`,
"label.tabpage.systems":`Istnieją * systemy`,
"label.textmessage.vonage.connect":`Połącz się z Vonage`,
"label.campaign.channel.input.ticket":`Wyślij bilet wstępu`,
"label.ccpeak.query.sharetab":`Formularze udostępniania wyszukiwania`,
"label.reporttype":`Raport Źródło danych`,
"message.duplication.label.isprofiletip":`Jeżeli jest zaznaczone, to podczas wyszukiwania duplikatów będą sprawdzane tylko te dane, które widzi bieżący użytkownik. W innym przypadku zostaną zweryfikowane wszystkie dane.`,
"label.tianyancha.businessverify.xieyi":`Umowa licencyjna użytkownika CloudCC`,
"font-evaluate-module-v1-select-person":`Proszę wybrać pracowników obsługi klienta`,
"vue_label_chatter_all_groups":`Wszystkie grupy`,
"label.recordtype.profile.setdefault":`Ustaw domyślne`,
"label.mr.descreption.nocondition":`Brak powielonych danych spełniających warunki.`,
"label.tabpage.askz":`O co chciałbyś zapytać`,
"label.marketsea.selectMember":`Wybierz członka`,
"template.report.stage.possibility.analysis":`Etapowa Analiza Możliwości`,
"label.data.selectderivedobject":`Wybierz obiekt do eksportu`,
"label.customfields.formula.explain":`Opis: obecnie obsługuje liczbę, procent i inne pola czterech zasad, jak również wartości przeniesienia pola wyszukiwania. Na przykład: liczba oblicz: jednostka*cena jednostki&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;pole wyszukiwania ma wartość: kontakt__r.adres`,
"vue_label_notice_change_fail":`Zmiana nie powiodła się`,
"label.customobjects.trackoldandnewvalues":`Śledzenie starych i nowych wartości`,
"label.h5.leftprompt":`Masz trochę zredagowanej treści, która nie została wysłana, czy na pewno chcesz wyjść?`,
"label.select.field":`Dostępne pola`,
"label.customobjects.layoutedit":`Układ strony Przydział`,
"label.false":`FALSE`,
"UG_Forcast_07":`Umożliwić prognozę`,
"vue_label_chatter_team_member":`członek grupy`,
"label.tabpage.retypez":`W przypadku zmiany typu rekordu, istniejące wartości listy opcji nie zostaną automatycznie zmienione. Zalecamy aktualizację istniejących wartości listy opcji rekordu w tym samym miejscu.`,
"front-epwechat-module-v1-single-desc":`Single Sign On na innych końcach CloudCC poprzez WeCom; Swift switch pomiędzy wszystkimi końcami.`,
"label.closeandconverted":`Closed-Converted`,
"label.service.confirmed":`Potwierdzone`,
"label.partner.workspace.member.cloudcc":`Profil CloudCC`,
"label.star.click":`Kliknij, aby wyczyścić`,
"label.icon.135":`Waluta`,
"button_partner_workspace_login_logo_upload":`Prześlij obraz`,
"message.error.sql.constraint.recordnotsingle":`Identyfikator zewnętrzny skonfigurowany pomyślnie. Powód: to pole w oryginalnych danych ma zduplikowane dane.`,
"label.ccchat.person.invite.errorpwd":`Użyj co najmniej 8 znaków, w tym kombinacji cyfr i znaków`,
"label_tabpage_isdeleterecord":`Jeśli usuniesz wybrany rekord`,
"label.weixin.prompt.message":`Komunikat ostrzegawczy`,
"vue_label_chatter_view_original_post":`Zobacz oryginalny post`,
"label.multilingual.tip3":`Włączenie wielojęzyczności umożliwia każdemu użytkownikowi w organizacji konfigurowanie języków, które zostały włączone.`,
"label.dataimport.error.datetime":`Błąd: Format danych i czasu jest nieprawidłowy`,
"label_tabpage_addcondition":`Dodaj warunek`,
"label.query.detail.manageexcludeuser":`Zarządzaj użytkownikiem zewnętrznym`,
"label.tianyancha.creditcode":`Jednolity kodeks kredytu społecznego`,
"label.cy.enter":`Wprowadź kurs przeliczeniowy z waluty firmowej na nową walutę.`,
"label.textmessage.vonage.message1":`Dzięki integracji z Vonage, użytkownicy mogą wysyłać i odbierać wiadomości tekstowe na Platformie CloudCC za pośrednictwem Vonage. Zanim jednak użytkownicy będą mogli wysyłać wiadomości tekstowe, muszą zarejestrować konta Vonage i kupić numery telefonów.`,
"front-marketing-module-v1-share-invitation":`Udostępnij Zaproszenie dla pracowników`,
"label.file.items":`przedmiot(y)`,
"label.otherwise":`W przeciwnym razie`,
"label.permission.detail.system":`System`,
"message.success.task.emailsend":`Zapisz i wyślij wiadomość e-mail pomyślnie`,
"label.the.reward.group":`Grupa Quote Line`,
"setup.layout.label.relatedlistsetup":`Powiązane ustawienia listy`,
"label.empty":`Jasne`,
"label.weixin.cloudcc.user.binding":`Wiązanie użytkownika CloudCC`,
"label.file.what.change":`Co się zmieniło?(opcjonalnie)`,
"label.search":`Szukaj`,
"label.mobile":`Mobile`,
"template.report.month.potential.customer":`Leads of This Month`,
"lable.setup.mobilesetup.isEnableValidationRulesForScan":`Włącz reguły walidacji podczas skanowania`,
"lable.outlook.list.des":`Konfiguracja Exchange Sync definiuje ustawienia dla CloudCC for Exchange, które mają być zastosowane do określonej grupy użytkowników.`,
"label.appupload.install.error.info":`{0} "{1}" zostało użyte przez {2}, proszę zmienić nazwę istniejącego {0}.`,
"label.tabpage.addoptionsz":`Dodaj opcje`,
"label.arabian.standard.time":`Czas standardowy Arabia`,
"label.thefirst":`Pierwsza kolumna`,
"label_partner_workspace_login_footertext":`Tekst stopki`,
"lable.Disabled.successfully":`Dezaktywacja zakończona sukcesem.`,
"label.confirm.del":`Rekordy oczekujące na zatwierdzenie, czy na pewno chcesz je usunąć?`,
"vue_label_normal_reregister":`Zaloguj się ponownie`,
"label_file_img":`Obraz`,
"label.salescloud.salesdashboard.sales.behavior":`Działalność handlowa`,
"label.startdate":`Data rozpoczęcia`,
"label.field.duplicate.error.msg5":`Proszę sprawdzić wszystkie błędy poniżej, ponów próbę po modyfikacji.`,
"setup.main2018.label.managesetup":`Ustawienia administracyjne`,
"label.forecast.editshrepage.title":`Nowe udostępnianie`,
"UG.solution.01":`Podaj rozwiązanie`,
"label.knowledgebase.data.recovery.successfully":`Odzyskaj dane {a} pomyślnie`,
"label.pc.ui.2018.myccchat":`Mój CCChat`,
"label.attachement":`Uwagi`,
"message.mobilechooseatmostten":`Wybierz do 10 pól`,
"label.campagin.roi.bhzeywjh":`Możliwości ogółem`,
"label.autoresponserule":`Reguły automatycznej odpowiedzi`,
"label.attendance.yuyue":`Nie masz umówionej wizyty, zarejestruj się teraz.`,
"label.insert":`Wkładka`,
"label.service.ganttBaiduMap.shutDown":`Czy chcesz się zamknąć?`,
"label.icon.194":`TV`,
"message.serviceterritory.violation":`Naruszenie strefy: strefa zasobów nie jest zgodna ze strefą serwisową powołania.`,
"label.appointment.disable.function":`Wyłączenie funkcji`,
"lable.currencyManage.manageexchangeRate.dis":`Aby zarządzać datowanymi kursami wymiany dla swojej organizacji, należy kliknąć przycisk Zarządzaj datowanymi kursami wymiany. Datowane kursy walut są wykorzystywane w szansach, produktach szans oraz raportach związanych z tymi dwoma obiektami.`,
"vue_label_file_upload_tip_newmsg":`Mniej niż {size} MB plik jest zalecany do załadowania, w przeciwnym razie mogą wystąpić problemy z powolnym ładowaniem.`,
"label.event.next.week":`Następny tydzień`,
"label.datamanage.import.contactfield":`W poniższej tabeli zaznacz pola z importowanego pliku, które powinny zostać zaimportowane do każdego kontaktu. Następnie kliknij przycisk Next:`,
"label.projectManagement.time.allocated":`Przydzielony czas`,
"label_tabpage_isdeleteview":`Czy na pewno chcesz usunąć ten widok?`,
"label.pc.ui.2018.search":`SZUKAJ...`,
"label.role.createrolelevel":`Tworzenie hierarchii ról`,
"label.tabpage.editview":`Edytuj widok`,
"label_partner_common_manageSetup":`Ustawienia administracyjne chmury partnerskiej`,
"label.service.gantt.noservice.resource":`Nie znaleziono żadnych zasobów usługowych dostępnych w ramach wybranego obszaru usług.`,
"message.numbertoolarge":`Liczba jest zbyt duża`,
"label.sendsms.success":`Tekst został wysłany pomyślnie`,
"UG.opportunity.009":`Lub`,
"label.ccpeak.construction.dataobj":`aby zbudować obiekt danych, nazwa API obiektu musi być przekazana w`,
"front-lighting-module-v1-detail-file-uploadInfo":`Rekord jest zablokowany i nie można na niego przesyłać plików. Prosimy o kontakt z administratorem w celu odblokowania.`,
"label.import.page2.newnotmatchfiled":`Łącznie {{ csvfiledlength }} pól w pliku. Nieodwzorowane {{this.csvfiledlength - this.selectlength}}.`,
"label.ems.inputmailss":`Serwer odbiorczy poczty elektronicznej`,
"label.knowledgebase.data.published.successfully":`Opublikuj {a} dane z powodzeniem`,
"label_emailtocloudcc_position":`Pozycja`,
"label.data.exp.customexp":`Eksport niestandardowy`,
"component_chatter_post_button_user":`Dodaj ludzi`,
"label.new.visualpagefolder":`Strona niestandardowa : Nowy folder`,
"label.forecast.shrepage.classdes":`Opis poziomów dostępu`,
"label.task.overdue.unfinished":`Zaległe, nieprzetworzone zadania`,
"label.ccchat.micropost.isedit.setting.info":`Autor postu lub komentarza, właściciel nagrania, moderator CCChat oraz moderator tej społeczności mają pozwolenie na modyfikację tego tekstu.`,
"label.recordname":`Nazwa rekordu`,
"label.posted_your":`i umieszczony w twoim`,
"label.globaloperation.operationtype.custom.page":`Własna strona`,
"label_tabpage_busoppnamez":`Nazwa możliwości biznesowych`,
"front-epwechat-module-v1-schedule-desc":`Synchronizacja harmonogramów WeCom i wydarzeń CloudCC`,
"label.escalation.setup.newentries.lastmodifydate":`W oparciu o czas ostatniej modyfikacji`,
"setup_layout_label_nofield":`Brak dostępnych pól`,
"label.sendemail.registIMUser.logininfo":`Partner cloud portal można zalogować się jest jak poniżej:<br>`,
"label.weixin..xsld.kehu":`Konta`,
"label.display_thank":`Pokaż stronę z podziękowaniami`,
"label.group.no.my.group":`Nie ma żadnych pasujących do mojej grupy.`,
"label.partnerCloud.newBuildSite.enterDomain":`Proszę wpisać nazwę domeny`,
"label.step1.total2":`Krok 1 z 2`,
"label.ccpeak.delete.record":`Usunąć zapisy:`,
"label.customer.tab.step1.introduce":`Wybierz obiekt niestandardowy dla tej nowej zakładki niestandardowej. Wypełnij pozostałe szczegóły.`,
"label_tabpage_newInterfacez":`Nowy interfejs`,
"setup.mainpage.label.manageuser":`Zarządzaj użytkownikami`,
"label.partnerCloud.partnerAccount.completed":`Czy płatność została zakończona?`,
"label.projectManagement.kanban":`Zadanie Kanban`,
"label.operate":`Działanie`,
"label.service.dispatchingUnits.selected.time.range":`Wyświetlanie wizyt serwisowych w wybranym zakresie czasu.`,
"component_setup_label_pagesize":`Numery wyświetlane na każdej stronie`,
"font-evaluate-module-v1-email-evaluation-settings":`Konfiguracja oceny emaili`,
"label.service.dispatchingUnits.skills":`Umiejętności`,
"label.editrecurrencetimetrigger":`Edycja wyzwalania okresowego`,
"vue_label_file_edit_lib":`Edytuj bibliotekę plików`,
"label.campaignmember.selectmember.deleteconc":`Kampania: usuń członków z kontaktów`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.monday":`Poniedziałek`,
"front-detail-module-v1-by":`przez`,
"label.mobile.home.page.date.signed":`Data zamknięcia`,
"label.apply.send.success":`Sukces wysyłki.`,
"label.app.choseimg":`Wybierz logo`,
"label.customsetting.visible":`Widoczność`,
"label.sendemail.activity.task.distributetaskcompleted":`Zadanie, które przydzieliłeś #belongtoidccname zostało zakończone.`,
"label.dashboard.snapshot.refreshing":`Odświeżający`,
"label.document.name.already.exists":`Ta Unikalna Nazwa Dokumentu już istnieje.`,
"label.ccchat.person.invite.needlastname":`Wpisz swoje nazwisko`,
"pagecreator_page_button_copy":`Kopia`,
"label.appointmentpage.wizard.subtitle1-2":`Poprzedni Tydzień`,
"label.validate.function.funcFormat.MILLISECOND":`MILISEKUNDA(data)`,
"label.profile.allowtocreateview":`Tworzenie widoków`,
"message.error.recordid":`Identyfikator rekordu nie może być pusty`,
"lable.SalesCommitmentKanBan.returnToTheSuperiorRole":`Powrót do roli nadrzędnej`,
"label.translation.start3":`W razie potrzeby należy wybrać obiekt. Na przykład, zadanie przepływu pracy posiada obiekt (Konto, Kontakt, itp.), który ma filtrować terminy możliwe do przetłumaczenia.`,
"label.ccpeak.send.email":`Wyślij wiadomość e-mail z powiadomieniem:`,
"vue_label_commonobjects_detail_activity_noexpirationdate":`Brak daty ważności`,
"label.permission.objectpermission.objpermission":`Ustawienia uprawnień do obiektów`,
"label.version.custom.report":`Raporty standardowe (strona niestandardowa)`,
"label.title.qrcodeOrbarcode":`Generuj kod kreskowy/kod QR`,
"label.emailtocloudcc.step2.name":`Skonfiguruj własność poczty elektronicznej`,
"label.reportsSubscription.edited.successfully":`Edycja subskrypcji raportu zakończona sukcesem!`,
"label_tabpage_kanbansetup":`Konfiguracja tablicy poglądowej`,
"label.tianyancha.regcapital":`Kapitał zarejestrowany`,
"front-epwechat-module-v1-web-single":`Web Single Sign On:`,
"label.visualpage.display.top":`wyświetl nagłówek, false - nie wyświetlaj nagłówka`,
"label.customfields.fielddependency.selectcell":`Wybierz co najmniej jedną komórkę z poniższej listy`,
"label.paging.addmember.totalofpages":`Łącznie {0} pozycji.`,
"label.email.saveing":`Dane to oszczędność...`,
"label.userinfo.doublepwd.notnull":`Musisz powtórzyć swoje hasło.`,
"label.appointment.wizard.subtitle4-4-2":`2 tygodnie`,
"label.chatter.BCC":`Bcc (blind courtesy copy)`,
"label.emailtocloudcc.description":`Podłącz swoje firmowe konto e-mail, takie jak sales@company.com, info@company.com, support@company.com. Automatycznie rejestruj otrzymane wiadomości e-mail jako leady i rekordy spraw w CloudCC, aby zapewnić terminowe śledzenie listów od klientów.`,
"label.sendemail.send.atlastone":`Musisz wybrać co najmniej jednego odbiorcę.`,
"label.mobile.phone.subordinate":`Włączenie podwładnych`,
"label.data.choses.e_desc":`W zależności od potrzeb można wyeksportować wszystkie dane lub wyeksportować dane z danego obiektu.`,
"chatter.new":`Wiadomości`,
"vue_label_help_back":`Powrót`,
"label.skipwizardintro":`Kreator Jump Start tworzy dla Ciebie jednoetapowy proces zatwierdzania w ciągu zaledwie kilku minut.`,
"label.weixin.fmu.before.week":`{0} tydzień(y) do przodu`,
"label.sendemail.chat.praiseFeedsubject":`CloudCC CCChat polubił twój post`,
"lable.currencyAdv.andafterdate":`i po`,
"label.sometoprocess":`Jeśli tylko niektóre rodzaje rekordów powinny być objęte tym procesem zatwierdzania, należy wprowadzić te kryteria poniżej. Na przykład, tylko raporty wydatków od pracowników w centrali powinny korzystać z tego procesu zatwierdzania.`,
"label.campaignmember.main.updateleaddesc":`Aktualizuj status wszystkich leadów jednocześnie`,
"label_partner_common_roleSetup":`Ustawienia roli i użytkownika w chmurze partnerskiej`,
"label.console.step5.no":`Wybierz sposób wyświetlania rekordów`,
"label.salescloud.teamrole.optionlist.account":`Dodaj członka zespołu do`,
"Report.Delete.Confirm.Title":`Proszę potwierdzić`,
"label.onclick":`Kliknij`,
"label.weixin.input.identifying.code":`Proszę wprowadzić kod weryfikacyjny`,
"label.knowledge.translate":`Przetłumaczony może zostać tylko artykuł wiedzy z edycji głównej o statusie Draft lub Published.`,
"label.log.ip":`IP`,
"front-electronic-export-goResult":`Sprawdź w Mailchimp`,
"label.escalation.setup.newaction.otheremail.otheremail":`Dodatkowe e-maile`,
"label.icon.104":`Harmonogram`,
"label.partnerCloud.exceedTwo":`Wgrywane zdjęcie profilowe nie może przekroczyć 2MB!`,
"label_tabpage_thevalurofz":`Wartość`,
"front-lightning-module-v1-details-page-chart-maximum":`Można wprowadzić do 50 znaków.`,
"label.data.downpage.i.title.num6":`Zaleca się, aby przed zaimportowaniem danych zaimportować plik testowy zawierający 5 rekordów, aby upewnić się, że dane, które chcesz zaimportować są poprawne.`,
"label.ccpeak.update.record":`Modyfikacja zapisów`,
"label.dataimportandexport":`Import i eksport danych`,
"label.tabpage.notexceed25":`Wybrany rekord nie może przekraczać 25`,
"label.starting":`W trakcie realizacji`,
"label.knowledge.language.spanish":`Hiszpański`,
"label_emailtocloudcc_set":`Ustawianie informacji o skrzynce pocztowej`,
"message.oneormoreneedsreport":`Proszę usunąć odniesienie do zespołu tablicy rozdzielczej dla tego raportu, a następnie spróbować ponownie.`,
"label.attendance.xccheckin":`Check In`,
"label.emailmerge.editfolder.title":`Foldery z szablonami Mail Merge`,
"template.report.year.customer":`Liderzy tego roku`,
"label.partner.common.webSit.memo":`Domyślna nazwa domeny chmury partnerskiej Twojej organizacji:`,
"label.partnerCloud.financeSetting.onlinePayment":`Płatność online`,
"Pagelayout.Setup.001":`Proszę wybrać listy powiązane, które będą wyświetlane przy najechaniu na układ.`,
"front-kefu-moudle-time-length":`Czas trwania pomocy`,
"label.deleteObject":`Obiekt został usunięty.`,
"label.setup.mobile.homepageshortcuts.select":`Wybierz 4 opcje jerzyków, które mają być widoczne w górnej części strony głównej`,
"setup.mainpage.label.welcome26":`Zarządzanie danymi - Przetwarzanie wsadowe`,
"label.ServiceCloud.yuyuebainhao":`Nr zlecenia serwisowego.`,
"label.emailobject.emaildetail.button.addtolead":`Dodaj do leadów`,
"label.event.single.view":`Widok pojedynczego użytkownika`,
"lable.product.pricebooks.ustand":`Wybierz cenę standardową`,
"label.emailtocloudcc.department":`Dział`,
"component_assistant_label_30daysnoact":`30 dni bez żadnej kampanii`,
"label.weixin.no.pending.qzkh.qin":`Niestety, nie ma żadnych tropów do pokazania.`,
"label.vlidaterule.formula":`Warunek błędu Wzór`,
"label.tianyancha.h5.contact":`Dane kontaktowe`,
"label.button":`Przyciski`,
"message.checkemail":`<strong>Błąd:</strong>w podanym adresie e-mail wystąpił błąd, proszę sprawdzić.`,
"lable.account.previous.CY":`Poprzedni CY`,
"label.icon.13":`Serwis`,
"chatter.coll.c":`Usuń zakładkę`,
"label.knowledge.category.hint.four":`Przydział kategorii danych`,
"label.tianyancha.phonenumber":`Numer telefonu`,
"label.tablayoutedit.remark":`Wybierz pola i strony niestandardowe wyświetlane na stronie głównej karty.`,
"label.shareusers":`Udostępnij użytkownikom`,
"label.endtime":`Koniec`,
"label.length":`Długość`,
"label.umeng.activity.event.begin":`zaczynać się po`,
"label.tabpage.alltabs":`Wszystkie karty`,
"label.exact.query":`Ulepszone wyszukiwanie`,
"label.weixin.skip":`Skocz do`,
"label.ems.cancel":`Anuluj`,
"label.trigger":`Wyzwalacze`,
"label.exchange.sync.setting":`Konfiguracja synchronizacji z Exchange`,
"label.product.pricebooks.name":`Cena Nazwa książki`,
"label.relation.list.total":`Wybrane`,
"label.step2.total7":`Krok 2 z 7`,
"label.martrixreport.2018.step6.new":`Krok 6 Wybierz typ wykresu i element podświetlenia.`,
"label.standard.buttonandlink.override":`Szerokość nadwyżki`,
"front-console-conversation-btn4":`Oddzielnie jako nowa sprawa`,
"vue_label_dashboard_range":`zakres`,
"label.app.sort.show":`Aplikacja jest wyświetlana w zapisanej kolejności.`,
"label.salescloud.teamrole.choose.correct":`Wybrano podwójnych użytkowników, proszę poprawić`,
"label.schedule_post":`Opublikuj post`,
"front-kefu-moudle-server-request-num":`Lista zgłoszeń serwisowych nr.`,
"label.h5.logout":`Wyloguj się`,
"label.weixin.horse.club.member.message":`Informacje dla członków Aid-Max`,
"label.field.addoptionlist.introduce":`Wprowadź jedną lub więcej wartości z listy wyboru poniżej, każdą wartość oddzielając nowym wierszem.`,
"setup_layout_label_setupfield":`Właściwości pól`,
"label.chatter.nextStep":`Następny krok`,
"label.quickbooks.searchlist.total1":`Istnieje {0} niepowiązanych faktur o łącznej wartości {1}.`,
"label.tianyancha.h5.regcapital":`Kapitał zarejestrowany`,
"label.icon.184":`Doradztwo`,
"label.dashboard.message.refreshtoomush":`Zrzut pulpitu jest odświeżany zbyt często, proszę odświeżyć później`,
"label.umeng.approval.reject":`#approver odrzucił twoją prośbę o zatwierdzenie #obj.`,
"label.h5.chatter.newmessage":`Wprowadź nową wiadomość`,
"message.error.relationid":`relationid nie może być pusty!`,
"label.setup.mobile.offlinecache.selectdefault":`Wybierz zakładki jako domyślne zakładki pamięci podręcznej offline`,
"label.setup.mobile.homepageshortcuts.saveprompt":`Proszę wybrać 4 szybkie funkcje.`,
"label.projectManagement.Selectmonth":`Wybierz miesiąc`,
"label.version.ultimate":`Ultimate Edition`,
"label.validate.remark5":`Obowiązkowe pola daty są w odpowiedniej kolejności, na przykład: czas rozpoczęcia musi być krótszy niż czas zakończenia`,
"label.version.nowis":`Twoja aktualna wersja CloudCC to`,
"front-kefu-moudle-CRM-set":`Konfiguracja CRM`,
"label.mr.title.customerAddress":`Adres konta`,
"label_emailtocloudcc_step1_name":`Wybierz funkcję`,
"label.time.operation.edit":`Modyfikacja zaplanowanych zadań`,
"label_tabpage_operationz":`Pole, operacja nie może być pusta`,
"label.translation.start4":`Kliknij dwukrotnie w kolumnie tłumaczenia, aby wprowadzić nowe wartości.`,
"vue_label_systemSettings_request":`Wniosek o przeniesienie partii`,
"label.maintenance.notice":`Zawiadomienie o konserwacji`,
"label.customfields.txet.textlength.tip":`Proszę podać maksymalną długość pola tekstowego poniżej Maksymalna długość wynosi 255 znaków.`,
"label.ccdocument.select.template.open":`Proszę wybrać szablon, który ma zostać otwarty.`,
"vue_label_display_date_field":`Pokaż pola daty`,
"label_partner_workspace_tab":`Zakładka`,
"lable.account.LasthDays":`Ostatnie 120 dni`,
"chatter.using.sticker":`Włącz śledzenie kanałów`,
"message.save.dataerror":`Błąd: błąd zapisu spowodowany dużą długością danych lub innymi problemami. Proszę zmodyfikować dane w celu ponownego zapisania.`,
"vue_label_commonobjects_view_chart_newchart":`Nowy wykres`,
"label.chat.micropost.a.group":`Grupa`,
"lable.currencyManage.advcurrencyunEnabled":`Zaawansowane zarządzanie walutą nie jest włączone`,
"label.appexchange.workflow":`Zasady przepływu pracy`,
"vue_label_calendar_show_details_and_add_events":`Pokaż szczegóły i dodaj wydarzenia`,
"label.salescloud.optionlist.inputname":`Proszę podać nazwę wartości listy wyboru`,
"label.dashboard.folder":`Foldery`,
"label.knowledgebase.permanently.remove.articles":`Usunięcie zarchiwizowanego artykułu spowoduje trwałe usunięcie również innych, powiązanych z nim wersji.`,
"label.emailtocloudcc.titel":`E-mail do CloudCC`,
"label.visualpage.sel":`Strony własne w tym folderze`,
"label.planned.all.work":`Wszystkie planowane miejsca pracy`,
"label.weixin.agree.agreement":`Zgodzić się na odpowiednią umowę`,
"label.forecast.customforecast.qsn":`Rok rozpoczęcia`,
"label.appupload.managed":`Kontrolowane`,
"template.report.folder.sale.index":`Analiza wskaźników sprzedaży`,
"UG_opportunity_011":`Transakcja importowa`,
"label.validate.function.funcFormat.SECOND":`SEKUNDA(data)`,
"UG_homepage_005":`Informacje o sprzedaży`,
"label.clicktoreturn":`Kliknij tutaj, aby powrócić`,
"label.collectionofview":`s Zestawy widokowe`,
"com.cloudcc.login.error.message.nonuser":`Twój identyfikator nie istnieje`,
"vue_label_systemSettings_emailsetting":`Konfiguracja poczty elektronicznej`,
"vue_label_email_mark_as":`Zaznacz jako`,
"label.tabpage.customernamez":`Nazwa klienta`,
"label.appupload.install.apicannotsame":`Nowa nazwa api nie może być taka sama jak oryginalna wartość`,
"label.task.all.undealt":`Wszystkie zaległe, nieprzetworzone zadania`,
"front-lightning-module-v1-dashborad-statistical-indicators":`Indeks statystyczny`,
"UG.quota.02":`Etap możliwości zmiany`,
"label.approve":`Zatwierdzić`,
"vue_label_calendar_remove_calendar":`Usuń kalendarz`,
"label.mr.title.contactName":`Nazwa kontaktowa`,
"label.projectManagement.resource":`Zarządzanie zasobami`,
"label.rejectbehaviour1":`Umożliwienie zatwierdzającemu ręcznego wyboru numeru kroku.  (powrót do poprzedniego kroku N)`,
"label.publicgroup.relationship":`Członkostwo w grupie`,
"Lead.Scoring.DetailedPage.Popup.Title":`Główny Wgląd`,
"label.owner.edit":`Właściciel Edycja`,
"label.campaign.channel.ticket.mark":`UWAGA: Zapisz kod QR do albumu zdjęć za pomocą zrzutu ekranu telefonu komórkowego lub zapisz go w telefonie komórkowym i wejdź do kampanii z kodem QR.`,
"label.opportunity.setting.showstage.info":`Czy pokazywać scenę możliwości w aplikacji CloudCC.`,
"label.emailobject.wizard.desc3":`Oszczędzaj czas, korzystając z szablonów wiadomości e-mail`,
"label.cpq.quote.no.product.add":`Brak dodanych produktów w ofercie. Prosimy o dodanie produktu przed wygenerowaniem zamówienia.`,
"label.customer.tab":`Własne karty`,
"Opportunity_Detailed_Phase_Label_Popup_002":`Data zamknięcia bieżącego etapu`,
"component_telerecord_label_name":`Nazwy`,
"label_component_helper_nodata":`Nic nie wymaga teraz Twojej uwagi. Sprawdź później.`,
"label.dashboardSetup.d2":`Punkt przerwania 2`,
"setup.mainpage.label.welcome4":`Instrukcje: Kliknij w menu po lewej stronie → Ustawienia aplikacji → Utwórz → Obiekt.`,
"label.step4.total5":`Krok 4 z 5`,
"label.payment.the.remaining.days":`Twoja licencja wygasa za {0} dni`,
"label.encoding":`Kodowanie`,
"label.setting.intergrationlist.status2":`Ta integracja jest obecnie zainstalowana.`,
"label.new":`Nowy`,
"label.search.searchsetup":`Ustawienia wyszukiwania`,
"label_tabpage_printz":`Drukuj`,
"report.type.label.customService":`Obsługa klienta`,
"label.notification.addEmailObject.message":`Otrzymałeś wiadomość od {!fromaddress}, kliknij aby zobaczyć więcej szczegółów`,
"label.icon.68":`Maszyna`,
"UG.Lead.003":`Społeczny`,
"label_mobile_default_field_service_home":`Strona główna Service Cloud`,
"label.select.one.group":`Proszę wybrać co najmniej jedną grupę linii cytatów.`,
"front-kefu-moudle-trkey-nopower":`Para kluczy Tianrun nie ma przypisanych uprawnień`,
"label.chatter.cancel":`Anuluj`,
"label.weixin.report.optiondisplay":`Pokaż`,
"front-kefu-moudle-v1-System-version":`Wersja systemu:`,
"lable.product.pricebooks.editall":`Edytuj wszystko`,
"label.group.no.recent3":`lub`,
"label.knowledge.article.delete":`Błąd podczas usuwania artykułu wiedzy.`,
"label.relateobj":`Related To`,
"workflow.action.tasks.assignortype.type":`Typ`,
"label.layout.selectedfields":`Wybrane pola`,
"label.role.assign.operate":`Przypisanie innych użytkowników do tej roli:<ul><li>Kliknij listę rozwijaną, aby wyświetlić wszystkich dostępnych użytkowników.</li><li>Wybierz użytkownika z lewej strony listy "Dostępni użytkownicy" i dodaj go do listy "Wybrani użytkownicy".</li></ul>`,
"label.field.insert":`Wstaw pole`,
"label.icon.11":`Ludzie`,
"label.group.no.recent4":`założyć grupę.`,
"front-epwechat-module-v1-input-corpid":`Proszę wpisać Corpld`,
"setup_object_field_dependency_label_actionfieldnotnull":`Proszę najpierw wybrać pole kontrolne.`,
"setup.mainpage.label.welcome19":`Instrukcje:  Kliknij na menu po lewej stronie → Zarządzaj ustawieniami → Zarządzaj użytkownikami → Użytkownicy, role, profile.`,
"label.escalation.setup.list.rulename":`Nazwa zasady`,
"label.ems.addaccount":`Dodaj konto teraz`,
"label.reportsSubscription.details.only":`Tylko szczegóły (format Excel .xlsx)`,
"vue_label_commonobjects_view_groupby":`Grupa według`,
"label.email.form.text":`Tylko tekst`,
"label.weixin.loginname":`Nazwa logowania`,
"label.forecast.settings.sr":`Dochody`,
"label.chatter.sendEmailToGroupMember.subject.F":`{0} opublikowane posty dla wszystkich w {1}`,
"label.ccchat.enter.subject":`Proszę wpisać temat głosowania`,
"label.customer.tab.introduce":`Zakładki obiektów niestandardowych wyglądają i zachowują się jak standardowe zakładki dostarczane z CloudCC.`,
"message.login.mfaverification.wrong":`Błąd kodu bezpieczeństwa.`,
"component.newrecords.label.name":`Nazwa`,
"label.salescloud.opportunity.addandedit.contactrole":`Dodawanie i edytowanie ról kontaktu`,
"label_emailtocloudcc_button_next":`Następny`,
"label.console.step5":`Krok 5 Wybierz sposób wyświetlania rekordów`,
"setup.main2018.label.norole":`Nie masz uprawnień administracyjnych`,
"template.chart.ywjhqd":`Etap możliwości biznesowych`,
"label.instrumentPanel.breakpointOneLabelname":`Wartość ta powinna być większa od wartości minimalnej.`,
"label.qrcode":`Kod QR`,
"label_tabpage_no2z":`Nr2`,
"label.log.search.date.range":`Cykl zapytania nie może być dłuższy niż {c} miesięcy.`,
"label.console.step7":`Krok 7 Przypisanie profilu`,
"label.australian.central.standard.time":`Australian Central Standard Time （Northern Territory）`,
"label_tabpage_deleteviewfailed":`Nie udało się usunąć widoku`,
"vue_label_commonobjects_view_searchview":`Wyszukiwanie w tym widoku`,
"message.error.object.notexists":`Obiekt nie istnieje.`,
"label.tablecell":`Komórki`,
"vue_label_notice_edit_success":`Edytuj z powodzeniem`,
"label.customer.language":`Język domyślny`,
"label.csrf":`Aktywuj ochronę bezpieczeństwa csrf`,
"label.forecast.customforecast.submit.zhi":`do`,
"label.sso.saml.idp.config.desc2":`Kliknij Enable Identity Provider, aby włączyć swoją organizację CloudCC.com jako dostawcę tożsamości.`,
"label.export_data":`Dane eksportowe`,
"component.todaytask.label.all":`Zobacz wszystkie`,
"label.h5.chatter.record":`Przebieg kariery zawodowej`,
"front-vew-email-verification":`Zobacz email i zweryfikuj konto. Możesz zalogować się dopiero po potwierdzeniu adresu email.`,
"laber.marketsea.del.error":`Pula ołowiu jest zajęta i nie może zostać usunięta`,
"vue_label_notice_homepage_entername":`Proszę wprowadzić zmodyfikowaną nazwę`,
"UG.Forcast.01":`Prognoza`,
"front-email-payment-tips":`Kwota na fakturze jest pusta. Prosimy o uruchomienie płatności online po wypełnieniu kwoty faktury.`,
"setup.mainpage.label.welcome2":`Własna baza danych (obiekt)`,
"APPIntegration.Social.facebookerror":`Musisz wpisać poprawny adres URL dla facebook.com`,
"label.profile.mobile.setup.stand":`Standardowa strona główna`,
"label.custom.CY":`Własny rok`,
"label.knowledgebase.publishing.conditions":`Pulish {a} dane nie powiodły się, oni są poza kryteriami publikowania!`,
"label.tianyancha.description":`Włącz TianYanCha, aby sprawdzić weryfikację danych przemysłowych i handlowych. Usługa ta obsługuje dane biznesowe zarejestrowane w Chinach kontynentalnych.`,
"label.appexchange.uninstallpage.title":`Odinstaluj pakiet will:`,
"label.currencyRate":`Wskaźnik konwersji`,
"setup_layout_label_areashow":`Wyświetl nagłówek sekcji Wł.`,
"label.setup.case.setting":`Mini Program do Sprawy`,
"vue_label_commonobjects_view_fixed_at_most":`Co najwyżej trzy kolumny mogą być stałe`,
"template.report.month.income":`Dochody w tym miesiącu`,
"label.sms.companyname":`Nazwa firmy`,
"label.sendemail.registIMUser.waitmessage":`Niestety, nie masz partnerskiego portalu cloud, do którego możesz się zalogować. proszę czekać, nasz administrator powiadomi Cię później. możesz odwiedzić podany adres, aby wejść na stronę logowania. użyj nazwy użytkownika i hasła powyżej, aby się zalogować.`,
"label.custom.field.task.object":`Zadanie, które zostało Ci przydzielone. Zadanie sbject:`,
"message.pleaseselectdayinweek":`Proszę wybrać dzień tygodnia.`,
"label.chat.topic.favorites":`Zakładka do książki`,
"UG.Campaign.004":`Kampania importowa`,
"label.approval.preview":`Podgląd procesu`,
"label.knowledgebase.assign.articles.to.people.or.queues":`Wybierz język docelowy i przypisz artykuł do danej osoby lub kolejki. Eksport tłumaczeń zazwyczaj jest przypisany do kolejki, a artykuły przetłumaczone wewnętrznie do osoby.`,
"pagecreator_systemstyle_message_save_success":`Styl zapisany pomyślnie`,
"label.outline":`Zarys`,
"label.read.only.field":`Tylko do odczytu Pola`,
"front-gantt-module-v1-early-warning":`Wczesne ostrzeganie`,
"label.file.ccchat.selectfrompc":`Wybierz plik z komputera`,
"vue_label_systemSettings_social":`Media społecznościowe`,
"label_report_year_last_year":`Rok do roku`,
"lable.PowerProcess.Meet.the.conditions":`Muszą być spełnione następujące kryteria:`,
"label.changemydisplay.list.title":`Wyświetlacz`,
"UG_Forcast_03":`Zacznij planować i realizować strategie biznesowe. <br>Życzę udanej prognozy!`,
"label.sendemail.chat.sendmessage":`Drogi #name:witaj! #userName wysłał do Ciebie wiadomość.`,
"label.huanxinconfig.secretid.lost":`secretid nie może być pusty`,
"label.icon.49":`Wytwarzanie energii elektrycznej`,
"chatter.feed.button.publish":`Udostępnij`,
"label.power":`^Moc`,
"label.partnerCloud.financeSetting.informationThree":`3. Po wejściu na stronę zarządzania tajnymi kluczami, kliknij mapi Gateway Product Key, i zdobądź ID partnera oraz tajny klucz MDS.`,
"label.emailtocloudcc.step1.lead2":`Po skonfigurowaniu, wiadomości otrzymywane na tę skrzynkę będą automatycznie rejestrowane jako rekordy leadów w CloudCC. Upewnij się, że żadna oferta nie zostanie pominięta.`,
"label.knowledgebase.delete.draft.succeeded":`Pomyślne usunięcie projektu`,
"label.dashboardSetup.title":`Edytor komponentów`,
"label.trigger.operation.email.template.map":`Powrót do informacji o szablonie, Temat emaila: m.get("subject"); Treść emaila: m.get("context"); czy typ emaila jest tekstem: m.get("istext")`,
"label.dependencesearchfilter":`Powiązane filtry Lookup`,
"label.selected.search.length":`Nie więcej niż 10 wybranych pól wyszukiwania`,
"label.profile.commonusercontrol":`Ogólne uprawnienia użytkowników`,
"lable.Microsoft.YaHei":`Microsoft YaHei`,
"label.appupload.component.type.app":`Aplikacja`,
"label.customsetting.manage.position":`Lokalizacja`,
"vue_label_systemSettings_bindweb":`Wiązanie sieci`,
"label.loginservice.license.notexist":`Licencja nie istnieje.`,
"label.icon.43":`Dzwony`,
"UG_homepage_003":`Widok 360 stopni`,
"label.file_format":`Format pliku`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.sunday":`Niedziela`,
"vue_label_chatter_post_has_delete":`Post został usunięty`,
"report_label_searchresult":`Wyniki wyszukiwania`,
"label.tabpage.justsz":`Tylko`,
"Lead_Scoring_Setting_LevelSetting":`Ustawienia popularności ołowiu`,
"setup.object.field.dependency.label.selectedfieldvalue":`Dostępne wartości pól`,
"label.search.morelistview":`Więcej widoków listy`,
"vue_label_homepage_won":`Zamknięte`,
"label.notification.last30days":`Ostatnie 30 dni`,
"vue_label_helpcenter_pool":`Użyj puli ołowiu i puli kont do zarządzania danymi sprzedaży.<br>Konfigurowanie puli kont<br>Twórz pulę kont w tle, skonfiguruj administratorów i członków puli kont oraz skonfiguruj reguły automatycznego recyklingu, co jest wygodne w zarządzaniu sytuacją śledzenia okazji w Twoim zespole i zachęcaniu członków zespołu do aktywnego śledzenia.<br>Ręczne zarządzanie danymi<br> Administrator puli kont może wykonywać operacje, takie jak dystrybucja, recykling, odrzucanie i przenoszenie rekordów w puli kont i zarządzać rekordami w puli kont w sposób ujednolicony;<br> Członkowie puli kont mogą otrzymywać nieprzydzielone rekordy lub przeglądać rekordy, za które są odpowiedzialni.`,
"label.emailsync.status.export":`Eksport jako plik w formacie Excel_csv`,
"label.service.miniProgram.slideshowTitle":`Karuzela`,
"label.service.miniProgram.slideshowName":`Nazwa karuzeli`,
"label.fieldupdate.selectobj":`Zdefiniować obiekt powiązany z aktualizacją pola, a następnie kliknąć Dalej. Aktualizacje pól mogą być kojarzone tylko z regułami przepływu pracy i procesami zatwierdzania tego samego typu.`,
"label.ccpeak.take.notice.sharetab":`Uwaga: pola w wyrażeniu formularza współdzielonego nie wymagają dodania "__c".`,
"label.log.startdate.after.endate":`Godzina rozpoczęcia nie może być późniejsza niż godzina zakończenia.`,
"label.rememberme":`Pamiętaj o mnie`,
"label.partner.all.maxNum":`Największe dane z chmur parterowych:`,
"component.setup.iframe.label.inputurl":`Wpisz adres url`,
"label.h5.systemmessage":`Komunikat systemowy`,
"label.delete.date":`Usuń Data`,
"front-email-payment-select-month-tips":`Proszę wybrać MM`,
"front-kefu-moudle-bind-userinfo":`Powiąż informacje o użytkowniku`,
"label.appointment.wizard.notif2":`您需要在创建日程预约前先设定好一个预约的时长`,
"label.custom.field.maping.number":`Liczba cyfr wiodących nie może być większa niż liczba cyfr mapowanego pola.`,
"label.event.dayview":`Widok dzienny`,
"label.replace":`Wymienić`,
"label.knowledgebase.search.knowledge.articles":`Wyszukaj artykuł wiedzy`,
"component_event_label_soon":`Natychmiast`,
"label.imgfield.upload":`Prześlij obraz`,
"message.printable.view":`Podgląd wydruku`,
"vue_label_notice_uploadavatar_notice1":`Rozmiar wgrywanego obrazka awatara nie może przekraczać 2MB.`,
"label.visualpage.developer.help":`Pomoc dla programistów stron niestandardowych`,
"label.validate.function.funcFormat.IF":`IF(logical_test, wartość_if_true, wartość_if_false)`,
"label.sso.saml.sp.description1":`Ustawienia pojedynczego logowania (Single Sign-On)`,
"vue_label_calendar_step_1":`Krok 1: Nadanie nazwy kalendarzowi`,
"component.telerecord.button.save":`Zapisz`,
"setup_mainpage_button_manageobject":`Zarządzanie obiektami`,
"label.marketingactivityinfluence":`Wpływ na kampanię`,
"label.quote.bjjsxx":`Informacja o przyjęciu oferty`,
"label.appupload.upload.install.retry":`Zainstaluj ponownie stronę`,
"label.layout.assignrules":`Zasady przydziału`,
"UG.Lead.006":`Odwiedzający stronę internetową`,
"label.workmate.searchs":`Wyszukaj współpracowników`,
"label.visualpage_list.no":`Brak uprawnień do dostępu do stron niestandardowych`,
"label.service.miniProgram.slideshowintroduce":`Nazwa karuzeli jest używana tylko do identyfikacji wielu wpisów reklamy i nie jest wyświetlana w reklamie.`,
"label.multilang.messagedetail.search.desc":`Nie możemy znaleźć wiadomości z {0}:`,
"label.mobile.phone.read.note":`Proszę wpisać tutaj uwagi`,
"label.passwordPolicy.setup.isUsingGotp":`Włącz wtórną weryfikację logowania`,
"message.datetypeerror":`<strong>Błąd</strong> Nieprawidłowa data.`,
"label.searchlayout.listview.button":`Przyciski wyświetlane w widokach listy.`,
"label.sectionpart":`Sekcja`,
"label.partnerCloud.basicSetting.userSetting":`Konfiguracja ról i użytkowników`,
"System_Data_Import_Warning_MaxCount":`Twoja organizacja może importować tylko {0} sztuk danych na raz, co jest teraz poza limitem, proszę dostosować i ponownie zaimportować.`,
"label.datamove.qualified.record":`kwalifikowany rekord(y), za każdym razem można przesłać najwyżej 100 rekordów`,
"component_task_label_priority":`Priorytet`,
"vue_label_report_me":`Ja`,
"label.college.duplicate.option":`Opcje nie mogą się powtarzać!`,
"label.pw.letter":`Listy`,
"label.file.sharedwithme":`Podzielona ze mną`,
"label.translation":`Przetłumacz`,
"lable.currencyAdv.exchagecurrency.before":`i przed`,
"label.file.share":`Udostępnij`,
"label.page.next":`Następny`,
"label.autoRegister.changepwd.setpwd.notmatch":`Dwa hasła są niespójne`,
"label.tabpage.include":``,
"front-email-payment-thanks":`Dzięki`,
"vue_label_help_helponthispage":`Pomoc na tej stronie`,
"label.approvepagelayout":`Układ strony zatwierdzania`,
"vue_lightning_help_zero_distance_communication":`Wsparcie online pomoże Ci zaoszczędzić czas, kontaktując się z ekspertami CloudCC z zerowym dystansem.`,
"vue_label_normal_case_sf":`Sprawa`,
"label.report.line.tuozhuai":`Proszę przeciągnąć i upuścić lub kliknąć dwukrotnie, aby wybrać kolumny raportu i dostosować ich kolejność.`,
"template.dashboard.management":`Zarządzanie operacjami`,
"label.customcomponent.params.info.n1":`Wartość "args" znacznika "args" w "component" jest w formacie "json", na przykład: args="name:'zhang',age:26", W bloku kodu cc, użyj: String myName = name; int myAge = age;`,
"lable.SalesCommitmentKanBan.signedCommitmentRate":`Wskaźnik podpisanych zobowiązań`,
"label.add.status":`Dodaj status`,
"label.loss.customers":`Zamknięte / Konto utracone`,
"vue_label_chatter_involving_me":`Zaangażowany`,
"label.update.input":`Proszę poprawić dane wejściowe`,
"label.import.step1.commonobj":`Obiekty ogólne`,
"label.appupload.upload.tips.document":`Uwaga: dokumenty znajdujące się w "moich folderach osobistych" i "szablonach czerwonych folderów" nie mogą być dodane do pakietu, ani wyświetlone na tej liście.`,
"label.appupload.install.complete":`Pełny`,
"label.console.edit":`Konsola Edycja`,
"setup.object.field.dependency.label.removefromlist":`Usuń wybrane wartości`,
"label.textmessage.groupsms.no.phone":`Brak telefonu`,
"label.account.Current.and.NextFQ":`Obecne i następne FQ`,
"label.sso.saml.sp.idtype.userid":`Asercja zawiera identyfikator użytkownika z obiektu Użytkownik`,
"label.data.import.setup.operate.update":`Aktualizuj istniejące rekordy, nie wstawiaj nowych rekordów`,
"front-kefu-moudle-v1-jcaws-call-serve":`Call Center zintegrowane z AWS (Amazon Web Service), aby zapewnić bardziej kompleksowe usługi SaaS`,
"label.version.bacheditordel":`Masowa edycja/usuwanie/przenoszenie`,
"lable.even.higher":`Wyżej`,
"label.datetime.error":`Format daty jest nieprawidłowy`,
"vue_label_commonobjects_detail_customer_hierarchy":`Hierarchia klientów`,
"label.startuploadfile":`Rozpocznij przesyłanie`,
"label.appointment.wizard.subtitle3-1":`Poniedziałek`,
"label.weixin.relevance":`Powiązana możliwość`,
"label.datamanage.field.mapping.information":`Ustawianie mapowania pól`,
"label.brief.lastweek":`W ostatnim tygodniu`,
"label.nextstep":`Następny krok`,
"label.listtoshow":`Poniżej znajduje się lista aktywnych i nieaktywnych procesów zatwierdzania dla {0}.`,
"label.partner.ishave":`Błąd: domena już istnieje`,
"label.service.miniProgram.name":`Proszę wpisać imię i nazwisko.`,
"label.view.filterbyaddition":`Filtruj według dodatkowych pól (opcjonalnie):`,
"label.projectManagement.nodata.task":`Brak zapisów dla zadań. Dodajmy informacje o zadaniach!`,
"label.chooseemailtemplate":`Wybierz szablon wiadomości e-mail`,
"label.page.step4.add.profile":`Krok 4 Dodaj do profili`,
"label.ems.mailtype":`Rodzaj poczty`,
"label.weixin.no.pending.projects.vg":`Dobra robota, brak pozycji oczekujących na zatwierdzenie`,
"label.tabpage.saveviewfailed":`Nie udało się zapisać widoku`,
"label.chat.file.upload.cancel":`Anuluj przesyłanie`,
"com.cloudcc.login.error.message.notenabled":`Twój identyfikator nie jest aktywny`,
"label.data.import.setup.operate.insertandupdate":`Aktualizacja istniejących rekordów i wstawianie nowych rekordów`,
"label_target_type":`Rodzaj celu`,
"label.notification.event2":`【被分配人】 obejrzał przypisane wydarzenie`,
"chatter.feed.menutype.feed.news":`Co śledzę`,
"label.import.page1.suitedwayofcustomer":`Klient dopasowany do stylu`,
"label.import.page2.CloudCCfiled":`Pole CloudCC`,
"label.custom.quarter.start":`Niestandardowa data rozpoczęcia kwartału`,
"label.page.including.tab":`Włącznie z zakładkami`,
"label.mobile.phone.day.plan2":`Dzisiaj`,
"template.report.lead.conversion.statistics":`Statystyki konwersji leadów`,
"label.show.type":`Typ wyświetlacza`,
"label.weixin.no.pending.wdgz.qin.week":`W tym tygodniu nie zaplanowano żadnych prac.`,
"2018UI.Homepage.DataDeleted.Info":`Dane, które chcesz zobaczyć zostały usunięte, kliknij, aby powrócić do poprzedniego kroku.`,
"label.vlidaterule.message":`Komunikat o błędzie`,
"label.approval.remark":`Opinia zatwierdzająca`,
"label.field.duplicate1":`Wyjątkowa`,
"label.batchtransfer":`Przenoszenie masy`,
"label.quickbooks.view.allinvoices":`Wszystkie faktury`,
"vue_label_commonobjects_detail_lead_selectedstatus":`Oznacz jako aktualny status`,
"label_home_page_source":`Proszę wybrać źródło danych.`,
"front-kefu-moudle-v1-opencall-please":`Proszę włączyć call center, a następnie skonfigurować`,
"setup_layout_label_asc":`Wstępna`,
"label.use_tikect":`Skorzystać z biletu wstępu?`,
"label.tag.setup":`Ustawienia znaczników`,
"label.existinglayout":`Istniejący układ strony`,
"label.productsales.today.noevt":`Nie ma otwartych imprez.`,
"message.error.view.date.validerr":`Proszę wprowadzić poprawny format daty (RRRR-MM-DD、MM/DD/YYYY) lub specjalne znaki daty.`,
"label.mr.descreption.oneGroupReData3":`ma do czynienia z`,
"label.tianyancha.businessverify.msg1":`Po włączeniu funkcji weryfikacji danych komercyjnych, użytkownicy powinni uważnie przeczytać i w pełni zrozumieć warunki niniejszej "umowy licencyjnej użytkownika" (zwanej dalej "umową"), w tym zwolnienie z odpowiedzialności firmy beijing shenzhou yundong customer co., ltd. (zwanej dalej "CloudCC") oraz ograniczenia praw użytkownika. prosimy o dokładne zapoznanie się z treścią umowy i podjęcie decyzji o akceptacji lub odrzuceniu jej.`,
"label.custom.CQ":`Custom Quarter`,
"label.version.custom.dashboard":`Dashboardy standardowe (strona niestandardowa)`,
"vue_label_commonobjects_detail_dragtoupload":`Przeciągnij tutaj swój plik lub <em>kliknij i prześlij</em>.`,
"label.tabpage.addadvancedoptions":`Dodaj opcje zaawansowane`,
"front-kefu-moudle-v1-Launch-page":`Landing Page:`,
"label.emailobject.tabname":`E-mail`,
"label.weixin.addmore":`Dodaj więcej`,
"message.error.view.operator.validerr":`Nieprawidłowy operator`,
"label.another_page":`Przekieruj na inną stronę`,
"label.reportTypeFocusD2":`Przykład: W przypadku raportowania na temat "Kontaktów z szansami z partnerami", wybierz "Kontakty" jako obiekt główny.`,
"label.icon.47":`Barometr`,
"label.task.today":`Dzisiaj`,
"label.service.gantt.weekend.highlight":`Podkreślenie weekendu`,
"label.customcomponent.referencetagname":`Zakładka Nazwa`,
"label.senderemail":`Adres e-mail nadawcy`,
"label.defaultvalue":`Wartość domyślna`,
"label_tabpage_Sdfez":`dni`,
"pagecreator.page.label.pagename":`Nazwa strony`,
"vue_label_report_pagenumber":`Numer strony w zakresie`,
"label.emailsync.connectaccount.description":`Dodaj tutaj swoją osobistą skrzynkę pocztową, a CloudCC będzie automatycznie dopasowywać leady i kontakty w systemie na podstawie ich adresów e-mail, synchronizować treść wiadomości e-mail z rekordami, aby ułatwić śledzenie i komunikację.`,
"label.schedulableprg.chooseweek":`Proszę wybrać datę każdego tygodnia`,
"lable.edit.queue.membercanuse":`Dostępni członkowie`,
"lable.Quick.find":`Szybkie spojrzenie`,
"label.daynuminmonth":`Dzień(y) Miesiąca(ów)`,
"message.error.state":`stan nie może być pusty!`,
"label.introduction.the.form":`Opis`,
"label.batchtransfer.pleaseselectcomefromuser":`Przeniesienie Z`,
"front-dashboard-module-implemented":`Zrealizowane`,
"label.custombutton.newerror":`Nowy utworzony nie powiódł się`,
"label.version.allow.size":`Jeśli to konieczne, proszę zaktualizować wersję CloudCC.`,
"label.weixin.account.loginpage":`Strona logowania bezpieczeństwa konta`,
"message.pleaseselectfieldtype":`Proszę wybrać typ pola`,
"component.setup.label.parentobject":`Obiekt nadrzędny`,
"System.TAB.SeeViewAmount":`Wyświetl sumy`,
"label.event.lastmonth":`Ostatni miesiąc`,
"label.taskrecordtype":`Rodzaje zapisów zadań`,
"label.layout.selectedpages":`Wybrane strony`,
"label.appointmentdetail.wizard.title19":`Plan na sobotę`,
"label_chatter_endData":`Data końcowa`,
"label.appupload":`Pakiety`,
"label.knowledgebase.article.link":`Artykuł powiązany`,
"label.licence.enddate":`Data wygaśnięcia`,
"chatter.fieldtrack.record":`zapis`,
"label.reportsSubscriptionPage.schedulereport.weekly":`Tygodnik`,
"label.forecast.editshrepage.title2":`Udostępnianie Edycja`,
"label.attendance.onwork.time":`Początek dnia`,
"label.appointment.wizard.subtitle1-8":`3 h`,
"pagecreator.layout.button.upload":`Prześlij układ`,
"label.input.notless.than.number":`Proszę wpisać liczbę większą lub równą {0}.`,
"setup.mainpage.label.welcome13":`Instrukcje: Kliknij menu górne → Raporty → Nowy.`,
"label.forecast.settings.data.opp":`Data zamknięcia możliwości`,
"vue_label_display_checkbox_field":`Pokaż pola Checkbox`,
"label.summaryreport.2018.step5":`Krok 5 Wybierz typ wykresu i element podświetlenia`,
"front-lightning-module-v1-dashborad-one-statistic":`Proszę wybrać co najmniej jedną wartość statystyczną i typ statystyki`,
"label.home.standard.dashboard.forcase":`Nie masz uprawnień do prognozowania i nie możesz wyświetlić pulpitu nawigacyjnego zobowiązań sprzedaży.`,
"page.field.track":`Historia śledzenia w terenie`,
"label.dataimport.format.datetime.error":`Błąd formatu, proszę użyć yyyy/MM/dd HH:mm:ss lub yyyy-MM-dd HH:mm:ss.`,
"lable.opppdt.selPbk.title":`Wybierz cenę Książka`,
"pagecreator_systemstyle_label_stylename":`Nazwa stylu`,
"label.projectManagement.nodata.project":`Brak powiązanych danych. Dlaczego nie stworzyć projektów związanych z moją osobą?`,
"label.start_below":`Zacznij udostępniać swój formularz kontaktom. Twój formularz został bezpiecznie opublikowany i jest gotowy do użycia pod adresem internetowym podanym poniżej.`,
"label.campaignmember.main.delete":`Masowe usuwanie uczestników kampanii`,
"label.modifyall":`Modyfikuj wszystko`,
"label.homepage":`Strona główna`,
"vue_label_pool_adoptedbyme":`Zebrałem`,
"label.email.clearItem":`Tylko wiadomości e-mail bez powiązanych elementów są usuwane.`,
"label.callcenter.login.Amazon.connect":`Zaloguj się do Amazon Connect`,
"label.import.page1.selectimportfiled":`Wybierz plik do zaimportowania`,
"message.error.id":`id nie może być puste!`,
"label.ggReleaseRange.searchUsers":`Wyszukaj użytkownika partnerskiego`,
"label.changemypwd":`Zmień moje hasło`,
"label.ccpeak.reference.parameters":`Parametry, do których można się bezpośrednio odwoływać to:`,
"chatter.share.success.tip":`Sukces! udostępniłeś ten post`,
"label.message.checkfailed":`Nie powiodło się sprawdzanie składni, nazwa klasy istnieje.`,
"label.shangqing.introduction":`Integracja i analiza ostatnich gorących wydarzeń dotyczących leadów lub klientów, aby pomóc sprzedawcom lepiej zrozumieć klientów.`,
"label.allemailnotice":`Wszystkie alerty e-mail`,
"vue_label_report_copy":`Kopia sprawozdania`,
"label.exchange.sync.state.setting":`Ustawienia konfiguracyjne`,
"label.merge.result.error1":`Następujący rekord jest zablokowany i nie jest dozwolona żadna operacja "scalania"`,
"label.process.des":`Kliknij lewy link, aby wyświetlić szczegóły bieżącego rekordu.`,
"label.textmessage.vonage.create.lead.setting":`Tworzenie nowych leadów po otrzymaniu wiadomości tekstowych od numerów, których nie ma w systemie`,
"label.views":`Widoki`,
"label.notification.tip1":`Brak powiadomień`,
"label.forecast.detailforecast.returnforecast":`Powrót do prognoz`,
"label.knowledgebase.target.framework.name":`Nazwa ramki docelowej`,
"label.brief.close.opportunities":`Closed-Win`,
"label.appointment.wizard.subtitle4-2":`Najkrótszy czas, aby cię zauważyć`,
"vue_label_systemSettings_set_record":`Ustaw tryb wysyłki listy powiązanej, próbując przełączać się między trybem karty i trybem listy.`,
"pagecreator_page_message_publish_fail":`Publikacja strony nie powiodła się`,
"vue_label_homepage_name":`Nazwa strony głównej`,
"label.weixin.no.pending.wdgz.qin.month":`Nie masz zaplanowanych zajęć w tym tygodniu.`,
"label.campagin.register.page":`Strona rejestracji członków kampanii`,
"label.campaign.channel.edit":`Kampanie Edycja kanału marketingowego`,
"label.folder":`Folder`,
"label.umeng.chatter.follow":`poszedł za tobą.`,
"label.sso.theKeyToEdit":`Edycja klucza`,
"label.deletelayout":`Usuń układy stron`,
"label.same.analyze.miaoshu":`Związek pomiędzy powyższymi warunkami jest następujący: "Nazwa Okazji" lub "Nazwa Konta" lub ("Kontaktowy Telefon Komórkowy" i "Kontaktowy Email");`,
"label.ccpeak.sel":`Klasy w tym folderze`,
"label.tabpage.addtoworkbench":`Dodaj do strony głównej stół warsztatowy`,
"label.forecast.shrepage.classdes.r":`Tylko do odczytu - Użytkownik może odczytywać dane prognozy.`,
"homepage.custompagename":`Własna nazwa strony głównej`,
"label.sendemail.batchapprovalinfo":`Witaj #name:Operacja zatwierdzania partii, którą wykonałeś zakończyła się sukcesem, z całkowitą liczbą #successnum pomyślnie zatwierdzonych i #errornum nieudanych.`,
"front-email-payment-Invoice-alipay-describe":`Bezpieczne i niezawodne płatności`,
"setup.object.field.dependency.label.configured":`Układy stron przypisane do profilu`,
"label.potentialcustomers":`Leads`,
"label.timetrigger.button":`Przycisk Dodaj wyzwalacz czasowy nie jest dostępny w następujących przypadkach:`,
"label.category.10":`Prawnik`,
"label.selectall":`Wybierz wszystko`,
"message.field.id.not.null":`Pole ID nie może być puste.`,
"CloudCCCRM.ST.Info.TypeIn.001":`Proszę wpisać`,
"label.author":`Autor`,
"label.import.step1.csvonly":`1. Obsługiwany jest tylko plik w formacie csv, a jednorazowo można zaimportować do {recordnumlimit} rekordów. Jednorazowo można zaimportować do 2,000 rekordów, jeśli wymagane jest wykonanie trigera. Rekordy, które przekroczą limit będą automatycznie ignorowane przez system. Jeśli chcesz zaimportować więcej danych, podziel je najpierw na wiele plików i zaimportuj je w różnym czasie. .`,
"label.assignment.setup.newrule.name":`Nazwa zasady`,
"label.campaignmember.selectmember.chosestatusdesc":`Wybierz kampanię, do której chcesz dodać członków i edytuj Status Członka Kampanii. Aby utworzyć nową kampanię, musisz zakończyć ten proces.`,
"label_tabpage_operation":`Operacja`,
"label_tabpage_datatyoez":`Typ danych`,
"UG_product_04":`Tworzenie produktu`,
"label_emailtocloudcc_step1_case2":`Po skonfigurowaniu, wiadomości otrzymane na tę skrzynkę będą automatycznie rejestrowane jako rekordy spraw w CloudCC. Zgodnie z kontaktem i kontem skrzynki nadawczej, należy powiązać sprawę z odpowiadającym jej kontaktem i kontem, aby ułatwić przyjmowanie i śledzenie spraw.`,
"workflow.action.tasks.assignortype.role":`Rola`,
"vue_label_notice_refreshi_success":`Odśwież pomyślnie`,
"label.notification.arketsea.abandon":`{5} odrzucone {2} {0}：{1}`,
"label.icon.36":`Komputer`,
"chatter.group.cancelToJoin":`Anuluj, aby dołączyć`,
"label.publicgroups.edit":`Edytuj grupę publiczną`,
"message.duplication.label.letternum":`Pasujące bity znaków`,
"label.brief.lost.opportunities":`Zagubiona`,
"setup.layout.label.nofield":`Brak dostępnych pól`,
"label.dataimport.isSharingRule":`Egzekwuj zasady udostępniania`,
"vue_label_opportunity_contactrole_synctocontacts":`Synchronizacja informacji z kontaktami`,
"attachment_button_massdownload":`Masowe pobieranie`,
"label.weixin.agreement.remark":`Usługa WeChat jest narzędziem wspomagającym usługi konsultingowe Aid-Max dla klientów, nie jest ostateczną podstawą dla firm ubezpieczeniowych do rozstrzygania roszczeń, a roszczenia klientów powinny być rozstrzygane zgodnie z wymogami akturalnymi firm ubezpieczeniowych.`,
"label.partnerCloud.basicSetting.introTwo":``,
"pagecreator_layout_funcpath":`/ konstruktor / biblioteka układów`,
"label.ccdocument.online.edit":`Dokument Online Edycja`,
"label.partner.setup.Enable":`Zweryfikuj`,
"label.log.state":`Status działania`,
"label.lower.bound":`Dolna granica`,
"label.timezone.isenable":`Włącz użytkownika wielu strefach czasowych, a następnie pozwolić użytkownikowi ustawić strefę czasową, i wyświetlić datę / czas przez użytkownika strefy czasowej.`,
"label.martrixreport.setrowtitle":`Określanie nagłówków kolumn`,
"label.bottom":`Na dole`,
"label.multilang.ccchat.groupnotcontainsname":`Nie jesteś członkiem żadnej grupy kampanii, która ma {0} w swojej nazwie`,
"label.step1.of.step5":`Krok 1 z 5`,
"message.report.error.FieldListIsAmbiguous":`W raporcie znajduje się formuła złożona, która powoduje wyjątek, proszę usunąć złożoną:&nbsp;`,
"label.monitorsys.operator.ip":`IP`,
"ccchat.fieldtrack.fieldchange":`Zmiana z {0} na {1}.`,
"label.report.export.print.content":`Eksport bieżących nagłówków raportów, grup i pierwszych 2000 rekordów`,
"message.thanksusing":`Dziękujemy za korzystanie z CloudCC.com`,
"label.reportexport.allobject":`Eksportuj wszystkie obiekty`,
"label.projectManagement.working.hours.per.day":`Dzienne godziny pracy`,
"label.partnerCloud.financeSetting.enterCollaborator":`Proszę wpisać identyfikator współpracownika`,
"label.defineReportRecords":`Określanie zestawu rekordów raportu`,
"greate":`większy niż`,
"label.sure_discard":`Czy na pewno rezygnujesz z tych zmian?`,
"label.escalation.setup.newaction.notifyowner":`Powiadomić właściciela sprawy`,
"label.icon.28":`Kapelusz lekarza`,
"lable.PowerProcess.see.page":`Zobacz kamienie milowe`,
"message.error.object.relogin":`Logowanie nie powiodło się, proszę spróbować zalogować się ponownie`,
"label.chatter.activity":`Działania`,
"label.query.clone.detail.choose.canChoose":`Dostępne pozycje linii`,
"chatter.using.object":`Włącz śledzenie obiektów, aby użytkownicy mogli śledzić rekordy danego typu obiektu. Wybierz pola do śledzenia, aby użytkownicy widzieli aktualizacje kanału, gdy te pola zostaną zmienione w rekordach, które śledzą.`,
"UG.opportunity.001":`Jak monitorujesz swoją sprzedaż?`,
"label.ServiceCloud.fuwuziyuan.distributionMap":`Mapa rozmieszczenia zasobów usługowych`,
"vue_label_email_current_email":`Wstawienie tego szablonu spowoduje nadpisanie aktualnej wiadomości e-mail`,
"label.h5.approval.page.layout":`Możesz ustawić układ strony zatwierdzania: <br>Ustawienia>Tworzenie>Przepływ pracy i zatwierdzanie>Procesy zatwierdzania<br>wybierz proces zatwierdzania, kliknij nazwę zatwierdzenia<br>kliknij Edytuj>ustaw układ strony zatwierdzania`,
"component.hots.label.title":`Gorące okazje`,
"mail.foldername.notOnly":`Ten plik już istnieje`,
"label.customer.tab.step1":`Krok 1 Wprowadź szczegóły`,
"label.delete.persion":`Usunięty przez`,
"chatter.changed0":`Zmień {0} z {1} na {2}.`,
"homepage.components.type":`Typ komponentu`,
"label.norfolk.isiands.time":`Czas Norfolk`,
"label.product.pricebooks.view":`Widoki z książki cenowej`,
"label.forecast.customforecast.director":`Bezpośredni podwładni`,
"label.emailtocloudcc.step3total3":`Krok 3 z 3`,
"label.cloudccsite.end":`Strona główna nieaktywnej witryny`,
"label.login.verification.mfa.device":`Weryfikacja wirtualnego urządzenia MFA`,
"chatter.follow":`Śledź`,
"label.month's":`Miesiąc`,
"label.sendmail.step1.introduce":`Wybierz widok poniżej, który zawiera odbiorców, którzy mają być uwzględnieni w tej wiadomości e-mail.`,
"label.shangqing.title":`Ustalanie informacji handlowych`,
"label.rejectrecords":`Odrzucone rekordy`,
"label.selectupdatevalue":`Wartość Zmieniająca się od`,
"vue_label_pricebook_disabled":`Cennik jest wyłączony`,
"component.chatter.label.title":`Najnowszy wpis`,
"label.partner.all.workspace":`Miejsce pracy`,
"label.querydetailservice.delete.message":`Dane usunięte lub nieistniejące.`,
"label.objectRelationshipWithout":`z lub bez powiązanych zapisów`,
"nocontain":`nie zawiera`,
"label.partnerCloud.financeSetting.accountSettings":`Konfiguracja funduszu partnerskiego`,
"label.file.sharetype.owner":`Właściciel`,
"label.open.multilingual":`Włącz obsługę wielu języków`,
"label.searchresult.field":`Pola wyników wyszukiwania`,
"label.tabpage.selectdate":`Wybierz datę`,
"label.h5.logouting":`Wyloguj się`,
"label.quickbooks.fieldlabel.payment":`Płatność`,
"label.chatter.leaveword":`Komentarz`,
"label.customfields.majoranddetailrelation.tip":`Utworzenie specjalnej relacji rodzic-dziecko pomiędzy tym obiektem (dzieckiem lub szczegółami) a innym obiektem (rodzicem lub głównym), gdzie: <br>● pola relacji dla wszystkich rekordów szczegółów muszą być wypełnione. <Gdy wartość pola relacyjnego zostanie zapisana, nie można jej zmienić. </li><br>● własność i udostępnianie rekordu szczegółowego jest określona przez rekord nadrzędny. </li><br>● gdy użytkownik usuwa rekord główny, wszystkie szczegóły są usuwane. </li><br>● na rekordzie głównym można utworzyć pola podsumowania zbiorczego, aby podsumować rekordy szczegółowe. </li><br>Pole relacji pozwala użytkownikowi kliknąć ikonę znajdź, aby wybrać wartość z listy podręcznej. Obiekt główny jest źródłem wartości na liście. "`,
"label.batchapproveorrefuse":`Masa Zatwierdź/Odrzuć`,
"label.copy.success":`Kopiuj z powodzeniem`,
"vue_label_show_record_count":`Pokaż liczbę zapisów`,
"label.ems.delete.false":`Nie udało się usunąć`,
"label.new.Product.Goals":`Cel nowego produktu`,
"label_chatter_BCC":`Bcc (blind courtesy copy)`,
"label.knowledgebase.data.archived.successfully":`{Archiwizacja danych zakończona sukcesem`,
"label.chuangming.title":`Chuang Ming SMS`,
"label.notification.arketsea.recovery":`Twoje {0}:{1} zostało przetworzone na {2} przez {5}.`,
"label.partnerCloud.orderingPlatform.paymentAmount":`Kwota płatności:`,
"label.martrixreport.2018.step5.new":`Krok 5 Wybór kryteriów raportowania`,
"label.testing":`Sprawdzanie...`,
"chatter.poll.option4":`Wybór 4`,
"lable.outlook.detail.otc":`Wymiana do CloudCC.com`,
"label.startuploadfile.batch.step2":`Krok 2 Kliknij przycisk "rozpocznij przesyłanie", prześlij pliki`,
"lable.outlook.edit.outdes":`Wprowadź pola własne, które zostały już utworzone w programie Exchange. Przed mapowaniem niestandardowego pola Exchange na pole CloudCC.com, CloudCC.com zweryfikuje istnienie pola Exchange podczas pierwszej synchronizacji.`,
"hour":`Godzina`,
"label.appointmentpage.wizard.notif4":`Nieprawidłowy format wiadomości e-mail`,
"label.import.index.state":`Status`,
"label.integrations.mailchimp.massage6":`Wybrane dane widoczne na bieżącej stronie będą mogły zostać wyeksportowane do Twojej listy Mailchimp.`,
"label.file.share.email.subject":`#sharedBy podzielił się z Tobą plikiem na #orgname`,
"label.assignment.setup.newentries.noassignment":`Nie przydzielać ponownie właściciela`,
"label.dashboard.unit1":`Jednostka: 10,000`,
"label.forecast.customforecast.foretype.commit":`Zaangażowany`,
"label.type":`Typ`,
"label.partner.workspace.login.logo":`Logo nagłówka`,
"pagecreator_systemstyle_button_edit":`Styl edycji`,
"label.displaytype2":`Przycisk strony szczegółowej`,
"email.one":`Drogi użytkowniku: \Witamy w CloudCC. Zażądałeś zresetowania hasła w {!operatetime}, proszę zaloguj się przy użyciu poniższego kodu weryfikacyjnego w ciągu 15 minut: \n Losowy kod weryfikacyjny: {!authcode} Kliknij poniższe łącze, aby zresetować swoje hasło: \n{!URL}/authcodecheck.jsp?username={!username}&lang={!lang} \n Ważne: Jeśli nie prosiłeś o to lub uważasz, że ta wiadomość nie powinna do Ciebie dotrzeć, skontaktuj się natychmiast ze swoim administratorem!`,
"label.partnerCloud.orderingPlatform.unavailable":`Brak dostępnych produktów`,
"vue_label_email_save_the_signature_successfully":`Zapisz podpis z powodzeniem`,
"label.reportsSubscriptionPage.email.detailed":`Szczegółowy`,
"chatter.group.query":`Zapytanie`,
"label.translation.unsupported.format":`Nieobsługiwany format, obsługa importu w wielu językach Tylko format właściwości`,
"message.operateexception":`Prompt(Please Contact Your Administrator).`,
"label.sendemail.chat.praiseFeedcomment":`Drogi #name:pozdrawiam! #userName polubił Twój komentarz (#href).`,
"label.recycle.clearmy":`Opróżnij kosz na śmieci`,
"label_tabpage_choose":`Wybierz`,
"#label.importstep2tip":`Jeśli chcesz przesłać więcej niż jeden plik, możesz skompresować wszystkie pliki razem i zaimportować je.`,
"label.batchedit":`Mas Edytuj`,
"label.integrations.mailchimp.export":`Eksport do Mailchimp`,
"label.cloudccsite.name":`Nazwa terenu`,
"serviceterritory.serviceappointment.iscontain.contain":`Nie można usunąć obszaru serwisowego, ponieważ jest on powiązany z umówionym terminem serwisowym. Można wyłączyć ten obszar usług.`,
"label.sum":`Suma`,
"setup.mainpage.label.welcome29":`Standardowa integracja API z produktami innych firm`,
"label.tabpage.nothingz":`Nic`,
"label.weixin.actual.contract.jine":`Rzeczywista kwota umowy`,
"label.tabpage.emailaddressz":`Od? Adres`,
"label.dashboard.unit4":`Jednostka: 10 milionów`,
"label.dashboard.data.labels":`Etykiety danych`,
"label.import.page2.oneonone":`Jedno pole CloudCC może odpowiadać tylko polom w jednym pliku.`,
"homepage.components.name":`Nazwa komponentów`,
"template.report.task.theme":`Zadanie Przedmiot`,
"component.setup.label.setupsaveok":`Ustawienia komponentu zostały zapisane pomyślnie`,
"front-epwechat-module-v1-add-selfapp":`Dodaj aplikację stworzoną przez Sefl`,
"label.to.save.the.current.page.information.button.":`Jeśli chcesz zapisać informacje z bieżącej strony, kliknij przycisk "Szybki zapis".`,
"vue_label_file_not_support_preview":`Plik nie obsługuje podglądu, proszę pobrać i obejrzeć`,
"label.object.reached.limit":`Liczba obiektów, które można utworzyć, osiąga górny limit.`,
"label.partnerCloud.basicSetting.online":`Aktywuj płatność online`,
"label.app.step1.error.nameexist":`Ta nazwa grupy już istnieje lub była wcześniej używana. Proszę wybrać inną nazwę.`,
"label.workflowandapprove":`Przepływ pracy i zatwierdzenia`,
"label.recordtypeselect.change.tip":`Gdy zmieniamy typ rekordu, istniejące wartości pikiet nie zmieniają się automatycznie. Zalecane jest, aby zaktualizować istniejące wartości listy pickupów w tym samym miejscu.`,
"label.summaryreport.step6":`Krok 6 Wybór kryteriów raportowania`,
"Pagelayout.Setup.004":`Można ustawić do 4 pól`,
"label.file.attached":`Załączona`,
"front-invoice-online-payment-setup-configure":`Kliknij "Configure Now", Configure {name} Payment Interface.`,
"label.approvaldatamove.submitdate":`Data przedłożenia`,
"label.emailobject.time.from":`Od:`,
"label.dataimport.insertdata.error.fieldrepeat.insert":`Pole $schemefield_name$ w rekordzie już istnieje w bazie danych i nie jest już wstawiane. Import rekordu został zignorowany.`,
"assetbom.copy.notpermission":`Nie masz uprawnień do klonowania BOM-u aktywów. Proszę skontaktować się z administratorem.`,
"lable.outlook.mcto.autoallocation":`Przypisz je automatycznie do powiązanych rekordów CloudCC.com.`,
"label.dataimport.but.datalength":`ale długość danych wynosi`,
"label.setuserstocommit":`Korzystając z poniższych opcji, określ, którzy użytkownicy mogą przesyłać wstępny wniosek do zatwierdzenia.`,
"component_telerecord_label_related":`Powiązane pozycje`,
"front-lighting-module-v1-detail-file-lockInfo":`Rekord jest zablokowany i nie ma możliwości dodawania plików. Prosimy o kontakt z administratorem w celu odblokowania.`,
"pagecreator_layout_button_edit":`Edytuj układ`,
"label.app.step3.tabcanuse":`Dostępne zakładki`,
"label.ems.delete.sure":`Czy na pewno chcesz usunąć informacje o tym koncie e-mail?`,
"label.email.show":`Pokaż`,
"label.checkbox.unchecked":`Niewybrane`,
"message.error.operation":`Błąd w działaniu, proszę skontaktować się z administratorem.`,
"label.template.set.folder.only.upload.type.file":`Zaznaczone na czerwono foldery w szablonie mogą być używane tylko do wgrywania plików typu Word, Excel i PPT.`,
"label.knowledgebase.select.publish.status":`Proszę wybrać status publikacji`,
"label.recordtype.tabname.edit":`Wprowadź nową nazwę dla wybranego typu rekordu, a następnie kliknij "Zapisz".`,
"label.tabpage.exportview":`Widok eksportu`,
"label.dataimport.insert.sharetab":`Nie udało się wstawić formularza udostępniania`,
"vue_label_dashboard_penetrateto":`przenikać do`,
"label.weixin.group.member":`Personel`,
"vue_label_systemSettings_customadd":`Rozszerzenie niestandardowe`,
"UG_Account_03":`Proaktywne sprawdzanie i łączenie zduplikowanych kont`,
"label.singapore.standard.time":`Czas standardowy Singapuru`,
"label.weixin.captcha":`Kod weryfikacyjny`,
"Account_News_Setting_004":`Włączanie nowości`,
"label_emailtocloudcc_select1":`Proszę wybrać`,
"label_ring_ratio":`Miesiąc po miesiącu`,
"label.industrialandcommercialverification.button.save":`Zapisz`,
"label.approvalstep5.tip":`Strona zatwierdzania jest miejscem, w którym osoba zatwierdzająca faktycznie zatwierdza lub odrzuca wniosek. Użyj następujących opcji, aby wybrać właściwości edycji pól, które mają być wyświetlane na tej stronie.`,
"label.import.page1.maxrecord{{30000}}":`1. Możesz zaimportować {{30000}} rekordów jednorazowo`,
"setup_object_layout_label_profileoptions":`Dostępne profile`,
"label.emailtemplate.type":`Typ szablonu`,
"label.searchlayout.tab.field":`Pola wyświetlane na stronie głównej zakładki.`,
"chatter.news":`Wiadomości`,
"label.pw.small.letter":`Małe litery`,
"label.notification.group3":`Twoje podanie o przyjęcie do grupy publicznej zostało odrzucone`,
"label.ccchat.day.before.yesterday":`Przedwczoraj`,
"component.chatter.post.label.title":`Opublikuj`,
"label.tianyancha.type":`Rodzaj przedstawiciela prawnego`,
"label.detail.searchlayout":`Wyświetlanie układu wyszukiwania`,
"vue_label_pool_deleteconfirm":`Czy na pewno chcesz usunąć wybrany (1) rekord(y)?`,
"label.import.index.maxmb{{100}}，maxitem{{30000}}":`1. Obsługuje tylko pliki w formacie csv, maksymalne wsparcie to {{100}}mb, a maksymalnie {{30000}} rekordów może być importowanych jednorazowo; proszę podzielić na wiele plików i importować je etapami, jeśli limit zostanie przekroczony,`,
"label.h5.similar.opportunity.lookup":`Znajdź podobne możliwości`,
"template.report.customer.list.opportunity":`Lista kont z większymi możliwościami`,
"component_setup_iframe_label_memo":`Kliknij ikonę ustawień i wprowadź adres osadzonego adresu url.`,
"label.version.allemail":`Mass Email`,
"lable.product.editp":`Edycja ceny`,
"label.weixin.plate.number":`Numer tablicy rejestracyjnej`,
"font-evaluate-module-v1-disabled-successfully":`Pomyślnie wyłączona opcja oceny "Neutralny"`,
"label.multilingual.tip1":`Użyj tej strony, aby zdefiniować język Twojej organizacji.`,
"label.japan.standard.time":`Czas standardowy Japonii`,
"lable.product.notdel.use":`Usuń próby, ponieważ jest nadal związane z następujących rekordów.W tym przypadku, zaleca się, aby wyłączyć.`,
"label.appointment.wizard.subtitle4-2-4":`4 h`,
"label.queue.edit":`Edytuj`,
"label.partnerCloud.financeSetting.informationTwo":`2. W Merchant Center, kliknij Account Management  Merchant Management  Product PIDIKEY  Secret Key Management.`,
"label.partnerCloud.partnerOrdering.permission":`Zezwolenie na zamawianie przez partnera`,
"vue_label_commonobjects_detail_company_hierarchy":`Hierarchia firmy`,
"label.forecast.settings.sl":`Ilość`,
"label.partner.workspace.tab.memo":`Wybierz zakładki dla tej chmury partnerskiej. można wybrać zakładki standardowe lub niestandardowe.`,
"label.mr.mainRecord":`Zapis główny`,
"setup_mainpage_label_welcome20":`Poczta, szablon SMS`,
"front-email-payment-select-date-tips":`Proszę wybrać YY`,
"label.dependencelisttag":`Lista powiązana Etykieta`,
"label.umeng.activity.eventof":`zdarzenie z`,
"label.sales.dashboard.collection":`Wpływy Cel`,
"report_label_folder":`Foldery`,
"label.assignment.setup.newentries.step1":`Krok 1 Ustaw kolejność, w jakiej będą przetwarzane wpisy tej reguły`,
"label.quote.shrname":`Nazwa odbiorcy`,
"label.newreport.group.sum":`Liczba grupowań`,
"label.number.MinCheck":`Minimalna wartość {a} wynosi {0}. Proszę zmodyfikować ilość i zapisać zmiany.`,
"label.chatter.save":`Zapisz`,
"vue_label_email_all_email_templates":`Wszystkie szablony wiadomości e-mail`,
"message.summaryconditionnototal":`Warunek Podsumowane warunki nie mogą korzystać z pól Roll-Up.`,
"label.callboard":`Ogłoszenia`,
"label.step2.total5":`Krok 2 z 5`,
"vue_label_homepage_custom_homepage_page":`Własna strona główna`,
"label.data.newtemplate.e_seltype":`Wybierz metodę eksportu danych`,
"label.data.dataexpalltype.all.desc2":`2、Trzeba trochę czasu, aby wyeksportować wszystkie dane. Po zakończeniu eksportu otrzymasz e-mail z przypomnieniem, że eksport danych zakończył się sukcesem.`,
"lable.account.CalenderYear":`Rok kalendarzowy`,
"message.error.data":`Przekazane dane nie mogą być puste, proszę sprawdzić przekazane parametry`,
"label.from_user":`Od użytkownika`,
"label.parentdepartment":`Wydział nadrzędny`,
"template.dashboard.product.analysis":`Analiza produktów`,
"label.tabpage.unpacketz":`Brak danych dotyczących grupowania!`,
"label.icon.107":`Komunikacja`,
"label.monitorsys.operator.username":`Użytkownicy`,
"label.serchreport":`Raporty wyszukiwania`,
"label.payment.upgrade":`Aktualizacja`,
"setup_layout_button_ok":`Potwierdź`,
"label.please.select.channel":`Proszę wybrać opiekuna kanału.`,
"template.chart.txdrw":`Przypomnienie o zadaniu`,
"chatter.group.accept":`Przyjmij`,
"pagecreator_systemstyle_message_canntdelete":`Bieżący styl nie może być usunięty`,
"label_tabpage_ctbtsftcz":`Kliknij przycisk wstecz, aby wyszukać zawartość`,
"label.datamanage.select.accountfield":`(Wybierz pola odpowiadające importowanemu rachunkowi)`,
"label.schedulejob.setup.list.title":`Zaplanowane zadania`,
"label.visualpage_list.title":`Aktywny dostęp do strony niestandardowej`,
"label.mr.selectTwoData":`Proszę wybrać co najmniej dwa rekordy, które mają zostać połączone.`,
"label.customer.tab.step2.different":`Zastosuj inną widoczność kart dla każdego profilu`,
"label.mobile.side.tab.can":`Dostępny`,
"label.log.url":`URI`,
"label.weixin.cloudccnumber.isgoon":`Konto CloudCC zostało powiązane, jeśli będziesz kontynuować, WeChat, który wcześniej był powiązany z tym kontem CloudCC nie będzie mógł korzystać z systemu micro CloudCC. Czy chcesz kontynuować?`,
"label.applet.to.case":`Portal obsługi klienta miniprogramu`,
"lable.outlook.detail.cmaping":`Mapa Pola kontaktowe`,
"label.theUserActiveTime":`Okres aktywności użytkownika`,
"label.event.moveup.9hour":`9 godzin naprzód`,
"vue_label_pool_other":`inne`,
"label.fieldname":`Nazwa pola`,
"vue_label_notice_add_success":`Dodano pomyślnie`,
"label.conditiontag.lookup.insertbutton":`Wstaw wybrany`,
"label.identifying":`Identyfikacja`,
"label.tabpage.uploadingz":`Przesyłanie`,
"label.view.introduce":`Edytuj widok`,
"vue_label_dashboard_sortingmethod":`Proszę wybrać sposób sortowania`,
"label.quote.number.introduce":`Wprowadź liczbę rabatów i zniżek, a następnie kliknij przycisk Zapisz.`,
"front-kefu-moudle-which-missphone-case":`Tworzenie spraw, dla których połączenia zostały nieodebrane`,
"label.sendemail.chat.response":`Odpowiedź CCChat:`,
"label.productsales.refreshTime":`Ostatnia aktualizacja`,
"lable.SalesCommitmentKanBan.phase":`Scena`,
"label.version.sum.object":`obiekt(y)`,
"label.defineReportStep2":`Krok 2`,
"message.duplication.label.returnDuplications":`Powrót do listy filtrów duplikatów`,
"label.lookover":`Zobacz`,
"label.quickbooks.button.copy2":`Kopiowanie danych z CloudCC do QuickBooks`,
"label.checkbox.true":`Tak`,
"label.profilename":`Nazwa profilu`,
"label.finalapproveoperate":`Czynności związane z ostatecznym zatwierdzeniem`,
"label.SMS.detailed":`Alerty SMS są wysyłane na podstawie reguł przepływu pracy, gdy zostały one uruchomione.`,
"label.lasttimemodifier":`Ostatnio zmodyfikowane przez`,
"label.sso.summary":`Streszczenie`,
"label.customfields.encd.tip":`Umożliwia użytkownikom wprowadzanie dowolnej kombinacji liter i cyfr oraz przechowywanie ich w postaci czystego tekstu, który może być zaszyfrowany i przeszukiwany.`,
"vue_label_report_formulacolumn":`Kolumna formuły na poziomie wiersza`,
"vue_label_systemSettings_transfer":`Rekordy transferu partii`,
"lable.product.ecm":`Proszę wpisać prawidłową kwotę.`,
"label.partner.setup":`Ustawienia chmury partnerskiej`,
"label.same.analyze.miaoshu2":`funkcja`,
"label.mobile.phone.day.summary":`Podsumowanie dnia`,
"label.ccchat.person.error.illdomain":`Błąd: niepoprawnie wypełniony format domeny`,
"label.knowledgebase.edit.as.draft":`Edytuj jako szkic`,
"message.duplication.label.newfilterule":`Nowa reguła duplikatów i dopasowania`,
"vue_label_salesfunnel_notice1":`Podsumowanie możliwości`,
"label.partnerCloud.partnerAccount.order":`Nr zamówienia :`,
"label.account.Current.and.PreviousFQ":`Obecne i poprzednie FQ`,
"label.customfields.formula.dateandtimeexample":`Next = NOW() 1`,
"label.area.unassign":`Nieprzypisani użytkownicy`,
"label.at.my":`Treść, którą wymieniłem (@)`,
"vue_label_calendar_notice_stopsharingfail":`Nie udało się zatrzymać udostępniania`,
"label.data.file.validation.rules":`Wykonaj reguły walidacji`,
"label.escalation.setup.entrydetail.escalation.hour":`Godziny`,
"vue_label_ccchat_notice_pleaseentercontent":`Proszę wprowadzić treść i opcje`,
"label.forecast.edit.error1":`Błąd: Nieaktywna waluta`,
"label_emailtocloudcc_exists1":`Ta skrzynka pocztowa została ustawiona na Email to Lead. Nie powtarzaj ustawień.`,
"label.trigger.send.email":`Powiadomienia e-mail za pomocą wyzwalaczy`,
"label.setmysafetysignagain":`Zresetuj mój znak bezpieczeństwa`,
"label.callcenter.pleaseenter.access.keyID":`Proszę wprowadzić identyfikator tajnego klucza`,
"chatter.poll.option10":`Wybór 10`,
"vue_label_systemSettings_mobelbottonsetting2":`Ustawienia zunifikowanego menu dolnego`,
"label.quickbooks.searchs":`Szukaj`,
"label.section":`Segment`,
"label.customfields.fielddependency.new.tip":`Utwórz zależną relację, która powoduje, że wartości na liście wyboru lub liście wielokrotnego wyboru są dynamicznie filtrowane na podstawie wartości wybranej przez użytkownika w innym polu.<ul ><li>Pole, które steruje filtrowaniem nazywane jest "polem sterującym". Standardowe i niestandardowe pola wyboru oraz listy wyboru z co najmniej jedną i mniej niż 300 wartościami mogą być polami kontrolnymi. </li><li>Pole, którego wartości są filtrowane nazywane jest "polem zależnym". Niestandardowe listy pickupów i listy pickupów multi-select mogą być polami zależnymi.</li></ul>.`,
"label.customobjects.track.introduce3":`Uwaga: tylko część pól jest śledzona, a "Edytowane" będzie wyświetlane podczas śledzenia pól.`,
"front-kefu-moudle-all-hidden-phone":`Ukryj numer telefonu globalnie`,
"vue_label_calendar_share_calendar_with_others":`Udostępnianie kalendarza innym osobom`,
"label.case.copre":`Pobierz kod QR portalu internetowego`,
"label.conditiontag.lookup.pagetitle":`Wybierz wartości list pickupów`,
"UG.opportunity.004":`Typ wielousługowy`,
"label.event.moveup.1day":`1 dzień wcześniej`,
"label.industrialandcommercialverification.enablestatus1":`Umożliwia weryfikację danych przemysłowych i handlowych`,
"label.ccpeak.newrecord.getorpost":`Nowy rekord: istnieją dwa sposoby na skonstruowanie obiektu CCObject używając CCObject.`,
"frame.personinfo.label.resizeimage":`Aby zmienić rozmiar miniaturki, przeciągnij i zmień rozmiar przerywanych linii na zdjęciu profilowym powyżej.`,
"label.optional.searchresultfield":`Dostępne pola wyników wyszukiwania`,
"UG.Contract.02":`Kontrakt jest pisemną umową pomiędzy stronami. Wiele firm korzysta z kontraktów, aby określić warunki prowadzenia działalności z innymi firmami. Wykorzystaj CloudCC do tworzenia i dokumentowania istniejących umów z klientami i możliwościami biznesowymi. Śledź umowę przez proces zatwierdzania. Używaj przypomnień o przepływach pracy, aby przypomnieć o przedłużeniu umowy.`,
"label.group.activity":`Grupy aktywne`,
"label.tabpage.characterz":`Postać początkowa`,
"label.globalsearch.tip":`Proszę wpisać treść wyszukiwania`,
"label.campaign.channel.download.size2":`Rozmiar średni 500*500 pikseli`,
"label.step3.total4":`Krok 3 z 4`,
"label.partnerCloud.payForFailure":`Płatność nie powiodła się`,
"label.ggReleaseRange.editSuccess":`Edytuj z powodzeniem`,
"label.summaryinforelyon":`Dane podsumowujące według`,
"label.productsales.htyj":`Wykonanie umowy`,
"label.newpagelayout":`Nowy układ strony`,
"front-gantt-module-input-task-name":`Proszę podać nazwę zadania".`,
"label.c_d_without":`Rekordy "C" mogą, ale nie muszą mieć powiązanych rekordów "D".`,
"label.licence":`Licencje`,
"setup.layout.button.selectall":`Wybierz wszystko`,
"label.app.step1.error.appnameexist":`Ta nazwa aplikacji już istnieje.`,
"label.cpq.quote.item.no.record":`Do umów mogą być przenoszone tylko produkty zamówień z zapisami.`,
"label.knowledgebase.noaffect.existing.translations":`Nie, moje modyfikacje nie będą miały wpływu na istniejące tłumaczenie.`,
"label.schedulejob.setup.schedule.editjob":`Edycja zaplanowanych zadań`,
"lable.PowerProcess.Tips":`Proces uprawnienia to konfigurowalna oś czasu zawierająca wszystkie kroki (kamienie milowe), które mogą pomóc obsłudze klienta i innym pracownikom w wykonaniu wszystkich kroków w celu rozwiązania obsługiwanej sprawy lub rekordu zlecenia roboczego. Po zakończeniu konfiguracji można ją zastosować do uprawnienia.`,
"label.campaignmember.selectmember.step2":`Krok 2 Wybierz członków, których chcesz dodać`,
"vue_label_calendar_stopsharing":`Czy jesteś pewien, że przestaniesz udostępniać kalendarz`,
"vue_label_notice_savemenu_fail":`Nie udało się zapisać menu`,
"message.error.getitems.id":`getItems: id nie może być puste`,
"label.return.currencylist":`Powrót do listy: Zarządzanie walutą`,
"label.wtd.detail.p":`PC`,
"label.knowledgebase.publish.now":`Opublikuj teraz`,
"label.appupload.install.explain":`Instrukcja instalacji`,
"label.visualpage.folder.all":`Wszystkie foldery stron`,
"message.passwordPolicy.validate.complexReq2":`Błąd:Twoje hasło musi składać się z małych i dużych liter oraz cyfr.`,
"label.umeng.chatter.at":`wspomniał o tobie.`,
"label.mobile.phone.month.report":`Miesięczne notatki robocze`,
"label.describableEditeSelectedFields":`Wybierz pola, które są domyślnie wyświetlane w kolumnach raportu podczas tworzenia nowego raportu niestandardowego.`,
"component.event.label.subject":`Temat`,
"label.knowledgebase.edit.draft":`Edytuj projekt?`,
"label.customer.tab.step1.selectoneobject":`Wybierz istniejący obiekt niestandardowy`,
"label_partner_step2":`Krok 2 potwierdzenie szablonu`,
"label_starting_annual":`Rok rozpoczęcia`,
"X":`Obszar tekstu`,
"label.customer.tab.style":`Zakładka Styl`,
"vue_label_commonobjects_detail_book":`Standardowy cennik`,
"chatter.email.referredToMe":`Wspomina o mnie w swoim poście`,
"label.enable.both.barcode.qrcode":`Aktywuj kod kreskowy i kod QR`,
"front-market-form-quired-choose":`Wymagane pola`,
"noinclude":`nie obejmuje`,
"label.sms.template.select":`Proszę wybrać szablon SMS`,
"label.weixin.optionten":`Wybór 10`,
"message.duplication.label.matchlastletters":`Ostatnie N znaków`,
"label.webtocloudcc.submit.success":`Skuteczne złożenie wniosku`,
"label.sales.dashboard.number":`Numer`,
"label.custom.field":`Mapuj to pole niestandardowe`,
"label.dataimport.of.field":`pole(-a)`,
"label.view.new":`Utwórz nowy widok`,
"UG_activity_03":`Zarezerwuj harmonogram`,
"label.customfields.image.tip":`Umożliwia użytkownikom przesyłanie zdjęć.`,
"label.startexport":`Rozpocznij eksport`,
"vue_label_commonobjects_view_chart_verticalbar":`Wykres słupkowy pionowy`,
"label.ccchat.person.invite.allexist":`Wszyscy, których zaprosisz, już używają CCChat`,
"label.fielddependence":`Zależności od pola`,
"label.scan.tip":`Prosimy o korzystanie z przeglądarki IE7, IE8, Chrome lub Firefox i zalecana jest rozdzielczość większa niż 1024~7768.`,
"label.wei.weiactor":`Głosowano przez`,
"label.service.miniProgram.quantity":`Można utworzyć do 20 rekordów karuzeli~.`,
"vue_label_homepage_new_homepage_page":`Nowa strona główna`,
"label.apply.telphone.validate.error":`Nieprawidłowy numer walidacji.`,
"component.assistant.button.newevent":`Nowe wydarzenie`,
"System_TimeField_Format_Warning":`Nieważna godzina`,
"chatter.feed.publishfeed":`Post`,
"label.setting.intergrationlist":`Lista integracyjna`,
"label.object.prefix":`Prefiks obiektu`,
"label.tippage.confirmed":`Tak, chcę usunąć źródło danych raportu niestandardowego i wszystkie zależne raporty.`,
"label_emailsync_form_signin":`Login`,
"label.delete.cancel":`Odzyskaj`,
"label.dashboard.myHomePage.des":`Wybierz pulpit nawigacyjny do odtwarzania w każdej aplikacji.`,
"lable.account.FY.Ago":`2 FY Ago`,
"label.umeng.approval.reassign":`#approver zmienił przypisanie Twojego żądania zatwierdzenia #obj.`,
"label.data.exp.zippwd2":`Automatycznie generuj hasło do plików skompresowanych`,
"label.tabpage.contentz":`Proszę wpisać treść`,
"label.callcenter.batch.add.number":`Dodaj numery w Batch`,
"label.tabpage.deleteviewsuccess":`Zobacz sukces usuwania`,
"setup_layout_group_field":`Pola`,
"label.appupload.component.addobj.scheme.label.suoshu":`Obiekt`,
"front-project-module-v1-market-is-template":`Oznacz jako szablon`,
"label.service.gantt.one.esource.types":`oraz jeden z następujących typów zasobów`,
"label.emailtocloudcc.search":`Szukaj`,
"label.mobile.home.page.myyj":`Mój występ`,
"vue_label_normal_invoice_sf":`Faktura`,
"label.permission.detail.app.fenpei.tip":`Określenie, które aplikacje są widoczne w menu aplikacji.`,
"label.login.access.month":`Miesiąc`,
"label_tabpage_retypez":`W przypadku zmiany typu rekordu, istniejące wartości listy opcji nie zostaną automatycznie zmienione. Zalecamy aktualizację istniejących wartości listy opcji rekordu w tym samym miejscu.`,
"label.ems.private.company.message":`Wersje w chmurze prywatnej nie wspierają edycji online firmowej skrzynki e-mail.`,
"label.dataimport.length.check":`Długość powyżej 18 bitów, proszę uważnie przejrzeć zapis i zmodyfikować.`,
"label.batchtransfer.type1":`Przeniesienie otwartych możliwości, które nie należą do właściciela rachunku bieżącego`,
"vue_label_calendar_are_you_sure_to_remove":`Czy na pewno chcesz usunąć ten kalendarz?`,
"label.icon.117":`Torba szkolna`,
"vue_label_systemSettings_downloadapp":`Pobierz aplikację mobilną`,
"label.approval.project":`Punkty do zatwierdzenia`,
"template.organization":`Poziom organizacyjny`,
"label.weixin.return.research":`Powrót do strony szczegółów mikrosondażu`,
"label.ccchat.person.invite.addsay":`Dodaj opcjonalną wiadomość...`,
"UG.Case.02":`Przypadki pozwalają na reagowanie i rozwiązywanie problemów z kontami. Sprawy są potężnym zapisem w Cloud CC, który nie tylko śledzi sprawy związane z kontem, ale także wyświetla pełny obraz konta.`,
"label_emailtocloudcc_step1":`Krok 1`,
"workflow.action.tasks.assignortype.owner":`Właściciel`,
"label.data.import.page":`Przejdź do strony importu`,
"label.cache":`Cache`,
"label.custom.page.cuspage.width":`Szerokość (Piksele)`,
"label.customcomponent.referencetag":`Etykieta referencyjna`,
"label.tabpage.search":`Szukaj`,
"label.knowledge.searcharticle.casefields":`Pola przypadków do wyszukiwania sugerowanych artykułów`,
"setup_layout_message_relatedlistfield":`Wybierz pola, które mają być wyświetlane na liście powiązanych pól. Można również zmienić kolejność wybranych pól.`,
"label.relationobject.type":`Typ obiektu powiązanego`,
"UG_Account_02":`Niektóre firmy świadczą usługi innym firmom, inne współpracują bezpośrednio z użytkownikami końcowymi, a jeszcze inne służą organizacjom pozarządowym.`,
"UG_homepage_006":`360-stopniowy wgląd w aktywność konta za pośrednictwem ankiet, czatów na żywo, wiadomości e-mail, zleceń roboczych, postów w mediach społecznościowych, a nawet działań sprzedażowych (takich jak leady, wsparcie serwisowe i działania).`,
"chatter.poll.option1":`Wybór 1`,
"label.ccdocument.fieldforld":`Nazwa folderu, do którego należą dokumenty`,
"label.wei.result":`Wynik`,
"label.recentview.new":`Najnowsze`,
"label.martrixreport.setsumfield":`Wybierz pole, które ma być użyte jako wiersz podsumowujący w raporcie macierzowym`,
"label.reportsSubscriptionPage.schedulereport.weekly.monday":`Poniedziałek`,
"label.marketsea.button.recycle":`Recykling`,
"label.standard.buttonandlink.info2":`Wybierz niestandardową stronę CloudCC.com, która ma zostać użyta zamiast adresu URL CloudCC.com dla tego standardowego przycisku lub linku.`,
"label.reportsSubscription.select.two.months":`Proszę wybrać zakres dat w ciągu dwóch miesięcy dla tej częstotliwości!`,
"label.standard.buttonandlink.page":`CloudCC Classic`,
"vue_label_commonobjects_view_chart_horizontalbar":`Wykres słupkowy poziomy`,
"label.Remove":`Usuń`,
"label.mobile.phone.receivable":`Płatności`,
"label.appupload.uploaddetail.goback":`Powrót do pakietu`,
"label.select.role":`Proszę wybrać rolę`,
"label.file.sharetype":`Typ akcji`,
"label.app.chosetab":`Wybierz zakładki`,
"label.case.other.phone":`Inny numer telefonu`,
"chatter.edit.cancel":`Twoje zmiany zostały anulowane.`,
"label.html":`HTML`,
"message.auth2cn.acquisition.failed":`Nie udało się uzyskać auth2cn!`,
"message.error.system.service.permissiondeny":`Przepraszamy, nie masz uprawnień do korzystania z tej usługi, skontaktuj się z administratorem.`,
"label.chatter.mygroups":`Moje grupy`,
"label.umeng.approval.approvalpass":`Wniosek o zatwierdzenie dla #obj został zatwierdzony. Nazwa #obj`,
"label.chatter.owner":`Właściciel`,
"vue_label_commonobjects_view_kanban_view":`Widok Kanban`,
"message.please.choose.group.role":`Proszę wybrać rolę grupy`,
"label.icon.136":`Waluta`,
"label_tabpage_selectdate":`Wybierz datę`,
"chatter.emailInformation":`Informacje ogólne`,
"front-lightning-module-v1-dashborad-bubble-size":`Wielkość bańki`,
"label.stdashbord.xsld.business.wan":`myriad`,
"label.datamanage.field.notexist":`Pole odpowiadające obiektowi nie istnieje.`,
"UG.Forcast.04":`Rozpoczęcie procesu`,
"UG.contact.02":`Angażowanie kontaktów poprzez wiele kanałów, rozmowy telefoniczne, email, social`,
"vue_label_pool_selecttransferinto":`Wybierz pulę ołowiu, do której chcesz dokonać transferu`,
"label.quote.xingming":`Nazwa`,
"label.customerinfo.userlicencenum":`Licencje użytkowników`,
"label.group.no.my.archived":`Nie znaleziono pasujących zarchiwizowanych grup.`,
"label.weixin.add.activity.tel":`Dodaj wezwanie do działania`,
"label.partner.setup.address":`Adres chmury partnera`,
"label.data.file.i_title.num3":`3.System wstępnie wczytuje plik z danymi na serwer, następnie uruchamia back-endowy mass importer, o którego wynikach użytkownicy zostaną powiadomieni pocztą, a Ty nie będziesz musiał czekać na tej stronie.`,
"label_sum_up":`SUM`,
"label.searchall.title":`Globalne wyszukiwanie`,
"label.bind.chooseone":`Wybierz właściciela`,
"label.campaign.channel.input.owner.select1":`Właściciel obecnej kampanii`,
"front-kefu-moudle-v1-Expand-chat":`Rozwiń szczegóły czatu`,
"label.component.hotdeal":`Gorące okazje`,
"component_event_label_title":`Nadchodzące wydarzenia`,
"No.planed.activity":`Brak planowanej działalności`,
"label.searchlayout.result.field":`Wyniki wyszukiwania Kolumny do wyszukiwania i tagowania.`,
"label.leadscore.value":`Wartość`,
"vue.dashboard.linkage.is.set.successfully":`Podnośnik ustawiony pomyślnie!`,
"PersonalInfo.LoginHistory.001":`Broswer sprawdza poprawność linku do rejestracji w skrzynce pocztowej`,
"front-gantt-module-v1-problem-number":`Numery problemów`,
"label.page.step5.of.step5":`Krok 5 z 5`,
"label.sendemail.chat.sendmessagesubject":`CloudCC CCChat alert wiadomości`,
"label.Linkedin_accounts":`Konto na LinkedIn`,
"label.qrcode.useful.life":`Kod QR Data ważności`,
"deleterow":`Usunąć rząd`,
"label.forecast.settings.future1":`Przyszły 1 cykl`,
"message.error.group.operation":`Błąd archiwizacji grupowej`,
"label_tabpage_loadz":`Ładowanie strony, proszę czekać...`,
"label.brackets.left":`(Nawias otwarty`,
"label.source.code":`Zobacz kod źródłowy`,
"setup_layout_label_areasetup":`Sekcja Właściwości`,
"component.assistant.label.todaylead":`Przydzielone Ci dzisiaj tropy`,
"label.qrcode_signin":`QR Code jest ograniczony do aplikacji, które wymagają skanowania kodu na miejscu i logowania.`,
"label.calendarshare":`Udostępnianie kalendarza`,
"IMG":`Obraz`,
"label.use.rule.when.both":`Zastosuj tę regułę, gdy jednocześnie włączone są funkcje kodu kreskowego i kodu QR.`,
"label.ccpeak.addshare.record":`Nowe rekordy formularza wspólnego: Ostatnio dodane rekordy`,
"label.enable.email.tracking":`Włącz śledzenie wiadomości e-mail`,
"label.top.plsinput":`Przeszukaj tę listę...`,
"vue_label_helpcenter_case":`Przypadki to pytania klientów, informacje zwrotne lub problemy. Agenci wspierający mogą przeglądać przypadki, aby zrozumieć, jak zapewnić lepszą obsługę. Przedstawiciele handlowi mogą wykorzystać przypadki, aby zrozumieć wpływ na proces sprzedaży. Reagowanie na poszczególne przypadki może zadowolić klientów i poprawić wizerunek marki.`,
"label.useonly":`Prywatna`,
"label.displaytype":`Typ wyświetlacza`,
"label.most.user.group":`Użytkownicy mogą dołączyć do maksymalnie 100 grup użytkowników, a Ty dołączyłeś już do setnej grupy.`,
"label.umeng.activity.yourevent":`Twoja impreza`,
"label.forecast.shrepage.classdes.w":`Odczyt/zapis - Użytkownik może przeglądać i zmieniać dane prognozy.`,
"label.defaultaccess":`Dostęp domyślny`,
"label.partner.new.step2":`Krok 2 potwierdzenie szablonu`,
"component_setup_iframe_label_title":`Dostosuj stronę`,
"label.sso.saml.sp.idenitytype":`Typ tożsamości SAML`,
"label.dashboard.this.folder":`Dashboardy w tym folderze`,
"label.data.newtemplate.e.seltype.desc":`Istnieją dwa rodzaje danych pochodnych</li><li class`,
"label.forecast.customforecast.submit.tip1":`Zgłoś swoją prognozę z:`,
"label.version.workflow.and.approval":`Automatyzacja procesów przepływu pracy i zatwierdzania`,
"label.tianyancha.tip":`Wprowadzony tekst jest nieprawidłowy, proszę wpisać go ponownie!`,
"label.report_details":`Szczegóły raportu`,
"template.report.folder.contract.product":`Analiza umów i produktów`,
"label.all":`Wszystkie`,
"label.version.area.long.rich":`{0} pola obszaru bogatego tekstu lub długiego tekstu`,
"label.enc":`Szyfrowana pamięć masowa`,
"vue_label_pricebook_enterproductname":`proszę wpisać nazwę produktu`,
"label.edit.quote.line":`Edytuj wiersz cytatu`,
"label.edit":`Edytuj`,
"M":`Relacja nadrzędny - szczegółowy`,
"front-kefu-phonenumber-exists":`Miejsce nr {a} już istnieje`,
"label.standardplatformuser":`Standardowi użytkownicy platformy`,
"label.custom.page.configuration":`Edytuj niestandardowy komponent konsoli`,
"url.error.contact.null":`Adres mikroserwisu jest pusty.`,
"label.sethelp":`Ustawienia pomocy`,
"setup.mainpage.label.welcome23":`Ustawienia bezpieczeństwa`,
"label.sales.page.dashboard.fenxi":`Pulpity analizy sprzedaży`,
"label.limit":`Dostęp`,
"maintenanceasset.asset.contractlineitem.illegal":`Musisz wybrać składnik aktywów na pozycji umowy, zanim skojarzysz pozycję umowy ze składnikiem konserwacyjnym.`,
"UG.contact.04":`Lub`,
"Opportunity.Detailed.Phase.Label.004":`Dzień(y)`,
"label.emailobject.receive":`Do`,
"label.brief.new":`Ostatnio nowe`,
"label.marketsea.button.adopt":`zbierać`,
"label.select.up.to.three.fields":`Można wybrać maksymalnie trzy pola.`,
"vue_label_allsearch_noresults":`Przeszukaliśmy według twoich niestandardowych ustawień wyszukiwania, nie znaleziono pasujących wyników z {userInput}.`,
"Report_CantDelete_Info":`Raport {0} jest źródłem danych dla dashboardu {1} i nie może zostać usunięty!`,
"label.chile.summer.time":`Chile Czas letni`,
"label.partnerCloud.menu.selectedMenu":`Wybrane menu (zaznaczone menu zostanie zsynchronizowane z aplikacją)`,
"vue_label_report_onlysummary":`Tylko podsumowanie`,
"front-template-V1-Applicable-object":`Proszę wybrać odpowiedni obiekt.`,
"label.invoice.message.sendfailed":`Nie udało się wysłać faktury, proszę spróbować ponownie później`,
"front-kefu-moudle-v1-use-free":`WYPRÓBUJ ZA DARMO`,
"label.rule.updated.successfully":`Pomyślna aktualizacja zasad`,
"label.owner.lastone":`Zachować co najmniej jeden warunek`,
"label.appointment.wizard.subtitle1":`Czas trwania spotkania`,
"template.report.opportunities.closed.month":`Zamknięte okazje tego miesiąca`,
"label.tabpage.choosecontent":`Wybierz zawartość wartości`,
"template.chart.jbnddxl":`Sprzedaż zamówień w ostatnim półroczu`,
"label.fieldsecurity.detail":`Szczegóły dotyczące bezpieczeństwa w terenie`,
"label.knowledgebase.data.deleted.successfully":`{a} dane usunięte pomyślnie`,
"label.sso.saml.idp.config.nameidfmt":`Nazwa ID Format`,
"label.emailobject.prompt":`Prompt`,
"label.marketsea.isgetbyself":`Umożliwienie członkom samodzielnego gromadzenia danych`,
"label.winxin.cancelprompt":`Czy na pewno chcesz wyjść? Twoja aktualna operacja nie zostanie zapisana.`,
"label.appexchange.installedpage.message2":`Aplikacje i komponenty są instalowane w pakietach. Wszystkie niestandardowe aplikacje, karty i niestandardowe obiekty są początkowo oznaczone jako "W opracowaniu" i nie są wdrażane u użytkowników. Pozwala to na przetestowanie i dostosowanie przed wdrożeniem. Komponenty można wdrażać pojedynczo, korzystając z innych funkcji w konfiguracji, lub grupowo, klikając przycisk Wdrażaj.`,
"vue_label_import_importtype":`Rodzaj przywozu`,
"label.data.importef.des":`Pliki, których nie udało się zaimportować będą przechowywane na serwerze przez 48 godzin i zostaną automatycznie usunięte po upływie 48 godzin.`,
"chatter.email.reply":`Komentarze do moich postów`,
"label.stdashbord.xsld.business.sdl":`Straty`,
"labal.emailtemplate.namemessage":`Unikalna nazwa szablonu wiadomości e-mail istnieje, proszę wprowadzić ją ponownie.`,
"vue_label_email_Please_select_file":`Proszę wybrać plik`,
"label.event.modify":`Wydarzenie Edycja`,
"label.projectManagement.isnmber":`Proszę wpisać liczbę z maksymalnie jednym miejscem po przecinku.`,
"lable.outlook.detail.emailst":`Ustawienia poczty elektronicznej`,
"label.partnerCloud.priceOfManual.isUsed":`To ustawienie określa, czy partnerzy mogą używać tej książki cenowej do zamawiania, czy nie.`,
"setup_mainpage_label_welcome26":`Zarządzanie danymi - Przetwarzanie wsadowe`,
"label.file.version":`Wersja`,
"pagecreator_systemstyle_label_bordercolor":`Kolor obramowania`,
"label.approval.isallowed.reject.prompt":`Czy chcesz zezwolić na odrzucenie podczas zatwierdzania pojedynczych danych? (Zatwierdzenie masowe zawsze może zostać odrzucone).`,
"label.myinfo":`Dane osobowe`,
"front-template-V1-fontSize":`Rozmiar czcionki`,
"lable.outlook.edit.alpreo":`Zawsze preferowana wymiana`,
"front-email-payment-card-number":`Numer karty`,
"label.cpq.quote.pricebook.no.change":`Po ustaleniu cennika dla oferty nie można go zmienić. Proszę utworzyć 1 nowy rekord oferty dla nowej książki cenowej.`,
"vue_label_file_size_limit_tip":`Rozmiar pliku przekracza limit`,
"lable.PowerProcess.worktime":`Czas pracy w procesie nabywania uprawnień`,
"label.monthly.month.report":`Miesięczny raport YoY i MoM`,
"front-kefu-moudle-v1-sydq-buyuser":`Twój szlak jest należny. Proszę zakupić Easemob, aby zachować użycie`,
"label_tabpage_Rolesz":`Role i podwładni`,
"chatter.f.n":`Postępuj zgodnie z tym zapisem`,
"UG.Forcast.02":`Prognozy to szacunki dotyczące oczekiwanej sprzedaży w danym okresie, a modele prognozowania mogą pomóc w określeniu popytu na produkty i przychodów ze sprzedaży w danym okresie. Menedżerowie mogą wykorzystywać prognozy do wyznaczania celów i mierzenia postępów zespołu. Ogólna prognoza organizacji może odzwierciedlać podsumowanie całej sprzedaży w podziale na przedstawicieli handlowych (niezależnie od etapu realizacji sprzedaży od etapu pipeline do etapu zamkniętego).`,
"label.productsales.contract.phb":`Lista umów`,
"label.umeng.insert.approval.submit":`#aplikator przesyła #obj do zatwierdzenia`,
"message.duplication.label.matchfirstletters":`Pierwsze N znaków`,
"label.partnerCloud.partnerAccount.toPay":`Przejdź do płatności`,
"label.model.un":`Nr modelu: UN6786`,
"label.save.c1":`Nazwa "Web To CloudCC" musi być unikalna.`,
"week":`Tydzień`,
"Pagelayout.Setup.003":`Pole Nazwa musi być zaznaczone`,
"label.query.detail.openpartnermessage":`Po włączeniu klienta jako partnera, pojawia się on w filtrowanych raportach i zestawieniach w polu ispartner. dodatkowo użytkownicy partnerscy mogą tworzyć z kontaktów powiązanych z tym klientem. jesteś pewien?`,
"label.validate.function.funcFormat.DATEVALUE":`DATEVALUE(data)`,
"label.apply.send.false":`Błąd wysyłania`,
"label.recordtype.edit.selectvalue":`Wartości Picklist`,
"label.chosesubject":`Wybierz temat poniżej`,
"label.validate.function.funcExplain.YEAR":`Rok daty powrotu jest liczbą z zakresu od 1900 do 9999.`,
"component.chatter.button.more":`Zobacz więcej szczegółów`,
"label.top.class.smallest":`Minimalny poziom hierarchii to 1.`,
"label.startingvalue":`Numer początkowy`,
"label.multi.layout.remark":`Układ, który ma zastosowanie do wejścia matryca-detal i dodawania masy`,
"label.role.availableuser":`Dostępni użytkownicy`,
"label.weixin.iebrowser":`Wersja przeglądarki, której obecnie używasz to IE6, wydana przez Microsoft w 2001 roku. Ponieważ wersja przeglądarki jest zbyt niska, aby CloudCC mógł być rozwijany z wykorzystaniem nowych technologii, nie ma gwarancji, że wszystkie funkcje będą działać poprawnie. Proszę pobrać i zaktualizować swoją przeglądarkę w odpowiednim czasie.`,
"Homepage_News_004":`Ostatnio nie ma żadnych nowości.`,
"vue_label_normal_task_sf":`Zadanie`,
"label.version.nonsupport.trigger":`Wyzwalacze na razie nie są obsługiwane.`,
"pagecreator_page_label_pagelayout":`Układ strony`,
"label_tabpage_step3":`Krok 3 wybierz pola do wyświetlenia`,
"label.canOnlyUploadCSVFormatFile":`Przesyłaj tylko pliki w formacie CSV`,
"label.b.c.least":`Każdy rekord "B" musi mieć co najmniej jeden powiązany rekord "C".`,
"label.list.userinterface.sales.enable":`Strona główna sprzedaży tablice liderów przeglądanie danych włączanie uprawnień`,
"label.umeng.approval.approvalreject":`Wniosek o zatwierdzenie dla #obj został odrzucony. #objname`,
"vue_labenl_normal_notice_share_fail":`Udostępnianie nie powiodło się`,
"label_emailtocloudcc_tip":`Prompt`,
"label.h5.touchselect":`Kliknij, aby wybrać`,
"label.tabularreport":`Raport tabelaryczny`,
"label.app.defaulttab":`Zakładki domyślne`,
"label.validate.function.category.Datetime":`Data i godzina`,
"vue_label_pricebook_editdetail":`Edycja pozycji cennika`,
"vue_label_commonobjects_view_no_selected_record":`Nie wybrano żadnego zapisu`,
"chatter.changed":`Zmieniono`,
"label.asset.bom.based":`Generowanie BOM aktywów zgodnie ze strukturą produktową zamówienia`,
"label.appointmentdetail.wizard.title8":`Start w każdej`,
"label.area.query.user.error":`Dane użytkownika odpowiadające terytorium zapytania nie powiodły się, a identyfikator terytorium był pusty.`,
"page.field.masterinput":`Ustawienia wejścia głównego i szczegółowego`,
"chatter.selads":`Wybierz Odbiorców`,
"label.data.exp.please.savebutton":`Proszę zaznaczyć opcję "Zapisz jako szablon".`,
"label.members.activity":`Członkowie kampanii`,
"label.weixin.click.searchs":`Kliknij, aby wyszukać rekord`,
"label.input.least.two":`Proszę wpisać co najmniej dwa znaki`,
"label.marketing.seting":`Ustawienia Marketing Cloud`,
"label.approveprocess.tip":`Zatwierdzenia to złożone procesy biznesowe, które wymagają zebrania informacji i zaplanowania przed wdrożeniem. Zaleca się, aby przed przystąpieniem do pracy postępować zgodnie z poniższymi instrukcjami.`,
"front-email-payment-Invoice-login-account":`Login Konto`,
"label.selectmulti.mes":`Zbyt duża liczba wybranych odbiorców.`,
"label.workflow.gotolist":`Powrót do listy: Workflow`,
"label.profile.fieldsafety":`Bezpieczeństwo na poziomie pola walki`,
"front-project-module-v1-no-selectemplat":`Brak dostępnego szablonu`,
"label.sendemail.queue.assigntitle":`Email powiadomienia o przypisaniu obiektu do kolejki`,
"label.approval.mobile.comments.placeholder":`Wpisz tutaj swój komentarz, do 1000 słów.`,
"vue_label_report_given":`konkretny`,
"vue_label_dashboard_groups":`Proszę wybrać grupę`,
"label.service.gantt.popoverTip":`Odległość/czas podróży`,
"label.mr.title.characters":`W zależności od długości znaków`,
"label.passwordPolicy.setup.day":`dni`,
"label_tabpage_personvisible":`Widoczny dla właściwego personelu`,
"ct":`Wielowalutowy`,
"label.chatter.newEvent":`Nowe wydarzenie`,
"vue_label_systemSettings_id":`Login Tożsamość`,
"label.page.preview.web.tab":`Podgląd karty sieciowej`,
"label_emailsync_button_sure":`Potwierdź`,
"front-template-V1-Modification-time":`Czas modyfikacji`,
"vue_label_homepage_edit_fixed_components":`Edycja stałych elementów`,
"label.apply":`Aplikuj`,
"Main.Menu.Mobiledownload":`WŁĄCZ SIĘ`,
"vue_label_salesfunnel_notice6":`Całkowita liczba możliwości z prawdopodobieństwem 100%.`,
"label.chosesubject.sendemail":`Wyślij e-mail`,
"label.changemydisplay.chagetab.des":`Wybierz karty, które będą wyświetlane w każdej z Twoich aplikacji.`,
"label.attendance.setting.checkUser":`istnieje już w innych frekwencjach.`,
"label.list.projectSetting.setup":`Ustawienia zarządzania projektem`,
"label.app.introduce2":`Możesz dostosować istniejące aplikacje do swojego sposobu pracy lub tworzyć nowe aplikacje, grupując karty standardowe i niestandardowe.`,
"label_emailsync_form_emialpassword":`Hasło`,
"label.Lightning.Setting":`Ustawienie błyskawicy`,
"label.print.preview":`Podgląd wydruku`,
"label_vue_create_edit_obj_create_event_dialog_desc_alert":`Czy nadal chcesz tworzyć wydarzenie w tych ramach czasowych?`,
"label.mobile.phone.report.type":`Typ raportu`,
"lable.account.CalenderWeek":`Tydzień kalendarza`,
"label_emailtocloudcc_step3total3":`Krok 3 z 3`,
"label_tabpage_emailaddressz":`Adres e-mail nadawcy`,
"label.data.is_woking":`Obsługa`,
"label.knowledge.cancelattach.case":`Anuluj Dołączenie do sprawy`,
"label.sendemail.chat.chatcontent":`Treść postu głównego:`,
"label.timezone.set":`Ustawienia Terytorium`,
"label_tabpage_uploadingz":`Przesyłanie`,
"front-epwechat-module-v1-home-url":`URL strony głównej:`,
"label.reportsSubscription.select.subscription.frequency":`Proszę wybrać częstotliwość subskrypcji!`,
"label.validate.function":`funkcja`,
"label.partnerCloud.orderingPlatform.quantity":`Ilość`,
"label.compact.layout.chatter":`CCChat`,
"label.sso.saml.sp.description2":`Skonfigurować single sign-on w celu uwierzytelniania użytkowników w CloudCC z zewnętrznych środowisk.`,
"label.ccchat.message.new.error1":`Nie możemy znaleźć żadnego użytkownika czatu z {0} w nazwie.`,
"label.file.share.email.content3":`W celu uzyskania szczegółowych informacji prosimy o zalogowanie się do systemu CloudCC CRM.`,
"label.file.cancel.sharing":`Anuluj udostępnianie`,
"label.changemydisplay.showalltabs.add":`Dodaj karty do domyślnego wyświetlacza`,
"label_chatter_incident":`Wydarzenia`,
"label.file.folder.delete3":`Czy na pewno chcesz usunąć {foldername}？`,
"label_tabpage_delsuccessz":`Skreślić sukces`,
"label.view_contact":`Zobacz Kontakt`,
"label.deactivate":`Dezaktywuj`,
"label.Horizontal.Date":`Umówienie się na serwis filtrów w zależności od daty lewa.`,
"label.forecast.tree.title":`Hierarchia prognoz`,
"vue_label_dashboard_dategruop":`Proszę wybrać podstawę grupowania dat`,
"label.version.nonsupport.custompage":`Strony niestandardowe nie są tymczasowo obsługiwane.`,
"label.tabpage.personvisible":`Widoczny dla właściwego personelu`,
"message.error.unknown":`Nieznany błąd`,
"label.down":`Down`,
"label.multilang.customforcast.financialyear":`{0} rok podatkowy：`,
"label.dataimport.type.error":`Błąd typu, proszę sprawdzić rekord i zmodyfikować.`,
"label.batchadd.newbatchpage.save.num":`Nieprawidłowy format liczbowy`,
"front-Dev-V12.2.8-calendar-endField":`Koniec pola`,
"label.tabpage.rtemptyz":`Typ rekordu nie może być pusty`,
"vue_label_dashboard_maximum":`Proszę wpisać maksymalną wartość`,
"label.expiredate":`Termin płatności`,
"label_emailtocloudcc_button_view":`Zobacz`,
"label.event.future":`Przyszłe wydarzenia`,
"label.mobile.app.layout":`Układ aplikacji mobilnej`,
"label.emailobject.contacts":`  kontakt(y)`,
"label.approvalstep2.tip":`Określenie, czy rekord musi spełniać określone kryteria przed wejściem do tego etapu zatwierdzania.`,
"label.usefollowtoset":`Korzystając z poniższych opcji, należy określić użytkownika, do którego ma zostać przypisane żądanie zatwierdzenia.`,
"label.dashboard.summary.editPageHeader":`Edytuj nagłówek`,
"label_partner_workspace_tab_memo":`Wybierz zakładki dla tej chmury partnerskiej. można wybrać zakładki standardowe lub niestandardowe.`,
"front-lightning-module-v1-details-page-chart-title-supports":` Tytuł obsługuje wstawianie nazwy rekordu w formacie {nazwa rekordu}, np. "Kwota szansy {nazwa rekordu}". Jeśli bieżącą nazwą rekordu jest CloudCC, to zostanie ona wyświetlona jako "Kwota szansy CloudCC".`,
"label.enable.generate.location.service":`Umożliwia generowanie usług danych dotyczących szerokości i długości geograficznej klienta w oparciu o adres klienta.`,
"label.loginsystem":`Login`,
"label.email.template.edit.template":`Edytuj szablon`,
"vue_label_commonobjects_detail_share":`Udział w przychodach`,
"label.icon.142":`Dom`,
"label.maintype":`Mistrz`,
"label.step2.total4":`Krok 2 z 4`,
"label.select.intended.tablayout":`Wybierz układ strony karty sieciowej, którą chcesz utworzyć.`,
"label.custom.unit":`Jednostka`,
"label.mr.title.phone":`Telefon`,
"label.compact.layout.frame.showtype":`Metoda wyświetlania:`,
"label.associations":`Obiekt powiązany`,
"label.potentialcustomers.name":`Nazwa wiodąca`,
"label.edit.profile":`Edytuj profil`,
"label.tabpage.allvisible":`Wszyscy użytkownicy są widoczni`,
"label.login.verification.confirmation.enabled":`Potwierdź, aby włączyć`,
"vue_label_norm_recordselected":`{selectNum} wybrany rekord(y)`,
"label.partner.workspace.member.selectedprofile":`Wybrany profil`,
"label.divide":`/Divide`,
"label.version.case.control":`Zarządzanie przypadkami`,
"label.attendance.nocheckin":`Nie zameldować się`,
"vue_label_helpcenter_report2.1":`2.Usuń grupowanie wierszy: <br> A. Po znalezieniu pola "grupowania wierszy", które chcesz usunąć na liście "wiersz grupy" po lewej stronie, kliknij "×" w polu pola. <br> B. Lub znajdź pole "grupowania wierszy", które chcesz usunąć w nagłówku raportu podglądu po prawej stronie, kliknij "przycisk rozwijania" i kliknij "usuń wiersz grupy".<br> Usuń grupowanie kolumn: <br> A. Po znalezieniu pola "Grupowanie kolumn", które chcesz usunąć na liście "Grupuj kolumny" po lewej stronie, kliknij "×" w polu pola. <br> 1. B. Lub znajdź pole Grupowanie wierszy, które chcesz usunąć w nagłówku tabeli raportu podglądu po prawej stronie, kliknij przycisk rozwijany i kliknij Usuń grupę wierszy. <br> Aby usunąć grupowanie kolumn:<br> A. Znajdź pole Grupowanie kolumn, które chcesz usunąć na liście Grupuj kolumny po lewej stronie i kliknij "x" w polu pola. <br> B. Lub znajdź pole Grupowanie kolumn, które chcesz usunąć w nagłówku tabeli raportu podglądu po prawej stronie, kliknij przycisk rozwijany i kliknij Usuń kolumnę grupy. <br>? Krok 1: Po zgrupowaniu według pól daty, można również dostosować ziarnistość daty. Najpierw należy wybrać pole daty, według którego chcemy grupować raport. Następnie kliknij przycisk Dropdown obok tego pola w nagłówku raportu podglądu i kliknij Podstawa grupowania według daty. <br> Krok 2: Wybierz sposób grupowania: Dzień, Miesiąc, Rok, Kwartał księgowy, Rok księgowy, Kwartał niestandardowy, Rok niestandardowy. <br>? Krok 1: Po znalezieniu kolumny, którą chcesz podsumować w nagłówku raportu podglądu, kliknij "przycisk rozwijania" i kliknij "Podsumowanie". <br>.`,
"label.payment.renew":`Odnów`,
"vue_label_file_wrong_type":`'Wystąpił błąd w typie przesyłanego pliku, format pliku, który teraz przesyłasz to {type}!`,
"UG_opportunity_005":`Wielokrotny proces sprzedaży`,
"label.knowledge.language.korean":`Koreański`,
"label.customobjects.inputrecordtagandformat":`Wprowadź nazwę rekordu Etykieta i format`,
"label.h5.chatter.commentednum":`Otrzymać odpowiedź`,
"label.quickbooks.button.unlink":`Odłącz`,
"label.step5.total5":`Krok 5 z 5`,
"label.projectManagement.Selweek":`Wybierz tydzień`,
"label.optional.searchfield":`Dostępne przeszukiwalne pola`,
"label.mobile.quickcreate.default.signin":`Zameldowanie`,
"label.visualpage.unable.parse":`Nie można rozwiązać problemu z markerem.`,
"mesage.error.role.delete":`Nie możesz usunąć roli, do której przypisana jest rola dziecka.`,
"label.role.user":`Użytkownicy w roli`,
"button_partner_workspace_saveas":`Zapisz jako`,
"label.file.no.public.link.created":`Nie utworzono łącza publicznego`,
"label.login.access.shenyu":`Pozostały`,
"label.ccchat.group.section":`Grupa`,
"label.weixin.object.notnull":`Temat nie może być pusty`,
"label.accmarketsea.add.title":`Pula nowych rachunków`,
"label.sales.funnel.layout":`Układ lejka sprzedaży`,
"pagecreator.page.button.edit":`Edytuj`,
"label_tabpage_entercontent":`Proszę wpisać treść`,
"component_event_label_begindate":`*Godzina rozpoczęcia`,
"label.file.versionhref":`Przejście do nowej wersji strony`,
"label_chatter_send":`Wyślij`,
"setup_layout_label_buttonlist":`Przyciski wyboru`,
"label.custom.Current.and.NexttCQ":`Bieżące i następne 3 CQ`,
"pagecreator_page_label_pagedesc":`Opis strony`,
"label.appupload.upload.uploader":`Załadowane przez`,
"label.console.step5.tab.primary":`Jako karta główna`,
"vue_label_globalsearch_expandlist":`Rozwiń listę`,
"label.forecast.edit.userqu":`Target`,
"label.step1.total5":`Krok 1 z 5`,
"label.multilang.dupicatecheck.onegroupredata":`Postęp weryfikacji duplikatu i kombinacji：łącznie {0} grup：`,
"vue_label_systemSettings_repeat":`Zarządzaj duplikatami`,
"label.mobile.side.tab.error1":`Proszę wybrać funkcje wspólne i zakładki aplikacji, które mają być wyświetlane.`,
"label.knowledgebase.reduction":`Przywróć`,
"label.standard.buttonandlink.override.usedefault":`No Override (użyj wartości domyślnej)`,
"dateandtime":`Data/godzina`,
"label.group.activate.info":`Aktywuj grupę`,
"label.triggertotask":`Wyzwalacze zadań`,
"label.emailobject.save.template":`Zapisz projekt jako szablon`,
"label.audit.objInfo":`Szczegóły procesu zatwierdzania`,
"label.callcenter.successfully.logged.account":`Zalogował się pomyślnie!`,
"label_new_customer_target":`Cel nowego konta`,
"label.campaign.channel.step5":`Krok 5: Podgląd strony rejestracji kanału marketingowego i kodu źródłowego.`,
"label.log.type":`Typy operacji`,
"front-template-V1-noTemplate":`Nie znaleziono dostępnych szablonów pod podmienionym obiektem.`,
"label_report_line_daixuan":`Kolumna raportów oczekujących`,
"label.tianyancha.businessverify.relation.tip":`Zapisz pola zwrócone przez tianyancha do pól klienta`,
"label.default.value":`Użyj tej wartości jako wartości domyślnej dla głównej listy wyboru`,
"label.weixin.campaign.attendance":`Uczestnictwo w kampanii`,
"message.duplication.label.check":`Sprawdź`,
"label.salescloud.salescloud.yes2forbidden":`Tak, chcę wyłączyć funkcję Sprzedaży zespołowej.`,
"lable.currencyAdv.exchagecurrency.rate":`Kursy wymiany dla:`,
"lable.Hide.title":`Ukryj tytuły`,
"label.finishedreport":`Generowane raporty`,
"vue_label_account_business":`Przeniesienie zamkniętych możliwości biznesowych właścicieli klientów`,
"vue_label_pool_assigned":`Przypisane`,
"label.report.export.error":`Operacja eksportu napotkała wyjątek. Proszę spróbować ponownie.`,
"label.layout.availablefield":`Dostępne pola`,
"label.licence.remainder":`Pozostałe licencje`,
"label.approval.idea.required":`Wymagana jest opinia zatwierdzająca.`,
"front-kefu-moudle-needhand-createcase":`Przed utworzeniem sprawy wymagane jest ręczne potwierdzenie.`,
"label.dashboard.snapshot.Data.change":`Źródło danych uległo zmianie, prosimy o ponowną konfigurację`,
"label.partner.workspace.login.footertext":`Tekst stopki`,
"vue_label_chatter_upload_link_type":`Wybrany post typu załaduj link`,
"front-dialog-module-v1-error-detail":`Szczegóły błędu`,
"label.emailobject.sendgroupemail":`Wyślij grupową wiadomość e-mail`,
"lable.newtabpage.allviews":`Wszystkie opinie`,
"label.khdd":`Lokalizacja konta`,
"vue_label_dashboard_sortfield":`Pole sortowania`,
"label.form.sample":`Przykładowy formularz`,
"component_setup_button_cancel":`Anuluj`,
"vue_label_salesfunnel_notice5":`Ilość możliwości biznesowych o prawdopodobieństwie 1% - 99% * prawdopodobieństwo`,
"pagecreator_systemstyle_label_modifystyle":`Edytor stylu`,
"UG_homepage_001":`Wygraj więcej transakcji w krótszym czasie`,
"label.campaign.pc":`PC`,
"label.visualpage.lightning":`Wersja błyskawica`,
"label.knowledge.category.hint.two":`Użyj tej strony, aby wybrać grupę dla Lightning po utworzeniu grupy kategorii.`,
"label.south.africa.standard.time":`Czas standardowy RPA`,
"label.service.gantt.reservation.number":`Numer zamówienia`,
"label.weixin.report.period":`Okres`,
"label.leadtomap.exp":`Użyj tych zakładek, aby zmapować każde z niestandardowych pól leadów Twojej organizacji do jednego z niestandardowych pól konta, kontaktu lub szansy. Mapowania te są używane podczas konwersji leadów na konta, kontakty lub szanse.`,
"label.currency.d":`Możesz zmienić walutę korporacyjną na inną z obsługiwanych przez Twoją organizację. Wszystkie kursy wymiany walut już zdefiniowane w CloudCC.com zostaną odpowiednio zmodyfikowane, aby odzwierciedlić tę zmianę.`,
"label.forecast.detailforecast.oppyclb":`Kategorie prognozowanych możliwości`,
"label.reportsSubscriptionPage.email.selected":`Wybrani posłowie`,
"vue_label_homepage_componentname":`Proszę wpisać nazwę komponentu`,
"lable.account.Previous.FYt":`Previous 2 FY`,
"label.appupload.success":`Prześlij kompletny`,
"label.customer.newtab":`Nowa zakładka strony niestandardowej`,
"label.value.notnull":`Należy wprowadzić wartość.`,
"label.case.miniprogram.layout":`Układ strony raportu apletu jest układem strony użytym dla żądania serwisowego, które zostało przesłane z końca apletu, i ten układ strony można tylko edytować, nie można go usunąć.`,
"label.partnerCloud.partnerAccount.twoDecimal":`Proszę wpisać w poprawnym formacie.  Można zachować dwie cyfry po przecinku.`,
"UG.Lead.004":`Formularz internetowy`,
"label.umeng.activity.event.eventwillbeginnew":`Powiadomienie o wydarzeniu: #event starts at #begintime`,
"label.projectManagement.subtasks":`Podtaki`,
"vue_label_checkduplicate_repeat_conditions":`Zdecyduj o powtarzających się warunkach`,
"label.subject":`Przedmiot:`,
"label_search_otherusers_forecast":`Szukaj przewidywań innych użytkowników`,
"label_tabpage_namemandatory":`Nazwa widoku jest wymagana`,
"label.timezone.importtimezone":`Ustawienie strefy czasowej dla importu danych`,
"label.mobile.buttom.team.init":`Inicjalizacja użytkownika zespołu`,
"label.checkfield.choosefield":`Wybierz pola, w których chcesz znaleźć duplikaty`,
"label.b_c_least":`Każdy rekord "B" musi mieć co najmniej jeden powiązany rekord "C".`,
"label.knowledge.setting.hint.five":`Wybierz autora wiedzy`,
"label.h5.similar.opportunity.step2":`Krok 2 Określ kryteria dopasowania`,
"label.page.style.imbedded.cloudcc":`Styl pełnostronicowy zapewnia maksymalną powierzchnię ekranu dla treści osadzanych w oknie CloudCC.com.`,
"label.sendemail.marketactivity.invitecode":`Kod zapraszający do kampanii #campaignname`,
"label.block.pricing":`Wycena według bloków`,
"message.error.field.number.zero":`Błąd wprowadzonego formatu długości, nie może być 0.`,
"pagecreator.systemstyle.message.save.success":`Styl zapisany pomyślnie`,
"pagecreator_systemstyle_label_styledesc":`Opis stylu`,
"APPIntegration_Dropbox_setting_01":`Włącz`,
"label_emailtocloudcc_redmessage2":`Proszę wprowadzić prawidłowe hasło do konta e-mail`,
"label.user.special.operations":`Używany tylko w pracy, nie może być używany tymczasowo, prosimy o kontakt z administratorem!`,
"pagecreator_page_label_layoutpreview":`Podgląd układu`,
"APPIntegration_Dropbox_setting_03":`Włącz opcję Dropbox, aby umożliwić wybieranie plików z Dropbox i dodawanie ich jako załączników.`,
"label.sure_leave":`Czy na pewno chcesz wyjechać?`,
"label.applt.copylink":`Kopiuj Link do miniprogramu`,
"label_tabpage_allpotentialcustomers":`Wszystkie tropy`,
"label.rulestrikedate":`Czas wyzwalania reguły`,
"label_tabpage_justsz":`Tylko`,
"label.customize.memory.function.sorting.title":`Dostosuj moją pamięć Funkcja sortowania`,
"message.duplication.label.mergebutton":`Merge`,
"chatter.group.cancelRequest":`Anuluj prośbę`,
"label.campaign.channel.step6.remark":`Jeśli potwierdziłeś stronę rejestracji, kliknij przycisk Generuj, aby wygenerować stronę rejestracji.`,
"label.appupload.upload.install.abort":`Anuluj instalację`,
"label.emailobject.proposetimes":`Proponowane godziny`,
"label.probability.cannot.empty":`Musisz wprowadzić liczbę w swojej możliwości.`,
"vue_label_homepage_editkanban":`Edytuj Kanban`,
"lable.Related.template":`Odpowiednie szablony`,
"label.cloudccclass.list.cls.time":`Zaplanowane zajęcia`,
"component.task.label.enddate":`Data wygaśnięcia`,
"label.sendmail.step3":`Krok 3 Przegląd i potwierdzenie`,
"label.projectManagement.Gridview":`Widok siatki`,
"label.emailobject.time":`Czas`,
"label.applt.address":`Portal Obsługi Klienta Miniprogramu`,
"label.searchfield":`Pola wyszukiwania`,
"vue_label_calendar_please_enter_the_name":`Proszę wpisać nazwę`,
"label.list.userinterface.default.page.setup":`Strona domyślna systemu`,
"label.detail.2018":`Szczegóły`,
"label.webtocloudcc.success":`Twoje dane zostały przesłane pomyślnie. Dziękujemy bardzo za udział, będziemy służyć Państwu z całego serca.`,
"component_telerecord_label_title":`Nagraj telefon`,
"label.setting.sureDelete.rules":`Czy na pewno chcesz usunąć tę regułę?`,
"vue_label_email_current_theme":`Wstawienie tego szablonu pokryje aktualny temat wiadomości e-mail.`,
"lable.Order.product":`Zamów produkt`,
"UG_product_02":`Produkty odnoszą się do produktów lub usług, które są sprzedawane lub kupowane.`,
"label.appexchange.task":`Zadania przepływu pracy`,
"label.selectprocesscondition":`Określenie warunków dla etapu`,
"label.mobile.quickcreate.default.scan":`Skanuj`,
"label.tabpage.prepagez":`Wyświetlanie na każdej stronie`,
"label.query.error":`Błąd zapytania.`,
"label.tabularreport.2018.step1":`Krok 1 Wybierz kolumny raportu`,
"pagecreator.systemstyle.label.modifystyle":`Edytor stylu`,
"label.app.step3":`Krok 3 Wybierz źródło obrazu dla niestandardowego logo aplikacji`,
"label_tabpage_rowsz":`Usuń wiersze`,
"label.validate.function.funcExplain.SUBSTITUTE":`Zastępuje nowy_tekst starym_tekstem w łańcuchu tekstowym. Użyj SUBSTITUTE kiedy chcesz zastąpić określony tekst w łańcuchu tekstowym.`,
"vue_label_checkduplicate_select_data_to_merge":`Wybierz dane do scalenia`,
"vue_label_commonobjects_view_chart_displaymode":`Tryb wyświetlania`,
"label.industrialandcommercialverification.servicesetiings":`Ustawienia serwisowe`,
"label.refresh":`Odśwież`,
"label.taskfield":`Pola zadań`,
"label.notification.approval4":`【提交人】 zwraca się z prośbą o zatwierdzenie 【对象】`,
"label.group.isusing":`Aktywny`,
"label.language.settings":`Ustawienia języka`,
"front-kefu-moudle-please-login":`Proszę się najpierw zalogować`,
"label.page.double.line.cloudcc":`2 Kolumny z paskiem bocznym CloudCC.com`,
"folder.error.delete":`1. Bieżący folder zawiera raporty i nie może zostać usunięty! 2. Bieżący folder zawiera raporty ukryte i nie może zostać usunięty! Raport ukryty to raport utworzony na podstawie logicznie usuniętego obiektu (ustawienia-tworzenie-usuniętych obiektów pod obiektem), ponieważ obiekt nie jest faktycznie usunięty, więc raport jest ukryty`,
"eight":`Osiem`,
"label.marketseamemset.user":`Członek`,
"label.recordnum":`Numer zapisu`,
"page.404.button.back":`Powrót do poprzedniego kroku`,
"label.mobile.phone.month.plan":`Plany na następny miesiąc`,
"label.marketseamemset.account.title2":`Proszę ustawić górny limit liczby klientów, który dotyczy wszystkich członków. Limit ten nie jest związany z pulą ołowiu`,
"vue_label_chatter_current_avatar":`Aktualny awatar`,
"label.mobile.side.tab.remark3":`Przytrzymaj wciśnięty przycisk Shift i kliknij lub kliknij przeciągnij, aby zaznaczyć serię sąsiadujących elementów. Przytrzymaj wciśnięty przycisk Ctrl i kliknij, aby zaznaczyć wiele niesąsiadujących elementów.`,
"component.sendmail.label.touser":`Odbiorca`,
"label.homeitems.noobject":`Nr Tematy`,
"template.report.overall.sales":`Całkowity okres sprzedaży (wg źródła leadów)`,
"label.partner.donotdel":`nie można usunąć`,
"label.service.miniProgram.bindCopyDesc":`Po powiązaniu organizacji z oficjalnym kontem firmy lub mini programem, możesz użyć tego adresu jako własnego portalu obsługi klienta, kopiując i przeskakując na ten adres jednym dotknięciem.`,
"UG_Contract_01":`Zarządzaj umową`,
"UG_quota_06":`Utwórz ofertę`,
"vue_label_report_deletereport":`Usuń raport`,
"front-epwechat-module-v1-input-appname":`Proszę wpisać nazwę aplikacji`,
"label_tabpage_deleteviewsuccess":`Zobacz sukces usuwania`,
"component_chatter_label_mygroup":`Moja grupa`,
"label.campagin.roi.leixing":`Typ kampanii`,
"label.dashboard.myHomepageDashboard":`Moja strona główna Pulpity nawigacyjne`,
"UG_solution_04":`Rozwiązanie w zakresie importu`,
"label.knowledge.setting.hint.four":`Aktywuj wiedzę`,
"label.campaign.channel.add.field":`Kliknij przycisk, aby dodać pola`,
"label.eastem.european.time":`Czas wschodnioeuropejski`,
"label.partner.workspace.member.partner":`Profil partnera CloudCC`,
"label.campaignmember.main.backtocampaign":`Powrót do Kampanii`,
"label.reportsSubscriptionPage.schedulereport.monthly.time.absolute":`Absolutny`,
"label.task.unsolve":`Wszystkie otwarte zadania`,
"label.multilang.chatterservice.vote":`{0} bilet(y)`,
"label.console":`Konsola`,
"label.emailsync.message1":`Jeśli anulujesz połączenie, nie będziesz mógł synchronizować zawartości skrzynki pocztowej z leadami i kontaktami, czy na pewno chcesz anulować?`,
"pagecreator.systemstyle.label.stylename":`Nazwa stylu`,
"setup_mainpage_label_welcome16":`Instrukcje: Kliknij w menu po lewej stronie strony → Ustawienia aplikacji → Utwórz → Przepływ pracy, Proces zatwierdzania, Zadania, Powiadomienia e-mail, Aktualizacja pól i inne.`,
"message.duplication.label.editfilterule":`Znajdź duplikaty reguł filtra`,
"Account.News.Setting.004":`Włączanie nowości`,
"label_tabpage_saveviewsuccess":`Widok zapisany pomyślnie`,
"label.forecast.forehistory.replacecommit":`Zastąpienie zobowiązania`,
"pagecreator_button_cancel":`Anuluj`,
"label.knowledge.article.nomatch":`Nie można zarchiwizować tego artykułu dla powiązanej wersji roboczej. Proszę usunąć wersję roboczą i spróbować ponownie.`,
"vue_label_combined_field":`Brak pól do sumowania.`,
"label.batchadd.save.prompt":`zapis(y)`,
"label.tabpage.summaryway":`Streszczenie Przez`,
"label.check.input.condition.two":`SQL nie jest obsługiwany`,
"mail.apiCode.notOnly":`Ta jedyna nazwa już istnieje`,
"UG.quota.01":`Zarządzaj kwotami rachunków`,
"label.approved.receiveApprovalEmail.option3":`Tylko jeśli jestem oddelegowanym zatwierdzającym`,
"label.stdashbord.xsld.business.img5":`Całkowita kwota prawdopodobieństwa 0%`,
"vue_label_chat_movedfromto":`{name} przeniósł {label} z {oldField} do {newField}.`,
"label.customfields.new.step2.opration":`Opcje ogólne`,
"label.dashboardSetup.isurl":`Dodaj linki`,
"label.forecast.settings.mrfwqj":`Cykl prognozy`,
"label.campaign.channel.field":`Pola`,
"label.weixin.optionthree":`Wybór 3`,
"label.safetystatement":`Deklaracja bezpieczeństwa`,
"label.useskipwizard":`Użyj Kreatora Jump Start`,
"label.projectManagement.completion":`Status ukończenia`,
"label.customfields.fielddependency.new.step2":`<b>Krok 2</b> Na następnej stronie edytuj reguły filtrowania, które kontrolują wartości pojawiające się w polu zależnym dla każdej wartości w polu kontrolnym.`,
"setup.mainpage.label.welcome8":`Dostosowywanie interfejsu metodą "przeciągnij i upuść`,
"label.emailobject.list.outbox":`Skrzynka nadawcza`,
"label.app.default.login.tab":`Domyślna karta logowania`,
"label.follow_emails":`Email followup to świetny sposób na szybki i łatwy kontakt z odwiedzającymi po wysłaniu przez nich formularzy.`,
"vue_label_homepage_application_page":`Strona główna aplikacji`,
"label.confirm.template":`Potwierdź`,
"lable.product.not":`Nie może być kompletny skreślić`,
"label.multilang.feedtrack.dispalyinfo":`Możesz wybrać maksymalnie {0} pól:`,
"label.weixin.plz.inputsrhkey":`Proszę wprowadzić słowo kluczowe do wyszukiwania`,
"label.projectManagement.service.appointment":`Nominacja na usługę`,
"label.list.userinterface.watermark.enable":`Włącz znaki wodne na stronie głównej, w widokach, stronach szczegółowych, raportach i pulpitach nawigacyjnych na komputerze i w aplikacji mobilnej.`,
"label.confirmDelete":`Czy na pewno chcesz usunąć te dane?`,
"label.sso.description":`Użytkownicy mogą uzyskać dostęp do systemu CloudCC.com bez logowania zgodnie z nazwą użytkownika i kod autoryzacji.<br>Kliknij adres URL poniżej, aby uzyskać dostęp do systemu CloudCC.com: http://localhost:8080/ssologin.action?userName=admin@dev.com&authCode=dcc5c192facd7c08e124fbe93d8950b9 .<br>Użyj linków powyżej, 'http://localhost:8080' proszę zastąpić organizacji dostęp do linku.'admin@dev.com' proszę zastąpić nazwę użytkownika organizacji.<br>'dcc5c192facd7c08e124fbe93d8950b9' proszę zastąpić kod autoryzacji organizacji.`,
"errormessage_email_atleastonereceiver_z":`Musisz wybrać lub edytować adres odbiorczy.`,
"C":`Podsumowanie rozwinięcia`,
"label.service.major.event.edit":`Edytuj kamień milowy`,
"label.icon.9":`Serwis`,
"label.visualpage.notvalidate.check":`Nieprawidłowe strony niestandardowe, zapoznaj się z tekstem pomocy, aby sprawdzić stronę.`,
"label.audit.todo.from":`z`,
"label.directboss":`Osoba na tym stanowisku podlega`,
"label.manageAll.selpage":`Strona`,
"label.console.step6.all":`Pełny ekran, bez poprawek, a listy są widoczne tylko wtedy, gdy wybrana jest zakładka nawigacyjna.`,
"vue_label_pool_expiredate":`Data wygaśnięcia`,
"lable.no.matching.record":`Brak pasującego rekordu`,
"label.standard.redirecterror":`Skok do strony niestandardowej poprzez standardowe przyciski nie powiódł się.`,
"label.Platform.Setting":`Ustawienia platformy`,
"lable.outlook.edit.havenewc":`Kontakty z ostatnio utworzonymi działaniami`,
"label.partnerCloud.partnerAccount.choosePayment":`Proszę wybrać metodę płatności`,
"label.weixin.optionsix":`Wybór 6`,
"lable.SalesCommitmentKanBan.allCommitments":`Rurociąg`,
"page_404_button_toknowmore":`Dowiedz się więcej`,
"label.customfields.number.tip":`Umożliwia użytkownikom wprowadzenie dowolnej liczby. Zera wiodące są usuwane.`,
"label.import.index.processimport":`Importowanie`,
"label.quote.phone":`Telefon`,
"label.insert.approval":`Wstawić zatwierdzenie`,
"label.tabpage.printview":`Widok Wydruku`,
"lable.product.price":`Cena`,
"front-kefu-moudle-call-detail":`Zadzwoń po szczegóły`,
"label.umeng.approval.apply":`stosować`,
"label.background.the.form":`Tło formularza`,
"chatter.f":`Followers`,
"label.quickbooks.searchresault.company":`Firma`,
"vue_label_systemSettings_platformutils":`Platforma Narzędzie`,
"front-quotation-v1-nofilles-tocreate":`Proszę kliknąć Generate Quote i wysłać po wygenerowaniu.`,
"label.category.6":`Leczenie medyczne`,
"label.attendance.choose.positon":`Wybierz punkty orientacyjne`,
"label.batchadd.newbatchpage.save.pho":`Nieprawidłowy format telefonu`,
"UG.Account.01":`Kto jest Twoim kontem?`,
"label.marketseamemset.addspecialuser":`Dodaj członków specjalnych`,
"label.query.detail.forbidpartneruser":`Zakazać użytkownikowi partnera`,
"label.stdashbord.xsld.business.ydzhl":`Won Rate`,
"vue_label_SMS_mymessagebox":`Moja skrzynka wiadomości`,
"label.knowledgebase.data.publishing.failed":`Publikacja {a} danych nie powiodła się. Proszę wybrać artykuł o statusie równym Draft do publikacji.`,
"label.wholestate":`Status ogólny`,
"label.selectedline":`Wybrane kolumny`,
"label.validate.function.funcExplain.LEFT":`Zwraca określoną liczbę znaków od początku łańcucha tekstowego`,
"label.emailmerge.edittemplate.detail":`Szczegóły szablonu Mail Merge`,
"vue_label_checkduplicate_checkduplicate":`Sprawdź Duplikat`,
"label.knowledgebase.assign.articles":`Artykuły asenizacyjne`,
"label.tabpage.recordsz":`Zapis`,
"label.field.img.validate.error":`Nazwa zmiennej po $User jest błędnie wpisana lub jest to nielegalne odwołanie do $User, proszę sprawdzić pisownię.`,
"workorderlineitem.worktype.isnot.father.worktype":`Należy wybrać rodzaj pracy związany z jej rekordem nadrzędnym dla tej pozycji zlecenia.`,
"label.ccchat.group.name.noexist":`Wprowadzona nazwa grupy nie istnieje, proszę wprowadzić ją ponownie.`,
"label.weixin.sign.type":`Błąd typu Sign in (out).`,
"label.nowvaluereplace":`Zastąpić istniejącym`,
"report_label_report":`Raporty`,
"label.knowledge.setting.plus":`Plus Ustawienia wiedzy`,
"label.event.moveup.2day":`2 dni naprzód`,
"label.translation.start":`Aby rozpocząć pracę z programem Translation Workbench:`,
"lable.PowerProcess.created.time":`W oparciu o czas utworzenia {detailInterestType}`,
"label.ems.step2":`Krok 2`,
"label.tabpage.groupingemptyz":`Elementy grupowania nie mogą być puste`,
"pagecreator.layout.button.new":`Nowy układ`,
"label.tabpage.listshow":`Lista pokazuje`,
"label.partnerCloud.productSet.optionName":`Nazwa opcji`,
"label.service.without.cycle":`Brak cyklu`,
"label.chatter.sendEmailToGroupMember.subject.V":`{0} opublikował głosy na wszystkich w {1}`,
"label_target_model_dimension":`Wymiary modelu docelowego`,
"component.task.label.subject":`Temat`,
"label.custom.field.login.query.information":`Proszę wejść do systemu i zobaczyć szczegóły.`,
"label.validate.function.funcExplain.NOT":`Zmień FALSE na TRUE lub zmień TRUE na FALSE`,
"pagecreator_layout_button_horizontal":`Demontaż boczny`,
"lable.Returned.to.successful":`Powrót z powodzeniem`,
"label.campaign.channel.ticket.title":`Bilet wstępu`,
"label.ruleName.supportMaximum.50Characters":`Nazwa reguły może zawierać maksymalnie 50 znaków.`,
"label.email.track.attachment.size.control1":`Całkowity rozmiar załącznika przekracza 20m, nie można go przesłać`,
"template.report.folder.opportunities":`Analiza możliwości`,
"label.knowledge.setting.data.eight":`Usuniesz grupę kategorii {flzmc} i jej kategorie. Kategoria ta nie będzie dostępna do przypisania do rekordów. Masz 15 dni na anulowanie usunięcia grupy kategorii. Po 15 dniach zostanie ona trwale usunięta i nie będzie można jej odzyskać. Czy na pewno chcesz usunąć tę grupę kategorii i jej kategorie?`,
"mail.id.notNull":`Identyfikator nie może być pusty przy usuwaniu szablonu`,
"vue_label_normal_product_sf":`Produkt`,
"vue_label_report_superiortothisrelationship":`Relacja pomiędzy obiektem nadrzędnym a tym obiektem`,
"label.leadscore.operation":`Operator`,
"label.customfields.formula.percentexample":`Rabat = (Kwota - Rabat_Amount__c) / Kwota`,
"component.setup.iframe.label.inputurlmemo":`Proszę wpisać adres url strony, która ma zostać zaimportowana.`,
"label.icon.177":`Logo`,
"label.tabpage.myz":`Mój`,
"label.leadmarketsea.add.title":`Utwórz pulę leadów`,
"label.partnerCloud.partnerAccount.thePage":`Strona {skippageNum}`,
"label.visualpage.some.size":`Pojemność kodu: maksymalna obsługa znaków 300 KB, około 300 000 bajtów.`,
"label.setwxpay.null":`Informacje wymagane do skonfigurowania płatności WeChat są puste.`,
"label.icon.74":`Obrabiarka`,
"font-evaluate-module-v1-evbad":`Rodzaj oceny Negatywna`,
"System.TimeField.Format.Warning":`Nieważna godzina`,
"label.captcha":`Losowy kod weryfikacyjny`,
"label.payment.assessment":`Sprawdź inne wydania`,
"message.error.not.taskevent":`Obiekt zdarzeń nie będących zadaniami`,
"font-evaluate-module-v1-evaluation":`Wycena`,
"vue_label_commonobject_view_updatedago":`Zaktualizowano {timeInterval} temu`,
"label.sendemail.birthday.newevent":`Drogi {!ownerName}： Urodziny {!objectLable} {!recordName} odbędą się za 3 dni. Proszę być świadomym, że {!orgName}`,
"label.laststep":`Poprzedni Krok`,
"message.duplication.label.matchoption":`Opcja dopasowania`,
"label.setupmultplerecordtype":`Wiele typów rekordów`,
"vue_label_account_unprocessed_oppprtunities":`Nieprzetworzone możliwości`,
"KeyInformationLayout.DefaultLayout.Name":`Domyślne ustawienia systemu`,
"label.partner.all":`Wszystkie części chmury`,
"label.datamanage.export.error":`Eksport nie powiódł się`,
"label.standard.buttonandlink":`Standardowy przycisk lub łącze`,
"label.reportsSubscriptionPage.email":`Raport e-mail`,
"message.nogrammarfaultinformula":`Brak błędów składni.`,
"front-kefu-moudle-nofind-instance":`Nie znaleziono instancji`,
"label.is.delete.data":`Rekordy, które chcesz usunąć, zawierają rekordy z prośbą o zatwierdzenie, czy na pewno chcesz je usunąć?`,
"label.partner.error":`Błąd: błąd formatu domeny`,
"label.notification.time2":`{0} minut temu`,
"label.ccchat.person.invite.needfirstname":`Wpisz swoje imię i nazwisko`,
"label.mr.title.URL":`URL`,
"chatter.norecord":`Brak zapisów.`,
"label.readwrite":`Odczyt/zapis`,
"label.partnerCloud.orderingPlatform.orderPayment":`Zamówienie Płatność`,
"label.accesslimittype":`Poziom dostępu`,
"label.preciew_tab":`Podgląd linku w nowej karcie`,
"label.attachment":`Załącznik`,
"label_tabpage_helpNavigationz":`Pomoc i nawigacja`,
"label.dataimport.select":`Sprawdź te informacje, wykonaj import danych`,
"chatter.en.info":`Wprowadź informacje, aby ludzie mogli dowiedzieć się więcej o Tobie.`,
"label.ccservice.validate.date":`Format odpowiedniej wartości {2} pola {1} w obiekcie API {0} jest nieprawidłowy. Proszę wprowadzić prawidłowy format daty lub czasu!`,
"label.social.posts.send":`Nie udało się wysłać`,
"label.emailobject.time.to":`Do:`,
"label.defineReportStep1":`Krok 1`,
"savefail":`Zapisanie nie powiodło się`,
"label.mr.descreption.title":`Łączenie zduplikowanych danych`,
"label.share.info.by":`Przez`,
"label.list":`Lista`,
"label.event.select":`Wybrane`,
"message.accountmap.cannotfind":`Adres konta nie został odnaleziony, prosimy o aktualizację adresu konta.`,
"label.choosefield":`Pola strony zatwierdzania`,
"label.forecast.settings.title":`Ustawienia prognoz`,
"label.setup.log.datetime":`Pobieranie dziennika zachowań w wyszukiwanym zakresie czasowym (Excel.xls)`,
"button_partner_new":`Nowa chmura partnerska`,
"label.umeng.approval.dlsp.reject":`#approvalname odrzucił wniosek #actorname o zatwierdzenie #objAPIName #recordname dla Ciebie.`,
"label.tabpage.totalTeamz":`Łącznie grupy`,
"label.lead.score.prompt3":`Może to potrwać kilka minut. Po zakończeniu otrzymasz wiadomość e-mail z potwierdzeniem.`,
"label.schedulejob.setup.schedule.name":`Nazwa stanowiska pracy`,
"vue_label_report_advanced":`Gdy filtr zaawansowany jest włączony, wpisz ręcznie warunek filtrowania w polu filtra zaawansowanego poniżej, w formacie przedstawionym na rysunku.`,
"label.emailsync.form.connecttime":`Czas pokrewny`,
"front-gantt-module-v1-project-status":`Status projektu`,
"label.field.for.example":`Na przykład`,
"label.marketsea.manager.notnull":`Administrator nie może być pusty.`,
"label.click.here":`&lt&lt Kliknij tutaj, aby powrócić`,
"UG.solution.04":`Rozwiązanie w zakresie importu`,
"label.validate.function.funcExplain.IF":`Czy warunek jest prawdziwy czy nie, i jeśli warunek jest TRUE zwraca jedną wartość, a warunek jest FALSE, zwracana jest inna wartość.`,
"label.profile.settab":`Ustawienia zakładki`,
"front-email-payment-weichat-tips":`Zeskanuj kod QR, aby zapłacić`,
"label.task.next.week":`Następny tydzień`,
"label.operatedata.selectobjectfields.tip":`Wybierz pola, które chcesz wyeksportować, i musisz wybrać przynajmniej jedno pole do eksportu.<font color="red">Uwaga:Obszar tekstowy (bogaty) nie może być eksportowany.</font>`,
"label.recalculate.alert":`Proszę wybrać regułę udostępniania, którą chcesz przeliczyć.`,
"label.marketsea.noopportunitydays":`Dni bez tworzenia możliwości biznesowych (musi być większa niż liczba dni bez kontynuacji po pozyskaniu)`,
"label.chat.likeperson":` Osoba(y)`,
"label.selectedFields":`Dostępne pola`,
"label.App":`Zastosowania`,
"label.file.type":`Typ pliku`,
"permissionService.error1":`Niewystarczające pozwolenie na złożenie wniosku.`,
"front-detail-module-v1-chart-display":`Wyświetlacz wykresu`,
"label.audit.status":`Status zatwierdzenia`,
"UG.activity.05":`Telefon nagrywający`,
"label.connectOtherObject":`( Kliknij, aby odnieść się do innego obiektu )`,
"lable.currencyManage.unEnabledadvcurrency":`Wyłącz Zaawansowane zarządzanie walutą`,
"label.ccpeak.getthree.function":`Istnieją trzy funkcje, oraz`,
"label.weixin.new.weitoupiao":`Proszę utworzyć nowe mikro głosowanie, użytkownicy mogą brać udział w głosowaniu i mieć dostęp do wyników głosowania w mikro wydarzeniach na WeChat.`,
"label.tag.manage.prompt":`Tag już nie istnieje".`,
"label.goon":`Kontynuuj`,
"label.addworkflowoperate":`Dodaj akcję przepływu pracy`,
"label.weixin.click.search":`Kliknij, aby wyszukać rekord`,
"vue_label_report_deletecolumn":`Usuń kolumnę`,
"label.ordercondition":`Sort By`,
"message.error.group.notallow":`Grupa nie pozwala na archiwizację`,
"label.unread":`Nieprzeczytane wiadomości email`,
"vue_label_report_notice_namerequired":`Nazwa kolumny jest wymagana`,
"label.tabpage.entercontent":`Proszę wpisać treść`,
"label.schedulejob.setup.schedule.startdate":`Data rozpoczęcia`,
"component_assistant_button_newtask":`Nowe zadanie`,
"vue_label_report_notice_filter1":`Musisz ręcznie wypełnić poniższe filtry zaawansowane, jak pokazano na rysunku, gdy włączysz filtr zaawansowany`,
"value":`Wartości`,
"label.icon.70":`Serwis`,
"label.knowledgebase.delete.draft.t":`Usuń projekt`,
"label.setup.mini.bind":`Wiązanie miniprogramów`,
"component_timeline_button_more":`Więcej kroków`,
"label_emailtocloudcc_redmessage4":`Proszę wprowadzić dane dotyczące portu`,
"label.field.input.number":`Proszę wpisać prawidłowe liczby`,
"front-invoice-online-payment-setup-title":`Rozpocznij płatność online`,
"front-kefu-moudle-called-user":`Osoba wezwana`,
"label.currency.disable":`Waluty nieaktywne`,
"label.user.alias":`Alias`,
"UG_quota_04":`Cytat z druku`,
"label.chatter.delete":`Usuń`,
"label.addtocurrentcustomer":`Dołączone do istniejących rachunków`,
"message.error.recordid.null":`recordid nie może być pusty!`,
"label.merge.records":`Łączenie rekordów`,
"report_label_norole":`Nie masz na to pozwolenia, skontaktuj się z administratorem.`,
"label.pqrs":`.`,
"label.email.attach.button":`Kliknij przycisk "Załącz".`,
"label.tabpage.selrecordtypez":`Wybierz typ rekordu`,
"label.ServiceCloud.purchase.date":`Data zakupu`,
"label.customreporttype.delete.prompt":`Proszę usunąć następujący raport przed wykonaniem operacji usunięcia`,
"label.brief.total.page":`Łącznie {całkowicie} strona(y)`,
"label.reportsSubscription.unsubscribe":`Zrezygnuj z subskrypcji`,
"label.ccpeak.take.notice.exp.order":`Uwagi: należy dodać "__c" po nazwie API pól w warunkach eksp i zamówienia.`,
"report_type_label_quote":`Cytaty`,
"label.file.norecord":`Brak elementów do wyświetlenia`,
"vue_label_checkduplicate_all_processed":`Wszystkie dane zostały przetworzone`,
"label.next":`Następny`,
"label.icon.10":`Folder`,
"label.lanxin.title.setting":`Informacje zintegrowane`,
"label.h5.chatter.business":`Związane z tym możliwości`,
"lable.are.you.sure.to.delete.this.view":`Czy chcesz usunąć ten widok?`,
"vue_group_no_operation_permission":`Brak pozwolenia na działalność!`,
"label.knowledge.archive.article":`Artykuł archiwalny`,
"vue_label_lead_":`Brak aktywnych reguł scoringowych, prosimy o kontakt z administratorem systemu`,
"label.fiscal.error.between":`Data rozpoczęcia roku podatkowego lub data zakończenia roku podatkowego jest pomiędzy historycznymi latami podatkowymi, proszę sprawdzić i zresetować.`,
"label.stdashbord.xsld.business.qdzje":`Łączna kwota (możliwości zamknięte-wygrane)`,
"label.calendar.day.view":`Widok dzienny`,
"label.emailtocloudcc.tip":`Prompt`,
"label.schedulejob.setup.schedule.st1":`1.`,
"label_tabpage_addtoworkbench":`Dodaj do strony głównej stół warsztatowy`,
"label.umeng.approval.waitapproval":`czekać na zatwierdzenie`,
"label.justcheckingwebsite":`Weryfikuj tylko stronę internetową`,
"homepage.components":`Komponenty strony głównej`,
"label.audit.remark":`Uwagi zatwierdzające`,
"label.searchs.labelname":`Search {fieldlabelName}`,
"label.remarkofreport":`Sprawozdanie Uwaga`,
"label.weixin.isno":`czy`,
"label.currencyCode":`Kod waluty`,
"label.service.resources":`Zasoby`,
"label.clone_form":`Forma klonu`,
"label.weixin.view.information":`Zobacz szczegóły`,
"UG_activity_05":`Telefon nagrywający`,
"chatter.feed.menutype.user.recentuser":`Osoby, które ostatnio oglądały`,
"label.marketsea.notfollowdays2":`Dni bez działań następczych`,
"label.tabpage.namemandatory":`Nazwa widoku jest wymagana`,
"message.demo.nosupport":`Ta funkcja zostanie wprowadzona w następnym wydaniu.`,
"label.mail.merge.template":`Łączenie szablonów wiadomości e-mail......`,
"label.sendemail.marketactivity.sign":`Powiadomienie o znaku kampanii`,
"setup_layout_group_relatedlist":`Powiązane listy`,
"label.pc.ui.2018.all.tabs":`Wszystkie menu`,
"label.field.lost.right.bracket":`Zagubiono uchwyt zamykający`,
"label.datamanage.contact.novalue":`Uwaga: Jeśli pole nazwy kontaktu jest puste, rekordy kontaktu nie zostaną zaimportowane.`,
"label.version.unlimited.edition":`Edycja Nieograniczona`,
"vue_label_dashboard_selectsortfield":`Proszę wybrać pole sortowania`,
"label.partnerCloud.productSet.instructions":``,
"front-kefu-moudle-v1-canuse-obj":`Widoczne dla`,
"thursday":`Czwartek`,
"label.nextapprover":`Następny zatwierdzający`,
"setup_mainpage_label_manageuser":`Zarządzaj użytkownikami`,
"label.saveandcontinue":`Zapisz`,
"label.top.userCenter":`Centrum osobiste`,
"component.chatter.file.button.save":`Opublikuj`,
"label_emailsync_setting":`Osobiste ustawienia poczty elektronicznej`,
"label.usableshareuser":`Dostępne Udostępnione Do`,
"label.customfields.optionlist.fieldvaluelist.letterrank":`Wyświetlaj wartości alfabetycznie, a nie w wprowadzonej kolejności`,
"label.list.button":`Przydział profilu`,
"chatter.up.m":`Error:Przesłane pliki są zbyt duże.Maksymalny rozmiar pliku to 20 MB.`,
"label.knowledgebase.filters":`{a} filtry`,
"label.sso.saml.sp.idtype.username":`Assertion zawiera nazwę użytkownika CloudCC.`,
"vue_label_file_size_limit":`Rozmiar pliku nie przekracza {size}Mb`,
"label.appupload.install.error.choice4":`Pomiń komponenty powodujące konflikty, nie instaluj komponentów powodujących konflikty`,
"label.currencyDecimalDigits":`Miejsca dziesiętne`,
"label.weixin.customer.details":`Szczegóły konta`,
"component.timeline.label.7daysahead":`7 dni przed`,
"label.sendsms.batch.step1":`Krok 1 Określenie odbiorców, którzy mają być uwzględnieni`,
"label.brief.opportunity1":`Możliwości`,
"label.datamanage.click.importbutton":`Kliknij <b>Import</b>, a dane zostaną zaimportowane do systemu CloudCC.`,
"label_filter_benchmark_objects":`Obiekt referencyjny filtra`,
"label.area.record.notexist":`Zapis ten nie istnieje.`,
"label.event.overdue.unfinished":`Wydarzenia zaległe`,
"label.file.publicview.errortype":`Typ pliku nie obsługuje podglądu`,
"label.setup.mobile.bottombutton.profile.setting":`Dostosuj dolne menu profilu`,
"label.campaignmember.main.addleaddesc":`Dodaj wszystkie istniejące leady do tej kampanii`,
"vue_label_approve_actual_operator":`Rzeczywisty operator`,
"label.version.essential":`Edycja podstawowa`,
"lable.SalesCommitmentKanBan.commitments":`Rurociąg`,
"label.chatter.pastEvents":`Wcześniejsze działania`,
"vue_label_calendar_choose_calendar_type":`Wybierz typ kalendarza`,
"label.service.dispatchingUnits.batch.send":`Przydzielanie partii`,
"chatter.poll.option8":`Wybór 8`,
"label_tabpage_summaryway":`Metoda podsumowująca`,
"front-kefu-moudle-trindex-copy-num":`Proszę skopiować numer przedsiębiorstwa na stronie głównej systemu Tianrun.`,
"lable.quote.syncing.syncfinish":`Synchronizacja zakończona`,
"label.home.task.finish":`Zadanie zakończone`,
"label.toleadfield":`Mapa Pola ołowiu`,
"label.everyone":`Wszyscy`,
"label.multilang.databatchadd.success":`{0} dane zostały dodane pomyślnie：`,
"label.quote.createdate":`Data utworzenia`,
"email.template.nopermission":`Tylko administratorzy mogą edytować szablony w tym folderze`,
"label.report.action.addtodashboard2":`Dodaj tablicę rozdzielczą`,
"label.campaign.name":`Nazwa kampanii`,
"label.check.input.condition":`Błąd składni, proszę sprawdzić wprowadzone kryteria filtrowania`,
"front-epwechat-module-v1-upload-file":`Prześlij dokument kredytowy:`,
"label.batchadd.newbatchpage.button.add":`Dodaj wiersz`,
"label.partnerCloud.footer":`Stopka`,
"lable.Enter.template.name":`Proszę podać nazwę płytki.`,
"label_tabpage_last":`Ostatni krok`,
"label.setup.mobile.bottombutton.setting":`Ustawienia strony pierwszego poziomu aplikacji mobilnej`,
"label_emailtocloudcc_filed_emailto":`E-mail do`,
"label.data.downpage.e_title.num3":`3. Użytkownicy mogą tworzyć szablony eksportu zgodnie ze swoimi potrzebami i wybierać pozycję "Eksportuj według szablonu", co może ułatwić operację eksportu.`,
"startwith":`Zaczyna się od`,
"vue_label_normal_cancel":`Anuluj`,
"label.reportTypcrtD":`Powiązany obiekt (d) proszę kliknąć, aby wybrać powiązany obiekt`,
"label.globalselect.disabledvalue":`Nieprawidłowa wartość`,
"vue_label_commonobjects_view_notice_deletecertification":`Czy na pewno chcesz usunąć wybrany rekord { selectNum }?`,
"front-epwechat-module-v1-bound-role":`Role związane`,
"label.partnerCloud.financeSetting.gaofilter":`Zaawansowane warunki filtrowania (np. 1 i 2 lub 3)`,
"label.quote.sprname":`Nazwa rozliczeniowa`,
"lable.asset.successfully":`Pomyślne przeniesienie produktu do aktywów.`,
"label.projectManagement.service.appointment.work.noedit":`Nie można edytować godzin pracy w ramach przydziału służbowego`,
"lable.tianyancha.h5.inputandsearch":`Wprowadź słowa kluczowe, aby wyszukać odpowiednie firmy`,
"label.customcomponent.check.tag.firstrow":`Pierwszy wiersz musi być`,
"label.knowledgebase.published.translations":`Opublikowane tłumaczenia również zostaną zarchiwizowane, a tłumaczenie w statusie Draft zostanie usunięte.`,
"vue_label_wang_yi":`Tom`,
"label.step3.total3":`Krok 3 z 3`,
"label.stdashbord.xsld.business.img6":`Całkowita liczba etapów oportunizmu z prawdopodobieństwem 100%/(Całkowita liczba etapów oportunizmu z prawdopodobieństwem 100% Całkowita liczba etapów oportunizmu z prawdopodobieństwem 0%)`,
"component_button_cancel":`Anuluj`,
"label.delete.false.not.exists":`Usunięcie nie powiodło się, ponieważ dane nie istnieją.`,
"label.appupload.install.error.choice1":`Proszę nie instalować`,
"label.Days.After.Horizontal.Date":`poziom data po`,
"setup_layout_button_additem":`Dodaj wybrane elementy`,
"UG.contact.05":`Utwórz kontakt`,
"label.form.title":`Formularz Tytuł`,
"label.horizontalbar-group":`Linie poziome - grupowanie wierszy`,
"component_sendmail_label_title":`Wyślij e-mail`,
"label.passwordPolicy.setup.neverexpires":`Nigdy nie wygasa`,
"label.sso.saml.idp.config.desc1":`Włącz CloudCC.com jako dostawcę tożsamości, aby można było korzystać z jednokrotnego logowania w innych witrynach internetowych`,
"label.chat.topic.desc.null":`Chcesz dowiedzieć się czegoś na ten temat? W menu rozwijanym w prawym górnym rogu wybierz opcję edytuj szczegóły.`,
"label.movablecustomerfield":`Pola niestandardowe Acitivity`,
"label.trigger.folder":`Niewypełnione foldery wyzwalaczy`,
"label.selectuploadfile":`Proszę wybrać plik, który chcesz przesłać.`,
"front-email-payment-card-tips":`Proszę wpisać numer karty`,
"label.tabpage.addcondition":`Dodaj warunek`,
"label.number.MinAndMaxCheck":`Minimum z {0} to {1}, maksimum to {2}. Proszę zmodyfikować ilość i zapisać zmiany.`,
"vue_label_dashboard_dashboard":`Udało się zmienić nazwę pulpitu nawigacyjnego`,
"label.objectDeleteList":`Usuń listę obiektów`,
"lable.service.gantt.and":`ORAZ`,
"label.emailtocloudcc.step2":`Krok 2`,
"label.chatter.postup":`Post Up`,
"label.personalsetting":`Ustawienia osobiste`,
"message.please.choose.permission":`Proszę wybrać dostęp`,
"label.mobile.move":`Aplikacja mobilna`,
"label.Choose":`Wybory`,
"label_chatter_vote":`Sondaż`,
"label.weixin.user.select.one":`Wybierz użytkownika`,
"pagecreator.page.label.modifypage":`Redaktor strony`,
"label.select.partOrField":`Wybierz sekcje lub pola, które mają być kontrolowane`,
"vue_label_helpcenter_chat":`1. Komunikator internetowy<br> Zespół może zastąpić firmowy WeChat itp., umożliwiając wysyłanie wiadomości tekstowych, plików itp. do kolegów z firmy podczas pracy w systemie CRM. Kiedy każdy dział organizacji musi utworzyć działową grupę dyskusyjną, lider działu może zainicjować czat grupowy w Zespole i dodać członków działu do czatu grupowego.<br> 2. Tworzenie czatów grupowych dla klientów i rekordów możliwości biznesowych<br> Otwórz stronę szczegółów rekordu klienta lub możliwości biznesowych i kliknij przycisk "Zespół" w prawym górnym rogu, aby utworzyć czat grupowy na temat tego rekordu w Zespole. Jeśli czat grupowy nie został utworzony przez właściciela rekordu, właściciel rekordu również zostanie automatycznie wciągnięty do czatu grupowego. Inne osoby mogą wejść na czat grupowy klikając przycisk "Zespół" w prawym górnym rogu strony szczegółów rekordu lub po dodaniu przez właściciela grupy.<br> 3. 3. Śledzenie rekordów w czacie grupowym<br> Utwórz czat grupowy dla klientów i rekordów możliwości biznesowych zgodnie z metodą opisaną w punkcie 4.2 i możesz śledzić dynamikę rekordów w czacie grupowym, wysyłając karty. Jeśli użytkownik ma dostęp do przeglądania rekordów na karcie, po kliknięciu na kartę może bezpośrednio przejść do strony ze szczegółowymi informacjami o odpowiednim obiekcie.<br>Śledzenie zmian pola rekordu w czacie grupowym<br>Gdy rekord jest skonfigurowany z listą powiązaną "Śledzenie pól" i pola, które muszą być śledzone są skonfigurowane, gdy śledzone pole się zmienia, asystent strategii grupowej w czacie grupowym wyśle kartę z informacją o zmianie pola do grupy.<br> Śledzenie wszystkich zmian w czatach grupowych<br> Gdy zmieni się właściciel rekordu, asystent strategii grupowej na czacie grupowym wyśle kartę z informacjami o zmianie właściciela do grupy.<br>Śledzenie działań w czatach grupowych<br> Po utworzeniu czatu grupowego rekordu, jeśli zostanie utworzone nowe zadanie lub wydarzenie dotyczące tego rekordu, asystent strategii grupowej na czacie grupowym wyśle kartę z podstawowymi informacjami o zadaniu lub wydarzeniu do grupy.<br> Śledzenie i rejestrowanie nowego rekordu listy powiązanej w czacie grupowym<br> Po utworzeniu czatu grupowego rekordu, gdy zostanie dodany rekord listy powiązanej, asystent zespołu w czacie grupowym wyśle do grupy kartę z podstawowymi informacjami o nowo dodanym rekordzie. Na przykład: gdy nowy kontakt jest dodawany do listy kontaktów rekordów klienta, karta "Nowy kontakt" zostanie otrzymana w czacie grupowym klienta, a podstawowe informacje o nowym rekordzie można zobaczyć na karcie.`,
"label.tianyancha.business":`Informacje dotyczące rejestracji działalności gospodarczej`,
"chatter.group.groupMembersToFind":`Wyszukiwanie członków grupy`,
"label.pc.ui.2018.pin.top":`Przypnij do góry`,
"label.forecast.forehistory.submitor":`Zgłoszony przez`,
"vue_label_email_send_emails_separately":`Pomyślne wysyłanie wiadomości e-mail`,
"vue_label_homepage_select_display_field":`Wybierz pole`,
"label.partnerCloud.partnerAccount.accountBalance":`Bilans`,
"label.sendemail.template":`Wybierz szablon wiadomości e-mail`,
"label.service.violated":`Naruszony`,
"label.manageAll.title":`Centrum Zatwierdzania`,
"label.forecast.settings.qy":`Włącz udostępnianie prognoz`,
"label.detailofshare":`Udostępnianie szczegółów reguły`,
"label.multilang.passwordpolicy.chechlength":`Błąd: Hasło nie może być krótsze niż {0} znaków:`,
"label.visualpage.filesave.error":`Zapis pliku nie powiódł się, proszę spróbować ponownie.`,
"vue_label_campaign_please_select_member_status":`Proszę wybrać status członka`,
"homepage.components.sort":`Zamówienie komponentów`,
"label.brief.thismonth":`W tym miesiącu`,
"label_emailsync_connectaccount_description":`Dodaj tutaj swoją osobistą skrzynkę pocztową, a CloudCC będzie automatycznie dopasowywać leady i kontakty w systemie na podstawie ich adresów e-mail, synchronizować treść wiadomości e-mail z rekordami, aby ułatwić śledzenie i komunikację.`,
"label.sms.csid":`Podpis Numer`,
"label.ccdocument.remark":`Opis dokumentu`,
"label.forecast.customforecast.disdw":`Wyświetlacz`,
"label_tabpage_field":`Pole`,
"label.logintime.all":`Cały dzień`,
"UG_Account_06":`Załóż konto`,
"label.login":`Login`,
"label.dupicate.data.error":`Znajdź zduplikowane rekordy i błąd scalania, sprawdź.`,
"label.monitorsys.recent.logs":`Domyślnie wyświetlanych jest 200 ostatnich logów.`,
"message.chooseatleastonefield":`Wybierz co najmniej jedną dziedzinę`,
"lable.PowerProcess.name1":`Nazwa procesu nabywania uprawnień`,
"label.processdetail":`Szczegóły definicji procesu`,
"label.upload.file.size.limit":`Wczytywane pliki nie mogą przekraczać 2MB!`,
"label.forecast.userenablepage.desc":`Użytkownicy włączeni do funkcji Prognozy pojawiają się na liście Włączeni użytkownicy. Aby włączyć dostępnych użytkowników, należy dodać ich do listy Włączeni użytkownicy. Aby wyłączyć użytkowników, należy ich usunąć.`,
"label.visualpage.type.detailembed":`Instrukcja użycia strony własnej (styl strony to "detailEmbed")`,
"label.textmessage.vonage.configurations":`Konfiguracje`,
"label.report.select.chart.and.item":`Wybierz wykres i element podświetlenia`,
"label.data.downpage.i.title.num1":`1、System obsługuje tylko wspólny format CSV.`,
"label.mobileapp.scansetting":`Ustawienia funkcji skanowania aplikacji mobilnej`,
"chatter.emailFollow":`Śledzi`,
"label.weixin.businformation":`Dane pojazdu`,
"label.import.index.recentrecord":`Ostatni zapis dotyczący przywozu`,
"label.case.update":`Aktualizacja`,
"label.isEnableVisualpage.new.desc":`Wybierz dostępną stronę niestandardową z Dostępnych stron niestandardowych i dodaj ją do Wybranych stron niestandardowych, kliknij przycisk Zapisz. Następnie użytkownicy z tym profilem mają dostęp do aktywnych stron niestandardowych.`,
"label.emailobject.wizard.title":`Podłącz swój e-mail`,
"vue_label_ccchat_notice_deletepostsuccess":`Pomyślnie usunięty post`,
"label.deleteQuoteLine":`Usuń wiersz cytatu`,
"label.integrations.export.failed.Mailchimp":`Eksport nie powiódł się, proszę sprawdzić połączenie sieciowe i spróbować ponownie później.`,
"label.increase":` Plus`,
"label.setup.mobile.homepageshortcuts.setunable":`Moduł nie wyświetla się na stronie głównej`,
"label.ccchat.person.invite.toolong":`Nie można wprowadzić tekstu, który przekracza 255 znaków`,
"label.knowledge.setting.help":`Samoobsługa klienta Pomoc`,
"label.is_pigeonhole":`Archiwum`,
"message.atleastonecommitter":`Co najmniej jeden zgłoszony przez kogo`,
"label.emailobject.wizard.desc4":`Wstaw proponowany czas, aby ułatwić umawianie spotkań dla wielu osób`,
"APPIntegration_Dropbox_setting_02":`Niepełnosprawni`,
"template.report.open.opportunities":`Niezamknięte możliwości`,
"label.goonwork":`Kontynuuj pracę`,
"label.isiands.time":`Czas Izjandów`,
"label.enable.rules.enableOnlyOneqrcodeOrbarcode":`Włączone reguły (każdy obiekt obsługuje tylko jeden QR Code lub Bar Code)`,
"label.summaryreport.2018.step2":`Krok 2 Podsumuj informacje poprzez:`,
"pagecreator.systemstyle.message.delete.success":`Styl usunięty pomyślnie`,
"label.standarduser":`Użytkownicy standardowi`,
"label.reportsSubscription.succeeded":`Subskrybuj raport pomyślnie!`,
"lable.Select.a.template":`Wybierz istniejący szablon jako podstawę nowego szablonu.`,
"label.file.library.addfile2libsuccess":`Załadowano {0} plik(i)!`,
"label.searchfield.instruction":`Pole wyszukiwania jest polem, które służy do wyszukiwania globalnego lub wyszukiwania pojedynczego obiektu.Jeśli nie jest zaznaczone domyślnie wyszukiwane jest przez wybrane pola wyników wyszukiwania.`,
"U":`URL`,
"label.Time.slot.overlap":`Jeden lub wiele przedziałów czasowych ma nakładające się zakresy czasowe. Proszę zaktualizować do przedziału czasowego, który nie nakłada się na siebie.`,
"vue_label_chat_opportunity_details":`Szczegóły możliwości`,
"label.knowledge.category.hint.seven":`Wybrana grupa kategorii`,
"label.chatter.list":`Lista`,
"front-email-payment-Invoice-preview":`Podgląd faktury`,
"label_emailsync_message1":`Jeśli anulujesz połączenie, nie będziesz mógł synchronizować zawartości skrzynki pocztowej z leadami i kontaktami, czy na pewno chcesz anulować?`,
"label.summaryreport.step5":`Krok 5 Określenie kolejności kolumn w raporcie`,
"component_newrecords_label_name":`Nazwa`,
"label.appointment.wizard.subtitle4-4-5":`2 miesiące`,
"component_salesperformance_label_title":`Wyniki sprzedaży`,
"label.ccchat.person.invite.says":`Powiedz:`,
"label.fax":`Faks`,
"label.knowledge.modify.article":`Zmodyfikuj artykuł`,
"label.componenteditor.Limit.number.components":`Na jednej stronie można dodać do 15 komponentów.`,
"label.multilang.forecast.shrepage.desc":`Na tej stronie zostanie wyświetlona lista użytkowników, ról i regionów, którzy mają współdzielony dostęp do {0}.`,
"label.chat.micropost.write.comment":`Napisz komentarz`,
"Lead.Scoring.Setting.Rule.Setup.Active":`Aktywny`,
"label.ccpeakfolder.time":`Foldery z planowanymi zajęciami`,
"label.partnerCloud.financeSetting.filter":`Warunki filtrowania:`,
"label.knowledge.delete.topicassignment":`Błąd podczas usuwania przypisania przedmiotu`,
"label.file.orderbyname":`Sortuj według tytułu`,
"vue_label_chat_activelater":`Aktywny później`,
"chatter.reply":`komentarz`,
"label.setup.profile.accordtext":`Zgodnie z tekstem`,
"label.encd.plaintext":`Pokaż czysty tekst`,
"label.h5.approval.cannotreassignmark":`Delegowane projekty zatwierdzenia nie mogą zostać ponownie przypisane, proszę ponownie wybrać projekty zatwierdzenia.`,
"label.version.area.lookup":`Obszar tekstowy lub pola relacji wyszukującej (multi-select)`,
"approval.request.email.body":`Następujące pozycje wymagają zatwierdzenia：：n kliknij na poniższy link, aby zatwierdzić：n`,
"label.user.mass.emails.select":`Mass Email: Wybierz szablon`,
"lable.quote.syncing.title":`Synchronizacja cytatów i możliwości`,
"vue_label_dashboard_dashboardaccess":`Dostęp do tablicy rozdzielczej`,
"label_emailtocloudcc_filed_owner":`Właściciel`,
"label.brief.page":`Strona`,
"label.isEnableVisualpage_new.desc":`Wybierz dostępną stronę niestandardową z Dostępnych stron niestandardowych i dodaj ją do Wybranych stron niestandardowych, kliknij przycisk Zapisz. Następnie użytkownicy z tym profilem mają dostęp do aktywnych stron niestandardowych.`,
"label.service.shift.view":`Praca na zmiany Widok`,
"label.emailsync.addnewaccount":`Dodaj nowe konto`,
"label.forecast.settings.prompt":`Wyłączenie udostępniania prognoz spowoduje usunięcie wszystkich ręcznie udostępnianych dostępów.`,
"front-electronic-signature-explain-second":`Przy składaniu podpisu elektronicznego prosimy o przygotowanie zdjęcia licencji przedsiębiorcy oraz jednolitego kodu ubezpieczenia społecznego.`,
"label.emailtocloudcc.redmessage3":`Proszę wprowadzić adres serwera`,
"message.confirmgiveupedit":`Jeśli opuścisz tę stronę, utracisz wszystkie niezapisane zmiany. Czy chcesz kontynuować?`,
"label.gantt.plan.success":`Pomyślnie zaplanowane`,
"label.monitorsys.type.error":`Proszę wybrać typ wyszukiwania.`,
"label.industrialandcommercialverification.button.setup":`Rozstawienie`,
"today":`Dzisiaj`,
"label.attendance.setting.position":`Ustaw punkty orientacyjne`,
"chatter.mynews":`Moje wiadomości`,
"label.recycle.dis.tip1":`System będzie przechowywał dane Tha w koszu przez 15 dni, a rekordy zostaną trwale usunięte po 15 dniach od umieszczenia ich w koszu.`,
"label.icon.81":`Chłodnictwo`,
"label.customer.tab.page.prompt":`Proszę skonfigurować przynajmniej jedną stronę!`,
"label.globalselect.use":`Użyj globalnego zestawu wartości listy opcji`,
"template.report.customer.sales.order":`Kolejność sprzedaży na kontach o różnych poziomach`,
"vue_label_dashboard_lastruntime":`Ostatni czas pracy`,
"label.edit.ccpeakfolder":`Klasy：Edycja folderu`,
"vue_label_lead_be_converted":`Została przekształcona i nie może zostać przekształcona`,
"label.tabpage.filenamez":`Nazwa pliku`,
"label.please.click.add.products.":`Proszę kliknąć "Dodaj produkt", aby dodać produkt do cennika.`,
"label.followup_emails":`Gdy odwiedzający wypełni formularz, wysłanie wiadomości email jest prostym sposobem na szybkie nawiązanie z nim kontaktu.`,
"label.indochina.time":`Czas Indochin`,
"message.error.task.email":`Nieprawidłowość w zadaniach pocztowych`,
"label.dynamic.copy":`Synchroniczne kopiowanie reguł układu`,
"label.log.d":`Pobieranie dziennika audytu w wyszukanym zakresie czasowym (plik Excel.csv)>>`,
"pagecreator_layout_label_layoutname":`Nazwa układu`,
"template.chart.htsktj":`Statystyki zbierania umów`,
"label.appointment.wizard.subtitle4-2-5":`1 Dzień`,
"label.view_form":`Wyświetl formularz`,
"label.tablet":`Tablet`,
"label.campaignmember.main.addcontact":`Dodaj członków - istniejące kontakty`,
"message.get.userinfo.error":`Nie udało się uzyskać informacji o użytkowniku`,
"label.department.username":`Nazwa użytkownika`,
"label.ems.verifysuccess":`Konto e-mail zostało pomyślnie zweryfikowane!`,
"label.batchedit.copyValue":`Zastosuj się do tej kolumny`,
"label.trigger.triggerVersion":`Wersja`,
"label.mr.descreption.oneGroupReData5":`grupy danych, które nie są przetwarzane.`,
"label.appointmentconfirmpage.wizard.subtitle5":`Opis`,
"label.weixin.inbetween":`Multi-Select`,
"label.salescloud.contactrole.relatelist.customnize":`Nie można dostosować tej listy.`,
"label.data.exp.please.nameanddes":`Proszę wprowadzić nazwę i opis szablonu.`,
"label_partner_workspace_login":`Strona logowania`,
"label.notification.approval7":`【被委派人名称】rejected 【提交人】 wniosek o zatwierdzenie 【对象】【对象名称】for użytkownika.`,
"message.send.posts.image.error":`Przesyłanie zdjęć nie powiodło się!`,
"message.fieldtrack.operateupdate":`Zmieniono`,
"label.sharerule.grantuselevelconstructureaccess":`Udzielanie dostępu przy użyciu hierarchii`,
"label.translation.setup":`Konfiguracja wielojęzyczna`,
"PageLayout.Search.MultiSearch.003":`Wybierz co najmniej jedno pole.`,
"label.ccchat.person.emaildomain":`Domena poczty elektronicznej przedsiębiorstwa`,
"pagecreator.systemstyle.label.bordercolor":`Kolor obramowania`,
"label.submit":`Prześlij`,
"UG.Lead.001":`Jak wprowadzać wskazówki?`,
"label.icon.172":`Mapa`,
"label_chatter_owner":`Właściciel`,
"vue_label_systemSettings_Currency":`Zarządzanie walutą`,
"page.layout.binfo":`Podstawowe informacje`,
"label.version.date":`{0} pola daty`,
"label.data.is.woking":`Obsługa`,
"label.customfields.searchrelation.dependobjectDefault.tip":`Możesz wybrać rekord w powiązanym elemencie jako wartość domyślną dla tego pola`,
"label.partnerCloud.orderingPlatform.configuration":`Produkty konfuguracyjne`,
"lable.currencyManage.Enabledadvcurrency":`Włącz zaawansowane zarządzanie walutami`,
"label.event.moveup.3hour":`3 godziny naprzód`,
"label.reportexport.object":`Eksport obiektów`,
"front-dialog-module-v1-requestid":`Identyfikator wniosku`,
"label.pw.symol":`Symbole`,
"label_group_field":`Określ pole grupowania`,
"label.recallapprove":`Wniosek o zatwierdzenie wycofania`,
"vue_label_pool_deal_done":`Transakcja zamknięta`,
"label.shangqing.description":`Jest to opis sytuacji biznesowej`,
"label.view.allcansee":`Widoczny dla <b>wszystkich użytkowników</b>`,
"chatter.poll.addOption":`Dodaj więcej`,
"label.icon.112":`Żywność`,
"label.ignorecase":`Traktuj "ABC" i "abc" jako zduplikowane wartości (wielkość liter nie ma znaczenia)`,
"label.email.track.edit":`Edytuj email`,
"label_tabpage_erraddressz":`Nieprawidłowy format adresu e-mail, proszę wpisać prawidłowy adres e-mail`,
"label_tabpage_viewz":`Drukuj bieżący widok`,
"component.timeline.label.future":`Następny krok`,
"label.b_c_without":`Rekordy "B" mogą, ale nie muszą mieć powiązanych rekordów "C".`,
"label.version.autonumberfield":`Pole automatycznego numeru`,
"label.appointmentdetail.wizard.title5":`Adres URL zaproszenia`,
"label.weixin.addoption":`Dodaj opcję`,
"label.b.c":`Stosunek B do C`,
"chatter.group.complete":`Pełny`,
"label.must.numeric.value":`Koszt musi być numeryczny.`,
"lable.edit.queue.memberdes":`Aby dodać członków do tej kolejki, wybierz typ członka, następnie wybierz rolę lub użytkownika z listy "Dostępni członkowie" i przenieś ich do listy "Wybrani członkowie". Jeśli modelem udostępniania dla wszystkich obiektów w kolejce jest Publiczny odczyt/zapis/transfer, nie ma potrzeby przypisywania użytkowników do kolejki, gdyż wszyscy użytkownicy mają już dostęp do rekordów tych obiektów.`,
"label.staticresource.chose.limit":`Pliki w tym formacie nie są tymczasowo obsługiwane. Prosimy o oczekiwanie na poprawę tej funkcji.`,
"vue_label_commonobjects_view_kanban_unset":`Proszę wybrać podstawę grupowania w ustawieniach widoku Kanban`,
"label.appexchange.download.merge.mes":`Następujące sprzeczne komponenty są instalowane poprzez połączenie:`,
"label.sharerule.baseofowner":`W oparciu o właściciela rekordu`,
"label.email.template.manage.SMS":`Zarządzaj szablonem SMS`,
"label.imgfield.example.tip":`Zielona ikona oznacza zatwierdzony, a czerwona ikona oznacza odrzucony.`,
"template.report.potential.customer.industry":`Leads Industry`,
"component_hots_label_title":`Gorące okazje`,
"label_file_use_document":`Wykorzystanie przestrzeni dyskowej`,
"label.input.path":`Wprowadź ścieżkę dostępu do pliku`,
"label.partnerCloud.financialSetup":`Konfiguracja finansowa partnera`,
"label_tabpage_myz":`Mój`,
"vue_label_pool_discard1":`{1}{2}`,
"label_emailtocloudcc_tip2":`Po usunięciu, nie będziesz mógł używać Email do CloudCC, czy na pewno chcesz usunąć?`,
"label.customfields.fielddependency.sure":`Pole kontrolne nie zawiera wartości pola zależnego. Czy chcesz kontynuować?`,
"label.project.task.date":`Data zadania musi mieścić się w zakresie daty kamienia milowego, do którego należy.`,
"Report.CantDelete.Info":`Raport {0} jest źródłem danych dla dashboardu {1} i nie może zostać usunięty!`,
"label.assignment.setup.title":`Zasady przydziału`,
"image.pt.most.maxsize":`Maksymalna wielkość pliku to 2 MB.`,
"label.appupload.introduce":`Pakiety zawierają komponenty takie jak aplikacje, obiekty, zakładki, wyzwalacze czy strony. Pakiety te mogą być umieszczane w CloudCC App Store i udostępniane publicznie. Poniższa lista zawiera wszystkie pakiety utworzone przez Twoją organizację. Aby utworzyć nowy pakiet, należy kliknąć przycisk Nowy.`,
"label.import.page2.confirm":`Potwierdź`,
"label.console.step2.introduce":`Wypełnij poniższe pola, aby zdefiniować konsolę.`,
"label.extendsfather":`Kontrolowane przez jednostkę dominującą`,
"front-homepageobject-module-v1-year":`W tym roku`,
"front-grasp-sales-opportunities":`CRM pomaga precyzyjnie zarządzać możliwościami sprzedaży, pozyskiwać więcej leadów, dostarczać szybkie oferty i zamykać więcej transakcji, jednocześnie realizując marketing omnichannel i stale poprawiając ROI firmy.`,
"label.tab.oldpage":`Strona starej wersji`,
"label.service.miniProgram.intro":`Wstęp`,
"label.data.import.setup.operate.insert":`Nie aktualizuj istniejących rekordów, tylko wstaw nowe rekordy.`,
"label.ccpeak.direction.for.use":`Opis korzystania z Platformy CloudCC [Wersja 2.0]`,
"label.sendemail.chat.addComentsmyFeedsubject":`CloudCC CCChat mikropost odpowiedź`,
"label.campaignmember.main.importmember.contacts":`Importuj Członków-Kontakty`,
"setup.mainpage.label.welcome20":`Poczta, szablon SMS`,
"label.newbatcheditor.remark":`Dla różnych rekordów, istnieją różne typy rekordów. Domyślnie układ wiersza, jeśli typ rekordu pierwszego rekordu jest używany jako układ strony do masowej edycji.`,
"label.step4.total7":`Krok 4 z 7`,
"label.campagin.roi.tzhbl":`Zwrot z inwestycji`,
"label.emailmerge.mergepage.step3":`Rejestrowanie działań`,
"label.marketsea.isrecyclecreatebyself":`Czy chcesz poddać recyklingowi samodzielnie zbudowane konto`,
"message.mobilechooseatmost.five":`Na urządzeniach mobilnych w menu można wybrać maksymalnie 5 pól.`,
"label.icon.171":`Dom gościnny`,
"label.saveandnext":`Zapisz i następny`,
"label.import.page1.selectcodingtype":`Wybierz typ kodowania`,
"label.searchlayout.displaybutton":`Wyświetlane przyciski`,
"label.approvalstep5":`Krok 5 - wybór właściwości edycyjnych pól, które mają być wyświetlane w układzie strony zatwierdzania`,
"label.passwordPolicy.setup.enforcePswHis":`Wymuszanie historii haseł`,
"vue_label_commonobjects_detail_contact_hierarchy":`Hierarchia kontaktów`,
"front-kefu-moudle-v1-trythjzx-intelligent":`TRRT(tinet) Inteligentne Centrum Obsługi Telefonicznej`,
"label.select.statistical.indicators":`Proszę wybrać indeks statystyczny`,
"label.callcenter.Tianrun.RONGTONG":`TRRT(tinet)`,
"label.file.library":`Biblioteki`,
"lable.completion.rate.color.setting":`Kolorowe ustawienie stopnia realizacji`,
"label.name.firstname":`Imię`,
"setup_layout_label_readonly":`Tylko do odczytu`,
"label.chatter.recordcall":`rejestracja połączenia`,
"label.service.appointmentList.service.empty":`Termin serwisowy jest pusty.`,
"component_milestones_label_choicestate":`Potwierdzić ten status`,
"label.approved.receiveApprovalEmail.option2":`Tylko jeśli jestem zatwierdzającym`,
"label.marketseamemset.account.title":`Ustawienia członków puli wiodącej`,
"label.changemydisplay.list.custom":`Dostosuj moje karty`,
"label.emailtemplate.selecttype":`Wybierz typ szablonu wiadomości e-mail, który chcesz utworzyć.`,
"component_timeline_label_title":`Oś czasu`,
"chatter.group.addRemoveMembers":`Dodawanie/usuwanie członków`,
"label.console.step6.width":`Szerokość`,
"pagecreator.systemstyle.message.delete.fail":`Usuwanie stylu nie powiodło się`,
"label.partnerCloud.orderingPlatform.productPrice":`{productQuantity}products，{totalCount} pieces, original price：{currency} {originalPrice}，discount：{currency} {Reduction}`,
"label.h5.share":`Udostępnij`,
"label.schedulejob.setup.list.tip":`Skonfiguruj zaplanowane zadania, które mają być wykonywane automatycznie w odstępach tygodniowych lub miesięcznych.`,
"message.intheapproving":`Rekord prosi o zatwierdzenie i nie może być ponownie przesłany.`,
"vue_label_commonobjects_detail_real_time":`Po dołączeniu do zespołu, będzie on wyświetlany na liście zespołów, a dynamika zespołu będzie informowana w czasie rzeczywistym.`,
"label.autoRegister.changepwd.setpwd.too.weak":`Za krótkie`,
"label.salescloud.forbiddenteamsales":`Zakazać zespołu sprzedaży`,
"component.chatter.link.label.title":`Link`,
"label.layout.editsearchdistribute.page":`Wybierz strony niestandardowe, które mają być zawarte w zakładce strona główna`,
"label.dashboard.show.value.percent":`Pokaż wartości lub pokaż %, proszę wybrać przynajmniej jedną z nich`,
"label.everymonth":`Za miesiąc`,
"label.campaign.channel.download.size1":`Duży rozmiar 1000*1000 pikseli`,
"permissionService.error2":`Nie udało się dodać uprawnień do licencji aplikacji.`,
"button.partner.workspace.manage.memo":`Zarządzaj chmurą partnerską i konfiguruj właściwości chmury partnerskiej.`,
"label.forecast.forehistory.commit.remark":`Uwagi do przedłożenia`,
"six":`Sześć`,
"label.datamanage.donot.export.object":`Obiekty, które nie mogą eksportować danych.`,
"label.schedulejob.setup.schedule.execute":`Wykonaj`,
"lable.account.CurrentandPreviousCY":`Obecny i poprzedni CY`,
"label.temp.SMS":`Szablony SMS`,
"label_partner_all_state":`Status`,
"label.editdocument":`Edycja Właściwości`,
"front-epwechat-module-v1-ios-single":`iOS Single Sign On`,
"lable.redo":`Redo`,
"vue_label_SMS_alltemplates":`Wszystkie szablony`,
"label.allfolderreport":`Wszystkie foldery raportów`,
"label.layout.alltab":`Wszystkie karty`,
"lable.account.Yesterday":`Wczoraj`,
"label.formula.to.evaluate":`Ocena wzoru`,
"component_setup_label_setupsaveok":`Ustawienia komponentu zostały zapisane pomyślnie`,
"pagecreator_page_message_canntdelete":`Bieżąca strona nie może zostać usunięta`,
"label.tab.message.failtotp":`Nie udało się zdobyć szczytu zakładki`,
"label.h5.chatter.location":`Wstawić lokalizację`,
"vue_label_commonobjects_view_chart_gotodashboard":`Przejdź do Dashboard`,
"label.data.exp.conf":`Czy na pewno chcesz wyeksportować dane?`,
"label.currency.e":`Typ waluty Edycja`,
"message.matrixReportSetupStage.column":`Proszę wybrać 【Specify Column Headers】 podstawę sumy częściowej, przy czym należy wybrać jedną podstawę sumy częściowej co najmniej w dwóch podstawach sumy częściowej.`,
"font-evaluate-module-v1-have-comment":`Pozostawienie oceny`,
"chatter.feed.dao":`Do`,
"label.import.index.notice":`Uwaga:`,
"label.weixin.information":`Szczegóły`,
"label.multilingual.tip5":`Status wielojęzyczności nie jest poprawny. Proszę odświeżyć i spróbować ponownie!`,
"label.appointment.wizard.subtitle3-7":`Niedziela`,
"label.emailobject.groupemail.fail.content":`Szanowni Państwo, poniżej znajduje się adres e-mail, którego nie udało się wysłać.`,
"vue_label_notice_uploadavatar_fail":`Nie udało się załadować awatara`,
"chatter.group.myGroup":`Moje grupy`,
"label.ccpeak.object.fieldapi.name":`jest nazwą API pola obiektu`,
"lable.activeCurrency":`Aktywne waluty`,
"label.file.save.to.send":`Zapisz i wyślij`,
"label.emailmerge.list.editfolder":`Folder Edycja`,
"label.Path.Setting":`Ustawienie ścieżki`,
"label.validate.function.funcFormat.DATE":`DATE(rok, miesiąc, dzień)`,
"message.objapiexists":`Ten obiekt API już istnieje.`,
"label.sendmail.batch.confirm":`Mass Email: Potwierdź`,
"message.approval.cannotsubmit.detail":`Ten rekord nie spełnia warunków lub nie został wstępnie zgłoszony do żadnego ważnego procesu zatwierdzania. Prosimy o kontakt z administratorem w celu uzyskania pomocy.`,
"setup.layout.button.deleteitem":`Usuń wybrane elementy`,
"label.end.loginipIP":`Końcowy adres IP`,
"component_event_label_subject":`Temat`,
"message.500":`Wystąpił wewnętrzny błąd serwera`,
"label.wei.polltype":`Rodzaje`,
"vue_label_norm_duplicate":`Duplikat`,
"label.addcycletrigger":`Dodaj wyzwalacz okresowy`,
"DetailedInfo.Activity.EmailMessage.01":`{0} wyślij wiadomość e-mail do {1}.`,
"No.Activity":`Brak aktywności`,
"label.chat.topic.add.topic":`Kliknij, aby dodać temat`,
"label.schedulejob.setup.schedule.morning":`AM`,
"chatter.save.al":`Twoje zmiany zostały zapisane.`,
"label.setsharerule.step3":`Krok 3 Wybierz użytkowników, którym chcesz udostępnić dane`,
"label.tabpage.Sdfez":`dni temu`,
"label_submit_forecast":`Prześlij prognozę`,
"label.version.sum.formulafield":`pola formuły`,
"lable.weixin.you.invitation":`Państwa zaproszeni`,
"label.stacked.horizontalbar":`Linie poziome ułożone w stos`,
"label.file.anyone.can.link":`Każdy, kto posiada link, może obejrzeć i pobrać plik.`,
"label.campaignmember.main.importmember.lead.desc":`Importuj leady z plików.`,
"UG_activity_01":`W jaki sposób śledzisz swoje rekordy, aby współdziałać ze swoimi kontami/zespołami?`,
"label.reason":`Uzasadnienie`,
"label.version.free.createmax":`Zezwolenie na utworzenie 2000 rekordów, górny limit został osiągnięty.`,
"label.brief.thisweek":`W tym tygodniu`,
"label.deleteobjinapprove":`Proszę wprowadzić komentarz przed usunięciem tego obiektu z procesu zatwierdzania.`,
"calendar.tips.event":`dzień(y) bez wydarzeń`,
"label.customerinfo.mailinfo":`Adres e-mail całej organizacji`,
"lable.electronic.signature":`Podpis elektroniczny`,
"label_emailsync_addnewaccount":`Dodaj nowe konto`,
"label.layout.exampleoftesgobj":`Przykład obiektu testowego`,
"label.happen_submit":`Co powinno się stać po wysłaniu tego formularza przez odwiedzającego`,
"label.forecast.customforecast.button.submit":`Prześlij`,
"label_right_click_notice":``,
"font-trade-module-v1-invoice-no-price":`Do zwrotu`,
"lable.opppdt.selPdt.morecondtions":`Więcej filtry`,
"label_invalid_token":`Nieprawidłowy token`,
"label_chatter_postup":`Post Up`,
"label.escalation.setup.newaction.step1":`Krok 1 Określenie kryteriów czasowych dla tej reguły`,
"label.sendmail.step3.dealoption2":`Przechowywanie aktywności dla każdego komunikatu`,
"front-kefu-moudle-v1-yesornoBatch-delete-templete":`Czy na pewno chcesz usuwać szablony partiami?`,
"vue_label_appstore_enter_website":`Wejdź na oficjalną stronę internetową`,
"label.when":`Czas publikacji`,
"label.linellae":`Linie`,
"label_chatter_detailinfo":`Szczegółowe informacje`,
"lable.SalesCommitmentKanBan.receivingTaskRate":`Wpływy Wskaźnik realizacji zadań`,
"vue_label_homepage_dashboard_deleted":`Deska rozdzielcza została zdemontowana`,
"pagecreator.layout.button.vertical":`Demontaż wzdłużny`,
"label.redistribution1":`Wybierz do 5 pozycji`,
"pagecreator_page_label_modifypage":`Redaktor strony`,
"label.Service.Cloud.Setting":`Ustawienia chmury serwisowej`,
"setup_layout_label_pagename":`Nazwa układu strony`,
"label.ems.send":`Wyślij`,
"vue_label_commonobjects_view_kanban_notice1":`Widok Kanban wyświetla tylko pierwsze 200 rekordów`,
"lable.outlook.detail.maping":`Odwzorowania pól`,
"vue_label_pool_abandonorrestore":`{1}{2}`,
"label.mobile.side.tab":`Ustawienia suwaka po stronie mobilnej`,
"label.trigger.operation.email.template.param":`Przekazywanie parametrów: język, ID szablonu e-mail oraz ID rekordu`,
"front-objectTemplate-V1-Select-a-template":`Wybierz istniejący szablon jako podstawę nowego szablonu.`,
"label.email.template.delete.template":`Czy na pewno chcesz usunąć ten szablon?`,
"label.reportsSubscription.cancel":`Anuluj`,
"lable.quote.syncingfrom.firstsync.description":`Produkty okazjonalne zastąpią pozycje ofertowe`,
"label.weixin.no.pending.xsld.qin":`Niestety, nie ma danych lejka sprzedaży do pokazania.`,
"template.dashboard.sales.indicators":`Wskaźniki sprzedaży`,
"label.field.new":`Zapewnienie użytkownikom operacji oceny i punktacji.`,
"label.generatepage.title.desc1":`Generowanie mobilnej lub PC wersji kodu HTML na podstawie wybranych pól, użytkownicy mogą modyfikować kod według potrzeb.`,
"template.report.source.potential.customers":`Źródło leadów`,
"label.mr.title.queryData":`Znajdź duplikaty`,
"button_partner_workspace_enable":`Włączenie chmury partnerskiej`,
"V":`Auto Numer`,
"label.icon.19":`Folder`,
"vue_label_report_summaryformula":`Formuła podsumowująca`,
"label.appointment.wizard.subtitle2":`Dostępny zakres dat`,
"label.stdashbord.xsld.business.bjdzhl":`Współczynnik konwersji etapu`,
"label.forecast.forehistory.deopportunity":`Możliwości`,
"chatter.email.referredToMeLeaveMessage":`Wspomina o mnie w komentarzu`,
"label.dategrouprelyon":`Kryteria grupowania dat`,
"label.sendmail.batch.finish":`Mass Email: Zakończono`,
"label.weixin.allexpired":`Wszystkie Zaległe`,
"label.dashboardSetup.showdw.d4":`10 Tys.`,
"message.duplication.label.masterRecord":`Zapis główny`,
"vue_label_calendar_availability":`Dostępność`,
"vue_label_chat_approval_message":`Komunikat zatwierdzający`,
"vue_label_zhang_er":`Jenny`,
"label.select.options":`Proszę wybrać opcje`,
"label.israel.daylight.time":`Czas standardowy Izraela`,
"front-sales-search-QB":`0 danych w sumie, czy utworzyć nowe konto w QuickBooks`,
"vue_label_account_change_customer":`Zmiana właściciela klienta`,
"label.integrations.mailchimp2":`Zobacz więcej o CloudCC i Mailchimp`,
"lable.product.pricebooks.onisu":`Nieaktywne Księgi Cen`,
"front-electronic-signature-backfill-field":`Pole zasypowe`,
"label.document.myself.folder":`Moje foldery osobiste`,
"label.event.moveup.10hour":`10 godzin naprzód`,
"report.label.report":`Raporty`,
"label.validate.function.funcFormat.CONTAINS":`CONTAINS(text, compare_text)`,
"label.usermanage.query.false":`Zapytanie nie powiodło się, użytkownik nie istnieje.`,
"front-epwechat-module-v1-input-EncodingAESKey":`Proszę wprowadzić EncodingAESKey`,
"label.event.multi.view":`Widok dla wielu użytkowników`,
"label.h5.similar.opportunity.setup":`Podobne możliwości Ustawienia`,
"label.setting.intergrationlist.button.install":`Zainstaluj`,
"label.event.monthview":`Widok miesiąca`,
"label.version.weixin":`Wersja WeChat`,
"label_emailtocloudcc_redmessage6":`Uwierzytelnianie IMAP/SMTP nie powiodło się, proszę sprawdzić, czy adres e-mail i hasło są poprawne.`,
"UG.homepage.003":`Widok 360 stopni`,
"vue_label_calendar_shared_calendar":`Kalendarz akcji`,
"label.select.hope.merge.num1.record":`Proszę wybrać rekordy, które mają być połączone w jeden rekord. Wybierz maksymalnie 3 rekordy jednocześnie.`,
"label.createnewprocess":`Utwórz nowy proces zatwierdzania`,
"font-trade-module-v1-invoice-status":`Status płatności`,
"label.customerinfo.introduce":`Informacje o firmie`,
"label.objectname":`Nazwa obiektu`,
"label.chosen.field":`Wybrane pola`,
"label_target_name":`Nazwa modelu celu:`,
"label.appointment.wizard.subtitle4-4-4":`1 miesiąc`,
"label.emailobject.groupemail.msg1":`Brak adresu e-mail`,
"label_component_hotdeal_nopermission":`Aby zobaczyć swoje dane dotyczące możliwości biznesowych, skontaktuj się z administratorem CloudCC.`,
"label.appointmentdetail.wizard.title13":`Opis`,
"front-web-module-v1-detail-comment-title":`Proszę wypowiedzieć się na temat tej usługi`,
"label.visualpage.component.n1":`1.Metoda wywoływania.  `,
"lable.outlook.mcto.erecord":`najwcześniej powstałe zapisy`,
"label.weixin.del.log":`Dziennik usunięcia`,
"setup_mainpage_label_welcome23":`Ustawienia bezpieczeństwa`,
"label.selectreportline":`Proszę wybrać kolumny raportu`,
"label.chatter.following":`Jest następujący`,
"seven":`Siedem`,
"message.error":`Błąd.`,
"label.mobile.phone.reporter":`Zgłoszony przez`,
"label.valadate.telphone.false":`Błąd przy wpisywaniu numeru telefonu, proszę wpisać ponownie`,
"label.linkedin.setting":`Zintegrowana aplikacja LinkedIn H5 MiniApp`,
"label.mobile.side.tab.success":`Zapisz ustawienia suwaka po stronie mobilnej pomyślnie.`,
"label.notification.approval3":`Wniosek o zatwierdzenie 【对象】 zostaje przeniesiony na stronę 【重新审批人】.`,
"label.channel.invites.employees":`Zapraszanie pracowników tego kanału`,
"label.assignment.setup.detail.assigner":`Przydziel do`,
"label.campaignmember.main.updatecontactdesc":`Aktualizuj status wszystkich kontaktów w jednym czasie`,
"label.permission.detail.app.fenpei":`Przydzielanie aplikacji`,
"label.copydown":`Kopiuj w dół`,
"label_emailsync_status_action":`Działanie`,
"lable.Please.switch":`Aby skorzystać z tej funkcji, należy przełączyć się na menu poziome lub pionowe.`,
"label_adjust_remark":`Uwagi dotyczące dostosowania`,
"label.weixin.newspaper.coverage.list":`Arkusze ryzyka`,
"label.datamanage.contact.field":`Kontakt Pola`,
"label.partner.workspace.login.headerfooter":`Nagłówek i stopka`,
"lable.account.quarter.ovdate":`Dzień zakończenia kwartału podatkowego`,
"pagecreator.systemstyle.label.textcolor":`Kolor tekstu`,
"label.industrialandcommercialverification.fieldmappingsettings":`Ustawienia mapowania pól`,
"component_chatter_button_message":`Komentarz`,
"label.partnerCloud.enterAddress":`Proszę wpisać adres`,
"label.email.template.recently.used":`Ostatnio używane`,
"component.event.label.calendar":`Zobacz kalendarz`,
"label.setup.mobile.offlinecache.setting":`Ustawienia pamięci podręcznej offline po stronie urządzenia mobilnego`,
"label.custom.PreviousCQ":`Poprzedni CQ`,
"lable.total.of.payments":`0 płatności ogółem`,
"label.ccpeak.use.class.time.trigger":`Jeśli triger wywołuje klasę, możesz użyć metod bezpośrednio w CCService.`,
"label_tabpage_addresswrongz":`Błędny format adresu skrzynki pocztowej, proszę poprawnie wpisać adres skrzynki!`,
"vue_label_homepage_select_components":`Wybierz komponenty`,
"front-kefu-moudle-v1-secretID-reinput":`Proszę wpisać secretID`,
"label.ccdocument.select.template.red":`Proszę wybrać zestaw szablonów.`,
"vue_label_email_public_template":`Wzór publiczny`,
"label.eowechat.openid":`WeCom ID`,
"label.user.ip.notlogin.range":`Ten adres IP nie znajduje się w zakresie IP.`,
"chatter.email.reply.collection":`Komentarze do artykułu, który dodałem do zakładek`,
"label.integrations":`Integracje`,
"label.permission.modifyAppPermission.selectedapp":`Wybrane aplikacje`,
"label.privacystatement":`Oświadczenie o ochronie prywatności`,
"label.specificvalue":`Określona wartość`,
"label.appointmentconfirmpage.wizard.subtitle2":`Data i godzina`,
"label.message.ispartner.delete":`Ponieważ kontakt jest już powiązany z użytkownikiem partnerskim, klient nie może zostać usunięty.`,
"report_button_go":`Idź do`,
"label.h5.similar.opportunity":`Podobne możliwości`,
"UG_Lead_005":`Skrzynka pocztowa`,
"label.num.length.not.overstep":`długość wartości nie może przekraczać 18 bitów`,
"label.profile.mobile.setup.CEOandDirector":`Prezes zarządu i dyrektor handlowy`,
"label.addfield":`Dodaj pole`,
"template.dashboard.institutional.overview":`Przegląd agencji`,
"label_tabpage_datefield":`Kiedy pole daty jest równe, może użyć formatu "wczoraj", "dziś", "jutro", "ostatni miesiąc", "ten miesiąc", "następny miesiąc", "ostatni tydzień", "ten tydzień", "następny tydzień" lub "RRRR-MM-DD、MM/DD/YYYY".`,
"label.category.7":`Turystyka`,
"UG_contact_02":`Angażowanie kontaktów poprzez wiele kanałów, rozmowy telefoniczne, email, social`,
"chatter.feed.menutype.feed.mecom":`New Post To Me`,
"vue_label_systemSettings_calltemplate":`Szablon listu`,
"approval_process_errore":`Wystąpił błąd podczas zapisywania, skontaktuj się z administratorem.`,
"label.tabpage.choosefilez":`Wybierz plik`,
"label.changemydisplay.chagetab.cusapp":`Aplikacje niestandardowe`,
"clearadvancedoption":`Wyczyść logikę filtra`,
"front-epwechat-module-v1-binding-user":`Użytkownicy powiązani`,
"label.customfields.fielddependency.null":`Nie zdefiniowano zależności.`,
"label.enterprise":`Enterprise Edition`,
"font-evaluate-module-v1-five-points":`Znak neutralny: 5 punktów`,
"lable.Synchronize.from.QuickBook":`Synchronizacja z QuickBook`,
"front-gantt-module-v1-task-number":`Zadanie Kwota`,
"label.currency.edit.newexchagecurrency":`Datowane kursy wymiany`,
"label.partnerCloud.partnerSite":`Strona partnerska`,
"label_tabpage_unequalz":`Nierówny do`,
"label.version.solutions":`Rozwiązania`,
"label.setting.intergrationlist.button.installed":`Zainstalowany`,
"label.h5.chatter.share":`Udostępnianie plików`,
"front-epwechat-module-v1-unbound-item4":` wiązanie rachunków zewnętrznych`,
"label.textmessage.vonage.accessibility.setting":`Ustawienie dostępności`,
"font-evaluate-module-v1-evaluation-set":`Ustawienia oceny`,
"message.servicecrew.time.violation2":`Poza czasem pracy`,
"label.processinfo":`Informacje dotyczące procesu zatwierdzania`,
"label.knowledgebase.last.modified":`Ostatnio zmodyfikowany`,
"label.to.phone":`Do`,
"label.baseoffirsttimereply":`Zatwierdź lub odrzuć na podstawie pierwszej odpowiedzi`,
"label.projectManagement.startingEndingTime":`Czas`,
"label.licence.enable":`Aktywny`,
"label.partnerCloud.basicSetting.cshua":`Inicjalizacja chmury partnerskiej`,
"APPIntegration.Dropbox.setting.03":`Włącz opcję Dropbox, aby umożliwić wybieranie plików z Dropbox i dodawanie ich jako załączników.`,
"label.account.contact":`Kontakt AI`,
"label.many.dayline.tab":`Mark`,
"label.weixin.input.username":`Proszę wpisać swoje imię i nazwisko`,
"label.logintime.pagecue.invalido":`Czas zakończenia musi być cały dzień.`,
"label.icon.30":`Książka`,
"label_tabpage_advancedscreening":`Filtr zaawansowany`,
"lable.currencyManage.unEnabledadvcurrency.agree":`Tak, chcę wyłączyć Zaawansowane zarządzanie walutą.`,
"label.tab.web.new":`Nowa karta sieci Web`,
"label.bmap.tiananmen":`Tiananmen`,
"label.disabled":`Niepełnosprawni`,
"error.currencyAdv.deleteprecodedate":`Nie można usunąć daty kursu wymiany waluty.`,
"message.error.view.checkbox.validerr":`Błąd: proszę użyć true lub false`,
"UG_ST_006":`Wejdź bezpośrednio`,
"label.dongshifang.title":`DongShiFang SMS`,
"label.data.dataexpalltype.all.desc3":`3、Eksportowane dane Successful wygeneruje skompresowany plik, który użytkownicy mogą pobrać z listy sukcesów eksportu strony zgodnie z informacjami w mailu.`,
"vue_label_pool_returnreason":`Powód zwrotu`,
"label.list.userinterface.des":`Zmodyfikuj interfejs użytkownika, wprowadzając następujące ustawienia:`,
"label.notification.approval2":`Wniosek o zatwierdzenie dla【对象】 został odrzucony przez 【审批人】`,
"label.service.dispatchingUnits.the.level":`Poziom`,
"front-email-payment-Invoice-preview-tips":`Wszystkie szablony faktur są obecnie wyłączone. Prosimy o kontakt z administratorem w celu włączenia szablonu przed wygenerowaniem faktur.`,
"label.dashboard.isAvailableFieldOfComponentGroupInTheReport":`Błąd: jedno lub więcej pól wybranych w komponencie nie jest już dostępnych w raporcie. <br>Użyj edytora komponentu tablicy rozdzielczej, aby wybrać jedno z dostępnych pól.`,
"label.import.step2.chooseidorother":`2、Możesz wybrać, aby użyć ID lub nazwę, aby dopasować rekord i wypełnić pole lookup. Jeśli potrzebujesz zdobyć odpowiedni identyfikator rekordu i inne informacje, możesz utworzyć raport i ustawić nazwę rekordu i identyfikator rekordu jako kolumny grupy, a następnie wyeksportować raport.`,
"label.customobjects.introduce":`Obiekty niestandardowe to tabele bazy danych, które pozwalają przechowywać w CloudCC dane specyficzne dla organizacji. Obiekty niestandardowe można wykorzystać do rozszerzenia funkcjonalności CloudCC lub do zbudowania nowej funkcjonalności aplikacji.`,
"label.visualpage.oldsystem":`Stara wersja`,
"label.icon.94":`Książka`,
"label.setup.log.desctiption":`Możesz pobrać ślad zachowania Twojej organizacji (Excel.xls)`,
"label.dynamicpage.layout":`Zasady układu`,
"lable.list.queue.objct":`Obsługiwane obiekty`,
"label.customfields.placeholder.tip":`Przykładowy tekst będzie wyświetlany w polu wejściowym i zniknie po uzyskaniu fokusu`,
"label.ems.activationtime":`Czas aktywacji`,
"label.detailinfo":`Szczegóły`,
"label.icon.17":`Raport`,
"label_emailtocloudcc_button_complete":`Wykończenie`,
"label.visualpage.component.n2":`2. Zwróć uwagę, że "znaczniki komponentów" nie mogą być zagnieżdżone wewnątrz  "<cc>tags".`,
"label.object.name.one":`Nazwa obiektu 1`,
"label.summaryreport.step2":`Krok 2 Wybór danych podsumowujących`,
"thisisanew":`Nowy`,
"label.query.detail.editpartneruser":`Edycja użytkownika partnerskiego`,
"label.tabpage.newview":`Tworzenie nowego widoku`,
"label.partnerCloud.productSet.addNew":`Nowa opcja`,
"label.appupload.upload.new.remark":`To jest nowy komponent`,
"label.case.ptext":`Podłączyliśmy Twoją firmę do wersji internetowej portalu. Skopiuj adres wersji www portalu obsługi klienta dedykowanego dla Twojej firmy i dodaj portal na swojej oficjalnej stronie internetowej.`,
"lable.PowerProcess.name":`Proces nabywania uprawnień`,
"label_tabpage_choosefilez":`Wybierz plik`,
"homepage.components.place":`Pozycja komponentu:`,
"lable.Synchronization.failure":`Nie udało się zsynchronizować`,
"label.dashboard.snapshot.get.data":`Pobierz swoje dane`,
"label.input.invalid.format":`Proszę wprowadzić prawidłowy format`,
"label.quickbooks.view.openinvoices":`Otwarte faktury`,
"label.weixin.seating":`Siedzenia`,
"label.searchlayout.remark":`Układy wyszukiwania umożliwiają wybór pól standardowych i niestandardowych, które są wyświetlane w następujących funkcjach wyszukiwania:`,
"label.escalation.setup.entrydetail.escalation.assiner":`Przydziel do`,
"vue_label_calendar_availability_view":`Kalendarz - widok dostępności`,
"label.country":`Kraj`,
"label.campagin.roi.zl":`Przegląd`,
"lable.currencyManage.advcurrencyEnabled":`Włączone jest zaawansowane zarządzanie walutą`,
"label.projectManagement.project.task":`Projekt Zadanie`,
"label.appointmentpage.wizard.subtitle3-2":`E-mail`,
"label.input.invalid.date":`Proszę wprowadzić ważne daty`,
"vue_label_chatter_my_followers":`Moi zwolennicy`,
"label.setupdevelop":`Opracuj`,
"label.sendemail.send.checksend":`Sprawdź, czy wiadomość e-mail została wysłana pomyślnie`,
"label.eventfield":`Pola zdarzeń`,
"label.ccpeak.ccobject.put":`Użyj put, aby przypisać do CCobject, na przykład:`,
"label.campaignmember.main.addMemberDesc":`Możesz wyszukiwać istniejące leady i kontakty, dodawać je do kampanii lub zarządzać istniejącymi członkami kampanii.`,
"label.knowledge.setting.hint.eleven":`Wprowadź kategorię danych`,
"label.knowledge.category.button.four":`Dodaj kategorię rodzeństwa`,
"label.icon.27":`Dowiedz się`,
"vue_label_chatter_certification":`Czy jesteś pewien, że chcesz {isStatus} "{titleName}"?`,
"label.data.downpage.i.title.btn":`Przejdź do strony importu i rozpocznij importowanie`,
"label.campaign.channel.step6.pc":`Wygeneruj stronę PC`,
"label.mr.caption.rule":`Reguły: należy wybrać jedną lub więcej reguł wyszukiwania duplikatów`,
"label.service.gantt.resourcestype":`Typ zasobu`,
"label.searchfitconditions":`Znajdź te, które spełniają następujące kryteria:`,
"label.partner.template.name":`Nazwa szablonu`,
"setup.mainpage.label.welcome15":`Reguły przepływu pracy platformy CloudCC automatyzują proces wsparcia dla sprzedaży, marketingu i nie tylko. W zależności od predefiniowanego zestawu reguł, rekordy mogą być automatycznie przypisywane do użytkowników lub konwertowane z jednego użytkownika na drugiego. Główną korzyścią z zarządzania przepływem pracy jest poprawa wydajności pracy poprzez wyeliminowanie wielu niepotrzebnych operacji podczas aktualizacji rekordów, a także poprawa poziomu przetwarzania biznesowego i optymalizacja procesów kontroli poprzez standaryzację metod pracy i zmniejszenie kosztów operacyjnych. Obsługuje nieograniczoną nieskończoność zatwierdzeń dla dowolnego obiektu, a także może wyzwalać przypomnienia e-mail, przypomnienia SMS, zadania, aktualizacje pól i inne funkcje.`,
"vue_label_commonobjects_view_chart":`Wykres`,
"label.salescloud.teamrole.choose":`Proszę wybrać rolę zespołu`,
"lable.outlook.mcto.emailrel":`Powiązania poczty elektronicznej`,
"front-invoice-online-payment-setup-describe":`Szybki dostęp, dostęp za pomocą jednego kliknięcia. Prosta, bezpieczna i szybka obsługa płatności online.`,
"label.korean.standard.time":`Czas standardowy Korei`,
"label.lord.howe.standard.time":`Czas letni Lord Howe`,
"setup_layout_group_button":`Przyciski`,
"label.editdefaultshare":`Domyślne ustawienia udostępniania dla całej organizacji Edycja`,
"label_fiscal_year":`Rok podatkowy`,
"label.appointmentdetail.wizard.title2":`Właściciel`,
"label.email":`E-mail`,
"label.city":`Miasto`,
"label.knowledgebase.data.recovery.failed":`Odzyskiwanie danych {a} nie powiodło się`,
"setup_mainpage_label_welcome6":`Użytkownicy mogą tworzyć różne typy pól we wszystkich obiektach systemu CloudCC bez konieczności posiadania wiedzy programistycznej czy tworzenia kodu. Typy pól obejmują: relację wyszukiwania, pole jednokrotnego wyboru, wybór dwuelementowy, formułę, automatyczną numerację. URL, telefon, fax, email, pole wyboru, data, czas, liczba, tekst, obszar tekstowy, lista opcji (wybór pojedynczy/wielokrotny), waluta, itp.`,
"label_emailtocloudcc_button_enable":`Aktywny`,
"label.account.custom":`Niestandardowe Kwartał fiskalny`,
"label.custompublish_time":`Czas publikacji przez klienta`,
"label.dashboardSetup.selwz":`Wyświetlana pozycja`,
"component_todaytask_label_all":`Zobacz Wszystkie`,
"label.service.resource.group.tip":`Zasoby służbowe odnoszące się do typów załogi wykorzystują typ załogi.`,
"label.tianyancha.legalpersonname":`Nazwa osoby prawnej`,
"component.setup.label.titlefield":`Pole tytułu`,
"label.email.template.public.mail":`Publiczny Folder Szablonów Email`,
"front-template-V1-DeleteTempalte":`Czy na pewno chcesz usunąć "{currentTelmplateName}"?`,
"pagecreator.layout.label.layoutdesc":`Opis układu`,
"vue_label_file_singel_upload":`Tylko jeden plik może być załadowany. Jeśli chcesz zastąpić plik, najpierw usuń przesłany plik.`,
"label.view.hierarchy":`Wyświetl hierarchie`,
"label.file.owner.settings":`Ustawienia właściciela`,
"label.sales.dashboard.name":`Nazwa`,
"label.offfer.filer.name":`Nazwa pliku cytatu`,
"label.quickbooks.view.recentlypaid":`Ostatnio zapłacone`,
"label.step1.select.merge.records":`Krok 1 wybór rekordów do połączenia`,
"message.recordtype.assignprofile.tip":`Zaznacz opcję Włącz dla profilu, aby nowy typ rekordu był dostępny dla profilu. Użytkownicy przypisani do tego profilu będą mogli tworzyć rekordy o tym typie rekordu lub przypisywać ten typ rekordu do istniejących rekordów. Aby nowy typ rekordu był domyślny dla profilu, należy zaznaczyć pole wyboru Ustaw jako domyślny.`,
"label.appointmentdetail.wizard.title9":`Czas podróży`,
"label.group":`Grupy`,
"label.deltorecycle":`Usuń do Kosza`,
"label.import.index.numlimit":`1. Obsługiwane są tylko pliki w formacie csv, jednorazowo można zaimportować do 30 000 rekordów (<span style="color: red">można zaimportować do 2 000 rekordów, jeśli trzeba wykonać trigger</span>). Rekordy, które przekroczą ten limit będą automatycznie ignorowane przez system. Jeśli chcesz zaimportować więcej danych, podziel je najpierw na wiele plików i zaimportuj w różnym czasie. .`,
"label.file.delete.desc":`Usunięcie pliku spowoduje również usunięcie go z wszelkich dodatkowych zapisów lub postów.`,
"UG_activity_04":`Skrzynka pocztowa Outlook/Gmail, zapisywanie poczty`,
"label.event.all.undealt":`Wszystkie nieprzetworzone zdarzenia`,
"label.appupload.upload.install.error":`Ta aplikacja nie może być zainstalowana. Proszę zakończyć instalację lub zmodyfikować api systemu i zainstalować ponownie!`,
"template.chart.yqydcpsl":`Liczba aktywowanych produktów`,
"label.import.index.advancepreparation":`Przygotowania wstępne`,
"label.eowechat.epdeptnamee":`Nazwa działu WeCom`,
"front-kefu-moudle-please-input-servernum":`Proszę wprowadzić numer listy zgłoszeń serwisowych.`,
"label.lookup.autocmp.nodata":`Brak danych dotyczących dopasowania`,
"vue_label_pool_assign":`Przyporządkuj`,
"label.knowledge.timing.publish":`Publikacja po czasie nie powiodła się`,
"label.selected.groups":`Wybrane grupy linii notowań`,
"front-epwechat-module-v1-removesele-desc":`Po usunięciu, wszystkie ustawienia tej aplikacji zostaną usunięte. Czy na pewno chcesz usunąć?`,
"label.batchtransfer.type2":`Przeniesienie możliwości zamkniętych`,
"label.richtext":`Obszar tekstowy (bogaty)`,
"label.icon.174":`Statek powietrzny`,
"vue.please.select.grouping.basis":`Proszę wybrać opcje Group By.`,
"label.matrixreport":`Raport macierzowy`,
"label.jiandangfenpei.leftlist":`Profile nieprzypisane`,
"label_chatter_card":`Karta`,
"label.file.enter.title":`Proszę wpisać tytuł`,
"label.the.record.is.locked.and.cannot.be.selected.":`Ten rekord jest zablokowany, nie można go wybrać.`,
"label.partner.success":`Sukces! Domena jest dostępna`,
"label.selectreporttype":`Wybierz Źródło danych raportu`,
"report.type.label.productPricebooks":`Produkty i Książki Cenowe`,
"label.texttemplate.mergefields.tip":`Dodaj pola inkorporowane podczas edycji treści SMS. Podczas wysyłania wiadomości SMS, pola inkorporowane mogą zostać zastąpione odpowiednim tekstem. Na przykład {!Contact.name} może zostać zastąpione nazwą kontaktu podczas wysyłania wiadomości SMS.`,
"label.publicgroup.detail.showallusers":`Wyświetl wszystkich użytkowników`,
"label.brief.follow":`Kontynuacja`,
"label.forecast.settings.qijian.p":`Prognoza kwartalna`,
"label.sms.url":`URL`,
"setup_layout_group_custompage":`Dostosuj stronę`,
"label.validate.function.funcFormat.BEGINS":`BEGINS(text, compare_text)`,
"label.umeng.chatter.sendmessage":`wysłał ci wiadomość`,
"label.pc.layout":`Układ komputera PC`,
"label.currency.v":`Podaj miejsca dziesiętne (ilość cyfr po przecinku) dozwolone przy wyświetlaniu danych w tej nowej walucie. Musi to być liczba całkowita o wartości od 0 do 6.`,
"label.projectManagement.kanbantask":`Kanban Zadanie`,
"component_recdetail_label_title":`Szczegółowe informacje`,
"label.isremider":`Przypomnienie`,
"front-epwechat-module-v1-input-home-url":`Proszę wpisać adres URL strony głównej`,
"label.usefullife":`Okres ważności`,
"label.visualpage.ptype":`Wspólny`,
"label.quote.name":`Nazwa cytatu`,
"vue_label_report_addtocomponent":`Czy na pewno chcesz dodać { name } do biblioteki komponentów?`,
"label.dashboardSetup.showdw.d1":`100 Milionów`,
"label.validate.function.funcFormat.OR":`OR(logiczne1,logiczne2,...)`,
"label.component.helper.potentialcustom":`Leady przypisane do Ciebie dzisiaj`,
"label.autoRegister.changepwd.setpwd.tip.number":`Co najmniej jedna liczba`,
"label.data.setok.e.desc3":`， pobierz wyeksportowane dane.`,
"label.data.downpage.e.title.num4":`4、 Pliki eksportowe mają dwa formaty: Format CSV i format kompresji. Format kompresji jest podzielony na dwa rodzaje: jeden jest do automatycznego generowania hasła do pliku skompresowanego, drugi jest do ręcznego wprowadzania hasła do pliku skompresowanego.`,
"lable.quote.editqtpdt.description":`Wybierz cennik dla tej oferty. Możesz dodać produkt tylko z jednej książki cenowej, a zmiana wybranej książki cenowej spowoduje usunięcie wszystkich istniejących produktów z oferty.`,
"front-kefu-moudle-edit-userinfo":`Edytuj informacje o użytkowniku`,
"label.please.ChooseMinAndMax":`Proszę wybrać co najmniej {0} opcji produktu, a maksymalnie można wybrać {1}.`,
"label.knowledgebase.archive.an.article":`Zarchiwizować artykuł?`,
"label.multilang.customforcast.submit":`Czy przedkładają Państwo prognozę na okres od {0} roku budżetowego{1} do {2} roku budżetowego{3}?`,
"label.import.index.filename":`Nazwa pliku`,
"front-console-no-reco-contact":`Kontakt nie może być zidentyfikowany`,
"label.quantity.greater.than0":`Ilość musi być większa niż 0.`,
"label.codeNorm":`Kod standardowy`,
"label.average":`Średnia`,
"label.multilang.page1":`Strona`,
"label.data.exp.save.ok":`Zapisz szablon pomyślnie`,
"message.error.delete.record":`Rekord, który ma zostać usunięty, nie został znaleziony!`,
"label.newvaluereplaceoldvalue":`Globalnie zastępuje istniejącą wartość na liście pickupów nową wartością. Upewnij się, że nowa wartość została wcześniej utworzona w polu listy wyboru.`,
"label.tabpage.saveviewsuccess":`Widok zapisany pomyślnie`,
"label.partnerCloud.productSet.parentOptions":`Opcja dla rodziców`,
"label.emailtemplate.availablemergefields":`Dostępne pola scalania`,
"label.data.import.setup":`Ustawienia importu danych`,
"label.escalation.setup.entrydetail.escalation.action":`Działania eskalacyjne`,
"System.TimeField.Description":`Umożliwia użytkownikom wprowadzenie czasu lokalnego. Na przykład, "14:40 PM", "14:40" i "14:40:00" są poprawnymi czasami dla tego pola.`,
"front-additional-products":`Kup inne produkty`,
"label.appointment.wizard.subtitle4-4-1":`1 tydzień`,
"label.chatter.colleagues.list":`Lista współpracowników`,
"label.log.invalid.data":`Nieprawidłowa data`,
"label.file.preview.unconvert":`Nie są generowane informacje o podglądzie, proszę kliknąć szczegóły podglądu`,
"label.customer.detailed":`Wybierz stronę dla tej nowej karty. Podaj inne szczegóły.`,
"label.sendsms.content":`Treść jest następująca:`,
"label.exported_to":`Wyeksportowany plik zostanie wysłany pocztą elektroniczną na adres`,
"label.attendance.checkin":`Check In`,
"Dashboard.NoAccessRightToSee.Warning":`Nie masz uprawnień do przeglądania dashboads {0}, które są ustawione jako defualt open, proszę zresetować.`,
"message.choosedelete":`Proszę wybrać dane, które chcesz usunąć`,
"label_tabpage_choosecontent":`Wybierz zawartość wartości`,
"label.no_responses":`Brak odpowiedzi`,
"report_type_label_customService":`Obsługa klienta`,
"label.report.select.condition":`Warunki`,
"label.umeng.activity.distributeevent":`przydzielił ci wydarzenie.`,
"label.knowledge.language.portuguese":`Portugalski`,
"label.knowledgebase.published":`Opublikowany`,
"UG_opportunity_001":`Jak monitorujesz swoją sprzedaż?`,
"label.mr.caption.scope":`Zakres: zapytanie o wszystkie dane, jeśli nie zostały wybrane`,
"message.login.mfaverification.to.pclogin":`Twoja organizacja ma włączoną weryfikację drugiego logowania, pierwsze logowanie wymaga powiązania z urządzeniem mobilnym, użyj strony PC do powiązania logowania`,
"vue_label_dashboard_pleaseenterthecolorrange":`Proszę wprowadzić zakres kolorów`,
"label.emailsync.status.time":`Czas`,
"chatter.putup":`Udostępnij plik`,
"vue_label_report_drillcondition":`Stan wiercenia`,
"label.emailobject.list.myemail":`Mój e-mail`,
"label_tabpage_andz":`I`,
"label.share_link":`Udostępnij link`,
"label.emailtocloudcc.exists2":`Ta skrzynka pocztowa została ustawiona na Email to Case. Nie powtarzaj ustawień.`,
"label.icon.89":`Doradztwo`,
"front-kefu-moudle-v1-qdygbzx-chat":`Czy na pewno wyłączyłeś czat online?`,
"label.approval.selectone":`Proszę wybrać przynajmniej jedno działanie.`,
"chatter.group.groupName":`Nazwa grupy`,
"label_chatter_relateitem":`Related To`,
"label.file.folder.delete1":`Skasować folder?`,
"Pagelayout_Setup_003":`Pole Nazwa musi być zaznaczone`,
"setup_mainpage_label_welcome2":`Własna baza danych (obiekt)`,
"pagecreator.systemstyle.label.linkcolor":`Kolor łącza`,
"label.task.this.week":`W tym tygodniu`,
"message.custom.field.donotdelete.report":`Pole to jest przywoływane przez raport`,
"pagecreator.layout.button.delete":`Usuń układ`,
"label.reportsSubscriptionPage.condition.operator":`Operator`,
"label.location.display.type.degrees":`Stopnie, minuty, sekundy`,
"label.appupload.upload.url":`URL instalacji`,
"label.logical.relation":`Relacja logiczna`,
"label.knowledge.publish.article":`Opublikuj artykuł`,
"vue_label_commonobjects_detail_activity_commingtask":`Dostępne nadchodzące zadanie`,
"vue_label_pool_reason":`{0} powód`,
"front-gantt-module-subtasks-cannot-subtasks":`Zadania nie mogą pojawiać się pod podzadaniami!`,
"label_tabpage_filesizez":`Rozmiar pliku`,
"label.customfields.formula.returntype.monry.tip":`Obliczanie kwoty w dolarach lub innej walucie i automatyczne formatowanie pola jako kwoty w walucie.`,
"label.tabpage.allapplications":`Wszystkie zastosowania`,
"message.duplication.label.matchcontainletters":`Zawierać`,
"maintenanceplan.workorder.type.asset.workorderlineitem":`Proszę wybrać "Jedna pozycja zamówienia na prace dla każdego składnika aktywów" jako typ generowania zamówienia na prace.`,
"label.preview_post":`Posterunek podglądowy`,
"chatter.p.data":`Poczta Data`,
"label.isnot.right.number":`Nieprawidłowy numer`,
"label.contentsource":`Źródło treści`,
"message.groupandsummaryconditionsame":`Warunki użyte do grupowania nie mogą być takie same jak warunki zbiorcze.`,
"label.weixin.wdyj.nodata.qin":`Przepraszamy, {0} nie ma żadnych danych.`,
"chatter.vote":`Głosowanie(-a)`,
"label_partner_workspace_tab_option":`Dostępne zakładki`,
"chatter.changeVote":`Zmiana Głosowanie`,
"label.data.file.i_title.num2":`2. Zaleca się wyeksportowanie danych podczas ich importu, tak aby dokument eksportu został użyty jako szablon do zestawienia danych do importu, a następnie importu. (Jeśli importowane dane zawierają przecinek, należy go zastąpić symbolem @).`,
"label.relation.list.error":`Błąd`,
"label.validate.function.funcExplain.MILLISECOND":`Zwróć milisekundę dnia (z pól Data/Godzina)`,
"label.emailobject.emaildetail.button.relateto":`Związane z`,
"label.dashboard.dataSource":`Pokaż źródło danych`,
"label.marketseamemset.lead.title":`Ustawienia członków puli wiodącej`,
"label.appupload.addobj":`Dodaj do pakietu`,
"lable.outlook.mcto.domain":`Dodaj moją domenę (gmail.com) do listy wykluczonych domen.`,
"label.input.right.url":`Proszę wpisać prawidłowy adres URL`,
"label.newprocessstep5.tip":`Strona zatwierdzania jest miejscem, w którym osoba zatwierdzająca faktycznie zatwierdzi lub odrzuci wniosek. Korzystając z poniższych opcji, wybierz pola, które mają być wyświetlane na tej stronie.`,
"label.schedulejob.setup.schedule.st4":`4.`,
"label.emailsync.status.user":`Użytkownicy`,
"front-kefu-moudle-v1-jymm-reinput":`Proszę wpisać 12cyfrowe hasło, łączące dwie lub więcej dużych, małych liter, cyfr i znaków.`,
"Lead_Scoring_Setting_Rule_Setup_RuleName":`Nazwa zasady punktacji`,
"label.mr.title.fieldName":`Nazwa pola`,
"label.data.deriall":`Eksportuj wszystko`,
"label.tianyancha.businessverify.step2":`Włącz weryfikację danych biznesowych krok 2`,
"label.submissions":`Zgłoszenia`,
"vue_label_calendar_removed_successfully":`Kalendarz usunięty pomyślnie`,
"label.eventrecordtype":`Typy zapisów zdarzeń`,
"lable.outlook.detail.syndire":`Kierunek synchronizacji`,
"label.mobile.bind.fail":`Nie udało się nawiązać połączenia, spróbuj ponownie później`,
"label.notification.task2":`【被分配人】 obejrzał zadanie, które mu przydzieliłeś`,
"label.partnerCloud.orderingPlatform.paymentMethod":`Pay By:`,
"label.escalation.setup.newaction.step3":`Krok 3 Wybierz użytkownika, którego chcesz powiadomić`,
"label.summaryreport.selectsum":`Wybierz podsumowywane dane i typ podsumowania`,
"label.components.setup":`Ustawienia komponentów`,
"label.taskevent.introduce":`Twoja lista działań`,
"label.assignment.setup.detail.conditon":`Kryteria`,
"front-lightning-module-v1-details-page-chart-select-statements":`Wybierz raport`,
"lable.Song.typeface":`SimSun`,
"label.formulassesstrue":`formuła zwraca wartość true`,
"label_partner_common_setup":`Ustawienie ogólne`,
"label_chatter_dateRange":`Zakres dat`,
"label.partner.workspace.tab.mobile.using":`Wyświetlanie w aplikacji mobilnej`,
"message.servicecrew.time.violation1":`Naruszenie czasu przeznaczonego na zadanie: jest członek zespołu.`,
"report_label_projectcount":`elementy, sortowanie według nazwy raportu`,
"label.file.uploadfile":`Prześlij pliki`,
"vue_label_commonobjects_detail_correct_email_address":`Proszę wpisać poprawny adres e-mail`,
"lable.account.CurrentandNextCQr":`Bieżące i następne 3 CQ`,
"setup.layout.label.order":`Sort By`,
"label.service.major.event.independent":`Niezależny`,
"label.icon.38":`Pozycjonowanie`,
"label.knowledge.draft.record":`Rekord, który próbujesz usunąć nie został znaleziony.`,
"label_quota_percentage":`Pokaż Zakończenie Procent kwoty`,
"label.escalation.setup.entrydetail.escalation.minute":`Protokół`,
"label.knowledgebase.edit.article.category":`Edytuj kategorię artykułu`,
"Homepage_News_003":`Nie można wyświetlić wiadomości bez danych konta, proszę utworzyć nowe konto, a powiązane wiadomości zostaną wyświetlone.`,
"label.mr.descreption.oneGroupNote3":`zapisy.`,
"label.customsetting.touse.getListCustomSetting":`Zapytajcie o dane typu "list" ustawień niestandardowych, zwróćcie wszystkie dane odpowiadające nazwie API. Mapa map = cs.getListCustomSetting(String apiName);`,
"message.error.view.cannotbenull":`Błąd: musisz wprowadzić wartość`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.friday":`Piątek`,
"message.error.view.badprevilege.qin":`Przepraszamy, nie masz dostępu do {1}, więc nie pokazano danych</br>`,
"label.dashboard.distribution":`Dystrybucja`,
"label.field.value.save":`Zawsze trzeba podać wartość w tym polu, aby zapisać rekord.`,
"label_custom_year":`Rok indywidualny`,
"label.code.error":`Kod zawiera polecenia lub funkcje, które nie są dozwolone, jak poniżej:`,
"label.appexchange.uninstallpage.message2":`Trwale usuń wszystkie własne ustawienia dla tych komponentów.`,
"label.global.search.obj":`Obiekt wyszukiwania globalnego`,
"label.emailobject.from":`Ze strony`,
"lable.opppdt.selPdt.byconditions":`Przez pole`,
"chatter.p.note":`Uwagi dotyczące tego stanowiska`,
"label.hiddenformulaedit":`Ukryty edytor formuł`,
"label.editQuotation":`Edytuj wycenę`,
"label.notification.arketsea.collection":`{5} zebrane{2}{0}{0}:{1}`,
"label.timzone.tip.info1":`Jeśli chodzi o zapisywanie danych typu java. util.Date （insert i update） w bazie danych, na przykład, Jeśli chodzi o zapisywanie bazy danych (insert i update) typu java.util.Date, na przykład, TpSysTask task=new TpSysTask () ；task.setBeginTime (new Date () ）；......dbman.insert (zadanie) lub dbman.update (zadanie); powinieneś zmienić new date (), aby wywołać TimeUtil.getNowDate (userInfo), więc odpowiednie oświadczenie w powyższym przykładzie powinno zostać zmienione na task.setBeginTime (TimeUtil.getNowDate (userInfo);)`,
"label_tabpage_transformationsz":`Konwertuj`,
"front-kefu-moudle-IP-phone":`Telefon IP`,
"label.emailobject.list.draft":`Projekty`,
"label.tianyancha.businessverify.readandconfirm":`Przeczytałem umowę i zgadzam się z nią`,
"label.win.customers":`Rachunki zamknięte-wygrane`,
"vue_label_commonobjects_view_switch_display":`Rekordy są pogrupowane według typu rekordu, możesz kliknąć odpowiednią nazwę typu rekordu, aby przełączyć wyświetlanie.`,
"pagecreator_systemstyle_label_textcolor":`Kolor tekstu`,
"label.autosearch.keywords":`Automatyczne kompletne wyszukiwanie słów kluczowych`,
"label.knowledge.setting.data.six":`Zamierzasz usunąć kategorię {lbmc}, czy na pewno chcesz kontynuować?`,
"front-console-sort-field":`Nr sprawy.`,
"label.bangladesh.time":`Czas Bangladeszu`,
"label.dashboardSetup.number":`Wartości liczbowe`,
"lable.account.LastbDays":`Ostatnie 30 dni`,
"label.layout.searchdialog":`Lookup Dialog`,
"label.newprocessstep4.tip":`Wybierz szablon wiadomości e-mail, który będzie używany do powiadamiania osób zatwierdzających, że wniosek o zatwierdzenie został do nich przypisany. Zauważ, że ten szablon będzie używany dla wszystkich kroków tego procesu.`,
"label.nousing":`Nieaktywny`,
"vue_label_report_detailline":`Linia szczegółowa`,
"label.emailobject.template.message3":`Maksymalna liczba szablonów poczty została osiągnięta!`,
"label.c.d":`C do D Związek`,
"message.report.error.fail":`Ładowanie nie powiodło się, proszę spróbować ponownie`,
"label.edit.ccdocument.content":`zmodyfikowany attechment.`,
"label.textmessage.exceeded":`Liczba Twoich szablonów tekstowych przekroczyła limit!`,
"label.saveas":`Zapisz jako`,
"label.visualpage.an.inline.style":`Osadzenie niestandardowego typu strony na stronie szczegółów i stronie głównej zakładki`,
"label.pagelayout.remark2":`dane. Po utworzeniu układu strony kliknij przycisk Przypisanie układu strony, aby kontrolować, jaki układ strony użytkownicy widzą domyślnie.`,
"label.notification.approval1":`Wniosek o zatwierdzenie dla【对象】 został zatwierdzony przez【审批人】`,
"label.h5.chatter.image":`Format przesyłanego obrazu jest nieprawidłowy`,
"vue_label_dashboard_displayunit":`Proszę wybrać jednostkę wyświetlającą`,
"label.knowledge.default.language":`Domyślny język wiedzy`,
"label.chatter.publish":`Opublikuj`,
"label.companyprofile.serveraddress":`Ta synchronizacja synchronizuje tylko bieżący serwer.`,
"label.chatter.groups":`Grupa`,
"label_set_successfully":`Udało się!`,
"label.quote.zongjia":`Cena całkowita`,
"label.project.notice.endingdatelater":`Data końcowa powinna być późniejsza lub równa dacie początkowej.`,
"label.customfields.fielddependency.info":`Strona ta umożliwia definiowanie zależności między polami (np. zależne listy pickupów).`,
"vue_label_lead_successful_conversion":`Pomyślna konwersja`,
"label.icon.93":`Książka`,
"shift.serviceresource.illegal":`Zasób serwisowy nie dotyczy członka terytorium serwisowego lub data przesunięcia nie jest w zakresie członkostwa.`,
"label.integrations.action.addnewlead":`Dodaj nowe leady`,
"label_display_all_zeros":`Pokaż wszystkie wiersze z wartościami zerowymi`,
"canlendaryear":`Rok kalendarzowy`,
"label_tabpage_selrecordtypez":`Wybierz typ rekordu`,
"vue_label_commonobjects_view_chart_funnel":`Wykres lejkowy`,
"label.layout3":`Układ 3`,
"label.logintime.cue":`Nie określono czasu logowania.`,
"label.service.miniProgram.lastDate":`Data ostatniej modyfikacji`,
"label.emailobject.view.fromcrm":`Wiadomości email od kontaktów/ potencjalnych klientów`,
"pagecreator.button.mobilepage":`Mobile-side`,
"lable.oppt.jieduan.signcur":`Oznaczony jako aktualny etap`,
"label.fullaccess":`Pełny dostęp`,
"homepage.layout.pagename":`Nazwa układu strony`,
"label.appointment.wizard.subtitle4-2-3":`3 h`,
"label.knowledgebase.please.check.record":`Proszę wybrać co najmniej jeden rekord.`,
"label.view.sortview.closepage":`Zamknij okno`,
"label_forecast_type":`Rodzaj prognozy`,
"all.day":`Cały dzień`,
"label.view.sortview.printpage":`Wydrukuj tę stronę`,
"message.integration.configure":`Zintegrowana konfiguracja jest pusta!`,
"label.forecast.customforecast.foretype.close":`Closed-Won`,
"label_chatter_like":`Jak`,
"template.report.folder.customer.potential":`Analiza leadów`,
"label.umeng.approval.dlsp.approve":`#approvalname zatwierdził wniosek o zatwierdzenie #actorname'' dla #objAPIName #recordname dla Ciebie.`,
"vue_label_normal_movedown":`Przesunąć w dół`,
"chatter.group.groupAccessPermissions":`Dostęp grupowy`,
"label.visualpage.tip":`Możesz stworzyć swoją własną stronę tutaj`,
"message.validation.isnotdate":`Nieprawidłowa data`,
"label.icon.173":`Żaglówka`,
"label.icon.124":`Wtrysk`,
"label.import.page2.csvfiled":`Pole CSV`,
"setup_layout_component_area":`Obszar`,
"label.visualpage.workability.standard":`Dostępne klasy standardowe na stronie`,
"label_emailtocloudcc_redmessage9":`Błąd bazy danych, prosimy o kontakt z administratorem.`,
"label_tabpage_contactsz":`Kontakty`,
"label.multilang.workflow.everydayinmonth":`{1} dni co {0} miesięcy`,
"APPIntegration.Social.linkedinerror":`Musisz wprowadzić prawidłowy adres URL dla linkedin.com`,
"button_partner_workspace_manage_memo":`Zarządzaj chmurą partnerską i konfiguruj właściwości chmury partnerskiej.`,
"template.chart.bnsrmb":`Cel w zakresie dochodów na dany rok`,
"chatter.follow.now":`Śledząc stronę`,
"label.entitlement.process.condition.repeat":`Powtórzenie kamienia milowego`,
"label.relationobject.isdl":`Delegat`,
"label.lasttimemodifieralias":`Alias ostatniego modyfikatora`,
"vue_label_commonobjects_detail_task_name":`Edytuj nazwę zadania`,
"vue_label_homepage_quarterlyperformance":`Wyniki kwartalne`,
"pagecreator.layout.message.delete":`Czy usuwasz aktualnie wybrany układ?`,
"component_sendmail_label_cc":`Cc`,
"vue_label_email_enable_signature":`Włącz podpis`,
"label.partnerCloud.financeSetting.create":`Utwórz fundusz dla kwalifikujących się użytkowników automatycznie po aktywacji nowych parterów.`,
"label.data.file.i.title.num1":`1. Importowany plik musi być plikiem w formacie CSV. Plik musi zawierać tytuł i nie może być importowany bez tytułu.`,
"label_efine_assessment":`Cykl oceny`,
"message.duplication.label.sectionTitle":`Wybierz wartość, która ma zostać zachowana`,
"front-electronic-export-buttonExport":`Kontynuuj eksport`,
"message.submitpage.email":`Gratulacje, wiadomość została wysłana pomyślnie.`,
"after":`Po`,
"label.version.nonsupport":`Niewspieranie`,
"label.icon.105":`Harmonogram`,
"label.quickcreate.titledesc":`Włączenie opcji szybkiego tworzenia pozwala użytkownikom na tworzenie rekordów z poziomu okna wyszukiwania.`,
"label.quote.number":`Wprowadź ilość`,
"label.view.sortview.setdefault.prompt":`Przypnij tę listę widoków`,
"label.refertime":`Data przedłożenia`,
"frame.personinfo.label.minipic":`Miniaturka obrazu`,
"label.mobile.home.page.newopp":`Ostatnio utworzone leady`,
"label.address":`Adres`,
"front-pay":`Zapłać`,
"label.chat.serviceAppointment":`Zawiadomienie o usłudze`,
"label.umeng.activity.eventviewed":`Zdarzenie, które przypisałeś do #name jest oglądane`,
"label.validate.function.funcExplain.DATE":`Tworzenie daty poprzez rok, miesiąc i dzień`,
"label.commiterselectapprover":`Pozwól zgłaszającemu ręcznie wybrać osobę zatwierdzającą.`,
"label.appointmentconfirmpage.wizard.subtitle3":`Lokalizacja`,
"vue_label_display_text_field":`Pokaż pola tekstowe`,
"label.salescloud.teamrole":`Rola zespołu`,
"maintenanceplan.workorder.generate.limit":`Zlecenie pracy powinno mieścić się w zakresie harmonogramu konserwacji.`,
"label.campaignmember.selectmember.description":`wyselekcjonować widok, następnie dodać członków do kampanii, a status kampanii Menmeber to`,
"label.ismodify":`Zezwalaj na edycję`,
"label.height":`High`,
"label.tabpage.thevalurofz":`Wartość`,
"label.create_successful":`Pomyślne utworzenie formularza`,
"front-invoice-online-payment-setup-configure-dialog":`Konfiguracja interfejsu płatności`,
"label.customerinfo.smsEid":`Brama SMS EID`,
"label.visualpage.list.no":`Brak uprawnień do dostępu do stron niestandardowych`,
"look.trigger.in":`Zobacz instrukcje`,
"label.setting.disable":`Dezaktywuj`,
"chatter.group.name":`Grupy`,
"label.solutionadministrator":`Kierownik ds. rozwiązań`,
"label.vlidaterule.top":`Góra strony`,
"pagecreator.layout.message.save.fail":`Nie udało się zapisać układu`,
"label.partnerCloud.orderingPlatform.noZero":`Ilość nie może wynosić 0.`,
"label.customfields.suretodeleteprompt":`Potwierdź podpowiedzi usunięcia pola niestandardowego`,
"button_partner_viewdetail":`Zobacz`,
"label.icon.122":`Dom`,
"label.customer.tab.step2.introduce":`Wybierz profile użytkowników, dla których będzie dostępna nowa karta niestandardowa. Możesz również sprawdzić lub zmienić widoczność zakładek na stronach szczegółów i edycji każdego profilu.`,
"label.task.delegated":`Delegowany`,
"vue_label_salesadvance_averageamount":`Za transakcję z klientem`,
"vue_label_chat_invitedtojoin":`{zaproszenie} zaprosił cię do udziału w czacie grupowym`,
"label.data.downpage.e_title.num1":`1. Wybierz obiekty, które chcesz eksportować lub wybierz opcję eksportu wszystkich.`,
"label_display_options":`Opcje wyświetlania`,
"vue_label_chatter_more_comments":`Więcej uwag`,
"label.ggReleaseRange.publish":`Opublikuj listę`,
"label.valuetype.notmate":`Błąd warunku linii, typ wartości nie jest zgodny.`,
"label.chatter.chatter":`CCChat`,
"label.exchange.sync.state.contact.m1":`Ostatnia synchronizowana aktywność:`,
"label.dataimport.duplication.filter":`Znajdź duplikaty filtrów podpowiedzi`,
"label.appdownload.uninstall":`Odinstaluj`,
"message.error.task.add":`Anomalia nowego zadania`,
"UG.Account.07":`Konto importowe`,
"label_tabpage_lastone":`Wybierz co najmniej jedną operację`,
"front-console-holdTime":`Czas opóźnienia`,
"label.emailobject.schedule":`Zobacz mój harmonogram i zarezerwuj czas tutaj.`,
"label.lookup.locked.data":`Ten zapis jest zablokowany, nie do wyboru`,
"label.assignment.setup.newentries.ifcondtions":`Uruchom tę regułę, jeśli`,
"label.magadan.time":`Pietro Pavlov Czas`,
"message.error.serviceterritorymember":`Proszę zdefiniować wybrany zasób serwisowy jako członka terytorium serwisowego w zakresie czasowym planu wizyt serwisowych.`,
"label_chatter_delete":`Usuń`,
"label.partner.workspace.member.permission":`Zestaw dostępnych uprawnień`,
"label.notification.task5":`Twoje zadanie zostało spóźnione`,
"mary":`Maj`,
"label.homepagemodule":`Komponenty strony głównej`,
"label.compact.layout.frame.error1":`Prawy ekran nie może nie mieć zawartości`,
"chatter.error.refresherror":`Odświeżanie nie powiodło się, proszę spróbować ponownie.`,
"label.login.rememberPsd":`Pamiętaj o mnie`,
"Lead.Scoring.Setting.Rule.Setup.01":`Lista zasad Lead Scoring`,
"label.reportsSubscriptionPage.schedulereport.weekly.sunday":`Niedziela`,
"label.visible":`Widoczny`,
"label.console.new":`Nowa konsola`,
"label.mr.descreption.reDataList4":`milisekund. na stronę.`,
"vue_label_notice_uploadavatar_notice2":`Przesłany obrazek awatara może być tylko w formacie JPG/PNG/GIF`,
"label.operation.error":`Operacja nie powiodła się, proszę spróbować ponownie.`,
"label.sendsms.context":`Treść SMS`,
"label.least.show.line":`(wyświetl co najmniej 4 linie)`,
"label.tabpage.newWizardz":`Nowy dodany kreator funkcji`,
"label.tippage.li2":`Usuń wszystkie raporty oparte na źródle danych raportu niestandardowego`,
"label.customfields.new.step2.opration.unique":`Wyjątkowa`,
"label.listofshare.remark":`Następujący użytkownicy mogą przeglądać rekordy`,
"label.address_information":`Informacje o adresie`,
"label.projectManagement.overdue.tasks":`Zaległe zadanie`,
"lable.account.PreviousCQ":`Poprzedni CQ`,
"label.service.miniProgram.advertising":`Nazwa ogłoszenia jest używana tylko do identyfikacji wielu wpisów ogłoszeń i nie jest wyświetlana w ogłoszeniu.`,
"label.integrations.mailchimp.exportlead":`Eksportuj wybrane leady do Mailchimp`,
"label.payments.paytip3":`Proszę wybrać adres rozliczeniowy`,
"label.mobile.phone.screen":`Filtr`,
"label.h5.tome":`O mnie`,
"label.mobile.side.tab.remark1":`Dodaj zakładkę i obiekt CloudCC do menu nawigacyjnego slidera po stronie mobilnej.`,
"vue_label_calendar_choose_a_custom_color":`Wybierz indywidualny kolor tego kalendarza`,
"label.lastname":`Nazwisko`,
"vue_label_dashboard_selectreport":`Proszę wybrać raport`,
"label.lanxin.setting.appid":`AppID`,
"vue_label_report_information":`Eksportuj raport w formie wyświetlanej w Cloud CC, łącznie z nagłówkiem raportu, informacjami o grupach i filtrach.`,
"label_chatter_default":`Domyślnie`,
"label.globalSearch.info":`Wyszukiwanie wszystkich wybranych obiektów`,
"label.integrations.mailchimp.massage2":`Eksport wybranych leadów do MailChimp, dzięki czemu będziesz mógł je później przeglądać na liście w Mailchimp`,
"label.tabpage.addresswrongz":`Błędny format adresu skrzynki pocztowej, proszę poprawnie wpisać adres skrzynki!`,
"label.mobile.phone.customer.call":`Odwiedź Klienta`,
"vue_label_email_linkrecordfail":`Rekord niepołączony`,
"lable.account.LastfDays":`Ostatnie 90 dni`,
"label.cpq.order.status.delete":`To zamówienie jest aktywne i nie może zostać usunięte.`,
"label.ccchat.notmember.active.group":`Nie jesteś członkiem`,
"label.savepayset.failure":`Nie udało się zapisać konta płatności online`,
"label.version.createlimitbyobject":`Twoja aktualna edycja CloudCC to {0}, a możesz utworzyć {1} {2} dla każdego obiektu. Teraz liczba {2} przekracza maksimum Twojego planu subskrypcji, proszę zaktualizuj swoją edycję CloudCC.`,
"approval.process.errore":`Wystąpił błąd podczas zapisywania, skontaktuj się z administratorem.`,
"label.stdashbord.xsld.business.reportanalysis":`Analiza wykresów`,
"label.login.verification.please.enter":`Proszę wprowadzić kod bezpieczeństwa otrzymany z aplikacji MFA.`,
"label.tabpage.cue":`Przypomnienie informacji`,
"vue_label_salesadvance_converserate":`Przelicznik`,
"label.marketsea.recyclereminddays1":`Przed automatycznym recyklingiem`,
"label.import.page1.update":`Aktualizacja`,
"label.document.folder":`Teczki na dokumenty`,
"label.h5.similar.opportunity.feature":`Ta funkcja pozwala użytkownikowi na wyszukiwanie szans, które mają wspólne pola z daną szansą. Po włączeniu tej funkcji na rekordzie szansy pojawia się lista Podobne okazje.`,
"label.myanmar.time":`Czas Myanmar`,
"monday":`Poniedziałek`,
"vue_label_account_shareholder":`Akcjonariusz`,
"button.partner.search":`Zapytaj`,
"label.partnerCloud.partnerAccount.topUpAmount":`Kwota doładowania`,
"label.tabpage.refreshz":`Odśwież`,
"lable.PowerProcess.complete":`Kamień milowy Zakończenie Mins`,
"front-kefu-moudle- normal-phone":`Telefon ogólny`,
"label.user.unauthorized.organization":`Nieautoryzowana organizacja, prosimy o kontakt z administratorem.`,
"label.area.canot.save.nulldata":`Nie można zapisać danych null`,
"label.version.role.management":`Zarządzanie rolami`,
"label.recordtype.batchaddattachments.batch.remark":`Krok 1 Wybierz plik, Krok 2 Kliknij przycisk "rozpocząć przesyłanie", przesyłanie plików, Krok 3 Kliknij przycisk, aby zakończyć.`,
"label_tabpage_contentz":`Proszę wpisać treść`,
"label.partner.workspace.member.all":`Wszystkie`,
"label.validate.function.funcFormat.LEFT":`LEFT(text, num_chars)`,
"vue_label_SMS_notice_selectatleastone":`Proszę wybrać co najmniej jeden lead lub kontakt`,
"label.appupload.install.error.choice5":`Natychmiast zatrzymaj instalację i usuń konfliktowe komponenty`,
"label.version.lookupmdfield":`Pole relacji mistrz - szczegół`,
"setup.layout.label.desc":`Zjeżdżający`,
"vue_label_report_addsummaryformula":`Dodaj formułę podsumowującą`,
"label.done":`Gotowe`,
"label.input.samevalue":`Wprowadź tę samą wartość`,
"label.SMS.next":`Należy wybrać obiekty dla powiadomień SMS i kliknąć "Dalej". Powiadomienia SMS mogą być kojarzone tylko z regułami przepływu pracy i procesami akceptacji tego samego typu.`,
"label.role.allunselectuser":`Wszyscy nieprzypisani użytkownicy`,
"label.loginhistory":`Historia logowania`,
"vue_label_report_addpublicreportstofolder":`Dodaj raporty publiczne do tego folderu`,
"label.email.track.no.attachment":`Brak załącznika`,
"label_network_connection_failure":`Połączenie sieciowe nie powiodło się.`,
"vue_label_file_delete_lib_member":`Usuń członka biblioteki plików`,
"label_partner_step1":`Krok 1 wybór szablonu`,
"label.password":`Hasło`,
"label.select.the.fields.around.code":`Wybierz pola, które mają być wyświetlane wokół kodu QR/kodu kreskowego.`,
"label.file.share.limit":`Po przekroczeniu limitu udziałów nie można dodać żadnego nowego udziału!`,
"label.desktop":`Pulpit`,
"label.sendmail":`Wyślij e-mail`,
"label.quote.detail":`Pozycje kosztorysowe`,
"label.approvalstep2":`Krok 2 Określenie kryteriów kroku`,
"label_component_hotdeal_nodata":`Brak danych związanych z możliwościami biznesowymi.`,
"lable.reset":`Reset`,
"label.eventpagelayout":`Układy strony wydarzenia`,
"label.icon.100":`Materiały piśmienne`,
"UG.quota.03":`Wzór cytatu`,
"label.calendar.week.view":`Widok tygodnia`,
"component_chatter_file_button_save":`Opublikuj`,
"label.as":`Jak`,
"template.chart.yqxypjz":`Średnia oczekiwana odpowiedź`,
"UG.Contract.03":`Tworzenie umowy`,
"label.projectManagement.gantt":`Wykres Gantta`,
"label.forecast.edit.error0":`Błąd: Musisz wybrać co najmniej jedną walutę korporacyjną.`,
"label.ccpeak.delete.sharetab":`Usuń formularz udostępniania`,
"label.account.contact.goback":`Powrót do rachunków`,
"vue_label_email_insert_field":`Proszę wybrać pole do wstawienia`,
"setup_object_field_dependency_label_fieldvalueoptions":`Dostępne wartości pól`,
"label.salescloud.opportunity.contactrole.optionlist.main":`Poniżej znajduje się główna lista opcji listy wartości dla pola role kontaktu na szansach`,
"label.huanxinconfig.tenantid.lost":`tenantid nie może być pusty`,
"label.mask.show.last_4":`Zamaskuj ostatnie cztery znaki`,
"label.targer.name":`Nazwa wskaźnika`,
"vue_label_commonobjects_detail_unlocksuccess":`Pomyślnie odblokowany`,
"front-kefu-moudle-length-min":`Długość (minuty)`,
"label.chat.topic.my.favorite":`Moje Tematy z Zakładek`,
"chatter.upload":`Prześlij`,
"message.cannotapproveit":`Wniosek o zatwierdzenie nie może zostać przetworzony.`,
"label.weixin..xsld.order.by.jine":`Sortuj według kwoty umowy`,
"label.projectManagement.wait.test":`Czekamy na testy.`,
"template.report.customer.contact.list":`Kontaktowa lista rachunków`,
"label.empty.recycle.bin":`Wyczyść kosz na śmieci`,
"label.detail.approveprocess":`Wyświetl procesy zatwierdzania`,
"label.appexchange.uninstallpage.message4":`Trwale usuń wszystkie raporty, widoki i zakładki niestandardowe obiektów niestandardowych w tym pakiecie`,
"label.weixin.linkreport":`Powiązane z raportem`,
"label.tianyancha.orgnumber":`Kod organizacji`,
"Q":`Picklist (Multi-Select)`,
"pagecreator_systemstyle_message_save_fail":`Nie udało się zapisać stylu`,
"label.partner.new":`Chmura partnerska: nowość`,
"label.ems.accounttype":`Rodzaj rachunku (a)`,
"label.weixin.next":`Następny`,
"label.weixin.coach.interpret":`Aid-Max zastrzega sobie prawo do rewizji i ostatecznej interpretacji w zakresie prawa serwisu WeChat.`,
"label.some":`zapis(y)`,
"label.currency.rate":`Edycja waluty: Kursy wymiany`,
"label.emailobject.template.name":`Nazwa szablonu`,
"UG.Campaign.001":`Planowanie kampanii`,
"label.mr.descreption.reDataList3":`grupy danych, czas zapytania`,
"label.project.hit.nine":`Codzienne przypomnienie o emisji`,
"lable.PowerProcess.golist":`<<Wstępna lista：Proces uzyskiwania uprawnień`,
"label.viewbuttonedit.remark":`Wybierz standardowe i niestandardowe przyciski wyświetlane w widoku pierwszoplanowym.`,
"label.component.helper":`Asystent`,
"lable.SalesCommitmentKanBan.contractAndReceipts":`Podpisane Płatność`,
"chatter.group.userName":`Nazwa użytkownika`,
"label.mobile.phone.business":`Możliwości`,
"label.quickbooks.payments":`PAY`,
"label.step6.total7":`Krok 6 z 7`,
"label.forecast.detailforecast.revenue":`Prognoza przychodów`,
"vue_label_commonobjects_view_chart_displayas":`Wyświetlać jako`,
"label.recordeditoption":`Właściwości edytowalności rekordu`,
"label.sendemail.send.sendfailstandby":`Wysyłanie wiadomości e-mail nie powiodło się, skontaktuj się z administratorem (zapasowa skrzynka odbiorcza).(kod błędu:`,
"label.knowledgebase.reset.filter":`Resetuj filtr`,
"label.icon.111":`Żywność`,
"label.standard.buttonandlink.firstsetting":`Właściwości nadrzędne`,
"front-filter-module-v1-filter-description":`Filtr flash nie może być zapisany. Ma on zastosowanie tylko do bieżącej operacji bez wpływu na widoki lub innych użytkowników.`,
"label.showmore":`Zobacz więcej`,
"UG_Lead_001":`Jak wprowadzać wskazówki?`,
"label.exchange.sync.state.setting.m1":`Podano konto usługi Miscrosoft Exchange:`,
"label.please.enter.channel.name":`Proszę wprowadzić nazwę kanału.`,
"label.emailtocloudcc.edit":`Edytuj`,
"label.layout.tabdialog":`zakładki`,
"label.Emoji":`Emoji`,
"template.report.completed.tasks":`Zadania zakończone`,
"label.tabpage.enterviewname":`Krok 1: wprowadź nazwę widoku`,
"label.mobile.phone.not.to.choose":`Brak Wybrane`,
"label.datamanage.contact.namenull":`Uwaga: Uwaga: Jeśli pole nazwy kontaktu jest puste, rekord nie zostanie zaimportowany.`,
"LT":`Geolokalizacja`,
"label.exchange.sync.state.task.m3":`Rekordy zsynchronizowane w ciągu ostatnich 24 godzin:`,
"lable.SalesCommitmentKanBan.contractOwner":`Właściciel kontraktu`,
"vue_label_chatter_write_review":`Napisz komentarz`,
"label.h5.approval.enter.content":`Proszę wprowadzić uwagi dotyczące zatwierdzenia`,
"label.location.display.type":`Metoda wyświetlania szerokości i długości geograficznej`,
"label.numberscannotnull":`Liczba nie może być pusta`,
"label.icon.3":`Waluta`,
"setup_object_field_dependency_label_linkedfieldvalue":`Pole zależne`,
"label.task.future":`Zadania na przyszłość`,
"label.look.more.record":`Pokaż więcej`,
"vue_label_account_cases":`Przekazanie wszystkich spraw właścicieli klientów`,
"label.emailobject.emaildetail.title.ccaddress":`CC:`,
"label.setHistoryTrack":`Ustaw śledzenie historii`,
"ObjectDetailed.ViewKeyInformation.Layout":`Edytuj kluczowe informacje`,
"label.layout.editsearchdistribute.tip":`Wybrać pola, które mają być uwzględnione w tym układzie wyszukiwania. Zauważ, że Twój wybór określa jedynie sposób wyświetlania wyników wyszukiwania i nie ma wpływu na pola, które są faktycznie wyszukiwane.`,
"label.emailtoall":`Wyślij wiadomości e-mail do wszystkich użytkowników.`,
"label_partner_new":`Chmura partnerska: nowość`,
"label.direct.dashboard.me.not.approval":`Moje pozycje do zatwierdzenia`,
"label.platform.customize.customizeui":`Własne UI`,
"label.userinfo.pwderror.againinput":`Dwukrotnie wprowadzone hasło nie jest takie samo. Proszę wpisać ponownie.`,
"label.customsetting.introduce":`Ustawienia niestandardowe służą do tworzenia i zarządzania danymi niestandardowymi na poziomie organizacji, profilu i użytkownika. Dane ustawień niestandardowych są przechowywane w pamięci podręcznej aplikacji. Oznacza to, że można uzyskać do nich dostęp w sposób efektywny, bez kosztów wielokrotnych zapytań.`,
"label.file.owner":`Właściciel`,
"label.icon.7":`Ludzie`,
"label.document.query.button":`Kliknij przycisk przeglądaj, aby znaleźć plik`,
"label.tabpage.turnoffsz":`Zamknięte  Przekształcone`,
"message.error.appid.appsecret.failed":`Nie udało się zdobyć kluczy bezpieczeństwa!`,
"vue_label_commonobjects_view_to_display_fields":`Wybierz do 10 pól wyświetlania`,
"label.martrixreport.setlinetitle":`Określ nagłówki wierszy`,
"vue_label_chatter_applycertification":`Zgadzasz się, aby "{name}" dołączył do czatu grupowego?`,
"front-electronic-export-success":`Eksport zakończył się sukcesem, proszę sprawdzić na liście Mailchimp.`,
"label.emailsync.status.enable":`Active Connect`,
"label.c_d":`C do D Związek:`,
"PageLayout_Search_MultiSearch_003":`Wybierz co najmniej jedno pole.`,
"label.tabpage.newInterfacez":`Nowy interfejs`,
"label.cutomsummaryfieldedit":`Edycja niestandardowego pola podsumowania`,
"label.usermanage.view.field.notexist":`Pole odpowiadające widokowi nie istnieje.`,
"label.list.userinterface.dashboard.setup":`Konfiguracja pulpitu nawigacyjnego`,
"label.knowledgebase.delete.article":`Usuń artykuł`,
"label.dataimport.type.update":`Aktualizacja`,
"label.marketsea.new":`Nowy basen`,
"label_tabpage_newlybuildz":`Nowy`,
"vue_label_helpcenter_report1":`1.Zbuduj raport<br> Raport Lightning w systemie zarządzania sprzedażą Cloud CC jest potężnym narzędziem do analizy danych. Wiele problemów związanych ze sprzedażą można rozwiązać poprzez grupowanie, filtrowanie i podsumowywanie rekordów. Na przykład: "Jak duży przychód stworzyły nowe możliwości biznesowe firmy w ostatnim kwartale?". Wykresy raportu można dodawać na podstawie uzupełniania przeglądu danych. Po zakończeniu raportu kliknij Uruchom, aby wyświetlić kompletne wyniki danych. <br> Krok 1: W zakładce raportu kliknij "Nowy raport";<br> Krok 2: Wybierz źródło danych raportu, a następnie kliknij "Dalej";<br> Wybrane źródło danych raportu może określić, które rekordy lub pola mogą być używane w raporcie. Wybierz lub wyszukaj obiekt jako obiekt główny. Możesz wybrać do 4 obiektów, które są powiązane z obiektem głównym i możesz wybrać relację między obiektami. <br> Krok 3: Wejdź na stronę edycji raportu i wyświetl dane podglądu<br> W trybie edycji, możesz dostosować raport, dodać pola jako kolumny do raportu, grupować wiersze i kolumny oraz używać filtrów do filtrowania danych raportu, aż dane, których potrzebujesz będą wyświetlane dokładnie<br>Dodaj lub usuń kolumny i dostosuj kolejność<br> Dodaj kolumnę: W trybie edycji raportu, kliknij pole wejściowe "Kolumna" w "Podsumowaniu" po lewej stronie strony i dodaj kolumny raportu po wyszukaniu pola lub przewinięciu rozwijanej listy pól i wybraniu pola docelowego. <br> Usuwanie kolumny: <br> A. Po znalezieniu "kolumny", którą chcesz usunąć na liście "kolumny" po lewej stronie, kliknij "×" na polu. <br> B. Lub znajdź kolumnę, którą chcesz usunąć w nagłówku podglądu raportu po prawej stronie, kliknij "przycisk rozwijania" i kliknij "usuń kolumnę".<br> Usunięcie kolumny z raportu nie powoduje usunięcia pola. Jeśli chcesz przywrócić kolumnę po jej usunięciu, po prostu dodaj ją ponownie. <br> Dostosuj kolejność kolumn: Przeciągnij pole "Kolumna" na liście "Kolumna" po lewej stronie w górę i w dół, aby dostosować kolejność rozmieszczenia "Kolumna". <Dodaj i usuń grupowanie wierszy i kolumn<br> Dodaj grupowanie wierszy: Kliknij pole wejściowe "Grupuj wiersz" w "Podsumowaniu" po lewej stronie i dodaj pola grupowania wierszy raportu, aby filtrować dane po wyszukaniu pola lub przewinięciu rozwijanej listy pól, a następnie wybraniu pola docelowego. <br> Bez dodawania grupowania kolumn, możesz dodać do trzech grupowań wierszy. <br> Dodaj grupowanie kolumn: gdy istnieje grupowanie wierszy, możesz dodać grupowanie kolumn. Kliknij pole "Grupuj kolumnę" w polu "Podsumowanie" po lewej stronie strony, wybierz pole po wyszukaniu lub przewiń rozwijaną listę pól i wybierz żądane pole Sposoby dodawania pól grupowania kolumn raportu w celu filtrowania danych. <br> Można dodać maksymalnie dwie grupy kolumn. W przypadku dodawania grup kolumn można dodać maksymalnie dwie grupy wierszy. Pola dodane jako grupy wierszy nie mogą być dodane jako grupy kolumn. <br>`,
"label.notification.event1":`【分配人】 przydzielił ci wydarzenie`,
"chatter.field":`Pole(-a)`,
"chatter.feed.menutype.feed.newscom":`Wszystko, za czym podążam`,
"label.attendance.range":`Zakres frekwencji`,
"vue_label_calendar_deleteconfirm":`Czy na pewno chcesz usunąć kalendarz {name}`,
"label.ems.createTask":`Nowe {taskName}`,
"label.visualpage.wgd":`Niewypełnione strony niestandardowe`,
"label.multilang.product.deleterederect1":`Twoja próba usunięcia <font style="font-weight:bold;">{0}</font> nie mogła zostać zakończona, ponieważ jest on nadal powiązany z następującym rekordem. W tym przypadku zalecamy jego wyłączenie.`,
"label_emailtocloudcc_filed_servertype":`Serwer poczty elektronicznej`,
"label.umeng.insert.approval.dlsp.approvenew":`#actorname przesyła #objAPIName#recordname do Twojej akceptacji`,
"label.tabpage.queue":`Kolejka`,
"label.approval.step":`Etapy zatwierdzania`,
"label.approvaldatamove.approvalprocessname":`Nazwa procesu`,
"label.actualapprovedpeople":`Faktyczny zatwierdzający`,
"label.systemlog.f":`FAILURE`,
"front-template-V1-addText":`Dodaj tekst`,
"label.chat.like":`Jak`,
"label.userinfo.oldpwd.notnull":`Stare hasło nie może być puste.`,
"label.service.all.done.major.event":`Ukończyłeś wszystkie kamienie milowe.`,
"label_chatter_to":`Do`,
"message.toomuchlinecannotoutput":`Wybrano zbyt wiele kolumn raportu i raport nie może zostać wyprowadzony.`,
"maintenanceasset.assetid.maintenanceplanid.unique":`Plan konserwacji został przypisany do zasobu. Proszę nie przypisywać planu wielokrotnie.`,
"lable.quote.syncing.firstsync.description":`Pozycje ofertowe zastąpią produkty z okazji`,
"lable.outlook.mcto.saveemail":`Pamiętaj, aby zapisać załączniki do wiadomości e-mail`,
"label.passwordPolicy.setup.pwdremember2":`2 zapamiętane hasła`,
"label.project.hit.five":`Zawiadomienie o aktualizacji zadań`,
"label.linkedin.setting.appid":`Tajny klucz`,
"label.dataimport.error.name.notnull":`Błąd: nazwa nie może być pusta`,
"label.knowledge.case.field.selected":`Wybrane pola sprawy`,
"label.version.datetime":`{0} pola daty/czasu`,
"Dashboard_NoAccessRightToSee_Warning":`Nie masz uprawnień do przeglądania dashboads {0}, które są ustawione jako defualt open, proszę zresetować.`,
"label.login.access.permission":`Przyznaj dostęp do`,
"label.operatedata.import.tip":`1. Importowany plik musi być plikiem w formacie CSV. Plik musi zawierać tytuł i nie może być importowany bez tytułu. 2. Zaleca się, aby przed importem dokonać eksportu, zestawić dane, które chcemy zaimportować dla szablonu danych z dokumentem eksportu, a następnie dokonać importu.`,
"workflow.action.tasks.assignortype.rolename":`Nazwa roli`,
"vue_label_account_quotations":`Przeniesienie wszystkich ofert właściciela klienta`,
"lable.account.CurrentCQ":`Aktualne CQ`,
"label.user.database.error":`Błąd bazy danych!`,
"label_emailtocloudcc_titel":`E-mail do CloudCC`,
"label_file_content":`Treść tekstu`,
"label.button.behavior":`Zachowanie`,
"message.recordtype.new.tip":`Wprowadź szczegóły`,
"label.ccchat.message.new.error3":`Błąd: nie można wybrać więcej niż 9 odbiorców`,
"vue_label_commonobject_notice_lessthanwords":`Nazwa pliku powinna być krótsza niż {FILE_NAME_COUNT} słów!`,
"label.stacked.verticalline":`Kolumny pionowe ułożone w stos`,
"vue_label_SMS_messagebox":`Skrzynka wiadomości`,
"label.appexchange.installedpage.message3":`</b>Zależnie od linków znajdujących się obok zainstalowanego pakietu, możesz podjąć różne działania na tej stronie. Aby usunąć pakiet, kliknij przycisk <b>Odinstaluj</b>. Aby zarządzać licencjami pakietów, kliknij przycisk <b>Zarządzaj licencjami</b>.`,
"label.unusedapproveprocess":`Nieaktywne procesy zatwierdzania`,
"label.onlywithspecificconditions":`Tylko rekordy spełniające określone kryteria powinny być uwzględnione w obliczeniach`,
"lable.outlook.mcto.formaterror":`Błąd formatu`,
"label.area.parent":`Terytorium macierzyste`,
"vue_label_chat_activesuccess":`Aktywacja zakończona sukcesem`,
"label.setting.intergrationlist.button.upgrade":`Aktualizacja`,
"label.page_hidden":`Hiden Fields for Registration Page`,
"label.customsetting.manage.belong":`Właściciel ustawień`,
"label.appointment.wizard.subtitle4-2-8":`7 dni`,
"template.chart.ydywjhxsje":`Miesięczna kwota sprzedaży możliwości biznesowych`,
"label.multilang.currencylist.after":`Po {0}`,
"vue_label_commonobjects_view_chart_countby":`Count By`,
"label.week":`Tydzień`,
"label.emailtemplate.name":`Nazwa szablonu`,
"label.umeng.sign":`wpisany`,
"label.appupload.upload.details":`Szczegóły`,
"label.file.loading":`Ładowanie`,
"label.newdetail.orgTitle":`Role kontaktowe`,
"label.salescloud.field.addoptionlist":`Dodaj wartości listy wyboru`,
"pagecreator.page.funcpath":`/ konstruktor / lista stron`,
"Account.News.Setting.001":`Ustawienia konta`,
"label.marketsea.getnoconversiondays":`Dni bez konwersji (muszą być większe niż liczba dni bez kontynuacji po uzyskaniu)`,
"message.error.event.add":`Anomalia nowego zdarzenia`,
"front-electronic-export-choseChimp":`Proszę wybrać wyeksportowaną listę Mailchimp`,
"vue_label_report_personothers":`Inne`,
"label.hierarchy.diagram":`Struktura Hierarchiczna`,
"label.stdashbord.xsld.business.yqsr":`Przewidywane dochody`,
"label.chat.topic.max.count":`Osiągnąłeś maksymalną liczbę tematów.`,
"label.sendemail.send.sendfail":`Wysyłanie wiadomości e-mail nie powiodło się, skontaktuj się z administratorem.`,
"registration.page.body.title":`Strona rejestracyjna`,
"label.userphoto.back":`Powrót`,
"label.service.without.timeslot":`Wydaje się, że nie ma żadnych przedziałów czasowych, dodajmy!`,
"label.processsetting.remaining.quantity":`Można wprowadzić do 255 znaków, pozostałe:`,
"label.sure.delete":`Potwierdź, aby usunąć`,
"front-epwechat-module-v1-callback":`Konfiguracja wywołania zwrotnego`,
"front-email-payment-failed":`Przepraszamy, płatność nie powiodła się!`,
"label.icon.67":`Maszyna`,
"UG_Forcast_01":`Prognoza`,
"label.escalation.setup.newentries.step3":`Krok 3 Określenie sposobu ustawiania czasów eskalacji`,
"lable.account.NextCY":`Następny CY`,
"report.type.label.quote":`Cytaty`,
"label.area.name":`Nazwa terytorium`,
"component.setup.label.object":`Obiekty`,
"label.customsetting.type":`Typ ustawienia`,
"label.showdetail":`Pokaż szczegóły`,
"label.department.prev":`Poprzednia strona`,
"label.select.data.source.report":`Proszę wybrać źródło danych Raport`,
"UG_homepage_002":`Zarządzaj swoimi wskazówkami, leadami, lejkami transakcji sprzedaży i informacjami o kontach za pomocą zintegrowanych narzędzi biznesowych`,
"vue_label_report_notice_exprot1":`Eksportowane są tylko wiersze szczegółów. Użyj tych danych do dalszych obliczeń lub załaduj je do innych systemów. Eksport stronicowy, do 5000 elementów na jednej stronie`,
"message.error.task.phonecreate":`Nieprawidłowość w tworzeniu zadań telefonicznych`,
"label_chatter_day":`Dzień`,
"label.setinitialcommiter":`Krok 6 Określenie początkowych podmiotów składających wniosek`,
"message.huanxinconfig.notfound":`Nie znaleziono konfiguracji Easemob`,
"label.customfields.file.count.tip":`Proszę podać liczbę plików, które mogą być wprowadzone w tym polu, domyślnie jest to 1`,
"label.weixin.appmanage":`Zarządzanie aplikacjami`,
"label.approverautoconfirm":`Zautomatyzowany zatwierdzający Określone przez`,
"vue_label_CCChat_followers":`Followers`,
"label.usermanage.notselect":`Nie wybrano żadnych użytkowników.`,
"label.item":`Pozycja(-e)`,
"label.sendemail.chat.linkurl":`Adres URL linku:`,
"label.sendmail.step3.deliveroptions":`Opcje dostawy`,
"homepage.components.creationtime":`Data utworzenia`,
"label.pc.ui.2018.ccchat.setting":`Ustawienie CCChat`,
"label.knowledge.search.result.highlight":`Wyróżnij istotne artykuły w wynikach wyszukiwania`,
"label.data.downpage.e.title.num2":`2、Jeśli zdecydujesz się na eksport danych pojedynczego obiektu, musisz wybrać sposób eksportu danych: eksport niestandardowy, eksport według szablonu i szablon eksportu.`,
"label.field.duplicate.error.msg1":`Tutaj są zduplikowane dane, proszę sprawdzić zduplikowane najpierw, a następnie ustawić unikalne właściwości.`,
"label.campaign.channel.input.number.error":`Błąd formatu liczby`,
"label.goto.dashboard":`Przejdź do Dashboards`,
"com.cloudcc.login.error.message.invalid.ip":`Twój adres IP nie znajduje się w zakresie IP.`,
"label.selectnewfieldvalue":`Określ nową wartość pola`,
"label.appointmentdetail.wizard.title11":`Data końcowa`,
"Opportunity_Detailed_Phase_Label_Popup_001":`Data rozpoczęcia bieżącego etapu`,
"front-dynamiclayout-module-v1-readonly":`Pole {wymagane} jest ustawione jako Tylko do odczytu.`,
"vue_label_calendar_start_field":`Pole startowe`,
"label.weixin.recalculate.shared.failed":`Przeliczanie reguł współdzielenia obiektów nie powiodło się.`,
"label.sendmail.step3.dealoptions":`Opcje przetwarzania`,
"setup_layout_label_modifypage":`Edytuj układ strony`,
"homepage.components.select.wide":`Wybierz szerokie komponenty do pokazania`,
"label.import.page1.laststep":`Poprzedni`,
"label.weixin.donot.permission":`Nie masz uprawnień do wykonania tej operacji.`,
"message.error.name.null":`nazwa nie może być pusta!`,
"label.salescloud.teamrole.optionlist":`Lista wyboru ról zespołowych Wartości`,
"component_setup_label_titlefield":`Pole tytułu`,
"vue_label_commonobjects_detail_have_been":`Byłeś`,
"label.textmessage.vonage.setup":`Konfiguracja Vonage`,
"label.recordtype.profile.enableit":`Włącz dla profilu`,
"UG.product.04":`Tworzenie produktu`,
"label.knowledge.No.related.articles":`Brak powiązanego artykułu...`,
"label.chat.muted":`Nie przeszkadzać`,
"registration.page.field.selection":`Wybierz pole strony rejestracji`,
"label.project.hit.eleven":`Wydanie zawiadomienia o przydzieleniu zadań`,
"lable.newtabpage.advsearch":`Wyszukiwanie zaawansowane`,
"label.report.share.roleandsub":`Role i wewnętrzni podwładni`,
"component.salesperformance.label.nodata":`Dodaj swoją okazję biznesową i wróć tutaj, aby zobaczyć wykres wydajności.`,
"label.submitted_on":`Zgłoszono dnia`,
"label.file.create.link":`Utwórz łącze`,
"label.contact":`Kontakty`,
"label.tab.message.failtoopenleft":`Operacja łączenia nie powiodła się przy otwieraniu lewej kolumny`,
"label.replaces":`Wymienić`,
"label.customcomponent.check.tag.startwith":`Komponent musi zaczynać się od etykiety &lt;cc:component&gt;.`,
"label.tab.web":`Karty sieciowe`,
"message.success.task.add":`Pomyślne zapisanie informacji o nowym zleceniu`,
"label.chatter.addresser":`Nadawca`,
"label.mobile.homepage":`Strona główna`,
"label.data.imp.su.ok":`Importowanie`,
"label.knowledge.category.hint.one":`Grupa kategorii to hierarchia kategorii danych. Na przykład, grupa kategorii o nazwie "Lokalizacja" może zawierać hierarchię geograficzną kontynentu, kraju, regionu i stanu. Użyj tej strony, aby zarządzać grupami kategorii i podkategoriami.`,
"label.schedulejob.setup.schedule.weekly":`Tygodnik`,
"label.tag.manage.description":`Wszystkie znaczniki {0} są następujące. Można zmienić nazwę lub usunąć dostępne znaczniki.`,
"label.tabcontrol":`Zakładki`,
"label.field.duplicate3":`Traktuj "ABC" i "abc" jako zduplikowane wartości __(wielkość liter nie ma znaczenia)`,
"label.customsetting.type.list":`Lista`,
"lable.account.ovdate":`Data zakończenia kwartału podatkowego`,
"label_chatter_pastSevenday":`W ciągu ostatnich 7 dni`,
"front-kefu-moudle-v1-lxndxsdb-free":`Proszę skontaktować się z przedstawicielem handlowym i włączyć obsługę wolnych agentów.`,
"label.termsforusage":`Warunki użytkowania`,
"label.forecast.settings.qijian.m":`Prognoza miesięczna`,
"label_tabpage_viewname":`Wyświetl nazwę`,
"label.report.action.addtodashboard1":`Dodaj do tablicy rozdzielczej`,
"label_vue_create_edit_obj_create_event_dialog_desc":`Użytkownik, którego przypisałeś, jest już zaangażowany w harmonogramy:`,
"vue_label_report_standardfilter":`Filtr Standardowy`,
"label.umeng.approval.submit":`#aplikator przedstawił rekord #obj do zatwierdzenia.`,
"label.tab.mobile.sign":`Ikona po stronie mobilnej`,
"vue_label_commonobjects_detail_check_the_content":`Wystąpił błąd weryfikacji, proszę sprawdzić zawartość`,
"UG_Campaign_001":`Planowanie kampanii`,
"chatter.group.baseInformation":`Informacje podstawowe`,
"label.sendemail.send.noreceiver":`Brak odbiorcy lub adres odbiorcy jest pusty.`,
"template.chart.yskje":`Należność Kwota`,
"label.textarea":`Obszar tekstu`,
"vue_label_statistics_value":`Wartość statystyczna`,
"font-evaluate-module-v1-select-img":`Wybierz obraz`,
"label.totalof":`Jesteś w sumie`,
"label.hangye":`Branże`,
"label.partner.common.setup":`Wspólne ustawienia`,
"label.icon.78":`Rolnictwo`,
"lable.outlook.detail.addemail":`Dodaj e-mail`,
"label.ServiceCloud.fuwuquyu":`Terytorium usług`,
"label.gb2312encoding":`chiński (GB2312)`,
"label.appointment.wizard.subtitle4-3-1":`10 min`,
"label_emailtocloudcc_reauthorization":`Reautoryzacja`,
"label.approval.message":`Opinie zatwierdzające mogą zawierać do 1000 znaków.`,
"label_component_helper":`Asystent`,
"label.editRate":`edytować kursy wymiany walut`,
"label.setuptemplate":`Szablony automatyzacji`,
"label_emailsync_button_cancel":`Anuluj`,
"label.marketseamemset.account.maxuser":`Maksymalna liczba klientów`,
"label.someerror":`Ze względów bezpieczeństwa czas trwania Twojej sesji CloudCC dobiega końca.<br><br>Co zamierzasz zrobić dalej?`,
"label_person_in_charge":`Inspektor nadzoru`,
"label.visualpage.reference.standard.style":`Wywołaj standardowy styl Platformy, dostosuj-standardowy styl`,
"errormessage_email_relatedorreceivermusthaveone_z":`Musisz wybrać co najmniej jednego odbiorcę lub temat pokrewny.`,
"label.insert.field.empty.continue":`Rekordy z wartością void 【{resDataField}】 istnieją, więc kod nie może zostać wygenerowany. Czy chcesz kontynuować generowanie?`,
"component.newrecords.label.title":`Ostatnie zapisy`,
"template.detail_info_link":`Szczegóły Link`,
"component_setup_tabs_label_default":`Strona domyślna`,
"label.emailobject.template.name.null":`Nazwa szablonu pocztowego nie może być pusta！.`,
"label.knowledge.field.changed":`{1} zostało zmienione`,
"homepage.components.select.narrow":`Wybierz opcję Pokaż wąskie komponenty`,
"label.mobile.phone.week":`Tydzień`,
"component_chatter_button_like":`Jak`,
"label.brief.won":`Won`,
"label.setup.profile.replaceme":`Wymień rzeczy o mnie`,
"label.knowledge.setting.enable.lightning":`Aktywuj wiedzę o błyskawicach`,
"label.middle":`Middle`,
"label.icon.109":`Ludzie`,
"vue_label_normal_activity_sf":`Działalność`,
"chatter.poll.option6":`Wybór 6`,
"label.lanxin.setting":`Zintegrowana aplikacja Lanxin H5 MiniApp`,
"label.stdashbord.xsld.business.totals":`Możliwości ogółem`,
"label.emailobject.emaildetail.promptbutton1":`Potwierdź`,
"Opportunity.Detailed.Phase.Label.001":`Scena`,
"label.customcomponent.params.info":`Jak używać parametrów.`,
"label.emailtocloudcc.button.next":`Następny`,
"front-email-payment-billing-date":`Data wystawienia faktury`,
"label.ems.with3day":`W ciągu 3 dni`,
"label.project.subtask.date":`Data podzadania musi mieścić się w zakresie dat zadania, do którego należy.`,
"label.role.allunselectanduseduser":`Wszyscy nieprzypisani i aktywni użytkownicy`,
"front-kefu-moudle-yes-wantbuy":`Tak, chcę dokonać zakupu`,
"label.looking_for":`Czy otrzymałeś to, czego szukałeś?`,
"page.404.label.noresource":`Przepraszamy, zasób, do którego chcesz uzyskać dostęp nie istnieje.`,
"vue_label_ccchat_notice_deletecommentcertification":`Czy na pewno chcesz usunąć ten komentarz?`,
"label.data.setok.e.desc1":`Sukces eksportu, otrzymasz wiadomość systemową alerty, dane pochodne są tymczasowo przechowywane na serwerze, system tylko dla Ciebie, aby zapisać 48 godzin, proszę jak najszybciej do`,
"label.weixin.confirm.delete":`Czy na pewno chcesz usunąć te dane?`,
"A":`Obszar tekstowy (bogaty tekst)`,
"template.report.sales.cycle":`Czas trwania cyklu sprzedaży`,
"label.service.shift":`Praca na zmiany`,
"label.visualpage.display.side.bar":`display sidebar,false - nie wyświetlaj paska bocznego`,
"label.list.userinterface.chatter.showall":`Strona główna CCChat domyślnie pokazuje wszystkie posty`,
"vue_label_systemSettings_set_course":`Utwórz ścieżkę, dodając wskazówki dla każdego etapu, aby prowadzić użytkowników krok po kroku.`,
"label.icon.156":`Ludzie`,
"label.marketsea.button.move":`Przesuń`,
"front-email-payment-select-email":`Proszę wpisać kod pocztowy`,
"front-electronic-signature-service-provider":`Usługodawca`,
"label.h5.add.checkin":`Zameldowanie`,
"vue_label_amount_total":`Kwota ogółem`,
"label.campaign.channel.new":`Kampanie Nowy kanał marketingowy`,
"label.knowledgebase.restore.creates.draft":`Przywrócenie wygeneruje wersję roboczą z bieżącej wersji. Musisz opublikować wersję roboczą, aby wszyscy mogli ją zobaczyć.`,
"UG_Case_01":`Sprawa`,
"label.validate.function.funcExplain.CONTAINS":`Sprawdź, czy tekst zawiera określony znak i jeśli tak zwróć TRUE, w przeciwnym razie zwróć FALSE`,
"label.data.exp.savetemp":`Zapisz jako szablon`,
"front-project-module-v1-template-newcreate":`Tworzenie projektu z szablonu projektu`,
"label.field.default.count":`Domyślna liczba wierszy`,
"page.note.acc":`Uwagi`,
"label.close":`Zamknij`,
"label.app.detailbeforeedit":`Szczegóły aplikacji niestandardowych poniżej. Kliknij "Edytuj", aby zmodyfikować aplikacje niestandardowe.`,
"label.profile.standardfieldsafety":`Standardowe zabezpieczenia na poziomie pola walki`,
"vue_label_report_notice_deletefilter":`Proszę najpierw usunąć filtr zaawansowany`,
"label.multilang.datamoveaction.movesuccess":`Łącznie {0} rekordów zostało przesłanych pomyślnie! ：`,
"label.emailmerge.edittemplate.descirption":`Wpisz informacje o swoim szablonie mail merge.Zwróć uwagę, że opis jest wyświetlany tylko w CloudCC.com, a nie w Wordzie.`,
"label.visualpage.at.the.end":`Użyj tagu na końcu`,
"label.exchange.sync.state":`Exchange Sync State`,
"label.newdashboardpage.new":`Dodaj wiersz`,
"label.querydetailservice.profile.notsetup":`Profil dla Twojego konta nie jest ustawiony.`,
"label.escalation.setup.detail.description":`Dodaj wpisy reguł, które określają kryteria używane do eskalacji przypadków. Na tej stronie możesz zmienić kolejność wpisów reguł po ich utworzeniu.`,
"lable.setup.mobilesetup.isenbaleh5newandedit":`Jeśli włączyć h5 w mobile-side i edytować`,
"vue_label_file_upload_tip_msg":`Zalecamy, aby wgrywany plik był mniejszy niż 30MB, w przeciwnym razie może powodować wolne ładowanie strony.`,
"label.eowechat.epdeptid":`Identyfikator działu WeCom`,
"label.adminorapprover":`Administratorzy <strong>lub</strong> aktualnie przypisana osoba zatwierdzająca może edytować rekordy w trakcie procesu zatwierdzania.`,
"label_emailtocloudcc_email":`E-mail`,
"setup_main2018_label_norole":`Nie masz uprawnień administracyjnych`,
"label.onlyone":`Wyjątkowa`,
"label.sso.saml.idp.config.nameidtype":`Rodzaj przedmiotu`,
"vue_label_normal_campaign_sf":`Kampanie`,
"label.icon.61":`Dźwig`,
"label.datatype":`Typ danych`,
"label.mobile.home.page.today.work":`Moja praca`,
"label.sendemail.chat.praiseFeedcommentsubject":`CloudCC CCChat polubił Twój komentarz`,
"chatter.sel.p":`0 wybrane.`,
"label.b_c":`Stosunek B do C:`,
"label.tabcontrolnameandtaglib":`Nazwy kart i etykiety`,
"label.globaloperation.tip":`Tworzenie, edycja i wyświetlanie operacji globalnych, które mogą być użyte dla stron szczegółowych.`,
"R":`Typy rekordów`,
"label.initcommiteoperate":`Czynności związane z przedłożeniem wniosku wstępnego`,
"front-kefu-moudle-v1-Operation-without0-permission":`Brak zgody na obsługę tej płyty, prosimy o kontakt z administratorem`,
"button_partner_create":`Nowy`,
"label.document.name.length.cannot.than":`Długość nazwy dokumentu nie może przekroczyć 255 znaków.`,
"label.area.donot.delete":`Nie można usunąć tego terytorium, ponieważ bieżące terytorium ma podterytorium.`,
"label.currency.activation":`Aktywuj`,
"label.connect":`&Konkatenat`,
"button.partner.viewdetail":`Zobacz`,
"setup_object_field_dependency_label_mustsetup":`Proszę najpierw ustawić zależność od pola i zapisać.`,
"label.SalesCommitmentKanBan.task":`Należności Zadanie Kwota`,
"lable.quote.syncing.finishbutton":`Gotowe`,
"label.weixin.group.type":`Typ dostępu`,
"vue_label_commonobjects_detail_relationship":`Stopień pokrewieństwa`,
"vue_label_email_cc":`Bcc`,
"setup.object.field.dependency.label.fieldvalueoptions":`Dostępne wartości pól`,
"label.sso.lookAtTheKey":`Wyświetl klucz`,
"UG.opportunity.008":`Zespół Możliwości`,
"label.customfields.new.step1":`Krok 1 Wybierz typ pola`,
"lable.qrcodeOrbarcode.rule":`Generowanie reguł QR Code/Bar Code`,
"vue_label_notice_nopermission_delete":`Przepraszamy, nie masz dostępu do usunięcia tego rekordu, skontaktuj się z administratorem.`,
"label.customerobj.tab":`Niestandardowe zakładki obiektów`,
"com.cloudcc.login.error.message.nolicens":`Licencja nie istnieje`,
"label.sendsms.batch.confirm":`Msza św. SMS: Potwierdź`,
"label.forecast.settings.sos":`Dochód i ilość`,
"label.calendar.addevent.notice.opencalendarfirst":`Proszę otworzyć mój kalendarz lub inne kalendarze przed dodaniem wydarzeń`,
"message.success.task.phonerecord":`Pomyślne zapisanie rekordów telefonicznych`,
"label.knowledgebase.create.new.subtab":`Nowa karta podrzędna`,
"label.knowledge.article.recordid":`ID artykułu wiedzy nie może być puste`,
"Opportunity.Detailed.Phase.Label.Popup.003":`Dni w bieżącym etapie`,
"homepage.layout.nowpage":`Istniejący układ strony`,
"template.chart.khslph":`Liczba rachunków Ranking`,
"front-epwechat-module-v1-android-single":`Android Single Sign On:`,
"serviceresource.assignedresource.islacksr.lack":`Nie możesz usunąć zasobu serwisowego, ponieważ został on przypisany do desygnatów serwisowych. Możesz wyłączyć ten zasób serwisowy.`,
"label.email.only.display.info":`W polu poniżej wyświetlane są tylko kontakty lub współpracownicy z zapisanymi adresami e-mail.`,
"label.weixin..xsld.yjhtje":`Przewidywana kwota umowy`,
"label.permission.delete.permsets.error.prompt":`Zestaw uprawnień nie może zostać usunięty, ponieważ są do niego przypisani użytkownicy.`,
"label.ccchat.enter.two.choices":`Proszę podać co najmniej dwie możliwości wyboru`,
"label.edit.field.select.style2":`Jedna opcja na wiersz`,
"vue_label_email_please_enter_email_subject":`Proszę wpisać temat wiadomości e-mail`,
"batch.sendemail.f":`, mail failed.`,
"label.sms.senderr":`Nie udało się wysłać SMS`,
"label.batchadd.newbatchpage.save.em":`Nieprawidłowy format wiadomości e-mail`,
"label.icon.96":`Kompas`,
"message.recordtype.deleterecord.tip":`Użyj tej strony, aby zastąpić wszystkie istniejące typy rekordów nowymi typami rekordów. Wybierz typ rekordu poniżej, aby przywrócić wszystkie rekordy, które zawierają usunięte typy rekordów. Jeśli chcesz tylko usunąć typ rekordu z istniejącego typu rekordu bez zastępowania go nowym typem rekordu, wybierz "Brak".`,
"label.field.edit.max":`Maksymalna liczba punktów`,
"label.partnerCloud.orderingPlatform.preferential":`Rabat`,
"label.callcenter.login.later":`Zaloguj się później`,
"batch.change.owner":`Proszę wybrać właściciela`,
"label.version.allow.upload.size":`edycja, maksymalny dozwolony plik do załadowania`,
"setup.mainpage.label.welcome17":`Ustawienia uprawnień`,
"label.tag.sectionname":`Informacje o tagach`,
"label_partner_workspace_setup":`Ustawienia`,
"label.managecontrol":`Uprawnienia administracyjne`,
"label.timetrigger.condition":`Warunek oceny jest ustawiony na każdorazowe tworzenie lub edycję rekordu.`,
"label.reportsSubscriptionPage.schedulereport.monthly.week":`Tydzień`,
"front-verkoop-bywerking-error":`Aktualizacja nie powiodła się`,
"label.allowcommittercallback":`Umożliwienie zgłaszającym wycofanie wniosków o zatwierdzenie`,
"vue_label_commonobjects_detail_lead_finishistatus":`Oznacz status jako zakończony`,
"message.error.object.lookupmd":`w tym obiekcie tworzone jest pole relacji materia-szczegóły`,
"label.stdashbord.xsld.business.img7":`Liczba etapów o prawdopodobieństwie 0% / (Liczba etapów o prawdopodobieństwie 100%   Liczba etapów o prawdopodobieństwie 0%)`,
"label.checkruleofevent":`Zasady walidacji zdarzeń`,
"front-epwechat-module-v1-single":`Pojedyncze logowanie`,
"label.tabpage.save":`Zapisz`,
"label_emailtocloudcc_search":`Szukaj`,
"label.tianyancha.h5.registeredPlace":`Miejsce zarejestrowane (skrót)`,
"label.field.addoptionlist":`Dodaj wartość Picklisty: Picklist`,
"label.schedule_anotherpost":`Zaplanuj inne posty`,
"label.customfields.searchrelation.tip":`Tworzy relację, która łączy ten obiekt z innym obiektem. Pole relacji umożliwia użytkownikom kliknięcie na ikonę odnośnika w celu wybrania wartości z listy podręcznej. Drugi obiekt jest źródłem wartości na liście.`,
"label.partnerCloud.partnerAccount.prepaidPhone":`Doładowanie konta`,
"label.projectManagement.view.details":`Zobacz szczegóły`,
"label.sendemail.chat.praiseFeed":`Drogi #name:witaj! #userName polubił twój post.`,
"label.validate.function.category.Text":`Tekst`,
"component.task.label.newevent":`Nowe zadanie`,
"label.data.import.setup.operate":`Co chcesz zrobić, jeśli znajdziesz istniejący rekord?`,
"label.salescloud.salesdashboard.clear.option":`Jasne opcje`,
"lable.account.PreviousCY":`Poprzedni 2 CY`,
"label.appointment.wizard.subtitle8":`Nazwa firmy widoczna dla zaproszonych`,
"label_emailsync_status_viewlog":`Wyświetl dziennik`,
"message.duplication.label.filtertitle":`Znajdź duplikaty filtrów`,
"label.custom.quarter.description":`Ta strona umożliwia zdefiniowanie i edycję niestandardowego kwartału. Data niestandardowego kwartału zostanie wygenerowana w oparciu o wybory dokonane poniżej.`,
"label_tabpage_filenamez":`Nazwa pliku`,
"lable.currencyAdv.andbefordate":`i przed`,
"label.version.nonsupport.sharerule":`Zasady udostępniania nie są tymczasowo obsługiwane.`,
"front-epwechat-module-v1-unbound":`Rozwiąż`,
"label.division":`Dział`,
"label.data.import.setup.repeat":`Czy chcesz zapobiec tworzeniu duplikatów rekordów?`,
"label.callcenter.makesure.Amazon.connect":`Uwaga: Upewnij się, że masz utworzoną instancję Amazon Connect`,
"label.version.lead.control":`Zarządzanie leadami`,
"label.copying.reward.groups":`Grupa sklonowanych linii notowań`,
"#label.severalorone":`Zip lub pojedynczy plik#`,
"label.mailinginfo":`Adres korespondencyjny`,
"component.telerecord.label.title":`Rejestrowanie połączeń`,
"label.godocumentlist":`Powrót do listy: Dokumenty`,
"APPIntegration.Dropbox.setting.01":`Włącz`,
"label.tianyancha.website":`Strona internetowa`,
"label_tabpage_greaterequalz":`Większe lub równe`,
"vue_label_campaign_influencedopportunity":`Wpływ na możliwości biznesowe`,
"message.save.param.null":`Parametr jest pusty, zapis nie powiódł się`,
"front-epwechat-module-v1-domain":`Nazwa zaufanej domenyJSSDK：`,
"label.allowreport":`Zezwalaj na raporty`,
"label.service.major.event":`Kamień milowy`,
"label.import.index.selectobjectandfiles":`Wybierz obiekt i plik`,
"label.chatter.task":`Zadanie`,
"label.knowledge.setting.hint.twelve":`Wprowadź kategorię danych`,
"lable.account.CurrentandPreviousFY":`Bieżący i poprzedni rok budżetowy`,
"label.martrixreport.step3":`Krok 3 Wybierz podsumowane dane`,
"front-console-select-cases":`Wybrany numer sprawy nie może przekraczać 10`,
"label.partnerCloud.partnerAccount.backHome":`Powrót do strony głównej`,
"label.me.assign":`Przypisane przeze mnie`,
"label.appointment.wizard.subtitle3":`Czas spotkania`,
"label.edit_columns":`Edytuj kolumny`,
"label.partnerCloud.orderingPlatform.useRebates:":`Skorzystaj z rabatu:`,
"label.projectManagement.enter.up.to.10.digits":`Można wprowadzić do 10 cyfr.`,
"label.integrations.description.mailchimp":`Integrując CloudCC z MailChimp, będziesz mógł importować wybrane leady i kontakty z konta CloudCC do MailChimp i wysyłać je do odpowiednich odbiorców, a Twoi użytkownicy będą mogli śledzić wyniki w MailChimp.`,
"label.ccchat.person.error.requiredomain":`Błąd: wymagana co najmniej jedna domena`,
"label.projectManagement.Pleaseselectitem":`Proszę wybrać projekt`,
"label.netaccess":`Dostęp do sieci`,
"vue_label_SMS_searchobject":`Wyszukaj obiekt`,
"label.role.viewintree":`Pokaż w widoku drzewa`,
"lable.SalesCommitmentKanBan.accountName":`Nazwa konta`,
"label.please.contact.your.administrator":`Prosimy o kontakt z administratorem w celu aktywacji reguł generowania kodów QR/kodów kreskowych`,
"label.sso.saml.sp.idenitysource":`SAML Tożsamość Lokalizacja`,
"label.queue.delete":`Usuń`,
"label.service.miniProgram.jumpLink":`Przeskocz link`,
"label_set_ forecast_scope":`Ustawienie zakresu prognozy`,
"label.weixin.success.sign":`Czy udało się zalogować, proszę o informację.`,
"front-dialog-module-v1-error-code":`Kod błędu`,
"label.projectManagement.nodata.problem":`Świetnie! Nie trzeba rozwiązywać żadnych skomplikowanych problemów.`,
"label.myhomepage":`Moja strona główna`,
"label.exchange.sync.state.task.m1":`Ostatnia synchronizowana aktywność:`,
"label.pw.config":`Proszę potwierdzić swoje hasło`,
"front-console-new-contact":`Nowy kontakt`,
"label.customfields.fielddependency.editexplain":`<li>Kliknij dwukrotnie komórkę, aby przełączyć jej widoczność dla wartości pola kontrolnego widocznego w nagłówku kolumny.</li><li>Aby zmienić wiele komórek naraz, zaznacz wiele komórek, a następnie kliknij przycisk Uwzględnij wartości lub Wyklucz wartości, aby zmienić widoczność wszystkich wybranych komórek naraz.</li><li>Użyj kombinacji SHIFT   kliknięcie, aby wybrać zakres sąsiadujących komórek. Użyj kombinacji klawiszy CTRL   kliknięcie, aby zaznaczyć wiele komórek, które nie są sąsiadujące.</li><li>Użyj przycisku Podgląd, aby przetestować wyniki.</li>`,
"setup_mainpage_label_welcome7":`Instrukcje: Klikamy na menu po lewej stronie → Ustawienia aplikacji → Utwórz → Obiekt → Nazwa obiektu → Pole własne.`,
"message.validation.sum":`Na stronie zatwierdzania jest zbyt wiele pól, można wybrać maksymalnie 190 pól.`,
"label.knowledge.attach.case":`Mocowanie do walizki`,
"front-electronic-signature-custom-field-type":`Niestandardowe typy pól`,
"vue_label_pricebook_activated":`Cennik jest aktywny`,
"vue.schedule.pre":`To jest mój harmonogram, proszę`,
"Lead_Tools_BatchScoring":`Lead Batch Scoring`,
"front-lightning-module-v1-details-page-chart-screening-based-on":`Filter By`,
"label.report.no.recently":`Brak najnowszych danych.`,
"label.service.gantt.dangerous.sum":`Liczba zagrożonych nominacji służbowych.`,
"label.main.field":`Pole podstawowe`,
"label.weixin.optionfive":`Wybór 5`,
"homepage.wide":`Kolumna szeroka (prawa)`,
"vue_label_notice_confirmdelatehomepage":`Czy jesteś pewien, że usuniesz stronę główną?`,
"vue_label_report_exportpages":`Strony eksportowe: Nie.`,
"label.select_compaign":`Wybierz kampanię`,
"attachment.button.massdownload":`Masowe pobieranie`,
"label.chatter.incident":`Wydarzenia`,
"label_partner_new_step1":`Krok 1 Wybierz szablon, który Ci się podoba`,
"button.partner.workspace.saveas.memo":`Zapisz bieżącą chmurę partnerów jako "szablon".`,
"vue_label_pricebook_edit":`Edytuj cennik`,
"label.weixin.privacy.rights":`Zezwolenia na ochronę prywatności Przybliżona lokalizacja (przez Internet), Dokładna lokalizacja (GPS).`,
"label.please.codeType":`Proszę wybrać typ kodu.`,
"label.approveorrefuserequest":`Zatwierdzić / Odrzucić`,
"message.error.sharemember":`Podany sharemember nie może być pusty, proszę sprawdzić podane parametry!`,
"label.file.folder.edit":`Edytuj Folder`,
"label.data.import.setup.repeat.yes":`Tak - zapobieganie tworzeniu duplikatów rekordów. Uwaga Jeśli chcesz zaktualizować istniejący rekord, musisz wybrać tę opcję.`,
"label.approveBeforeTheOperation":`Eksploatacja przed zatwierdzeniem`,
"vue_label_file_already_checked_file":`Wybrano pliki {CheckedWork}, można dodać do 10 plików jednocześnie.`,
"vue_label_hidden_record_count":`Ukryj liczbę rekordów`,
"UG_product_01":`Wymień produkty/usługi`,
"label.tabpage.clearoptionsz":`Wyczyść opcje zaawansowane`,
"label.partnercloud.num.overstep":`Przekroczona maksymalna liczba chmur partnerów.`,
"label.tianyancha.businessverify.msg8":`Obecnie funkcja ta obsługuje tylko zapytania do przedsiębiorstw zarejestrowanych do prowadzenia działalności gospodarczej w Chinach kontynentalnych, i ma pewne opóźnienia.`,
"Lead_Scoring_DetailedPage_Popup_Title":`Główny Wgląd`,
"label.emailtocloudcc.email":`E-mail`,
"vue_label_pool_highcost":`Wysoki koszt produktu`,
"label.callcenter.enterprise.configuration":`Proszę skopiować parę kluczy w Enterprise ConfigurationSystem Interconnection w systemie Tianrun`,
"label.view.edit.search.prompt":`Proszę wpisać słowa kluczowe`,
"label.ems.sms":`Wyślij tekst`,
"label.emailobject.list.new":`Skomponuj`,
"label.salescloud.forenableteamsales":`Umożliwić zespołowi sprzedaży`,
"pagecreator.systemstyle.funcpath":`/ konstruktor / biblioteka stylów marki`,
"label.partnerCloud.basicSetting.domain":`Domena najwyższego poziomu nie może być pusta`,
"label.projectManagement.Posttask":`Po wykonaniu zadania`,
"label.tianyancha.businessverify":`Umożliwienie weryfikacji danych biznesowych`,
"label.tianyancha.h5.info":`Informacje podstawowe`,
"september":`Wrzesień`,
"chatter.poll.option9":`Wybór 9`,
"label.department.firstpage":`To pierwsza strona`,
"label.reportsSubscriptionPage.condition.button":`Dodaj warunek`,
"label.exchange.sync.state.task":`Zadania`,
"pagecreator.layout.button.splitall":`Rozdzielić wszystko`,
"vue_label_calendar_please_select_the_start":`Proszę wybrać pole do rozpoczęcia pracy`,
"label.tab.message.failtogettop":`Nie udało się uzyskać górnej karty`,
"label.sharerule.organizationscopesetshare":`Domyślne ustawienia dla całej organizacji`,
"label.delete.rules":`Usuń zasady`,
"label.recordtype.tabname.detail":`Kliknij przycisk "Edytuj" aby zmienić opcje typu rekordu. Wybierz dostępne wartości listy pickupów dla tego typu rekordu klikając na link "edytuj" na liście powiązanych wartości listy pickupów.`,
"label.knowledge.setting.hint.ten":`Nie masz pewności co do trybu orgnizacji? Nie ma problemu. Możesz wykonać go później.`,
"vue_label_norm_undone":`Tej operacji nie można wycofać`,
"label.trigger.line":`linia:`,
"lable.info.queue.reason":`Powód zostania członkiem`,
"label.validate.function.funcExplain.HOUR":`Reutrn Zwraca godzinę dnia (z pól Data/Godzina), w zakresie 0 -11.`,
"label.update.document.content":`zmotywował zawartość dokumentu`,
"lable.Existing.template":`Dostępne szablony`,
"label.summaryreport.step3":`Krok 3 Wybór metody grupowania podsumowanych danych`,
"label.emailmerge.list.filetype":`Rodzaj dokumentu`,
"label.customfields.helptext.tip":`Tekst jest wyświetlany na stronie szczegółów i stronie edycji, gdy użytkownik najedzie kursorem na ikonę informacji obok tego pola.`,
"label.setting.intergrationlist.description":`Integracje CloudCC pozwalają na przeglądanie i udostępnianie danych pomiędzy aplikacjami biznesowymi bez konieczności opuszczania CRM. Niektóre z tych integracji, jak QuickBooks czy Zapier, wymagają uprawnień, aby były dostępne dla Twoich użytkowników. Inne integracje, takie jak Gmail, Outlook mogą być konfigurowane przez każdego użytkownika na jego własnym koncie.`,
"component_milestones_label_title":`Kamień milowy`,
"label.custom.AntiRevocation":`Anuluj Cofnij`,
"label.mobile.app.new.task":`Umożliwienie tworzenia nowych zadań i zdarzeń w aplikacji mobilnej`,
"vue_label_opportunity_related_chooseproduct":`Wybierz co najmniej jeden produkt`,
"label.standardguest":`Gość standardowy`,
"label.icon.125":`Instrument`,
"label.skipsomeset":`Ponieważ jest to Kreator szybkiego startu, CloudCC automatycznie wybiera dla Ciebie niektóre ustawienia.`,
"label.forecast.shrepage.fmanager":`Kierownik Prognoz`,
"label.mobile.quickcreate.default.work":`Biuro`,
"label.projectManagement.nodata.team.members":`Nie można znaleźć członka mojego projektu`,
"label_social_media_account_settings":`Konfiguracja kont w mediach społecznościowych`,
"UG.quota.05":`Bisync with Opportunities`,
"label.partner.workspace.tab.selectedoption":`Wybrane zakładki`,
"front-kefu-moudle-v1-clientID-reinput":`Proszę podać identyfikator klienta`,
"label.mobile.home.page.contract.value":`Przewidywana kwota umowy`,
"december":`Grudzień`,
"label.campagin.roi.dcrs":`Obecność`,
"label.currency.edits":`Waluta Edycja`,
"label.currency.company":`Waluta korporacyjna`,
"label.customfields.newformula.nogrammererror":`Brak błędów składni w polach lub funkcjach łączenia.`,
"label.version.nonsupport.api":`Interfate API nie jest chwilowo obsługiwane.`,
"label.data.file.i.title.num2":`2. Zaleca się wyeksportowanie danych podczas ich importu, tak aby dokument eksportu został użyty jako szablon do zestawienia danych do importu, a następnie importu. (Jeśli importowane dane zawierają przecinek, należy go zastąpić symbolem @).`,
"front-console-conversation-title":`Ocena usług`,
"front-kefu-moudle-call":`Zadzwoń na`,
"vue_label_systemSettings_pagefooter":`Ustawienie stopki`,
"label.newRule.successfully.added":`Nowe reguły zostały dodane pomyślnie.`,
"label.trigger.direction.for.use":`Instrukcja dla platformowych wyzwalaczy [Wersja 2.0]`,
"label.instrumentPanel.maxLabelname":`Wartość ta powinna być większa od wartości minimalnej, wartości punktu przerwania 1 i wartości punktu przerwania 2.`,
"label.same.month.report":`Raport YoY i MoM`,
"label.knowledge.language.american":`American`,
"label.paging.totalof":`A Total of {0}`,
"label.tianyancha.businessverify.enable.error":`Aby sprawdzić, czy weryfikacja danych handlowych jest włączona, należy skontaktować się z administratorem systemu!`,
"vue_label_commonobjects_detail_email_template":`Użyj szablonu wiadomości e-mail`,
"message.error.save.failed":`Zapisać nieudane".`,
"advancedoptions":`Dodaj logikę filtra...`,
"setup_object_layout_message_selectedlayoutandrecordtype":`Proszę wybrać układ i rodzaj płyty`,
"label.sendemail.recycle.operatesuccess":`udało Ci się opróżnić kosz, usuwając dane o rozmiarze #size.`,
"J":`Obszar tekstowy (długi)`,
"message.validation.isnotmail":`Proszę wpisać nieprawidłowy adres e-mail.`,
"label.timetrigger.before.lasttime":`1 godzinę wcześniej niż Data ostatniej modyfikacji (Last Modified Date)`,
"label.tabpage.arecordtypez":`Dostępny typ rekordu`,
"label.reportoption":`Opcje raportów`,
"pagecreator.button.next":`Następny krok`,
"assetbom.transferowner.notpermission":`Nie masz uprawnień do przenoszenia BOM-u aktywów. Proszę skontaktować się z administratorem.`,
"label.toptitle.lightning":`Błyskawica`,
"label.copy.target":`Wartość wskaźnika klonowania`,
"label.productsales.oppor.approach":`Nadarzające się okazje`,
"label.email.template.select":`Proszę wybrać szablon wiadomości e-mail.`,
"label.edit.lower.bound.of.discount.per.tier.is.required.":`Dolna granica dla edycji każdego poziomu rabatu jest wymagana.`,
"label.tabularreport.step3":`Krok 3 Zdefiniuj kolejność kolumn w raporcie`,
"label.multilang.cchttpservice.signin":`Szanowny {0}, Twój zaproszony gość {1} z {2} został pomyślnie zarejestrowany.`,
"label.appexchange.uninstallpage.message3":`Trwale usuń wszystkie dane obiektów niestandardowych w tym pakiecie`,
"label_tabpage_ownedz":`Totalnie`,
"label.tabularreport.2018.step2":`Krok 2 Wybór kryteriów raportowania`,
"label.object":`Obiekt`,
"template.report.contracted.customers":`Analiza branżowa rachunków kontraktowych`,
"label.field.remark3":`Uwaga: Usunięcie pola niestandardowego spowoduje usunięcie wszystkich filtrów, które używają tego pola. Może to również zmienić wynik działania Reguł Przypisania lub Eskalacji, które opierają się na danych pola niestandardowego.`,
"label.eventview.issms":`Powiadomienie SMS`,
"label.knowledge.language.brazilian":`portugalski (Brazylia)`,
"vue_label_norm_viewfilter":`Zastosuj filtr`,
"label.forecast.settings.qijian":`Okres prognozy`,
"label.startuploadfile.step.intruduce":`Kliknij "Select File", aby znaleźć plik i wyświetlić wybrane pliki w dolnym regionie.`,
"label.smstemplate":`Szablon SMS`,
"vue_label_chatter_no_permission":`Nie masz dostępu do przeglądania tego pliku`,
"label.callcenter.Incorrect.data.filling":`Wystąpił błąd przy wypełnianiu danych`,
"label.tag.search.button":`Wyszukiwanie według tagów`,
"label.multiplyselectoptions":`Opcje pól wyboru`,
"lable.outlook.detail.mutual":`Synchronizacja dwukierunkowa`,
"label.workflow.estimatecondition1":`utworzony, a także za każdym razem, gdy jest edytowany, aby następnie spełniał kryteria`,
"label.validate.globalvariable.user.profileId":`Identyfikator profilu`,
"UG.Campaign.003":`Utwórz kampanię`,
"label.validate.function.funcExplain.ISNULL":`Wyrażenie jest puste i zwraca TRUE, w przeciwnym razie zawiera wartość i zwraca FALSE.`,
"label.setting.intergrationlist.status0":`STATUS INTEGRACJI`,
"label.copy_error":`Nie udało się skopiować`,
"label.connectOtherNone":`Wybrany obiekt nie posiada innych obiektów powiązanych.`,
"label.bmap.beijing":`Pekin`,
"front-kefu-moudle-v1-hxzxybsc-again":`Easemob został usunięty. Proszę połączyć się ponownie!`,
"label.wei.pollsubject":`głosowanie Przedmiot`,
"APPIntegration_Social_twittererror":`Musisz wprowadzić prawidłowy adres URL dla twitter.com`,
"label.appupload.install.apicannotuse":`Nazwa api nadal nie jest dostępna`,
"label.returntolist":`Powrót do listy`,
"label.translation.start2":`Wybierz element konfiguracji.`,
"lable.edit.queue.alter":`Wybierz obiekty, które chcesz przypisać do tej kolejki.`,
"label.campaign.channel.step3":`Krok 3 Wybierz pola do wyświetlenia na stronie rejestracji kanału marketingowego`,
"label.data.newtemplate.e.seltype":`Wybierz metodę eksportu danych`,
"front-kefu-moudle-hangup":`Rozłącz się`,
"label.forecast.forecastroleuserpage.shre.managerandother":`Administratorzy i osoby zarządzające prognozą mogą udostępniać tę prognozę`,
"label.knowledgebase.mark.as.new.version":`Oznacz jako nowe wydanie`,
"label.conditiontag.lookup":`Lookup`,
"label.import.page3.importsucceed":`Import zakończony sukcesem`,
"label.stdashbord.xsld.condtion":`Ustawienia stanu`,
"label_emailtocloudcc_redmessage10":`Informacje straciły ważność, proszę zalogować się ponownie.`,
"label.event.moveup.1hour":`1 godzina przed`,
"label.chat.topic.page.add.favorite":`Zapisz jako zakładkę na stronie CCChat`,
"label.icon.88":`Doradztwo`,
"page_404_label_noresource":`Przepraszamy, zasób, do którego chcesz uzyskać dostęp nie istnieje.`,
"label.quickbooks.refresh":`Odśwież`,
"front-kefu-moudle-which-getphone-case":`Zasady tworzenia spraw po odebraniu połączenia`,
"label.objecttab.edit":`Zakładka Obiekt Edycja`,
"label.data.file.the.trigger":`Wykonaj wyzwalacz`,
"frame.personinfo.label.personimage":`Zdjęcie profilowe`,
"label_tabpage_turnoffsz":`Wyłączyć - przekształcone`,
"label.sendmail.batch.chose":`Mass Email: Wybierz odbiorców`,
"label.data.downpage.i_title":`Kroki importu danych:`,
"label.recycle.clearconfirm":`Jest pan pewien?`,
"chatter.using":`Ten użytkownik`,
"label.batchadd.newbatchpage.list":`Lista danych masowego dodawania`,
"pagecreator.systemstyle.button.new":`Nowy styl`,
"label.notification.serviceappointment.changestate":`Status {1}{0} zmienił się na{2}{3}.`,
"label.weixin.weipollname":`Mikro głosowanie Nazwa`,
"label.tabpage.skip":`Przejdź do`,
"label.edit.field":`Edytuj pola`,
"label.edit.new.rule":`Edycja reguł generowania`,
"label.approved.receiveApprovalEmail":`Otrzymywanie wiadomości e-mail z prośbą o zatwierdzenie`,
"label.dashboard.refreshNow":`Odśwież teraz`,
"label.lookup.introduce":`Proszę wpisać co najmniej 1 znak, aby rozmyć wyszukiwanie.`,
"homepage.components.newdes":`Upewnij się, że wpisany poniżej kod HTML jest poprawny i dobrze sformatowany. Wpisanie niewłaściwego kodu HTML w komponencie może spowodować, że cała karta strony głównej będzie wyświetlana niepoprawnie.`,
"label.role.giveuserrole":`Przydzielanie ról użytkownikom`,
"lable.opppdt.selPbk.subtitle":`Książka cenowa`,
"setup_mainpage_label_welcome19":`Instrukcje:  Kliknij na menu po lewej stronie → Zarządzaj ustawieniami → Zarządzaj użytkownikami → Użytkownicy, role, profile.`,
"setup.mainpage.label.welcome22":`Instrukcje: Kliknij w menu po lewej stronie tej strony → Zarządzaj ustawieniami → Szablon newslettera → Szablon e-mail.`,
"label.tianyancha.h5.zipcode":`Kod pocztowy`,
"label_tabpage_allapplications":`Wszystkie zastosowania`,
"label.chatter.like":`Jak`,
"label.licence.noremainder":`Niewystarczająca liczba licencji`,
"lable.outlook.edit.dataset":`Ustawienia danych`,
"D":`Data`,
"label.detail":`Czytaj`,
"label.globaloperation.operationtype.custom_page":`Własna strona`,
"label.addattachment.down":`Pobierz plik`,
"label.data.exportall.all_btn":`Eksportuj wszystkie dane`,
"label.recordtypeselect.current":`Typ bieżącego zapisu`,
"label.tabpage.entercusnamez":`Proszę wpisać nazwę klienta`,
"label.location.valunit.km":`Km`,
"label.mobile.phone.week.plan":`Następny tydzień`,
"vue_label_report_everyday":`Codziennie`,
"label.weixin.broadcasting":`Wysyłam...`,
"label.input.search.string":`Proszę wpisać szukany ciąg znaków`,
"label.picandreporttype":`Typ wykresu`,
"label.setmulti":`Przeniesienie wielokrotne`,
"label.visualpage.component.t":`Jak używać komponentów?`,
"label.knowledge.designate":`Tylko artykuł wiedzy o statusie Draft może zostać przypisany.`,
"label.enable.barcode.only":`Tylko aktywacja kodu kreskowego`,
"vue_label_commonobjects_detail_a_group_strategy":`Dane te nie mają właściciela i nie mogą utworzyć Zespołu`,
"setup.layout.group.button":`Przyciski`,
"label.mini.layout.remark":`jest układem używanym w oknie najechania na stronę.`,
"setup.mainpage.label.welcome3":`Tworzenie formularzy w platformie chmurowej CloudCC opiera się na niestandardowych bazach danych (obiektowych), obiekty zdefiniowane przez użytkownika to tabele bazy danych, które przechowują dane specyficzne dla Twojej organizacji. Relacje między tabelami mogą być łatwo utworzone bez konieczności tworzenia programu.`,
"label.knowledge.draft.status":`Status postów artykułów wiedzy to Draft!`,
"label.manageAll.sel.one1":`Punkty do zatwierdzenia`,
"label.campagin.roi.bhydkhywjh":`Ilość zamkniętych okazji do wygranej`,
"label_partner_template_thumbnail":`Miniaturka`,
"label.loginip.setup":`Zakres IP logowania`,
"label.data.downpage.e.title.e.btn":`Przejdź do strony eksportu i rozpocznij eksportowanie`,
"vue_label_appstore_project_management":`Zarządzanie projektami`,
"assetbom.delete.notpermission":`Nie masz uprawnień do usuwania BOM aktywów. Proszę skontaktować się z administratorem.`,
"vue.dashboard.setdrill.inThe":`podlegający`,
"label.mobile.more.savephoto":`Zapisz zdjęcie`,
"label.customerinfo.PageTriggerFag":`Synchronizacja`,
"label.commonobjects.Nopermission":`Przepraszamy, nie masz uprawnień do edycji tych danych, prosimy o kontakt z administratorem systemu.`,
"label.searchlayout.opperationtab.xsldfield":`Pola wyświetlane po kliknięciu linku Lejek sprzedaży na stronie głównej zakładki Możliwości.`,
"label.emailsync.form.disconnect":`Anuluj połączenie`,
"label.document.nofile.upload":`Nie można przesyłać plików.`,
"label.appointmentpage.wizard.subtitle3-3":`Telefon`,
"message.custom.field.donotdelete":`Pole jest używane i nie może być usunięte.`,
"chatter.using0":`{0}ms został wykorzystany w tym momencie`,
"label.tabpage.multiple":`Wybór wielokrotny`,
"label.attendance.setting.sy.alert":`Należy wybrać odpowiednich użytkowników, którzy będą uczestniczyć w zajęciach.`,
"label.refuse":`Odrzuć`,
"label.log.button":`wyszukiwanie według nazwy użytkownika`,
"component_chatter_link_label_title":`Link`,
"template.report.contract.collection":`Umowa Płatność`,
"label.campaignmember.selectmember.step1":`Krok 1 Wybierz kampanię i status członków kampanii`,
"label.datamanage.warn.owner":`Ostrzeżenie: jeśli będziesz kontynuować import, wszystkie rekordy zostaną zaimportowane z tobą jako właścicielem rekordu.`,
"label.a.b":`Relacja A do B`,
"label.app.step3.homeisfrist":`Strona główna musi być pierwsza.`,
"UG_Lead_003":`Społeczny`,
"label.partner.workspace.member.choice":`Wybierz profil`,
"lable.outlook.detail.emaping":`Mapuj pola zdarzeń`,
"label.service.appointmentList.gantt.chart.shows":`Pokaż datę Gantta`,
"label.mr.caption.account.result":`Znajdź duplikaty i połącz: Wyniki wyszukiwania duplikatów kont`,
"vue_label_chatter_approve_members_join":`Zatwierdzanie członków do grupy`,
"label.reportsSubscriptionPage.schedulereport.monthly.day":`Dzień`,
"pagecreator.systemstyle.label.modifycolor":`Edytuj kolor`,
"label.tabpage.yesz":`Tak`,
"label.fieldtoolongmessage":`Pole przekracza limit`,
"lable.account.year.name":`Rok podatkowy Nazwa`,
"label.mini.layout":`Układ przy najechaniu kursorem`,
"label.icon.97":`Nauczanie`,
"vue_label_chat_smart_assistant":`Inteligentny asystent`,
"label.marketingmanagementuser":`Marketing Użytkownik`,
"label_emailtocloudcc_description2":`Połącz swoją pocztę e-mail`,
"label.campaign.channel.input.name":`1.Proszę wpisać nazwę kanału marketingowego`,
"UG.homepage.007":`Od wysyłania e-maili uzupełniających po automatyzację kampanii sprzedażowych, od tworzenia przepływów pracy za pomocą naszej technologii Blueprint po uruchamianie niestandardowych makr, zautomatyzuj codzienne zadania i skup się bardziej na budowaniu relacji.`,
"label.share":`Dzielenie się`,
"label.step2.total6":`Krok 2 z 6`,
"label.sendemail.chat.addComentspraise":`Drogi #name:witaj! #userName odpowiedział na Twój post, który Ci się spodobał`,
"label.icon.20":`Plik`,
"label.service.gantt.absenteeism":`Absencja`,
"message.error.color.nagatice":`Liczba bieżących stron nie może być ujemna.`,
"chatter.group.applyToJoin":`Zgłoś się, aby dołączyć`,
"pagecreator_layout_message_delete":`Czy usuwasz aktualnie wybrany układ?`,
"label.multilang.viewlist.count":`W sumie {0} rekordów：`,
"message.notdesable.type":`Ten typ rekordu nie może zostać usunięty, ponieważ poniższy profil używa tego typu rekordu jako wartości domyślnej.`,
"label.standard.time":`Czas standardowy`,
"label_chatter_newpost":`Ostatnio opublikowany post`,
"front-epwechat-module-v1-binding":`Bind WeCom`,
"label.recent":`Ostatnio`,
"label.globaloperation.createfeeditem":`Utwórz projekt podsumowujący`,
"label_partner_common_roleNum":`Liczba ról`,
"front-template-V1-quikSearch":`Wprowadź nazwę pola i znajdź`,
"label_tabpage_haschangedz":`Ten trop został przekształcony`,
"label.service.work.order.line":`Pozycje zlecenia pracy`,
"label.lead.score.ok":`OK`,
"Account_News_Setting_003":`Ustawienia ogólne`,
"label.event.moveup.15minutes":`15 minut wcześniej`,
"vue_label_all_selected_objects":`Wszystkie`,
"label.visualpage.an.inline.style.relatedlist":`Osadzanie niestandardowych typów stron na listach powiązanych`,
"label.umeng.approval.approvaling":`#aplikator prosi o zatwierdzenie dla #obj #objname #owner`,
"lable.SalesCommitmentKanBan.digital":`Digit`,
"label.appupload.img.max.size":`Obrazek, który załadowałeś jest zbyt duży, maksymalny rozmiar obrazka nie powinien przekraczać 20K, proszę załaduj go ponownie.`,
"vue_label_normal_top":`Top`,
"label.knowledge.language.traditional":`Chiński tradycyjny`,
"homepage.layout.edit":`Edytuj układ strony głównej`,
"label.campagin.qrcode":`Kod QR Campagin`,
"label.emailmerge.merge.emailmerge":`Email Merge`,
"label.icon.18":`Zegar`,
"vue_label_homepage_taskview":`Widok zadań`,
"label.search.related.record":`Nie znaleziono żadnych zapisów.`,
"label.report.reports":`Raporty`,
"label.appointment.wizard.subtitle4-3-2":`15 min`,
"label.forecast.condition":`Kryteria prognozowania`,
"label.westem.indonesia.time":`Czas Indonezji Zachodniej`,
"front-epwechat-module-v1-callback-desc":`Skopiuj następujące informacje do zaplecza programu WeCom.`,
"label.version.group":`Edycja zespołowa`,
"label.allReportType":`Wszystkie źródła danych raportów niestandardowych`,
"label.trigger.lastmodifydate":`Data ostatniej modyfikacji`,
"message.layout.unique.sectionfield":`Zostało naruszone ograniczenie unikalności pola w układzie strony. Proszę sprawdzić i zapisać ponownie.`,
"vue_label_systemSettings_mobelbottonsetting":`Ustawienie menu dolnego dla aplikacji mobilnej`,
"label.recordtype.selectonefield":`Wybierz przynajmniej jedno pole, które chcesz dodać`,
"label.notification.group1":`【申请人】 chce dołączyć do Twojej grupy publicznej`,
"component_todaytask_label_title":`Dzisiaj`,
"label.assignment.setup.list.description":`Automatycznie przypisuj leady do użytkowników na podstawie zdefiniowanych przez Ciebie kryteriów. Możesz tworzyć wiele reguł z różnymi warunkami.`,
"label.project.resource.data":`Ten zasób serwisowy został przypisany do terminu serwisowego, proszę nie dodawać go ponownie.`,
"label.emailmerge.newtemplate.file":`plik`,
"label.notification.task1":`【分配人】 zlecił ci zadanie`,
"label.ServiceCloud.Overlapping":`Wyświetlanie nakładających się wysyłek`,
"label.globalselect.used":`Pozycja wykorzystania pola`,
"setup_layout_button_layoutprop":`Nieruchomości`,
"label.quickbooks.retrivingdata":`Pobieranie danych...`,
"component.button.ok":`Potwierdź`,
"message.pleaseinputformula":`Proszę wprowadzić wzór`,
"label.h5.whatifollow":`Co śledzę`,
"label.new.crew.target":`Nowy cel personalny`,
"label_chatter_task":`Zadanie`,
"label.knowledge.setting.data.four":`Można wybrać maksymalnie {count} grup kategorii.`,
"label.rule.not.enabled":``,
"label_in_scope":`W zakresie`,
"label.partnerCloud.orderingPlatform.bundle":`Pakiet`,
"label.emailtocloudcc.redmessage10":`Informacje straciły ważność, proszę zalogować się ponownie.`,
"label.knowledgebase.data.assignment.succeeded":`{a} dane przypisane pomyślnie`,
"vue_label_commonobjects_view_nokanban":`Nie utworzono jeszcze żadnego widoku kanban`,
"label.knowledgebase.article.cancelled.attaching.case":`Artykuł {nazwa} został anulowany w celu dołączenia do sprawy".`,
"label.brief":`Streszczenie`,
"label.version.sum.app":`zastosowania`,
"label.commoninfo":`Wspólne informacje`,
"vue_label_SMS_nodata":`Brak danych`,
"label.icon.153":`Informacje`,
"label.conditiontag.lookup.false":`FALSE`,
"label.emailobject.view.unread":`Nieprzeczytane e-maile`,
"label.staticresource.useful":`Gdzie jest to wykorzystywane?`,
"label.ems.connect.test":`Test`,
"vue_label_chat_group_assistant_notification":`Zgłoszenie asystenta grupy`,
"label.multipleactivity.total":`W sumie`,
"vue_label_report_addtocomponentlibrary":`Dodaj do biblioteki komponentów`,
"font-evaluate-module-v1-following-personnel":`Powiadomić następujących użytkowników, gdy otrzymają ocenę mniejszą niż 3:`,
"label.setup.mobile.bottombutton.change.fail":`Nie udało się zmienić`,
"front-epwechat-module-v1-unbound-item5":`i dane nie mogą zostać pobrane, czy na pewno należy je odłączyć?`,
"label.customerinfo.smsUid":`Brama SMS UID`,
"label.list.isOpenApprovalQueue":`Aktywuj kolejkę zatwierdzania (niedostępne dla opcji Ręczny wybór zatwierdzającego)`,
"label.leadscore.setup.scorenumber":`Czas(y)`,
"label.workflow.selectobj.introduce":`Wybierz obiekt, do którego odnosi się reguła przepływu.`,
"label.visualpage.label.for.example":`Etykiety stron takie jak:`,
"label.appointmentdetail.wizard.title17":`Plan na czwartek`,
"label.projectManagement.timeFrame":`Czas rozpoczęcia i zakończenia zadania powinien mieścić się w zakresie czasowym kamienia milowego.`,
"lable.product.pricebooks.list":`Książka cenowa to lista produktów z określoną ceną i zdefiniowaną walutą. Książka cenowa może być ustawiona dla wielu walut. Podczas wprowadzania produktu do książki cenowej, okazje lub oferty mogą obejmować tylko produkty z jednej książki cenowej. Aby edytować produkt w książce cenowej, kliknij nazwę książki cenowej.`,
"font-trade-module-v1-delete-invoice":`Zweryfikuj fakturę`,
"vue_label_salesadvance_winamount":`Kwota brutto Won`,
"component.salesperformance.label.nopermission":`Aby wyświetlić dane związane z możliwościami biznesowymi, należy skontaktować się z administratorem systemu.`,
"vue_label_report_formatreport_desc":`Wyeksportuj raport z nagłówkami, grupami i ustawieniami filtrów.`,
"label.enable.qrcode.only":`Aktywuj tylko kod QR`,
"label.smstemplate.edit":`Edytuj szablon SMS`,
"label.qrcodeSetting.detailed.information":`Kod QR może przechowywać więcej danych niż kod kreskowy, a skanowanie liniowe nie jest wymagane. Dlatego też kod QR jest szeroko stosowany m.in. w śledzeniu produktów, identyfikacji przedmiotów, zarządzaniu dokumentacją, marketingu itp.`,
"label.event.moveup.1week":`1 tydzień naprzód`,
"label.customize.memory.function.sorting.disable":`Wyłączenie pamięci sortowania nagłówków`,
"label.icon.195":`Wanna`,
"label.compact.layout.assign":`Przypisanie układu informacji kluczowych`,
"label.icon.183":`Dom`,
"front-kefu-moudle-v1-jchxzxzi-chat":`Zintegruj siedzenie z czatem online z Easemob, aby zapewnić bardziej kompleksową usługę SaaS.`,
"label.mycontact":`Moje kontakty`,
"label.tabularreport.2018.step3":`Krok 3 Wybór kryteriów raportowania`,
"chatter.group.uploadGroupPicture":`Prześlij zdjęcie grupowe`,
"label.total.forecast.setup":`na początku i ustawiamy ją na`,
"label.weixin.group.description":`Uwaga`,
"label.edit_emailfooter":`Edytuj stopkę wiadomości email`,
"label.ems.create":`Nowy`,
"label.weixin.optionseven":`Wybór 7`,
"font-evaluate-module-v1-continue-work":`Twoja ocena dodała nam otuchy! Będziemy kontynuować wysiłki, aby robić to lepiej!`,
"label.close.multilingual":`Wyłączyć obsługę wielu języków`,
"component.chatter.post.button.user":`Dodaj ludzi`,
"label.use_QRcode":`Użyj kodu QR`,
"label.operatedata.exportsuc":`Eksport zakończył się sukcesem. Proszę zobaczyć wiadomość e-mail, aby otrzymać link do pobrania. Prosimy o pobranie wyeksportowanych plików w ciągu 48 godzin. Zaleca się, aby usunąć wiadomość e-mail zawierającą link do pobrania wyeksportowanych plików.`,
"label.page.step2.define.content":`Krok 2 Określanie właściwości zawartości i wyświetlania`,
"label_tabpage_groupingitem":`Element grupujący`,
"label.customfields.placeholder":`Wypełnić próbkę`,
"vue_label_commonobjects_detail_enter_subject":`Proszę wprowadzić temat`,
"label.multilang.workflow.everyotherdayinmonth":`{1} dni co {0} miesięcy`,
"label.knowledgebase.data.archiving.failed":`{a} archiwizacja danych nie powiodła się`,
"vue_label_notice_nopermission_view":`Przepraszamy, nie masz dostępu do przeglądania tego rekordu, prosimy o kontakt z administratorem.`,
"vue_label_calendar_calendar_view":`Widok kalendarza`,
"lable.outlook.edit.des":`Jeśli kontakt z Exchange pasuje do wielu kontaktów CloudCC.com, zsynchronizuj go z kontaktem CloudCC.com spełniającym następujące kryteria.`,
"label.custom.NextCQ":`Następne CQ`,
"label.emailsync.form.stutas":`Status`,
"label.nameandintro":`Nazwa i opis`,
"label.dashboardSetup.showdw":`Wyświetlacz`,
"label.tianyancha.actualcapital":`Kapitał otrzymany`,
"front-kefu-moudle-info-delete-calluser":`Informacja została zmodyfikowana, prosimy o kontakt z administratorem`,
"label.emailobject.list.all":`Wszystkie`,
"label.campaign.channel.step7.send":`Proszę wybrać użytkowników, którzy mają otrzymywać wiadomości e-mail`,
"label.formulafield.type":`Typ zwrotu formuły`,
"label.reportsSubscriptionPage.schedulereport.weekly.thursday":`Czwartek`,
"label.chosesubject.eat":`Harmonogram Kolacja`,
"label.back":`Powrót`,
"label.h5.allcompany":`Wszystkie posty dotyczące chmur`,
"label.location.display.type.digital":`Digital`,
"label.datamanage.error.csv":`Nieprawidłowy format pliku, system obsługuje tylko popularny format CSV, proszę spróbować ponownie.`,
"label.emailobject.mark":`Mark`,
"setup_mainpage_label_welcome9":`Użytkownicy mogą realizować klasyfikację wyświetlania i dostosowanie układu wszystkich elementów strony oraz ustawienie tylko do odczytu i wymaganych pól pól na stronie poprzez przeciąganie i upuszczanie myszką bez tworzenia kodu.`,
"label.icon.56":`Przyrząd pomiarowy`,
"label.forecast.edit.fwcd":`Zasięg Długość`,
"vue_label_email_Please_select_related_items_first":`Proszę najpierw wybrać powiązane elementy`,
"label.icon.87":`Książka`,
"label.knowledgebase.recovery.was.successful":`Odzyskiwanie zakończyło się sukcesem`,
"label.emailobject.emaildetail.promptcontent":`Czy na pewno chcesz usunąć tę wiadomość?`,
"label.delete.role":`Usuń role`,
"label.multiselect":`Picklist (Multi-Select)`,
"label.customerinfo.mailisnull":`Nie ustawiono firmowego adresu e-mail.`,
"label.waitforamoment":`Ładowanie strony, proszę czekać...`,
"lable.edit.queue.tip":`Wprowadź nazwę kolejki i adres e-mail, który ma być używany do wysyłania powiadomień (np. gdy sprawa została umieszczona w kolejce). Kiedy obiekt jest przypisany do kolejki, tylko członkowie kolejki zostaną powiadomieni.`,
"lable.custom.y.d":`Ta strona umożliwia zdefiniowanie niestandardowego rekordu roku. Daty dla roku niestandardowego zostaną wygenerowane na podstawie wyborów dokonanych poniżej.`,
"chatter.feed.content.user.searchbutton":`Szukaj`,
"label.data.downpage.i.list.desc3":`Użytkownicy mogą zobaczyć przyczynę niepowodzenia importu w ostatniej kolumnie pliku po pobraniu.`,
"label.tag.manage.createdby":`Stworzony przez`,
"label.h5.similar.opportunity.last.months3":`Ostatnie 3 miesiące`,
"chatter.group.members":`Członkowie`,
"label.knowledgebase.data.translation.failed":`Nie udało się przetłumaczyć danych {a].`,
"label.log.look":`Sprawdź wskazówki dotyczące audytu ustawień`,
"label.service.gantt.week.timescale":`Skala czasu na widoku tygodnia:`,
"label.userLicence":`Licencja użytkownika`,
"label.file.library.managemembers.permission":`Dostęp`,
"label_emailtocloudcc_name":`Nazwa`,
"label.mr.mrSuccess":`Fuzja zakończona`,
"vue_label_commonobject_view_notice_selectadd":`Proszę wybrać dane do dodania`,
"vue_label_commonobjects_detail_level":`Poziom`,
"CloudCCCRM_ST_Info_TypeIn_001":`Proszę wpisać`,
"label_chatter_list":`Lista`,
"label_tabpage_optionsz":`Opcje`,
"UG_homepage_008":`Zrozumienie bieżącego statusu biznesowego (briefingi sprzedażowe, tablice liderów, lejki sprzedażowe itp.), przeglądanie możliwości biznesowych, które mogą być problematyczne, przewidywanie przyszłych wyników, terminowe akceptowanie i przypisywanie ważnych kwestii oraz podejmowanie świadomych decyzji.`,
"label.myselfdashboard":`Moje osobiste pulpity nawigacyjne`,
"label.globaloperation.operationtype.record_phone":`Nagraj telefon`,
"label.field.standard":`Pola standardowe`,
"label.changemydisplay.appedit.check":`Nadpisywanie osobistych ustawień niestandardowych aplikacji`,
"label.tianyancha.h5.legalpersonnames":`Przedstawiciel prawny`,
"label.tabpage.sorttypez":`Typ sortowania`,
"label.newdashboard.folder":`Nowy Folder Dashboard`,
"label.campaign.channel.step6":`Krok 6: Generowanie strony rejestracji kanału marketingowego`,
"label.ems.composeemail":`Wyślij e-mail`,
"label.app.step4.tabcanuse":`Dostępne zakładki`,
"label.sendmail.batch":`Mass Email`,
"label.process.execute.title":`W oczekiwaniu na`,
"lable.outlook.detail.lastup":`Ostatnio aktualizowane`,
"label_emailtocloudcc_delete":`Usuń`,
"lable.opppdt.selPdt.leastone":`Proszę wybrać co najmniej jeden wiersz`,
"label.customfields.new.step2.opration.exid":`Identyfikator zewnętrzny`,
"label.assignment.setup.newrule.description":`Wprowadzić nazwę reguły, a następnie zaznaczyć pole wyboru Włączone, aby użyć tej reguły do automatycznego przypisania. Włączenie tej reguły spowoduje wyłączenie bieżącej reguły przypisywania.`,
"label.campaign.channel.input.to.isactivity":`7.Aktywny kanał marketingowy`,
"label.document.return":`Powrót do dokumentów`,
"label.data.downpage.i_title.num5":`5. Prosimy o sprawdzenie poprawności danych.`,
"label.taskinto":`Zadania są szablonami, z których korzystają reguły przepływu pracy podczas automatycznego przypisywania zadań użytkownikom.`,
"label.customfields.formula.textexample":`Pełna nazwa = LastName`,
"label.appointmentpage.wizard.subtitle1-1":`Następny tydzień`,
"label.weixin.radio":`Single-Select`,
"vue_label_file_replace_reason_check":`Powód zastąpienia (nieobowiązkowo)`,
"label.sendemail.recycle.operateexception":`opróżnianie kosza nie powiodło się, proszę spróbować ponownie.`,
"label.vlidaterule.formulaerror":`Wyświetl błąd, jeśli rabat jest większy niż 30%.`,
"vue_label_campaign_existing_member_status":`Zachowanie dotychczasowego statusu członka`,
"label.service.miniProgram.fillSlideshowName":`Proszę wpisać nazwę karuzeli.`,
"label_partner_workspace_login_headerfooter":`Nagłówek i stopka`,
"label.quickbooks.viewlist.total2":`Istnieje {0} szacunków dla łącznej wartości {1}.`,
"chatter.viewingResults":`Zobacz wyniki`,
"label_tabpage_allvisible":`Wszyscy użytkownicy są widoczni`,
"label.quote":`Cytaty`,
"label.changemydisplay.list.des":`Dostosuj zakładki do swoich potrzeb`,
"label.leadscore.notimes":`Nie ma już czasu na zdobywanie leadów`,
"label.icon.51":`Wytwarzanie energii elektrycznej`,
"component.assistant.label.title":`Asystent`,
"label.emailobject.emailsent":`E-mail wysłany！.`,
"label.group.nofile":`Do tej grupy nie zostały wysłane żadne pliki.`,
"label.foldervisitlimit2":`Wszyscy użytkownicy nie mają dostępu do tego folderu`,
"label.dataoperate":`Operacja na danych`,
"label.addattachment.size":`Rozmiar`,
"label.not.double":`Duplikaty wartości są niedozwolone.`,
"label.customfields.formula.number.tip":`Obliczyć wartość liczbową.`,
"lable.opppdt.addpdt.table.description":`Opis linii`,
"label.sms.isactivity":`Aktywny`,
"label.campaign.channel.input.owner":`4.Kto będzie właścicielem leadów tego kanału:`,
"label.visualpage.notfound.error":`Wystąpił nieznany błąd, prosimy o kontakt z administratorem.`,
"label.mr.title.button.group3":`zapisy`,
"label_tabpage_beginz":`Rozpocząć`,
"label_tabpage_queue":`Kolejka`,
"label.tabpage.advancedscreening":`Filtr zaawansowany`,
"nogreate":`mniejszy lub równy`,
"chatter.fields":`Pola w`,
"button_partner_workspace_manage":`Zarządzanie`,
"label.partnerCloud.orderingPlatform.search":`Wyszukaj produkty`,
"message.password.isnull":`Proszę wpisać swoje hasło.`,
"label.fenbeitong.title":`FenBeiTong Setting`,
"label.salescloud.contactrole.message.chooseatleastone":`Proszę wybrać przynajmniej jeden kontakt.`,
"label.knowledge.delete.election":`Błąd przy usuwaniu wyboru kategorii danych`,
"front-console-status-hoided":`Ułożyć się`,
"label.lastmodifydate":`Data ostatniej modyfikacji`,
"vue_label_chat_deleting_chat":`Po usunięciu, historia czatu zostanie wyczyszczona i usunięta z listy Drużyny. Po otrzymaniu nowej wiadomości pojawi się ona ponownie na liście Drużyny.`,
"label.timeframe":`Ramka czasowa`,
"UG.opportunity.002":`Zdefiniuj swój cykl sprzedaży, skonfiguruj etapy`,
"label.templates.merge":`Proszę wybrać szablony, które mają zostać połączone. Można wybrać maksymalnie 20.`,
"label.generatepage.c2":`Maksymalna długość to 30.`,
"label.appointment.wizard.subtitle4-1-6":`2 h`,
"label.passwordPolicy.setup.pwdremember3":`3 zapamiętane hasła`,
"button.partner.workspace.enable":`Włączenie chmury partnerskiej`,
"vue_label_pool_nopool_notice":`Nie dołączyłeś jeszcze do żadnej puli, skontaktuj się z administratorem, aby utworzyć lub dołączyć do puli.`,
"label.layout.required.field.select":`Wybrane wymagane pola`,
"label.loginhis.date":`Wprowadzić datę początkową i datę końcową.`,
"vue_label_commonobjects_detail_and_overdue":`Nadchodzące i zaległe`,
"label_tabpage_advancedsearch":`Wyszukiwanie zaawansowane`,
"label.custom.field.login.home.query":`Proszę wejść na stronę główną i zobaczyć szczegóły zadania.`,
"page":`Strona`,
"label_tabpage_onlymevisible":`To jest widoczne tylko dla mnie`,
"label.weixin.optionfour":`Wybór 4`,
"label.confirm.to.remove":`Potwierdź, aby usunąć`,
"label.event.moveup.30minutes":`30 minut wcześniej`,
"label.mail.merge.template.finish":`Zakończono scalanie szablonów wiadomości e-mail`,
"label.multilang.currencylist.before":`Przed {0}`,
"label.goback":`aby przejść do poprzedniego`,
"label.unknown.prefix":`Nieprawidłowy prefiks, proszę wpisać ponownie.`,
"lable.account.CurrentandPreviousCYt":`Obecne i poprzednie 2 CY`,
"label.product.dent":`Wprowadź słowo kluczowe i kryteria filtrowania, a następnie kliknij przycisk Szukaj, aby rozpocząć wyszukiwanie.Kliknij przycisk Więcej filtrów, aby użyć więcej niż jednego filtra.Wyniki wyszukiwania zawierają wszystkie rekordy, które pasują zarówno do słowa kluczowego, jak i wpisów filtra.`,
"label.ems.bcc":`Bcc`,
"label.import.index.operation":`Operacja`,
"label.knowledge.setting.hint.eight":`Utrzymuj wszystko w idealnym porządku!`,
"label.sso.saml.sp.idtype.fid":`Asercja zawiera ID Federacji z obiektu Użytkownik`,
"vue_label_chat_voice":`Głos`,
"label.config.pw":`Potwierdź nowe hasło`,
"lable.newtabpage.closesearchresult":`Upadek Wyniki wyszukiwania`,
"lable.account.NextWeek":`Następny tydzień`,
"label.ems.username":`Nazwa użytkownika (u)`,
"vue_label_email_emails_from_potential":`E-maile od leadów i kontaktów w Twoim CRM, oraz emaile zawierające je w odbiorcach, będą kategoryzowane tutaj`,
"lable.approval.shared":`Udział w zatwierdzeniu`,
"label.tabpage.allz":`Wszystkie`,
"label.file.uploadfiles":`Prześlij pliki`,
"label.emailobject.text":`Tekst:`,
"label.version.allow.create":`Zezwalaj na tworzenie nowych`,
"label.empty.field":`Pole nie może być puste.`,
"label.emailsync.status.department":`Dział`,
"label.pw.str":`5 znaków`,
"label.attendance":`Frekwencja`,
"label_mobile_buttom_team":`Zespół`,
"label.campaignmember.main.addcontactdesc":`Dodaj wszystkie istniejące kontakty do tej kampanii`,
"label.search.result":`Wyniki wyszukiwania`,
"label.weixin.activity.account":`Działalność gości`,
"label_tabpage_clearoptionsz":`Wyczyść opcje zaawansowane`,
"UG.activity.01":`W jaki sposób śledzisz swoje rekordy, aby współdziałać ze swoimi kontami/zespołami?`,
"serviceappointment.new.status.limit":`Nie udało się utworzyć nowej wizyty serwisowej o statusie zaplanowana lub wysłana.`,
"label.notice.higher":`Wyślij e-mail do menedżera`,
"label.passwordPolicy.setup.gletters":`bohater(ka)`,
"label.data.exportsf.des":`Pomyślnie wyeksportowane pliki zostaną automatycznie usunięte po 48 godzinach od zapisania na derverze.`,
"label.view.onlymecansee":`Widoczny tylko dla<b> mnie</b>`,
"UG.Lead.005":`Skrzynka pocztowa`,
"label.umeng.approval.approvalfail":`nie udało się.`,
"label.huanxinconfig.clientid.lost":`clientid nie może być pusty`,
"label.campaignmember.main.updatecontactstatus":`Aktualizuj status - istniejące kontakty`,
"component_chatter_button_delete":`Usuń`,
"label.weixin.no.pending.projects.qin":`Brak punktów do zatwierdzenia.`,
"front-electronic-signature-auto-fill-field":`Pole autouzupełniania`,
"message.resetpw":`Czy na pewno chcesz zresetować swoje hasło?`,
"label.service.ganttBaiduMap.service.resourname":`Nazwa usługi Zasoby`,
"vue_label_pricebook_deleted":`Usunięto cennik`,
"label.icon.193":`Wanna`,
"label.validate.function.funcFormat.NOT":`NOT(logiczne)`,
"label.address.city":`Miasto`,
"label.pc.ui.2018.searchs":`SZUKAJ...`,
"label.yard":`Kod zaproszenia`,
"label.data.downpage.i_title.btn":`Przejdź do strony importu i rozpocznij importowanie`,
"label.useablereceivers":`Dostępni odbiorcy`,
"label.cloudccsite.name.length":`Pozwala użytkownikom na wprowadzenie do 255 znaków`,
"label.secrecy":`Poufne`,
"label.campagin.roi.ydkhywjhzz":`Całkowita kwota zamkniętych możliwości wygranych`,
"vue_label_report_conditiondesc_one":`Oprócz subskrypcji, można ustawić warunki dla tego raportu. Zostaniesz powiadomiony, jeśli wszystkie warunki zostaną spełnione. Jest to opcja`,
"label.datamanage.select.contactfield":`(Wybierz pole odpowiadające importowanemu kontaktowi)`,
"label.emailtocloudcc.filed.action":`Działanie`,
"label.smstemplate.new":`Nowy szablon SMS`,
"label.mobile.side.tab.app":`Aplikacje`,
"label.icon.118":`Zegar`,
"label.customfields.selectcontainfieldlayout.tip":`Pole zostanie dodane jako ostatnie pole w pierwszej 2-kolumnowej sekcji tych układów strony. Pole nie pojawi się na żadnej stronie, jeśli nie wybierzesz układu strony. Aby zmienić położenie tego pola na stronie, musisz dostosować układ strony.`,
"Lead_Homepage_Tools_BatchScoring":`Wynik partii`,
"lable.quote.syncing.quote":`Cytaty`,
"pagecreator.button.preview":`Podgląd`,
"label.ccchat.am":`AM`,
"chatter.feed.menutype.user.nullrecent":`Brak najnowszych danych`,
"lable.info.queue.showallmember":`Wyświetlanie członków kolejki`,
"label.multilang.campaign.selelctmember.desc":`Wybierz widok i wybierz członka, którego chcesz dodać do kampanii. Status członka to {0}.`,
"label.notification.ccchat3":`【评论用户名】 skomentował(a) wpis.`,
"UG.product.03":`Instrukcja obsługi cen w wielu walutach`,
"label.sso.saml.idp.config.pksize":`Rozmiar klucza`,
"label.defineCustomReportType":`Zdefiniuj źródło danych raportu niestandardowego`,
"component.timeline.button.filter":`Filtr`,
"label.mr.nextGroup":`Pomiń grupę i przejdź do następnej grupy`,
"label.quote.sprdz":`Adres rozliczeniowy`,
"label.total.refuse.forecast.have.priority":`Odrzuć wszystkie Prognoza Priorytet`,
"lable.product.peep":`Proszę wpisać prawidłową cenę.`,
"label.file.who.can.access":`Kto może uzyskać dostęp`,
"label.page.last":`Ostatnia strona`,
"label.icon.180":`Ludzie`,
"font-evaluate-module-v1-enabled-successfully":`Udało się włączyć opcję oceny "Neural".`,
"label.appointment.wizard.subtitle4-2-2":`2 h`,
"label.passwordPolicy.setup.oneyear":`Jeden rok`,
"label.login.bound.mfadevice.title":`Włącz wirtualne urządzenia MFA`,
"vue_label_dashboard_statisticalvalue":`Proszę wybrać wartość statystyczną`,
"label.ishistory":`Historia`,
"component.timeline.label.title":`Oś czasu`,
"label.page.step3.of.step5":`Krok 3 z 5`,
"label.assignment.setup.detail.section":`Zasada Szczegółowa`,
"label.salescloud.opportunity.nothave.main.contactrole":`Brak istotnych kontaktów`,
"label.import.page1.limitedcsv":`Format CSV TYLKO do przesyłania plików`,
"label.icon.187":`Młotek`,
"label.emailobject.wizard.desc5":`Dostosuj swój podpis, aby Twoja poczta wyglądała lepiej.`,
"vue_label_report_notice_copy_success":`Skopiuj raport pomyślnie!`,
"label.dupicatecheck.repeatcondition.chooserulemsg":`Nie wybrałeś zasady sprawdzania duplikatów.`,
"label.componentEditor.upper.limit":`Do 100`,
"label.validate.function.funcExplain.ISNEW":`Sprawdza, czy rekord jest nowy i zwraca TRUE, jeśli jest nowy, w przeciwnym razie zwraca FALSE`,
"label.postalCode":`Kod pocztowy`,
"label.dashboard.snapshot.enable.flag":`Włączanie migawek pulpitu nawigacyjnego`,
"vue_label_file_upload_type_size":`Można przesyłać tylko pliki {fileType} i nie więcej niż {size}Mb`,
"label.appointment.wizard.subtitle3-6":`Sobota`,
"homepage.narrow":`Kolumna wąska (lewa)`,
"chatter.addmute.confirm":`Czy jesteś pewien, że chcesz zachować ten post "nie przeszkadzać"?`,
"label.lookup.account":`Wyszukaj konta`,
"message.lostthemanager":`To zgłoszenie wymaga zatwierdzenia przez menedżera użytkownika, a wartość menedżera użytkownika jest pusta. Skontaktuj się z administratorem, aby dowiedzieć się więcej.`,
"label.exchange.sync.state.contact.m3":`Rekordy zsynchronizowane w ciągu ostatnich 24 godzin:`,
"label.version.phone.app":`Aplikacja mobilna`,
"label_tabpage_search":`Szukaj`,
"vue_label_helpcenter_campaign":`W informacjach szczegółowych, kliknij przycisk diagramu drzewa obok kampanii, aby wyświetlić diagram struktury hierarchicznej kampanii i zrozumieć hierarchię rodzic-dziecko kampanii.<br>Zarządzaj kontaktami lub leadami zaangażowanymi w kampanię poprzez powiązaną listę członków kampanii.`,
"front-lightning-module-v1-dashborad-last-year":`W ubiegłym roku`,
"label.campaign.channel.value":`Wartości`,
"vue_label_opportunity_contactrole_primarycontact_notice":`Aby wybrać swój główny kontakt, zapisz ten krok i wybierz opcję Zarządzanie`,
"label.biaoqingfaxian.title":`Rozpoznanie ofert i przetargów`,
"label.approved":`Zatwierdzony`,
"label.hong.kong.time":`Czas Hongkongu`,
"label.customfields.file.cannotopen":`Nie można otworzyć pliku`,
"lable.New.tips":`Kliknij "Nowy", aby utworzyć nowy szablon raportu serwisowego na podstawie szablonu standardowego lub dowolnie wybranego. Proszę aktywować szablon i zacząć go używać.`,
"component.setup.tabs.label.add":`Dodano`,
"label.forecast.forehistory.replacebest":`Nadpisanie najlepszego przypadku`,
"front-kefu-moudle-v1-jctrrt-call-serve":`Call Center zintegrowane z TRRT w celu zapewnienia bardziej kompleksowych usług SaaS`,
"label.workflow.configrule":`Krok 2 Konfiguracja reguły przepływu pracy`,
"label.dashboard.snapshot.refresh.frequently":`Zrzuty z pulpitu nawigacyjnego odświeżają się zbyt często, proszę spróbować ponownie później`,
"label.ems.editsetting":`Edytuj ustawienia wiadomości e-mail`,
"message.confirmdeleteAPP":`Czy na pewno chcesz usunąć tę aplikację?`,
"label_chatter_activity":`Działania`,
"label.editsharerules":`Zasady udostępniania Edycja`,
"label.loginservice.license.notuse.must":`Licencja nie jest obecnie dostępna, musisz`,
"label.import.step2.beforeexport":`1、Przed importem, należy upewnić się, aby zaimportować wszystkie powiązane rekordy. Na przykład, jeśli są importowane rekordy kontaktu i chcesz wypełnić pole konta, które jest pole lookup, trzeba utworzyć rekord konta, które wypełniasz w pierwszy, a następnie zaimportować rekord kontaktu i wypełnić pole konta z nazwą lub ID odpowiedniego konta.`,
"label.chat.mute":`Nie przeszkadzać`,
"label.icon.128":`Dom`,
"label.give":`&&And`,
"label.hide":`Nie pokazuj`,
"label.relationobject.wpr":`Zatwierdzający delegowany`,
"label.summation":`Suma`,
"label.layout.availabletab.details":`Szczegóły`,
"label.circle":`Wykres pączków`,
"vue_label_opportunity_contactrole_add":`Dodaj role kontaktu`,
"label.file.library.file2libsuccess":`Dodano pomyślnie!`,
"label.weixin.report.reportgenerated":`Wygenerowany raport`,
"label.icon.91":`Ludzie`,
"report.label.pleaseinput":`Wpisz, czego chcesz szukać`,
"label.escalation.setup.newaction.otheremail.tip":`Można wprowadzić do pięciu (5) adresów e-mail, które mają być powiadamiane. Każdy adres e-mail jest oddzielony znakiem ",".`,
"label.area.donot.have.data":`Brak danych`,
"label.customcomponent.btn.reference":`Odniesienie do komponentu`,
"label.appointmentdetail.wizard.title7":`Czas przypomnienia`,
"label.ccchat.with":`Posiadać`,
"label.file.size":`Rozmiar`,
"label.product.sort.beyond":`Można ustawić maksymalnie 10 poziomów !`,
"label.ccchat.2018":`CCChat`,
"label.report.select.column":`Wybierz kolumny`,
"label.appointmentpage.wizard.subtitle1_1":`Wybierz datę i godzinę`,
"label.passwordPolicy.setup.uppercasealpandnumsymbol":`Musi łączyć cyfry i małe i wielkie litery oraz znaki specjalne.`,
"label_chatter_addressee":`Odbiorca`,
"label.profile.remark2":`Jeśli Twoja organizacja używa Typów rekordów, użyj linków Edytuj w sekcji Ustawienia typów rekordów poniżej, aby udostępnić jeden lub więcej typów rekordów użytkownikom o tym profilu.`,
"UG_Account_01":`Kto jest Twoim kontem?`,
"label.dataimport.error.contact.notnull":`Błąd: nazwa kontaktu nie może być pusta.`,
"lable.account.CalenderQuarter":`Kwartał kalendarza`,
"vue_label_commonobjects_detail_empty":`Cena sprzedaży nie może być pusta`,
"label.approveassigntemplate":`Zatwierdzony do przypisywania szablonów wiadomości e-mail.`,
"label.objectRelationshipDescription1":`To źródło danych raportu będzie generować raporty dotyczące`,
"vue_label_email_insertmergefield":`Wstaw pole łączące`,
"label.mobile.home.page.check.team":`Zespół`,
"lable.edit.queue.edit":`Kolejka Edycja`,
"label.campagin.roi.query":`Zobacz ROI kampanii`,
"label.dataimport.field.allow.access.to":`Pola danych nie są dostępne, proszę ręcznie usunąć odpowiedni rekord i spróbować ponownie.`,
"pagecreator.systemstyle.message.canntdelete":`Bieżący styl nie może być usunięty`,
"label.searchkey":`Proszę wpisać słowa kluczowe`,
"chatter.showall":`Pokaż wszystko`,
"show":`Pokaż`,
"label.quote.choseproduct":`Wybierz produkt`,
"label.report.selected.field":`Wybrane pola`,
"label.globaloperation.operationtype.create_data":`Utwórz rekord`,
"label.knowledge.setting.data.seven":`Usuń grupę kategorii: {flzmc}`,
"chatter.email.mentionOrMessage":`Wzmianki lub wiadomości`,
"label_tabpage_exclusivez":`Z wyłączeniem`,
"chatter.en.userinfo":`Wprowadź informacje o sobie.`,
"label.log.orgid":`Organizacja`,
"label.dataimport.insertdata.error.fieldrepeat.update":`Pole $schemefield_name$ w rekordzie nie może być odnalezione w bazie danych i nie może być aktualizowane. Rekord został zignorowany podczas importu.`,
"vue_label_chatter_add_link_success":`Link został dodany pomyślnie`,
"label.sender_details":`Aby dodać nowe dane nadawcy, utwórz użytkownika w swoim`,
"label.ccpeak.addwhere.condition":`Można dodać kryterium "gdzie".`,
"label.datamove.total":`Ogółem`,
"label.tianyancha.businessverify.warning":`Proszę zauważyć, że ta weryfikacja obsługuje tylko dane biznesowe zarejestrowane w Chinach kontynentalnych.`,
"label.emailmainbody":`Email Body`,
"label.justadmin":`Tylko administratorzy`,
"label.data.downpage.e.list.desc1":`Ta strona wyświetla pomyślnie wyeksportowane pliki. Prosimy o pobranie wyeksportowanych plików w czasie zgodnym z linkiem do pobrania w emailu.`,
"label.reportsSubscriptionPage.email.value":`Wartości istniejące`,
"message.error.serviceappointment":`Prosimy o wpisanie planowanej godziny rozpoczęcia i zakończenia wizyty serwisowej.`,
"label.textMessageObject.selectone":`Proszę wybrać co najmniej jeden rekord jako odbiorcę SMS-a`,
"label.schedulejob.setup.schedule.plan":`Harmonogram`,
"label.assignment.layout.field.isassigned":`Przydzielanie zgodnie z aktywnymi zasadami przydzielania.`,
"label.captcha.error":`Błąd weryfikacji!`,
"mobel_web_not_more_data":`Nie ma więcej danych`,
"label.emailsync.form.emailaddress":`Adres e-mail`,
"label.loginservice.error":`Błąd logowania, prosimy o kontakt z administratorem.`,
"label.integrations.description":`Połącz swoje konto CloudCC z innymi aplikacjami`,
"vue_label_homepage_notice_selectone":`Proszę wybrać co najmniej jeden lead lub kontakt`,
"label.chatter.default":`Domyślnie`,
"label.tabpage.datefield":`Kiedy pole daty jest równe, może użyć formatu "wczoraj", "dziś", "jutro", "ostatni miesiąc", "ten miesiąc", "następny miesiąc", "ostatni tydzień", "ten tydzień", "następny tydzień" lub "RRRR-MM-DD、MM/DD/YYYY".`,
"front-kefu-moudle-myzdhsc-file":`Plik zapisu nie został znaleziony lub nie został wygenerowany`,
"label.createname":`Twórca`,
"label.mobile.phone.enter.plan":`Wprowadź swój plan`,
"report.label.highlevelreport":`Raporty zaawansowane pozwalają na tworzenie relacji pomiędzy maksymalnie 4 obiektami.`,
"label.edit.select.label":`Tryb edycji`,
"label.partnerCloud.financeSetting.deduction":`Po aktywacji, funty zostaną dodane do konta rabatowego, przychodu rabatu i obiektu wydatkowania rabatu. Użytkownicy partnerscy mogą korzystać z konta rabatowego, aby odliczyć kwotę do zapłaty.`,
"message.duplication.label.updateoption":`Działanie w sprawie aktualizacji`,
"label.custom.CurrentCQ":`Aktualne CQ`,
"front-kefu-moudle-wait":`Oczekiwanie`,
"sunday":`Niedziela`,
"label.service.timezone":`Strefa czasowa`,
"setup.layout.label.selectfield":`Wybierz pola`,
"label_emailtocloudcc_filed_action":`Działanie`,
"label.forecast.customforecast.mycommit":`Moje zobowiązanie`,
"label.uploadsuc":`Przesyłanie zakończone sukcesem`,
"vue_label_commonobjects_view_notice_atleast1field":`Wybierz co najmniej 1 pole wyświetlania`,
"label.dataimport.khmc.length":`Błąd: długość konta jest zbyt duża.`,
"label.isemailnotification":`Wyślij wiadomość e-mail z powiadomieniem`,
"label.addAPPexchange":`Dodaj aplikacje z CloudCC App Store`,
"label.partnerCloud.orderingPlatform.currency":`Waluta:`,
"UG_quota_02":`Etap możliwości zmiany`,
"label.customer.tab.step2.same.option3":`Zakładka Ukryte`,
"H":`Telefon`,
"label_tabpage_searchz":`Szukaj`,
"vue_label_homepage_deleted":`Usunięto`,
"label.weixin.recent.view":`Ostatnio oglądane widoki`,
"template.report.opportunity.sales":`Wielkość sprzedaży szans`,
"label.customfields.new.step2.opration.unique.info.v1":`Traktuj "ABC" i "abc" jako zduplikowane wartości (wielkość liter nie ma znaczenia)`,
"savesuccess":`Zapisany pomyślnie`,
"label.partner.workspace.member.memo":`Wszyscy użytkownicy z wybranym profilem i uprawnieniami mogą uzyskać dostęp do tej chmury partnerskiej.`,
"label.icon.23":`Lek`,
"lable.batchadd.service.cfq.before":`Wyzwalacze (przed wstawieniem)`,
"label.instrumentPanel.breakpointTwoLabelname":`Wartość ta powinna być większa od wartości minimalnej i wartości punktu przerwania 1.`,
"message.selectgsummaryinformation":`Proszę wybrać dane, które mają być podsumowane`,
"label.tianyancha.businessverify.msg6":`Ta funkcja korzysta z usług stron trzecich i może mieć niestabilną wydajność lub niemożliwe usługi z powodu wysokiego jednoczesnego wykorzystania. CloudCC nie ponosi żadnej odpowiedzialności.`,
"vue_label_helpcenter_report3":`3.A. Kliknij pole wyszukiwania pól, wybierz pole, które chcesz, wyszukując je lub przewijając listę pól, wybierz operator pola, wpisz lub wybierz wartość, kliknij Zastosuj, a filtr pola zacznie działać. <br> B. Kliknij znak " " nad polem wyszukiwania i wprowadź zaawansowany warunek filtrowania składający się z cyfr i liter w polu "Filter Condition Input Box". Na przykład, (1 i 2) lub3.<br>? Edycja filtrów<br>Aby edytować filtry, włącz filtry standardowe i kliknij na filtry. <br>? Usuń filtry<br>Kliknij ikonę "x" na filtrze, aby go usunąć. <br>? Uruchom raport<br> Kliknij przycisk Uruchom w prawym górnym rogu strony edycji, aby zobaczyć pełne wyniki raportu. <br>? Zapisz raport<br> Kliknij przycisk "Zapisz" w prawym górnym rogu strony edycji, wpisz nazwę raportu, wybierz folder raportu i zapisz go. <br>2. Tworzenie folderu raportu<br> Przed utworzeniem folderu raportu, system domyślnie generuje Mój własny folder raportu i niezarchiwizowany publiczny folder raportu. <br>Krok 1: W zakładce Raporty, kliknij Nowy Folder Raportów<br>Krok 2: W oknie podręcznym Nowy Folder Raportów, możesz wybrać przeniesienie raportów z folderu Niearchiwizowane Raporty Publiczne do tego folderu. Można wybrać, którzy użytkownicy mogą uzyskać dostęp do tego folderu i prawa dostępu. <br>3. Przeglądanie raportów<br> Krok 1: Z zakładki Raporty, przejdź do strony listy raportów i znajdź raport, który chcesz przeglądać poprzez przełączenie "Ostatnio przeglądane", "Utworzone", "Wszystkie raporty" lub folder raportów. lub folder raportów, aby znaleźć raport, który chcesz przeglądać. <br> Krok 2: Kliknij nazwę raportu, aby go wyświetlić. Lub kliknij przycisk rozwijany po prawej stronie raportu i wybierz opcję Uruchom, aby wyświetlić raport. <br>Jeśli posiadasz profil administratora, z zakładki Raporty przejdź do strony Lista raportów i kliknij ikonę koła zębatego obok przycisku Nowy folder, aby wybrać pola do wyświetlenia w nagłówku tabeli listy raportów w każdym folderze. <Krok 1: W zakładce Raporty, przejdź do strony z listą raportów, znajdź raport, który chcesz wyeksportować i kliknij przycisk rozwijania znajdujący się po prawej stronie raportu. <br> Krok 2: Wybierz typ<br> Raport formatu: zawiera nagłówki raportu, grupowanie, filtrowanie szczegółów. <br> Raport tylko szczegółów: Niesformatowane wiersze szczegółów. <br> Krok 3: Kliknij przycisk Eksportuj. Raport tylko szczegóły musi być wyeksportowany w stronach, z maksymalną ilością 2000 danych na stronę.  `,
"label.batchdelete.success":`Masowe usuwanie powiodło się`,
"label.newprocess5.seq":`Zamówienie`,
"label.knowledgebase.data.translated.successfully":`Przetłumacz dane {a] pomyślnie`,
"label_enable_range":`Aktywuj zasięg`,
"label.ccchat.and":`I`,
"label.assignment.setup.list.norule":`Nie określono żadnych zasad.`,
"vue_label_report_summaryformulacolumn":`Kolumna formuły podsumowującej`,
"label.field.edit.change1":`Maksymalna liczba punktów nie powinna przekraczać 100`,
"syntaxerror":`Błąd składni, proszę sprawdzić wprowadzone kryteria.`,
"label.icon.116":`Dom`,
"lable.asset.BOM.according.to.product":`Generowanie BOM aktywów zgodnie ze strukturą produktu`,
"chatter.like.post":`ludzie polubili ten post`,
"label.trigger.page":`Strony wyzwalające`,
"vue_label_email_contact_adminstrator":`System działa nieprawidłowo, skontaktuj się z administratorem.`,
"label.workreport":`Uwagi do pracy`,
"vue_label_homepage_edit_card_view":`Edytuj widok karty`,
"label_emailsync_status_disabel":`Nieaktywny`,
"label.icon.54":`Koparka`,
"message.error.view.validerr.common":`Weryfikacja nie powiodła się.`,
"label.exchange.sync.account.username":`Nazwa użytkownika konta serwisowego (nazwa domeny lub UPN)`,
"label.dataimport.error.date":`Błąd: Data`,
"label.orgname":`Organizacja`,
"label.weixin.group.owner":`Właściciel`,
"vue_label_dashboard_colorrange":`Zakres kolorów`,
"label.forecast.shrepage.tableth":`Prognoza Dostęp`,
"label.related.disabled":`Powiązane listy nie są włączone, skontaktuj się z administratorem systemu, aby włączyć powiązane listy w układach stron.`,
"label.version.product.management":`Zarządzanie produktami`,
"label.knowledge.new.article.published":`Artykuł jest publikowany jako nowy artykuł.`,
"label.sendsms.batch.step4":`Krok 4 Twój SMS został wysłany.`,
"vue_label_commonobjects_detail_and_tasks":`Gratulacje, wszystkie zdarzenia i zadania zostały przetworzone`,
"label.salescloud.ci":`czas(y)`,
"label.ccpeak.getapi.name.time":`Jeśli chcesz korzystać z metod klasy CCService, musisz ją zainicjować.`,
"label.escalation.setup.detail.conditon":`Kryteria`,
"label.lbs.isUseLbs":`Włącz usługi lokalizacyjne`,
"front-lightning-module-v1-dashborad-color-depth":`Głębokość koloru`,
"date":`Data`,
"label.select.personnel":`Wybór personelu`,
"label.appointmentpage.wizard.notif3":`Email jest wymagany!`,
"label.import.page1.pleaseselectwayofdealdata":`Proszę wybrać tryb przetwarzania`,
"label.partner.all.memo":`Lista pokazuje wszystkie chmury partnerskie w Twojej organizacji. kliknij url aby się zalogować.`,
"label.appointment.wizard.subtitle4-3-3":`30 min`,
"component_telerecord_label_subject":`Przedmiot:`,
"label.sendsms.batch.finish":`SMS masowy: Zakończono`,
"label.login.access.myusername":`Moja nazwa użytkownika`,
"label.weixin.wechatnumber":`Identyfikator WeChat`,
"label.eowechat.status":`Status użytkownika`,
"Lead_Scoring_Setting_Rule_Setup_Value":`Wynik`,
"label.appexchange.oldreport.noupload":`Stare raporty - nie przesyłaj`,
"label.approverfieldediting":`Możliwość edycji pól i zapisów przez zatwierdzającego`,
"label_tabpage_customernamez":`Nazwa klienta`,
"vue_label_dashboard_linkagesettings":`Ustawienie powiązań`,
"vue_label_ccchart_notice_deletecomment":`Czy na pewno chcesz usunąć ten komentarz?`,
"label.allprofile":`Wszystkie profile`,
"label.campaignmember.main.addMember":`Dodaj członków - wyszukiwanie`,
"label.projectManagement.subtask.list":`Lista podzadań`,
"label.code.some.size":`Pojemność kodu: maksymalnie 200KB znaków, około 20,0000 bajtów.`,
"front-custom-service":`Service Cloud zapewnia wydajne i sprawne usługi dostosowane do potrzeb klientów, skraca czas rozwiązywania problemów z usługami i zwiększa ich liczbę dzięki inteligentnemu systemowi zleceń roboczych, zwiększa lojalność klientów i podnosi wskaźnik ich ponownego zakupu.`,
"label.SMS.det":`Szczegóły powiadomień SMS`,
"setup_layout_label_nobutton":`Brak dostępnych przycisków`,
"vue_label_email_Could_not_save_template":`Nie można zapisać szablonu`,
"label.imgfield.height":`Wysokość`,
"label.leadscore":`Lead scoring`,
"setup_object_field_dependency_label_removefromlist":`Usuń wybrane wartości`,
"message.error.code.null":`Kod autoryzacji nie może być zerowy!`,
"label.tianyancha.businessscope":`Zakres działalności`,
"vue_label_chat_empty_message":`Pusta wiadomość`,
"label.total":`Ogółem`,
"label.delerror.list":`Lista nieusuniętych plików`,
"label.selectedreceivers":`Wybrani odbiorcy`,
"label.layout.availablepages":`Dostępne strony`,
"label.pc.ui.2018.personalinfo":`Dane osobowe`,
"label.chat.topic.edit.detial":`Edytuj szczegóły`,
"label.mr.descreption.reDataList1":`W zapytaniu ofertowym, aby spełnić warunki dotyczące łącznie`,
"label.document.value.too.long":`Ten plik ma rozmiar ponad 5M!`,
"lable.opppdt.addpdt.table.listprice":`Cena katalogowa`,
"label.selectoperate":`Wybierz działanie`,
"label.icon.5":`Waluta`,
"label.icon.126":`Łóżko szpitalne`,
"label.hiddensearch":`Ukryte poszukiwania`,
"label.view.sortview.exportble":`Możliwość eksportu`,
"vue_label_homepage_noassignee":`Brak cesjonariusza`,
"label.knowledgebase.close.and.resolve":`Zamknięte i rozwiązane`,
"label.licence.used":`Używane licencje`,
"label.newprocessstep5":`Krok 5 Wybór pól do wyświetlenia na stronie zatwierdzania`,
"vue_label_appstore_all_applications":`Wszystkie zastosowania`,
"label.no.edit.permission":`Nie można wybrać. Brak uprawnień do edycji wybranych rekordów.`,
"vue_label_calendar_calendar_added_successfully":`Kalendarz dodany pomyślnie`,
"report_line":`Pole danych`,
"component.chatter.link.label.name":`Nazwa związku`,
"label.data.expnode.e_desc1":`1. Eksport niestandardowy: użytkownicy mogą wybrać pola do eksportu i ustawić warunki filtrowania zgodnie z własnymi potrzebami.`,
"label.tabularreport.step4":`Krok 4 Wybierz kryteria raportu`,
"Opportunity.Detailed.Phase.Change.Text.001":`Etap możliwości zmiany`,
"label.quickbooks.searchresault.action":`Działanie`,
"component_timeline_label_today":`Dzisiaj`,
"label.callboard.remark":`Proszę wpisać poniżej swoje ogłoszenie firmowe.`,
"label.campagin.field.choose":`Wybierz pola, które mają być zawarte na stronie rejestracji członków kampanii`,
"front-gantt-module-rolling-temporary-tasks":`Przeniesienie do zadania tymczasowego`,
"label.file.des":`Opis`,
"Dashboard_View_RecentlyView":`Ostatnio oglądane`,
"UG_Account_04":`Pasywne filtrowanie kont zapytań`,
"chatter.refresh":`Odśwież`,
"label.tianyancha.companyorgtype":`Typ przedsiębiorstwa`,
"label.chatter.dateRange":`Zakres dat`,
"label.campagin.step3":`Krok 3: Wygeneruj strony`,
"label.appointmentdetail.wizard.title14":`Plan na poniedziałek`,
"setup.object.field.dependency.button.setdependency":`Ustawienia zależności od pola`,
"serviceterritorymember.serviceterritory.isactive.notactive":`Ten obszar usług nie jest włączony. Członków można dodawać tylko w ramach włączonego obszaru usług.`,
"template.chart.ygydyj":`Pracownik Wygrana Kolejność Wydajność`,
"label.tag.edittags":`Znaczniki edycji`,
"label.clone":`Clone`,
"front-electronic-signature-setting-intro1":`Przed związaniem konta zaleca się najpierw rejestrację i uwierzytelnienie na platformie DocuSign.`,
"label_reach":`Wydajność`,
"label.tabpage.havez":`Załączona`,
"label.email.clearCase":`Tylko puste E-maile niepowiązane ze sprawami`,
"label.customer.tab.all":`Wszystkie karty`,
"label.direct.dashboard.day.report":`Nowa dzienna notatka robocza`,
"label_tabpage_exportview":`Widok eksportu`,
"label.passwordPolicy.setup.maxFailTimes":`Maksymalna liczba nieudanych prób logowania`,
"label.processsetting.complete.enable":`Zakończyć i aktywować`,
"label.marketsea.memberfield":`Pola mogą być licytowane przez członków`,
"label.report.export.format.title":`Format Raporty`,
"label.recycle.execute.title":`Czyszczenie kosza.`,
"label.file.use.most.user":`Użytkownicy z największą ilością wykorzystanej przestrzeni dyskowej`,
"report_type_label_systemReport":`Raporty systemowe`,
"label.customobjects.majorobject":`Obiekt główny`,
"label.file.delete.public.link":`Usuń łącze publiczne`,
"front-epwechat-module-v1-id":`WeCom ID`,
"label.partner.common.roleNum":`Liczba ról`,
"label.sendtonextapprover":`Wysłane do następnego zatwierdzającego`,
"label.notification.tip3":`Załaduj 10 Więcej powiadomień`,
"label.tabpage.placeenterz":`Proszę wejść?`,
"label.mobile.phone.cc.people":`Cc`,
"component_setup_iframe_label_inputurlmemo":`Proszę wpisać adres url strony, która ma zostać zaimportowana.`,
"label.umeng.activity.statuschange":`Status zadania, które przypisałeś do #name został zmieniony na #newstatus`,
"label.step3.restricted.visibility":`Krok 3 Ograniczenie widoczności`,
"label.multilang.datadelete.approvedata":`Rekordy w trakcie zatwierdzania ({0}):`,
"label.reportsSubscription.save":`Zapisz`,
"label.emailobject.template.visibility":`Widoczność`,
"label_partner_step3":`Krok 3 Informacje podstawowe`,
"label.product.across":`Accross Price Books`,
"label.same.analyze.opportunity.name":`Nazwa możliwości`,
"label.chatter.memotel":`Memo-telefon`,
"label.recentview.seloption2":`Ostatnio utworzone`,
"label.ccchat.message.search.desc1":`Nie udało nam się znaleźć żadnych informacji o`,
"label.reportexport":`Eksport`,
"label.service.gantt.drop.tip":`Odmowa pozwolenia: Nie masz wystarczających uprawnień do działania. Proszę skontaktować się z administratorem.`,
"label.australian.westem.standard.time":`Australian Western Standard Time （Australia）`,
"label.emailobject.email":`E-mail`,
"Homepage_Contract_FieldMissed_DoesntSupport":`W obiekcie umowy nie ma pól "qdrq" i "htje", więc nie można pokazać tych danych.`,
"label.email.cancel.upload.info":`Spowoduje to anulowanie trwającego procesu przesyłania danych.`,
"label.page.copy.merged.field.value":`Kopiuj wartość pola scalania`,
"UG.ST.006":`Wejdź bezpośrednio`,
"label.trigger.service.connot.access":`Niedostępne oświadczenie`,
"label.projectManagement.new.tasks":`Nowe zadanie`,
"lable.SalesCommitmentKanBan.receiptsRate":`Wpływy Stopień realizacji`,
"label.productsales.oppor.overdue":`Zaległe okazje`,
"vue_label_pool_convertedbyme":`Przekształcony przeze mnie`,
"label.loginip.pagecue.invalidt":`Początkowy adres internetowy jest dalej niż końcowy adres internetowy lub nieprawidłowy adres internetowy.`,
"label.campagin.roi.xyzj":`Odpowiedź ogółem`,
"label.visualpage.list.title":`Aktywny dostęp do strony niestandardowej`,
"chatter.feed.searchinitvalue":`Wprowadź nazwę...`,
"label.export_submission":`Eksportuj przesłane dane`,
"this.season":`W tym kwartale`,
"label.forecast.settings.gx":`Udostępnianie danych dotyczących prognoz`,
"label.tag.addtags.tagcolour":`Kolor Tag`,
"label.api":`Nazwa API`,
"label.bulk.delete":`Masowe usuwanie (na stałe)`,
"label.reportsSubscriptionPage.condition.emailoption":`Opcje poczty elektronicznej`,
"vue_label_dashboard_newdashboardsuccessfully":`Pomyślne utworzenie nowego pulpitu nawigacyjnego`,
"three":`Trzy`,
"label.prompt":`Prompt`,
"label.same.analyze.contact.phone":`Mobile`,
"label.icon.62":`Rurociąg`,
"label.forecast.shrepage.tableth.isnable":`Zezwalaj na wysyłanie`,
"label.multilang.polloption.vote":`{0} bilet(y)`,
"label.customfields.totalsummary.selecttotaltype":`Wybierz typ zwijania`,
"lable.SalesCommitmentKanBan.receivingCommitmentRate":`Wpływy Wskaźnik zobowiązań`,
"label.areaAndSub":`Terytorium i podterytorium`,
"vue_label_pool_recycle":`Recykling`,
"lable.outlook.detail.synset":`Ustawienia synchronizacji`,
"label.quote.detail.introduce":`Wprowadź słowa kluczowe, kliknij "Szukaj", aby wyszukać, po zakończeniu wyszukiwania kliknij "Wybierz", aby przejść do następnego kroku.`,
"label.profile.customappset":`Własne ustawienia aplikacji`,
"label.changemylanguage":`Zmiana języka`,
"message.approval.plzcapppor":`Wybierz zatwierdzającego`,
"vue_label_pool_operatecertification2":`{0}{1}{2}{3}？`,
"label.publiccalendarandresource":`Publiczne kalendarze i zasoby`,
"label.wtd.changefields.title.desc1":`Wybierz pola, które mają być zawarte w formularzu Web-to-CloudCC, wprowadź określony URL zwrotny, a następnie kliknij przycisk "Generuj".`,
"label.weixin.voting.not.empty":`Opcje głosowania nie mogą być puste`,
"label.campaign.channel.equal":`Równe`,
"label.emailobject.emaildetail.button.back":`Powrót`,
"label.ccchat.person.invite.allowemails":`Dla bezpieczeństwa prosimy o wpisywanie tylko adresu e-mail zakończonego poniższym`,
"label.notEdit.message":`Przepraszamy, nie masz dostępu do edycji tych danych, skontaktuj się z administratorem systemu.`,
"label.layout.selectedfields.relatedlist":`Wybrane pola / Powiązane listy`,
"label.weixin.voting.deadline":`Termin:`,
"label.document.upload":`Plik do wysłania`,
"label.import.page2.notmatchfiled":`Pola {csvfiledlength} w pliku w sumie. Pola {difflength} są niemapowane.`,
"label.data.exp.selzippwd":`Jeśli nie wypełnisz, domyślnie nie ma skompresowanego hasła.`,
"label.user.step2.select.email.template":`Krok 2 Wybierz szablon wiadomości e-mail`,
"label.currency.effective":`Aktywne waluty`,
"label.version.control.type":`Organizacja Wydanie`,
"label.projectManagement.Taskorproblem":`Zadanie/problem`,
"label.everyweek":`Tygodnik`,
"label.passwordPolicy.setup.pwdremember4":`4 zapamiętane hasła`,
"label.emailobject.groupemail":`Email grupy`,
"label.approvepagelayout1":`Wszyscy mają ten sam układ`,
"label.integrations.mailchimp.massage5":`Zaimportuj wybrane leady i kontakty z konta CloudCC do MailChimp i wyślij wiadomość do odpowiednich odbiorców`,
"label.icon.22":`Dodaj do`,
"Dashboard_View_All":`Wszystkie pulpity`,
"label.import.page2.example":`Przykład`,
"label.send.letter":`Wyślij list z zaproszeniem`,
"label.mobilesectionpart":`Część przenośna`,
"component_setup_tabs_label_title":`Stronicowanie zakładek`,
"label.knowledgebase.results":`{a} wyniki`,
"label.field.remark":`Ta strona umożliwia określenie pól, które mogą pojawić się na stronie`,
"vue_label_systemSettings_url":`Konfiguracja nazwy domeny`,
"vue_label_SMS_failed_find_view_list":`Nie udało się znaleźć listy widoków`,
"setup_layout_label_order":`Sort By`,
"label.customsetting.touse":`Użyj ustawień niestandardowych`,
"label.product.enter":`Wprowadź słowa kluczowe, aby znaleźć pasujące produkty.`,
"label.email.template.private.SMS":`Ekskluzywny Szablon SMS Folder`,
"vue_label_homepage_chart_deleted":`Wykres lub tablica rozdzielcza zostały usunięte`,
"label.conversion_pages":`Strona konwersji`,
"label.compact.layout.select":`Wybierz kluczowe pola układu informacji`,
"report_label_folderandreport":`Raporty i foldery`,
"label.product.entry":`Cennik`,
"label.campaignmember.main.manageMember":`Zarządzaj Członkami`,
"front-QBtoCC-changing":`Aktualizowanie...`,
"vue_label_pool_abandonreason":`Powód odrzucenia`,
"template.report.customer.contract.statistics":`Umowa Analityka kont`,
"label.invoice.message.sendsuccessully":`Faktura wysłana pomyślnie`,
"label.addcurrentoperate":`Dodaj Exsiting Action`,
"label.customerinfo.mailpwd":`Hasło do skrzynki pocztowej`,
"batch.nochange.owner":`Brak zgody na zmianę właściciela rekordu!`,
"label_tabpage_uploadfailez":`Przesyłanie nie powiodło się, prosimy o ponowne przesłanie.`,
"vue_label_systemSettings_mobelqrsetting":`Konfiguracja skanowania aplikacji mobilnej`,
"label.regular_field":`Forma Domena`,
"label.tabpage.delsuccessz":`Skreślić sukces`,
"label.Days.Before.Horizontal.Date":`poziom data przed`,
"label.evaluation.general":`Ok`,
"chatter.notlike.p":`Przestań lubić ten post`,
"label.chatter.send":`Wyślij`,
"label.emailsync.button.cancel":`Anuluj`,
"label.notification.task4":`Twoje zadanie wygasa dzisiaj`,
"vue_label_helpcenter_detail1.2":`Szybka zmiana statusu zadania: zaznacz pole wyboru przed zadaniem w module "zaległe i nadchodzące" i kliknij przycisk odświeżania, aby szybko zmienić status zadania na "zakończone".<br>Przed odświeżeniem anuluj zaznaczenie, a status zadania nie zmieni się.<br>Zadania o wysokim priorytecie będą oznaczone ikoną "czerwonej flagi" na osi czasu aktywności.<br>Sekwencja wyświetlania osi czasu aktywności<br> Ułóż w odwrotnej kolejności zgodnie z datą wymagalności zadania, datą wymagalności nagranej rozmowy, datą rozpoczęcia zdarzenia, datą wysłania i odebrania wiadomości e-mail oraz datą wysłania i odebrania wiadomości SMS. Jeśli powyższe daty są takie same, zostaną posortowane w kolejności odwrotnej do czasu utworzenia rekordu.<br>?Filtr osi czasu czynności<br> Użyj filtrów na osi czasu zdarzenia, aby zawęzić zakres widocznych elementów, skupić się na ważnych elementach i znaleźć elementy docelowe. Filtr osi czasu obejmuje trzy typy filtrów: zakres daty, czynność do wyświetlenia i typ czynności.<br> Czynności do wyświetlenia: wszystkie czynności, moje czynności<br> W filtrze osi czasu zdarzenia ta opcja pozwala zawęzić zakres wyświetlania zdarzenia.<br> Moje czynności: Pokaż aktywności, w których uczestniczyłeś, czy to jako właściciel, czy uczestnik. Na przykład, jesteś właścicielem, który wysyła wiadomości e-mail lub organizuje wydarzenia. Na przykład, gdy jesteś odbiorcą wiadomości e-mail w polu Cc lub Bcc, oznacza to, że bierzesz udział w wydarzeniu.<br>`,
"component_chatter_post_label_title":`Opublikuj`,
"label.data.dataexptemplate.desc":`Szablon eksportu danych stworzony przez użytkowników jest używany do eksportu danych i może sprawić, że eksport danych będzie wygodniejszy.`,
"label.helptext":`Tekst pomocy`,
"vue_label_norm_removecomponent_certify":`Potwierdź usunięcie elementu`,
"front-template-V1-Click-new-template":`Kliknij "Nowy", aby utworzyć nowy szablon. Aktywuj i zacznij używać tego szablonu`,
"label.optional_fields":`Pola opcjonalne`,
"label.delete_about":`Zamierzasz usunąć`,
"chatter.feed.initvalue":`Nad czym pracujesz?`,
"label.mail.configure":`Skonfiguruj swój osobisty adres e-mail, aby móc wysyłać i odbierać wiadomości na stronie głównej CloudCC, a także synchronizować historię e-maili z leadami i kontaktami.`,
"label.project.hit.seven":`Przypomnienie o wygaśnięciu zadania`,
"label.button.upgrade":`UPGRADE lub ZMIANA EDYCJI`,
"lable.PowerProcess.event.name":`Nazwa kamienia milowego`,
"label.weixin.confirm":`Potwierdź`,
"label.customfields.new.inputformula":`Wprowadź wzór`,
"label.standard.buttonandlink.edit":`Zastąp standardowe przyciski lub łącza`,
"workflow.action.tasks.assignortype.createdtype":`Typ twórcy`,
"front-email-payment-paypal-describe":`Kliknij "Kontynuuj", możesz zalogować się do witryny PayPal lub utworzyć konto PayPal, aby zakończyć płatność za fakturę.`,
"label.selectexistingoperate":`Wybierz istniejące działania`,
"label.workflow":`Przepływ pracy`,
"label.assignment.setup.detail.ruleentries":`Zapisy zasad`,
"label.data.file.i.title.num3":`3.System wstępnie wczytuje plik z danymi na serwer, następnie uruchamia back-endowy mass importer, o którego wynikach użytkownicy zostaną powiadomieni pocztą, a Ty nie będziesz musiał czekać na tej stronie.`,
"label.use.view":`Wykorzystanie istniejących widoków`,
"label.forecast.settings.moren":`Domyślna rodzina produktów`,
"vue_label_calendar_add_share":`Dodaj udział`,
"label_tabpage_newview":`Tworzenie nowego widoku`,
"label.recycle":`Kosz na śmieci`,
"UG_solution_03":`Stwórz rozwiązanie`,
"label.customfields.formula.text.tip":`Utwórz ciąg tekstowy, na przykład przez połączenie innych pól tekstowych.`,
"vue_label_file_single_file_size":`Maksymalna obsługa pojedynczego pliku`,
"label.a.b.least":`Każdy rekord "A" musi mieć co najmniej jeden powiązany rekord "B".`,
"label.validate.function.addtoformula":`Wstaw wybraną funkcję`,
"label_tabpage_pleaseSelectz":`Proszę wybrać`,
"label.account.NextFQ":`Następny FQ`,
"label.project.project.name":`Nazwa projektu nie może się powtarzać.`,
"label.emailtocloudcc.filed.owner":`Właściciel`,
"label.textmessage.template.message2":`Pole wstawione w bieżącej wiadomości e-mail nie pasuje do powiązanego rekordu, co może powodować wartości null.`,
"label.icon.92":`Książka`,
"label.trailerpage":`Strona ogonowa`,
"component_event_label_noevent":`Wygląda na to, że zakończyłeś swoją dzisiejszą pracę.`,
"label.trigger.tip":`O wyzwalaczach`,
"label.knowledge.case.field.usable":`Dostępne pola sprawy`,
"label.group.isusing.success":`Aktywuj z powodzeniem`,
"label.marketsea.nextnotfollowdays":`Od ostatniego badania kontrolnego`,
"component.todaytask.label.choicestate":`Wybierz status`,
"label.recordtype.main":`-Master--`,
"label.sendletter.step1":`Krok 1: Określenie odbiorców zaproszenia`,
"label_tabpage_saveviewfailed":`Nie udało się zapisać widoku`,
"vue_label_report_notiec_selectone":`Każdy rekord obiektu nadrzędnego musi mieć co najmniej jeden rekord obiektu powiązanego`,
"UG_opportunity_003":`Śledź kanały sprzedaży, twórz pulpity`,
"#label.importsourcestep4":`Krok 4 Importuj swoje pliki#`,
"front-kefu-moudle-v1-trrt-tip":`Aby uzyskać funkcję "Click to Dial", należy powiązać użytkowników (pracowników obsługi klienta) z numerami wewnętrznymi TRRT.`,
"UG.Forcast.09":`Następny krok`,
"label.ggReleaseRange.subordinates":`Wyszukaj rolę i podwładnego`,
"label.log.desctiption":`Możesz pobrać ślad audytu, który zawiera więcej informacji (plik Excel.csv).`,
"label.submitted":`Zgłoszony`,
"label.validate.function.funcExplain.BEGINS":`Sprawdza, czy tekst zaczyna się od podanych znaków i jeśli tak zwraca TRUE, w przeciwnym razie zwraca FALSE.`,
"label.campaign.channel.code":`Kanał marketingowy Kod QR`,
"chatter.group.theLastActivityDate":`Data ostatniej czynności`,
"vue_label_dashboard_pleaseenterabreakpoint2value":`Proszę wprowadzić wartość punktu przerwania 2`,
"label.labeltranslation":`Etykieta Przetłumacz`,
"label.multilang.product.deleterederect":`Twoje usunięcie {0} nie mogło zostać zakończone, ponieważ jest ono nadal powiązane z rekordami w innych księgach cen. Powiązany rekord jest następujący.`,
"lable.currencyManage.manageRate.dis":`Aby zarządzać kursami wymiany dla innych obiektów, dodawać nowe waluty, aktywować lub dezaktywować waluty lub zmienić walutę korporacyjną, należy kliknąć Zarządzaj walutami.`,
"setup.layout.label.modifypage":`Edytuj układ strony`,
"label.import.page2.editforname":`Proszę zmodyfikować mapowanie dla pola {necessaryName} .`,
"label.searchlayout":`Układy wyszukiwania`,
"label.chatter.loadmore":`Załaduj więcej`,
"label.trigger.folder.all":`Wszystkie foldery z wyzwalaczami`,
"label.export_submissions":`Eksport wysyłanych formularzy`,
"lable.SalesCommitmentKanBan.allsignedTaskRate":`Całkowity podpisany wskaźnik wykonania zadania`,
"KeyInformationLayout_DefaultLayout_Name":`Domyślne ustawienia systemu`,
"label.h5.chatter.great":`jak(i)`,
"label.call.center.configuration.enable":`Aby włączyć funkcję połączeń z centrum organizacyjnym, należy użyć następujących ustawień`,
"label.overdate":`Data końcowa`,
"chatter.poll":`Sondaż`,
"label.login.input.verification.code":`Proszę wprowadzić kod bezpieczeństwa:`,
"label.file.sharetype.cooperation":`Współpracownik`,
"label.app.step5":`Krok 5 Przypisanie do profili`,
"front-gantt-module-save-order":`Zapisz zamówienie`,
"label.globalselect.toallrecord":`Dodaj nowe wartości listy opcji do wszystkich typów rekordów, które używają tego globalnego zestawu wartości`,
"setup.mainpage.label.welcome24":`Platforma chmurowa CloudCC zapewnia ustawienia bezpieczeństwa dostępu dla wszystkich danych obiektów w systemie. Współdzielenie danych i prawa dostępu mogą być kontrolowane poprzez ustalanie różnych reguł i warunków.`,
"homepage.layout.desctiption":`Ta strona umożliwia tworzenie różnych układów zakładek dla karty głównej.`,
"vue_label_SMS_notice_send_sussess":`Wysłane SMS-y`,
"label.projectManagement.overdue":`Zaległe`,
"label.assignment.setup.list.lead.description":`Automatycznie przypisuj leady do użytkowników na podstawie zdefiniowanych przez Ciebie reguł przypisywania leadów. Możesz tworzyć wiele reguł z różnymi warunkami.`,
"label.list.projectSetting.des":`Czy chcesz wysyłać e-maile zgodnie z poniższymi ustawieniami:`,
"setup.mainpage.label.welcome18":`Ustawienia uprawnień w CloudCC pozwalają kontrolować prawa poszczególnych użytkowników do korzystania z danych i modułów. Ustawienia uprawnień oparte na rolach obejmują również pozycje użytkowników, grupy, role, zasady udostępniania danych i kontrole bezpieczeństwa na poziomie pola, aby umożliwić współdzielenie danych między różnymi osobami i działami przedsiębiorstwa.`,
"label.ratio":`r/r i m/m`,
"label.Xaxis":`Oś X`,
"label.google.map":`Google Map`,
"Dashboard.SelectBoardToDisplay":`Proszę wybrać pulpity, które mają być wyświetlane w zakładce dashborad`,
"label.data.newtemplate.e_conditions":`Warunki wywozu`,
"label.emailtocloudcc.description3":`Podłącz swoje firmowe konto e-mail, takie jak sales@company.com, info@company.com, support@company.com. Automatycznie rejestruj otrzymane wiadomości e-mail jako leady i rekordy spraw w CloudCC, aby zapewnić terminowe śledzenie listów od klientów.`,
"label.page.select.profile":`Wybierz profile użytkowników, dla których będzie dostępna nowa karta niestandardowa. Możesz również sprawdzić lub zmienić widoczność zakładek na stronach szczegółów i edycji każdego profilu.`,
"label.chosen.button":`Wybrane przyciski`,
"front-epwechat-module-v1-info":`Informacje backend o WeCom`,
"label.translation.select":`Kryteria filtrowania`,
"ten":`Dziesięć`,
"label.barcode":`Kod kreskowy`,
"lable.product.nextdel":`Kontynuuj i usuń wyświetlony rekord， lub kliknij przycisk`,
"label.default":`Domyślnie`,
"label.chatter.theme":`Tematy`,
"vue_label_commonobjects_view_split_screen_view":`Widok podzielonego ekranu`,
"label.ems.myemails":`Moje e-maile`,
"label.email.clearPersonalEmail":`Czy chcesz opróżnić wszystkie e-maile zsynchronizowane z osobistą skrzynką e-mail?`,
"label.login.access.admin":`Administrator Twojej firmy`,
"label.emailobject.wizard.desc":`Po podłączeniu konta email w CloudCC można wysyłać wiadomości email bezpośrednio z CloudCC, automatycznie łącząc je z powiązanymi z nimi leadami, kontaktami i szansami. Historia komunikacji jest przejrzyście uporządkowana według osi czasu.`,
"label.passwordPolicy.setup.minpwdlength":`Minimalna długość hasła`,
"choserow":`Wybór kolumn do wyświetlenia`,
"front-epwechat-module-v1-role-binding":`Role Wiązanie`,
"lable.outlook.edit.newdata":`Ma najstarszą datę utworzenia`,
"label.schedulejob.setup.schedule.enddate":`Data końcowa`,
"label.quickbooks.view":`Zobacz`,
"font-evaluate-module-v1-not-inform":`Brak zgłoszenia`,
"chatter.poll.option3":`Wybór 3`,
"setup_layout_label_selectfield":`Wybierz pola`,
"label.partner.common.roleSetup":`Ustawienia roli partnera i użytkownika`,
"label_partner_new_step3":`Krok 3 wprowadź nazwę i adres url`,
"label.transfer":`Transfer`,
"label.bmap.myaddress":`Moja lokalizacja`,
"label_tabpage_individual":`Wybór indywidualny`,
"label.autoRegister.changepwd.setpwd.repassword":`Proszę ponownie wprowadzić hasło.`,
"vue_label_commonobjects_detail_and_before":`Wcześniej`,
"front-kefu-moudle-v1-single-Login-area":`Nazwa domeny z pojedynczym logowaniem`,
"label.replacedocument":`Zastąpić dokument`,
"label.validate.function.category.Logical":`Logika`,
"label.companyprofile.syncsuccess":`Synchronizacja zakończona sukcesem`,
"template.chart.rwzthyxj":`Temat i priorytet zadania`,
"label.product.clearcondition":`Jasne warunki`,
"component_task_label_person":`* Osoba przydzielona`,
"label.tabpage.as":`Jak`,
"message.error.calendar.add":`Kalendarz został już dodany`,
"label.marketsea.isrecycleleadcreatebyself":`Czy chcesz poddać recyklingowi samodzielnie zbudowane leady`,
"label.icon.57":`Barometr`,
"UG.Lead.010":`Lub`,
"setup_object_field_dependency_label_configured":`Układy stron przypisane do profilu`,
"label.tianyancha.regnumber":`Kod zarejestrowany`,
"front-kefu-moudle-v1-Opened-chats":`Włącz czat`,
"label_tabpage_converstatez":`Stan przekształcony`,
"label.bmap.beijing.haidianqu":`Shangdi 10 Street, Haidian District, Beijing`,
"label.startimport":`Rozpocznij import`,
"label.knowledgebase.application.default.settings":`Domyślne ustawienia aplikacji Lightning`,
"lable.account.year.custom":`Niestandardowe lata podatkowe`,
"label.event.nextmonth":`Następny miesiąc`,
"label.email.body":`Body`,
"setup.object.field.dependency.label.mustsetup":`Proszę najpierw ustawić zależność od pola i zapisać.`,
"label_tabpage_multiple":`Wybór wielokrotny`,
"label.task.this.month":`W tym miesiącu`,
"label.customfields.formula.moneyexample":`Marża brutto = Kwota - Koszt__c`,
"label.tonewemailnotice":`Wybrać obiekt dla tego zadania i kliknąć Dalej. Zadania mogą być kojarzone tylko z regułami przepływu pracy i procesami zatwierdzania tego samego typu.`,
"setup.mainpage.label.welcome11":`Raport niestandardowy`,
"label.layout.availabletab":`Dostępne zakładki`,
"label.data.importef":`Nieudany import plików`,
"label.appupload.upload.alert":`Proszę podać szczegóły dotyczące tego pakietu przed wysłaniem. Te ustawienia określają, jakie wymagania muszą być spełnione, aby zainstalować ten pakiet.`,
"label.sales.accountteam.shared":`Account Team Sharing`,
"lable.currency.addexchageRate":`Dodaj kursy wymiany`,
"label.page.simplified.chinese":`chiński (uproszczony)`,
"label.service.dispatchingUnits.search.service.area":`Wyszukaj obszar usług`,
"lable.list.queue.name":`Nazwa kolejki`,
"pagecreator.button.save":`Zapisz`,
"label.ccpeak.support.function":`Obsługa wszystkich rodzajów funkcji w jednym formularzu`,
"label.tianyancha.legalpersonid":`Identyfikator osoby prawnej`,
"label.sendemail.chat.addPostmainPage":`Drogi #name:witaj! #userName umieszcza posty na Twojej stronie głównej CCChat.`,
"batch.no.change":`Brak uprawnień do przesyłania danych.`,
"label.the.referenced":`wywoływany w`,
"label.input.webtab.information":`Wypełnij informacje o karcie sieciowej.`,
"vue_label_systemSettings_subscription":`Typ subskrypcji`,
"label.login.access.title":`Przyznanie dostępu do konta`,
"label.schedulejob.setup.schedule.lastday":`ostatni dzień`,
"label.synchronize.department":`Synchronizuj użytkowników`,
"label_tabpage_lessequalz":`Mniej niż lub równa`,
"label.file.library.successmanagemember":`Zapisano pomyślnie`,
"label.service.major.event.oreder":`Sekwencja`,
"label.desktopintegration":`Integracja z pulpitem`,
"label.a_b":`Relacja A do B`,
"every":`Każdy`,
"label.tabpage.bar":`Bar`,
"label.filecontentsnotnull":`Zawartość pliku nie może być pusta.`,
"label.layout.detailoftestobj":`Szczegóły dotyczące obiektu testowego`,
"label.summaryreport.2018.step3":`Krok 3 Wybierz nagłówki kolumn`,
"UG.Lead.002":`Istnieje wiele sposobów na identyfikację "leadów" dla Twojego produktu lub usługi.`,
"label_partner_workspace_member_selectedprofile":`Wybrany profil`,
"label.newdescription":`Nowa uwaga`,
"vue_label_normal_moveup":`Przesunąć się w górę`,
"label.mobile.quickcreate.default.logacall":`Historia połączeń`,
"userterritory.serviceterritory.user.unique":`Ten użytkownik ma już przypisany ten obszar usług. Proszę nie dokonywać ponownego przypisania.`,
"label.weixin.record":`Zapis`,
"front-kefu-moudle-connecting":`Podłączenie`,
"label.monitorsys.recent.operation.log":`Dziennik ostatnich operacji`,
"lable.outlook.detail.lmaping":`Mapa Pola ołowiu`,
"lable.account.year.ovdate":`Data zakończenia roku podatkowego`,
"vue.homepage.auditcard.record":`{recordTotal} records`,
"label.processsetting.delete.process.succeeded":`Usuń proces pomyślnie!`,
"label.customerinfo.smsPwd":`Hasło bramy SMS`,
"label.tolead.object":`Importuj obiekty`,
"label.data.downpage.i.list.desc2":`Po zaimportowaniu danych otrzymasz e-mail przypominający o pomyślnym zaimportowaniu danych.`,
"label.sharerule.ruletype":`Typ przepisu`,
"label.reportsSubscriptionPage.email.toothers":`Wyślij do mnie i określonych grup użytkowników`,
"label.emailobject.templates":`Szablony`,
"vue_label_checkduplicate_":`Analiza kolizji`,
"label.campaign.channel.lookup.example":`Zobacz próbkę`,
"label.login.verification.please.note":`Proszę zwrócić uwagę:`,
"label.version.charge":`Opłata`,
"label.ccdocument.show.trace":`Pokaż ślad`,
"label.sendemail.approval.submit":`Witam, #name:\N #actorname the #objLabel-#recordname submitted by #actordate is waiting for your approval. please click the following link or log in the crm system to enter the approval center for approval:\n #path#appPath/query.action?id=#recordid&m=query\n#orgName`,
"setup.mainpage.label.welcome12":`Użytkownik może dokończyć definicję raportu klikając myszką, bez programowania, i postępując zgodnie z instrukcjami systemu. System ma do wyboru raport listy, raport podsumowujący i raport macierzowy. Dostępne są również opcje wyświetlania dla wszystkich pól. Usuń niepotrzebne informacje z pola. W tym samym czasie, zapewnia on różnorodne wyświetlacze graficzne, w tym paski, linie zagięcia, pierścienie, lejki i torty, dzięki czemu użytkownicy mogą zobaczyć na pierwszy rzut oka.`,
"UG_contact_06":`Importuj kontakty`,
"message.success.event.add":`Pomyślne zapisanie informacji o nowym wydarzeniu`,
"report.line":`Pole danych`,
"label.approvepagelayout2":`Każdy ma inny układ`,
"vue_label_normal_contract_sf":`Umowa`,
"label.tabpage.tpcustomersz":`Konwersja leadów`,
"label.ccchat.message.new.error5":`Błąd, Twoja wiadomość nie może przekroczyć 10000 znaków.`,
"label.severalorone":`Indywidualne akta`,
"pagecreator_systemstyle_label_buttonfontcolor":`Tekst przycisku`,
"label.customer.tab.step3.introduce":`Wybierz aplikacje niestandardowe, dla których będzie dostępna nowa karta niestandardowa. Możesz również sprawdzić lub zmienić widoczność kart na stronach szczegółów i edycji każdej aplikacji niestandardowej.`,
"chatter.group.groupEdit":`Grupa Edytuj`,
"label.partnerCloud.partnerAccount.spending":`Wydatki z tytułu rabatu`,
"label.slip":`przedmiot)`,
"label.field.master.class":`Poziom relacji główny - szczegółowy jest powyżej poziomu 3`,
"label.sendemail.chat.addComentsmyFeed":`Drogi #name:witaj! #userName odpowiedział na Twój mikropost.`,
"label.service.ganttBaiduMap.selectingDispatchTime":`Wybierz przedział czasu wysyłki`,
"label.knowledgebase.remove.article":`Czy na pewno chcesz usunąć artykuł z archiwum?`,
"label.appupload.notmanaged":`Niekontrolowane`,
"label.report.goto.step":`Przejdź do kroku`,
"label.publicgroup.save.mustbeselect":`Należy wybrać członków`,
"label.data.expnode.e.desc2":`2、Eksport według szablonu: użytkownicy mogą wybrać szablon do eksportu danych.`,
"UG.product.02":`Produkty odnoszą się do produktów lub usług, które są sprzedawane lub kupowane.`,
"label.sendemailtouser":`Czy na pewno chcesz wysłać email do wybranych użytkowników?`,
"label.knowledge.setting.hint.nine":`Jeśli nie wiesz, w jaki sposób wiedza ta przyniesie Ci korzyści? Posortuj podobne artykuły jako jedyną kategorię danych i skumuluj do szerszej kategorii. Teraz dodajmy kategorię danych. Więcej kategorii możesz dodać później.`,
"front-asset-module-v1-view-asset-bom":`Wyświetlanie BOM aktywów`,
"label_partner_all_enable":`Włącz`,
"label.processsetting.disable.process.successfully":`Pomyślne wyłączenie procesu`,
"label.call.center.enable":`Włącz Call Center`,
"message.recordtype.applyitseparatly":`Zastosuj inny układ strony dla każdego profilu.`,
"label.weixin.report.customize":`Dostosuj`,
"label.file.mongdb.file.is.not.exist":`Plik nie istnieje`,
"label.chat.edit.topics":`Edytuj temat`,
"label.knowledge.delete.searchterm":`Błąd podczas usuwania promowanego terminu wyszukiwania`,
"label_emailtocloudcc_redmessage3":`Proszę wprowadzić adres serwera`,
"use":`Użyj`,
"label.batchtransfer.transferfrom":`Przeniesienie z`,
"label.recycle.my":`Mój kosz na śmieci`,
"label_json_string_null":`Puste`,
"label.version.lookupfield":`Pole relacji Lookup`,
"lable.tianyancha.h5.searchf":`Nie znaleziono`,
"label.validate.globalvariable.description":`$User.[Field API] eg: $User.id <br>Wartości, których możesz użyć to: id,name,roleId,roleName,profileId,profileName,department,title,email`,
"UG.opportunity.006":`Geniusz możliwości`,
"label.applt.copy":`Klonowanie jednym dotknięciem`,
"chatter.emailMessageOrReply":`Posty lub komentarze do moich postów`,
"label.newreport.self":`Wybrane pola`,
"label.visualpage.checkpinxie":`Proszę sprawdzić pisownię strony.`,
"label.knowledgebase.article.attaching.case":`Artykuł {name} został dołączony do sprawy!`,
"label.dialogbox":`Okno dialogowe`,
"label.summaryreport.step3.new":`Krok 3 Wybierz dane do podsumowania`,
"label.confirm":`Potwierdź`,
"label.mobile.buttom.team":`Zespół`,
"label.quickbooks.action.link":`Link`,
"vue_label_commonobjects_view_support_to_datas":`Operacja obsługuje do 10 danych`,
"vue_label_helpcenter_homepage":`Każdy użytkownik ma od początku dwie strony główne, standardową stronę główną i osobistą stronę główną. Administrator może przypisać użytkownikowi odpowiednią profilową stronę główną zgodnie z jego profilem. Należy pamiętać, że strona główna wersji Lightning i strona główna starej wersji nie są kompatybilne.<br> 1. Standardowa strona główna<br> Zawartość standardowej strony głównej jest jednolita i nieedytowalna. W tym komponent wyników kwartalnych, ostatnio oglądany komponent, komponent centrum zatwierdzania, komponent dzisiejszego wydarzenia, komponent zadań, komponent zaległych możliwości biznesowych, komponent możliwości biznesowych poza 30 dniami i komponent nadchodzących możliwości biznesowych<br> Kwartalny komponent wyników: każdy może ustawić własne cele kwartalne<br> Ostatnio oglądany komponent: Wyświetl 10 ostatnio oglądanych rekordów obiektów<br> Komponent 30-dniowych okazji biznesowych bez kontaktu: Pokaż 5 okazji biznesowych, których dni braku kontaktu są większe niż 30 dni, a prawdopodobieństwo nie wynosi 0 lub 100<br> 2. Osobista strona startowa<br> Każdy ma osobistą stronę startową, a zawartość osobistej strony startowej można dostosować, dodając lub usuwając komponenty, lub metodą przeciągnij i upuść dostosować położenie i rozmiar komponentów<br> Podczas otwierania konta na osobistej stronie startowej domyślnie będą dostępne: komponent odprawy, komponent centrum zatwierdzania, komponent zaległych możliwości biznesowych i komponent nadchodzących możliwości biznesowych<br> Osobista strona startowa umożliwia wyświetlanie do 15 komponentów<br> 3. Strona główna profilu<br> Administratorzy mogą tworzyć/edytować/usuwać strony główne profilu, dostosowując stronę główną, i mogą przypisać różne strony główne do różnych profili, tak aby użytkownicy o różnych profilach mogli widzieć różne strony główne<br> Do 15 komponentów na stronę główną profilu<br> 4. Dodawanie komponentów<br> Osobistą stronę główną i stronę główną profilu można dostosować, aby dodać komponenty, można dodać komponenty tablicy rozdzielczej, komponenty wykresu tablicy rozdzielczej i komponenty widoku karty<br> Komponent tablicy rozdzielczej: dodaj całą tablicę rozdzielczą w systemie do strony głównej. Liczba podkomponentów w tablicy rozdzielczej reprezentuje, ile komponentów zajmuje komponent tablicy rozdzielczej (strona główna obsługuje do 15 komponentów), a dane komponentu tablicy rozdzielczej po dodaniu nie będą powiązane z oryginalną tablicą rozdzielczą (to znaczy, jeśli oryginalna tablica rozdzielcza zostanie usunięta, komponent tablicy rozdzielczej może nadal działać) <br> Komponent wykresu w tablicy rozdzielczej: Możesz dodać określony komponent wykresu w tablicy rozdzielczej w systemie do strony głównej, a funkcja powiązania komponentu będzie nieważna w tym czasie<br> Komponent widoku karty: Można wybrać dodanie określonego widoku obiektu jako źródła danych do strony głównej, a pola i elementy operacji można dostosować. Należy jednak pamiętać, że jeśli widok źródła danych widoku karty zostanie usunięty, widok karty nie będzie miał żadnych danych.`,
"label.usersandlimit":`Użytkownicy i uprawnienia`,
"label.sendmail.step3.introduce2":`odbiorca(y) wybrany(i) do otrzymania tej wiadomości e-mail.`,
"label.setupcustomfield":`Pola niestandardowe`,
"label.layout.last.notdel":`Ostatni z nich nie ma możliwości usunięcia układu.`,
"label.emailtocloudcc.redmessage7":`Błąd konfiguracji, proszę skontaktować się z administratorem.`,
"label.includedIn":`Zawarte w {parentproductname}`,
"label.permission.detail.app.pagesetting":`Własne ustawienia strony`,
"label.addfile.tips":`Wybrano {selectedNum} plików. Jednorazowo można dodać do {originNum} plików.`,
"label.fieldinformation":`Szczegóły dotyczące pola`,
"label.campagin.roi.sjcb":`Koszt rzeczywisty`,
"label.email.all.works.company":`Wszyscy współpracownicy firmy`,
"label.currencyDesc":`Użyj tej strony, aby zdefiniować wszystkie waluty używane przez Twoją organizację. Waluta korporacyjna powinna być ustawiona na walutę, w której centrala Twojej firmy raportuje przychody. Jeśli jako waluta korporacyjna zostanie wybrana inna waluta, wszystkie kursy przeliczeniowe zostaną zmodyfikowane, aby odzwierciedlić tę zmianę.`,
"label.file.details":`Szczegóły`,
"label.foldervisitlimit3":`Tylko następujący użytkownicy mogą mieć dostęp do tego folderu:`,
"label.account.next.M":`Następny miesiąc`,
"label.oweralias":`Alias właściciela`,
"label.projectManagement.entryname":`Nazwa projektu`,
"label.customcomponent.page.add.title1":`Informacje o komponentach`,
"label.projectManagement.PleaseenterCreator":`Proszę podać twórcę`,
"label.multipleactivity.memberselected":`Wybrani posłowie`,
"label_chatter_memotel":`Memo-telefon`,
"lable.Confirm.customers":`Potwierdź, aby odzyskać {num} przewodów.`,
"front-email-payment-Invoice-number":`Nr faktury.`,
"label.not.appoint.validation":`Nie określono obiektów dla reguły walidacji, proszę określić.`,
"label.peru.time":`Peru Czas`,
"label.setting.intergrationlist.status3":`Wymagane logowanie do QuickBooks`,
"vue_label_display_number_field":`Pokaż pola numeryczne`,
"label_productline_count":`Seria produktów Ilość`,
"label.data.downpage.i_title.num2":`2. Przed rozpoczęciem importu upewnij się, że nazwa pola w pliku, który chcesz zaimportować jest zgodna z nazwą pola obiektu w CloudCC.`,
"label.field.duplicate4":`Traktuj "ABC" i "abc" jako różne wartości __(wielkość liter ma znaczenie)`,
"message.approval.step.validation.invalid.levels":`Co najmniej 1 poziom`,
"label.tianyancha.businessverify.step1":`Włącz weryfikację danych biznesowych krok 1`,
"label.hidedetail":`Ukryj szczegóły`,
"UG_Lead_009":`Historia połączeń APP`,
"label.partnerCloud.newProductSeries":`Nowa rodzina produktów`,
"label.brief.opportunities":`Ogółem`,
"label.user.mfa.unbind.remind":`Zamierzasz odblokować MFA dla wybranych użytkowników i musisz ponownie przypisać urządzenie MFA po następnym logowaniu, czy jesteś pewien?`,
"vue_label_report_grouprow":`Rząd grupy`,
"setup.layout.label.newarea":`Nowy obszar`,
"label.nostart":`Nie rozpoczęto`,
"UG_Lead_010":`Lub`,
"label.emailmerge.mergepage.record.requeired":`Proszę wybrać rekordy, które mają zostać połączone.`,
"label.appointmentpage.wizard.notif1btn1":`Potwierdź`,
"UG.Account.02":`Niektóre firmy świadczą usługi innym firmom, inne współpracują bezpośrednio z użytkownikami końcowymi, a jeszcze inne służą organizacjom pozarządowym.`,
"label.address.country":`Kraj`,
"label.userinfo.updatepwd":`Zmiana hasła`,
"label.salescloud.teamrole.optionlist.opportunity":`Dodaj członka zespołu ds. możliwości do`,
"lable.account.Current.FY":`Bieżący rok budżetowy`,
"chatter.coll.p":`Zapisz ten post`,
"label.setupsms":`SMS`,
"label.atlantic.daylight.time":`Czas letni atlantycki`,
"label.recordslock":`Blokada zapisu`,
"button_partner_search":`Zapytaj`,
"vue_label_salesfunnel_notice4":`Ilość możliwości biznesowych o prawdopodobieństwie 1% - 99%`,
"vue_label_report_statistics":`Statystyki`,
"label.ccchat.notmember.active.group0":`Nie jesteś członkiem żadnej grupy aktywności z {0} w nazwie`,
"label.tag.manage.newtag":`Nowa metka`,
"label.customfileds.formula.dateandtime.tip":`Obliczanie daty/czasu, na przykład przez dodanie liczby godzin lub dni do innej daty/czasu.`,
"label.weixin.mobile.fly.ios":`Udostępnianie z urządzenia mobilnego (IOS)`,
"vue_label_file_over_file_size":`Rozmiar pliku file.name  'przekracza wstępne ustawienie systemowe!`,
"label.schedulejob.setup.schedule.last":`ostatni`,
"label.ccchat.whose.name.contains":`każdej aktywnej grupy, której nazwa zawiera`,
"label.project.milestone.name":`Nie można mieć dwóch kamieni milowych o tej samej nazwie w jednym projekcie.`,
"message.passwordPolicy.validate.reuse":`Błąd: Nie można ponownie użyć tego starego hasła.`,
"label.stdashbord.xsld.business.img3":`Ilość prawdopodobieństwa 1%-99% * Prawdopodobieństwo`,
"label.event.view.list":`Wyświetl listę`,
"label.workflow.ruletriggertime":`Czas wyzwalania reguły`,
"label.campaign.channel":`Kanały marketingowe`,
"label.appexchange.emailnotice":`Alert e-mail o przepływie pracy`,
"label.icon.77":`Rolnictwo`,
"label.visualpage.display.value":`Wprowadź wartości, które mają być wyświetlane i zwróć uwagę, że nie ma spacji przed ani po nich.`,
"label.forecast.customforecast.type.user":`Przez użytkownika`,
"label_tabpage_lessz":`Mniej niż`,
"label.same.analyze.contact.email":`E-mail`,
"vue_label_report_range":`zakres`,
"lable.product.pricebooks.nr":`Możesz sklonować zawartość z istniejących książek cenowych wybierając z poniższej listy.`,
"label_mobile_buttom_team_setUp":`Ustawienia zespołu`,
"label.email.bcc.recipients":`Odbiorcy Bcc`,
"vue_label_ccchat_notice_deletepostfail":`Nie udało się usunąć postu`,
"label_file_type":`Typ pliku`,
"label.multilang.feedtrack.operateupdate":`Rekord {0} został zmodyfikowany：`,
"label.contractmanager":`Kierownik kontraktu`,
"front-gantt-module-drag-one-task-sorting":`Zadania mogą być sortowane tylko w obrębie tego samego kamienia milowego!`,
"label.partner.step2":`Krok 2 potwierdzenie szablonu`,
"front-epwechat-module-v1-again-binding":`Rebind`,
"label.service.miniProgram.imageSize":`Nie można załadować więcej niż 2MB zdjęcia!`,
"setup_main2018_label_managesetup":`Ustawienia administracyjne`,
"component_salesperformance_label_nopermission":`Aby wyświetlić dane związane z możliwościami biznesowymi, należy skontaktować się z administratorem systemu.`,
"lable.account.stadate":`Kwartał fiskalny Data rozpoczęcia`,
"label.service.gantt.and.resourcestype":`a typ zasobu to`,
"label.ems.attachfiles":`Dodaj załącznik`,
"label.data.expnode.e.desc1":`1、 Custom Export: użytkownicy mogą wybrać pola do eksportu i ustawić warunki filtrowania według własnych potrzeb.`,
"vue_label_systemSettings_analyse":`Przeanalizuj stronę`,
"label.project.all.date":`Data końcowa musi być późniejsza lub równa dacie początkowej!`,
"vue_label_commonobjects_view_summary_basis":`Podstawa agregacji`,
"template.chart.yywjhdschd":`Kampanie z szansami`,
"vue_label_pool_notmeet":`Nie spełnia wymagań klienta`,
"label.attendance.manager":`Zarządzaj frekwencją`,
"vue_labenl_normal_current":`Aktualna strona`,
"label.projectManagement.completed.quantity":`Zakończenie Ilość`,
"label.layout.testfield":`Pola testowe`,
"label.customfields.selectcontainrelatelistlayout":`Wybierz układy stron, które powinny zawierać tę listę powiązaną`,
"label.fiji.time":`Czas Fidżi`,
"message.error.domain.already.exists":`Nazwa domeny już istnieje.`,
"label.accountandcontact":`Konta/Kontakty`,
"label.dashboardSetup.right":`Prawo`,
"label.view.appliedMobile.xgry":`Zaznaczenie tej pozycji spowoduje, że odpowiedni użytkownicy będą mogli zobaczyć widok na stronie głównej.`,
"label.file.share.all":`Każdy użytkownik w Twojej firmie`,
"vue_label_pool_summary":`Łącznie {0} rekordów, odświeżone o {1}.`,
"label.emailtemplate.new":`Nowy szablon wiadomości e-mail`,
"label.tag.manage.button1":`Utwórz nowy tag`,
"label.data.exp.tempexppage":`Strona szablonu eksportu danych`,
"font-trade-module-v1-invoice-total":`Całkowita kwota faktury`,
"label.folder.sort":`Sortuj folder`,
"label.multilang.campaign.countnum":`{0} czas(s)`,
"label.homepagelayout":`Układy strony głównej`,
"setup_layout_button_cancel":`Anuluj`,
"lable.Search.in.QuickBook":`Wyszukiwanie w QuickBook`,
"setup_fielddependency_label_pleaseclick":`Kliknij na wartość pola kontrolnego do edycji`,
"setup.fielddependency.label.pleaseclick":`Kliknij na wartość pola kontrolnego do edycji`,
"label.version.sum.field":`pole(-a) własne`,
"label.form.is.submitted.successful":`Komunikat o pomyślnym złożeniu formularza`,
"label.campaignmember.main.batchaddmember":`Masowe dodawanie członków kampanii`,
"label.sendemail.activity.newevent":`Drogi #belongtoidccname, hello:Twój kolega #createbyidccname przydzielił Ci nowe wydarzenie w #createdate, które brzmi następująco:\Ntemat: #subject czas rozpoczęcia: #begintime \r \n end time: #endtime \r \n related items: #relatedstr: treść: #Aby uzyskać więcej szczegółów, odwiedź ten link`,
"label.knowledgebase.select.target":`Proszę wybrać cel`,
"setup.layout.label.buttonlist":`Przyciski wyboru`,
"pagecreator.page.label.pagedesc":`Opis strony`,
"label.version.professional":`Professional Edition`,
"UG.Forcast.10":`Pełny`,
"template.chart.schdyqsr":`Przewidywane przychody z kampanii`,
"front-filter-module-v1-quick-filter":`Filtr błyskowy`,
"label.notification.group2":`Z powodzeniem dołączyłeś do zespołu publicznego`,
"label.ServiceCloud.statistics.by.serviceArea":`Statystyki według terytoriów usług`,
"label.validate.function.funcExplain.TIMENOW":`Zwraca czas reprezentujący bieżącą chwilę`,
"label.brief.lastmonth":`Ostatni miesiąc`,
"label.weixin.member.states":`Status członka`,
"template.chart.ljxsje":`Skumulowana kwota sprzedaży`,
"label.eidt.queue.label.hasused2":`Ta nazwa kolejki już istnieje lub była wcześniej używana.`,
"label.textmessage.nophonenumber":`Ten kontakt nie ma w rejestrze numeru telefonu komórkowego!`,
"label.task.new":`Nowe zadanie`,
"label.tabpage.grid":`Wyświetlanie siatki`,
"label.workbanch.setup.viewname":`Zobacz nazwę`,
"front-gantt-module-temporary-tasks":`Zadanie tymczasowe`,
"label.reportTypeDescripe":`Dzięki niestandardowemu źródłu danych raportów możesz umożliwić użytkownikom tworzenie raportów z predefiniowanych obiektów, relacji między obiektami i pól, które określisz.`,
"setup_layout_label_fieldlist":`Dostępne pola`,
"label.ggReleaseRange.searchforRole":`Rola partnera wyszukiwania`,
"label.datamanage.account.field":`Pola konta`,
"label_tabpage_groupingemptyz":`Elementy grupowania nie mogą być puste`,
"label.permission.edit.insertinfo":`Wprowadź informacje o zestawie uprawnień`,
"label.back_forms":`Powrót do listy formularzy`,
"vue_label_calendar_step_2":`Krok 2: Utwórz kalendarz z obiektu standardowego lub niestandardowego.`,
"lable.outlook.mcto.out":`Domeny wyłączone`,
"label.workflow.accessnext":`Użyj tego procesu zatwierdzania, jeśli`,
"label.data.exp.temppage":`Strona eksportu danych i tworzenia szablonów`,
"label_tabpage_printview":`Widok Wydruku`,
"vue_label_report_preview":`Aby wyświetlić najnowsze edycje, odśwież dla podglądu.`,
"frame_personinfo_label_personimage":`Zdjęcie profilowe`,
"component.chatter.button.like":`Jak`,
"label.ems.drafts":`Projekty`,
"front-lightning-module-v1-details-page-chart-report-name":`Nazwa raportu`,
"label.partner.workspace.login":`Strona logowania`,
"include":`zawiera`,
"label_length_20":`Ograniczenie długości do 20 znaków.`,
"component_event_button_save":`Zapisz`,
"label.weixin.recalculate.shared.success":`Przeliczanie reguł współdzielenia obiektów zakończone sukcesem.`,
"message.duplication.errorinscript.lessthan2":`Musisz wybrać co najmniej dwa rekordy do połączenia.`,
"label_my_forecast":`Moja prognoza`,
"label.ems.to":`Odbiorca`,
"label_mobile_buttom_team_init":`Inicjalizacja użytkownika zespołu`,
"label.sendemail.send.codeerror":`Konwersja kodu nie powiodła się, proszę wprowadzić prawidłowe kodowanie.`,
"lable.quote.syncing.and":`oraz`,
"label.campaignmember.selectmember.step1oftotal":`Krok 1 z 2`,
"label.ems.step3":`Krok 3`,
"lable.PowerProcess.detail.message":`Informacje o procesie kamieni milowych`,
"chatter.poll.option2":`Wybór 2`,
"front-view-module-v12-verify-number":`Błąd formatu liczbowego. Proszę sprawdzić dane wejściowe.`,
"label.setup.mobile.homepageshortcuts.savesuccess":`Ustawienia funkcji Swift zapisane.`,
"lable.outlook.edit.zdyoutfi":`Nazwa pola wymiany niestandardowej`,
"label.assignment.setup.newentries.inputentries":`Wprowadź wpis reguły`,
"label.customfields.money.tip":`Umożliwia użytkownikom wprowadzenie kwoty w dolarach lub innej walucie i automatycznie formatuje pole jako kwotę w walucie. Może to być przydatne w przypadku eksportu danych do Excela lub innego arkusza kalkulacyjnego.`,
"label.service.appointmentList.cancelThePlan":`Anuluj plan`,
"label.chat.topic.suggest.add.topic":`Brak sugestii, dodaj swój własny temat.`,
"vue_label_commonobjects_detail_tips":`Porady`,
"message.error.view.nameexists":`Błąd: Unikalna nazwa widoku już istnieje.`,
"label_emailtocloudcc_step2_name":`Skonfiguruj własność poczty elektronicznej`,
"label.field.validation.apiname":`Musi zaczynać się od litery, zawierać tylko duże i małe litery, cyfry i podkreślenia. Maksymalna długość to 50 znaków, minimalna długość to 2 znaki. Proszę zauważyć, że nie może to być słowo kluczowe bazy danych.`,
"page.field.masterinput.remark2":`Na przykład, gdy tworzysz nowe zamówienie, musisz włączyć tę funkcję, aby wprowadzić pozycje linii zamówienia na tej samej stronie. (cecha ta jest dobrze dostosowana do obiektów w relacji nadrzędny-szczegółowy).`,
"label.rule.enabled.successfully":`Pomyślne włączenie reguł`,
"label.role.createrolelist.tip":`Poniżej znajduje się lista ról dla Twojej organizacji. Możesz zobaczyć więcej informacji klikając na link roli.`,
"label.multilang.datamanage.dataimport.redundantmsg":`Długość tytułu jest &nbsp;{0}&nbsp;, ale długość danych jest &nbsp;{1}&nbsp;, system nie może określić, które &nbsp;{2}&nbsp; pola są zbędne.`,
"label.visualpage.staticresource":`Wprowadzenie zasobu statycznego`,
"chatter.group.members01":`Członkowie`,
"label.planned.workname":`Nazwa stanowiska pracy`,
"label.service.dispatchingUnits.gantt.data":`Dopasuj datę Gantta`,
"label.data.newtemplate.t.conditions":`Szablon Warunki`,
"label.accmarketsea.edit.title":`Edycja puli kont`,
"label_chatter_priority":`Priorytet`,
"label_mobile_buttom_team_open":`Włącz zespół na PC i aplikacjach`,
"front-gantt-module-no-tasks-available":`Brak dostępnych zleceń`,
"component.newrecords.label.type":`Typ przechowywania`,
"label.version.ccdocument.and.remark":`Uwagi i załączniki`,
"label.martrixreport.step2":`Wybierz tryb grupowania używany do obliczania danych, które mają być zwijane`,
"label.projectManagement.Scheduleinformation":`Informacje o rozkładzie jazdy`,
"label.emailmerge.mergeFolder.description":`Na tej stronie możesz utworzyć dokument Microsoft Word zawierający Twoje dane kontaktowe. Proszę wybrać szablony mail merge, do 20.`,
"label.autoRegister.changepwd.setpwd.tip":`Hasło musi spełniać następujące warunki`,
"label.partnerCloud.orderingPlatform.shoppingEmpty":`Koszyk jest pusty, proszę kliknąć "Dodaj produkty", aby dodać.`,
"label.marketcloud_seminar":`Seminarium Marketing Cloud`,
"label.knowledgebase.no.results.knowledge.search":`Brak wyników na temat "{a}" w Wiedzy`,
"label.createdate":`Data utworzenia`,
"vue_label_systemSettings_bazaar":`Rynek`,
"report_type_label_contractPayment":`Umowy i należności`,
"label.myemailset":`Moje ustawienia poczty elektronicznej`,
"label.emailtype":`Typ e-mail`,
"label.appexchange.uninstallpage.message5":`Trwałe usunięcie wszystkich relacji i list powiązanych powiązanych z obiektami niestandardowymi w tym pakiecie`,
"label.customerinfo.applicationlicencenum":`Liczba licencji na funkcje`,
"label.product":`Produkty`,
"lable.opppdt.selPdt.subtitle":`Wybór produktów dla`,
"label_emailtocloudcc_step1_lead1":`E-mail do lidera`,
"label.multilang.recentview.query":`Zobacz swoje najnowsze {0}`,
"label.cumstom":`Własna`,
"lable.product.pep":`Proszę podać cenę.`,
"label.suggestion":`Pomysły`,
"vue_label_email_sentto":`wysłano`,
"label.email.cancel":`Po anulowaniu powiązania skrzynka nie może być używana do wysyłania ani odbierania wiadomości email. Czy na pewno chcesz anulować skojarzenie?`,
"component_timeline_label_1monthahead":`1 miesiąc przed`,
"setup_mainpage_label_welcome31":`Instrukcje: Kliknij na menu po lewej stronie tej strony → Zarządzaj ustawieniami → Utwórz → Aplikacja.`,
"label.weixin.settlement.rate":`Wskaźnik realizacji ugody`,
"front-lightning-module-v1-details-page-chart-add-report":` Można dodać maksymalnie 4 wykresy raportu.`,
"label_related_list_types":`Related List type of Lightning version`,
"label.tabpage.converstatez":`Stan przekształcony`,
"label.chatter.ok":`Potwierdź`,
"lable.SalesCommitmentKanBan.contractRate":`Podpisany Stawka`,
"component.setup.label.setupsavefail":`Nie udało się zapisać ustawień komponentu`,
"label.email.form.text2":`[switch to html]`,
"UG.Lead.009":`Historia połączeń APP`,
"label.escalation.setup.newrule.title":`Zasada Eskalacji Sprawy`,
"label.field.available.value":`Dostępne wartości pól`,
"label.cannotuseaddtimetrigger":`<b>`,
"vue_label_chat_activefail":`Błąd przy aktywacji`,
"label.dashboard.show.total.percent":`Pokaż całość lub pokaż %, proszę wybrać co najmniej jedno z nich`,
"label.schedulejob.setup.schedule.jobprg":`Programy pracy`,
"label.select.email.type":`Proszę wybrać typ emaila!`,
"chatter.group.allTheMembers":`Wszyscy członkowie`,
"label.webtab.validation.apiname":`Musi zaczynać się od litery. Musi zawierać tylko duże i małe litery, cyfry i podkreślenia. Maksymalna długość to 20 znaków, minimalna długość to 2 znaki.`,
"label_partner_new_step3_name":`Nazwa`,
"vue_label_chatter_remove_member":`Usunąć członka`,
"label.customobjects.majorobject.tip":`Jeśli wybierzesz obiekt relacji inny niż szczegółowy, dane podsumowujące nie będą miały uprawnień.`,
"label.forecast.edit.kjjd":`FQ`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.three":`Trzy`,
"label.weixin.senderror":`Wysyłanie nie powiodło się`,
"label.visiturl":`Odwiedź URL`,
"label.apply.img.error":`Znak wprowadzony w gragh jest nieprawidłowy`,
"label.been.detained":`Zniżka Reset`,
"vue_label_helpcenter_dashboard2":`<br> W nowo utworzonej tablicy rozdzielczej należy najpierw dodać komponenty i wybrać źródło danych raportu lub źródło danych zestawienia. Następnie określ typ wykresu i wybierz odpowiednie grupowanie i dane statystyczne, aby utworzyć wykres<br> Po dodaniu komponentów możesz kliknąć przycisk "Zmień kolejność" na pulpicie, aby dostosować położenie i rozmiar komponentów. <br>Jeśli potrzebujesz ustawić warunki filtrowania czasu dla niektórych komponentów, możesz kliknąć "Ustawienia warunków filtrowania", aby wybrać komponent i ustawić pole czasu, które komponent musi filtrować. Po ustawieniu, możesz filtrować według czasu na pulpicie nawigacyjnym i wybrać odpowiedni zakres czasu, aby zaktualizować wybrane dane. <br>Uwaga: Tablica rozdzielcza obsługuje do 10 komponentów. <br> 2. Przenikanie i powiązanie komponentów<br> W tej samej tablicy rozdzielczej komponent A może ustawić komponent B i C z tego samego źródła danych jako swoje obiekty powiązania. Po zakończeniu ustawień, kliknij na obszar danych komponentu A, komponent B i komponent C będą jednocześnie wykonywać ponowne liczenie danych w oparciu o warunki obszaru danych komponentu A. <br> Zauważ, że kliknięcie obszaru danych komponentu B lub komponentu C nie spowoduje ponownego liczenia komponentu A. Jeśli chcesz osiągnąć ten efekt, musisz ustawić komponent A jako obiekt powiązania z komponentem B/C. <br> Dla każdego komponentu wykresu w tablicy rozdzielczej dane pochodzą z widoku lub raportu. W związku z tym zapewniona jest funkcja przenikania, tzn. kliknięcie obszaru danych komponentu może spowodować przejście do odpowiedniego raportu lub zestawienia. Należy pamiętać, że jeśli oryginalne źródło danych ulegnie awarii, komponent nie będzie miał żadnych danych i funkcja przenikania również ulegnie awarii. <br> Ponieważ zarówno przenikanie, jak i powiązanie są obszarami danych komponentu do klikania, nie mogą one działać w tym samym czasie. Jeśli komponent ma ustawione zarówno przenikanie, jak i powiązanie, wtedy komponent może mieć tylko jedną funkcję działającą w tym samym czasie, a ty możesz wybrać funkcję działającą przez przełączanie stanów powiązania i przenikania.`,
"vue_label_commonobject_view_notice_delete_false":`Nie udało się usunąć danych {0}, powód to {1};`,
"label.weixin.newspaper.coverage.information":`Szczegóły arkusza ryzyka`,
"label.you.do.not.have.permission.to.operate.":`Nie masz dostępu do obsługi.`,
"label.checkfield.match":`Mecz`,
"message.custom.field.donotdelete.ref":`Pole to jest powiązane z innymi polami`,
"label.version.maxsum":`osiągnęła górną granicę.`,
"System.ChangeUser.Info.001":`Właściciel zmieniony i kliknij, aby powrócić do poprzedniej strony.`,
"label.target":`Target`,
"template.dashboard.behavior.analysis":`Analiza działań`,
"label.login.verification.enter.prompt":`Proszę wprowadzić 6-cyfrowy cyfrowy kod bezpieczeństwa`,
"label.am":`AM`,
"chatter.emailSetUp.remark":`Pozwól użytkownikom otrzymywać e-maile z CCChat, gdy ktoś Cię śledzi, komentuje Twój post i nie tylko.`,
"label.accmarketsea.grouplist.title":`Ustawienia grupy puli kont`,
"label.stdashbord.xsld.business.danwei":`Jednostka: 10 tys.`,
"label.app.step1.error.namenull":`Należy wprowadzić nazwę grupy publicznej.`,
"label.login.button.verification":`Przekazać do weryfikacji`,
"label_tabpage_newWizardz":`Nowy dodany kreator funkcji`,
"label.addattachment.step1.intruduce":`Wprowadź ścieżkę dostępu do pliku lub kliknij przycisk , aby znaleźć plik.`,
"pagecreator.layout.funcpath":`/ konstruktor / biblioteka układów`,
"fourth":`Czwarty`,
"label.timetrigger.after.lasttime":`Jeden dzień później od daty ostatniej modyfikacji.`,
"vue_label_report_showme":`Pokaż mi`,
"label.h5.similar.opportunity.end.date.in":`Data końcowa przypada w następującym okresie`,
"label.turntonextstep":`Przejdź do następnego kroku`,
"label.icon.106":`Harmonogram`,
"label.user.receivenewsbulletin":`Odbieranie audycji informacyjnych`,
"label.mask.card.number":`Numer karty kredytowej`,
"setup.object.layout.label.profileoptions":`Dostępne profile`,
"vue_label_systemSettings_obj":`Obiekty i pola`,
"label.call.center.history.open":`Automatycznie otwieraj stronę historii połączeń`,
"label.attendance.cityname":`Proszę wpisać nazwę miasta`,
"label.newemailnotice.tip":`Utwórz alert e-mail, który będzie powiązany z jedną lub wieloma regułami przepływu pracy lub procesami zatwierdzania. Podczas zmiany alertu e-mail wszelkie modyfikacje zostaną zastosowane do wszystkich reguł lub zatwierdzeń z nim powiązanych.`,
"label.app.step1.error.labelnull":`Error: Label nie może być pusta.`,
"front-kefu-moudle-connect-free-account":`Powiązanie użytkowników CloudCC z kontami próbnymi TRRT`,
"label.biaoqingfaxian.description":`Po włączeniu opcji wyszukiwania ofert, do front-end'u można dodać menu wyszukiwania ofert, gdzie użytkownicy mogą przeglądać informacje o ofertach z odpowiednich branż i przekształcać dane ofertowe w leady w systemie.`,
"label.filter":`Filtr`,
"label.data.downpage.e.title.num1":`1、Wybierz obiekty, które chcesz wyeksportować lub wybierz opcję eksportu wszystkich.`,
"label.h5.similar.opportunity.last.months12":`Ostatnie 9-12 miesięcy`,
"label.chatter.name":`Nazwa`,
"vue_label_helpcenter_email":`1. Wysyłanie poczty<br> Opuszczanie systemu, aby przejść do swojej skrzynki pocztowej w celu komunikacji z kontaktami, było przestarzałe. W Cloud CC możesz połączyć swój osobisty adres e-mail, aby wysyłać e-maile bezpośrednio z Cloud CC. Kiedy wpiszesz adres e-mail lub nazwę odbiorcy, system dopasuje dla ciebie rekord kontaktu lub leada. Możesz również powiązać rekordy pocztowe z powiązanymi rekordami, które zostały skonfigurowane, a wysyłane wiadomości e-mail będą synchronizowane na stronie szczegółów rekordu.<br> 2. 4 wspólne funkcje podczas wysyłania wiadomości e-mail<br>Podczas wysyłania wiadomości e-mail możesz skorzystać z 4 funkcji znajdujących się pod tekstem wiadomości, aby ułatwić sobie pracę.<br>Śledzenie poczty<br>Po włączeniu śledzenia poczty, pomożemy Ci monitorować liczbę otwarć wiadomości e-mail i kiedy została ona ostatnio otwarta. Możesz najechać myszką na ikonę "oka" na liście skrzynki nadawczej, aby ją zobaczyć.<br>Prześlij załącznik<br> Kliknij Prześlij załącznik, możesz wybrać plik, który został przesłany do systemu, lub możesz wybrać, aby przesłać plik. Możesz wybrać wiele załączników, o ile rozmiar załącznika jest mniejszy niż 20M.<br>Wstaw połączone pola<br> Gdy wiadomość e-mail jest powiązana z rekordem obiektu, możesz kliknąć, aby wstawić połączone pole, wybierz powiązany obiekt, wybierz pole, które chcesz wstawić i wprowadź tekst zastępczy po przecinku w połączonym polu, takim jak {!Contact.FirstName,Sir lub Madam }. Podczas zapisywania szablonu połączone pola będą wyświetlane w treści wiadomości e-mail szablonu. Użyj połączonych pól, aby spersonalizować treść wiadomości e-mail. Możesz dodać tekst zastępczy do dowolnego pola połączonego. Tekst zastępczy jest wyświetlany tylko wtedy, gdy połączony rekord nie zawiera danych pola.<br>Edytuj i włącz podpis<br> Gdy wysyłasz służbowe e-maile, podpis, który może reprezentować Twoją tożsamość, pomoże poprawić profesjonalizm Twojej pracy. Kliknij przycisk "Edytuj podpis", możesz edytować swoje podstawowe informacje i wspierać wstawianie zdjęć. Jeśli zaznaczysz opcję "Włącz podpis", Twój podpis będzie dołączany do treści wiadomości za każdym razem, gdy tworzysz wiadomość e-mail. Możesz wyłączyć podpis w dowolnym momencie.<br> 3. Filtrowanie skrzynki odbiorczej<br> Możesz filtrować wszystkie nieprzeczytane wiadomości w skrzynce odbiorczej, aby ułatwić sobie pracę. Jeśli chcesz pobrać pliki za pośrednictwem poczty e-mail, możesz filtrować wszystkie wiadomości e-mail z załącznikami w skrzynce odbiorczej, dzięki czemu możesz szybko zlokalizować wiadomość, której potrzebujesz. Ponadto, można szybko zobaczyć rekordy klientów w systemie, że można śledzić poprzez e-maile, przesiewając e-maile zawierające otwarte możliwości biznesowe lub przesiewając e-maile wysłane przez prowadzi lub kontaktów.<br> 4. Masowy mailing<br> W prawym górnym rogu listy leadów i kontaktów znajduje się przycisk do grupowego mailingu. Możesz wysyłać masowe mailingi do potencjalnych klientów lub rekordów kontaktów z adresami e-mail. Kiedy masz rekord działań marketingowych, możesz wysyłać e-maile do członków działań marketingowych w partiach, co jest również wygodne dla Ciebie do wysyłania zaproszeń na wydarzenia.`,
"front-kefu-moudle-auto-callphone":`Automatyczne tworzenie nowych spraw dla połączeń połączonych`,
"label.fiscal.FQ":`Kwartał fiskalny`,
"label_tabpage_groupsVisiblez":`Niektóre grupy użytkowników są widoczne`,
"UG.product.01":`Wymień produkty/usługi`,
"vue_label_commonobjects_view_members":`Członkowie fakultatywni`,
"label.organization.id":`Identyfikator organizacji`,
"label.tyle_preview":`Podgląd stylu`,
"label.campaign.channel.input.to.owner":`6. Proszę ustawić, czy ich właściciele mają być powiadamiani, gdy członkowie kampanii zalogują się do systemu.`,
"label.appointmentconfirmpage.wizard.notif1":`Spotkanie zostało odwołane!`,
"lable.tianyancha.maping":`Mapowanie w terenie`,
"front-kefu-moudle-v1-noadd-online-chats":`Agent online nie jest dodany`,
"vue_label_commonobjects_detail_group_strategy":`Czy jesteś pewien, że wprowadzasz zespół klienta?`,
"vue_label_report_deletegrouprow":`Usuń wiersz grupy`,
"lable.account.y.d":`Ta strona umożliwia zdefiniowanie niestandardowego rekordu roku fiskalnego. Daty dla niestandardowego roku podatkowego zostaną wygenerowane w oparciu o wybory dokonane poniżej.`,
"label.visualpage.lllegal.definitions":`Nieprawidłowa definicja`,
"label.tabpage.enterrecordnamez":`Proszę wpisać właściciela rekordu`,
"vue_label_report_howmuchlines":`{długość} wierszy`,
"homepage.components.custom":`Komponenty niestandardowe`,
"label.campaign.channel.upload.img":`Prześlij obraz`,
"UG_Case_03":`Automatyczna rozbudowa obudowy`,
"label.approved.receiveApprovalEmail.option4":`Nigdy`,
"System.Data.Import.Warning.MaxCount":`Twoja organizacja może importować tylko {0} sztuk danych na raz, co jest teraz poza limitem, proszę dostosować i ponownie zaimportować.`,
"label.sent.sms":`wysłał wiadomość SMS`,
"vue_label_dashboard_statistictype":`Typ statystyki`,
"label_report_last_year_same":`Ten sam okres w roku ubiegłym`,
"lable.Examle":`Przykłady`,
"label.customerinfo.PageTriggerFagTitle":`Synchronizacja trwa dwie godziny.`,
"label.mobile.phone.read":`Poprawić`,
"label.product.gopage":`Przejdź do strony`,
"label.a_b_without":`Rekordy "A" mogą, ale nie muszą mieć powiązanych rekordów "B".`,
"front-kefu-moudle-callin-missphone":`Odwoływanie nieodebranych połączeń`,
"label.sso.saml.sp.idsource.attrname":`Nazwa atrybutu`,
"label.h5.chatter.colleagues2":`Koledzy`,
"label.approveprocess":`Procesy zatwierdzania`,
"label.dataimport.error.name.null":`Błąd: nazwa jest pusta`,
"label.paging.countitems":`{0}`,
"vue_label_report_notice_filter":`Gdy filtrowanie zaawansowane nie jest włączone, różne warunki filtrowania to "i", czyli w raporcie wyświetlane są rekordy spełniające wspólne cechy 1 i 2. Na przykład: 1 to możliwość biznesowa o kwocie większej niż 1 milion, a 2 to szacowana data kontraktu równa temu miesiącowi, więc wynikiem raportu jest ponad 1 milion możliwości biznesowych w tym miesiącu.`,
"front-lightning-module-v1-dashborad-export-picture":`Eksport obrazu`,
"label.activity.disabled":`Brak włączonej aktywności, należy skontaktować się z administratorem systemu w celu włączenia historii aktywności i nieprzetworzonych aktywności w układzie strony.`,
"message_chooseatleastonefield":`Proszę wybrać co najmniej jedno pole do wyświetlenia.`,
"label.case.text":`Formularze zgłoszeń serwisowych składane przez stronę internetową mogą generować rekordy spraw w systemie. Należy wybrać użytkownika jako twórcę rekordu sprawy, a wybrany użytkownik musi mieć uprawnienia do tworzenia obiektu sprawy. Strona jest dostępna dla komputerów i telefonów komórkowych.`,
"label.sendmail.step3.dealoption1":`BCC mnie w jednej wiadomości`,
"label.forecast.settings.title.remark":`Najlepsze oszacowanie szacunkowych przychodów dla użytkownika, które zapewnia pełny obraz biznesowy dla użytkowników`,
"label.apply.youxiaotime.finish.opperation":`Masz 5 minut na wykonanie tych czynności. Proszę zignorować tę wiadomość, jeśli operacja nie jest wykonywana osobiście.`,
"label.user":`Użytkownik`,
"pagecreator.page.button.copy":`Kopia`,
"label.userinfo.pwdupdate.or.reset":`Twoje hasło zostało ostatnio zmienione lub zresetowane w dniu`,
"label.fieldupdata":`Aktualizacje w terenie`,
"label.sendemail.chat.followsubject":`CloudCC CCChat ma kogoś, kto śledzi`,
"component_task_label_enddate":`Data wygaśnięcia`,
"label.campaign.channel.step6.remark5":`Można je ponownie przypisać za pomocą Reguł Przypisywania Leadów. Dowiedz się więcej o Regułach Przypisywania leadów.`,
"label.mr.title.mobilePhone":`Mobile`,
"label.notice":`Przypomnienie`,
"message.serviceappo.time.violation":`Naruszenie dostępnego czasu rozpoczęcia wizyty serwisowej: Uzgodniony czas rozpoczęcia spotkania serwisowego jest późniejszy niż najwcześniejszy dostępny czas rozpoczęcia.`,
"label.account":`Konta`,
"front-kefu-moudle-callcenter-user":`Użytkownicy Call Center`,
"label.usermanage.query.notexist":`Użytkownik, którego dotyczy zapytanie, nie istnieje.`,
"label.forecast.userinfo.isnable":`Umożliwić prognozowanie`,
"label_partner_workspace_member":`Członek`,
"vue_label_dashboard_penetrationsetting":`Penetracja Ustawienie`,
"chatter.fieldtrack.operatecreate":`utworzony`,
"label_tabpage_tpcustomersz":`Konwersja leadów`,
"label.emailtocloudcc.redmessage6":`Uwierzytelnianie IMAP/SMTP nie powiodło się, proszę sprawdzić, czy adres e-mail i hasło są poprawne.`,
"label.customfields.file.upload":`Prześlij`,
"label.forecast.isforecast":`Prognoza nie jest włączona`,
"label_benchmark":`Odnośnik`,
"label.exchange.sync.state.system":`Stan synchronizacji systemu`,
"UG.opportunity.003":`Śledź kanały sprzedaży, twórz pulpity`,
"label.campaign.matchway.select.error":`Aby zaktualizować dane, należy wybrać metodę dopasowania`,
"vue_label_dashboard_located":`Folder Dashboard`,
"front-electronic-signature-enter-object":`Proszę wprowadzić obiekt`,
"vue_label_systemSettings_mobelquick":`Aplikacje mobilne Szybka konfiguracja`,
"lable.outlook.list":`Konfiguracje Exchange Sync`,
"label.sendemail.approval.dlsp":`Witaj, #dlspr:\N #actorname#objapiname-#recordname przedłożony przez #actordate został ustawiony jako Twój zatwierdzający proxy przez pierwotnego zatwierdzającego #spr i czeka na Twoją akceptację.\NProszę kliknąć na poniższy link lub zalogować się do systemu crm, aby wejść do centrum zatwierdzania w celu zatwierdzenia:\n#url\n Dzięki! \N#orgname`,
"label.service.deleteCustomView.wanttoremove.filter":`Czy na pewno chcesz usunąć filtr "{name}"?`,
"component_task_label_newevent":`Nowe zadanie`,
"vue_label_commonobjects_view_chart_groupby":`Grupa Przez`,
"front-kefu-moudle-v1-edit-chats":`Edytuj agenta`,
"pagecreator_page_message_delete_fail":`Usuwanie strony nie powiodło się`,
"label.file.search":`Wyszukaj pliki...`,
"label.projectManagement.Addpredecessors":`Dodaj zadanie wstępne`,
"label_tabpage_norecordtypez":`Typ rekordu niemożliwy do wykorzystania`,
"label.come.recycle.bin":`Przejdź do Kosza`,
"label.reportsSubscriptionPage.schedulereport.monthly.time.relative":`Relatywnie`,
"label.customfields.address.tip":`Umożliwia użytkownikowi wybranie pól województwo, miasto, powiat i wprowadzenie konkretnych informacji adresowych, które mogą być wykorzystane do obliczenia szerokości i długości geograficznej.`,
"label.weixin.optioneight":`Wybór 8`,
"label.recordtypeselect.modify":`Edytuj typ rekordu`,
"label.forecast.settings.future3":`Przyszłe 3 cykle`,
"label.rename":`Zmień nazwę`,
"label.emailtocloudcc.button.complete":`Wykończenie`,
"chatter.new.at":`Najnowsza aktywność`,
"component.setup.label.milestonesfield":`Pole kamienia milowego`,
"vue_label_commonobjects_detail_email_newaddress":`Wyślij do`,
"lable.PowerProcess.big.event":`Kamień milowy:`,
"label.appexchange.uninstallpage.confirm":`Tak, chcę odinstalować ten pakiet i trwale usunąć wszystkie powiązane z nim składniki.`,
"label_mobile_buttom_homepage":`Strona główna`,
"label.sso.saml.idp.config.logouturl":`Adres URL pojedynczego wylogowania`,
"lable.quote.pdf.button.savetoquote":`Zapisz do cytatu`,
"label.page.select.application":`Wybierz aplikacje niestandardowe, w których chcesz używać nowych kart niestandardowych. Możesz także zobaczyć lub zmodyfikować, czy karta ma być wyświetlana na stronie szczegółów i stronie edycji każdej aplikacji niestandardowej.`,
"chatter.down":`Pobierz`,
"label.tabpage.searchz":`Szukaj`,
"label.emailsync.form.action":`Działanie`,
"label.campaignmember.setup.campaignmember.field":`Pola członków kampanii`,
"label.version.remark":`Uwaga: Free Edition pozwala na utworzenie tylko 5 użytkowników, 2000 rekordów i nie można importować ani eksportować danych.`,
"label.selectoperateobject":`Wybierz obiekt.`,
"label.appointmentdetail.wizard.title12":`Czas na książkę`,
"label.submitforapproval":`Przekazać do zatwierdzenia`,
"label.the.lower.bound.of.each.layer.of.editing.discount.must.be.equal.to.the.upper.bound.of.the.upper.level.":`Dolna granica dla edycji każdego poziomu rabatu jest równa górnej granicy ostatniego poziomu.`,
"label.appupload.install.component.view":`Widoki Części składowe`,
"label.profile.customobjcontrol":`Niestandardowe uprawnienia do obiektów`,
"label.customfields.configprofilefieldsafety.tip":`Wybierz profile, którym chcesz nadać dostęp do edycji tego pola poprzez field-level security. Pole zostanie ukryte przed wszystkimi profilami, jeśli nie dodasz go do zabezpieczeń na poziomie pola.`,
"label.service.gantt.service.resources":`Zasoby usługowe`,
"label.input.right.emailaddress":`Proszę wpisać nieprawidłowy adres e-mail.`,
"label.ccdocument.folder.notedit":`Folder nie jest edytowalny.`,
"label.data.choses.i.desc":`W zależności od potrzeb możesz importować dane z jednego obiektu.`,
"label.icon.75":`Samochód`,
"label.summaryreport.step4":`Krok 4 Wybierz kolumny raportu`,
"label.appupload.upload.install":`Zainstaluj`,
"label.reportlist.newfolder":`Nowy folder raportów`,
"label.projectManagement.myproject":`Mój projekt`,
"label.true":`TRUE`,
"label.tabpage.reallproplez":`Właściciel zapisu`,
"label.change.lead.share.error":`Brak prawa do edycji klienta`,
"F":`Data/godzina`,
"lable.account.CurrentandNextCQ":`Aktualne i następne CQ`,
"UG.activity.06":`Chęć kontynuowania współpracy z klientami`,
"UG.contact.03":`Śledzenie kontaktów w jednym miejscu, sygnały sprzedaży`,
"label.field.duplicate.error.msg2":`Nie powiodło się ustawienie unikalnej właściwości`,
"label.sales.dashboard.reality":`Płatności rzeczywiste`,
"lable.PowerProcess.type":`Rodzaje procesu nabywania uprawnień`,
"batch.selected.data":`Wybrane dane:`,
"#label.importsourcefilestep2":`Krok 2 Skompresuj swój plik(Opcjonalnie)#`,
"label.emailtemplate.select":`Proszę wybrać szablon wiadomości e-mail, którego chcesz użyć.`,
"chatter.most.w":`Można wprowadzić do 500 znaków`,
"vue_label_calendar_new_object_calendar":`Kalendarz nowych obiektów`,
"label.aggregated_formsdata":`Dane zbiorcze formularzy`,
"label.knowledge.language.french":`Francuski`,
"label.customfields.enc.tip":`Pozwala użytkownikom na wprowadzanie dowolnej kombinacji liter i cyfr i przechowywanie ich w postaci zaszyfrowanej. I nie mogą być przeszukiwane.`,
"label.icon.158":`Chmura`,
"font-evaluate-module-v1-bad-review ":`Gdy rodzajem oceny jest ocena negatywna`,
"UG_quota_03":`Wzór cytatu`,
"label.eidt.queue.label.hasused":`Etykieta jest już używana`,
"label.lookupfilter":`Filtry wyszukiwania`,
"label.callcenter.Instance.name":`Nazwa instancji`,
"label.commitertype":`Rodzaj zgłaszającego`,
"vue_label_checkduplicate_any_one":`Spotkaj się z kimkolwiek`,
"label.campaign.channel.input.img":`Proszę wybrać obraz z lokalnego komputera jako stronę z podziękowaniami`,
"vue_label_dashboard_pleaseenterafoldername":`Proszę wprowadzić nazwę folderu`,
"label.tianyancha.look":`Zobacz`,
"label.tabpage.lastone":`Wybierz co najmniej jedną operację`,
"label.sendemail.approval.submit.title":`{!objLabel} - {!recordName} czeka na twoją akceptację`,
"label.chat.topic.delete.prompt1":`Usunięcie tematu wymaga czasu, temat będzie zachowany w postach i zapisach aż do zakończenia procesu.`,
"component_setup_label_displaybutton":`Przycisk wyświetlacza`,
"label.partnerCloud.backgroundImage":`Obraz tła`,
"label.mobile.phone.time.range":`Zakres czasu`,
"label.page.url.address.remark":`Wprowadź adres strony internetowej w polu "Link URL". Możesz wpisać prosty adres URL, tak jak pojawia się on w pasku adresu przeglądarki, lub użyć jednego lub więcej pól łączących, aby wstawić dane specyficzne dla organizacji z CloudCC.com do parametrów adresu URL. Niektóre strony mogą nie działać w karcie sieci Web ze względu na ustawienia zabezpieczeń przeglądarki, lub dlatego, że strona nie może być wyświetlana w ramce.`,
"label.h5.copyemail":`E-mail został skopiowany`,
"label.view.step3":`Krok 3 Wybierz pola do wyświetlenia`,
"label.quickbooks.view.moneyreceived":``,
"label.emailobject.attachment.preview":`Podgląd`,
"label.selectapprover":`Wybierz zatwierdzającego`,
"vue_label_normal_opportunity_sf":`Szansa`,
"label_emailtocloudcc_filed_port":`Port`,
"mesage.errorinsaving":`Wystąpił błąd podczas zapisywania. Proszę skontaktować się z administratorem.`,
"label.partnerCloud.partnerCloudName":`Proszę wpisać nazwę chmury partnerskiej`,
"lable.edit.queue.checkemail":`Błąd: Nieprawidłowy adres e-mail.`,
"label_builder":`Kreator stron`,
"component_setup_label_setupsavefail":`Nie udało się zapisać ustawień komponentu`,
"label.icon.76":`Samochód`,
"label.reportsSubscriptionPage.schedulereport.monthly":`Miesięcznie`,
"message.nopermession":`Brak uprawnień`,
"label.view.groupscansee":`Widoczny dla <b>pewnych grup użytkowników</b>`,
"label.leadscore.rule.new":`Lead Scoring: NNowa reguła`,
"label.new.ccpeakfolder.time":`Zaplanowane zajęcia: Nowy Folder`,
"label.record":`Zapisy`,
"message.error.flabel":`Podane etykiety pól nie mogą zawierać angielskich pojedynczych lub podwójnych cudzysłowów.`,
"label.emailobject.emaildetail.promptbutton2":`Anuluj`,
"label.h5.phone":`Zadzwoń na`,
"label.visualpage.error.deal.with":`Wystąpił błąd, proszę skontaktować się z administratorem`,
"label.button.step1.select.field":`Krok 1 Wybierz pola`,
"label.setsharerule.step1":`Krok 1 Wybierz typ reguły`,
"component.chatter.file.label.title":`Przesyłanie plików`,
"front-epwechat-module-v1-appname":`Nazwa aplikacji`,
"chatter.error.notsel":`Błąd:Proszę wybrać obraz do załadowania.`,
"label.updatevalue":`Dokładna wartość Zmiana od`,
"label.chatter.sendEmailToGroupMember.subject.D":`{0} zaksięgowane dokumenty dla wszystkich w {1}`,
"label_tabpage_grid":`Wyświetlanie siatki`,
"homepage.components.standard":`Komponenty standardowe`,
"label.movable":`Działania`,
"label.report.selected.field.cannot":`Liczba wybranych pól nie może przekraczać 50.`,
"label.projectManagement.distribution.by.excess":`Przydzielanie według nadgodzin`,
"addrow":`Dodaj wiersz`,
"label.approvaldatamove.p":`Użyj następujących opcji, aby zarządzać wieloma wnioskami o zatwierdzenie. Kliknij "Znajdź", aby przefiltrować wnioski o zatwierdzenie. Gdy wyniki zostaną wyświetlone w widoku listy, określ akcję.`,
"label.passwordPolicy.setup.title":`Zasady dotyczące haseł`,
"label.appointmentpage.wizard.title1":`{0} ({1}) zaprasza na`,
"label.tippage.li1":`Trwałe usuwanie niestandardowego źródła danych raportu`,
"label.campagin.roi.dcl":`Wskaźnik frekwencji`,
"label.h5.new.errorbody":`Te wymagane pola oznaczone * muszą zostać wypełnione.`,
"label.cy.enable":`Włącz walutę`,
"label.currency.rate.e":`Edytuj kursy wymiany dla walut Twojej organizacji.`,
"or":`Lub`,
"lable.custom.Previous.CYt":`Poprzedni 2 CY`,
"front-epwechat-module-v1-unbound-desc":`Usunięcie powiązania spowoduje wyczyszczenie powiązanego konta. Czy na pewno chcesz usunąć powiązanie?`,
"pagecreator_button_publish":`Opublikuj`,
"font-evaluate-module-v1-case-owners":`Powiadomić właściciela sprawy:`,
"label.pw.new":`Proszę wprowadzić nowe hasło`,
"message.tabsearch.nokeywords":`Proszę wpisać słowo kluczowe o długości co najmniej jednego znaku`,
"label.sendemail.send.erroruser":`Nieprawidłowy użytkownik`,
"label.personalinfo":`Moje dane osobowe`,
"label.case":`Sprawy`,
"lable.product.pricebooks.now":`Istniejące księgi cen`,
"label.ccpeak.take.notice":`Uwaga: ID, Auto Number, Created By, Created Date i inne pola systemowe nie wymagają wprowadzania wartości.`,
"label.page.first":`Pierwsza strona`,
"label.icon.168":`Widoki`,
"label.choices":`Wybierz`,
"label.is.delete.document":`Czy na pewno chcesz usunąć ten plik?`,
"homepage.layout.custom":`Niestandardowe układy`,
"label.emailobject.template.insert.field":`Pola`,
"label.ccpeak.folder.all":`Foldery wszystkich klas`,
"front-console-conversation-btn3":`Przekaż wiadomość email`,
"label.ems.port":`Port`,
"label.app.introduce":`Aplikacja to grupa zakładek, które działają jako jednostka zapewniająca funkcjonalność. Użytkownicy mogą przełączać się między aplikacjami za pomocą rozwijanego menu aplikacji, znajdującego się w prawym górnym rogu każdej strony.`,
"label.file.library.managemembers.admin":`Administrator biblioteki`,
"vue_label_salesadvance_win":`Won`,
"label.email.click.complete.info":`Kliknij przycisk "Zakończ", aby powrócić do poprzedniej strony.`,
"label.umeng.activity.event.willbegin":`Twoje wydarzenie #event zaczyna się w #czasie.`,
"label.mobile.phone.week.summary":`Podsumowanie tygodnia`,
"label.quickbooks.fieldlabel.terms":`Warunki`,
"lable.currencyManage.advcurrencyEnabled.dis":`Umożliwia zarządzanie datowanymi kursami wymiany, które mapują kurs przeliczeniowy waluty na określony zakres dat. Datowane kursy wymiany są stosowane do pól walutowych w szansach, produktach szans oraz raportach powiązanych z tymi dwoma obiektami.`,
"label.weixin.data.save.failed":`Niezapisanie danych.`,
"label.service.gantt.filter.logic":`Logika filtra:`,
"vue_label_pool_adopt":`zbierać`,
"label.emailobject.markasunread":`Oznacz jako nieprzeczytane`,
"label_please_select_a_member":`Proszę wybrać członków.`,
"label.salescloud.unit.ci":`Jednostka (Czas)`,
"vue_label_pool_obsolete":`odrzucany`,
"label.cancelall":`Odznacz wszystko`,
"label.exchange.sync.state.setting.m2":`Użytkownicy w aktywnych konfiguracjach CloudCC Exchange:`,
"vue_label_pool_claimtime":`Czas złożenia wniosku`,
"label.forecast.forehistory.history":`Historia prognozy`,
"label.knowledge.article.record":`Artykuł o wiedzy jest bez zastrzeżeń.`,
"label.setting.intergrationlist.button.uninstall":`Odinstaluj Integrację`,
"label_tabpage_gotit":`Mam to.`,
"label.data.exp.csvform":`Ważne tylko dla eksportowanych danych.`,
"UG.Forcast.06":`Proszę wybrać użytkowników, którzy mają prawo do prognozowania`,
"vue_label_report_savereport":`Zapisz raport`,
"setup.object.field.dependency.label.mustone":`Musisz wybrać co najmniej 1 wartość pola zależnego.`,
"label.batchadd.newbatchpage.des1":`Pole Nazwa rekordu jest wymagane, w przeciwnym wypadku rekord nie zostanie zapisany.`,
"lable.custom.CurrentandPreviousCYt":`Obecne i poprzednie 2 CY`,
"label.versiontype.Professional":`Professional Edition`,
"label.customfields.configprofilefieldsafety":`Ustanowienie bezpieczeństwa na poziomie pola`,
"label.ccpeak.wgd.time":`Niewypełniony plan zajęć`,
"component.telerecord.label.subject":`Temat`,
"label_year":`Rok`,
"pagecreator_layout_label_modifylayout":`Edytor układu`,
"label.compact.layout.frame.splitline":`Linia rozdzielająca prawy i lewy ekran`,
"lable.PowerProcess.enter.the.process":`{describeName} Proces wejścia`,
"label.emailobject.cc":`Cc:`,
"front-electronic-export-choseCount":`Proszę wybrać importowane dane`,
"label.setup.mobile.bottombutton.recovery.default.success":`Pomyślnie przywrócono stan domyślny`,
"label.datamanage.import.accountfield":`Wybierz z poniższej listy pola w pliku importu, które powinny być zaimportowane do każdego konta. Następnie kliknij "Next Step":`,
"vue_label_opportunity_related_list":`Dodaj do listy powiązanych`,
"label.group.recent":`Ostatnio oglądane grupy`,
"vue_label_pool_finalclaimtime":`Czas złożenia ostatecznego wniosku`,
"vue_label_homepage_30daysnocontact":`Możliwości biznesowe bez kontaktu przez 30 dni`,
"label.tianyancha.field.error":`Dane Tianyancha nie zostały znalezione, skontaktuj się z administratorem systemu, aby przeprowadzić inicjalizację`,
"label.product.go":`Przejdź do raportów`,
"label.customsetting.manage.introduce":`Jeśli ustawienie niestandardowe jest listą, kliknij przycisk Nowy, aby dodać nowy zestaw danych. Na przykład, jeśli aplikacja posiada ustawienie dla kodów krajów, każdy zestaw może zawierać nazwę kraju i kod wybierania.`,
"label.task.dateadd":`Plus`,
"label.email.recipients.select":`Proszę wybrać adresatów`,
"chatter.emailListMyChat":`Lubi post lub komentarz, który napisałem`,
"label.batchadd.newbatchpage.save.name":`Jeśli nazwa jest pusta, system domyślnie nie doda tego rekordu, upewnij się, że nazwa nie jest pusta, a następnie zapisz.`,
"UG_Lead_011":`Utwórz wskazówkę`,
"vue_label_salesfunnel_notice2":`Ogółem Bieżące możliwości`,
"APPIntegration_Social_linkedinerror":`Musisz wprowadzić prawidłowy adres URL dla linkedin.com`,
"label.industrialandcommercialverification.enablestatus2":`Zapytania w czasie rzeczywistym Nazwa konta`,
"label.stdashbord.xsld.business.ajssx":`Przez rolę`,
"lable.info.queue.showalluser":`Wyświetl wszystkich użytkowników`,
"label.generatepage.c1":`Musi zaczynać się od litery. Musi zawierać tylko duże i małe litery, cyfry i podkreślenia.`,
"label.thenset":`A potem według`,
"label.salescloud.salescloud.defaultteam":`Domyślna grupa możliwości użytkowników`,
"label_partner_workspace_tab_selectedoption":`Wybrane zakładki`,
"label.tippage.li":`Usuń źródło danych raportu niestandardowego：`,
"lable.quote.syncingfrom.syncingto":`Produkty szansy zostały zsynchronizowane z pozycjami oferty`,
"label.emailobject.delete":`Usuń`,
"label.data.selectimportobject":`Wybierz obiekty do zaimportowania`,
"label.knowledge.language.dutch":`Niderlandzki`,
"message.campaign.page.overtime":`Strona wygasła.`,
"label.ccchat.message.search.desc4":`Sprawdź pisownię szukanych słów.`,
"label.login.forgetPsd":`Zapomniałem hasła`,
"vue_label_title_order":`Zamówienie`,
"template.report.contract.follow.status":`Działania uzupełniające Status umowy`,
"label.forecast.edit.kjnd":`Rok podatkowy`,
"front-electronic-export-listTitle":`Lista Mailchimp`,
"label.dataimport.error.khmc.notnull":`Błąd: musisz podać nazwę konta`,
"label.testobject":`Obiekt testowy`,
"label_chatter_nextStep":`Następny krok`,
"label.file.public.link.share":`Publiczne udostępnianie linków`,
"label.weixin.organization.name":`Nazwa organizacji`,
"label.quote.email":`E-mail`,
"label.reg_field":`Pole zwykłe`,
"font-evaluate-module-v1-response":`Odpowiedź po ocenie:`,
"label.chatter.sendmail":`Wyślij e-mail`,
"label.weixin.start.incorrect":`Nieprawidłowy format daty rozpoczęcia`,
"component_chatter_link_label_url":`Link url`,
"vue_label_pool_operatecertification1":`{0}{1}{2}`,
"lable.currencyManage.Enabledadvcurrency.agree":`Tak, chcę włączyć Zaawansowane zarządzanie walutą.`,
"label.east.africa.time":`Czas wschodnioafrykański`,
"label.product.proof.Three":`W {0} proszę wybrać minimum {1} opcji produktowych, ale do {2}.`,
"label_emailtocloudcc_filed_password":`Hasło`,
"component.task.label.person":`* Osoba przydzielona`,
"pagecreator_systemstyle_label_buttonareacolor":`Kolor obszaru roboczego`,
"label.clearrule":`Jasne zasady`,
"lable.customer.access":`Uprawnienia dostępu do konta`,
"label.finish.wait":`Twój wniosek został rozpatrzony, sprawdź powiadomienie o zakończeniu w swojej skrzynce pocztowej.`,
"label.weixin.appr.auditor":`Zatwierdzający`,
"label.tabpage.systemz":`System(y)`,
"label.file.nocan.process.desc":`Nie można przetworzyć żądania. Nie możemy obsłużyć dostarczenia treści`,
"label.relationobject.name":`Nazwa obiektu powiązanego`,
"setup.layout.group.relatedlist":`Powiązane listy`,
"label.generatepage.title":`Strona internetowa do CloudCC`,
"label.page.step3.input.url.information":`Krok 3 Wprowadź szczegóły adresu URL`,
"label.change.to":`Zmień status członka kampanii na`,
"label.validate.function.funcFormat.TIMEVALUE":`WARTOŚĆ CZASOWA(data)`,
"label.partnerCloud.seriesSettings":`Konfiguracja rodziny produktów`,
"component.timeline.label.1monthahead":`1 miesiąc przed`,
"label.batchadd.senumberpage.selnum":`Wybierz liczbę rekordów, które mają być dodane`,
"label.downloadapp":`DOSTĘPNE NA`,
"label.dashboardSetup.showmainpage":`Wyświetlane na stronie głównej`,
"label.h5.nophoneprompt":`Kolega nie podał numeru kontaktowego`,
"label.service.deleteCustomView.wanttoremove.theFilter":`Czy chcesz usunąć filtr "{name}"?`,
"label.appupload.state1":`Załadowane`,
"component_timeline_button_filter":`Filtr`,
"label.passwordPolicy.setup.subtitle":`Ustaw ograniczenia haseł i zasady blokowania logowania dla wszystkich użytkowników.`,
"vue_label_normal_quote_sf":`Cytat`,
"label.productsales.today.noevttskaddall":`Nie ma żadnych otwartych wydarzeń i wygasających zadań, możesz kliknąć " " w prawym górnym rogu, aby dodać nowe wydarzenie i zadanie.`,
"label.projectManagement.no.end.date":`Brak daty końcowej`,
"label.sendmail.batch.chosetemplate":`Mass Email: Wybierz szablon`,
"serviceterritorymember.serviceresource.isactive.notactive":`Ten zasób serwisowy nie jest aktywny. Można przypisać terytoria usług do aktywnego zasobu usług.`,
"label.notification.event.overlapEvent.continue":`Kontynuuj`,
"label.appupload.component.type.obj":`Obiekt niestandardowy`,
"label.partnerCloud.financeSetting.basicConfiguration":`Ścieżka dostępu: Platforma publiczna  Rozwój  Konfiguracja podstawowa`,
"lable.outlook.detail.info":`Szczegóły konfiguracji Exchange Sync`,
"vue_label_commonobjects_detail_activity_commingevents":`Dostępne nadchodzące wydarzenie`,
"coderules.nullvalue2":`Nie udało się wygenerować. Proszę wprowadzić wartość dla 【{0}】,【{1}】 użytą w regułach generowania.`,
"label.version.sum.workflowrule":`zasada(y) przepływu pracy`,
"label.sso.saml.idp.config.enable":`Włącz dostawcę tożsamości`,
"label.temp.exp.conf":`Czy na pewno chcesz wyeksportować szablon?`,
"label.department":`Dział`,
"label.trigger.operation.email.template":`Pobierz informacje o szablonie wiadomości e-mail`,
"label.page.content.frame.height":`Wysokość ramki zawartości (w pikselach)`,
"label.ServiceCloud.jinengyaoqiu":`Wymagane umiejętności`,
"PageLayout.Search.MultiSearch.001":`Wybierz maksymalnie 3 pola.`,
"label.error500":`Ups! Błąd...<br />Proszę o kontakt z administratorem...`,
"label.appexchange.download.stop":`Zatrzymaj instalację z konfliktem`,
"label.service.dispatchingUnits.left.right.totalAll":`Aktualnie {left}-{right} rekordów, łącznie {totalCount} rekordów.`,
"label.tabpage.haschangedz":`Ten trop został przekształcony`,
"label.industrialandcommercialverification.button.cancel":`Anuluj`,
"label.edit.role":`Rola Edytuj`,
"label.mr.descreption.condition2":`Zasady - według kilku pierwszych znaków: wprowadź numer, znajdź duplikaty według kilku pierwszych znaków wprowadzonego numeru.`,
"label.testgrammer":`Sprawdź składnię`,
"label.age":`Wiek`,
"lable.real.time.chat":`Wsparcie techniczne dla czatu w czasie rzeczywistym jest zapewnione przez Easemob. Proszę skonfigurować zaawansowane ustawienia w Easmob.`,
"vue_label_opportunity_selected":`{suma} wybrane`,
"label.weixin.optionone":`Wybór 1`,
"label.file.delete.public.link.desc":`Usunięcie publicznego linku oznacza, że nikt nie może uzyskać dostępu do pliku z tym adresem url.Jeśli utworzysz nowy, będzie to inny adres URL.`,
"label_tabpage_cancel":`Anuluj`,
"template.report.opportunity.analysis":`Analiza etapu możliwości`,
"label.escalation.setup.newrule.inputrule":`Wprowadź nazwę reguły`,
"label.ccpeak.getapi.name":`Uzyskaj bezpośrednio nazwę API pola podczas pobierania wartości rekordu:`,
"second":`Drugi`,
"label_tabpage_uploadsz":`Prześlij`,
"label.description":`Uwagi`,
"label.ccchat.person.invite.notsamepwd":`Niespójne hasło`,
"label.mobile.app.isEnableAblumWatermark":`Dodawanie znaku wodnego do zdjęć wybranych z mobilnych albumów podczas zameldowania`,
"vue_label_allsearch_searchable_items":`Elementy z możliwością wyszukiwania`,
"lable.outlook.detail.react":`Ostatnie działania`,
"label.sales.team":`Zespół Opportunity`,
"label.guif.standard.time":`Czas standardowy Zatoki Perskiej`,
"label.emailobject.emaildetail.button.forward":`Do przodu`,
"label.refused":`Odrzucony`,
"homepage.components.one":`Krok 1 Wprowadź nazwę komponentu niestandardowego`,
"day":`Dzień`,
"label.dataimport.error.number":`Błąd: Numer`,
"label.customer.tab.step2.same.option2":`Domyślnie Wył.`,
"component_button_ok":`Potwierdź`,
"label.allrecordmeetprocess":`Wszystkie rekordy powinny wejść do tego etapu`,
"label.version.onefile.size":`Rozmiar każdego z wgrywanych załączników`,
"label.partnerCloud.orderingPlatform.allProducts":`Wszystkie produkty`,
"pagecreator.page.message.publish.success":`Strona została pomyślnie opublikowana`,
"lable.currencyAdv.exchagecurrency.rate.pro":`Poprzedni Zakres`,
"label.attendance.persons":`Odpowiedni użytkownicy`,
"label.send.an.email":`Wyślij wiadomość e-mail`,
"registration.page.browser.title":`Rejestracja kanału marketingowego Campagin`,
"label.importfilestep3":`Krok 2 Wybierz i prześlij swój plik(i)`,
"lable.currencyAdv.exchagecurrency.rate.next":`Następny zakres`,
"label.ems.no.sync.msg":`Nie skonfigurowano jeszcze informacji o synchronizacji poczty.`,
"label.total_views":`Podgląd przesyłania formularzy`,
"label.knowledge.article.notnull":`Proszę wybrać co najmniej jeden artykuł.`,
"message.error.view.lastview.delete":`Nie można usunąć ostatniego zestawienia publicznego</br>Nie można usunąć ostatniego zestawienia publicznego, które jest widoczne dla wszystkich użytkowników.<br><br>`,
"label.integrations.second.half":`fragment(y) danych, wybierz zaimportowane dane`,
"vue_label_systemSettings_mobelparams":`Ustawienie parametrów aplikacji mobilnej`,
"message.choose.maximum":`Można wybrać do 150 rekordów do udostępnienia, teraz`,
"vue_label_homepage_won&unprocessed":`Otwarte Nieprzetworzone`,
"UG.contact.01":`Jak najlepiej wykorzystać swoje kontakty?`,
"label.data.import.setup.remark":`Administrator może określić reguły, które mają być wykonywane podczas importu danych, w tym czy mają być wykonywane reguły walidacji, wyzwalacze oraz reguły duplikacji i dopasowania.`,
"pagecreator_layout_message_delete_success":`Układ usunięty pomyślnie`,
"lable.account.name":`Nazwa kwartału podatkowego`,
"label.userinfo.must.updatepwd":`Dla bezpieczeństwa musisz zmienić swoje hasło.`,
"label.mobile.phone.subordinate.setup":`Nie można ustawić, aby zawierał podwładnych, proszę wybrać wszystkich i ustawić ich na zezwalanie na prognozy.`,
"label.monitorsys.delete.date":`Usuń Data`,
"label_emailsync_form_emailaddress":`Adres e-mail`,
"label.projectManagement.cancelled":`Anulowane`,
"label.partnerCloud.partnerAccount.rechargeAmount":`Kwota doładowania musi mieścić się w przedziale od 0.1 do 1000000.`,
"label.select.relatedlist.approval.layout":`Wybierz listy pokrewne, które mają być wyświetlane w układzie strony zatwierdzania.`,
"label.userphoto.thumbnail":`Miniaturka`,
"label.assignment.setup.list.rulename":`Nazwa zasady`,
"label.emailtemplate.usemergefields":`Łączenie pól w szablonie wiadomości e-mail`,
"label.tabpage.enabletomobile":`Czy włączyć opcję "mobile-side`,
"setup_layout_label_desc":`Zjeżdżający`,
"vue_label_pool_abandonreasondiscription":`Opis przyczyny odrzucenia`,
"label.ems.outputmails":`Serwer wysyłania poczty elektronicznej (smtp)`,
"font-evaluate-module-v1-evall":`Cała ocena`,
"front-epwechat-module-v1-unbound-tips":`Następujące dane zostaną usunięte po odblokowaniu:`,
"label.weixin.number.data":`Dane`,
"front-objectTemplate-V1-UseObject":`Stosowany obiekt`,
"label.call.center.configuration":`Ustawienia centrum telefonicznego`,
"vue_label_systemSettings_website":`Portal internetowy Biura Obsługi Klienta`,
"lable.currencyAdv.foreverdate":`Stała data`,
"label.globalselect.view":`Zestaw wartości z listy opcji podglądu`,
"component_newrecords_label_title":`Ostatnie zapisy`,
"component_assistant_label_title":`Asystent`,
"label.equals.deletebut.bulk.delete":`Zawiera przycisk usuwania, masowe usuwanie (do Kosza)`,
"label.field.duplicate.error.msg4":`Błąd:Nieprawidłowe dane.`,
"label.input.right.date":`Proszę wprowadzić prawidłowy format daty`,
"file.error.notsel":`Błąd: proszę wybrać plik do przesłania`,
"label.customcomponent.page.add.title":`Nowy komponent niestandardowy`,
"message.chooseatleastthreefield":`Wybierz co najmniej 3 pola`,
"label.dataimport.system.unnecessary":`system nie jest w stanie określić kilku`,
"message.login.wrong":`Nieprawidłowa nazwa użytkownika lub hasło.`,
"label.appupload.install.recheck":`Sprawdź ponownie`,
"label.ems.option":`Opcja`,
"label.wei.subject.img":`Przedmiot lcon`,
"chatter.emailReceiveOrNotAccept":`Zaznaczenie tej opcji pozwala na otrzymywanie przypomnień CCChat, odznaczenie tej opcji uniemożliwia otrzymywanie przypomnień ccchat.`,
"label.icon.46":`Piec`,
"label.newpw":`Nowe hasło`,
"font-evaluate-module-v1-praise":`Rodzaj oceny jest pozytywny`,
"label.help.user":`Podręcznik użytkownika`,
"label.callcenter.no.searchs":`Brak odpowiedniego zapytania do informacji`,
"UG_homepage_007":`Od wysyłania e-maili uzupełniających po automatyzację kampanii sprzedażowych, od tworzenia przepływów pracy za pomocą naszej technologii Blueprint po uruchamianie niestandardowych makr, zautomatyzuj codzienne zadania i skup się bardziej na budowaniu relacji.`,
"label.saveandnew":`Zapisz`,
"component_salesperformance_label_70finish":`Zakończone - nieprzetworzone (>70%)`,
"lable.account.dp":`Ta strona umożliwia zdefiniowanie własnych lat podatkowych.`,
"label.notification.serviceappointment.injeopardy":`{1}{0}jest w stanie krytycznym. Prosimy o jak najszybsze przetworzenie.`,
"label.workflow.edit.esimaterule":`Błąd: nie można zmienić kryteriów oceny na "za każdym razem, gdy tworzony lub edytowany jest rekord", gdy z regułą powiązane są wyzwalacze czasowe.`,
"label.partnerCloud.basicSetting.feature":`Ustawienia funkcjonalne`,
"label.sms.companyname.gm.infor":`C.M.W.L.SMS Info (Ta usługa obsługuje tylko Chiny kontynentalne)`,
"vue_label_homepage_components":`Proszę wybrać elementy`,
"label_chatter_allactivity":`Wszystkie działania`,
"label.quickcreate.title":`Szybkie tworzenie układów`,
"label.tabpage.exclusivez":`Z wyłączeniem`,
"front-service-cloud-transfer-desc":`Podczas przenoszenia właściciela BOM aktywów, bieżący składnik aktywów i własne aktywa pod aktywami zostaną zmienione właściciela`,
"label.data.downpage.i.list.desc1":`Podczas importu dane, które nie zostaną pomyślnie zaimportowane, ponieważ dane są nieprawidłowo sformatowane, lub ponieważ wyzwalacz lub reguła walidacji nie powiodła się, generuje plik CSV do wyświetlenia na bieżącej stronie. Dane zaimportowane pomyślnie nie będą wyświetlane na bieżącej stronie.`,
"template.report.individual.case.status":`Status spraw`,
"label.report.export.file.format":`Format: Format Excel .csv`,
"vue_label_filternotice1":`Oznacza to, że każdy z warunków filtra jest spełniony w tym samym czasie, na przykład: 1 okazja biznesowa o kwocie większej niż 1 milion okazji biznesowych, 2 to okazja biznesowa z szacowaną datą zawarcia umowy równą temu miesiącowi, a wynik przesiewania pokazuje okazje biznesowe większe niż 1 milion w tym miesiącu; gdy <span style="color: red">filtr zaawansowany jest włączony</span> Gdy trzeba ręcznie filtrować warunki w polu filtra zaawansowanego`,
"label.lead.score.confirm1":`Może to potrwać kilka minut. Po zakończeniu otrzymasz wiadomość e-mail z potwierdzeniem.`,
"label.scores":`Wyniki`,
"label.dashboard.message.mainnoset":`Tablica rozdzielcza główna nie jest skonfigurowana`,
"label.customfields.optionlist.fieldvaluelist":`Proszę wpisać wartości, każdą wartość oddzielając nowym wierszem`,
"label.autosearch.title":`Automatyczne wyszukiwanie tytułu prawnego`,
"label.knowledge.setting.hint.seventeen":`Stwórz kilka artykułów`,
"label_tabpage_closez":`Zamknij`,
"label.partnerCloud.orderingPlatform.shoppingCart":`Koszyk`,
"label.recalculate":`Przelicz`,
"label.umeng.approval.approvalmes4obj":`#numsucc rekordy zostały zatwierdzone w #obj, #numfailed reokrdy nie zostały zatwierdzone.`,
"label.appointment.wizard.subtitle2-2":`Do`,
"label.validate.function.funcExplain.AND":`Sprawdź, czy wszystkie parametry są prawdziwe. Zwróć TRUE jeśli wszystkie parametry są prawdziwe.`,
"label.recordtype.batchaddattachments.remark":`Krok 1 Wybierz plik, Krok 2 Archiwum, Krok 3 Kliknij przycisk "rozpocząć przesyłanie", przesyłanie plików, Krok 4 Kliknij przycisk, aby zakończyć.`,
"label.reportlist.findreport":`Znajdź raporty`,
"label.partnerCloud.financeSetting.enterAppsecret":`Proszę wpisać sekret aplikacji`,
"label.campagin.roi.query2":`Zobacz ROI z kanałów marketingowych`,
"label.sendmail.notice.immediately":`Wysyłanie powiadomień e-mail`,
"label.file.library.managemembers1":`Zarządzaj Członkami`,
"label.forecast.customforecast.foredis.yclb":`Kategoria prognozy`,
"label.no.target.model.available.":`Brak dostępnego modelu wskaźnika. Proszę najpierw utworzyć model wskaźnika lub skontaktować się z administratorem systemu.`,
"label.quote.contactname":`Nazwa kontaktowa`,
"label.customer.tab.step2.same":`Zastosuj widoczność jednej karty dla wszystkich profili`,
"UG_product_03":`Instrukcja obsługi cen w wielu walutach`,
"label.pc.system.prompt":`Prompt systemu`,
"homepage.components.description":`Składnik Opis`,
"front-email-payment-safety-code":`Kod bezpieczeństwa`,
"label.the.extra.reward.group.describes":`Dodaj opis grupy linii cytatu`,
"label.isEnableVisualpage.new.rightlist":`Aktywne strony niestandardowe`,
"label.icon.84":`Transformator`,
"label.chat.message.to":`Odbiorca`,
"lable.product.pricebooks.edit":`Edycja książki cenowej`,
"label.partner.workspace.member.belong":`Należy do`,
"pagecreator_systemstyle_message_delete_success":`Styl usunięty pomyślnie`,
"label.salescloud.teamrole.message.chooseatleastone":`Proszę wybrać przynajmniej jednego użytkownika.`,
"label.knowledgebase.self.window":`Identyczne okno`,
"label.product.cost":`Koszt`,
"label.imgfield.remove":`Czyste obrazy`,
"label.event.lastweek":`W ostatnim tygodniu`,
"template.report.today.statistics":`Sprzedaż w dniu dzisiejszym`,
"label.emailobject.recipients":`Recipients({0})`,
"vue_label_commonobjects_view_successfully":`Ustaw domyślny widok z powodzeniem`,
"label.uploadfail.typeerror":`Przesyłanie nie powiodło się, typ pliku jest nieprawidłowy.`,
"vue_label_lead_required_fields":`Proszę wypełnić wymagane pola`,
"front-console-reopen":`Ponownie otworzyć`,
"message.layout.unique.relatedlist":`Proszę powrócić do unikalnych ograniczeń powiązanej listy w układzie strony, proszę potwierdzić i zapisać ponownie.`,
"label.emailobject.emaildetail.nextactivity":`Następne działania`,
"label.publicgroup.save.error":`Błąd: jedna z poniższych grup jest już grupą nadrzędną dla tej grupy`,
"label.editdefaultshare.tip":`Poniżej edytuj domyślne ustawienia udostępniania dla całej organizacji. Zmiana tych ustawień spowoduje ponowne przeliczenie wszystkich reguł udostępniania. Może to wymagać znacznych zasobów systemowych i czasu w zależności od ilości danych w Twojej organizacji.`,
"label.icon.53":`Samochód`,
"label.exchange.sync.state.setting.m3":`Użytkownicy z połączonymi adresami e-mail Microsoft Exchange i CloudCC:`,
"label.currency.enable":`Waluty: Włącz walutę`,
"component.timeline.label.past":`Wcześniejsze działania`,
"workflow.action.tasks.assignortype.user":`Użytkownik`,
"setup_layout_label_relatedlistsetup":`Powiązane ustawienia listy`,
"label.systemadmin":`Administrator systemu`,
"label_tabpage_allz":`Wszystkie`,
"label.ems.subject":`Przedmiot:`,
"message.recordtype.selectlayout.tip":`Wybierz układ strony, który użytkownicy tego profilu widzą dla rekordów z tym typem rekordu. Po zapisaniu, wybierz wartości listy wyboru, które są dostępne dla tego typu rekordu.`,
"label.current.version":`Aktualna wersja programu`,
"label.sourceoffile":`Untranslated - Tworzy zestaw plików, według języków, z tekstem, który nie został jeszcze przetłumaczony.`,
"label.file.versionerror":`W nowej wersji interfejsu prosimy o korzystanie z zakładki funkcji plików`,
"label.validate.function.funcExplain.MINUTE":`Zwróć minutę dnia (z pól Data/Godzina)`,
"abel.setup.mobile.bottombutton.profile.setting":`Dostosuj dolne menu profilu`,
"label.recycle.dis.tip3":`Wybierz opcję My Recycle Bin z listy rozwijanej, aby wyświetlić usunięte przez siebie elementy. Administrator może wybrać opcję All Recycle Bin, aby wyświetlić wszystkie dane organizacji, które zostały usunięte.`,
"message.selectnothing":`Brak Wybrane`,
"label.develop":`Opracuj`,
"label.tab.lightningpage":`strona wersji błyskawicy`,
"label.chat.micropost.share.info":`Udostępnij`,
"label.block.pricing.editor":`Edytor cen bloków`,
"label.ccchat.file.unavailable":`Ten plik nie jest dostępny`,
"label_component_helper_businesschange_0UntreatActivity":`Możliwości bez działalności nieprzetworzonej`,
"label.search.setup.obj":`Można ustawić najwyżej 100 obiektów.`,
"component.setup.button.cancel":`Anuluj`,
"message.longtextareamaxlength":`Długość nie może przekraczać 32 000 znaków`,
"vue_label_chat_removedby":`Zostałeś usunięty z czatu grupowego przez "Administratora"`,
"label.autoRegister.changepwd.setpwd.tip.morechar":`Nie może być krótszy niż 8 znaków`,
"label.informassigner":`Powiadomić przydzieloną osobę`,
"font-evaluate-module-v1-not-received":`Nigdy nie otrzymuję żadnej oceny satysfakcji od kontaktów`,
"label.trigger.triggertime":`Czas wyzwalania`,
"label.attendance.cannot.make":`Nie można oznaczyć`,
"label.shouldallrecords":`Wszystkie zapisy powinny być uwzględnione w obliczeniach`,
"label.eidt.queue.alter1":`Proszę wybrać członków kolejki`,
"L":`Picklist`,
"label_emailtocloudcc_filed_email":`E-mail`,
"label.productsales.contract.badversion":`Twoja aktualna edycja nie obsługuje przeglądania przedmiotu umowy, więc nie możesz zobaczyć kwot umowy.`,
"label.tabpage.operation":`Operacja`,
"label.file.copy.public.link":`Link publiczny został skopiowany`,
"label.all.SMS":`ALL SMS Alerts`,
"UG_opportunity_008":`Zespół Możliwości`,
"UG.Campaign.002":`Planować, realizować i monitorować skuteczność działań rynkowych.`,
"label.jiandangfenpei.title":`Przydział profilu`,
"pagecreator.systemstyle.message.delete":`Czy usuwany jest aktualnie wybrany styl?`,
"lable.outlook.mcto.repeat":`Jeśli zostaną znalezione zduplikowane rekordy, wiadomość e-mail jest kojarzona z`,
"label.user.field":`Pola użytkownika`,
"vue_label_commonobjects_detail_market_hierarchy":`Hierarchia rynkowa`,
"label.ems.emails":`E-maile`,
"label.tabpage.deleteviewfailed":`Nie udało się usunąć widoku`,
"label.data.exp.new.expobjtemp":`Tworzenie szablonu eksportowanego obiektu`,
"label.useformulassetval":`Użyj formuł do wyznaczenia nowych wartości`,
"label.service.newBuildDialog.six.fields":`Można wybrać do 6 pól.`,
"error":`Błąd`,
"template.chart.sdyyfx":`Analiza Utraconego Rozumu`,
"label.icon.191":`Wąsy`,
"label.app.step3.tabused":`Wybrane zakładki`,
"label.user.level":`Poziom użytkownika`,
"label.custombutton.querydata.notexist":`Dane nie istnieją.`,
"label.executestate.calculating":`Obliczanie...`,
"label.visualpage.folder.notdel2":`1.Ten folder zawiera pliki i nie może być usunięty.2.Ten folder zawiera ukryte pliki i nie może być usunięty. Ukryty plik jest uwolniony od logicznego obiektu usuwania (usuń z Setup-Create-Obkects), który jest ukryty, ponieważ obiekt nie jest faktycznie usuwany.`,
"vue_label_report_conditiondesc_three":`Zostaniesz powiadomiony, jeśli wszystkie warunki zostaną spełnione`,
"approval.request.email.subect":`Wniosek o zatwierdzenie`,
"label.log.user.value":`Proszę podać nazwę użytkownika, aby móc szukać!`,
"label.isCompanyCurrency":`Corporate`,
"label.related.2018":`Powiązane listy`,
"label.tonga.time":`Czas Tonga`,
"message.actionfailed":`Działanie nie powiodło się`,
"label.’s":`'s`,
"label.custombutton.queryobj.notnull":`ID obiektu zapytania nie może być puste.`,
"label.list.userinterface.setup":`Interfejs użytkownika`,
"front-kefu-moudle-v1-yxgsbzq-reinput":`Format wiadomości email jest nieprawidłowy. Proszę wpisać ponownie`,
"label.chatter.content":`Treść`,
"label.projectManagement.Addnotes":`Dodaj notatki`,
"label.service.newBuildDialog.reservation":`Pokazywanie zamówionych`,
"label.ccchat.pm":`PM`,
"vue_label_chat_cannot_invite_users":`Osoby niebędące właścicielami grupy nie mogą zapraszać użytkowników do czatów grupowych`,
"label_partner_workspace_member_belong":`Należy do`,
"label.task.modify":`Zadanie Edycja`,
"label.tabpage.transformationsz":`Konwertuj`,
"label.new.password.no.indexof":`Nowe hasło nie może zawierać chińskich znaków i spacji.`,
"label.ji.quarter":`Nr {a} Kwartał`,
"label.sso.isActiveNo":`Nie`,
"label.mobile.phone.week.report":`Tygodniowe notatki z pracy`,
"label.email.template.please.select.folder":`Proszę wybrać folder`,
"label.pc.ui.2018.tab.groups":`Grupa menu`,
"label.h5.approval.status":`Status zatwierdzenia`,
"setup.mainpage.label.welcome27":`Platforma chmurowa CloudCC udostępnia takie funkcje jak import, eksport, wsadowe usuwanie i wsadowe przenoszenie wszystkich danych o obiektach w systemie.`,
"vue_label_systemSettings_setHomePage":`Konfiguracja Strona główna`,
"label.select.button":`Dostępne przyciski`,
"label_emailsync_status_enable":`Active Connect`,
"label.trigger.triggerVersion.detail":`To pole nie jest edytowalne. Istnieją obecnie dwie wersje wyzwalaczy, 1.0 i 2.0, a wszystkie nowe wyzwalacze są 2.0, wersja 1.0 została zakazana do tworzenia.`,
"pagecreator_layout_message_save_fail":`Nie udało się zapisać układu`,
"label.salescloud.salesdashboard.10big":`10 największych szans w ciągu najbliższych 3 miesięcy`,
"label.file.share.size":`Maxinum share i publiclink każdego pliku to`,
"label.page.simple":`Prosta`,
"pagecreator.page.message.delete":`Czy usuwasz aktualnie wybraną stronę?`,
"label.weixin.newspaper.coverage.detailinfo":`Szczegółowe informacje dotyczące arkusza ryzyka`,
"label.list.userinterface.chattersetup":`Ustawienia CCChat`,
"lable.opppdt.addpdt.table.quantity":`Ilość`,
"label.product.description":`Opis produktu`,
"button_partner_back":`Powrót`,
"label.user.current.loginuser.sessionid":`SessionID aktualnie zalogowanego użytkownika to:`,
"label.otherreport":`Inne sprawozdania`,
"pagecreator_button_mobilepage":`Mobile-side`,
"label.mobile.phone.state":`Status`,
"lable.currencyManage.unenableCurrencyAdv":`Wyłączyć Zaawansowane zarządzanie walutą.`,
"lable.product.addp":`Dodaj cenę`,
"label.field.validate.notpass":`Brak błędów składni.`,
"label.app.global.search.obj":`Można ustawić do 10 obiektów, które będą używane w wyszukiwaniu globalnym.`,
"label.group.archived":`Archiwum`,
"vue_label_approve_to_submit":`Do przedłożenia`,
"showfrom":`Pokaż od`,
"chatter.emailNotification":`Powiadomienia e-mail`,
"label.callcenter.pleaseenter.enterprise.number":`Proszę wpisać numer przedsiębiorstwa.`,
"label.forecast.customforecast.forecastnumber":`Prognoza Liczby`,
"label.vlidaterule.messagelocation":`Lokalizacja błędu`,
"label.h5.similar.opportunity.step3.conment":`Kolumna Trafność, która reprezentuje liczbę pasujących pól, będzie zawsze wyświetlana.`,
"label.ccchat.group.gd.setting.info":`Modyfikacja ustawień grupy CCChat`,
"label.knowledgebase.delete.article.succeeded":`Usuń artykuł pomyślnie`,
"message.layout.edit":`Zarządzanie układem strony jest oddzielną funkcją dodatkową. Jeśli Twoja organizacja potwierdzi, że zakupiła moduł funkcyjny, poproś administratora systemu o hasło. Skontaktuj się z CloudCC.com, aby dowiedzieć się więcej.`,
"label.case.create":`Tworzy się przypadek ({0})`,
"label.icon.170":`Zakupy`,
"message.error.contact.null":`Kontakt nie może być pusty`,
"label.appupload.install.error.hasinstalled":`Ten pakiet oprogramowania jest już zainstalowany w Twojej organizacji. przed zainstalowaniem nowej wersji, musisz najpierw odinstalować zainstalowaną wersję.`,
"label.service.miniProgram.imageType":`Obsługiwane są formaty PNG, JPG i JPEG. Zalecane są zdjęcia o wymiarach 750*349 pikseli. Najedź myszką na zdjęcie, aby je przeładować lub usunąć.`,
"label.leadscore.rule.edit":`Reguła Scoringowa dla leadów: Edytuj regułę`,
"vue_label_commonobject_anytime":`W każdej chwili`,
"label.clearing.conditions":`Jasne warunki`,
"label.campagin.roi.ydkhjhze":`Całkowita kwota wygranych szans dla klientów`,
"Lead_Auto_Scoring_Setting_001":`Automatyczny wynik podczas edycji lub zapisywania (z wyjątkiem leadów, które są importowane wsadowo lub tworzone przez interfejs)`,
"pagecreator.systemstyle.label.buttonareacolor":`Kolor obszaru roboczego`,
"label.batchregist.huanxinuser.finish":`Zakończono rejestrację użytkownika masowego`,
"UG_opportunity_006":`Geniusz możliwości`,
"message.serviceappo.violation":`Naruszenie terminu przydziału: koliduje z innym terminem usługi.`,
"label.recordtypeselect.selectnew":`Wybierz typ nowego rekordu`,
"Lead.Tools.BatchScoring":`Lead Batch Scoring`,
"label.partnerCloud.financeSetting.enterWechat":`Proszę wprowadzić konto handlowe WeChat.`,
"label.philippine.time":`Czas Filipin`,
"five":`Pięć`,
"label_average_value":`ŚREDNIA`,
"message.realdelete":`Jest pan pewien?`,
"label.currency.note":`Wprowadzić informacje dla nowej waluty. Należy pamiętać, że nie można usunąć waluty po jej aktywacji.`,
"label.projectManagement.delete.prompt":`Usuń monit`,
"label.approval.present":`(Current)`,
"label.escalation.setup.newrule.name":`Nazwa zasady`,
"label.edit.list":`Edytowalna lista danych`,
"label.partnerCloud.financeSetting.informationOne":`1. Odwiedź centrum handlowe Alipay (b.alipay.com) i zaloguj się za pomocą subskrybenta Alipay.`,
"label.customfields.numberText":`2.Suma długości wpisanej liczby i liczby miejsc po przecinku nie może przekroczyć 18 miejsc.`,
"label.biaoqing.businessverify.relation.tip":`Zapisuje zwróconą wartość bid&tender do pola lead`,
"label.icon.149":`Robot`,
"System.btn.SaveAndCommit":`Zapisz i prześlij`,
"label.calendar.many":`Wielu użytkowników`,
"label.ccchat.create.email":`Wiadomość email została utworzona.`,
"template.report.income.marketing.activities":`Sprawozdanie z dochodów z kampanii`,
"label.ccchat.person.invite.needemail":`Wprowadź adres e-mail.`,
"template.report.open.amount":`Kwota niezamknięta`,
"label.currentoperate":`Wybrane działania`,
"label.finalapprove":`Ostateczne zatwierdzenie`,
"label.emailmerge.mergepage.step2":`2. Wybierz szablon mail merge, maksymalnie 20:`,
"label_tabpage_sorttypez":`Typ sortowania`,
"label.workbanch":`Mój warsztat pracy`,
"font-evaluate-module-v1-disable":`Czy na pewno chcesz to dezaktywować？`,
"label.ServiceCloud.distributionMap":`Mapa rozmieszczenia`,
"lable.Confirm.potential.customers":`Potwierdź, aby zebrać {num} leadów.`,
"label.mobile.quickcreate.default.nearby":`W pobliżu`,
"label.isremider.noremider":`Brak przypomnienia`,
"label.approval.select.step":`Wybierz, który etap zatwierdzania ma zostać przywrócony`,
"chatter.error.pm":`Błąd: Rozmiar pliku jest zbyt duży.`,
"UG_activity_08":`Zarezerwuj harmonogram`,
"label.marketsea.notwinopportunitydays":`Liczba dni bez transakcji (musi być większa niż liczba dni bez tworzenia okazji biznesowych)`,
"label.selectpage":`Wybierz istniejącą stronę`,
"label.dashboard.dispalyOnTheHomePage":`Dispalyed Strona główna`,
"front-lightning-module-v1-details-page-chart-set-report":`Tworzenie raportu`,
"vue_label_pool_mydeal":`Moja umowa`,
"vue_label_report_lastone":`Ostatni`,
"label.tabpage.potentialcustomersz":`Leads`,
"font-evaluate-module-v1-more-satisfied":`Nie jesteśmy wystarczająco dobrzy。 Sprawimy, że następnym razem będziesz bardziej zadowolony!`,
"label.trigger.instructions":`<p>Instrukcje użycia：</p><p><li>Parametry mogą być cytowane bezpośrednio:(DataContext)context,(UserInfo)userInfo,(Map)record_old,(Map)record_new</li><li>Gdy chcesz uzyskać wartość rekordu proszę bezpośrednio "get" Nazwa API pola</li><li>Jeśli chcesz utworzyć nowy rekord, użyj "String id = IDGenerator.generateID("ID Prefix")"</li><li>Jeśli potrzebujesz zwrócić komunikat o błędzie, użyj "trigger.addErrorMessage("")";trigger powróci do bieżącej linii, nie będzie już wykonywany"</li></p><font color="red">Uwaga:Maksymalnie 200KB znaków, około 200,000 bajtów.</font><font size=3 color="red">【Key：Must Add Notes!】</font>`,
"lable.SalesCommitmentKanBan.commitmentToCompletionRate":`Stopień realizacji zobowiązań`,
"label.umeng.approval.dlsp.approvenew":`Zatwierdzenie delegowane: #actorname prosi o zatwierdzenie #objapiname#recordname`,
"label.edit.visualpagefolder":`Strona niestandardowa : Edytuj folder`,
"label.pc.flash.teach":`Wideo Nauczanie`,
"label.showsearch":`Pokaż wyszukiwanie`,
"label.reportsSubscriptionPage.condition.title1":`Zostaniesz powiadomiony, gdy wszystkie warunki zostaną spełnione (AND)`,
"label.h5.search.result":`Hrabia`,
"vue_label_commonobjects_view_chart_pie":`Wykres kołowy`,
"label_please_enter_currency":`Proszę wprowadzić walutę`,
"chatter.share.to.profile":`Twój profil`,
"label.mykeeptouchset":`Ustawienia usługi Keep In Touch`,
"label.profile.mustcopyaprofile":`Należy wybrać istniejący profil, z którego ma zostać sklonowany.`,
"label.managereport":`Zarządzaj raportami`,
"label.total.choice":`pliki, wybrane`,
"label_emailtocloudcc_help":`Proszę wprowadzić prawidłowe hasło e-mail lub kod autoryzacji. Jeśli Twój serwer poczty elektronicznej wymaga włączenia usługi IMAP/SMTP do logowania za pomocą konta innej firmy, musisz najpierw zalogować się do ustawień konta poczty elektronicznej, aby włączyć tę usługę, a następnie skopiować odpowiedni kod autoryzacji do pola wprowadzania hasła.`,
"label.trigger.sel":`Wyzwalacze w tym folderze`,
"label.dashboardLookUp":`Wyświetlanie pulpitów`,
"label.batchadd.newbatchpage.save.emptytext":`Prosimy o sprawdzenie, czy są jakieś wymagane informacje, które nie zostały wypełnione.`,
"setup.mainpage.label.welcome16":`Instrukcje: Kliknij w menu po lewej stronie strony → Ustawienia aplikacji → Utwórz → Przepływ pracy, Proces zatwierdzania, Zadania, Powiadomienia e-mail, Aktualizacja pól i inne.`,
"vue_label_email_mark as":`Zaznacz jako`,
"label.customobjdel.cannot.delete.try":`Obiekt nie może zostać usunięty, ponieważ jest powiązany z następującą relacją innych obiektów.`,
"label.customsetting.visible.public":`Publiczne`,
"label.log.bit":`Bity`,
"label.data.exportall.all.desc":`Eksportuje wszystkie dane dla wszystkich obiektów, które bieżący użytkownik ma uprawnienia do przeglądania.`,
"message.login.mfadevice.already.bound":`Użytkownik już powiązał urządzenie MFA.`,
"label.campaign.channel.please.img":`Proszę załadować obraz`,
"assetbom.manage.notpermission":`Prosimy o kontakt z administratorem w celu umożliwienia dostępu do zarządzania BOM aktywów.`,
"schedstarttime.schedendtime.time.illegal":`Planowany czas rozpoczęcia wizyty serwisowej powinien być krótszy lub równy rzeczywistemu czasowi zakończenia.`,
"label.referperson":`Właściciel`,
"front-email-payment-area":`Dzielnica`,
"label.c.d.least":`Każdy rekord "C" musi mieć co najmniej jeden powiązany rekord "D".`,
"label.weixin.longitude.isnull":`Długość i szerokość geograficzna są puste lub nieważne`,
"setup.layout.button.ok":`Potwierdź`,
"vue_label_fiter_component_date_customdate":`Data indywidualna`,
"label.enable.case.createarticle":`Pozwól użytkownikom na tworzenie artykułów z przypadków.`,
"label.event.moveup.8hour":`8 godzin do przodu`,
"label.input.most.string":`Proszę wpisać do {0} znaków`,
"lable.SalesCommitmentKanBan.contractEndDate":`Data zakończenia umowy`,
"label.visualpage.function.name":`Nazwij funkcję, która ma być:`,
"label_emailtocloudcc_redmessage1":`Nieprawidłowy adres e-mail`,
"message.aliasnameinput":`Błąd: Nazwa musi być unikalna i zaczynać się od litery. Musi zawierać tylko litery i cyfry.`,
"label.data.exp.selectedtemp":`Wybierz szablon używany do eksportu danych`,
"label.import.page1.suitedwayoflinkman":`Kontakt pasujący do stylu`,
"label.customsetting":`Ustawienia niestandardowe`,
"label.versiontype.Free":`Plan dowolny`,
"setup.layout.label.norelatedlist":`Brak powiązanych list`,
"label.forecast.edittotal.de.leiji":`Rollup z`,
"label.customfields.file.max":`Przesłany plik jest zbyt duży, proszę nie przekraczać 5m`,
"label_partner_all_workspace":`Miejsce pracy`,
"label.searchrelation":`Relacja Lookup`,
"label.icon.185":`Doradztwo`,
"label.service.gantt.effective":`Ważny`,
"label.newreportstp1":`Krok 1 Wybierz format tabelaryczny`,
"label.category.9":`Produkcja`,
"label.zuowei":`Jak`,
"front-quotation-v1-select-quota":`Wybierz ofertę`,
"label.dashboard.refresh":`Odśwież`,
"label.weixin.saveandnew.log":`Zapisz`,
"label.report.list":`Listy raportów`,
"FL":`Plik`,
"label.h5.followingcolleagues":`Koledzy odłogowali`,
"template.report.conversions.number":`Liczba konwersji leadów (wg właściciela)`,
"label.validate.function.funcFormat.MONTH":`MIESIĄC (data)`,
"front-kefu-moudle-v1-tenant-ID":`Identyfikator najemcy`,
"label.reportsSubscriptionPage.schedulereport.monthly.time":`Czas`,
"label.multilang.workflow.everyotherday":`Co {0} dni`,
"label.chat.message.send.message":`Wyślij informacje`,
"label.knowledgebase.fast.operation.error":`Szybkość działania Błąd`,
"label.multilang.dupicatecheck.dumplicatedata":`W {0} rekordach znaleziono łącznie {1} grup zduplikowanych danych spełniających warunek, a zapytanie trwało {2} milisekund. Na każdej stronie znajduje się {3} grup danych.`,
"vue_label_report_addFile_detail_Information":`Wyeksportuj tylko 2000 wierszy szczegółowych. Użyj tych danych do dodatkowych obliczeń lub prześlij je do innych systemów.`,
"label.ccchat.message.search.desc3":`Wskazówki dotyczące wyszukiwania`,
"message.deletereport.prompt":`Nie można usunąć tego raportu`,
"pagecreator.page.message.save.success":`Strona zapisana pomyślnie`,
"vue_label_rise":`Ascend`,
"label.appupload.install.error.choicehead":`Jak należy postępować w przypadku, gdy istniejące w systemie komponenty są sprzeczne z komponentami, które mają zostać zainstalowane?`,
"message.dispatch.violation":`Naruszenie czasu przydziału: okres przydziału nie mieści się w zakresie czasu pracy zasobów.`,
"label.tool":`Narzędzia`,
"label.sso.saml.idp.downloadcert":`Pobierz certyfikat`,
"label.chatter.detailinfo":`Szczegółowe informacje`,
"label.area.tree":`Terytoria Hierachy Widok na drzewa`,
"label.partnerCloud.priceOfManual.notEnabled":`Nie aktywować`,
"label.chosesubject.call":`Zadzwoń na`,
"label.leadscore.rule.detail":`Leads Scoring: Szczegóły reguły`,
"front-welcome-to-try":`Witamy na próbie`,
"label.umeng.activity.event.willbegin1":`Wydarzenie #event rozpocznie się za #czas.`,
"component.event.label.noevent":`Wygląda na to, że zakończyłeś swoją dzisiejszą pracę.`,
"label.document.templatesetof.folder":`Zestaw szablonów folderów`,
"label.quickbooks.none":`Nie znaleziono dopasowań，Proszę wpisać nazwę, aby wyszukać lub utworzyć nowego klienta`,
"label.assignment.setup.newrule.inputrule":`Wprowadź Nazwę reguły przypisania.`,
"label.appointmentdetail.wizard.title4":`Nazwa firmy`,
"label.malaysia.time":`Czas Malezji`,
"label.partnerCloud.partnerAccount.way":`Metoda uzupełniania`,
"label.roleoflinkman":` Kontakt Rola`,
"mesage.error.role.delate.user":`Rola nie może zostać usunięta, ponieważ ma przypisanych użytkowników.`,
"chatter.warning":`Ostrzeżenie: Jeśli wybierzesz inny obiekt, Twoje zmiany nie zostaną zapisane. Czy na pewno chcesz to zrobić?`,
"label.service.gantt.violations.sum":`Wizyty serwisowe z naruszeniem przepisów`,
"label.permission.objectpermission.recordfenpei1":`Przypisane typy rekordów`,
"label.mobile.phone.required.plan":`Plan jest wymagany`,
"label.after_leaving":`Aktualne dane nie zostaną zapisane po opuszczeniu`,
"label.cpq.opportunity.mainquote.trasnfer.order":`Odbyło się pierwotne notowanie w ramach możliwości i przeniesione do porządku.`,
"component.setup.iframe.label.title":`Dostosuj stronę`,
"visit.dispatchplatform.nopermission":`Odmowa zezwolenia: Nie masz uprawnień do dostępu do konsoli dyspozytorskiej. Proszę skontaktować się z administratorem.`,
"label.validate.function.funcExplain.RIGHT":`Zwraca określoną liczbę znaków od końca tekstu`,
"component.chatter.link.button.save":`Opublikuj`,
"label.knowledge.selection":`Dla każdej wiedzy można wybrać maksymalnie 8 grup danych.`,
"chatter.email.homePage":`Wyślij mi wiadomość na mojej stronie głównej CCChat`,
"vue_label_commonobjects_view_copy_view":`Widok kopiowania`,
"label.documentmessage":`Szczegóły dokumentu`,
"label.emailtocloudcc.step1":`Krok 1`,
"label.user.mfa.unbind":`Odblokuj MFA dla wybranych użytkowników`,
"label.stdashbord.xsld.business.sdzje":`Kwota ogółem (zamknięte - utracone możliwości)`,
"vue.please.select.the.total.method":`Proszę wybrać sposób sumowania.`,
"label.stdashbord.xsld.business.img1":`Liczba etapów z prawdopodobieństwem od 1% do 99%.`,
"label.reportsSubscriptionPage.condition.title":`Oprócz subskrypcji, możesz ustawić warunki dla tego raportu. Zostaniesz powiadomiony, gdy warunki zostaną spełnione. Jest to opcjonalne.`,
"chatter.sel.field":`Błąd: Wybrano więcej niż 20 pól.`,
"label.login.access.year":`Rok`,
"label.dashboard.all":`Wszystkie pulpity`,
"label.approver":`Zatwierdzający`,
"Lead.Homepage.Tools.BatchScoring":`Wynik partii`,
"lable.opppdt.selPdt.lesscondtions":`Mniejsza liczba filtrów`,
"label.integrations.action.export":`Eksport`,
"label.datamanage.lookupandsure":`(Zobacz i potwierdź)`,
"label.email.attach.to.mail":`Dołącz do wiadomości e-mail`,
"message.nodataordeleted":`Dane nie istnieją lub zostały usunięte`,
"component_newrecords_label_all":`Zobacz wszystkie`,
"lable.currencyAdv.startdate.rate":`Pokaż wszystkie stawki zdefiniowane dla daty początkowej w następującym zakresie`,
"label.callbackoperate":`Działania związane z wycofaniem produktu z rynku`,
"label.knowledge.setting.hint.eighteen":`Zacznij tworzyć artykuł do wiedzy`,
"label.user.step4.submit.email":`Krok 4 Twój wniosek o wysłanie wiadomości e-mail został złożony.`,
"label.appointment.wizard.subtitle4-1":`Czas przejazdu między imprezami`,
"component.assistant.button.newtask":`Nowe zadanie`,
"label.icon.129":`Karta`,
"label.relatedlist":`powiązane listy`,
"label.report.recently":`Ostatnio oglądane`,
"label.batchadd":`Mass Add`,
"front-template-V1-Delete-succeeded":`"{currentTelmplateName}" został pomyślnie usunięty.`,
"label.appupload.upload.otherdetail":`Dodatkowe informacje`,
"label.emailobject.link":`Link:`,
"label.quickbooks.createcustomer":`Tworzenie klienta w QuickBooks`,
"report.label.projectcount":`elementy, sortowanie według nazwy raportu`,
"vue_label_normal_contact_sf":`Kontakt`,
"chatter.group.groupActivities":`Wszystkie grupy`,
"label_tabpage_addoptionsz":`Dodaj opcje`,
"label.knowledgebase.submit.for.translation":`Zgłoś się do tłumaczenia`,
"vue_label_pool_notallowed":`Charakter działalności nie jest dozwolony`,
"label.icon.80":`Papiernictwo`,
"label.readonlys":`Tylko do odczytu`,
"label.recordsediting":`Możliwość edycji zapisów`,
"label.mr.title.email":`E-mail`,
"label.partner.all.enable":`Włącz`,
"label.customsetting.manage.errmessage":`Utrzymuj pola niestandardowe zanim zaczniesz zarządzać danymi.`,
"label.cloudccclass.list.cls":`Klasa`,
"label.weixin.click.loadall":`Kliknij, aby załadować wszystkie`,
"label.weixin.appr.initialtime":`Czas przedłożenia`,
"UG_ST_002":`Określić`,
"setup_mainpage_label_welcome17":`Ustawienia uprawnień`,
"label.appupload.state0":`Nie przesłano`,
"label.icon.115":`Dom`,
"setup_mainpage_label_welcome5":`Pole niestandardowe`,
"lable.custom.year.ovdate":`Niestandardowa data zakończenia roku`,
"label_tabpage_findz":`Szukaj`,
"label.appupload.uploading":`Przesyłanie...`,
"setup.mainpage.label.welcome1":`Potrzeba odpowiedniego pozwolenia`,
"label.file.folder.delete2":`Usunąć bibliotekę?`,
"2018UI_Homepage_DataNoAccess_Info":`Nie masz uprawnień do przeglądania tego rekordu, kliknij, aby powrócić do poprzedniego kroku.`,
"label.ems.google":`Google`,
"label.hawaii.aleutian.standard.time":`Czas standardowy Hawaje-Aleutyjski`,
"template.report.unfinished.tasks":`Zadania niezakończone`,
"vue_label_calendar_add_calendar":`Dodaj kalendarz`,
"label.button.sel.useremail":`Wyślij wiadomość e-mail do wybranych użytkowników`,
"user.email.template":`Dear{username}：<br>Kod zaproszenia dla [{Campaign.name}] jest następujący<br>{Campaign.ColleagueInvitationLetter}<br>a adres URL to：<br>{Campaign.ColleagueInvitationLetterLink}<br>Rejestracja kodu QR i rejestracja linku URL są obsługiwane dla obecnej kampanii! Dzięki za wsparcie! <br>Marketing Executive:{Kampania.Właściciel}`,
"label.forecast.settings.shouru":`Dochody`,
"label.casesensitive":`Traktuj "ABC" i "abc" jako różne wartości (wielkość liter ma znaczenie)`,
"message.pleaseinputrightdistanceweek":`Proszę wpisać właściwy tydzień przerwy.`,
"label.linellae-group":`grupowanie kolumn`,
"label.showdefault_times":`Pokaż domyślny czas publikacji`,
"label.smstemplate.finishmessagedetailinfo":`Uzupełnij szczegóły szablonu SMS`,
"label.service.miniProgram.backgroundImage":`Obraz tła`,
"label.recentview.news":`Ostatnie zapisy`,
"label.reportType.chose.and.form":`Wybierz źródło danych raportu i format raportu`,
"setup.layout.button.additem":`Dodaj wybrane elementy`,
"front-epwechat-module-v1-auto-mate":`Automatch`,
"vue_label_helpcenter_contract&plan":`? Kontrakt jest pisemną umową pomiędzy stronami. Wiele firm używa kontraktów do określenia warunków prowadzenia interesów z innymi firmami. Użyj Cloud CC do ustanowienia i udokumentowania istniejących umów z klientami i możliwościami biznesowymi. Śledź umowę poprzez proces zatwierdzania.<br>?Wspomagaj funkcję kontraktu i zarządzaj transakcjami poprzez plan windykacji.`,
"label_mobile_version_nonsupport_feature":`Ta funkcja nie jest obsługiwana w obecnej wersji. Proszę zaktualizować do najnowszej wersji.`,
"label.icon.44":`Ogień`,
"label.data.downpage.i.title.num3":`3、BBefore import, upewnij się, że importujesz wszystkie powiązane rekordy. Na przykład: jeśli istnieje relacja lookup pomiędzy obiektami, które obecnie importujesz, a kontaktami, powinieneś najpierw zaimportować kontakty, a następnie zaimportować swoje dane.`,
"label.mr.object.customer":`Konta`,
"label.social.user.null":`Informacje o użytkowniku w Social nie mogą być puste`,
"front-epwechat-module-v1-unbound-item2":` wszystkie dane ustawień aplikacji`,
"label.partnerCloud.partnerAccount.noempty":`Kwota doładowania nie może być pusta.`,
"label.weixin.myapproval":`Moje zatwierdzenia`,
"label.data.setok.e_desc1":`Sukces eksportu, otrzymasz wiadomość systemową alerty, dane pochodne są tymczasowo przechowywane na serwerze, system tylko dla Ciebie, aby zapisać 48 godzin, proszę jak najszybciej do`,
"lable.batchadd.service.cfq.after":`Wyzwalacze (po wstawieniu)`,
"label.umeng.activity.youhaveanevent":`Masz nowe wydarzenie.`,
"label_emailsync_status_connectaccounts":`Podłączone konto e-mail`,
"label.multilang.shenpi.count":`W sumie {0} rekordów：`,
"pagecreator.page.message.delete.fail":`Usuwanie strony nie powiodło się`,
"label.version.sum.lookupmdfield":`Pola relacji mistrz - szczegół`,
"vue_label_pool_clueduplication":`Duplikat podpowiedzi`,
"label.system.setup.log":`Dziennik zachowań systemowych`,
"label.globaloperation.operationtype.send.e-mail":`Wyślij e-mail`,
"vue_label_pricebook_entry":`Nowy wpis do cennika`,
"label.forecast.forehistory.submit.date":`Zgłoszony Data/Godzina`,
"chatter.handle":`Nad czym pracujesz?`,
"lable.SalesCommitmentKanBan.complete":`Kwota zrealizowana`,
"label.weixin.upload.pictures":`Prześlij obraz`,
"label.create.document":`Nowy dokument`,
"vue_label_commonobjects_detail_unlockconfirm":`Potwierdzić odblokowanie?`,
"label.customer.page":`Własne zakładki strony`,
"button.partner.workspace.saveas":`Zapisz jako`,
"setup.layout.label.asc":`Wstępna`,
"label.ccpeak.folder.time":`Niewypełnione foldery zajęć planowych`,
"label_tabpage_includez":`Włącz`,
"label.custom.button":`Własne przyciski`,
"label.weixin.binding":`Bind`,
"P":`Procent`,
"chatter.stop.n":`Przestańcie śledzić ten zapis`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.wednesday":`Środa`,
"template.report.revenue.marketing.activities":`Przychody z kampanii`,
"lable.SalesCommitmentKanBan.theActualReceipts":`Faktyczne wpływy`,
"vue_label_popularresults":`Popularne Wyniki`,
"label.log.belongs":`Część podrzędna`,
"label.profile.remark":`Użytkownicy z tym profilem mają uprawnienia i układy stron wymienione poniżej. Administratorzy mogą zmienić swój profil poprzez edycję danych osobowych użytkowników.`,
"label.appupload.component.type.button":`Przycisk`,
"label.partner.all.operate":`Operacja`,
"vue_label_notice_modify_fail":`Nie edytować`,
"label.icon.137":`Ziemia`,
"front-dialog-module-v1-nosupport-copy":`Klonowanie nie jest obsługiwane`,
"label.integrations.mailchimp.massage3":`Integracja pomyślnie odinstalowana`,
"UG.opportunity.010":`Tworzenie transakcji`,
"front-lightning-module-v1-details-page-chart-selecting-reports":` Można wybrać tylko raporty publiczne, tzn. raporty z dostępem dla wszystkich użytkowników, oraz raporty publiczne niezłożone.`,
"System_btn_SaveAndCommit":`Zapisz i prześlij`,
"vue_label_dashboard_statisticaltype":`Proszę wybrać typ statystyczny`,
"label.mr.object.opportunity":`Możliwości`,
"label.area.detail.remark":`Wyświetl użytkowników na tym terytorium`,
"label.view.sortview.index":`Zamówienie`,
"label.mobile.quickcreate.default.events":`Wydarzenia`,
"label.product.price":`Cena sprzedaży`,
"label.leadmarketsea.edit.title":`Lead Pool Edit`,
"pagecreator.layout.button.edit":`Edytuj układ`,
"label.addressee":`Odbiorcy`,
"label.movablesearchlayout":`Układy wyszukiwania wg aktywności`,
"label.ems.confirm":`Potwierdź`,
"vue_label_file_save_to_file":`Zapisz do pliku`,
"component_chatter_button_more":`Zobacz więcej szczegółów`,
"label.ccdocument.hidden.trace":`Ukryty ślad`,
"label.partnerCloud.maximumTwo":`Obsługiwany jest plik o maksymalnej wielkości 2M.`,
"label.event.moveup.4hour":`4 godziny naprzód`,
"label.batchadd.save":`Dodaj awarię udostępniania`,
"label.passwordPolicy.setup.expireDate":`Hasło użytkownika wygasa w`,
"label.workflowrule":`Zasady przepływu pracy`,
"vue_label_notice_pleaseselecview":`Proszę wybrać widok`,
"label.h5.chatter.colleagues":`O kolegach`,
"lable.opppdt.addpdt.subtitle":`Dodaj produkt do`,
"label.data.import.setup.repeat.no":`Nie - Wstaw wszystkie rekordy do mojego pliku importu.`,
"label.changeCorporate":`Zmiana waluty przedsiębiorstwa`,
"label.customfields.dateandtime.tip":`Umożliwia użytkownikom wprowadzenie daty i godziny lub wybranie daty z wyskakującego kalendarza. Kiedy użytkownik kliknie datę w oknie podręcznym, ta data i aktualny czas są wprowadzane do pola Data/Godzina.`,
"label.integrations.mailchimp.massage1":`Proszę wybrać co najmniej 1 rekord do eksportu`,
"lable.PowerProcess.custom":`W oparciu o niestandardowe warunki`,
"label.service.editDialog.displays.service.appointmentsFordays":`Pokaż terminy serwisowe na {} dni przed datą poziomu i {} dni po dacie poziomu.`,
"label.Receivables.ActualMoneyTime":`Rzeczywista data uzyskania`,
"label.matrixreport.intro":`Raporty macierzowe pokazują dane zbiorcze obliczone w ujęciu poziomym i pionowym w formie siatki.`,
"message.validation.isnotnumber":`Proszę wprowadzić nieprawidłowy numer.`,
"label.partner.workspace.member.search":`Szukaj`,
"label.customfields.deletewill":`Usunięcie pola niestandardowego spowoduje:`,
"label.content":`Treść`,
"component.setup.button.weburl":`Zewnętrzny adres URL`,
"setup.mainpage.label.welcome28":`Instrukcje: Kliknij w menu po lewej stronie tej strony → Zarządzaj ustawieniami → Zarządzanie danymi → Import i eksport danych, Transfer wsadowy, Usuwanie wsadowe.`,
"label.related.setup":`Ustawianie zadań i zdarzeń`,
"label.weixin.sign":`Drogi, już się zalogowałeś, nie ma potrzeby robić tego ponownie.`,
"label.norecord":`Brak zapisów`,
"label.emailmerge.detail.emailtempldatemerge":`Szablony Mail Merge`,
"label_emailsync_status_role":`Rola`,
"label.mobileapp.modelsetting2":`Wybierz moduły, które spełniają Twoje potrzeby biznesowe<br>Activate：allows wybrane moduły, aby pokazać w More Standard Function<br>Deactivate: wybrane moduły nie będą mogły być wyświetlane w More  Standard Function.`,
"component.sendmail.label.title":`Wyślij e-mail`,
"component_assistant_button_newevent":`Nowe wydarzenie`,
"label.chatter.input":`Proszę wprowadzić treść`,
"message.error.view.operate.rtnlink":`Kliknij<a href='javascript:history.back();'>tutaj</a> aby powrócić.`,
"lable.new.profile":`Nowy profil`,
"label.custom.field.null":`Nie ma dostępnych`,
"label.reportsSubscriptionPage.schedulereport.weekly.saturday":`Sobota`,
"label.stdashbord.xsld.business.img4":`Całkowita liczba etapów o prawdopodobieństwie 100%`,
"pagecreator_layout_button_splitall":`Rozdzielić wszystko`,
"label.mobile.phone.total.amount":`Łączna kwota (dziesięć tysięcy)`,
"label.ratifyhistory":`Historia zatwierdzenia`,
"label.projectManagement.Antecedents":`Zadanie wstępne`,
"label.projectManagement.Newserviceappointment":`Nowa nominacja serwisowa`,
"label.delete.record.is.approval":`Rekordy, które chcesz usunąć są proszone o zatwierdzenie, czy na pewno chcesz je usunąć?`,
"front-gantt-module-no-tasks-describe":`Na wykresie Gantta można zobaczyć, jak elementy pracy są zorganizowane w czasie, jak się pokrywają i jak są ze sobą powiązane.`,
"vue_label_visualize_data":`Dane z TianYanCha są wypełnione. Proszę zapisać zmiany.`,
"UG.activity.02":`Przydzielanie zadań`,
"label.field.duplicate2":`Nie wolno powielać wartości`,
"label.cloudccclass.list.tip":`Umożliwia programistom tworzenie klas na platformie CloudCC.com, które mogą być używane do dostosowywania stron i wyzwalaczy.`,
"before":`Przed`,
"UG.ST.001":`Prompt`,
"label_tabpage_userGuidez":`Podręcznik użytkownika`,
"vue_label_account_looking_for":`Proszę wpisać, czego Państwo szukają`,
"vue_label_calendar_notice_timecantmove":`Czasu w kalendarzu nie można zmienić przez przeciąganie`,
"label.mobile.phone.enter.summary":`Wprowadź swoje podsumowanie`,
"label.object.api.existed":`Nazwa API tego obiektu już istnieje, proszę zmienić inną nazwę API.`,
"label.weixin..xsld.order.by.time":`Order By Close Date`,
"label.h5.chatter.whether":`Czy`,
"label.file.delete.success":`Plik usunięty pomyślnie`,
"label.imgfield.type.url.tip1":`Użytkownik może podać link odwołujący się do obrazka, a także ustawić jego rozmiar poprzez dodanie`,
"label.tomanyrecords":`Ponad 5.000 pozycji w formularzu.`,
"label.save.partnercloud":`Błąd podczas zapisywania danych w chmurze partnerskiej`,
"vue_label_homepage_fliteritems":`Filtrowanie elementów konfiguracji`,
"pagecreator_page_button_new":`Nowa strona`,
"label.sharerule.baseofcondition":`W oparciu o kryteria`,
"label.dashboard.snapshot":`Zrzuty z tablicy rozdzielczej`,
"label.appointmentpage.wizard.subtitle1.1":`Wybierz datę i godzinę`,
"label.reportsSubscriptionPage.condition.emailsummary":`Tylko podsumowanie`,
"chatter.group.showAll":`Pokaż wszystko`,
"label.tabpage.helpNavigationz":`Pomoc i nawigacja`,
"label.emailtocloudcc.button.back":`Anuluj`,
"approval_request_email_subect":`Wniosek o zatwierdzenie`,
"label.lookup.error":`Wystąpił błąd podczas wyszukiwania`,
"label.publicgroup.save.groupisnull":`Dane grupy są puste podczas zapisywania. Proszę zapisać je ponownie. Jeśli nadal występuje błąd, proszę skontaktować się z administratorem.`,
"label.pie":`Wykres kołowy`,
"chatter.feed.is":`to sieć korporacyjna, która umożliwia użytkownikom współpracę, rozmowy i współdzielenie informacji w czasie rzeczywistym.`,
"label.customfields.file.max5m":`Maksymalny rozmiar pliku to 5m.`,
"com.cloudcc.login.error.message.vaildauthfail":`Nieprawidłowe uwierzytelnienie logowania`,
"label.profile.appsetuppermission":`Zarządzanie ustawieniami aplikacji`,
"label.customfields.file.totalmax":`Przesłany plik jest zbyt duży, proszę nie przekraczać 500m`,
"label.sms.list":`Lista interfejsów SMS`,
"message.error.referencedcolumnIdnotexist":`Pola referencyjne raportu zostały usunięte i nie mogą być poprawnie wyświetlane. Prosimy o kontakt z administratorem w celu uzyskania pomocy.`,
"front-lightning-module-v1-details-page-chart-setting-chart":`Ustawianie wykresu raportu`,
"label.recordtype.profile.enables":`Obecnie dostępne typy rekordów`,
"chatter.this.n":`ten zapis`,
"label.only.upload.file":`Dozwolony jest tylko plik jpg/png i nie większy niż 500kb.`,
"vue_label_lead_conversion_failed":`Konwersja nie powiodła się`,
"label.file.share.file.success":`Pomyślne udostępnianie plików`,
"label.processsetting.delete.process":`Czy na pewno chcesz usunąć ten proces?`,
"message.uniquenamevalidate":`Musi zaczynać się od litery. Musi zaczynać się od litery. Musi zawierać tylko litery, cyfry i podkreślenia.`,
"label.group.archived.desc.info":`Ta grupa została zarchiwizowana, więc nie można tworzyć nowych postów ani udostępniać plików w tej grupie. włączenie grupy umożliwia korzystanie ze wszystkich funkcji.`,
"label.customer.maincontact":`Główny kontakt`,
"label.appointment.wizard.subtitle1-9":`4 h`,
"label_productline_income":`Seria produktów Przychody`,
"label.dashboardSetup.tz.ybb":`Przejdź do Dashboardów`,
"label.recordowner":`Właściciel zapisu`,
"message.approval.othersdoing":`Ktoś inny pracuje nad tym procesem, proszę odświeżyć, aby uzyskać najnowsze dane.`,
"Opportunity_Detailed_Phase_Label_002":`{0} dzień(y) w bieżącym etapie`,
"label.field.validating.rule.isnot.passed":`Kompilacja reguły walidacji nie powiodła się, proszę sprawdzić składnię.`,
"label.textmessage.fieldskong":`Niektóre pola w wiadomości są puste, proszę edytować i wysłać ponownie!`,
"com.cloudcc.login.error.message.islocked":`Twój identyfikator jest zablokowany`,
"label.forecast.customforecast.foredis.debfb":`% kwoty`,
"lable.opppdt.selPbk.changepbk.worning":`Zmodyfikuj cennik dla tej okazji, a produkt związany z tą okazją zostanie usunięty. Czy jesteś pewien?`,
"label.mr.backLookReData":`wstecz, Wyświetlanie listy zduplikowanych danych`,
"label.quickbooks.searchqb":`Wyszukaj QuickBooks`,
"label.service.gantt.searchSkills":`Umiejętności wyszukiwania`,
"label.account.Current.and.NexttFQ":`Bieżące i następne 3 FQ`,
"customer.notopen.chat":`Organizacja nie włączyła funkcji czatu, prosimy o kontakt z administratorem`,
"vue_label_commonobjects_view_sum":`Łącznie {całkowicie} rekord(y)`,
"label.partnerCloud.orderingPlatform.adjust":`Dostosuj Zamówienie Produkt`,
"label.emailmerge.mergeFolder.tips":`Na tej stronie można wygenerować plik Microsoft Word z danymi kontaktowymi. Proszę wybrać szablony wiadomości email, które mają zostać połączone, maksymalnie można wybrać 20 szablonów.`,
"vue_label_ccchat_notice_deletecommentfail":`Nie udało się usunąć komentarza`,
"label.emailsync.status":`Status e-mail użytkownika`,
"label.forecast.forecastroleuserpage.desc":`Przydziel do tej roli menedżera prognoz. Prognozy jego podwładnych będą agregowane w prognozy jego kierownika.`,
"label.step1.total4":`Krok 1 z 4`,
"front-kefu-moudle-confirm-fjcase":`Czy na pewno podzielić ten przypadek`,
"label.icon.60":`Dźwig`,
"label.appointmentpage.wizard.subtitle3":`Wpisz swoje dane`,
"label.loginservice.license.exceed.time":`Licencja wygasła.`,
"label.customcomponent.check.tag.lastrow":`Ostatnim wierszem musi być`,
"label.product.code":`Kod produktu`,
"label.salescloud.salesdashboard.phone":`Telefon`,
"label_please_input_price_list_price":`Proszę podać cenę katalogową.`,
"label.multilang.page3":`strona(y)`,
"label.file.lastmodifydate":`Czas zmodyfikowany`,
"label.icon.121":`Komputer`,
"message.error.system.service.unknow":`Nieznane usługi, proszę skontaktować się z administratorem.`,
"label.thesecond":`2. kolumna`,
"vue_label_report_conditiondesc_two":`Dodaj warunki do tego raportu`,
"label.exchange.serverUrl":`Adres serwera`,
"RL":`odnośnik`,
"label.emailobject.emailsend.sendindividuallyprompt":`Każdy paragon otrzyma wiadomość wysłaną tylko do niego. Czy jesteś pewien?`,
"label.appointmentconfirmpage.wizard.subtitle4":`Uczestnicy`,
"message.save.opportunity.team.save.failed":`Grupa możliwości biznesowych nie powiodła się`,
"vue_labenl_normal_notice_share_success":`Wspólne z sukcesem`,
"label.triggerfolder":`Foldery wyzwalaczy`,
"label.more":`Więcej`,
"label.file.num":`Ilość`,
"label.dashboard.list.sortBy":`element(y), sortowanie według czasu dostępu`,
"c":`Waluty`,
"label.weixin.detail.edit":`Edytuj`,
"label.escalation.setup.newentries.step2":`Krok 2 Wybierz kryteria dla wpisu tej reguły`,
"label.report.error.prompt":`Konfiguracja nie powiodła się. Obsługiwany jest tylko raport seryjny z zestawem wierszy. Proszę upewnić się, że jest to raport publiczny i nie został usunięty!`,
"label.notification.new":`Nowy`,
"label_tabpage_releaseTourz":`Opublikuj przewodnik`,
"label.icon.41":`Pozycjonowanie`,
"label.sendsms.hello.new":`Witaj, masz nowy`,
"label.custom.combination":`Połącz`,
"label.project.hit.fifteen":`Zawiadomienie o przydzieleniu kamieni milowych`,
"label.campaign.channel.step6.mobile":`Wygeneruj stronę mobilną`,
"label.goback.N.step":`Powrót do poprzedniego kroku N`,
"label_partner_all_name":`Nazwa chmury partnerskiej`,
"label.usermanage.loginusername.exist":`Nazwa użytkownika już istnieje.`,
"template.chart.cpxse":`Sprzedaż produktów`,
"chatter.feed.deletecomments":`Czy na pewno chcesz usunąć ten komentarz?`,
"label.list.userinterface.show.newrcords.enable":`Wyłączenie ostatniego zapisu`,
"label.sso.saml.idp.config.enablelogout":`Włącz pojedyncze wylogowanie`,
"label.file.library.create":`Nowa biblioteka`,
"label.event.moveup.half.day":`0,5 dnia naprzód`,
"label.stdashbord.xsld.business.jhzje":`Całkowita kwota możliwości`,
"label.partnerCloud.orderingPlatform.unitPrice":`Koszt jednostkowy`,
"label.recordtype.edit.attribute":`Właściwości ogólne`,
"front-template-V1-TemplatePreview":`Podgląd szablonu`,
"label.tabpage.personalCenterz":`Centrum osobiste`,
"label.setuplookuplayout":`Układy wyszukiwania`,
"label.no.merge.records":`Nie można łączyć żadnych rekordów`,
"label.attachementNew.set2":`Krok 2 Archiwum`,
"label.publicgroup.detail.showmembers":`Wyświetlanie członków grupy`,
"UG.Forcast.03":`Zacznij planować i realizować strategie biznesowe. <br>Życzę udanej prognozy!`,
"label.h5.manageprompt":`Wybierz kartę, aby dodać stronę główną, lub kliknij kartę, aby ją otworzyć.`,
"label.icon.145":`Powiązane`,
"label.select":`Wybierz`,
"label.publicgroup":`Grupy publiczne`,
"label.customcomponent.usewhere.title":`Gdzie ten komponent jest używany:`,
"label.custom.page.button.name":`Przycisk Nazwa`,
"pagecreator_layout_button_vertical":`Demontaż wzdłużny`,
"label.marketsea.autorecyclerule":`Automatyczne zasady recyklingu`,
"label.reportsSubscription.entrance.attachment":`Format Excel .xlsx`,
"component_chatter_button_collect":`Zakładka do książki`,
"label.page.step2.of.step5":`Krok 2 z 5`,
"label.reportsSubscription.addfile.helptext":`Można ustawić, czy załączniki raportów mają być dodawane do e-maili z subskrypcją, oraz format załączanych raportów.`,
"label.oldpw":`Stare hasło`,
"lable.SalesCommitmentKanBan.contractAmount":`Podpisana kwota`,
"lable.Bundle":`Pakiet Superior`,
"label.weixin.unit.million":`Jednostka (dziesięć tysięcy juanów)`,
"label.app.choseprofile":`Przypisz profil`,
"label_tabpage_editz":`Edytuj`,
"label.email.attachement.size.info":`Plik nie może być większy niż`,
"label.chatter.pastSevenday":`W ciągu ostatnich 7 dni`,
"label.weixin.end.later.start":`Data końcowa musi być późniejsza niż data początkowa.`,
"label.passwordPolicy.setup.lockoutPeriod":`Okres obowiązywania blokady`,
"pagecreator_page_funcpath":`/ konstruktor / lista stron`,
"label.emailobject.apperror":`Usługa pocztowa nie jest dostępna, prosimy o kontakt z administratorem.`,
"label.custom.page.button.broadband":`Rozmiar przycisków (piksele)`,
"label.weixin.contract.rate":`Wskaźnik realizacji umowy`,
"label.brief.payments":`Płatności`,
"lable.approvaldatamove.transfermsg":`Masowe przenoszenie wszystkich oczekujących wniosków o zatwierdzenie do nowego użytkownika`,
"label.datamanage.account.namenull":`Uwaga: Jeśli pole nazwa konta jest puste, rekord nie zostanie zaimportowany.`,
"lable.SalesCommitmentKanBan.allTotalPaymentAmount":`Całkowita kwota wpływów Rollup`,
"Opportunity_Detailed_Phase_Label_001":`Scena`,
"vue_label_helpcenter_calendar2":`<Kalendarze obiektowe: Kalendarze, które tworzysz z obiektami wyświetlają dane rekordu jako pozycje kalendarza w polu daty na widoku kalendarza. Możesz edytować lub usunąć kalendarze obiektów, a także dostosować kolor dla każdego kalendarza obiektu. <br> Nowe zdarzenie<br> Możesz utworzyć nowe zdarzenie w widoku kalendarza na dwa sposoby. <br> (1) Kliknij przycisk Nowe zdarzenie w prawym górnym rogu widoku kalendarza, aby utworzyć nowe zdarzenie. W nowym wydarzeniu można powiązać wydarzenie z innymi obiektami, takimi jak możliwości biznesowe, wybierając inne obiekty w polach Elementy powiązane i Nazwa. Rekordy zdarzeń, które są powiązane z innymi obiektami są synchronizowane w module Aktywność na stronie szczegółów innych obiektów. <br> (2) Możesz też utworzyć nowe wydarzenie, klikając na siatce kalendarza. <br> Nowy Kalendarz Obiektów<br> Krok 1: Kliknij zakładkę Kalendarz w menu nawigacyjnym, aby przejść do strony widoku Kalendarza. <br> Krok 2: Znajdź Moje kalendarze po prawej stronie widoku, kliknij ikonę obok Moje kalendarze i przejdź do okna wyskakującego Nowy kalendarz obiektu. <br> Krok 3: Zacznij od nadania nazwy tworzonemu kalendarzowi obiektowemu. Wybierz obiekt, który jest podstawą kalendarza i zaznacz pola określające zawartość wyświetlanego kalendarza: "Pole Start", "Filtr widoku", "Pole wyświetlania". Pole Start określa zakres czasu, w którym wyświetlane są dane, można filtrować dane za pomocą filtrów widoku, a pole Wyświetlanie określa, co jest wyświetlane w pozycji kalendarza. <br> Inne kalendarze<br> Inne kalendarze zawierają kalendarze innych dodanych użytkowników. Możesz dodać kalendarze osób, które są Ci podległe i współdzieliły z Tobą kalendarz. <br> Share My Events Calendar<br> Krok 1: Kliknij zakładkę Kalendarz w menu nawigacyjnym, aby przejść do strony widoku kalendarza. <br> Krok 2: Znajdź Moje wydarzenia po prawej stronie widoku kalendarza pod Moje kalendarze, kliknij przycisk rozwijany po prawej stronie Moje wydarzenia, i wybierz Udostępnij kalendarz. <br> Krok 3: W oknie podręcznym Udostępniony kalendarz wybierz użytkowników i prawa dostępu, którym chcesz udostępnić kalendarz. Ponadto, można również zobaczyć swoje wspólne rekordy kalendarza klikając na "Kto ma obecnie dostęp" i usunąć wspólne rekordy klikając na ikonę "x" po prawej stronie wspólnych rekordów. <br> Po udostępnieniu kalendarza Twoi podwładni mogą dodawać Twój kalendarz wydarzeń do innych kalendarzy, a następnie przeglądać Twój kalendarz wydarzeń. <br> Dodawanie kalendarza<br> Krok 1: Kliknij zakładkę Kalendarz w menu nawigacyjnym, aby przejść do strony widoku kalendarza. <br> Krok 2: Kliknij przycisk rozwijany dla innych kalendarzy po prawej stronie widoku kalendarza i wybierz Dodaj kalendarz. <br> Krok 3: W oknie wyskakującym Współdzielone kalendarze, wybierz kalendarze wydarzeń osób, które chcesz dodać. Możesz wybrać kalendarze wydarzeń swoich podwładnych, jak również kalendarze wydarzeń, które są udostępnione do Ciebie. Kliknij przycisk Dodaj, aby pomyślnie dodać kalendarz. <br> Usuń dodany kalendarz<br> Kliknij przycisk rozwijany po prawej stronie kalendarza, który chcesz usunąć, poniżej innych kalendarzy i wybierz opcję Usuń.`,
"label.callcenter.Seat.number":`Numer miejsca siedzącego`,
"vue_label_commonobjects_view_change_all_selected_records":`Zmień wszystkie wybrane rekordy`,
"label.user.notinuse":`Użytkownik jest nieaktywny, skontaktuj się z administratorem.`,
"label.usermanage.hasbeen.reached":`Osiągnięto maksymalną liczbę licencjonowanych użytkowników, prosimy o kontakt z dostawcą usług w celu uzyskania większej liczby licencji.`,
"vue_label_help_list":`Widok listy`,
"label.infomation.edit":`Podstawowe informacje Edycja`,
"label.ccchat.person.setting.info":``,
"label.sso.isDelete":`Jest Usuń`,
"label.unique.identification.number":`Niepowtarzalny kod identyfikacyjny`,
"label.weixin.no.pending.projects":`Brak pozycji do zatwierdzenia`,
"label.projectManagement.Pleaseenteramember":`Proszę podać członka`,
"label.salescloud.salesdashboard.visit":`Odwiedź stronę`,
"label.weixin.user.registered":`Rejestracja użytkownika`,
"message.loginhistory.downloadcsv":`Pobierz historię logowania z ostatnich sześciu miesięcy. ( CSV )`,
"label.icon.37":`Pozycjonowanie`,
"template.chart.schdyqyx":`Oczekiwana reakcja na kampanie`,
"label.tel.ten":`Można wprowadzić do 10 numerów telefonów, które mają być powiadamiane przez SMS, a każdy numer telefonu jest oddzielony znakiem ";".`,
"label.data.exp.objdata":`Dane dla tego obiektu zostaną wyeksportowane zgodnie z następującymi warunkami`,
"label.loginservice.after.use":`po tym, można użyć.`,
"pagecreator_systemstyle_message_delete":`Czy usuwany jest aktualnie wybrany styl?`,
"label.globalselect.deleteerror":`Ponieważ ten zestaw wartości listy opcji używany jest przez następujące pola, nie można go tymczasowo usunąć.`,
"label.department.add":`Dodaj nowy dział`,
"label.attendance.dingwei":`Lokalizacja`,
"label.workflow.editrule":`Edytuj regułę`,
"lable.product.pecm":`Proszę wpisać prawidłową kwotę.`,
"label.icon.182":`Teczka`,
"label.help.release.notes":`Informacja o wydaniu CloudCC R7.1`,
"UG.product.05":`Produkt importowany`,
"label.email2":`E-mail`,
"label.weekrepeat":`Tydzień Powtórzenie`,
"label.mr.descreption.oneGroupReData2":`zestaw(y)`,
"chatter.at.d":`Składki`,
"label.mr.descreption.oneGroupReData1":`Znajdź duplikaty i połącz proces: łącznie`,
"label.weixin.mobile.fly.android":`Udostępnij na Android Mobile App`,
"label.brackets.right":`)Nawias ścisły`,
"message.recordtype.applytoAllProfiles":`Zastosuj układ strony do wszystkich profili`,
"label.customcomponent.page.index.tip":`Podobnie do sposobu działania funkcji w języku programowania, komponenty niestandardowe pozwalają na hermetyzację wspólnych wzorców projektowych, a następnie ponowne ich wykorzystanie w jednej lub wielu niestandardowych stronach.`,
"lable.List.properties":`Lista atrybutów`,
"label.fieldinfo":`Szczegóły dotyczące pola`,
"label.ems.error.fail":`Ładowanie nie powiodło się, proszę spróbować ponownie lub skontaktować się z administratorem systemu.`,
"label_emailsync_form_email":`E-mail`,
"lable.currencyManage.button.manageRate":`Zarządzaj walutami`,
"component_salesperformance_label_100finish":`Zakończono`,
"label.knowledgebase.data.assignment.failed":`{a} przypisanie danych nie powiodło się`,
"label.custom.buttonandlink.remark":`Wybierz zachowanie: Display in existing window/Display in new window (Existing window:dispaly in current window. Nowe okno: wyświetl w nowym oknie)`,
"label.list.userinterface.watermark.setup":`Ustawienie znaku wodnego`,
"component_timeline_label_7daysahead":`7 dni przed`,
"label.sendemail.chat.replyinchat":`Komentarz do postu:`,
"component.salesperformance.label.title":`Wyniki sprzedaży`,
"label.data.downpage.e.list.desc2":`Po zakończeniu otrzymasz wiadomość e-mail z przypomnieniem, że dane zostały pomyślnie wyeksportowane.`,
"vue_label_campaign_fromclosedopprotunities":`Od {sjcb} zamkniętych możliwości biznesowych`,
"label.umeng.activity.taskviewed":`Zadanie, które przypisałeś do #name jest przeglądane`,
"vue_label_salesadvance_retentions":`Numer retencyjny`,
"label.fieldtag":`Etykieta pola`,
"label.quickbooks.button.searchinquickbooks":`Wyszukaj w QuickBooks`,
"label.quickbooks.viewlist.action":`DZIAŁANIE`,
"label.weixin.sysapp":`Aplikacje systemowe`,
"label.approval.examine.level":`Zatwierdzanie i odrzucanie według poziomu użytkownika， maksymalny poziom użytkownika wynosi`,
"label.appupload.upload.error":`Ta aplikacja nie może zostać zainstalowana. Proszę anulować instalację lub zmodyfikować API w swoim systemie i zainstalować ponownie.`,
"label.emailtemplate":`Szablon e-mail`,
"front-email-payment-Invoice-amount":`Kwota faktury`,
"label.viewselectedproducts":`Zobacz wybrane produkty`,
"label.tianyancha.businessverify.openfirst":`Proszę włączyć weryfikację danych biznesowych`,
"lable.SalesCommitmentKanBan.returnAList":`Powrót do listy: Koledzy`,
"label.knowledgebase.nopublished.draft.translations":`Brak opublikowanej lub wstępnej wersji tłumaczenia`,
"vue_label_calendar_day_view":`Widok dnia kalendarzowego`,
"label.globalselect.remark":`Globalny zestaw wartości listy opcji pozwala na współdzielenie wartości pomiędzy obiektami.`,
"label.orderby":`Sort By`,
"lable.weixin.LastaDaysFinished":`Zakończone w ciągu ostatnich 7 dni`,
"lable.currencyManage.Enabledadvcurrency.discripation":`Umożliwia zarządzanie datowanymi kursami wymiany, które mapują kurs przeliczeniowy waluty na określony zakres dat. Datowane kursy walut są stosowane do pól walutowych w szansach, produktach szans oraz raportach powiązanych z tymi dwoma obiektami. Nie są one stosowane do pól innych obiektów lub innych typów raportów. Na przykład, kurs wymiany na dzień 1 stycznia wynosił 1 USD za 6,68 CNY, ale 6 lutego zmienił się na 1 USD za 6,70 CNY. Twoje szanse, które zostały zamknięte między 1 stycznia a 6 lutego, używają pierwszego kursu wymiany (1 = 1,68), podczas gdy szanse, które zostały zamknięte po 6 lutego, używają drugiego kursu wymiany (1 = 6,70).`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.one":`Jeden`,
"label.leadtoobjectfield":`Mapuj niestandardowe pola wiodące`,
"label.dashboardSetup.shujuyuan":`Źródła danych`,
"label.tabpage.userz":`Użytkownicy`,
"label.sms.companyname.dsf":`Ustawienie SMS-1`,
"label.step2.total3":`Krok 2 z 3`,
"front-gantt-module-Drag-dropt- reorder-tasks":`Przeciągnij, aby zmienić kolejność zadań!`,
"label.dashboard.snapshot.no.enabled":`Funkcja migawek pulpitu nawigacyjnego nie jest włączona`,
"label.dashboard.unit3":`Jednostka: jednostka całkowita`,
"label.forecast.shrepage.desc2":`Użytkownicy, role i terytoria z dostępem współdzielonym.`,
"label.commonobjects.new":`New {eventName}`,
"label.view.nameonlyone":`Zobacz Unikalna nazwa`,
"label.assignment.setup.newentries.user":`Użytkownicy`,
"label.otheremails":`Dodatkowe e-maile`,
"component_sendmail_button_send":`Wyślij`,
"vue_label_accountpool":`Pula środków na rachunku`,
"label.h5.approval.actortime":`Data przedłożenia`,
"message.approval.cannotsubmit":`Nie można przesłać do zatwierdzenia`,
"vue_label_pool_createdbyme":`Stworzony przeze mnie`,
"label.change.event":`Widok zdarzeń`,
"vue_label_homepage_personalpage":`Osobista strona główna`,
"label.new.collect.target":`Nowy wskaźnik agregatowy`,
"label.ServiceCloud.zichanxuhao":`Nr aktywów.`,
"label.product.userl":`Kolumny dla wszystkich użytkowników`,
"label.syslog":`Dziennik systemowy`,
"label.reportcreatestatus":`Status generowania raportu`,
"label.datamanage.account.novalue":`Uwaga: Jeśli pole nazwy rachunku jest puste, zapisy na rachunku nie zostaną zaimportowane.`,
"label.letter.body":`Tekst zaproszenia`,
"label.select.please":`Proszę wybrać`,
"label.escalation.setup.entrydetail.description":`1.Kliknij Edytuj, aby zmienić wpisy w regule. <br/>2.Kliknij przycisk Nowy, aby dodać operację aktualizacji.`,
"label.component.salesDashboard.nodata":`Dodaj możliwości biznesowe, z których korzystasz, a następnie wróć tutaj, aby zobaczyć wyniki.`,
"vue_label_helpcenter_account":`W informacjach szczegółowych kliknij przycisk diagramu drzewa obok klienta, aby wyświetlić diagram hierarchii klientów, zrozumieć relacje dziecko-rodzic powiązanych klientów i wyświetlić niektóre informacje o polu każdego klienta.<br>?Podczas zmiany właściciela klienta, można wybrać, aby zmienić właściciela możliwości biznesowych związanych z klientem, przypadki i inne informacje w tym samym czasie.`,
"front-kefu-moudle-v1-awshjzx-intelligent":`AWS Intelligent Service Call Center`,
"label.productby":`Generated By`,
"label.operation.date":`Data rozpoczęcia eksploatacji`,
"label.name.donot.delete":`Nazwa nie może zostać usunięta`,
"label.validate.function.funcFormat.DATETIMEVALUE":`DATETIMEVALUE(data)`,
"label.escalation.setup.entrydetail.howescalationtime":`Jak ustalane są czasy eskalacji`,
"label.view.step2":`Krok 2 Określ kryteria filtrowania`,
"lable.outlook.edit.notnull":`Musisz podać nazwę pola.`,
"label.knowledgebase.createnewbrowser":`Nowa karta przeglądarki`,
"label.partner.all.name":`Nazwa chmury partnerskiej`,
"chatter.group.groupSetUp":`Ustawienia grupowe`,
"label.reportlist.findfolder":`Znajdź folder...`,
"component.setup.tabs.label.title":`Stronicowanie zakładek`,
"label.passwordPolicy.setup.pswComplexReq":`Wymóg dotyczący złożoności hasła`,
"label.emaildocument":`Wyślij dokument w formie wiadomości e-mail`,
"message.selectgsummaryconditon":`proszę wybrać kryteria podsumowania`,
"component_todaytask_label_notask":`Dzisiaj nie ma zadania wygaśnięcia, weź kawę.`,
"label.user.organization.notexists":`Organizacja nie została odnaleziona.`,
"label.isEnableVisualpage.new.leftlist":`Dostępne strony niestandardowe`,
"label.mobile.phone.write.week.report":`Nowe tygodniowe notatki z pracy`,
"label.emailmerge.edittemplate.edit":`Edycja szablonu Mail Merge`,
"template.dashboard.folder.sales.manage":`Zarządzanie sprzedażą`,
"label.confirm.order.productsToassets":`Czy na pewno chcesz zamienić produkt zamówienia na aktywa?`,
"label.service.dispatchingUnits.leftRight.total":`Obecnie {{ left }}-{ right }} rekordów, {{ totalCount }} rekordów łącznie.`,
"label.import.step1.chooseidorother":`2、Możesz wybrać, aby użyć ID lub nazwę, aby dopasować rekord i wypełnić pole wyszukiwania. Jeśli potrzebujesz odpowiedniego identyfikatora rekordu i innych informacji, możesz utworzyć raport i ustawić nazwę rekordu i identyfikator rekordu jako kolumny grupy, a następnie wyeksportować raport.`,
"label_tabpage_completez":`Zaznacz wybrany status jako zakończony`,
"chatter.c.adr":`Adres`,
"label.account.d":`Ta strona umożliwia zdefiniowanie i edycję własnego kwartału fiskalnego. Data niestandardowego kwartału fiskalnego zostanie wygenerowana na podstawie wyborów dokonanych poniżej.`,
"label.tag.more50":`Tworzenie do 50 znaczników`,
"setup.layout.label.areashow":`Wyświetl nagłówek sekcji Wł.`,
"label.partnerCloud.basicSetting.rebate":`Aktywuj rabat`,
"label.tabpage.greaterequalz":`Większe lub równe`,
"vue.please.select.the.aggregate.basis":`Proszę wybrać opcje SUM BY.`,
"label.form":`Formularze`,
"label.chatter.colleagues.list.beizhu":`Włącz`,
"label.priority":`Priorytet`,
"vue_label_checkduplicate_set_repeat_rules":`Ustaw zasady powtarzania`,
"label.share_form":`Udostępnij swój formularz`,
"label_relation_shareholder":`Udziałowcy i spółki zależne nie mogą być tożsame.`,
"label.project.hit.sixteen":`Przypomnienie o wygaśnięciu emisji`,
"label.service.miniProgram.imageFormat":`Tylko obrazy PNG, JPG i JPEG są obsługiwane do przesyłania.`,
"label.summary.mode":`Metoda podsumowująca`,
"vue_label_beforeverification":``,
"label.data.newtemplate.desc":`Zapisz pola i kryteria wybrane przez użytkowników jako szablon, a użytkownicy będą mogli eksportować dane bezpośrednio przez szablon eksportu danych.`,
"lable.evaluation.badreview":`Bad`,
"label.total.tabs":`{0} Razem {1}`,
"label.emailmerge.mergeFolder.foldertemplate":`Szablony w tym folderze`,
"vue_label_normal_notice_repeated":`Proszę nie dodawać wielokrotnie`,
"label.icon.140":`Dane`,
"label.fromonetoanother":`od jednego użytkownika do drugiego`,
"label.user.list":`Wszyscy użytkownicy`,
"label.file.prevent.share.operate":`Uniemożliwienie innym dzielenia się i nie dzielenia się`,
"label.app.detail":`Szczegóły aplikacji`,
"label.h5.similar.opportunity.correlation":`Względność`,
"label_emailtocloudcc_filed_username":`Adres e-mail`,
"vue_labe_account_shareholdingratio":`Wskaźnik udziału w kapitale zakładowym`,
"label.data.dataexpalltype.all_desc3":`3. Eksport danych zakończony sukcesem wygeneruje skompresowany plik, który użytkownicy będą mogli pobrać ze strony z listą sukcesów eksportu zgodnie z informacjami zawartymi w mailu.`,
"label.callcenter.please.select .seatID":`Proszę wybrać numer miejsca`,
"label.remark.length.cannot.than":`Opis nie może zawierać więcej niż 255 bohaterów.`,
"label.batchtransfer.dateandtimetype.tip":`Dla pól daty/czasu należy wprowadzić wartość w następującym formacie:`,
"label.component.helper.businesschange.0UntreatActivity":`Możliwości bez działalności nieprzetworzonej`,
"front-project-module-v1-plase-input-start-time":`Proszę wpisać datę rozpoczęcia`,
"label.event.moveup.6hour":`6 godzin wcześniej`,
"label.data.exp.tempexp":`Eksport według szablonu`,
"label.schedulejob.setup.schedule.afternoon":`PM`,
"label.ems.format":`Format`,
"label.objectHasBeenDeleted":`Usunięte obiekty`,
"label.ServiceCloud.chaxunchenggong":`Pomyślnie przeszukane`,
"label.campaign.channel.input.notice.owner":`Powiadomić właściciela`,
"label.bajisitan.time":`Czas Pakistanu`,
"label.warnMes":`Odwołano się do obiektu, usunięcie nie powiodło się.`,
"lable.Up.to.ten.fields":`Wybierz obiekt i dodaj do 10 pól do wykresu. Kliknij na strzałki w górę i w dół, aby posortować kolejność pól.`,
"label.approverule":`Zasady zatwierdzania`,
"message.error.specific":`Zwróć określony komunikat o błędzie`,
"front-template-V1-saveUse":`Zapisz i podgląd`,
"label.uploadfile.success":`przesłane pomyślnie`,
"label.tabname.donot.database.key":`Nazwa zakładki nie może być słowem kluczowym bazy danych`,
"message.recordtype.selectlayout.select":`--Wybierz układ strony--`,
"front-detail-module-v1-list-cardview":`Widok listy/kart`,
"label.product.maintenance":`Konserwacja`,
"vue_label_helpcenter_approve":`1. Pozycje do zatwierdzenia<br> Lista wszystkich pozycji, które wymagają zatwierdzenia. Możesz wyszukiwać rekordy do zatwierdzenia według daty rozpoczęcia, daty zakończenia, osoby składającej, typu rekordu i powiązanych elementów rekordu zatwierdzającego.<br>Przetwarzaj pojedynczy rekord: Kliknij lewy przycisk każdego rekordu.<br> A. Zatwierdzenie<br> Krok 1: Kliknij "Zatwierdź", aby otworzyć stronę żądania zatwierdzenia<br> Krok 2: Kliknij "Zatwierdź" lub "Odrzuć", aby zakończyć operację zatwierdzenia.<br>Jeśli następny krok zatwierdzenia w konfiguracji procesu zatwierdzania wymaga ręcznego wyboru zatwierdzającego, krok 3 jest wykonywany po "Zatwierdzeniu".<br> Krok 3: Wybierz następnego zatwierdzającego, aby zakończyć operację zatwierdzenia.<br>Jeśli musisz wybrać krok powrotu po odrzuceniu zatwierdzenia w konfiguracji procesu zatwierdzania, przejdź do kroku 4 po "Odrzuć".<br>Krok 4: Wybierz krok zatwierdzania, który ma zostać zwrócony w celu zakończenia operacji zatwierdzania.<br>B. Ponowny podział<br> Krok 1: Kliknij "Ponowne przypisanie"<br> Krok 2: Znajdź osobę ponownie przypisującą<br> Krok 3: Kliknij "Ponowne przypisanie wniosku o zatwierdzenie", aby zakończyć ponowne przypisanie osób zatwierdzających.<br>Uwaga: Jeśli jesteś zastępcą zatwierdzającego rekord, nie możesz wykonać operacji ponownego przypisania.<br> Przetwarzanie wsadowe wielu rekordów: Po wybraniu wielu pozycji do zatwierdzenia, kliknij przycisk operacji nad listą.<br> C. Zatwierdzanie<br> Krok 1: Wybierz wiele rekordów do zatwierdzenia<br> Krok 2: Kliknij "Zatwierdź"<br> Krok 3: Kliknij "Zatwierdź" lub "Odrzuć", aby zakończyć operację zatwierdzania.<br>Jeśli musisz wybrać krok powrotny po odrzuceniu zatwierdzenia w konfiguracji procesu zatwierdzania, przejdź do kroku 4 po "Odrzuć".<br> Krok 4: Wybierz krok zatwierdzenia, który ma zostać zwrócony, aby zakończyć operację zatwierdzania.<br> D. Redystrybucja<br> Krok 1: Wybierz wiele rekordów do zatwierdzenia<br> Krok 2: Kliknij "Ponownie przypisz"<br> Krok 3: Znajdź osoby ponownie przypisujące<br> Krok 4: Kliknij "Ponownie przypisz wniosek o zatwierdzenie", aby zakończyć ponowne przypisywanie osób zatwierdzających.<br> 2. Złożone projekty<br> Lista wszystkich zatwierdzonych elementów, które złożyłeś. Możesz szybko wyszukać rekord, który chcesz wyświetlić dzięki dacie rozpoczęcia, dacie zakończenia, osobie składającej, typowi rekordu, powiązanym elementom i statusowi zatwierdzenia rekordu zatwierdzenia.<br> 3. Moje zatwierdzone projekty<br> Lista wszystkich zatwierdzonych elementów, które zostały przez Ciebie zatwierdzone. Możesz szybko wyszukać rekord, który chcesz wyświetlić za pomocą daty rozpoczęcia, daty zakończenia, podmiotu składającego, typu rekordu, powiązanych elementów i statusu zatwierdzenia rekordu zatwierdzenia.<br> 4. Elementy odrzucone <br> Lista wszystkich zatwierdzonych elementów, które zostały odrzucone. Możesz szybko wyszukać rekord, który chcesz wyświetlić, poprzez datę początkową, datę końcową, podmiot wysyłający, typ rekordu, powiązane pozycje i status zatwierdzenia rekordu zatwierdzenia.`,
"label.knowledgebase.knowledge.article":`Artykuł wiedzy`,
"march":`Marzec`,
"label.accraditation":`Zatwierdzić`,
"vue_label_pool_cantreach":`Nie można skontaktować się z klientem`,
"label.service.appointmentList.startOf.maturityPeriod":`Początek biegu terminu płatności`,
"message.huanxin.closed":`Nieaktywna funkcja czatu`,
"label.implementation.time.operation":`Wykonaj zaplanowane zadania`,
"label.setting.intergrationlist.permissions":`UPRAWNIENIA DO INTEGRACJI`,
"label.translation.norecord":`Brak zapisów`,
"label.lack.expression":`Traci się ekspresję`,
"setup.layout.message.relatedlistfield":`Wybierz pola, które mają być wyświetlane na liście powiązanych.`,
"label.group.file":`Pliki grupowe`,
"message.error.id.null":`Brak takich informacji o identyfikatorze`,
"label.a_b_least":`Każdy rekord "A" musi mieć co najmniej jeden powiązany rekord "B".`,
"label.addattachment.step3":`Krok 4 Kliknij "Complete", aby powrócić do poprzedniej strony.`,
"label.data.exportsf":`Pliki wyeksportowane`,
"label.callcenter.call.out":`Wywołanie`,
"front-electronic-export-exportIntro":`Wybrane dane zostaną wyeksportowane do wybranej listy Mailchimp.`,
"label.custombutton.deletedata.notnull":`Usunięte dane nie mogą być puste.`,
"UG.homepage.002":`Zarządzaj swoimi wskazówkami, leadami, lejkami transakcji sprzedaży i informacjami o kontach za pomocą zintegrowanych narzędzi biznesowych`,
"label.globaloperation":`Działanie globalne`,
"label.icon.58":`Pracownik`,
"vue_label_salesadvance_lostrate":`Wskaźnik rezygnacji`,
"chatter.from":`z`,
"front-epwechat-module-v1-account-binding":`Wiązanie na rachunku`,
"label.list.userinterface.old.page.setup":`Stara strona`,
"label.forecast.settings.periods":`&nbsp;cykl(y)`,
"label.file.share.email.content":`#sharedBy podzielił się z Tobą plikiem na #orgname`,
"label.knowledge.category.hint.five":`Ustawienie kategorii danych`,
"setup.layout.label.selectedfield":`Wybierz pola`,
"label_business_income":`Przychody z tytułu możliwości prowadzenia działalności gospodarczej`,
"vue_label_display_options_field":`Pokaż pola listy wyboru`,
"label.emailtocloudcc.set":`Ustawianie informacji o skrzynce pocztowej`,
"label.knowledge.setting.data.five":`Usuń kategorię: {lbmc}`,
"front-epwechat-module-v1-bound-enterprise":`Przedsiębiorstwo powiązane`,
"label.ccpeak.delete.recycle":`Rekord zostanie usunięty do kosza.`,
"label.leadconvers.tip":`Leady nie mogą być konwertowane na konta, kontakty, szanse i zadania followup. Należy konwertować leady tylko wtedy, gdy zostaną one uznane za kwalifikowane.`,
"label.rsa.key.invalid":`Klucz publiczny jest nieprawidłowy, proszę zalogować się ponownie.`,
"label.mobile.bind.success":`Wiąż z powodzeniem`,
"label.emailtocloudcc.filed.servertype":`Serwer poczty elektronicznej`,
"label.user.new":`Nowy użytkownik`,
"label.setup.mobile.homepageshortcuts.remark":`Organizacje mogą ustawić funkcje szybkiego reagowania na poziomie organizacji widoczne w górnym obszarze strony głównej zgodnie ze scenariuszem biznesowym.`,
"label_emailtocloudcc_select2":`Wybierz typ wyświetlacza`,
"page.send.email":`Wyślij e-mail`,
"label.service.newBuildDialog.field.display":`Pola do wyświetlenia`,
"vue_label_homepage_card_impending":`Nadarzające się okazje`,
"label.message.contactispartner.delete":`Z tym kontaktem powiązany jest użytkownik partnerski, nie można go usunąć`,
"label.attendance.checkout":`Check Out`,
"label.emailmerge.newtemplate.description":`Wpisz informacje o swoim szablonie mail merge.Zwróć uwagę, że opis jest wyświetlany tylko w CloudCC.com, a nie w Wordzie.`,
"laebe.data.exp.success":`Po udanym eksporcie otrzymasz przypomnienie e-mailem. Wyeksportowane dane będą przechowywane na serwerze przez 48 godzin. Prosimy o jak najszybsze pobranie danych ze strony z listą wyeksportowanych danych.`,
"lable.Maximum.number":`Nazwa szablonu może zawierać maksymalnie 50 znaków.`,
"label.projectManagement.drag.and.drop.existing.tasks":`Przeciągnij istniejące zadanie do bieżącej kategorii`,
"label.forecast.tree.desc":`Hierarchia prognoz określa, w jaki sposób prognozy są rozwijane w organizacji oraz kto może je przeglądać i modyfikować. Jest ona generowana automatycznie na podstawie hierarchii ról, ale może być konieczne dodanie lub edycja menedżerów, przedstawicieli handlowych lub innych użytkowników.`,
"vue_label_chatter_upload_file_type":`Wybrany typ pliku uploadu post`,
"front-lightning-module-v1-dashborad-analysis-dimension":`Wymiar analizy`,
"vue_label_homepage_custom_homepage":`Własna strona domowa`,
"label.icon.39":`Pozycjonowanie`,
"label.appointmentpage.wizard.notif1":`Proszę najpierw wybrać godzinę!`,
"vue_label_report_filterby":`Filtrowanie według {screenCondition}`,
"label.argentina.time":`Czas argentyński`,
"label.role.assign.notremove":`Nie można usunąć użytkowników z <b>Wybrani użytkownicy</b> do "Wszyscy nieprzypisani i aktywni użytkownicy" lub "Wszyscy nieprzypisani użytkownicy".`,
"label.sharerule.detailsetshare":`Udostępnianie szczegółów reguły`,
"label.file.publicview.error1":`Plik został usunięty lub link publiczny nie jest aktywny.`,
"label.data.downpage.e_title.num4":`4. Pliki eksportowe mają dwa formaty: Format CSV oraz format kompresji. Format kompresji jest podzielony na dwa rodzaje: jeden to automatyczne generowanie hasła do skompresowanego pliku, drugi to ręczne wprowadzanie hasła do skompresowanego pliku.`,
"label.knowledge.case.article":`Artykuł dotyczący przypadku`,
"label.data.newtemplate.e.conditions":`Warunki wywozu`,
"front-object-change-owner":`Właściciel wpisu na liście powiązanej, który odpowiada temu właścicielowi konta, również zostanie zmieniony na nowego właściciela`,
"label.newdashboardpage.edittitle":`Edytuj tytuł`,
"label.datamove.end.query.no.record":`Koniec zapytania, brak zakwalifikowanych rekordów.`,
"lable.SalesCommitmentKanBan.receiptsTarget":`Wpływy Cel`,
"label.orderagain":`Ponowne zamówienie`,
"vue_report_dashboard_transfer":`Przenieś folder`,
"label.view.sortview.default":`Widok domyślny`,
"label.brasilia.time":`Czas letni Brasilia`,
"label.industrialandcommercialverification.instructions":`Włącz weryfikację danych przemysłowych i handlowych, aby pomóc użytkownikowi wprowadzić prawidłowe informacje o rejestracji przemysłowej i handlowej klienta. Należy pamiętać, że ta funkcja obsługuje tylko zapytania o informacje o rejestracji przemysłowej i handlowej w Chinach kontynentalnych.`,
"label.chatter":`Słupek chmury`,
"label.sso.goBackToList":`Powrót do listy Zarządzanie`,
"label.mobile.side.tab.state":`Uruchom własny suwak`,
"label.weixin.addbus":`Dodaj pojazdy`,
"label.dropbox.description":`Połącz swoje konto DropBox, aby używać go w CloudCC.`,
"label.service.newBuildDialog.available.tousers":`Ustaw ten filtr jako dostępny dla wszystkich użytkowników.`,
"label.knowledge.language.thai":`Tajlandia`,
"label.passwordPolicy.setup.foreverlock":`Na zawsze (musi być zresetowany przez administratora)`,
"label.bmap.unreported.location":`Nie udostępniłeś informacji o swojej lokalizacji. Proszę skonfigurować w WeChat oficjalne konto .`,
"label.tag.field":`Tagi`,
"label.addyourlanguage":`Kliknij przycisk Dodaj, aby dodać języki obsługiwane przez Twoją organizację.`,
"label.chat.topic.my.use":`Tematy, których używam`,
"UG.contact.06":`Importuj kontakty`,
"label.embed_code":`Kod osadzenia`,
"label.campaign.channel.input.chenben":`3. Koszt rzeczywisty:`,
"label.quickbooks.estimates":`Szacunki`,
"label.report.items.i.created":`Raporty, które stworzyłem`,
"label.forecast.edit.fwqd":`Początek zakresu`,
"label.validate.function.funcExplain.DATEVALUE":`Utwórz datę z jej datetime`,
"vue_label_helpcenter_calendar1.1":`Zdarzenia są potężnym narzędziem, dzięki któremu zawsze rozumiesz relacje z klientami i zamykasz transakcje. Zdarzenia można powiązać z szansami, leadami, klientami i kontaktami. W widoku kalendarza wyświetlane są głównie rekordy zdarzeń.<br> 1. Widok kalendarza i widok listy<br>Widok kalendarza<br> Kliknij kartę Kalendarz w menu nawigacyjnym, aby przejść do strony kalendarza. <br>Widok kalendarza<br> Klasyfikacja widoków kalendarza: Widoki kalendarza są podzielone na widok miesiąca, widok tygodnia, widok dnia i widok dostępności. Zarejestrowane dane z różnych zakresów czasowych mogą być wyświetlane oddzielnie za pomocą różnych stylów siatki. W widoku dostępności wyświetlane są dane dzienne z każdego kalendarza jako wymiar, w tym mój kalendarz i inne kalendarze. Kliknij ikonę "przycisku kalendarza" w prawym górnym rogu strony kalendarza, aby przełączyć widoki. <br> Co można wyświetlić w widoku kalendarza: Kalendarz obejmuje mój kalendarz i inne kalendarze. W widoku kalendarza możesz wyświetlić mój kalendarz, w tym wszystkie zapisane dane mojego kalendarza wydarzeń i kalendarza obiektów. Rekordy te określamy jako "wpisy kalendarza". <br> Możesz wyświetlić wszystkie wydarzenia, które masz w widoku kalendarza. Kalendarz, który utworzysz z obiektem będzie wyświetlał dane jako wpisy kalendarza w widoku kalendarza w polu daty. W widoku kalendarza możesz również przeglądać inne kalendarze, czyli możesz przeglądać wszelkie wpisy kalendarza udostępnione przez współpracowników, które dodałeś do widoku. <br>`,
"label.tabpage.rowsz":`Usuń wiersze`,
"label.file.library.managemembers.memberlist":`Obecni członkowie`,
"label.report.action.addtodashboard4":`Dodaj do Exsiting Dshboard`,
"label.chat.send.voice":`Wyślij wiadomość głosową`,
"label.home.dashboard.add":`Dodaj do pulpitów głównych`,
"front-dialog-module-v1-copied-requestid":`Identyfikator żądania jest sklonowany`,
"label.customfields.exportdata":`Eksport danych`,
"label.emailobject.signature":`Podpis`,
"label.hide.source":`Ukryj kod źródłowy`,
"label.icon.71":`Serwis`,
"vue_label_help_whatslightning":`Co to jest błyskawica`,
"report.type.label.systemReport":`Raporty systemowe`,
"front-kefu-moudle-v1-input-email":`Proszę wpisać adres email`,
"label.event.moveup.5minutes":`5 minut wcześniej`,
"message.error.postsid.null":`Post ID nie może być pusty!`,
"UG.Account.05":`Schemat struktury styków`,
"label_emailtocloudcc_description3":`Podłącz swoje firmowe konto e-mail, takie jak sales@company.com, info@company.com, support@company.com. Automatycznie rejestruj otrzymane wiadomości e-mail jako leady i rekordy spraw w CloudCC, aby zapewnić terminowe śledzenie listów od klientów.`,
"report.label.searchresult":`Wyniki wyszukiwania`,
"vue_label_report_detailsonly_desc":`Eksportuj tylko wiersze szczegółów. Użyj tych danych do dodatkowych obliczeń lub do przesłania do innych systemów.`,
"label.partnerCloud.partnerAccount.payment":`Kwota płatności:`,
"vue_label_commonobjects_view_select_member":`Wybierz członka`,
"label.emailtocloudcc.step1.lead1":`E-mail do lidera`,
"label.forecast.settings.current":`Bieżący okres`,
"label.canceluploadfile":`Anuluj przesyłanie`,
"label.manual.shared":`Ręczne udostępnianie`,
"label.document.uniquename.length.cannot.than":`Długość unikalnej nazwy dokumentu nie może przekroczyć 255 znaków.`,
"vue_label_lead_notcreateopportunity":`Nie stwarzaj okazji`,
"APPIntegration.Social.twittererror":`Musisz wprowadzić prawidłowy adres URL dla twitter.com`,
"message.duplication.label.errormessage":`Komunikat o błędzie`,
"label.file.img":`Obraz`,
"label.tabpage.sum":`Całkowita liczba?`,
"label.permission.systempermission.fenpei":`Przydział uprawnień`,
"template.dashboard.folder.data":`Analiza danych`,
"label.sms.account":`Konto użytkownika`,
"label.product.filter":`Filtr do produktów`,
"label.file.content":`Treść tekstu`,
"label.percent":`Procent`,
"label.single.attachment":`Pojedynczy`,
"label.processsetting.failed.enable.process":`Nie udało się aktywować procesu`,
"label.view.modify":`Edytuj`,
"label.knowledgebase.enter.keywords.filter":`Proszę wpisać słowa kluczowe do filtrowania`,
"label.tabpage.uploadfailez":`Przesyłanie nie powiodło się, prosimy o ponowne przesłanie.`,
"label.please.enter.the.target.model.name":`Proszę wpisać nazwę modelu docelowego.`,
"label.layout.availabletab.related":`związane`,
"label.label":`Etykieta`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.saturday":`Sobota`,
"label.addattachment.unit":`bajt`,
"vue_label_commonobjects_view_selected":`wybrano rekord(y) {checkedLength}`,
"label.view.sortview.printble":`Możliwość wydruku`,
"label.umeng.insert.approval.approvaling":`#aplikator przedstawia #obj#objname do zatwierdzenia`,
"label.forecast.customforecast.tztotal":`Skorygowana kwota ogółem`,
"label.ccchat.failtoset":`Błąd ustawienia ccchat`,
"label.ccchat.message.new.error2":`Użytkownik CCChat`,
"label.validate.function.category.Advanced":`Zaawansowane`,
"label.projectManagement.team.members":`Członkowie zespołu`,
"vue_label_report_clickcrosstofliter":`Kliknij skrzyżowania w powyższej tabeli, aby wyfiltrować szczegóły.`,
"lable.opppdt.selPdt.leasttwenty":`Możesz wybrać do 25 linii`,
"label.campaign.channel.download":`Pobierz HD QR Code`,
"component_event_label_person":`Osoba wyznaczona`,
"vue_label_homepage_new_homepage":`Nowa strona główna`,
"label.version.sum.vlidaterule":`Zasady walidacji`,
"vue_label_chat_click_for_details":`Kliknij, aby zobaczyć szczegóły`,
"label.fold":`Składanie`,
"label.readonly":`Tylko do odczytu`,
"label.h5.similar.opportunity.result":`Podobne możliwości`,
"label.yourimportsuc":`Twoja prośba o import została przetworzona, proszę zobaczyć wiadomość e-mail.`,
"label.report.line.yixuan":`Wybrana kolumna raportu`,
"setup_layout_label_areaname":`Nazwa sekcji`,
"label.forecast.edit.title":`Target`,
"label.chatter.allweather":`Na każdą pogodę`,
"label.service.ganttBaiduMap.scheduled.endtime":`Planowana data zakończenia`,
"lable.create.new.list":`Nowa lista`,
"label.emailobject.groupemail.msg3":`{0}mail`,
"lable.opppdt.selPdt.description":`Wprowadź słowo kluczowe i kryteria filtrowania, a następnie kliknij przycisk Szukaj, aby rozpocząć wyszukiwanie Kliknij przycisk Więcej filtrów, aby użyć więcej niż jednego filtra. Wyniki wyszukiwania zawierają wszystkie rekordy, które pasują zarówno do słowa kluczowego, jak i do wpisanego filtra.`,
"label.file.versionerror1":`Możesz kliknąć poniższy link, aby przejść bezpośrednio do zakładki plików nowego interfejsu, lub możesz użyć funkcji zakładki plików po ręcznym przejściu do nowego interfejsu`,
"label.under.approve.record":`W oczekiwaniu na`,
"front-epwechat-module-v1-open":`Włącz`,
"label.projectManagement.delete.task":`Po usunięciu tego zadania wszystkie powiązane z nim informacje zostaną również usunięte, a danych nie będzie można odzyskać. Czy na pewno chcesz potwierdzić usunięcie?`,
"label.reportforms":`Raporty`,
"label.tabpage.onlymevisible":`To jest widoczne tylko dla mnie`,
"label.customer.tab.please.name":`Proszę wpisać nazwę karty`,
"label_emailsync_form_stutas":`Status`,
"message.recordtype.nolist":`Nie zdefiniowano typów rekordów.`,
"label.version.forecasting.sales":`Prognozy`,
"chatter.sel.mostfield":`Można wybrać do`,
"label.data.derived":`Eksport danych`,
"label.component.helper.businesschange.expiredtask":`Możliwości biznesowe z wygasłymi zadaniami`,
"label.cycle":`Cykl`,
"lable.product.standp":`Cena standardowa`,
"label.sendemail.batchapproval":`Operacja zatwierdzenia partii`,
"message.organization.not.open.mffverification":`Organizacja nie włącza certyfikacji dodatkowej.`,
"label.icon.131":`Parasol`,
"UG.activity.08":`Zarezerwuj harmonogram`,
"label_partner_workspace_member_choicepermission":`Wybierz zestaw uprawnień`,
"label.reportTypeCategory":`Raport Źródło danych`,
"label.exporttwotype":`Można eksportować dwa rodzaje tekstu`,
"message.oppdt.selectpricebook":`Proszę wybrać cenę książki`,
"vue_label_dashboard_generatefromlistview":`Generuj z widoku listy`,
"label.quote.title":`Tytuł`,
"label.tianyancha.businessverify.cancel.sure":`Po wyłączeniu weryfikacji danych firmowych nie ma możliwości uzupełnienia informacji o rejestracji firmy podczas tworzenia/edycji klienta. czy jest to potwierdzone?`,
"label.save":`Zapisz`,
"label.mobile.quickcreate.default.appstore":`Aplikacje`,
"label.partnerCloud.orderingPlatform.configure":`Produkty {a} nie są skonfigurowane, proszę zapisać po skonfigurowaniu.`,
"front-epwechat-module-v1-unbound-role":`Nieograniczone role`,
"label.partnerCloud.financeSetting.enterAlipay":`Proszę wpisać nazwę firmy Alipay.`,
"label.validate.function.funcExplain.TODAY":`Powrót do bieżącej daty`,
"label.visualpage.parameter.values":`Wyświetlanie wartości parametrów bezpośrednio na stronie:`,
"label.version.task.and.activity":`Przyporządkowanie zadań i czynności`,
"label.audit.history":`Historia zatwierdzenia`,
"setup.object.field.dependency.label.addtolist":`Dodaj wybrane wartości`,
"vue_label_report_exportquantity":`Ilość eksportowa:`,
"label_tabpage_havez":`Załączona`,
"label.partnerCloud.partnerAccount.amountOfRebate":`Dostępna kwota refundacji`,
"label.createralias":`Utworzony przez Alias`,
"label.created_followup":`Utwórz wiadomość email z kontynuacją`,
"label_chatter_mygroups":`Moje grupy`,
"label.chat.topic.no.display":`Brak tematów do wyświetlania`,
"vue_label_calendar_month_view":`Widok kalendarz-miesiąc`,
"label.service.gantt.resources.assigned.work":`Zasoby z przypisaną pracą`,
"UG_activity_07":`Utwórz zadanie`,
"label.quote.xsjg":`Cena sprzedaży`,
"message.toomanyrows":`Zbyt wiele rekordów do zapytania.`,
"label.importsourcestep1":`Krok 1 Przygotowanie przetłumaczonego pliku z rozdzielonymi zakładkami`,
"vue_label_normal_appointment_sf":`Powołanie`,
"lable.list.queue.message":`Kolejka nie może zostać usunięta, ponieważ istnieją rekordy obiektów należące do kolejki.`,
"label.service.major.event.desc":`Kamień milowy reprezentuje zależne od czasu kroki w procesie wsparcia. Można go dodać do początku procesu uprawnienia. Następnie można zastosować proces do uprawnień kont i na ich podstawie utworzyć sprawę lub zlecenie pracy.`,
"label.ems.hostorport.null":`Zarówno serwer, jak i port nie mogą być puste.`,
"chatter.group.private":`Prywatna`,
"label.icon.192":`Mydlarnia`,
"vue_label_systemSettings_list":`Lista powiązana Konfiguracja wyświetlacza`,
"label.activity.saveobj.notnull":`Zapisywany obiekt nie może być pusty.`,
"vue_label_chatter_current_no_people_approval":`Obecnie nie ma osób wymagających zatwierdzenia`,
"label.tianyancha.reglocation":`Adres siedziby`,
"UG_ST_005":`Mam to, nie pokazuj mi tej strony ponownie i zaloguj się prosto następnym razem.`,
"label.vlidaterule.example.truetodisplay":`Ten komunikat pojawi się, gdy formuła Error Condition jest prawdziwa`,
"label.icon.99":`Uwagi`,
"label.whenselectmoreapprover":`W przypadku wybrania więcej niż jednego zatwierdzającego`,
"label.forecast.customforecast.directorbest":`Najlepszy przypadek bezpośredniego podporządkowania`,
"label.customsetting.view.introduce":`Podaj wartości dla pól, które utworzyłeś. Dane te są buforowane przez aplikację.`,
"label.there.are.no.unenabled.rules":`Wszystkie reguły są włączone.`,
"front-project-module-v1-plase-selectemplat":`Proszę wybrać szablon projektu`,
"label.campaignmember.selectmember.from":`Ze strony`,
"setup_layout_button_quicksave":`Quick Save`,
"label.setup.service.report":`Ustawienia szablonu raportu serwisowego`,
"label.visualpage.direction.for.use":`Instrukcja Obsługi Stron Firmowych [wersja 2.0]`,
"message.modify":`Czy na pewno chcesz dokonać modyfikacji?`,
"label.sms.inside":`Wnętrze`,
"label.category.3":`Edukacja`,
"label.login.mfadevice.verification.title":`Weryfikacja urządzeń MFA`,
"UG_Forcast_08":`Poprzedni krok`,
"label.projectManagement.unable.to.complete":`Nie można zakończyć`,
"front-kefu-moudle-all-missphone":`Wszystkie nieodebrane połączenia`,
"font-evaluate-module-v1-emergency":`Ostrzeżenie`,
"label.sso.saml.sp.idsource.attr":`Tożsamość jest w elemencie atrybutu`,
"chatter.not.meg":`Nie można wysłać pustej wiadomości.`,
"label.chatter.startDate":`Dane początkowe`,
"label.emailobject.track.times":`Całkowita liczba otwarć: {0}`,
"label.customsetting.fieldhasbeendeleted":`Pola usunięte`,
"label.knowledge.setting.hint.thirteen":`Dodaj kategorię Inne dane`,
"message.duplication.label.newfiltertitle":`Nowa reguła dotycząca duplikatów`,
"setup_object_field_dependency_label_selectedfieldvalue":`Dostępne wartości pól`,
"vue_label_calendar_who_currently_has_access":`Kto ma obecnie dostęp`,
"message.passwordPolicy.validate.minlengthe":`bohater(ka)`,
"label.emailsync.status.disconnect":`Anuluj połączenie`,
"label.applt.down.one":`Pobieranie jednym dotknięciem`,
"label.manageAll.sel.one2":`Przedmioty, które złożyłem`,
"message.error.SQLTimeout":`Z powodu niewłaściwej konfiguracji systemu lub niezoptymalizowanych zapytań SQL, system przekroczył dozwolone możliwości zapytań, co spowodowało awarię zapytania. Prosimy o kontakt z administratorem systemu w celu dostrojenia systemu.`,
"label.global.search.obj.setup":`Globalne ustawienia obiektów z możliwością wyszukiwania`,
"vue_label_commonobjects_view_chat":`Zespół`,
"vue_label_systemSettings_startSet":`Rozpocznij konfigurację`,
"label.quickbooks.viewlist.balance":`BALANCE`,
"message.error.fieldid.null":`fieldid nie może być pusty! Id zawartości pliku`,
"label.replaceallnullvalue":`Zastąp wszystkie puste wartości`,
"label.georgia.time":`Czas Gruzji`,
"label.hastransfer":`Zawiera Przekształcone`,
"label.partner.all.description":`Opis`,
"font-evaluate-module-v1-following-peopple":`Po otrzymaniu negatywnej recenzji, powiadom następujących użytkowników`,
"label_business_count":`Kwota na działalność gospodarczą`,
"vue_label_ccchat_closedetail":`Zamknij`,
"label.partner.all.disable":`Wyłącz`,
"label.view.relationship":`Relacje między obiektami`,
"label.noless":`>=Większy niż lub równy`,
"label.sendsms.batch.step2":`Krok 2 Wybierz szablon lub dostosuj treść SMS-a do własnych potrzeb`,
"label.stdashbord.xsld.business.jieduan":`Nazwa etapu`,
"label.appupload.component.type.trigger":`Spust`,
"label.knowledge.setting.data.two":`Nazwa kategorii jest wymagana.`,
"label.color.display.of.completion.rate":`Kolorowy wyświetlacz wskaźnika realizacji`,
"label.loginhis.default":`Domyślnie wyświetla listę 200 ostatnich historii`,
"vue_label_pricebook_book":`Aktualny cennik`,
"label.knowledgebase.data.deletion.failed":`{a} usunięcie danych nie powiodło się`,
"label_partner_workspace_member_permission":`Zestaw dostępnych uprawnień`,
"label.list.userinterface.approval.setup":`Konfiguracja zatwierdzania`,
"label.weixin.binding.effect":`Wiązanie nieprawidłowe, proszę zalogować się ponownie.`,
"label.appupload.install.newapicannotnull":`Nowa nazwa api nie może być pusta`,
"chatter.feed.menutype.feed.company":`Wszystkie przedsiębiorstwa`,
"label.assignment.setup.detail.email":`E-mail`,
"label_tabpage_selectcontentz":`Proszę wybrać treść`,
"template.report.converted.leads.campaign":`Konwersja leadów z kampanii`,
"label.forecast.season":`W tym kwartale`,
"label.post":`Post`,
"label.knowledge.setting.hint.fifteen":`Fundamenty zostały położone. Teraz Ty i Twój zespół możecie pisać i organizować swoje artykuły wiedzy.`,
"front-kefu-moudle-v1-Seats-name":`Pseudonim agenta`,
"label.weixin.leadname":`Nazwa wiodąca`,
"label.account.quarter":`Kwartał`,
"label.detail.field":`Zobacz pola`,
"label.icon.189":`Kosmetyka`,
"label.appointment.disable.reappointment":`Dezaktywuj Zmień harmonogram`,
"label.appointmentconfirmpage.wizard.subtitle1":`Nazwa wydarzenia`,
"label.campaign.channel.step6.remark3":`System wygeneruje unikalny kod QR, który będzie mógł być wykorzystany przez pracowników, a zrealizowane zamówienia będą mogły być zaliczone na poczet ich osobistych osiągnięć.`,
"System.AddressFieldType.Post":`Kod pocztowy`,
"label_partner_new_step2":`Krok 2 Potwierdzenie szablonu`,
"vue_label_helpcenter_file":`Przeglądaj i zarządzaj swoimi plikami<br> Użyj nowej wersji obiektu Plik, aby przeglądać i zarządzać plikami należącymi do Ciebie lub udostępnionymi przez innych. Możesz podglądać pliki w niektórych formatach online. <br>Biblioteka plików<br> Użyj funkcji biblioteki plików, aby utworzyć bazę wiedzy zespołu, skonfigurować różnych administratorów i członków w celu wygodnego zarządzania; użyj funkcji folderu, aby sklasyfikować pliki.`,
"label.locateddowncurrentvalue":`Wartość poniżej bieżącej`,
"label.tianyancha.businessverify.msg5":`2. niezawodność usług`,
"label.setup.mobile.bottombutton.change.success":`Pomyślnie zmieniono`,
"label.appointmentconfirmail.wizard.subtitle2":`Czas`,
"label.email.address.lookup":`Wyszukaj adres e-mail`,
"setup.mainpage.label.welcome":`Witamy na platformie CloudCC PaaS, główne funkcje platformy są następujące:`,
"label.icon.55":`Buldożer`,
"label_tabpage_enterrecordnamez":`Proszę wpisać właściciela rekordu`,
"label.tabpage.andz":`I`,
"label.selectfiletoimport":`Wybierz plik do zaimportowania`,
"label.version.sum.trigger":`spust(y)`,
"label.multi.layout":`Kompaktowe układy`,
"pagecreator.button.back":`Ostatni krok`,
"label.imgfield.truetype":`Proszę załadować właściwy typ zdjęcia`,
"front-kefu-moudle-v1-publicKey":`Wspólny klucz`,
"label.data.exp.newtemp":`Szablon Utwórz`,
"label.martrixreport.2018.step4.new":`Krok 4 Wybierz nagłówki kolumn`,
"label.sendemail.chat.addComentsatsubject":`Zostałem wspomniany w wiadomości CloudCC CCChat`,
"vue_label_applauncher_description_leadpool":`Wykorzystaj Pulę Liderów, aby wygodnie zarządzać statusem kontynuacji w organizacji i motywować pracowników do realizacji transakcji.`,
"label.knowledgebase.archive.published.articles.without.drafts":`Można archiwizować tylko opublikowane artykuły, które nie mają żadnych wersji roboczych.`,
"label.projectManagement.bar.chart":`Wykres słupkowy`,
"label.ccpeak.condition.return.sort":`Zwracanie i sortowanie według warunków`,
"label.salescloud.opportunity.contactrole":`Okazja Kontakt Rola`,
"label.language":`Język`,
"message.error.view.badprevilege":`Przepraszamy, nie masz uprawnień do korzystania z tej usługi, skontaktuj się z administratorem.`,
"label.textmessage.managetemplates":`Zarządzaj szablonami`,
"message.error.type.null":`Typ nie może być zerowy!`,
"setup.mainpage.label.welcome9":`Użytkownicy mogą realizować klasyfikację wyświetlania i dostosowanie układu wszystkich elementów strony oraz ustawienie tylko do odczytu i wymaganych pól pól na stronie poprzez przeciąganie i upuszczanie myszką bez tworzenia kodu.`,
"label.appupload.component.type.page":`Własne strony`,
"label.textmessage.bookschedule":`Kliknij poniższy link, aby zobaczyć i zarezerwować mój harmonogram:`,
"component_chatter_post_button_save":`Opublikuj`,
"lable.oppt.jieduan.signcomplete":`Oznacz etap jako zakończony`,
"label.help.notes":`POMOC I PORADNIK`,
"label_tabpage_reallproplez":`Zapis wszystkich osób`,
"label.obtain.authorization.failure":`Nie udało się uzyskać kodu autoryzacji. Prosimy o ponowną autoryzację.`,
"label.account.FiscalQuarter":`Kwartał fiskalny`,
"label.customsetting.savecustomvalue":`Dane dla tej lokalizacji już istnieją, proszę je zmodyfikować i zapisać ponownie.`,
"label.maximum":`Maksymalnie`,
"component_chatter_file_label_maxsize":`Maksymalny rozmiar pliku to 20m`,
"c218":`Twój post został zapisany jako wersja robocza`,
"c875":`Nowy post do konwersacji`,
"c183":`Tag Filtr`,
"c366":`Skonfiguruj pulę`,
"c91":`Wynik interakcji z wiadomościami email`,
"c184":`Zaawansowanie etapu`,
"c750":`Inicjator:`,
"c619":`Wpisy na Twitterze muszą mieć 280 lub mniej znaków. Spróbuj używać skrótów, aby je skrócić.`,
"c69":`Płatne`,
"c675":`wyrównane do lewej`,
"c533":`Liczba zmodernizowanych obudów`,
"c167":`Wymagana jest długość zamówienia`,
"c682":`Kwadrat`,
"c960":`Super Edition`,
"c850":`Pokazuje ona aktualną liczbę obserwujących dla każdego z kont społecznościowych, z wyjątkiem Facebooka, który pokazuje aktualną liczbę polubień strony.`,
"c343":`Dodaj członków projektu`,
"c8":`Wybierz formę`,
"c157":`Tryb przyjmowania zleceń otwartych`,
"c397":`Załoga serwisowa`,
"c556":`nie udało się zamieścić obrazów`,
"c563":`Czas aktywny`,
"c179":`Logo partnera`,
"c147":`Zasady przyjmowania zamówień`,
"c303":`Obowiązek prawny`,
"c885":`Ukryj pasek boczny`,
"c808":`Wstaw obraz`,
"c718":`Kontynuuj konfigurację`,
"c414":`Dziękujemy za czas poświęcony na jego wypełnienie.`,
"c9":`Nagabywanie pracowników`,
"c15":`Została ona zafakturowana. Proszę wybrać ponownie`,
"c59":`Najpierw należy zalogować się jako administrator Easemob, a następnie przejść do ustawień zaawansowanych.`,
"c504":`Planowanie projektów, przydzielanie zadań, zarządzanie zasobami i współpraca z zespołem w celu osiągnięcia celów projektu, kontrolowanie postępów projektu, realizacja projektu zgodnie z harmonogramem i w ramach budżetu.`,
"c836":`Wiąż konto Fadada`,
"c187":`Strona z podziękowaniami`,
"c208":`Pakiet do pobrania`,
"c952":`Brazylia`,
"c104":`Odpowiedz raz`,
"c346":`Obliczanie zasobów zadania`,
"c913":`Rozwiń pasek boczny`,
"c571":`Wybrano formularz(e) {selectnumber}.`,
"c44":`Wybierz sieć, z którą chcesz się połączyć`,
"label.social.posts.content.null":`Treść postu jest pusta`,
"c852":`Nazwa firmy (niewypełnione)`,
"c561":`Zastosuj filtr`,
"obtain.contract.envelopeid.fail":`Nie udało się uzyskać informacji o kopercie lub wiadomości niepowiązanej`,
"c465":`Tylko zamówienia w tej samej walucie mogą wygenerować fakturę`,
"c982":``,
"c350":`Sortowanie zadań`,
"c352":`Kalendarz Zasobów Ludzkich`,
"c670":`Ikony graficzne`,
"front-electronic-signature-given":`Dostawa`,
"c542":`Ocena satysfakcji`,
"c314":`Generowanie pliku faktury`,
"c148":`Konfiguracja powiadomień email`,
"c47":`Połącz domenę`,
"c754":`Wypełnij`,
"c326":`BOM aktywów`,
"c289":`Preferencje`,
"c196":``,
"c63":`Otwórz {objName}`,
"c769":`Po cofnięciu podpisany dokument zadania zostanie usunięty. Kontynuować cofanie?`,
"c216":`Twój post został zaplanowany`,
"c842":`Wyślij wiadomość email z powiadomieniem o złożeniu wniosku`,
"c389":`Terytorium służb macierzystych`,
"c7":`Właściciel promocji`,
"c981":``,
"c143":`Wybierz użytkownika, który ma otrzymywać powiadomienia. To ustawienie można zmienić na każdej stronie docelowej, na której formularz jest używany.`,
"c930":`Przełącznik pozycjonowania pracowników`,
"c515":`Dodaj podsumowanie pracy`,
"c393":`Członek rejonu służbowego`,
"c357":`Oceń`,
"c597":`Przyrząd celowniczy`,
"front-electronic-signature-cancelIntro1":`Podpis elektroniczny DocuSign nie będzie dostępny po odblokowaniu. Czy na pewno chcesz się wypisać?`,
"c271":`Wystąpiła przerwa w przyjmowaniu zamówienia, numer: {0}. Prosimy o szybkie załatwienie sprawy i liczenie się z opóźnieniami w pracy. Kliknij, aby zobaczyć więcej >`,
"label.gaode.map.cannot.work.normally.please.check.whether.the.secret.key.is.correct":`Amap nie działa prawidłowo. Proszę sprawdzić, czy klucz tajny jest prawidłowy!`,
"c424":`Zarządzanie Terytorium Serwisowym`,
"c711":`Połącz swoje konta społecznościowe i dotrzyj do zupełnie nowego świata fanów.`,
"c197":`Osiągnięto maksymalną liczbę zgłoszeń. Dziękujemy za udział!`,
"front-electronic-signature-save-success":`Zapisz mapowanie z powodzeniem`,
"c765":`Zablokowana strona`,
"c286":`Niezgodność z przepisami`,
"c145":`Zgłoszony czas pracy dla jednego/wielu zadań na osobę dziennie nie może przekroczyć 24 godzin.`,
"c264":`Zarządzaj polami osobistymi`,
"label.china":`Chiny`,
"label.no.bind.mobile":`Brak telefonu komórkowego. Przejdź do informacji osobistych i zwiąż`,
"c95":`Usuń wybrane produkty`,
"front-electronic-signature-open-signInfo1":`Epodpis i pieczęć DocuSign jest włączona. Proszę go wyłączyć, a następnie włączyć Epodpis i pieczęć Fadada.`,
"c391":`Zobacz komentarz`,
"c106":`Interakcje`,
"c519":`W przypadku usunięcia tego timesheetu wszystkie powiązane z nim informacje zostaną również usunięte, a danych nie będzie można odzyskać. Czy na pewno chcesz potwierdzić usunięcie?`,
"c528":`Dziennik Dziennik Timesheet`,
"c78":`Nr katalogowy`,
"c41":`Odblokuj z powodzeniem`,
"c517":`Wprowadź prawidłową stawkę podatkową`,
"c774":`Podpisz postęp`,
"c296":`Proszę wpisać nazwę pola`,
"c757":`Do zaakceptowania`,
"front-electronic-signature-confirmintro":`Powiązanie powiodło się. Możesz teraz zainicjować podpisywanie z obiektu Contracts.`,
"c446":`Status zadania`,
"c238":`{!ServiceResource.name} przyjął zamówienie. Account: "{!ServiceAppointment.accountid.name}", Temat: "{!ServiceAppointment.subject}", Numer: "{!ServiceAppointment.name}".`,
"c980":``,
"c802":`Każdy użytkownik może zostać dodany tylko jako zasób usługowy`,
"c387":`Umiejętności związane z zasobami usług`,
"c965":`Usługa EaseMob nie jest włączona`,
"c480":`Którą listę mamy wysłać?`,
"c937":`Zmiana numeru telefonu`,
"c632":`Zobacz na Facebooku`,
"c131":`Pole konta na fakturze jest puste, proszę uzupełnić informacje.`,
"c680":`Biała`,
"c806":`Kiedy`,
"c649":`Przeczytałeś wszystko, co znalazło się w skrzynce odbiorczej.`,
"c797":`Ostatnie kontakty`,
"c616":`Otwórz łącze w nowym oknie`,
"c169":`Przepraszamy, nie masz uprawnień do wyświetlania tego wykresu`,
"c21":`Numer produktu nie może być mniejszy niż zafakturowana kwota`,
"c231":`Nie może być mniejsza niż liczba produktów, które zostały zapakowane`,
"c555":`Nie udało się opublikować obrazu Twojego postu.`,
"c583":`Mapa Chin`,
"front-electronic-signature-open-signInfo2":`Epodpis i pieczęć Fadada są włączone. Proszę go wyłączyć, a następnie włączyć Epodpis i pieczęć DocuSign.`,
"c822":`Nowe kontakty zewnętrzne`,
"c600":`Wykres numeryczny`,
"c442":`Wszechstronny system zarządzania projektami`,
"c762":`Do podpisania`,
"label.user.not.permission":`Bieżący użytkownik nie ma uprawnień do obsługi`,
"c35":`Nazwa subskrypcji`,
"c921":`rola(e)`,
"c305":`Interesy publiczne`,
"c730":`Nie można ponownie użyć starego hasła`,
"c525":`Wyłączenie użytkownika portalu`,
"c942":`Ameryka`,
"c780":`Proces podpisywania`,
"c447":`Źródło kanału końcowego`,
"c369":`Wyślij plik z zapytaniem ofertowym`,
"c702":`Sporządzić projekt`,
"c22":`Zapłacona kwota na fakturze będzie większa niż całkowita wartość, jeśli nadal będziesz tworzyć ten szczegół płatności. Prosimy o ponowne ustawienie kwoty i ponowne zapisanie.`,
"c79":`Data zamówienia`,
"c785":`Prawdziwe imię i nazwisko (opcjonalnie)`,
"label.insert.approval.reassign.error":`Zatwierdzenie w statusie zatwierdzenia wstawiającego nie może być ponownie przypisane`,
"c273":`Przekroczenie czasu przyjmowania zamówienia. Anuluj wysyłkę.`,
"c3":`Pomyślne usunięcie wykresu`,
"c448":`Sesja czatu`,
"c495":`Wszystko, czego potrzebujesz, aby sprzedawać szybciej i mądrzej`,
"c429":`KPI dla dyspozytorów`,
"c16":`Istnieje więcej niż jedno zafakturowane zamówienie. Proszę wybrać ponownie`,
"c128":`Można dodać do 5 rzędów`,
"c955":`Minimalna szerokość {label} wynosi {minWidth}px`,
"c716":`Możesz rozpocząć publikację bezpośrednio z CloudCC`,
"c638":`Opcje wydawnicze`,
"c746":`Odwołanie wniosku o zniszczenie`,
"c534":`Liczba zamkniętych spraw`,
"c948":`Włochy`,
"c317":`Wyślij plik zamówienia zakupu`,
"c426":`Zarządzanie zasobami usług`,
"c457":`Łączna kwota kontraktu Ranking`,
"c263":`Pola osobiste`,
"c372":`Generuj zamówienie`,
"c907":`Dostępne tylko w wersji z błyskawicą`,
"c771":`Postęp napełniania`,
"c408":`Możliwość dostosowania aplikacji do obsługi w terenie`,
"c12":`Stopa wzrostu`,
"c379":`Szczegóły dotyczące płatności`,
"c410":`Rodzaj pracy`,
"c510":`Zamówienia partnerskie`,
"c701":`Przypisz kampanię`,
"c617":`Tekst jest wymagany do opublikowania postu`,
"c213":`Format EPS`,
"c473":`System wygeneruje unikalny kod zaproszenia dla pracowników, którzy będą mogli wykorzystać go do wysyłania zaproszeń i zaliczyć do osobistych wyników. Należy pamiętać, że właścicielem leadów będzie aktualny właściciel kampanii lub osoba zapraszająca do kanału marketingowego.`,
"c975":``,
"c168":`Proszę wybrać tabelę!`,
"c121":`Uncategorized`,
"label.send.invoice":`Wyślij fakturę`,
"c792":`Potwierdzenie Inicjowanie`,
"c686":`Rozmiar`,
"c652":`Pokazuje liczbę postów, które zostały opublikowane na Twoich kontach w wybranym okresie. Uwzględnione są również posty, które zostały opublikowane na połączonych kontach poza CloudCC.`,
"c136":`Proszę wpisać tutaj krótkie wprowadzenie`,
"c662":`Ikona niestandardowa`,
"label.invoice.customer.is.error":`Generowanie faktur jest obsługiwane tylko dla zamówień złożonych przez tego samego klienta.`,
"c580":`Wykres bąbelkowy`,
"c894":`Przypisz kampanię do postu i możesz przeglądać wszystkie powiązane posty w ramach tej samej kampanii. Jest to przydatne w niesamowitych działaniach marketingowych.`,
"c570":`Projekt`,
"c133":`przekroczyć`,
"c564":`Drogi użytkowniku: \n Witamy w systemie CloudCC. Poprosiłeś o zresetowanie swojego hasła w {!operatetime}, zaloguj się przy użyciu poniższego kodu weryfikacyjnego w ciągu 15 minut: \nLosowy kod weryfikacyjny: {!authcode} Ważne: Jeśli nie prosiłeś o tę operację lub uważasz, że ta wiadomość nie powinna do Ciebie dotrzeć, natychmiast skontaktuj się z administratorem!`,
"c854":`Wygląda na to, że nie ma nic opublikowanego.`,
"c775":`Zakończenie działalności`,
"c105":`Odtwórz więcej niż raz`,
"c729":`Sprawdź, czy masz skonfigurowaną platformę społecznościową. Przejdź do ustawień zaplecza  Integracje  Włącz (Twitter/Facebook/LinkedIn)`,
"c491":`Dezaktywowana`,
"c609":`Znak towarowy`,
"c611":`Link do`,
"c843":`Przeglądanie zgłoszeń`,
"c933":`Strona konwersji`,
"c383":`Produkty Opportunity`,
"c186":`Ten unikalny identyfikator już istnieje. Proszę nie dodawać go wielokrotnie.`,
"c608":`Wymienić`,
"c149":`Włączanie powiadomień z programu Outlook (obsługuje tylko część usług poczty email)`,
"c486":`Odpowiedz na adres email:`,
"c598":`Wykres pączków`,
"c726":`Wniosek został pomyślnie zniszczony`,
"c645":`Zatwierdzenie projektu`,
"label.verificationCode.is.invalid":`Kod weryfikacyjny był nieprawidłowy. Proszę go odzyskać.`,
"c904":`Między`,
"c594":`Wykres liniowy 2D`,
"c103":`Kliknij więcej niż raz`,
"c188":`komentarz(e)`,
"c891":`Rekord nie może być kontaktem, szansą, leadem ani kontem`,
"c902":`Odległość między adresem zameldowania a gościem`,
"c484":`Poczta elektroniczna:`,
"c421":`Metoda generowania zleceń roboczych`,
"c406":`Zautomatyzowane zarządzanie sprzedażą`,
"c739":`Kampania: Nagabywanie pracowników`,
"c329":`Wymiana mienia`,
"c351":`Częstotliwość nawrotów`,
"c622":`Statystyki sieci ostatnio odświeżone o godz.`,
"2":`Pomyślnie skonfiguruj opcje filtrowania`,
"c463":`Moje możliwości`,
"c268":`Pomyślne połączenie informacji`,
"label.mobile.no.letter.blankcharacter":`Numer telefonu nie może zawierać liter i pustych znaków`,
"c438":`Transfer`,
"c581":`Tabela MoM&YoY`,
"c953":`Korea Południowa`,
"c90":`Temat:`,
"c2":`Usuń tablicę rozdzielczą pomyślnie!`,
"c897":``,
"c444":`Źródło pierwszego kanału`,
"c242":`{!ServiceResource.name} odrzucił zamówienie. Konto: "{!ServiceAppointment.accountid.name}", Numer: "{!ServiceAppointment.name}".`,
"c135":`Pusty szablon`,
"c659":`Za mną`,
"c773":`Finalizacja`,
"c11":`Promocja marketingu form`,
"c799":`Kontakty zewnętrzne`,
"c880":`edytuj posty społecznościowe`,
"c890":`Pomyślne wysłanie wiadomości email z zaproszeniem`,
"c846":`Proszę wybrać odpowiednią wizytę służbową`,
"front-electronic-signature-sucessSign":`Rozpocznij pomyślne podpisywanie`,
"c472":`Wybierz formę, na której chcesz zastosować plakat`,
"c963":`Pole Nazwa jest wymagane`,
"c390":`Terytorium usług dla dzieci`,
"c248":`Trwa przyjmowanie zlecenia przekazania.`,
"c646":`Strumień skrzynki odbiorczej`,
"c308":`Wybierz co najmniej jedną daną`,
"c858":`Czy na pewno chcesz zapisać {a} posty jako wersje robocze? Te posty nie będą publikowane, dopóki nie zaplanujesz ich ponownie.`,
"c152":`Liczba zrealizowanych wizyt serwisowych w aktualnie wybranym przedziale czasowym / Liczba wszystkich wizyt serwisowych w aktualnie wybranym przedziale czasowym`,
"c316":`Zobacz postępy w sprawie`,
"c435":`Wersja poglądowa`,
"c362":`Dołączone ograniczenia dotyczące produktu`,
"c800":`Proszę wpisać imię i nazwisko lub nazwę firmy`,
"c415":`Zaplanowany start`,
"c735":`Nazwa nie może być powtórzona`,
"c903":`Wybierz ikonę aplikacji`,
"label.insert.approval.massreassign.error":`Zatwierdzenia partii istniejące Zatwierdzenie wstawiania nie może być ponownie przypisane. System dokona automatycznego filtrowania za Ciebie`,
"c354":`Edytuj arkusz czasu`,
"c409":`Platforma kompleksowej obsługi klienta`,
"c651":`Pokazuje ona liczbę osób śledzących (Followers) dla każdego z kont społecznościowych, z wyjątkiem Facebooka, który pokazuje liczbę bieżących polubień strony.`,
"c582":`Mapa świata`,
"c826":`Czy na pewno chcesz odrzucić wprowadzone zmiany?`,
"c781":`Przedsiębiorstwo: Proszę wpisać nazwę firmy podaną w zezwoleniu na prowadzenie działalności. Sprawdzenie zostanie dokonane podczas podpisywania.`,
"c873":`Więcej informacji`,
"c837":`Po usunięciu powiązania nie będzie można korzystać z funkcji podpisu elektronicznego Fadada, a ustawione funkcje autouzupełniania i uzupełniania pól zostaną usunięte. Czy na pewno chcesz usunąć powiązania z kontem?`,
"label.diedirect.sale":`Bezpośrednie obniżki cen`,
"c798":`Kontakty wewnętrzne`,
"c368":`Wygeneruj plik wyceny`,
"c770":`Zainicjowane`,
"c882":`Warunki świadczenia usług`,
"front-setting-dialog-title-two":`Ustaw się na stronie z informacjami osobistymi, jeśli nie wprowadzono ich tym razem. Wiąż podczas wprowadzania numeru`,
"c535":`Nierozstrzygnięty`,
"front-electronic-signature-look-account":`Wyświetl konto`,
"c19":`Tryb wyświetlania szczegółów zapisu`,
"c52":`Nazwa podatku`,
"c388":`Uprawnienie do stowarzyszania się i użytkowania`,
"c18":`Istnieje więcej niż jedno nieaktywne zamówienie, proszę wybrać ponownie`,
"c820":`Wpisz numer telefonu/skrzynkę pocztową`,
"c285":`Przegląd`,
"c478":`Uwierzytelnianie programu Mailchimp`,
"c164":`Wprowadź wartość całkowitą z zakresu 060.`,
"label.tip.excess.quota":`Wykorzystanie zasobów zostało przekroczone`,
"c318":`Generowanie pliku zamówienia zakupu`,
"c698":`Sieć społecznościowa`,
"c312":`Wielokrotne zamówienia nie zostały jeszcze zrealizowane, proszę wybrać ponownie`,
"c110":`Grupuj według projektów`,
"c549":`Zakres dat nie może przekraczać 31 dni!`,
"c845":`Proszę wybrać co najmniej jedną wizytę serwisową`,
"c282":`Zarządzaj danymi osobowymi klientów w ramach CRM`,
"c270":`Limit czasu przyjmowania zleceń`,
"c288":`Zmiana podstawy przetwarzania danych`,
"c878":`Aktualny adres`,
"c324":`Dodaj kolejki do spraw`,
"c129":`To działanie spowoduje trwałe usunięcie pliku. Czy chcesz kontynuować?`,
"c339":`GDPR Niszczenie danych`,
"c405":`Wielkość załogi`,
"c848":`Konta na Linkedin`,
"c345":`Szablon projektu`,
"c591":`Mapa Australii`,
"c180":`Język na stronie logowania`,
"c126":`Dostarczone`,
"c311":`Nieskuteczne, proszę wybrać ponownie`,
"c587":`Mapa Meksyku`,
"c37":`To jest tekst, który będzie widoczny na stronie preferencji komunikacyjnych klienta`,
"c840":`Yay! Żadnych nieudanych postów.`,
"c241":`{!ServiceResource.name} odrzucił zamówienie. Account: "{!ServiceAppointment.accountid.name}", Temat: "{!ServiceAppointment.subject}", Numer: "{!ServiceAppointment.name}".`,
"c141":`Wymagane jest przesłanie podziękowania`,
"obtain.contract.fail":`Nie udało się uzyskać informacji o umowie`,
"c945":`Rosja`,
"c454":`Kwota umowy Miesięcznie`,
"c34":`W koszyku znajduje się 100 produktów. Przed dodaniem nowego produktu usuń przynajmniej jedną pozycję.`,
"c243":`{!ServiceResource.name} odrzucił zamówienie. Temat: "{!ServiceAppointment.subject}", Numer: "{!ServiceAppointment.name}".`,
"c548":`Zadania/zadania, podzadania i projektu nie można edytować z poziomu arkusza czasu pracy.`,
"c807":`Post Now`,
"c590":`Mapa Niemiec`,
"c831":`Certyfikacja`,
"c198":`Twój formularz jest bezpiecznie opublikowany i można go użyć pod następującym adresem URL, aby udostępnić formularz jako łącze publiczne.`,
"c977":``,
"c66":`Informacje logistyczne dotyczące produktu zostały zaktualizowane do pozycji Dostarczono.`,
"label.twitter.title.setting":`Zintegrowane informacje na Twitterze`,
"c922":`Skontaktuj się z administratorem, aby umożliwić Zespołowi`,
"front-email-payment-Invoice-Tips":`Prosimy o kontakt z administratorem w celu włączenia PayPal lub VISA, a następnie zainicjowania płatności online.`,
"c605":`	
Domyślny adres rozliczeniowy`,
"c403":`Projekty`,
"c156":`Zasady przyjmowania zamówień dla strony mobilnej`,
"c635":`Zaplanuj kolejny post`,
"c753":`Uczestnik`,
"c647":`Cała działalność`,
"c295":`Po wyłączeniu wszystkie oznaczenia pól osobistych, podstawy przetwarzania danych i inne informacje zgodne z przepisami DGPR zostaną usunięte, z wyjątkiem historii operacji dla rekordów. Czy na pewno chcesz wyłączyć?`,
"c915":`Basen otwarty`,
"front-electronic-signature-signStatus":`Rozpocząłeś podpisywanie umowy online. Status umowy to {signStauts}.`,
"c568":`Dostosuj układ`,
"c744":`Wprowadź prawidłową liczbę z przedziału od 0 do 100.`,
"c464":`post(y) został(y) usunięty(e)`,
"c385":`Podsumowanie pracy`,
"c392":`Wybierz rozwiązanie, którego potrzebujesz`,
"c418":`Przydzielone zasoby służbowe`,
"c256":`Zmiana konta spowoduje wyczyszczenie zamówienia z wybranych pozycji. Czy na pewno chcesz zmienić konto?`,
"c690":`Ładowanie obrazu`,
"c261":`Zniszcz dane`,
"c62":`Nagabywanie pracowników`,
"c892":`Nie znaleziono bieżącego rekordu`,
"c909":`Definicje cen dla tej waluty zostały dodane. Prosimy nie dodawać ich ponownie!`,
"c883":`&`,
"c134":`Górna granica liczby członków puli`,
"c896":`Rekord został zablokowany i nie obsługuje dodawania plików. Prosimy o kontakt z administratorem w celu odblokowania`,
"c974":``,
"c209":`Rozmiar średni`,
"c185":`Statystyki na tej stronie`,
"c796":`Przed przystąpieniem do podpisywania umowy należy skontaktować się z administratorem w celu skonfigurowania szablonu umowy na platformie Fadada.`,
"c60":`Liczba projektów`,
"c866":`Konfiguracja aplikacji`,
"c666":`Wyświetlacz`,
"c219":`Twój post został usunięty.`,
"c732":`Plakat`,
"c155":`{name} Nazwa`,
"c511":`Ekontrakt`,
"c240":`Odrzucono`,
"c468":`Typ sortowania jest pusty`,
"c961":`Q{kwartał} {yrok}`,
"c404":`Narzędzie do marketingu i generowania leadów`,
"c586":`Mapa Singapuru`,
"c694":`Szerokość/Wysokość`,
"c297":`Proszę podać rodzaj danych osobowych`,
"c860":`Zmiana adresu`,
"c58":`Strona główna projektu`,
"c920":`Jeśli zostaną skonfigurowane reguły automatycznego recyklingu, system będzie automatycznie usuwał rekordy do puli, jeśli lead nie zostanie przekonwertowany po upływie określonego czasu. Zwiększa to efektywność śledzenia leadów.`,
"c27":`Proszę wpisać kwotę zmienną, aby dostosować kwotę brutto, np.  10 lub 10.`,
"c94":`3 razy w górę`,
"c1":`Tylko telefon komórkowy`,
"c557":`Przyjęte sprawy`,
"c294":`Wyłącz ustawienia zgodności z GDPR`,
"c970":``,
"c565":`Przypisz to zadanie do`,
"c668":`Wyrównanie`,
"c972":``,
"c660":`Prawa autorskie`,
"c433":`Śledzenie puli leadów w terenie`,
"c443":`Archiwum Wszystkie`,
"c275":`W przypadku {0} upłynął czas przyjmowania zleceń, a wysyłanie zostało anulowane. Numer: {1}. Kliknij, aby zobaczyć więcej >.`,
"c691":`Łącze (opcjonalnie)`,
"c956":`Nie aktywowałeś jeszcze swojego konta Mailchimp. Przejdź do ustawień>Integracja>Lista integracji, aby aktywować swoje konto Mailchimp lub skontaktuj się z administratorem.`,
"c910":`Nowe zamówienie na pracę`,
"c692":`Domyślna przeglądarka`,
"c355":`Dodaj partię arkuszy czasu`,
"c122":`Obraz produktu`,
"c395":`Typ terytorium`,
"c689":`Maks. wysokość`,
"c344":`Wyświetlanie projektu za pomocą wykresu Gantta`,
"c656":`Czas odświeżania`,
"c943":`Japonia`,
"front-electronic-signature-outerSinger":`Sygnatariusz zewnętrzny`,
"front-generate-v1-invoiceDetail":`Szczegóły faktury`,
"front-electronic-signature-open-vertify":`Proszę wprowadzić kod weryfikacyjny`,
"c291":`Typ danych osobowych`,
"front-setting-phone-message":`Proszę wpisać numer telefonu`,
"c559":`Przypadki nasilone`,
"label.google.map.cannot.work.normally.please.check.whether.the.secret.key.is.correct":`Mapa Google nie działa prawidłowo. Proszę sprawdzić, czy klucz tajny jest prawidłowy!`,
"c259":`Podstawy przetwarzania danych`,
"c488":`Czas zaproszony`,
"c6":`Nazwa promocji`,
"front-electronic-signature-signerInfo":`Ustaw informacje o sygnatariuszu`,
"c512":`Członkowie projektu`,
"c507":`Kultywowanie lidera`,
"c760":`Odrzucono`,
"c756":`Nie wysyłaj`,
"c321":`Wymagane lub nie`,
"c817":`Wyświetl ustawienia uprawnień dla menu strony niestandardowej`,
"c949":`Hiszpania`,
"label.biaoqing.field.relation.tip":`Pole wykrywania ofert i przetargów`,
"c382":`Punktacja netto za powiązania`,
"c265":`To polecenie nie może być zmienione, ponieważ nie jest jeszcze skuteczne.`,
"c417":`Serwis Zasoby pracy Informacje o pracy`,
"c847":`Konta na Facebooku`,
"c494":`Ujednolicone zarządzanie wszystkimi kanałami w chmurze Marketing CloudCC. Buduj więzi i długotrwałe zaufanie z klientami, zwiększaj ROI dzięki analityce i przekształcaj zasięg w przychody.`,
"c86":`Kampania: Edytuj polecenie pracownika`,
"c776":`Cofnij z powodzeniem`,
"c709":`Wybierz sieć, z którą chcesz się połączyć`,
"label.mobile.orVerificationCode.is.error":`Błąd numeru telefonu lub kodu weryfikacyjnego`,
"c579":`Wykres radarowy`,
"c413":`Status nominacji serwisowej`,
"c950":`Holandia`,
"c573":`Wykres słupkowy 2D`,
"label.choose.is.tax":`Wybierz typ podatku`,
"c768":`Zainicjowane zadanie podpisywania umowy nie zostało zakończone. Dokument należy pobrać po podpisaniu umowy.`,
"c604":`Adres rozliczeniowy już istnieje, zapisz bieżący jako nowy adres rozliczeniowy`,
"c160":`Zaległe leczenie`,
"c239":`Zaakceptowano`,
"c834":`Wstępnie przyjęty`,
"c113":`Wyślij {name}.`,
"c146":`Odpowiednie produkty zostaną rozliczone po zmianie waluty. Czy chcesz kontynuować zmianę?`,
"c313":`Wyślij plik z fakturą`,
"c140":`Wybierz obiekt i szablon`,
"c298":`Niezgodne z przepisami`,
"c681":`Krąg`,
"c870":`Czy na pewno chcesz usunąć partię?`,
"c551":`<span style="fontsize: 16px; fontweight: bold; color: #fe8a14"> {days} </span> dni pozostałe do zakończenia procesu`,
"c88":`Dni pozostałe do zakończenia procesu`,
"c175":`Nie udało się uzyskać informacji szczegółowych`,
"c64":`Czy otworzyć {objName}`,
"c319":`Ustawianie stylu formularza`,
"label.pay.online":`Zainicjuj płatność online`,
"c941":`Chiny  Tajwan`,
"c550":`Proszę wybrać datę rozpoczęcia lub zakończenia`,
"c365":`Synchronizuj wiersz oferty z produktem szansy`,
"c908":`Wybierz ikonę`,
"c260":`Wniosek o zniszczenie`,
"c50":`Stawka podatku`,
"c869":`Czy na pewno zarchiwizowano wszystkie dane`,
"c93":`Wielokrotne otwieranie`,
"c280":`Usuń wiadomość email`,
"c23":`Zapłacona kwota na fakturze będzie wyższa niż kwota zamówienia, jeśli nadal będziesz tworzyć ten szczegół płatności. Prosimy o ponowne ustawienie kwoty i ponowne zapisanie.`,
"front-console-v1-see-contacts":`Zidentyfikowano wiele kontaktów. Proszę wybrać`,
"c607":`Adres wysyłki już istnieje, zapisz bieżący jako nowy adres rozliczeniowy`,
"c229":`Usuń kamień milowy`,
"front-filter-v1-filter-by-name":`Filtrowanie według '{name}'`,
"c125":`W tranzycie`,
"c513":`Arkusze czasu pracy`,
"c80":`Adres rozliczeniowy`,
"c648":`Rozmowy`,
"c521":`Liczba zamówionych`,
"c560":`Sprawy zamknięte`,
"c973":``,
"c509":`Lista pakowania`,
"c685":`Dodaj nowy adres`,
"c178":`Format załadowanego obrazu nie jest obsługiwany. Prosimy o przesyłanie obrazów w formacie png, jpg i jpeg.`,
"c436":`Szczegóły dotyczące gości`,
"front-electronic-signature-prepareTemplate":`Prosimy o kontakt z administratorem w celu ustawienia szablonu umowy w systemie przed rozpoczęciem podpisywania.`,
"c749":`Proces podpisywania`,
"c114":`Proszę kliknąć przycisk Generate {name}, aby wygenerować {name} przed wysłaniem.`,
"c898":``,
"c279":`Sprzedaż`,
"c232":`Nie może przekraczać liczby produktów, które mają być zapakowane`,
"c911":`Wysyłka anulowana`,
"c901":`Twoja liczba zgłoszeń osiągnęła limit.`,
"c663":`Tekst alternatywny`,
"c541":`Dane statystyczne dotyczące bieżącej sprawy`,
"c536":`Otrzymane`,
"front-project-v1-batch-deletion-confirmation-information":`Wsadowe usunięcie wybranych rekordów spowoduje również usunięcie wszystkich informacji związanych z wybranymi rekordami, a danych nie będzie można odzyskać. Czy na pewno chcesz usunąć?`,
"c893":`Bieżący użytkownik nie ma dostępu do edycji pola adresu szczegółowego konta`,
"c623":`Monitor`,
"c493":`Kształtuj marketing cyfrowy, wykorzystaj wszystkie możliwości`,
"c327":`Hierarchia aktywów`,
"c747":`Całkowita liczba produktów jest pełna. Proszę najpierw usunąć niektóre produkty, a następnie kontynuować dodawanie produktów.`,
"c728":`Prywatność danych`,
"front-reportlist-v1-optimizedReport":`raporty są optymalizowane po zapytaniu. Prosimy nie modyfikować ich przypadkowo.`,
"c741":`Wypełnij treść maila!`,
"c643":`Post Details`,
"c537":`Średni czas reakcji`,
"front-electronic-signature-add-field":`Dodaj pole do zasypywania`,
"c626":`Wszyscy użytkownicy`,
"c199":`Łącze do formularza`,
"c917":`Wykorzystaj pulę, aby pobudzić potencjał zespołu i zwiększyć wydajność monitorowania kont. Administrator puli umożliwia ujednolicone zarządzanie kontami i przydziałami partii. Pracownicy działu sprzedaży mogą również sprawdzać leady i otrzymywać dalsze informacje.`,
"c159":`Długość zamówienia nie może przekraczać maksymalnej liczby`,
"c640":`Schedule Post`,
"c192":`Bieżący układ strony:`,
"c978":``,
"c969":``,
"c871":`W ten sposób Twój post będzie wyświetlany w witrynie {a}. Mogą wystąpić niewielkie różnice, jeśli {a} dokona jakichkolwiek zmian w układzie.`,
"c814":`1{0} wybrane`,
"c235":`{!ServiceResource.name} przyjął zamówienie. Temat: "{!ServiceAppointment.subject}", Numer: "{!ServiceAppointment.name}".`,
"c215":`Twój post został opublikowany`,
"c425":`Zarządzanie terminami serwisowymi`,
"c182":`Nie można jednocześnie połączyć zlecenia pracy i rejestru spraw`,
"c194":`Ograniczenie liczby zgłoszeń`,
"c657":`Brak pozwolenia na działanie， skontaktuj się z administratorem`,
"c855":`Wygląda na to, że nic nie jest zaplanowane.`,
"c333":`Budżet Koszt`,
"c338":`Dostawca  zniszczyć`,
"c431":`Hierarchia kampanii`,
"c374":`Cena Książka Produkt`,
"c506":`Harmonogram automatyczny`,
"font-trade-module-invoice-totalMoney":`Należności z tytułu faktur ogółem`,
"c203":`Udostępniaj formularze za pomocą programu Mailchimp`,
"c962":`{miesiąc} rok}`,
"c786":`Numer telefonu/skrzynka pocztowa`,
"c469":`Strona jest w stanie edycji. Bieżące dane nie zostaną zapisane po opuszczeniu strony.`,
"c137":`Wybierz szablon dla formularza`,
"c483":`Informacje o kampanii`,
"c947":`Francja`,
"c190":`Waluta pozycji płatności powinna być zgodna z walutą zamówienia, faktury i płatności. Doprecyzuj walutę i zapisz ponownie.`,
"c386":`Spełnione`,
"c803":`Konta: Wszystkie rachunki`,
"c759":`Do wypełnienia`,
"c823":`Ustawianie kolejności`,
"c422":`Metoda generowania wizyt serwisowych`,
"c782":`Jak wziąć udział`,
"c416":`Raport serwisowy Zapis pchnięcia`,
"c758":`Zaakceptowano`,
"c407":`Pracownik obsługi`,
"c51":`Nowy podatek`,
"c844":`Powiąż konto DocuSign`,
"c361":`Menu Edycja`,
"c602":`Wykres matrycowy`,
"c191":`Wymagane jest uprawnienie do edycji bieżącego widoku`,
"c299":`Wybierz co najmniej jeden obiekt`,
"c432":`Historia kampanii`,
"c650":`Opublikuj nowy post, aby rozpocząć nową konwersację`,
"c531":`Liczba otrzymanych spraw`,
"c13":`Bieżący użytkownik nie ma uprawnień do edycji`,
"c162":`Równoczesne informowanie cedenta i cesjonariusza`,
"c171":`Udziały`,
"c230":`Usuń zadanie`,
"c470":`Automatyczne wypełnianie pól`,
"c367":`Generuj umowę`,
"c26":`Ustanowienie rabatu`,
"c705":`Opublikowane stanowiska`,
"c613":`Strona zewnętrzna`,
"front-electronic-signature-openSign":`Rozpocznij podpisywanie`,
"c349":`Przeciągnij i upuść`,
"c683":`Load More`,
"c679":`Szary`,
"c914":`Zwiń pasek boczny`,
"c224":`Przejdź do kamienia milowego`,
"c220":`Twój post został opublikowany bez powodzenia`,
"c498":`CloudCC Inventory skutecznie wspiera wielokanałową działalność online i offline, realizując przepływ towarów i środków oraz zarządzanie nimi. Efektywne połączenie wielu modułów pozwala użytkownikom na zaawansowane zarządzanie zamówieniami i tworzenie korzystnych sytuacji we współpracy z partnerami.`,
"c566":`Automatyczne odzyskiwanie adresu konta po zapisie`,
"front-electronic-signature-ContractTemplate":`Wybierz szablon umowy`,
"c540":`Rozwiązywanie problemu czasu według kanałów`,
"c793":`Szablony dokumentów`,
"c293":`Ustaw obiekty, aby zapewnić zgodność z GDPR`,
"front-invoice-online-pay-again":`Zainicjowałeś już płatność online. Proszę nie próbować ponownie.`,
"front-electronic-signature-open-password":`Proszę wpisać hasło`,
"front-v1-partner-background-tooltip":`Maksymalnie 2M plik jest obsługiwany. Zaleca się wgrywanie czystych obrazów.`,
"c449":`Historia czatu`,
"c30":`Klasyczna`,
"c245":`{!oldServiceResource.name} przeniósł zlecenie pracy o numerze {!ServiceAppointment.name} do {!newServiceResource.name}.`,
"c923":`Oto Twój zespół`,
"c24":`Pokaż mapę`,
"c872":`Nazwa (niewypełniona)`,
"c886":`Otwórz pasek boczny`,
"c485":`Nazwa formularza:`,
"c101":`pc(s)`,
"c816":`View post`,
"c445":`Rola projektu`,
"c853":`Pokazuje liczbę polubień i komentarzy dla opublikowanych postów.`,
"c398":`Zacznij teraz`,
"c522":`Liczba fakturowanych`,
"c287":`Zgodność`,
"c578":`MoM&YoY Wykres numeryczny`,
"c40":`Wprowadź hasło`,
"c631":`Zobacz na Twitterze`,
"c489":`Czas dezaktywacji`,
"c819":`Numer telefonu/skrzynka pocztowa`,
"c935":`Typ formularza`,
"c625":`Wszystkie kampanie`,
"c471":`Kampania: Polecenie pracownika`,
"front-electronic-signature-writen":`Wypełniony`,
"c889":`Pomyślna dezaktywacja konta użytkownika`,
"c201":`Udostępnij ten formularz w swoich mediach społecznościowych`,
"c467":`Pole sortowania jest puste`,
"label.mobile.no.null":`Numer telefonu nie może być pusty`,
"c307":`Uprawnienia`,
"front-kefu-moudle-wait-calling":`Połączenie w toku, proszę spróbować ponownie później`,
"c784":`Proszę wpisać nazwę firmy podaną w zezwoleniu na prowadzenie działalności`,
"c490":`Czas ostatniego logowania`,
"c790":`Podpis odręczny`,
"c336":`Leady  Zniszcz`,
"c453":`Strona główna Kanban`,
"c530":`Najpierw należy skonfigurować firmową skrzynkę pocztową`,
"c610":`Ikona będzie łączyć się z domeną główną, jeśli nie został podany adres URL`,
"c359":`Wykres`,
"c193":`Ograniczenia`,
"label.mobile.verificationCode.exceeded.times":`Przekroczono liczbę ponownych prób. Prosimy o ponowne żądanie.`,
"c138":`Szablon firmy`,
"c821":`Nowe kontakty wewnętrzne`,
"c381":`Wniosek o płatność online`,
"c761":`Podpisywanie dokumentów`,
"c964":`Wymagane jest pole relacji nadrzędnyszczegół`,
"c585":`Mapa Zjednoczonego Królestwa`,
"c500":`Zapewnij kompleksowe rozwiązania w zakresie obsługi klienta dzięki standaryzowanym procesom i efektywnemu zarządzaniu, koordynuj zasoby serwisowe, aby zapewnić klientom jak najlepszą obsługę.`,
"c214":`Dołącz bitmapy w trzech rozmiarach i grafikę wektorową we wszystkich formatach`,
"c714":`Zaplanuj publikowanie postów w odpowiednim czasie.`,
"c552":`Odrzucono`,
"c684":`{sumaTotalCount} więcej`,
"c54":`Proszę wpisać rodzaj podatku`,
"c320":`Wybierz pola formularza`,
"c236":`{!ServiceResource.name} przyjął zamówienie. Konto: "{!ServiceAppointment.accountid.name}", Numer: "{!ServiceAppointment.name}".`,
"c123":`Informacje logistyczne`,
"c654":`Powrót do listy pulpitów nawigacyjnych`,
"c335":`Marża zysku`,
"c267":`Nie udało się zatwierdzić zmian dla kryterium nie jest spełnione`,
"c226":`Przejdź do podzadania`,
"c102":`Kliknij raz`,
"c637":`Zapisz jako szkice`,
"c633":`Tworzenie nowych postów w serwisach społecznościowych`,
"c777":`Konfigurowanie informacji o uczestnikach`,
"c223":`Dodaj do projektu`,
"c592":`Wykres wodospadowy`,
"c315":`Tylko ważne zamówienia mogą generować faktury`,
"c89":`Email Nazwa wydarzenia`,
"c108":`Automatyzacja zakończona sukcesem`,
"c402":`Pole`,
"c748":`Proszę wybrać cennik dla {tytułu}. Można dodawać produkty tylko z jednego cennika. Zmiana wybranej książki cenowej spowoduje usunięcie wszystkich istniejących produktów.`,
"c501":`Zapewnij swoim klientom wysokiej jakości serwis terenowy`,
"c269":`Nie udało się scalić informacji`,
"front-electronic-signature-open-confirm":`Wiąż konto`,
"c584":`Mapa Stanów Zjednoczonych`,
"c437":`Niepowodzenie`,
"c738":`Data wysłania`,
"c274":`Nastąpił przekroczenie czasu przyjmowania zlecenia i wysyłka została anulowana. Numer: {0}. Kliknij, aby zobaczyć więcej >.`,
"c83":`Dane wyszukiwania`,
"c206":`Format PNG`,
"c309":`Wyślij plik zamówienia`,
"c539":`Największy udział źródeł`,
"c304":`Główne zainteresowania`,
"c151":`Krótki opis głównej zawartości formularza`,
"c639":`Post Now`,
"c720":`Nie，dzięki`,
"c801":`Nowe kontakty`,
"c900":`Gość nie ma informacji o adresie, więc nie można obliczyć odległości zameldowania.`,
"c695":`Wielkość oryginalna`,
"c864":`Wybierz formularz`,
"c881":`Przeczytałem i zgodziłem się`,
"c794":`Szablon do podpisywania`,
"c543":`Otrzymane oceny`,
"c466":`Tylko zamówienia korzystające z tej samej książki cenowej mogą wygenerować fakturę`,
"c867":`{userName} otrzyma wiadomość email z zaproszeniem i prośbą o utworzenie hasła umożliwiającego dostęp do Centrum Pomocy.
Kontynuować?`,
"c529":`Brak dostępnych sposobów doładowania, skontaktuj się z administratorem`,
"c742":`Można wybrać maksymalnie 4 obrazy, a każdy z nich nie może być dłuższy niż 200K. Kliknij obraz, aby go wybrać.`,
"c430":`Wyszukiwanie terminów wydajności`,
"c553":`Godzina ostatniego zaproszenia`,
"c575":`Wykres kolumnowy`,
"c124":`Dostawa w toku`,
"c629":`Niepowodzenie`,
"c554":`Czas pierwszego zaproszenia`,
"c547":`Ostatnie 7 dni`,
"c599":`Tabela Wykres`,
"c588":`Mapa Kanady`,
"c703":`Via`,
"c713":`Tworzenie postów społecznościowych z poziomu CloudCC.`,
"c142":`Jest to akcja, która zostanie podjęta po przesłaniu formularza przez odwiedzającego witrynę.`,
"c153":`Po wyczyszczeniu produktów powiązanych z bieżącym rekordem można zmienić walutę.`,
"c253":`Zgodność z GDPR`,
"c612":`Strona wewnętrzna`,
"c400":`Lokalizacja zasobów serwisowych`,
"c671":`Ikona i słowo`,
"c20":`Nie może przekraczać ilości do zafakturowania dla powiązanego zamówienia.`,
"c514":`Wykresy w raporcie`,
"c946":`Zjednoczone Królestwo`,
"c717":`Nowy post`,
"c174":`Wszystkie edytowane pomyślnie`,
"c940":`Chiny  Hongkong`,
"c743":`Wprowadź prawidłowe liczby`,
"c441":`Inteligentne zarządzanie biznesem i finansami`,
"c423":`Platforma dyspozytorska`,
"c723":`Potwierdź, aby złożyć wniosek o zniszczenie`,
"c664":`Brak sieci społecznościowej`,
"c859":`Proszę wprowadzić {0}.`,
"c356":`Planowany koszt`,
"c221":`Przejdź do projektu`,
"front-email-payment-Invoice-Tips1":`Prosimy o kontakt z administratorem w celu włączenia WeChat, Alipay, PayPal lub VISA, a następnie zainicjowania płatności online.`,
"c99":`Produkt Ilość`,
"c278":`Czy chcesz usunąć następujące wiadomości email?`,
"c364":`Cytat Linia`,
"c572":`Wybrane pola nie mogą być puste, należy dodać pole(a)`,
"c310":`Generowanie pliku zamówienia`,
"c247":`Przekazane`,
"c158":`Przypisz próg czasowy`,
"c325":`Wzór zawiadomienia o przydzieleniu sprawy`,
"c877":`Wypełnić Nieuporządkowane`,
"front-filter-v1-press":`Naciśnij`,
"c505":`Śledzenie odwiedzających`,
"c523":`Dodaj jako użytkownika portalu`,
"c727":`Skuteczne niszczenie danych`,
"front-electronic-signature-sended":`Wysłane`,
"c150":`Wypełnij wymagane informacje`,
"c700":`CZAS OSTATNIEJ AKTUALIZACJI`,
"c824":`Zaloguj się do zamówienia`,
"c710":`Jeden dom do zarządzania wszystkimi mediami społecznościowymi`,
"c358":`Budżet`,
"c544":`Kanały`,
"c212":`Format SVG`,
"c165":`Wprowadź wartość całkowitą z zakresu 024.`,
"c932":`Spam`,
"c888":`Pomyślna aktywacja konta użytkownika`,
"c838":`Operator`,
"c98":`Kategoria produktu`,
"c830":`STWORZONE PRZEZ`,
"c661":`Sieć`,
"c818":`Ustawienia menu strony niestandardowej`,
"c861":`Wybierz z mapy`,
"c736":`Posted By`,
"c204":`Standardowa strona`,
"c839":`Wygląda na to, że nic nie jest zaplanowane.`,
"c456":`Kwota zapłacona`,
"c341":`Rachunki końcowe`,
"c724":`Potwierdź zniszczenie danych`,
"c865":`Zapoznałem się i zgadzam się na {0} i {1}.`,
"c332":`Kwota nie może przekraczać wartości zamówienia, które ma być zafakturowane`,
"c520":`Płatność nie powiodła się. Dostępny rabat jest niewystarczający.`,
"c906":`Minus`,
"c482":`Name Your Compagin:`,
"c49":`Aktualizacja ustawień bezpieczeństwa domeny`,
"c725":`Odwołanie wniosku o zniszczenie z powodzeniem`,
"c76":`PAY`,
"c558":`Sprawy zawieszone`,
"c876":`Znak Nieuporządkowany`,
"front-invoices-v1-nofilles-tocreate":`Proszę kliknąć na przycisk Generuj fakturę, aby wygenerować fakturę, a następnie ją wysłać.`,
"c779":`Termin składania podpisów`,
"c603":`Wykres dwuosiowy MoM&YoY`,
"c455":`Cel umowy`,
"c428":`Dyspozytornia w trybie mapy`,
"c55":`Proszę wpisać wartość podatku`,
"c899":`Odległość zameldowania`,
"label.facebook.title":`FacebookH5 MiniApp`,
"c487":`Nazwa odbiorcy:`,
"label.social.posts.info":`Nie znaleziono treści postu`,
"c704":`Publiczność`,
"c673":`Obraz internetowy`,
"front-electronic-signature-singed":`Rozpoczęto podpisywanie`,
"c722":`1 podłączone konto`,
"c595":`Wykres powierzchni`,
"c120":`typ(y)`,
"c68":`Zlecenie płatnicze`,
"c479":`CloudCC Forms Mailchimp`,
"front-electronic-signature-explain-mainTitle":`Epodpis i stemplowanie`,
"c5":`Podatek`,
"c976":``,
"c812":`UWAGI`,
"c532":`Liczba przypadków odpoczynku`,
"c330":`Pozycja umowy`,
"c249":`post jest wysyłany teraz`,
"c630":`Zobacz na LinkedIn`,
"c958":`Post Like ID nie może być pusty`,
"c170":`Nie udało się utworzyć danych o id rekordu {0}, powód niepowodzenia: {1};`,
"c810":`REPLIES`,
"c783":`Wymagania dotyczące podpisów`,
"c968":``,
"c752":`Zainicjuj zadanie podpisywania`,
"c439":`Odwiedzający`,
"c67":`Złóż zamówienie z powodzeniem!`,
"front-generate-v1-invoice":`Wygeneruj fakturę`,
"c477":`Musisz uwierzytelnić się na swoim koncie MailChimp. Kliknij przycisk "Authenticate MailChimp" (Uwierzytelnij MailChimp), a zostaniesz przekierowany do Mail Chimp, aby wysyłać kampanie.`,
"c966":`Skontaktuj się z administratorem`,
"c764":`Odrzucono`,
"c301":`Można wprowadzić do 200 znaków`,
"c61":`Najpierw należy otworzyć program Wiedza, a następnie z niego skorzystać.`,
"c815":`Archiwizuj wszystko`,
"c827":`Na tej stronie wprowadzono niezapisane zmiany, które zostaną utracone, jeśli będziesz kontynuować.`,
"c688":`Maks. szerokość`,
"c33":`Edytuj typ subskrypcji`,
"c217":`post is going out {date}`,
"c721":`Rozłączenie konta`,
"c284":`Przetwarzanie wniosków o dane od klientów w ramach CRM`,
"c939":`Chiny  Makao`,
"c503":`Śledź postępy w realizacji projektu`,
"c492":`Zaproszony`,
"c73":`Saldo bieżące`,
"label.the.peoples.republic.of.china":`Chińska Republika Ludowa`,
"c828":`POST`,
"c36":`Podgląd`,
"c954":`Nowy numer telefonu`,
"front-electronic-signature-innerSinger":`Sygnatariusz wewnętrzny`,
"c508":`Analiza ROI`,
"c833":`Certyfikat zaliczony`,
"c207":`Format wektorowy`,
"c31":`Pół ekranu`,
"c71":`Proszę wybrać opcję płatności`,
"c373":`Cennik standardowy`,
"c545":`Czas rozwiązywania (h)`,
"c77":`Moduł Konfiguracja`,
"label.lastcompiledate":`Czas ostatniej kompilacji`,
"c119":`Potwierdź odbiór`,
"c281":`Przetwarzanie danych`,
"c715":`Monitoruj wzmianki o marce i szybko reaguj.`,
"c127":`Zarządzaj kolumnami`,
"c283":`Wniosek o udostępnienie danych`,
"c919":`Wykorzystaj pulę, aby pobudzić potencjał zespołu i poprawić współczynnik konwersji leadów. Administrator puli umożliwia ujednolicone zarządzanie leadami i przydzielanie im partii. Pracownicy działu sprzedaży mogą również sprawdzać leady i otrzymywać informacje zwrotne.`,
"c82":`Tylko dla błyskawic`,
"front-file-delete-intro":`Plik został usunięty`,
"c606":`Domyślny adres wysyłki`,
"c905":`Dodaj`,
"c644":`CZAS PUBLIKOWANY`,
"c75":`Rebate Balance`,
"c884":`Polityka prywatności`,
"c538":`Średni czas rozwiązywania zadań`,
"c322":`Nowa faktura`,
"c461":`Tendencje płatnicze`,
"c825":`Przedsiębiorstwa`,
"c56":`Suma należności z tytułu faktury i kwota należności nie są zgodne. Proszę wypełnić ponownie.`,
"c931":`Nie włączono przełącznika pozycjonowania pracowników i nie można korzystać z interwału udostępniania lokalizacji. Kontynuować?`,
"c276":`Zapewnij zgodność z GDPR`,
"c334":`Kwota z budżetu`,
"c733":`Kampania: Nowy plakat`,
"c384":`Nowa lista rzeczy do spakowania`,
"c139":`Szablon spotkania`,
"c957":`Post Comment ID nie może być pusty`,
"front-electronic-signature-nosign":`Żaden dostawca usługi Epodpisu nie został wybrany przez Twój organ. Prosimy o kontakt z administratorem w celu włączenia tej usługi.`,
"c419":`Plan konserwacji`,
"c934":`Tytuł konwersji`,
"c677":`Wyrównana do prawej`,
"c593":`Wykres liniowy`,
"c272":`{0} ma limit czasu przyjęcia zlecenia. Konto: {1}, Temat: {2}, Numer: {3}. Kliknij, aby zobaczyć więcej >.`,
"c811":`RETWEETS`,
"c451":`Rozdzielona obudowa`,
"c277":`Po usunięciu wiadomości email kolejne wiadomości email również zostaną usunięte i nie będą wysyłane do przyszłych kontaktów. Jest to nieodwracalne.`,
"c244":`{!ServiceResource.name} odrzucił zamówienie. Numer: "{!ServiceAppointment.name}"`,
"c627":`Opublikowany`,
"c601":`Wykres celu`,
"c251":`nie udało się opublikować postu(ów)`,
"c202":`Udostępnij w programie Mailchimp`,
"font-social-prohibit-create":`Nie możesz utworzyć nowego postu podczas edycji`,
"c394":`CloudCC pomaga w zarządzaniu przedsiębiorstwem online i zwiększaniu wydajności. Wybierz aplikację, której chcesz używać, a następnie postępuj zgodnie z wprowadzeniem i wskazówkami.`,
"c323":`Format PDF`,
"front-setting-dialog-title-one":`W celu uniknięcia utraty konta, szybkiego logowania i łatwego odzyskiwania danych, prosimy o powiązanie numeru telefonu`,
"front-electronic-signature-cancelIntro2":`Jeśli jest to pierwszy raz, aby powiązać konto, proszę kliknąć Kontynuuj, aby przejść do następnego kroku. Jeśli ponownie wiążesz konto po usunięciu powiązania, zalecane jest kliknięcie Anuluj i ponowne powiązanie po wyczyszczeniu danych przeglądania.`,
"c353":`Wyświetlanie arkuszy czasu`,
"c621":`Bogata treść tekstowa`,
"front-v1-partner-image-tooltip":`Obsługiwany jest plik o maksymalnej wielkości 2M. Obrazek zostanie przeskalowany do rozmiaru {size}. Zaleca się wgrywanie wyraźnych obrazów o podobnych proporcjach.`,
"c772":`Sfinalizowano`,
"c734":`Nazwa kanału plakatowego`,
"c380":`Nowa płatność`,
"c979":``,
"c233":`Nie można usunąć listy opakowań o statusie wysłane`,
"c458":`Mapa rozkładu kont`,
"c697":`Wybierz adres konta{nazwa}`,
"c476":`Wybierz pracownika, do którego chcesz wysłać kod zaproszenia`,
"c634":`Stwórz interesujący post i nawiąż kontakt z całym światem`,
"c144":`Godzina zakończenia nie może przekraczać 2038. Wybierz nową godzinę zakończenia.`,
"c474":`Ponowne przypisanie można wykonać przy użyciu zasad przypisywania liderów. Reguły przypisywania można znaleźć na stronie`,
"c371":`Synchronizacja z szansą`,
"c420":`Środki na utrzymanie`,
"c620":`Służy do grupowania wielu elementów treści do analizy w ramach jednego działania marketingowego.`,
"c708":`Ujednolicić skalę czy nie`,
"c100":`Rabat`,
"c576":`Wykres kolumnowy 2D`,
"c751":`Termin składania podpisów:`,
"c252":`Ustawienia zgodności`,
"c699":`Tylko nowy`,
"c74":`Płać przez Rebate`,
"c805":`Wybierz sieć społecznościową, aby rozpocząć:`,
"c452":`Historia przypadku`,
"c740":`Wybierz pracownika, do którego chcesz wysłać zaproszenie`,
"c596":`Wykres dwuosiowy`,
"c832":`Przeglądanie strony`,
"c971":``,
"c262":`Historia`,
"c363":`Wrażliwa strona`,
"label.singleSignOn.is.invalid":`Loginfree był nieprawidłowy`,
"c72":`Płatności osób trzecich`,
"c292":`Marketing`,
"c499":`Sprawna obsługa klienta, która robi wrażenie na klientach`,
"c574":`Wykres słupkowy ułożony w stos`,
"c618":`Zmień treść lub czas publikacji tego postu.  Twitter nie zezwala na publikację więcej niż jednego posta o tej samej treści w ciągu 24 godzin.`,
"front-setting-phone-format":`Proszę wpisać numer telefonu w poprawnym formacie`,
"c460":`Ranking wielkości konta`,
"c189":`Waluta faktury powinna być zgodna z walutą zamówienia. Doprecyzuj walutę i zapisz ponownie.`,
"label.exe.supported.request.rejected":`Plik exe. nie jest obsługiwany do wysłania. Żądanie zostało odrzucone!`,
"c835":`Dla tej oferty została już wystawiona faktura. Kontynuować czy nie?`,
"c655":`Poczta z`,
"c45":`Podłączenie przez`,
"c43":`Połącz konto`,
"c481":`Zaloguj się jako inny użytkownik`,
"c674":`Adres zewnętrzny`,
"c266":`To zamówienie nie może być zmienione, ponieważ zostało już wykonane.`,
"c967":``,
"c154":`Po wybraniu produktów należy przeszukać cenniki`,
"c841":`Masz pomysły? Przygotuj projekt.   `,
"c615":`Nie wybrano żadnego konta`,
"c84":`Wybierz pracownika, któremu chcesz wysłać kod zaproszenia`,
"c401":`Serwis`,
"c290":`Obiekty włączone`,
"c205":`Pobierz Kod QR`,
"c928":`Można wybrać do 10 pól.`,
"c195":`Limit zgłoszeń`,
"1":`Brak dostępnych działań`,
"c46":`Autoryzuj z powodzeniem`,
"c459":`Podpisana umowa Kwota`,
"c250":`posty są zapisywane jako wersje robocze`,
"c399":`Inwentaryzacja`,
"c518":`The #recordName of #label failed the approval for #failReason`,
"c396":`Wybierz różne rozwiązania`,
"c300":`Zniszcz na żądanie`,
"c789":`Metoda podpisu bez ograniczeń`,
"c874":`Przeczytałeś wszystko, co znalazło się w skrzynce odbiorczej.`,
"c38":`Numer bloku Wspólnoty`,
"c228":`Dodaj podzadanie`,
"c342":`Zysk`,
"c879":`Klonowanie postów społecznościowych`,
"c173":`Ponowne wiązanie zakończone sukcesem`,
"c778":`Inicjator`,
"c211":`Mały rozmiar`,
"c496":`CloudCC Sales Cloud  inteligentny CRM dla wszystkich scenariuszy, pomagający osiągnąć cele sprzedażowe`,
"c427":`Wysyłka w trybie wykresu Gantta`,
"c851":`Pokazuje liczbę postów, które zostały opublikowane na wszystkich kontach użytkownika w wybranym okresie.`,
"c32":`Nowy typ subskrypcji`,
"c28":`Wzrost rok do roku`,
"c163":`Jednoczesne informowanie i anulowanie wysyłki`,
"c225":`Przejdź do zadania`,
"c569":`Najpierw należy wybrać konto`,
"c92":`Otwórz raz`,
"c412":`Automatycznie utwórz zlecenie serwisowe (AutoCreate Service Appointment)`,
"c81":`Dodaj do koszyka`,
"c653":`Pokazuje liczbę polubień, reakcji i komentarzy dla opublikowanych postów. Uwzględnia także posty opublikowane na połączonych kontach poza CloudCC. Jeśli szukasz retweetów na Twitterze, znajdziesz je w sekcji Udziały.`,
"c516":`Obecność`,
"c918":`Jeśli skonfigurowane są reguły automatycznego recyklingu, system będzie automatycznie przekazywał rekordy do puli, jeśli konto nie zamknęło transakcji po upływie określonego czasu. Zwiększa to efektywność monitorowania konta.`,
"c809":`LIKES`,
"c181":`Proszę wypełnić zlecenie pracy lub rejestr spraw`,
"c745":`Proszę wprowadzić do 2 miejsc po przecinku`,
"c669":`Kolor`,
"c929":`Sprawdź połączenie sieciowe`,
"c117":`Zapisz i zapłać`,
"c938":`Chiny kontynentalne`,
"c112":`Wszystkie szablony {name} są obecnie wyłączone. Skontaktuj się z administratorem, aby włączyć szablon przed wygenerowaniem {name}.`,
"c347":`Zmiana godzin pracy w ramach zadania projektowego`,
"c795":`Proszę wybrać wzór umowy`,
"c17":`Nieaktywne. Proszę wybrać ponownie`,
"c787":`Podpisane przez Operatora`,
"c829":`KAMPANIA`,
"c161":`Informuj także`,
"c65":`Czy chcesz zmienić status logistyczny produktu na Dostarczony?`,
"c665":`Dodaj jeszcze jeden`,
"c767":`Sprawdź postęp podpisywania`,
"c87":`Kod QR formularza kampanii`,
"c589":`Mapa Francji`,
"front-electronic-signature-newTime":`Ostatnio aktualizowane na`,
"c813":`SHARE`,
"c85":`{Członek} zaproszony wybrany`,
"c951":`Polska`,
"c29":`Wzrost miesiąc do miesiąca`,
"c210":`Duży rozmiar`,
"c39":`Archiwalne`,
"c672":`Słowo`,
"c97":`Ta lista powinna zawierać co najmniej jedną opcję "Przekształcone".`,
"c687":`Maks. wielkość`,
"c916":`Zamknięty basen`,
"c475":`Proszę wypełnić dane właściciela kampanii`,
"c628":`Zaplanowane`,
"c788":`Książka cenowa dla tej okazji jest obecnie wyłączona. Włącz książkę cen przed utworzeniem nowego zamówienia.`,
"c177":`Sugerowany rozmiar: 390*210`,
"c856":`Yay! Żadnych nieudanych postów.`,
"c70":`Informacje o zamówieniu`,
"c546":`Ostatnie 24 godziny`,
"c331":`Przekształcenie aktywów`,
"label.order.paidamount.greater.than.total":`Po utworzeniu nowych danych płatności, zwrócona kwota zamówienia będzie wyższa niż kwota zamówienia. Proszę ponownie ustawić płatność i zapisać ją.`,
"c524":`Ponowne zaproszenie`,
"c246":`{!oldServiceResource.name} przekazał Ci zlecenie pracy o numerze {!ServiceAppointment.name}.`,
"label.parameter.is.incorrect":`Nieprawidłowe parametry`,
"c667":`Odstępy między ikonami`,
"c737":`Platforma społecznościowa`,
"c48":`Odłącz`,
"c111":`Wygeneruj {nazwa}`,
"c755":`W kolejności`,
"c526":`Włącz użytkownika portalu`,
"c450":`Łączenie spraw`,
"front-electronic-export-reChoseChimp":`W bieżącym widoku nie ma żadnych rekordów danych i nie można go wyeksportować. Proszę wybrać nowy widok.`,
"label.invoice.paidamount.greater.than.total":`Po utworzeniu nowych danych płatności, zwrócona kwota faktury będzie większa niż całkowita wartość. Proszę ponownie ustawić płatność, a następnie zapisać ją.`,
"c222":`Edytuj projekt`,
"c849":`Konta na Twitterze`,
"c678":`Czerń i biel`,
"c502":`Oferuje kompleksowe rozwiązania do obsługi wszystkich procesów związanych z usługami świadczonymi w terenie, aby usprawnić działania, poprawić wydajność, zwiększyć lojalność i zadowolenie klientów.`,
"c497":`Mądrzejsza inwentaryzacja, lepsze zarządzanie biznesem i finansami`,
"c200":`Udostępnij w mediach społecznościowych`,
"c658":`Bogaty tekst`,
"c434":`Nowy powiązany kontakt`,
"c641":`Możesz wybrać nie więcej niż 4 obrazy，kliknij wybrany obraz, aby go odznaczyć. Rozmiar przesyłanego obrazu nie powinien przekraczać 200 kb.`,
"c944":`Niemcy`,
"c411":`Przesunięcie terminu płatności`,
"c624":` Wszystkie rachunki`,
"label.twitter.title":`TwitterH5 MiniApp`,
"c791":`Podpis standardowy`,
"c306":`Zgadzam się`,
"c14":`Bieżący użytkownik nie ma uprawnień do usuwania`,
"c176":`Obsługiwane są tylko obrazy w formatach png, jpg i jpeg. Przesłany obraz nie może przekraczać 2M.`,
"c166":`Wprowadź maksymalną długość zamówienia zgodnie z zasadami`,
"c731":`Zmiana wybranego cennika spowoduje również usunięcie wszystkich istniejących produktów. Czy na pewno chcesz zmienić cennik na nowy?`,
"c237":`{!ServiceResource.name} przyjął zamówienie. Numer: "{!ServiceAppointment.name}"`,
"c887":`Ponowne zaproszenie użytkownika zakończone sukcesem`,
"c227":`Edytuj podzadanie`,
"c257":`Dostępny Kontakt`,
"c712":`Raportowanie i porównywanie wydajności w różnych sieciach, postach i kampaniach.`,
"c107":`Wyszukiwanie użytkowników według nazwy, konta i numeru telefonu komórkowego`,
"c370":`Umowa`,
"c895":`Nie udało się obliczyć odległości, wprowadź pełny adres`,
"c693":`Autoregulacja`,
"c763":`Podpisano:`,
"c302":`Uzasadnione interesy`,
"c577":`Wykres kolumnowy ułożony w stos`,
"c258":`Złóż skargę`,
"c676":`Centrum`,
"c868":`Po dezaktywacji tego konta system ograniczy jego dostęp lub operacje w Twoim portalu. Kontynuować?`,
"c53":`Współczynnik (%)`,
"c527":`#userName przydzielił Ci zadanie zatwierdzenia`,
"label.facebook.title.setting":`Informacje zintegrowane z Facebookiem`,
"c340":`Zmień właściciela planu projektu`,
"c706":`O wykresach`,
"label.mobile.used":`Numer telefonu komórkowego został użyty`,
"c328":`Kod QR aktywów`,
"c337":`Kontakty  Zniszcz`,
"c642":`Najnowsze zdjęcia`
}